import React, { useEffect, Component } from 'react';
import * as ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import AsyncStorage from '@callstack/async-storage';
import PhoneInput from 'react-phone-input-2';
import PhoneInput1 from 'react-phone-input-2';
import PhoneInputnew from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import '../assets/css/IntlTelInput.css';
import 'react-phone-input-2/lib/style.css';
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from 'react-router-dom';
import $ from 'jquery';
import BusinessVerification from './BusinessVerification';
import BusinessVerificationButton from '../pages/BusinessVerificationButton';
import Header_component from '../includes/Header_component';
import Footer_component from '../includes/Footer_component';
import transparent from '../assets/img/transparent.png';
import zapier_logo from '../assets/img/zapier.png';
import redtie_logo from '../assets/img/redtie_logo_sm.png';
import alert_search from '../assets/img/alert_search.png';
import nft_img from '../assets/img/nft_img.png';
import ft_img from '../assets/img/transparent.png';
import prof_webhooks from '../assets/img/prof_webhooks.png';
import redtie_bot1 from '../assets/img/Redtie-AI.gif';
import MP3video from '../assets/img/read.mp4';
import alert_conversation from '../assets/img/alert_conversation.png';
import user7 from '../assets/img/user7-128x128.jpg';
import imgalert_contact from '../assets/img/alert_contact.png';
import MicRecorder from 'mic-recorder-to-mp3';
import VideoRecorder from 'react-video-recorder';
import Multiselect from './multiselect/Multiselect';
import './multiselect/styles.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import { ReactMediaRecorder } from "react-media-recorder";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { SDK_VERSION } from 'firebase';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { ToastContainer, toast, Flip } from 'react-toastify';
import { first } from 'lodash';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.snow.css';
import Linkify from 'react-linkify';
import ReactTooltip from 'react-tooltip';
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
import DateRangePicker from 'react-daterange-picker';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import 'react-daterange-picker/dist/css/react-calendar.css';
// import html2canvas from "html2canvas";
import XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import DataTable, { createTheme } from 'react-data-table-component';
var QRCode = require('qrcode.react');
var moment = require('moment');
var current_step_id = 0;
var placeholder_cmb = document.createElement('div');
placeholder_cmb.className = 'placeholder_cmb';
let Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
let docAttachmentsCount_cmb = 0;
const API_CALL_ENDPOINT = process.env.REACT_APP_APICALL_ENDPOINT;
const APP_ENDPOINT = process.env.REACT_APP_APP_ENDPOINT;
const APP_EMAIL_ENDPOINT = process.env.REACT_APP_EMAIL_ENDPOINT;
const CHAT_APP_ENDPOINT = process.env.REACT_APP_CHAT_APP_ENDPOINT;
const RECAT_APP_V4_SLACK_API_NEW_URL = 'https://slack.com/api/oauth.v2.access/';
const API_KEY = process.env.REACT_APP_V4_API_KEY;
const API_SECRET = process.env.REACT_APP_V4_API_SECRET;
const Slack_auth = process.env.REACT_APP_V4_SLACK_AUTH;
const Slack_api_url = process.env.REACT_APP_V4_SLACK_API_URL;
const Slack_clientid = process.env.REACT_APP_V4_SLACK_CLIENTID;
const Slack_secret = process.env.REACT_APP_V4_SLACK_SECRET;

const Mp3Recorder = new MicRecorder({ bitRate: 128 });
//test
var TagLstDtatable = '';
var ArchvHstryDtatble = '';
var emaildumpDtatble = '';
var TemDtatable = '';
var url_business_id = '';
var entrypntdatatbl = '';
var firsttime_entrypntdatatbl = true;
var stepsdatatbl = '';
var firsttime_stepsdatatbl = true;
var templatedatatbl = '';
var firsttime_templatedatatbl = true;
var wfcontactsdatatbl = '';
var firsttime_wfcontactsdatatbl = true;
var upload_count = 0;
var upload_counts = [];
var nft_key_count = 0;
const myUploadProgress = (myFileId) => (progress) => {
  let percentage = Math.floor((progress.loaded * 100) / progress.total);
  var finpercentage = percentage + '%';
  $('.progres_cnt' + myFileId + '').css({ width: '' + finpercentage + '' });
  $('.progres_cnt' + myFileId + '').text(finpercentage);
};
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
    },
  },
  cells: {
    style: {},
  },
};

var tdata = [];

const tcolumns = [
  {
    name: 'File',
    selector: 'File',
    sortable: true,
    left: true,
  },
  {
    name: 'Status',
    selector: 'Status',
    sortable: true,
    left: true,
  },
  {
    name: 'Uploaded on',
    selector: 'Uploaded on',
    sortable: true,
    left: true,
  },
  {
    name: 'Action',
    selector: 'Action',
    sortable: true,
    left: true,
  },
];

const ftcolumns = [
  {
    name: 'Receiver',
    selector: 'Receiver',
    sortable: true,
    left: true,
  },
  {
    name: 'Sent',
    selector: 'Sent',
    sortable: true,
    left: true,
  },
  {
    name: 'Accepted',
    selector: 'Accepted',
    sortable: true,
    left: true,
  },
  {
    name: 'No of Tokens',
    selector: 'No of Tokens',
    sortable: true,
    left: true,
  },
];

const stateDefinitions = {
  available: {
    color: null,
    label: 'Available',
  },
  enquire: {
    color: '#ffd200',
    label: 'Enquire',
  },
  booking: {
    color: '#3BEFDF',
    label: 'Booking',
  },
  waiting: {
    color: '#FF4D4D',
    label: 'Waiting',
  },
  registration: {
    color: '#B0B0F7',
    label: 'Registration',
  },
  delivery: {
    color: '#EFAD9F',
    label: 'Delivery',
  },
  testing: {
    color: '#66ff66',
    label: 'Testing',
  },
  upgrade: {
    color: '#BB6FCD',
    label: 'Upgrade',
  },
  trip: {
    color: '#5066F2',
    label: 'Trip',
  },
  renovation: {
    color: '#F3B230',
    label: 'Renovation',
  },
  cleaning: {
    color: '#ff4d4d',
    label: 'Cleaning',
  },
  carSale: {
    color: '#8bd2da',
    label: 'Car Sale',
  },
  newCar: {
    color: '#40bf80',
    label: 'New Car',
  },
  unavailable: {
    // selectable: false,
    color: '#ff80ff',
    label: 'Unavailable',
  },
};
var today = new Date();
var end_date;
var start_date;
// var jsPDF;
// var XLSX;
function randDarkColor() {
  var lum = -0.25;
  var hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  var rgb = '#',
    c,
    i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }
  return rgb;
}
function validate(name, cardNumber, expirationdate, cvv) {
  const errors = [];
  if (name.length === 0) {
    errors.push("Name on card can't be empty");
    return errors;
  }

  if (cardNumber.length === 0) {
    errors.push("CardNumber can't be empty");
    return errors;
  }

  if (expirationdate.length === 0) {
    errors.push("Expiration Date can't be empty");
    return errors;
  }
  if (cvv.length === 0) {
    errors.push("Cvv can't be empty");
    return errors;
  }

  return errors;
}
var gapi = window.gapi;
var CLIENT_ID = process.env.REACT_APP_V4_CAL_CLIENT_ID;
var CLIENT_SECRET = process.env.REACT_APP_V4_CAL_CLIENT_SECRET;
var API_KEY_gapi = process.env.REACT_APP_V4_CAL_API_KEY;
var DISCOVERY_DOCS = process.env.REACT_APP_V4_CAL_DOCS;
var SCOPE = process.env.REACT_APP_V4_CAL_SCOPE;
const editorConfiguration = {
  // plugins: [ Essentials, Bold, Italic, Paragraph ],
  // toolbar: [ 'bold', 'italic' ],
  link: {
    decorators: {
      openInNewTab: {
        mode: 'manual',
        label: 'Open in a new tab',
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      },
    },
  },
};
class Profile_settings extends Component {
  constructor(props) {
    ClassicEditor.defaultConfig = {
      toolbar: {
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          '|',
          'blockQuote',
          'bulletedList',
          'numberedList',
          '|',
          'undo',
          'redo',
        ],
      },

      language: 'en',
    };
    super(props);
    // this.delete_start_point = this.delete_start_point.bind(this);
    this.start_fn = this.start_fn.bind(this);
    this.dataLst = this.dataLst.bind(this);
    this.archivehistory_tgl = this.archivehistory_tgl.bind(this);
    this.summaryalert_tgl = this.summaryalert_tgl.bind(this);
    this.autotxtrespnse_tgl = this.autotxtrespnse_tgl.bind(this);
    this.autotextresponsemedia_tgl = this.autotextresponsemedia_tgl.bind(this);
    this.autotextresponsemedia_del = this.autotextresponsemedia_del.bind(this);
    this.autotextresponsemedia_save = this.autotextresponsemedia_save.bind(this);
    this.voicemsg_tgl = this.voicemsg_tgl.bind(this);
    this.voice_message = this.voice_message.bind(this);
    this.autovoiceresponse_tgl = this.autovoiceresponse_tgl.bind(this);
    this.autovoiceresp = this.autovoiceresp.bind(this);
    this.bdaygreetings_tgl = this.bdaygreetings_tgl.bind(this);
    this.profemailaddr_edit = this.profemailaddr_edit.bind(this);
    this.webhookshistory_tgl1 = this.webhookshistory_tgl1.bind(this);
    this.webhookshistory_tgl2 = this.webhookshistory_tgl2.bind(this);
    this.addwebhook_clk = this.addwebhook_clk.bind(this);
    this.addwebhook_close = this.addwebhook_close.bind(this);
    this.apicreate_clk = this.apicreate_clk.bind(this);
    this.tagcreate_clk = this.tagcreate_clk.bind(this);
    this.addinttag_close = this.addinttag_close.bind(this);
    this.psphrase_addtagname = this.psphrase_addtagname.bind(this);
    this.psphrase_closeaddtagname = this.psphrase_closeaddtagname.bind(this);
    this.qrcodecreate_clk = this.qrcodecreate_clk.bind(this);
    this.addqrcode_close = this.addqrcode_close.bind(this);
    this.qrcodehistory_tgl1 = this.qrcodehistory_tgl1.bind(this);
    this.qrcodehistory_tgl2 = this.qrcodehistory_tgl2.bind(this);
    this.phrasecreate_clk = this.phrasecreate_clk.bind(this);
    this.addintphrase_close = this.addintphrase_close.bind(this);
    this.psqrcode_addtagname = this.psqrcode_addtagname.bind(this);
    this.psqrcode_closeaddtagname = this.psqrcode_closeaddtagname.bind(this);
    this.gmailconnect_clk = this.gmailconnect_clk.bind(this);
    this.qrcodesendmsgattach_clk = this.qrcodesendmsgattach_clk.bind(this);
    this.archiveMode = this.archiveMode.bind(this);
    this.ViewArchiveOnOff = this.ViewArchiveOnOff.bind(this);
    this.onClickTagTxtboxAdder = this.onClickTagTxtboxAdder.bind(this);
    this.onClickTagTxtboxSubmit = this.onClickTagTxtboxSubmit.bind(this);
    this.getTagname = this.getTagname.bind(this);
    this.EditTagNameClick = this.EditTagNameClick.bind(this);
    this.DelTag = this.DelTag.bind(this);
    this.chkInboundtag = this.chkInboundtag.bind(this);
    this.saveSmryalrt = this.saveSmryalrt.bind(this);
    this.chkAllTem = this.chkAllTem.bind(this);
    this.receiveAlrtChk = this.receiveAlrtChk.bind(this);
    this.reSetSmryalrt = this.reSetSmryalrt.bind(this);
    this.AutoTxtPlsclick = this.AutoTxtPlsclick.bind(this);
    this.AutoTxtSaveclick = this.AutoTxtSaveclick.bind(this);
    this.VoiceGrtnaudio_start = this.VoiceGrtnaudio_start.bind(this);
    this.VoiceGrtnaudio_stop = this.VoiceGrtnaudio_stop.bind(this);
    this.VoiceGrtnaudio_play = this.VoiceGrtnaudio_play.bind(this);
    this.VoiceGrtnaudio_pause = this.VoiceGrtnaudio_pause.bind(this);
    this.SaveVoiceGrrtng = this.SaveVoiceGrrtng.bind(this);
    this.AtoVcRspnsSaveClick = this.AtoVcRspnsSaveClick.bind(this);
    this.SaveHngMsgwithout = this.SaveHngMsgwithout.bind(this);
    this.DelVoiceGrrtng = this.DelVoiceGrrtng.bind(this);
    this.atoVcRspnLevMsgDelClk = this.atoVcRspnLevMsgDelClk.bind(this);
    this.DelHngMsgwithout = this.DelHngMsgwithout.bind(this);
    this.saveBrthgrtng = this.saveBrthgrtng.bind(this);
    this.DeltBrthgrtng = this.DeltBrthgrtng.bind(this);
    this.VoiceTypeClick = this.VoiceTypeClick.bind(this);
    this.generateVoice_play = this.generateVoice_play.bind(this);
    this.generateVoice_pause = this.generateVoice_pause.bind(this);
    this.ResetVoiceGenClk = this.ResetVoiceGenClk.bind(this);
    this.voiceGnrteTextSave = this.voiceGnrteTextSave.bind(this);
    this.voiceGnrteTextDelete = this.voiceGnrteTextDelete.bind(this);
    this.AutoTxtTtlDel = this.AutoTxtTtlDel.bind(this);
    this.UnChkInbndTg = this.UnChkInbndTg.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.onchangebusiness_info_name = this.onchangebusiness_info_name.bind(this);
    this.onchangebusiness_info_details = this.onchangebusiness_info_details.bind(this);
    this.business_update = this.business_update.bind(this);
    this.onClickButtonAdder = this.onClickButtonAdder.bind(this);
    this.onChangeprefix = this.onChangeprefix.bind(this);
    this.areacode = this.areacode.bind(this);
    this.loadmore = this.loadmore.bind(this);
    this.regloadmore = this.regloadmore.bind(this);
    this.prefixsearch = this.prefixsearch.bind(this);
    this.regionsearch = this.regionsearch.bind(this);
    this.onChangeregion = this.onChangeregion.bind(this);
    this.onsubmit = this.onsubmit.bind(this);
    this.num_validate = this.num_validate.bind(this);
    this.first_level_wf = [];
    this.timer = null;
    this.savetimer = null;
    this.state = {
      errors: [],
      success: [],
      business_List: [],
      business_id: '',
      user_id: '',
      _id: '',
      user_email: '',
      business_info_name: '',
      business_email_address: '',
      business_name1: '',
      business_color_code: '',
      prfImag: '',
      business_email_name: '',
      business_info_phone: '',
      business_info_details: '',
      business_info_array: [],
      archiveHstry_detail: [],
      tagList: [],
      tagTxtBox: [''],
      TagMsgClss: '',
      TagMsg: '',
      EditTagName: '',
      EditTagId: '',
      SaveTagBtnDsble: false,
      EditTagBtnDsble: false,
      TeamMbrLst: [],
      SummaryAlerts: [],
      TmRcvdalrt: '',
      smryTeamIds: [],
      chkdTemMbrsIds: [],
      TemIdsMebrArry: [],
      TemIdsMebrArry_chat: [],
      VwArchiewDisbl: true,
      AutoTxtArea: [''],
      AutotxtMxRspnsVlue: '',
      isRecording: false,
      VoiceGrtngblobURL: '',
      isBlocked: false,
      VoiceGrtngRecUrl: '',
      ViceGrtMsg: '',
      ViceGrtcls: '',
      LeavAutoVceMsgVle: '',
      LeavAutoVoiceMxmRspnsVlu: '',
      AtoViceResMsg: '',
      AtoViceRescls: '',
      HangMsgValue: '',
      birthdyTxtValue: '',
      bithGrtngTime: '12:00 AM',
      bithGrtngTimeZone: 'GMT-1200',
      brtGrtMsg: '',
      brtGrtcls: '',
      bithGrtngTimeSelt: '',
      bithGrtngTimeZoneSelt: '',
      TxtVoiceGrtngvlue: '',
      TxtTypeVoiceUrl: '',
      VoiceLngRegn: 'en-US',
      getVoiceTypeMlrFml: '',
      GrntVoiveLngRegin: [],
      VoceLstBsOnLanguge: [],
      generatePlayDisble: true,
      voiceGnrteResetdisble: true,
      VoiceGrtngRecDeltDisble: true,
      VoiceGrtngTxtTypDeltDisble: true,
      leaveMsgDelDisble: true,
      hangupMsgDelDisble: true,
      brthdyGrtngDelDisble: true,
      VoiceClksId: '',
      AutotxtListUniqId: '',
      AtoTxtClsNm: '',
      AtoTxtMsg: '',
      AtoTxDelClkDisble: true,
      max_chars_profilename: 32,
      chars_left_profilename: 32,
      max_chars_description: 200,
      chars_left_description: 200,
      business_info_name_blur: false,
      business_info_details_blur: false,
      unsupportedtext: '',
      unsupportedtext_unique_id: '',
      qr_title: '',
      qr_description: '',
      qr_message: '',
      qr_filtered_tag_list: [],
      qr_filtered_tag_list_up: [],
      qr_newtag: '',
      qr_download_link: '',
      qr_addtag_save: false,
      qr_code_list: [],
      qr_code_history: [],
      qr_code_image_edit: '',
      qr_code_id_edit: '',
      message_edit: false,
      QRGrtMsg: '',
      QRGrtcls: '',
      chat_filtered_tag_list: [],
      chat_newtag: '',
      chat_addtag_save: false,
      ChatGrtMsg: '',
      ChatGrtcls: '',
      EmlAlrtMsg: '',
      EmlAlrtCls: '',
      chat_grtmsg: '',
      chat_replymsg: '',
      chat_newcontactmsg: '',
      chat_existcontactmsg: '',
      src: null,
      crop: {
        unit: '%',
        width: 30,
        aspect: 14 / 12,
      },
      croppedImage: '',
      prfImag: '',
      active_edit_id: '',
      cmb_notesedit: false,
      savingprogress: '',
      notesValue2_cmb: '',
      messageAttachd_cmb: false,
      attchmnt_audioId_cmb: [],
      attchmnt_videoId_cmb: [],
      attchmnt_FileDocId_cmb: [],
      attchmnt_UrlIdDets_cmb: [],
      DcfilNm_cmb: '',
      attchmnt_audioIdUrl_cmb: [],
      Rnunique_id_cmb: '',
      atcharryDet_cmb: [],
      lodingicon_cmb: '',
      businessprofiledetails: {},
      businessprofileplandetails: {},
      attachmentlimit_count: 0,
      attachOrderIncrs_cmb: 1,
      attachmentdoc_count_cmb: 0,
      play_audio_url: '',
      document_url: '',
      video_play_link: '',
      Lightbox_open: false,
      Lightbox_open_video: false,
      slackGrtcls: '',
      slackGrtMsg: '',
      run: false,
      steps: [
        // {
        //   target: '.joyride_general',
        //   placement: 'auto',
        //   disableBeacon: true,
        //   content: <strong>General</strong>,
        //   locale: {
        //     skip: (
        //       <strong style={{color: '#333333'}} aria-label="skip">
        //         SKIP
        //       </strong>
        //     ),
        //   },
        // },
        {
          target: '.joyride_info',
          placement: 'auto',
          disableBeacon: true,
          content: <strong>Update your Workspace info here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_archive',
          disableBeacon: true,
          content: <strong>Turn On Archive mode to retrieve removed contacts and messages.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },

        {
          target: '.joyride_tags',
          disableBeacon: true,
          content: <strong>Create your contact groups here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_summary',
          disableBeacon: true,
          content: (
            <strong>
              Receive a summary on activities over your workspace aka New Contacts, Messages sent , Messages received
              etc.
            </strong>
          ),
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores1',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>Create your auto-responder text message for inbound text messages here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores2',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: (
            <strong>
              Create your R-Bot responder text message in case if someone attempts to send you an unsupported attachment
              type.
            </strong>
          ),
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores3',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>Create your R-Bot responder text message for inbound calls here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores4',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>Create your R-Bot voicegreetings for the call you receive.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores5',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>You can create a birth-day greeting for your contacts here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
      ],

      stepIndex: 0,
      booster_pack_list: [],
      boosterpack_active_id: '',
      price_quantity_list: [],
      pack_quantity_message: 1,
      pack_quantity_contact: 1,
      packcart_list: [],
      order_data_count: '',
      order_doller: '',
      order_amount: '',
      card_name: '',
      card_number: '',
      exp_date: '',
      exp_month: '',
      exp_year: '',
      cvc: '',
      cardList: [],
      existcard_id: '',
      exist_cart_id: '',
      isLoading: false,
      cartmsg: '',
      cartcls: '',
      pack_history_list: [],
      cart_updated_count: 0,
      //workflow
      workflow_history_data: {},
      workflow_name: '',
      workflow_description: '',
      workflow_list_array: [],
      workflow_status_data: {},
      workflow_entry_list_array: [],
      workflow_edit_data: {},
      workflow_edit_name: '',
      workflow_editenable: false,
      send_filtered_tag_list_up: [],
      tagcnt_list: [],
      compsrch_txt: '',
      cttagactiv_id: '',
      tags_contact_count: 0,
      contactscount_tag: 0,
      contactscount_tag_elsif: 0,
      tag_list: [],
      inbound_cond: '',
      inbound_content: '',
      edit_entrypnt_tags: false,
      edit_entrypnt_tags_data: {},
      edit_ifentrypnt_tags: false,
      edit_ifentrypnt_tags_data: {},
      edit_entrypnt_inbound_data: {},
      edit_entrypnt_inbound: false,
      disable_tag: false,
      disable_contact: false,
      disable_inbound: false,
      contacts: [],
      contacts_archive: [],
      contact_id: [],
      search_content: '',
      edit_entrypnt_contacts: false,
      edit_entrypnt_contacts_data: {},

      //WF_STEPS
      firstlevel_click: false,
      workflow_step_id_create: '',
      Workflow_step_if_else_data: '',
      workflow_steps_list_array: [],
      edit_startpnt_msg: false,
      edit_startpnt_msg_data: {},
      edit_startpnt_msg_data_steps: '',
      disable_send_msg: false,
      workflow_msg: '',
      chars_left_wfmsg: 300,
      max_chars_wfmsg: 300,

      workflow_delay_count: '',
      edit_startpnt_delay: false,
      edit_startpnt_delay_steps: '',
      edit_startpnt_elseif_steps: '',
      edit_startpnt_elseif_steps_ifelse_condition: '',
      edit_startpnt_delay_data: {},
      workflow_delay_time: '',
      disable_start_delay: false,

      inbound_content_ifelse: '',
      inbound_cond_ifelse: '',
      edit_step_inbound_data: {},
      edit_step_inbound_data_steps: '',
      edit_step_inbound: false,
      workflow_entry_contact_array: [],
      workflow_entry_contact_data: [],
      workflow_steps_contact_array: [],
      workflow_steps_contact_array_data: [],

      workflow_contacts_list_arr: [],
      workflow_contacts_list_data: [],
      workflow_contacts_list_type: '',

      //Templates
      templ_name: '',
      templ_msg: '',
      chars_left_templ_msg: 300,
      max_chars_templ_msg: 300,
      templ_msg_update_details: {},
      templ_message_edit: false,

      //Auto_text attachments
      active_class_attachment: '',

      //date picker
      dates: null,
      value: '',
      states: '',
      setYear: new Date().getFullYear(),
      setMonth: new Date().getMonth(),
      date: new Date(),
      start: '',
      end: '',
      showNewMonth: true,
      archive_search_keyword: '',
      archive_search_type: 'all',
      archive_search_contact: '',
      bgColor: ['#17a2b8', '#dc7943', '#8840e9', '#097952', '#0ca31a', '#b9af15', '#15418a'],
      scResultContactList: [],
      contacts_available_archived: [],
      show_download_all: false,
      //Email dump
      dump_members: 3,
      dump_emails: [''],
      emaildump_Hstry_detail: [],

      //contact select
      checked: [],
      dropDownValue: [],
      user_views_list_arr: [],
      company_list: [],

      //NFT:
      nft_details: {},
      nft_token: {},
      nft_token_file_extension: '',
      nft_tokens: [],
      table_view: false,
      nft_name: '',
      nft_decription: '',
      nft_file_name: '',
      nft_file_url: '',
      nft_thumb_file_url: '',
      nft_keys: '',
      nft_file_type: '',
      user_details: {},
      nft_minted_tokens: [],
      nft_minted_sent_tokens: [],
      nft_minted_accepted_tokens: [],
      nft_mint_click: false,
      nft_minted_tokens_lists: [],
      nft_sent_tokens_lists: [],
      nft_accept_tokens_lists: [],
      nft_available_cnt: 0,
      nft_sent_cnt: 0,
      nft_accept_cnt: 0,
      nft_available_load_more: true,
      nft_sent_load_more: true,
      nft_accept_load_more: true,
      nft_load_more: false,
      nft_total_count: 0,
      webhookdetails: [],
      webhookdetails_count: 0,
      ft_table_details: [],
      ft_load_more: false,
      ft_load_more_start: '0',
      ft_load_more_button: true,
      plivolist: [],
      rplivolist: [],
      prefix: '',
      plivonumber: '',
      limit: 7,
      number_click: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevState.packcart_list) !== JSON.stringify(this.state.packcart_list)) {
      this.setState({ cart_updated_count: this.state.cart_updated_count + 1 });
      console.log('cart_updated_count', this.state.cart_updated_count);
    }
    // if (prevState.notesValue2_cmb !== this.state.notesValue2_cmb) {
    //   if (this.state.cmb_notesedit === false) {
    //     if (this.state.notesValue2_cmb?.length >= 13) {
    //       this.saveNotes2_cmb();
    //     }
    //   }

    //   this.autoupdateNotes2_cmb();
    // }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.notesValue2_cmb !== nextState.notesValue2_cmb) {
      // this.autoupdateNotes2_cmb();
      return false;
    } else {
      return true;
    }
  }
  without_refresh = () => {
    this.setState({
      errors: [],
      success: [],
      business_List: [],
      business_id: '',
      user_id: '',
      _id: '',
      user_email: '',
      business_info_name: '',
      business_email_address: '',
      business_name1: '',
      business_color_code: '',
      prfImag: '',
      business_email_name: '',
      business_info_phone: '',
      business_info_details: '',
      business_info_array: [],
      archiveHstry_detail: [],
      tagList: [],
      tagTxtBox: [''],
      TagMsgClss: '',
      TagMsg: '',
      EditTagName: '',
      EditTagId: '',
      SaveTagBtnDsble: false,
      EditTagBtnDsble: false,
      TeamMbrLst: [],
      SummaryAlerts: [],
      TmRcvdalrt: '',
      smryTeamIds: [],
      chkdTemMbrsIds: [],
      TemIdsMebrArry: [],
      TemIdsMebrArry_chat: [],
      VwArchiewDisbl: true,
      AutoTxtArea: [''],
      AutotxtMxRspnsVlue: '',
      isRecording: false,
      VoiceGrtngblobURL: '',
      isBlocked: false,
      VoiceGrtngRecUrl: '',
      ViceGrtMsg: '',
      ViceGrtcls: '',
      LeavAutoVceMsgVle: '',
      LeavAutoVceMsgVle_unique_id: '',
      LeavAutoVoiceMxmRspnsVlu: '',
      AtoViceResMsg: '',
      AtoViceRescls: '',
      HangMsgValue: '',
      birthdyTxtValue: '',
      birthdyTxtValue_unique_id: '',
      bithGrtngTime: '12:00 AM',
      bithGrtngTimeZone: 'GMT-1200',
      brtGrtMsg: '',
      brtGrtcls: '',
      bithGrtngTimeSelt: '',
      bithGrtngTimeZoneSelt: '',
      TxtVoiceGrtngvlue: '',
      TxtTypeVoiceUrl: '',
      VoiceLngRegn: 'en-US',
      getVoiceTypeMlrFml: '',
      GrntVoiveLngRegin: [],
      VoceLstBsOnLanguge: [],
      generatePlayDisble: true,
      voiceGnrteResetdisble: true,
      VoiceGrtngRecDeltDisble: true,
      VoiceGrtngTxtTypDeltDisble: true,
      leaveMsgDelDisble: true,
      hangupMsgDelDisble: true,
      brthdyGrtngDelDisble: true,
      VoiceClksId: '',
      AutotxtListUniqId: '',
      AtoTxtClsNm: '',
      AtoTxtMsg: '',
      AtoTxDelClkDisble: true,
      max_chars_profilename: 32,
      chars_left_profilename: 32,
      max_chars_description: 200,
      chars_left_description: 200,
      business_info_name_blur: false,
      business_info_details_blur: false,
      unsupportedtext: '',
      qr_title: '',
      qr_description: '',
      qr_message: '',
      qr_filtered_tag_list: [],
      qr_filtered_tag_list_up: [],
      qr_newtag: '',
      qr_download_link: '',
      qr_addtag_save: false,
      qr_code_list: [],
      qr_code_history: [],
      qr_code_image_edit: '',
      qr_code_id_edit: '',
      message_edit: false,
      QRGrtMsg: '',
      QRGrtcls: '',
      chat_filtered_tag_list: [],
      chat_newtag: '',
      chat_addtag_save: false,
      ChatGrtMsg: '',
      ChatGrtcls: '',
      EmlAlrtMsg: '',
      EmlAlrtCls: '',
      chat_grtmsg: '',
      chat_replymsg: '',
      chat_newcontactmsg: '',
      chat_existcontactmsg: '',
      src: null,
      crop: {
        unit: '%',
        width: 30,
        aspect: 14 / 12,
      },
      croppedImage: '',
      prfImag: '',
      active_edit_id: '',
      cmb_notesedit: false,
      savingprogress: '',
      notesValue2_cmb: '',
      messageAttachd_cmb: false,
      attchmnt_audioId_cmb: [],
      attchmnt_videoId_cmb: [],
      attchmnt_FileDocId_cmb: [],
      attchmnt_UrlIdDets_cmb: [],
      DcfilNm_cmb: '',
      attchmnt_audioIdUrl_cmb: [],
      Rnunique_id_cmb: '',
      atcharryDet_cmb: [],
      lodingicon_cmb: '',
      businessprofiledetails: {},
      businessprofileplandetails: {},
      attachmentlimit_count: 0,
      attachOrderIncrs_cmb: 1,
      attachmentdoc_count_cmb: 0,
      play_audio_url: '',
      document_url: '',
      video_play_link: '',
      Lightbox_open: false,
      Lightbox_open_video: false,
      slackGrtcls: '',
      slackGrtMsg: '',
      run: false,
      steps: [
        // {
        //   target: '.joyride_general',
        //   placement: 'auto',
        //   disableBeacon: true,
        //   content: <strong>General</strong>,
        //   locale: {
        //     skip: (
        //       <strong style={{color: '#333333'}} aria-label="skip">
        //         SKIP
        //       </strong>
        //     ),
        //   },
        // },
        {
          target: '.joyride_info',
          placement: 'auto',
          disableBeacon: true,
          content: <strong>Update your Workspace info here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_archive',
          disableBeacon: true,
          content: <strong>Turn On Archive mode to retrieve removed contacts and messages.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },

        {
          target: '.joyride_tags',
          disableBeacon: true,
          content: <strong>Create your contact groups here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_summary',
          disableBeacon: true,
          content: (
            <strong>
              Receive a summary on activities over your workspace aka New Contacts, Messages sent , Messages received
              etc.
            </strong>
          ),
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores1',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>Create your auto-responder text message for inbound text messages here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores2',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: (
            <strong>
              Create your auto-responder text message in case if someone attempts to send you an unsupported attachment
              type.
            </strong>
          ),
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores3',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>Create your auto-responder text message for inbound calls here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores4',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>Create your R-Bot voicegreetings for the call you receive.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
        {
          target: '.joyride_autores5',
          // disableBeacon: true,
          placementBeacon: 'left',
          content: <strong>You can create a birth-day greeting for your contacts here.</strong>,
          locale: {
            skip: (
              <strong style={{ color: '#333333' }} aria-label="skip">
                SKIP
              </strong>
            ),
          },
        },
      ],

      stepIndex: 0,
      booster_pack_list: [],
      boosterpack_active_id: '',
      price_quantity_list: [],
      pack_quantity_message: 1,
      pack_quantity_contact: 1,
      packcart_list: [],
      order_data_count: '',
      order_doller: '',
      order_amount: '',
      card_name: '',
      card_number: '',
      exp_date: '',
      exp_month: '',
      exp_year: '',
      cvc: '',
      cardList: [],
      existcard_id: '',
      exist_cart_id: '',
      isLoading: false,
      cartmsg: '',
      cartcls: '',
      pack_history_list: [],
      cart_updated_count: 0,
      //workflow
      workflow_history_data: {},
      workflow_name: '',
      workflow_description: '',
      workflow_list_array: [],
      workflow_status_data: {},
      workflow_entry_list_array: [],
      workflow_edit_data: {},
      workflow_edit_name: '',
      workflow_editenable: false,
      send_filtered_tag_list_up: [],
      tagcnt_list: [],
      compsrch_txt: '',
      cttagactiv_id: '',
      tags_contact_count: 0,
      contactscount_tag: 0,
      contactscount_tag_elsif: 0,
      tag_list: [],
      inbound_cond: '',
      inbound_content: '',
      edit_entrypnt_tags: false,
      edit_entrypnt_tags_data: {},
      edit_ifentrypnt_tags: false,
      edit_ifentrypnt_tags_data: {},
      edit_entrypnt_inbound_data: {},
      edit_entrypnt_inbound: false,
      disable_tag: false,
      disable_contact: false,
      disable_inbound: false,
      contacts: [],
      contacts_archive: [],
      contact_id: [],
      search_content: '',
      edit_entrypnt_contacts: false,
      edit_entrypnt_contacts_data: {},

      //WF_STEPS
      firstlevel_click: false,
      workflow_step_id_create: '',
      Workflow_step_if_else_data: '',
      workflow_steps_list_array: [],
      edit_startpnt_msg: false,
      edit_startpnt_msg_data: {},
      edit_startpnt_msg_data_steps: '',
      disable_send_msg: false,
      workflow_msg: '',
      chars_left_wfmsg: 300,
      max_chars_wfmsg: 300,

      workflow_delay_count: '',
      edit_startpnt_delay: false,
      edit_startpnt_delay_steps: '',
      edit_startpnt_elseif_steps: '',
      edit_startpnt_elseif_steps_ifelse_condition: '',
      edit_startpnt_delay_data: {},
      workflow_delay_time: '',
      disable_start_delay: false,

      inbound_content_ifelse: '',
      inbound_cond_ifelse: '',
      edit_step_inbound_data: {},
      edit_step_inbound_data_steps: '',
      edit_step_inbound: false,
      workflow_entry_contact_array: [],
      workflow_entry_contact_data: [],
      workflow_steps_contact_array: [],
      workflow_steps_contact_array_data: [],

      workflow_contacts_list_arr: [],
      workflow_contacts_list_data: [],
      workflow_contacts_list_type: '',

      //Templates
      templ_name: '',
      templ_msg: '',
      chars_left_templ_msg: 300,
      max_chars_templ_msg: 300,
      templ_msg_update_details: {},
      templ_message_edit: false,

      //date picker
      dates: null,
      value: '',
      states: '',
      setYear: new Date().getFullYear(),
      setMonth: new Date().getMonth(),
      date: new Date(),
      start: '',
      end: '',
      showNewMonth: true,
      archive_search_keyword: '',
      archive_search_type: 'all',
      archive_search_contact: '',
      bgColor: ['#17a2b8', '#dc7943', '#8840e9', '#097952', '#0ca31a', '#b9af15', '#15418a'],
      scResultContactList: [],
      contacts_available_archived: [],
      show_download_all: false,

      //Email dump
      dump_members: 3,
      dump_emails: [''],
      emaildump_Hstry_detail: [],

      //contact select
      checked: [],
      dropDownValue: [],
      user_views_list_arr: [],
      company_list: [],
      //NFT:
      nft_details: {},
      nft_token: {},
      nft_token_file_extension: '',
      nft_tokens: [],
      table_view: false,
      nft_name: '',
      nft_decription: '',
      nft_file_name: '',
      nft_file_url: '',
      nft_keys: '',
      nft_file_type: '',
      nft_minted_tokens: [],
      nft_minted_sent_tokens: [],
      nft_minted_accepted_tokens: [],
      nft_mint_click: false,
      nft_minted_tokens_lists: [],
      nft_sent_tokens_lists: [],
      nft_accept_tokens_lists: [],
      nft_available_cnt: 0,
      nft_sent_cnt: 0,
      nft_accept_cnt: 0,
      nft_available_load_more: true,
      nft_sent_load_more: true,
      nft_accept_load_more: true,
      nft_load_more: false,
      nft_total_count: 0,
      webhookdetails: [],
      webhookdetails_count: 0,
      ft_table_details: [],
      ft_load_more: false,
      ft_load_more_start: '0',
      ft_load_more_button: true,
      plivolist: [],
      rplivolist: [],
      prefix: '',
      plivonumber: '',
      limit: 7,
      number_click: false,
    });
    // this.start_fn();

    AsyncStorage.getItem('business_id').then((business_id) => {
      if (business_id) {
        this.setState({ business_id });
        url_business_id = business_id;
        console.log('business_id');
        console.log(business_id);
      }
    });
    AsyncStorage.getItem('user_id').then((user_id) => {
      if (user_id) {
        this.setState({ user_id });
        console.log('User_id');
        console.log(user_id);
      }
    });

    AsyncStorage.getItem('_id').then((_id) => {
      if (_id) {
        this.setState({ _id });
        console.log('_id');
        console.log(_id);
      }
    });

    AsyncStorage.getItem('user_email').then((user_email) => {
      if (user_email) {
        this.setState({ user_email });
        console.log('email code');
        console.log(user_email);
      }
    });
    this.user_views_list();
    const pack_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
      },
    };

    axios.get(API_CALL_ENDPOINT + '/booster/pack/list', pack_list).then((res) => {
      if (res.data.result) {
        let price_quantity_list = [];
        for (let i = 0; i < res.data?.result?.length; i++) {
          const item = res.data.result[i];
          price_quantity_list = [
            ...price_quantity_list,
            {
              _id: item._id,
              quantity: 1,
            },
          ];
        }
        console.log('price_quantity_list', price_quantity_list);
        this.setState({
          booster_pack_list: res.data.result,
          price_quantity_list,
        });
      } else if (res.data.status == 'no_record') {
      }
    });
    setTimeout(() => {
      this.loadWebhooks();
      $('.receiptnft_div').attr({ style: 'display:none' });
      let url = this.props.location.search;
      let params = queryString.parse(url);
      console.log('params', params);
      if (params.code) {
        // console.log('Code,State', params.code, params.state);

        var Slack_business_id = params?.state?.split('|');
        // console.log('Slack_business_id', Slack_business_id);
        // console.log('business_id', this.state.business_id);
        if (Slack_business_id[1] === this.state.business_id) {
          const options = {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          };
          const data = new FormData();
          data.append('client_id', Slack_clientid);
          data.append('client_secret', Slack_secret);
          data.append('code', params.code);
          axios
            .post('https://slack.com/api/oauth.v2.access', data, options)

            .then((res) => {
              //   console.log('https://slack.com/api/oauth.access', res);
              if (res.data) {
                var jsondata = {
                  ok: res?.data.ok,
                  access_token: res?.data.access_token,
                  scope: res?.data.scope,
                  user_id: res?.data.bot_user_id,
                  _id: res?.data.bot_id,
                  team_id: res?.data.team.id,
                  enterprise_id: res?.data.enterprise,
                  team_name: res?.data.team.name,
                  incoming_webhook: res?.data.incoming_webhook,
                };
                const Slack_integrate = {
                  apikey: API_KEY,
                  secret: API_SECRET,
                  user_id: this.state?.user_id,
                  _id: this.state?._id,
                  business_id: this.state?.business_id,
                  setup: 'slack',
                  slack: jsondata,
                };
                // console.log('Slack_integrate', Slack_integrate);
                axios
                  .post(API_CALL_ENDPOINT + '/business/profile/settings', Slack_integrate)
                  .then((res1) => {
                    // console.log('Response', res1);
                    // $('#custom-tabs-integrations-tab').trigger('click');
                    $(".nav_links_prof").removeClass('active');
                    $('.nav_links_prof_tabs').removeClass('active show');
                    $('#custom-tabs-general-tab').removeClass('active');
                    $('#custom-tabs-integrations-tab').addClass('active');
                    $('#custom-tabs-general').removeClass('active show');
                    $('#custom-tabs-integrations').addClass('active show');
                    $('#custom-tabs-psemail-tab').removeClass('active');
                    $('#custom-tabs-psslack-tab').addClass('active');
                    $('#custom-tabs-psemail').removeClass('active show');
                    $('#custom-tabs-psslack').addClass('active show');
                    this.props.history.push('/profile_settings');
                    const business_details = {
                      params: {
                        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                        secret: 'R1eqD2twI3E4',
                        user_id: this.state.user_id,
                        business_id: this.state.business_id,
                      },
                    };
                    console.log(business_details);
                    axios.get(API_CALL_ENDPOINT + '/business/info', business_details).then((res) => {
                      console.log('/business/info', res.data);
                      if (res.data.result) {
                        this.setState({
                          business_info_array: res.data?.result,
                          business_name1: res.data?.result?.business.business_name,
                          business_color_code: res.data?.result?.business.color_code,
                          prfImag: res?.data?.result?.business?.profile_image,
                        });
                        var assigned_role_restrict = res?.data?.result?.business?.user_role.find(
                          (usr) => usr.user_id === this.state.user_id,
                        );
                        if (assigned_role_restrict) {
                          console.log('assigned_role_restrict found', assigned_role_restrict);
                          this.user_roles_info(assigned_role_restrict.role_id);
                        } else {
                          console.log('assigned_role_restrict not found', assigned_role_restrict);
                        }
                      }
                    });
                    if (res1?.data?.status === 'conflict') {
                      this.setState(() => ({
                        slackGrtMsg: res1?.data?.message,
                        slackGrtcls: 'alert alert-danger',
                      }));
                      setTimeout(() => {
                        this.setState(() => ({
                          slackGrtMsg: '',
                          slackGrtcls: '',
                        }));
                      }, 5000);
                    }
                    // window.location.reload(true);
                  })
                  .catch((err) => {
                    console.log('ERROR', err);
                  });
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response?.data?.status === 'conflict') {
                  this.setState(() => ({
                    slackGrtMsg: error.response?.data?.message,
                    slackGrtcls: 'alert alert-danger',
                  }));
                  setTimeout(() => {
                    this.setState(() => ({
                      slackGrtMsg: '',
                      slackGrtcls: '',
                    }));
                  }, 5000);
                }
              }
            });
        }
      } else if (params.pack_checkout) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-packs-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-packs').addClass('active show');
        $('.choosepackdtls_div').hide();
        $('.creditcarddtls_div').show();
        this.props.history.push('/profile_settings');
      } else if (params.pack_buynew) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-packs-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-packs').addClass('active show');
        $('.choosepackdtls_div').show();
        $('.creditcarddtls_div').hide();
        this.props.history.push('/profile_settings');
      } else if (params.workflow_trigger) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-workflow-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-workflow').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.integrations_list) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-integrations-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-integrations').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.nft_lists) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-nft-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-nft').addClass('active show');
        if (params.tab === 'available') {
          $('#custom-tabs-nftavailable-tab').trigger('click');
        } else if (params.tab === 'sent') {
          $('#custom-tabs-nftinprocess-tab').trigger('click');
        } else if (params.tab === 'accept') {
          $('#custom-tabs-nftsent-tab').trigger('click');
        }
        this.props.history.push('/profile_settings');
      } else if (params.ft_lists) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-ft-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-ft').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.nft_cont) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-nft-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-nft').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.addworkflow) {
        this.addWorkflow();
      } else if (params.change_number) {
        this.setState({ number_click: true });
        setTimeout(() => {
          $('.picknumber_clk').trigger('click');
          this.props.history.push('/profile_settings');
        }, 3500);
      } else if (params.type == 'pack') {
        console.log("params.status", params.status);
        if (params.status == 'success') {
          var checkoutid = params?.session_id;
          $('.processing_div').show();
          $('.wrapper').hide();

          this.paymentChecking(checkoutid);
        } else {
          toast.dark('Your payment has been declined.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } else if (params.type == 'number') {
        console.log('params.status', params.status);
        if (params.status == 'success') {
          AsyncStorage.getItem('purchase_id').then((purchase_id) => {
            if (purchase_id) {
              console.log('purchase_id');
              console.log(purchase_id);
              this.numberpaymentChecking(purchase_id);
            }
          });
          $('.processing_div').show();
          $('.wrapper').hide();
        } else {
          toast.dark('Your payment has been declined.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          this.props.history.push('/profile_settings');
        }
      }
      const archive_history = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios.get(API_CALL_ENDPOINT + '/business/archive/history', archive_history).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState({ archiveHstry_detail: res.data.result });
          // ArchvHstryDtatble = $('#archivehistory_tbl').DataTable({
          //   paging: true,
          //   lengthChange: false,
          //   ordering: false,
          //   searching: false,
          // });
        }

        if (res.data.status == 'no_record') {
          // ArchvHstryDtatble = $('#archivehistory_tbl').DataTable({
          //   paging: true,
          //   lengthChange: false,
          //   ordering: false,
          //   searching: false,
          // });
        }
      });
      const dump_history = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/business/emaildump/history', dump_history)
        .then((res) => {
          console.log(res.data);
          if (res.data.result) {
            this.setState({ emaildump_Hstry_detail: res.data.result });
            // emaildumpDtatble = $('#dailyemaildumphistory_tbl').DataTable({
            //   paging: true,
            //   lengthChange: false,
            //   ordering: false,
            //   searching: false,
            // });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status == 'no_record') {
              // emaildumpDtatble = $('#dailyemaildumphistory_tbl').DataTable({
              //   paging: true,
              //   lengthChange: false,
              //   ordering: false,
              //   searching: false,
              // });
            }
          }
        });
      this.getNumberLists();
      this.areacode();
      $('#chooseareacode1').trigger('click');
      $('.picknewnumber_close').trigger('click');
      this.closeReceipt();
      this.nftDetails();
      this.NftCount();
      this.ft_table_data();
      $('#ft_token_name').val('');
      $('#ft_token_symbol').val('');
      $('#ft_token_number').val('');
      $('.ftrequest_btn').show();
      $('.ftrequest_confirm_btn').hide();
      $('.ftrequest_confirm_message').hide();
      console.log('worlflow1');
      const workflow_list = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };
      axios.get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list).then((res) => {
        if (res.data.result) {
          this.setState({
            workflow_list_array: res.data?.result,
          });
          if (res.data.result.length !== 0) {
            $('.workflowcreate_div').hide();
            $('.addworkflow_div').hide();
            $('.addentrypoints_div').hide();
            $('.workflowlist_div').show();
            // $('#allworkflowlist_tbl').DataTable({
            //   paging: true,
            //   lengthChange: true,
            //   ordering: false,
            //   searching: true,
            // });

            // $('#activeworkflowlist_tbl').DataTable({
            //   paging: true,
            //   lengthChange: true,
            //   ordering: false,
            //   searching: true,
            // });

            // $('#pausedworkflowlist_tbl').DataTable({
            //   paging: true,
            //   lengthChange: true,
            //   ordering: false,
            //   searching: true,
            // });
          } else {
            $('.workflowcreate_div').show();
          }
        }
        if (res.data.status === 'no_record') {
          $('.workflowcreate_div').show();
          $('.addworkflow_div').hide();
          $('.addentrypoints_div').hide();
          $('.workflowlist_div').hide();
        }
      })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'no_record') {
              $('.workflowcreate_div').show();
              $('.addworkflow_div').hide();
              $('.addentrypoints_div').hide();
              $('.workflowlist_div').hide();
            }
          }
        });
      this.businessprofiledetails();
    }, 100);

    setTimeout(() => {
      const card_List = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
        },
      };
      axios
        .get(API_CALL_ENDPOINT + '/stripe/cards/list', card_List)
        .then((res) => {
          console.log(res.data.result);

          if (res.data.result) {
            this.setState({ cardList: res.data.result.cards });
          } else {
            console.log('no cards found');
            this.setState({ cardList: [] });
            document.getElementById('choosecrd').style.display = 'none';
          }
        })
        .catch((error) => {
          console.log(error);
        });
      const tagLst_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      console.log(tagLst_details);
      axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState({ tagList: res.data.result, tag_list: res.data.result });

          // TagLstDtatable = $('#inttags_tbl').DataTable({
          //   paging: true,
          //   lengthChange: false,
          //   ordering: false,
          //   searching: false,
          //   //"responsive": true,
          // });
        }
      });
    }, 100);

    setTimeout(() => {
      const assigned_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };
      console.log(assigned_details);
      axios.get(API_CALL_ENDPOINT + '/user/business/assigned/list', assigned_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState(() => ({
            TeamMbrLst: res.data.result.assigned_user,
          }));

          var jnAry = [];
          for (var i in res.data.result.assigned_user) {
            jnAry.push(res.data.result.assigned_user[i].user_info[0]._id);
          }

          this.setState({ TemIdsMebrArry: jnAry });
          this.setState({ TemIdsMebrArry_chat: jnAry });

          // TemDtatable = $('#profteammember').DataTable({
          //   paging: true,
          //   lengthChange: false,
          //   ordering: false,
          //   searching: false,
          // });
          // $('#emailprofteammember').DataTable({
          //   paging: true,
          //   lengthChange: false,
          //   ordering: false,
          //   searching: false,
          // });
        }
      });
    }, 100);

    setTimeout(() => {
      const VoiceLanguage_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
        },
      };

      console.log(VoiceLanguage_details);
      axios.get(API_CALL_ENDPOINT + '/voice/voice_list', VoiceLanguage_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState({ GrntVoiveLngRegin: res.data.result.voice_list });

          for (var i in res.data.result.voice_list) {
            if (res.data.result.voice_list[i]._id == 'en-US') {
              console.log(res.data.result.voice_list[i].voice_list);
              this.setState({ VoceLstBsOnLanguge: res.data.result.voice_list[i].voice_list });
            }
          }
        }
      });
    }, 100);

    setTimeout(() => {
      const AutotxtRes_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      console.log(AutotxtRes_details);
      axios.get(API_CALL_ENDPOINT + '/business/autotext/list', AutotxtRes_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState({ AutoTxtArea: res.data.result });
        }
      });
    }, 100);

    setTimeout(() => {
      const businessList = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/business/list', businessList)
        .then((res) => {
          console.log(res.data);
          // console.log(res.data.result[0].phone_number.length)
          if (res.data.status === 'success') {
            this.setState({ business_List: res.data.result });
            const onchangebusiness_name = {
              params: {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            axios
              .get(API_CALL_ENDPOINT + '/business/info', onchangebusiness_name)
              .then((res) => {
                //   console.log(res.data);
                if (res.data.status === 'success') {
                  if (
                    res.data?.result?.business.payment_status === 'payment_failed' &&
                    res.data?.result?.business.status !== 'active' &&
                    res.data?.result?.business.status !== 'suspended'
                  ) {
                    console.log('phone empty');
                    AsyncStorage.setItem('business_id', res.data?.result?.business._id);
                    AsyncStorage.setItem('plan_id', res.data?.result?.business.plan_id);
                    AsyncStorage.setItem('user_id', res.data?.result?.business.user_id);

                    this.props.history.push('/create-profile');
                  }
                  if (
                    res.data?.result?.business.phone_number.length === 0 &&
                    res.data?.result?.business.business_name.length === 0
                  ) {
                    // console.log("phone empty")
                    // AsyncStorage.setItem("business_id", res.data.result[0]._id);
                    // AsyncStorage.setItem("plan_id", res.data.result[0].plan_id);
                    this.props.history.push('/create-profile1');
                  }
                  if (
                    res.data?.result?.business.phone_number.length > 0 &&
                    res.data?.result?.business.business_name.length === 0
                  ) {
                    // console.log("phone not empty")
                    // console.log(res.data.result[0].phone_number)
                    // AsyncStorage.setItem("plivo_number", res.data.result[0].phone_number);
                    // AsyncStorage.setItem("business_id", res.data.result[0]._id);
                    // AsyncStorage.setItem("plan_id", res.data.result[0].plan_id);
                    this.props.history.push('/create-profile2');
                  }
                  if (
                    res.data?.result?.business.phone_number.length > 0 &&
                    res.data?.result?.business.business_name.length > 0
                  ) {
                    // AsyncStorage.setItem("plivo_number", res.data.result[0].phone_number);
                    // AsyncStorage.setItem("business_id", res.data.result[0]._id);
                    // console.log("phone not empty")
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (res.data.status === 'no_record') {
            // window.location.reload(true);
            this.props.history.push('/create-profile');
          }
        })
        .catch((error) => {
          console.log(error);
        });
      const business_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };
      console.log(business_details);
      axios.get(API_CALL_ENDPOINT + '/business/info', business_details).then((res) => {
        console.log('/business/infosss', res.data);
        $('#nft_token_name').val('');
        $('#nft_token_symbol').val('');
        $('#token_limits').val('');
        $('.key_vals').val('');
        $('.append_divs').remove();
        $('#keyrequired0').prop('checked', false);
        if ($('#custom-tabs-workspace_id-tab').hasClass('active')) {
          if (res.data.result?.busines_evaluation_details?.status == 'pending') {
            toast.dark(
              'Thank you for your patience, please note that your workspace is under verification. We will get back to you upon verification via email.',
              {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              },
            );
            return false;
          } else if (
            !res.data.result?.busines_evaluation_details ||
            res.data.result?.busines_evaluation_details?.status != 'approved' ||
            res.data.result?.busines_evaluation_details?.otp_status != 'verified'
          ) {
            $('.business_evaluation_popup').trigger('click');
          }
        }
        if (res.data.result) {
          this.setState({
            business_info_array: res.data?.result,
            business_name1: res.data?.result?.business.business_name,
            business_color_code: res.data?.result?.business.color_code,
            prfImag: res?.data?.result?.business?.profile_image,
          });
          if (res.data.result.business.phone_number) {
            const prefix = res.data.result.business.phone_number.substring(1, 0);

            if (prefix == '1' || prefix == '0') {
              res.data.result.business.phone_number = res.data.result.business.phone_number.substring(1);
              res.data.result.business.phone_number = res.data.result.business.phone_number
                .replace(/[^\dA-Z]/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                .trim();
              this.setState({ business_info_phone: res.data.result.business.phone_number });
            } else {
              res.data.result.business.phone_number = res.data.result.business.phone_number
                .replace(/[^\dA-Z]/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                .trim();

              this.setState({ business_info_phone: res.data.result.business.phone_number });
            }
          }
          this.setState(() => ({
            prfImag: res.data.result.business.profile_image,
            business_info_name: res.data.result.business.business_name,
            business_email_address: res?.data?.result?.business?.email_address,
            business_email_name: res?.data?.result?.business?.email_address.substring(
              0,
              res?.data?.result?.business?.email_address.lastIndexOf('@'),
            ),
            chars_left_profilename: this.state.max_chars_profilename - res.data.result.business.business_name.length,
            // business_info_phone:res.data.result.business.phone_number,
            business_info_details: res.data.result.business.description,
            chars_left_description: this.state.max_chars_description - res.data.result.business.description.length,
            SummaryAlerts: res.data.result.business.summary_alert,
            smryTeamIds: res.data.result.business.summary_alert.team_id,
            TmRcvdalrt: res.data.result.business.summary_alert.receive_alert,
          }));

          if (res.data.result.business.summary_alert.status == 'on') {
            $('.summaryalert_tgldiv').show();
            $('#summaryalert').prop('checked', true);
          }

          if (res.data.result.business.summary_alert.status == 'off') {
            $('.summaryalert_tgldiv').hide();
            $('#summaryalert').prop('checked', false);
          }
          if (res.data.result.business.view_archive == 'on') {
            $('#archivemessages').prop('checked', true);
          }
          if (res.data.result.business.view_archive == 'off') {
            $('#archivemessages').prop('checked', false);
          }

          if (res.data.result.business.auto_text_response.status == 'on') {
            $('#autotextresponse').prop('checked', true);
            $('.autotxtrespnse_tgldiv').show();
            this.setState({
              AutotxtMxRspnsVlue: res.data.result.business.auto_text_response.maximum_response,
              AtoTxDelClkDisble: false,
            });
            $('#autoTxtrespnsDel_id').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
          }

          if (res.data.result.business.auto_text_response.status == 'off') {
            $('#autotextresponse').prop('checked', false);
            $('.autotxtrespnse_tgldiv').hide();
            this.setState({
              AutotxtMxRspnsVlue: '',
              AtoTxDelClkDisble: true,
            });
          }

          if (res.data.result.business.voice_greetings.status == 'on') {
            $('#voicemsg').prop('checked', true);
            $('.voicemsg_tgldiv').show();
            if (res.data.result.business.voice_greetings.type == 'record') {
              this.setState({
                VoiceGrtngblobURL: res.data.result.business.voice_greetings.greeting_url,
                VoiceGrtngRecDeltDisble: false,
              });
              $('#audioPlayVoiceGrtng').show();
              $('#audioStrtVoiceGrtng').hide();
              $('#voice_record').prop('checked', true);
              $('div.voicedesc').hide();
              $('#voicemsg1').show();
            }

            if (res.data.result.business.voice_greetings.type == 'text') {
              this.setState({
                TxtTypeVoiceUrl: res.data.result.business.voice_greetings.greeting_url,
                generatePlayDisble: false,
                TxtVoiceGrtngvlue: res.data.result.business.voice_greetings.text,
                VoiceLngRegn: res.data.result.business.voice_greetings.language_region,
                voiceGnrteResetdisble: false,
                VoiceGrtngTxtTypDeltDisble: false,
              });

              $('#voice_typetxt').prop('checked', true);
              $('div.voicedesc').hide();
              $('#voicemsg2').show();

              for (var i in this.state.GrntVoiveLngRegin) {
                if (this.state.GrntVoiveLngRegin[i]._id == res.data.result.business.voice_greetings.language_region) {
                  console.log(this.state.GrntVoiveLngRegin[i].voice_list);
                  this.setState({ VoceLstBsOnLanguge: this.state.GrntVoiveLngRegin[i].voice_list });
                }
              }
              $(
                res.data.result.business.voice_greetings.voice
                  ? '.' + res.data.result.business.voice_greetings.voice
                  : '.Justin',
              ).prop('checked', true);
              this.setState({ VoiceClksId: res.data.result.business.voice_greetings.voice });
            }
          }

          if (res.data.result.business.voice_greetings.status == 'off') {
            $('#voicemsg').prop('checked', false);
            $('.voicemsg_tgldiv').hide();
            $('#audioPlayVoiceGrtng').hide();
            $('#audioStrtVoiceGrtng').show();
            $('#voice_record').prop('checked', false);
            $('div.voicedesc').show();
            $('#voicemsg1').hide();
            $('#voice_typetxt').prop('checked', false);
            $('div.voicedesc').show();
            $('#voicemsg2').hide();
          }
          if (res.data.result.business.auto_text_unsupport.status == 'off') {
            $('#autotextresponsemedia').prop('checked', false);
            $('.autotxtrespnsemedia_tgldiv').hide();
            this.setState({
              unsupportedtext: '',
              unsupportedtext_unique_id: '',
            });
          } else {
            $('#autotextresponsemedia').prop('checked', true);
            $('.autotxtrespnsemedia_tgldiv').show();
            this.setState({
              unsupportedtext: res.data.result.business.auto_text_unsupport.text_response,
              unsupportedtext_unique_id: res.data.result.business.auto_text_unsupport.unique_id,
            });
          }

          if (res.data.result.business.auto_voice_response.status == 'on') {
            $('#autovoiceresponse').prop('checked', true);
            $('.autovoiceresponse_tgldiv').show();

            if (res.data.result.business.auto_voice_response.type == 'leave_message') {
              this.setState({
                LeavAutoVceMsgVle: res.data.result.business.auto_voice_response.text_response,
                LeavAutoVceMsgVle_unique_id: res.data.result.business.auto_voice_response.unique_id,
                LeavAutoVoiceMxmRspnsVlu: res.data.result.business.auto_voice_response.maximum_response,
                leaveMsgDelDisble: false,
              });
              $('#autovoicemsg1').show();
              $('#autovoicemsg').prop('checked', true);
            }

            if (res.data.result.business.auto_voice_response.type == 'hangup_message') {
              this.setState({
                HangMsgValue: res.data.result.business.auto_voice_response.maximum_response,
                hangupMsgDelDisble: false,
              });
              $('#autovoicemsg2').show();
              $('#autovoicehangup').prop('checked', true);
            }
          }

          if (res.data.result.business.auto_voice_response.status == 'off') {
            $('#autovoiceresponse').prop('checked', false);
            $('.autovoiceresponse_tgldiv').hide();
            $('#autovoicemsg1').hide();
            $('#autovoicemsg').prop('checked', false);
            $('#autovoicemsg2').hide();
            $('#autovoicehangup').prop('checked', false);
          }

          if (res.data.result.business.birthday.status == 'on') {
            $('#bdaygreetings').prop('checked', true);
            $('.bdaygreetings_tgldiv').show();
            this.setState({
              birthdyTxtValue: res.data.result.business.birthday.text,
              birthdyTxtValue_unique_id: res.data.result.business.birthday.unique_id,
              bithGrtngTimeSelt: res.data.result.business.birthday.local_time,
              bithGrtngTime: res.data.result.business.birthday.local_time,
              bithGrtngTimeZoneSelt: res.data.result.business.birthday.offset,
              bithGrtngTimeZone: res.data.result.business.birthday.offset,
              brthdyGrtngDelDisble: false,
            });
          }

          if (res.data.result.business.birthday.status == 'off') {
            $('#bdaygreetings').prop('checked', false);
            $('.bdaygreetings_tgldiv').hide();
            this.setState({
              birthdyTxtValue: '',
              birthdyTxtValue_unique_id: '',
              bithGrtngTimeSelt: '',
              bithGrtngTime: '12:00 AM',
              bithGrtngTimeZoneSelt: '',
              bithGrtngTimeZone: 'GMT-1200',
              brthdyGrtngDelDisble: true,
            });
          }

          var archiveMdStatus = res.data.result.business.archive.text;

          if (archiveMdStatus == 'on') {
            $('#archivemode').prop('checked', true);
            this.setState({ VwArchiewDisbl: false });
          }
          if (archiveMdStatus == 'off') {
            $('#archivemode').prop('checked', false);
            this.setState({ VwArchiewDisbl: true });
          }

          var TmIdDtls = res.data.result.business.summary_alert.team_id;
          for (var j in TmIdDtls) {
            $('.smryTmIds' + TmIdDtls[j]).prop('checked', true);
          }
          var TmIdDtls_email = res.data.result.business.integration_email.team_id;
          console.log('email integration', TmIdDtls_email);
          for (var g in TmIdDtls_email) {
            // console.log('email integration', TmIdDtls_email[g]);
            $('.emailteam' + TmIdDtls_email[g]).prop('checked', true);
          }

          var TmIdDtls_chat = res.data.result.business.chat_widget.team_id;
          for (var p in TmIdDtls_chat) {
            $('.chatTmIds_' + TmIdDtls_chat[p]).prop('checked', true);
          }
          var TagDtls_chat = res.data.result.business.chat_widget.tags;
          // this.setState({chat_filtered_tag_list: TagDtls_chat});
          for (var g = 0; g < TagDtls_chat.length; g++) {
            // for (var g in TagDtls_chat) {
            console.log('to be selected inside list', TagDtls_chat[g]);
            $('.chatWidget_tags option').filter(`[value=${TagDtls_chat[g]}]`).attr('selected', 'selected');
          }
          this.setState({
            chat_grtmsg: res.data.result.business.chat_widget.greeting,
            chat_replymsg: res.data.result.business.chat_widget.reply_message,
            chat_newcontactmsg: res.data.result.business.chat_widget.new_contact_message,
            chat_existcontactmsg: res.data.result.business.chat_widget.existing_contact_message,
          });
          var assigned_role_restrict = res?.data?.result?.business?.user_role.find(
            (usr) => usr.user_id === this.state.user_id,
          );
          if (assigned_role_restrict) {
            console.log('assigned_role_restrict found', assigned_role_restrict);
            this.user_roles_info(assigned_role_restrict.role_id);
          } else {
            console.log('assigned_role_restrict not found', assigned_role_restrict);
          }
        }
      });
      const cart_list = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios.get(API_CALL_ENDPOINT + '/booster/cart/list', cart_list).then((res) => {
        console.log('/booster/cart/list', res.data);
        if (res.data.result) {
          let price_quantity_list = [...this.state.price_quantity_list];
          let order_amount = 0;
          let order_doller = 0;
          let exist_cart_id = [];
          for (let i = 0; i < res.data?.result?.length; i++) {
            const item = res.data.result[i];

            let selectedQlist = price_quantity_list.find((x) => x._id === item.master_pack_id);
            selectedQlist.quantity = item.pack_quantity;

            var removeIndex = price_quantity_list.map((listitem) => listitem._id).indexOf(item.master_pack_id);
            price_quantity_list.splice(removeIndex, 1);
            price_quantity_list = [...price_quantity_list, selectedQlist];
            // order_amount = order_amount.push("'" + res.data?.result[i]?.order_amount + "'");

            order_amount += res.data?.result[i]?.order_amount;
            order_doller += parseInt(res.data?.result[i]?.order_doller);
            // order_amount = order_amount.join(', ');
            // exist_cart_id = exist_cart_id.push("'" + res.data?.result[i]?._id + "'");
            exist_cart_id = [...exist_cart_id, res.data?.result[i]?._id];
            // exist_cart_id = exist_cart_id.join(', ');
          }
          console.log('price_quantity_list', price_quantity_list);
          this.setState({
            price_quantity_list,
            order_amount,
            exist_cart_id,
            order_doller,
          });
          // for (var i in res.data?.result) {
          //   if (res.data?.result[i]?.pack_type === 'message') {
          //     this.setState({
          //       pack_quantity_message: res.data?.result[i]?.pack_quantity,
          //       order_data_count: res.data?.result[i]?.order_data_count,
          //       order_doller: res.data?.result[i]?.order_doller,
          //       order_amount: res.data?.result[i]?.order_amount,
          //       exist_cart_id: res.data?.result[i]?._id,
          //     });
          //   }
          // }

          this.setState({ packcart_list: res.data.result });
        } else if (res.data.status == 'no_record') {
        }
      });

      const contactslist = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/contacts/list', contactslist)
        .then((res) => {
          if (res.data.status === 'no_record') {
            // document.getElementById('contact_nil').style.display = 'block';
          }
          this.setState({
            contacts: res.data?.result?.contacts,
            contacts_archive: res.data?.result?.contacts,
          });
          // var available_data = this.state.contacts_available_archived
          // for (var i in res.data?.result?.contacts) {
          //   if (res.data?.result?.contacts[i].text_archive !== 'false') {
          //     available_data.push(res.data?.result?.contacts[i]._id)
          //   }
          //   this.setState({contacts_available_archived: available_data})
          //   console.log("this.state.contacts_available_archived",this.state.contacts_available_archived)
          // }
          var conList = [];
          for (var i in res.data?.result?.contacts) {
            if (res.data?.result?.contacts[i].text_archive !== 'false') {
              // console.log(res.data?.result?.contacts[i]._id);
              var name =
                res.data?.result?.contacts[i].first_name == 'Guest'
                  ? '+91 ' +
                  res.data?.result?.contacts[i].phone_number
                    .toString()
                    .substring(1)
                    .replace(/[^\dA-Z]/g, '')
                    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                    .trim()
                  : res.data?.result?.contacts[i].first_name + ' ' + res.data?.result?.contacts[i].last_name;
              conList.push({
                name: name,
                value: res.data?.result?.contacts[i]._id,
                tags: res.data?.result?.contacts[i].tags,
                contact: res.data?.result?.contacts[i],
              });
            }
          }
          this.setState({ dropDownValue: conList });
        })
        .catch((error) => { });
      this.templates_listclick();
    }, 100);
    // this.dataLst();
    $('.viewarchive_tgldiv').hide();
  };
  componentDidMount() {
    this.start_fn();

    AsyncStorage.getItem('business_id').then((business_id) => {
      if (business_id) {
        this.setState({ business_id });
        url_business_id = business_id;
        console.log('business_id');
        console.log(business_id);
      }
    });
    AsyncStorage.getItem('user_id').then((user_id) => {
      if (user_id) {
        this.setState({ user_id });
        console.log('User_id');
        console.log(user_id);
      }
    });

    AsyncStorage.getItem('user_email').then((user_email) => {
      if (user_email) {
        this.setState({ user_email });
        console.log('email code');
        console.log(user_email);
      }
    });
    this.user_views_list();

    const user_details = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
      },
    };

    axios.get(API_CALL_ENDPOINT + '/user/info', user_details).then((res) => {
      if (res.data.result) {
        this.setState({
          user_details: res.data.result.user,
        });
      }
    });
    const pack_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
      },
    };

    axios.get(API_CALL_ENDPOINT + '/booster/pack/list', pack_list).then((res) => {
      if (res.data.result) {
        let price_quantity_list = [];
        for (let i = 0; i < res.data?.result?.length; i++) {
          const item = res.data.result[i];
          price_quantity_list = [
            ...price_quantity_list,
            {
              _id: item._id,
              quantity: 1,
            },
          ];
        }
        console.log('price_quantity_list', price_quantity_list);
        this.setState({
          booster_pack_list: res.data.result,
          price_quantity_list,
        });
      } else if (res.data.status == 'no_record') {
      }
    });
    setTimeout(() => {
      let url = this.props.location.search;
      let params = queryString.parse(url);
      console.log('params', params);
      if (params.code) {
        // console.log('Code,State', params.code, params.state);

        var Slack_business_id = params?.state?.split('|');
        // console.log('Slack_business_id', Slack_business_id);
        // console.log('business_id', this.state.business_id);
        if (Slack_business_id[1] === this.state.business_id) {
          const options = {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          };
          const data = new FormData();
          data.append('client_id', Slack_clientid);
          data.append('client_secret', Slack_secret);
          data.append('code', params.code);
          axios
            .post('https://slack.com/api/oauth.v2.access', data, options)

            .then((res) => {
              var jsondata = {
                ok: res?.data.ok,
                access_token: res?.data.access_token,
                scope: res?.data.scope,
                user_id: res?.data.bot_user_id,
                team_id: res?.data.team.id,
                enterprise_id: res?.data.enterprise,
                team_name: res?.data.team.name,
                incoming_webhook: res?.data.incoming_webhook,
              };
              //   console.log('https://slack.com/api/oauth.access', res);
              if (res.data) {
                const Slack_integrate = {
                  apikey: API_KEY,
                  secret: API_SECRET,
                  user_id: this.state?.user_id,
                  business_id: this.state?.business_id,
                  setup: 'slack',
                  slack: jsondata,
                };
                // console.log('Slack_integrate', Slack_integrate);
                axios
                  .post(API_CALL_ENDPOINT + '/business/profile/settings', Slack_integrate)
                  .then((res1) => {
                    // console.log('Response', res1);
                    // $('#custom-tabs-integrations-tab').trigger('click');
                    $(".nav_links_prof").removeClass('active');
                    $('.nav_links_prof_tabs').removeClass('active show');
                    $('#custom-tabs-general-tab').removeClass('active');
                    $('#custom-tabs-integrations-tab').addClass('active');
                    $('#custom-tabs-general').removeClass('active show');
                    $('#custom-tabs-integrations').addClass('active show');
                    $('#custom-tabs-psemail-tab').removeClass('active');
                    $('#custom-tabs-psslack-tab').addClass('active');
                    $('#custom-tabs-psemail').removeClass('active show');
                    $('#custom-tabs-psslack').addClass('active show');
                    this.props.history.push('/profile_settings');
                    const business_details = {
                      params: {
                        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                        secret: 'R1eqD2twI3E4',
                        user_id: this.state.user_id,
                        business_id: this.state.business_id,
                      },
                    };
                    console.log(business_details);
                    axios.get(API_CALL_ENDPOINT + '/business/info', business_details).then((res) => {
                      console.log('/business/info', res.data);
                      if (res.data.result) {
                        this.setState({
                          business_info_array: res.data?.result,
                          business_name1: res.data?.result?.business.business_name,
                          business_color_code: res.data?.result?.business.color_code,
                          prfImag: res?.data?.result?.business?.profile_image,
                        });

                        var assigned_role_restrict = res?.data?.result?.business?.user_role.find(
                          (usr) => usr.user_id === this.state.user_id,
                        );
                        if (assigned_role_restrict) {
                          console.log('assigned_role_restrict found', assigned_role_restrict);
                          this.user_roles_info(assigned_role_restrict.role_id);
                        } else {
                          console.log('assigned_role_restrict not found', assigned_role_restrict);
                        }
                      }
                    });
                    if (res1?.data?.status === 'conflict') {
                      this.setState(() => ({
                        slackGrtMsg: res1?.data?.message,
                        slackGrtcls: 'alert alert-danger',
                      }));
                      setTimeout(() => {
                        this.setState(() => ({
                          slackGrtMsg: '',
                          slackGrtcls: '',
                        }));
                      }, 5000);
                    }
                    // window.location.reload(true);
                  })
                  .catch((error) => {
                    if (error.response) {
                      if (error.response?.data?.status === 'conflict') {
                        this.setState(() => ({
                          slackGrtMsg: error.response?.data?.message,
                          slackGrtcls: 'alert alert-danger',
                        }));
                        setTimeout(() => {
                          this.setState(() => ({
                            slackGrtMsg: '',
                            slackGrtcls: '',
                          }));
                        }, 5000);
                      }
                    }
                  });
              }
            })
            .catch((err) => {
              console.log('ERROR', err);
            });
        }
      } else if (params.pack_checkout) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-packs-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-packs').addClass('active show');
        $('.choosepackdtls_div').hide();
        $('.creditcarddtls_div').show();
        this.props.history.push('/profile_settings');
      } else if (params.pack_buynew) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-packs-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-packs').addClass('active show');
        $('.choosepackdtls_div').show();
        $('.creditcarddtls_div').hide();
        this.props.history.push('/profile_settings');
      } else if (params.workflow_trigger) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-workflow-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-workflow').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.workflow) {
        // console.log("urlparse", (params.workflow_id));
        this.onupdate_workflow_view(params.workflow_id);
        this.props.history.push('/profile_settings');
      } else if (params.integrations) {
        // console.log("urlparse", (params.workflow_id));
        this.onupdate_integration_view(params.type);
        this.props.history.push('/profile_settings');
      } else if (params.integrations_list) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-integrations-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-integrations').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.nft_lists) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-nft-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-nft').addClass('active show');
        if (params.tab === 'available') {
          $('#custom-tabs-nftavailable-tab').trigger('click');
        } else if (params.tab === 'sent') {
          $('#custom-tabs-nftinprocess-tab').trigger('click');
        } else if (params.tab === 'accept') {
          $('#custom-tabs-nftsent-tab').trigger('click');
        }
        this.props.history.push('/profile_settings');
      } else if (params.ft_lists) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-ft-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-ft').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.nft_cont) {
        $(".nav_links_prof").removeClass('active');
        $('.nav_links_prof_tabs').removeClass('active show');
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-nft-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-nft').addClass('active show');
        this.props.history.push('/profile_settings');
      } else if (params.change_number) {
        this.setState({ number_click: true });
        setTimeout(() => {
          $('.picknumber_clk').trigger('click');
          this.props.history.push('/profile_settings');
        }, 3500);
      } else if (params.type == 'pack') {
        console.log("params.status", params.status);
        if (params.status == 'success') {
          var checkoutid = params?.session_id;
          this.paymentChecking(checkoutid);
          $('.processing_div').show();
          $('.wrapper').hide();

        } else {
          toast.dark('Your payment has been declined.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } else if (params.type == 'number') {
        console.log('params.status', params.status);
        if (params.status == 'success') {
          AsyncStorage.getItem('purchase_id').then((purchase_id) => {
            if (purchase_id) {
              console.log('purchase_id');
              console.log(purchase_id);
              this.numberpaymentChecking(purchase_id);
            }
          });
          $('.processing_div').show();
          $('.wrapper').hide();
        } else {
          toast.dark('Your payment has been declined.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          this.props.history.push('/profile_settings');
        }
      }

      const archive_history = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/business/archive/history', archive_history)
        .then((res) => {
          console.log(res.data);
          if (res.data.result) {
            this.setState({ archiveHstry_detail: res.data.result });
            ArchvHstryDtatble = $('#archivehistory_tbl').DataTable({
              paging: true,
              lengthChange: false,
              ordering: false,
              searching: false,
            });
          }

          if (res.data.status == 'no_record') {
            ArchvHstryDtatble = $('#archivehistory_tbl').DataTable({
              paging: true,
              lengthChange: false,
              ordering: false,
              searching: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status == 'no_record') {
              ArchvHstryDtatble = $('#archivehistory_tbl').DataTable({
                paging: true,
                lengthChange: false,
                ordering: false,
                searching: false,
              });
            }
          }
        });
      const dump_history = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/business/emaildump/history', dump_history)
        .then((res) => {
          console.log(res.data);
          if (res.data.result) {
            this.setState({ emaildump_Hstry_detail: res.data.result });
            emaildumpDtatble = $('#dailyemaildumphistory_tbl').DataTable({
              paging: true,
              lengthChange: false,
              ordering: false,
              searching: false,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status == 'no_record') {
              emaildumpDtatble = $('#dailyemaildumphistory_tbl').DataTable({
                paging: true,
                lengthChange: false,
                ordering: false,
                searching: false,
              });
            }
          }
        });

      this.getNumberLists();
      this.closeReceipt();
      this.nftDetails();
      this.NftCount();
      this.ft_table_data();
      console.log('worlflow2');
      const workflow_list = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };
      axios
        .get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list)
        .then((res) => {
          if (res.data.result) {
            this.setState({
              workflow_list_array: res.data?.result,
            });
            if (res.data.result.length !== 0) {
              $('.workflowcreate_div').hide();
              $('.addworkflow_div').hide();
              $('.addentrypoints_div').hide();
              $('.workflowlist_div').show();
              $('#allworkflowlist_tbl').DataTable({
                paging: true,
                lengthChange: true,
                ordering: false,
                searching: true,
              });

              $('#activeworkflowlist_tbl').DataTable({
                paging: true,
                lengthChange: true,
                ordering: false,
                searching: true,
              });

              $('#pausedworkflowlist_tbl').DataTable({
                paging: true,
                lengthChange: true,
                ordering: false,
                searching: true,
              });
            } else {
              $('.workflowcreate_div').show();
            }
          }
          if (res.data.status === 'no_record') {
            $('.workflowcreate_div').show();
            $('.addworkflow_div').hide();
            $('.addentrypoints_div').hide();
            $('.workflowlist_div').hide();
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'no_record') {
              $('.workflowcreate_div').show();
              $('.addworkflow_div').hide();
              $('.addentrypoints_div').hide();
              $('.workflowlist_div').hide();
            }
          }
        });
      this.businessprofiledetails();
      this.loadWebhooks();
    }, 100);

    setTimeout(() => {
      const card_List = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
        },
      };
      axios
        .get(API_CALL_ENDPOINT + '/stripe/cards/list', card_List)
        .then((res) => {
          console.log(res.data.result);

          if (res.data.result) {
            this.setState({ cardList: res.data.result.cards });
          } else {
            console.log('no cards found');
            this.setState({ cardList: [] });
            document.getElementById('choosecrd').style.display = 'none';
          }
        })
        .catch((error) => {
          console.log(error);
        });
      const tagLst_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      console.log(tagLst_details);
      axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState({ tagList: res.data.result, tag_list: res.data.result });

          TagLstDtatable = $('#inttags_tbl').DataTable({
            paging: true,
            lengthChange: false,
            ordering: false,
            searching: false,
            //"responsive": true,
          });
        }
      });
    }, 100);

    setTimeout(() => {
      const assigned_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };
      console.log(assigned_details);
      axios.get(API_CALL_ENDPOINT + '/user/business/assigned/list', assigned_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState(() => ({
            TeamMbrLst: res.data.result.assigned_user,
          }));

          var jnAry = [];
          for (var i in res.data.result.assigned_user) {
            jnAry.push(res.data.result.assigned_user[i].user_info[0]._id);
          }

          this.setState({ TemIdsMebrArry: jnAry });
          this.setState({ TemIdsMebrArry_chat: jnAry });

          TemDtatable = $('#profteammember').DataTable({
            paging: true,
            lengthChange: false,
            ordering: false,
            searching: false,
          });
          $('#emailprofteammember').DataTable({
            paging: true,
            lengthChange: false,
            ordering: false,
            searching: false,
          });
        }
      });
    }, 100);

    setTimeout(() => {
      const VoiceLanguage_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
        },
      };

      console.log(VoiceLanguage_details);
      axios.get(API_CALL_ENDPOINT + '/voice/voice_list', VoiceLanguage_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState({ GrntVoiveLngRegin: res.data.result.voice_list });

          for (var i in res.data.result.voice_list) {
            if (res.data.result.voice_list[i]._id == 'en-US') {
              console.log(res.data.result.voice_list[i].voice_list);
              this.setState({ VoceLstBsOnLanguge: res.data.result.voice_list[i].voice_list });
            }
          }
        }
      });
    }, 100);

    setTimeout(() => {
      const AutotxtRes_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      console.log(AutotxtRes_details);
      axios.get(API_CALL_ENDPOINT + '/business/autotext/list', AutotxtRes_details).then((res) => {
        console.log(res.data);
        if (res.data.result) {
          this.setState({ AutoTxtArea: res.data.result });
        }
      });
    }, 100);

    setTimeout(() => {
      const businessList = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/business/list', businessList)
        .then((res) => {
          console.log(res.data);
          // console.log(res.data.result[0].phone_number.length)
          if (res.data.status === 'success') {
            this.setState({ business_List: res.data.result });
            const onchangebusiness_name = {
              params: {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            axios
              .get(API_CALL_ENDPOINT + '/business/info', onchangebusiness_name)
              .then((res) => {
                //   console.log(res.data);
                if (res.data.status === 'success') {
                  if (
                    res.data?.result?.business.payment_status === 'payment_failed' &&
                    res.data?.result?.business.status !== 'active' &&
                    res.data?.result?.business.status !== 'suspended'
                  ) {
                    console.log('phone empty');
                    AsyncStorage.setItem('business_id', res.data?.result?.business._id);
                    AsyncStorage.setItem('plan_id', res.data?.result?.business.plan_id);
                    AsyncStorage.setItem('user_id', res.data?.result?.business.user_id);

                    this.props.history.push('/create-profile');
                  }
                  if (
                    res.data?.result?.business.phone_number.length === 0 &&
                    res.data?.result?.business.business_name.length === 0
                  ) {
                    // console.log("phone empty")
                    // AsyncStorage.setItem("business_id", res.data.result[0]._id);
                    // AsyncStorage.setItem("plan_id", res.data.result[0].plan_id);
                    this.props.history.push('/create-profile1');
                  }
                  if (
                    res.data?.result?.business.phone_number.length > 0 &&
                    res.data?.result?.business.business_name.length === 0
                  ) {
                    // console.log("phone not empty")
                    // console.log(res.data.result[0].phone_number)
                    // AsyncStorage.setItem("plivo_number", res.data.result[0].phone_number);
                    // AsyncStorage.setItem("business_id", res.data.result[0]._id);
                    // AsyncStorage.setItem("plan_id", res.data.result[0].plan_id);
                    this.props.history.push('/create-profile2');
                  }
                  if (
                    res.data?.result?.business.phone_number.length > 0 &&
                    res.data?.result?.business.business_name.length > 0
                  ) {
                    // AsyncStorage.setItem("plivo_number", res.data.result[0].phone_number);
                    // AsyncStorage.setItem("business_id", res.data.result[0]._id);
                    // console.log("phone not empty")
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (res.data.status === 'no_record') {
            // window.location.reload(true);
            this.props.history.push('/create-profile');
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'no_record') {
              // window.location.reload(true);
              this.props.history.push('/create-profile');
            }
          }
        });
      const business_details = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };
      console.log(business_details);
      axios.get(API_CALL_ENDPOINT + '/business/info', business_details).then((res) => {
        console.log('/business/info', res.data);
        if (res.data.result) {
          this.setState({
            business_info_array: res.data?.result,
            business_name1: res.data?.result?.business.business_name,
            business_color_code: res.data?.result?.business.color_code,
            prfImag: res?.data?.result?.business?.profile_image,
          });
          if (res.data.result.business.phone_number) {
            const prefix = res.data.result.business.phone_number.substring(1, 0);

            if (prefix == '1' || prefix == '0') {
              res.data.result.business.phone_number = res.data.result.business.phone_number.substring(1);
              res.data.result.business.phone_number = res.data.result.business.phone_number
                .replace(/[^\dA-Z]/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                .trim();
              this.setState({ business_info_phone: res.data.result.business.phone_number });
            } else {
              res.data.result.business.phone_number = res.data.result.business.phone_number
                .replace(/[^\dA-Z]/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                .trim();

              this.setState({ business_info_phone: res.data.result.business.phone_number });
            }
          }
          this.setState(() => ({
            prfImag: res.data.result.business.profile_image,
            business_info_name: res.data.result.business.business_name,
            business_email_address: res?.data?.result?.business?.email_address,
            business_email_name: res?.data?.result?.business?.email_address.substring(
              0,
              res?.data?.result?.business?.email_address.lastIndexOf('@'),
            ),
            chars_left_profilename: this.state.max_chars_profilename - res.data.result.business.business_name.length,
            // business_info_phone:res.data.result.business.phone_number,
            business_info_details: res.data.result.business.description,
            chars_left_description: this.state.max_chars_description - res.data.result.business.description.length,
            SummaryAlerts: res.data.result.business.summary_alert,
            smryTeamIds: res.data.result.business.summary_alert.team_id,
            TmRcvdalrt: res.data.result.business.summary_alert.receive_alert,
          }));

          if (res.data.result.business.summary_alert.status == 'on') {
            $('.summaryalert_tgldiv').show();
            $('#summaryalert').prop('checked', true);
          }

          if (res.data.result.business.summary_alert.status == 'off') {
            $('.summaryalert_tgldiv').hide();
          }
          if (res.data.result.business.view_archive == 'on') {
            $('#archivemessages').prop('checked', true);
          }

          if (res.data.result.business.auto_text_response.status == 'on') {
            $('#autotextresponse').prop('checked', true);
            $('.autotxtrespnse_tgldiv').show();
            this.setState({
              AutotxtMxRspnsVlue: res.data.result.business.auto_text_response.maximum_response,
              AtoTxDelClkDisble: false,
            });
            $('#autoTxtrespnsDel_id').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
          }

          if (res.data.result.business.auto_text_response.status == 'off') {
            $('#autotextresponse').prop('checked', false);
          }

          if (res.data.result.business.voice_greetings.status == 'on') {
            $('#voicemsg').prop('checked', true);
            $('.voicemsg_tgldiv').show();
            if (res.data.result.business.voice_greetings.type == 'record') {
              this.setState({
                VoiceGrtngblobURL: res.data.result.business.voice_greetings.greeting_url,
                VoiceGrtngRecDeltDisble: false,
              });
              $('#audioPlayVoiceGrtng').show();
              $('#audioStrtVoiceGrtng').hide();
              $('#voice_record').prop('checked', true);
              $('div.voicedesc').hide();
              $('#voicemsg1').show();
            }

            if (res.data.result.business.voice_greetings.type == 'text') {
              this.setState({
                TxtTypeVoiceUrl: res.data.result.business.voice_greetings.greeting_url,
                generatePlayDisble: false,
                TxtVoiceGrtngvlue: res.data.result.business.voice_greetings.text,
                VoiceLngRegn: res.data.result.business.voice_greetings.language_region,
                voiceGnrteResetdisble: false,
                VoiceGrtngTxtTypDeltDisble: false,
              });

              $('#voice_typetxt').prop('checked', true);
              $('div.voicedesc').hide();
              $('#voicemsg2').show();

              for (var i in this.state.GrntVoiveLngRegin) {
                if (this.state.GrntVoiveLngRegin[i]._id == res.data.result.business.voice_greetings.language_region) {
                  console.log(this.state.GrntVoiveLngRegin[i].voice_list);
                  this.setState({ VoceLstBsOnLanguge: this.state.GrntVoiveLngRegin[i].voice_list });
                }
              }
              $(
                res.data.result.business.voice_greetings.voice
                  ? '.' + res.data.result.business.voice_greetings.voice
                  : '.Justin',
              ).prop('checked', true);
              this.setState({ VoiceClksId: res.data.result.business.voice_greetings.voice });
            }
          }

          if (res.data.result.business.voice_greetings.status == 'off') {
            $('#voicemsg').prop('checked', false);
          }
          if (res.data.result.business.auto_text_unsupport.status == 'off') {
            $('#autotextresponsemedia').prop('checked', false);
            $('.autotxtrespnsemedia_tgldiv').hide();
          } else {
            $('#autotextresponsemedia').prop('checked', true);
            $('.autotxtrespnsemedia_tgldiv').show();
            this.setState({
              unsupportedtext: res.data.result.business.auto_text_unsupport.text_response,
              unsupportedtext_unique_id: res.data.result.business.auto_text_unsupport.unique_id,
            });
          }

          if (res.data.result.business.auto_voice_response.status == 'on') {
            $('#autovoiceresponse').prop('checked', true);
            $('.autovoiceresponse_tgldiv').show();

            if (res.data.result.business.auto_voice_response.type == 'leave_message') {
              this.setState({
                LeavAutoVceMsgVle: res.data.result.business.auto_voice_response.text_response,
                LeavAutoVceMsgVle_unique_id: res.data.result.business.auto_voice_response.unique_id,
                LeavAutoVoiceMxmRspnsVlu: res.data.result.business.auto_voice_response.maximum_response,
                leaveMsgDelDisble: false,
              });
              $('#autovoicemsg1').show();
              $('#autovoicemsg').prop('checked', true);
            }

            if (res.data.result.business.auto_voice_response.type == 'hangup_message') {
              this.setState({
                HangMsgValue: res.data.result.business.auto_voice_response.maximum_response,
                hangupMsgDelDisble: false,
              });
              $('#autovoicemsg2').show();
              $('#autovoicehangup').prop('checked', true);
            }
          }

          if (res.data.result.business.auto_voice_response.status == 'off') {
            $('#autovoiceresponse').prop('checked', false);
          }

          if (res.data.result.business.birthday.status == 'on') {
            $('#bdaygreetings').prop('checked', true);
            $('.bdaygreetings_tgldiv').show();
            this.setState({
              birthdyTxtValue: res.data.result.business.birthday.text,
              birthdyTxtValue_unique_id: res.data.result.business.birthday.unique_id,
              bithGrtngTimeSelt: res.data.result.business.birthday.local_time,
              bithGrtngTime: res.data.result.business.birthday.local_time,
              bithGrtngTimeZoneSelt: res.data.result.business.birthday.offset,
              bithGrtngTimeZone: res.data.result.business.birthday.offset,
              brthdyGrtngDelDisble: false,
            });
          }

          if (res.data.result.business.birthday.status == 'off') {
            $('#bdaygreetings').prop('checked', false);
          }

          var archiveMdStatus = res.data.result.business.archive.text;

          if (archiveMdStatus == 'on') {
            $('#archivemode').prop('checked', true);
            this.setState({ VwArchiewDisbl: false });
          }
          if (archiveMdStatus == 'off') {
            $('#archivemode').prop('checked', false);
            this.setState({ VwArchiewDisbl: true });
          }
          if (res.data.result.business.email_dump?.status == 'on') {
            $('#dailyemaildump').prop('checked', true);
            this.setState({
              dump_emails:
                res.data.result.business.email_dump?.email_address?.length !== 0
                  ? res.data.result.business.email_dump?.email_address
                  : [''],
            });
          } else {
            $('#dailyemaildump').prop('checked', false);
            this.setState({
              dump_emails:
                res.data.result.business.email_dump?.email_address?.length !== 0
                  ? res.data.result.business.email_dump?.email_address
                  : [''],
            });
          }

          var TmIdDtls = res.data.result.business.summary_alert.team_id;
          for (var j in TmIdDtls) {
            $('.smryTmIds' + TmIdDtls[j]).prop('checked', true);
          }
          var TmIdDtls_email = res.data.result.business.integration_email.team_id;
          console.log('email integration', TmIdDtls_email);
          for (var g in TmIdDtls_email) {
            // console.log('email integration', TmIdDtls_email[g]);
            $('.emailteam' + TmIdDtls_email[g]).prop('checked', true);
          }

          var TmIdDtls_chat = res.data.result.business.chat_widget.team_id;
          for (var p in TmIdDtls_chat) {
            $('.chatTmIds_' + TmIdDtls_chat[p]).prop('checked', true);
          }
          var TagDtls_chat = res.data.result.business.chat_widget.tags;
          // this.setState({chat_filtered_tag_list: TagDtls_chat});
          for (var g = 0; g < TagDtls_chat.length; g++) {
            // for (var g in TagDtls_chat) {
            console.log('to be selected inside list', TagDtls_chat[g]);
            $('.chatWidget_tags option').filter(`[value=${TagDtls_chat[g]}]`).attr('selected', 'selected');
          }
          this.setState({
            chat_grtmsg: res.data.result.business.chat_widget.greeting,
            chat_replymsg: res.data.result.business.chat_widget.reply_message,
            chat_newcontactmsg: res.data.result.business.chat_widget.new_contact_message,
            chat_existcontactmsg: res.data.result.business.chat_widget.existing_contact_message,
          });
          var assigned_role_restrict = res?.data?.result?.business?.user_role.find(
            (usr) => usr.user_id === this.state.user_id,
          );
          if (assigned_role_restrict) {
            console.log('assigned_role_restrict found', assigned_role_restrict);
            this.user_roles_info(assigned_role_restrict.role_id);
          } else {
            console.log('assigned_role_restrict not found', assigned_role_restrict);
          }
        }
      });
      const cart_list = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios.get(API_CALL_ENDPOINT + '/booster/cart/list', cart_list).then((res) => {
        console.log('/booster/cart/list', res.data);
        if (res.data.result) {
          let price_quantity_list = [...this.state.price_quantity_list];
          let order_amount = 0;
          let order_doller = 0;
          let exist_cart_id = [];
          for (let i = 0; i < res.data?.result?.length; i++) {
            const item = res.data.result[i];

            let selectedQlist = price_quantity_list.find((x) => x._id === item.master_pack_id);
            if (selectedQlist?.quantity) {
              selectedQlist.quantity = item.pack_quantity;
            }

            var removeIndex = price_quantity_list.map((listitem) => listitem._id).indexOf(item.master_pack_id);
            price_quantity_list.splice(removeIndex, 1);
            price_quantity_list = [...price_quantity_list, selectedQlist];
            // order_amount = order_amount.push("'" + res.data?.result[i]?.order_amount + "'");

            order_amount += res.data?.result[i]?.order_amount;
            order_doller += parseInt(res.data?.result[i]?.order_doller);
            // order_amount = order_amount.join(', ');
            // exist_cart_id = exist_cart_id.push("'" + res.data?.result[i]?._id + "'");
            exist_cart_id = [...exist_cart_id, res.data?.result[i]?._id];
            // exist_cart_id = exist_cart_id.join(', ');
          }
          console.log('price_quantity_list', price_quantity_list);
          this.setState({
            price_quantity_list,
            order_amount,
            exist_cart_id,
            order_doller,
          });
          // for (var i in res.data?.result) {
          //   if (res.data?.result[i]?.pack_type === 'message') {
          //     this.setState({
          //       pack_quantity_message: res.data?.result[i]?.pack_quantity,
          //       order_data_count: res.data?.result[i]?.order_data_count,
          //       order_doller: res.data?.result[i]?.order_doller,
          //       order_amount: res.data?.result[i]?.order_amount,
          //       exist_cart_id: res.data?.result[i]?._id,
          //     });
          //   }
          // }

          this.setState({ packcart_list: res.data.result });
        } else if (res.data.status == 'no_record') {
        }
      });

      const contactslist = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/contacts/list', contactslist)
        .then((res) => {
          if (res.data.status === 'no_record') {
            // document.getElementById('contact_nil').style.display = 'block';
          }
          this.setState({
            contacts: res.data?.result?.contacts,
            contacts_archive: res.data?.result?.contacts,
          });
          // var available_data = this.state.contacts_available_archived
          // for (var i in res.data?.result?.contacts) {
          //   if (res.data?.result?.contacts[i].text_archive !== 'false') {
          //     available_data.push(res.data?.result?.contacts[i]._id)
          //   }
          //   this.setState({contacts_available_archived: available_data})
          //   console.log("this.state.contacts_available_archived",this.state.contacts_available_archived)
          // }
          var conList = [];
          for (var i in res.data?.result?.contacts) {
            if (res.data?.result?.contacts[i].text_archive !== 'false') {
              // console.log(res.data?.result?.contacts[i]._id);
              var name =
                res.data?.result?.contacts[i].first_name == 'Guest'
                  ? '+91 ' +
                  res.data?.result?.contacts[i].phone_number
                    .toString()
                    .substring(1)
                    .replace(/[^\dA-Z]/g, '')
                    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                    .trim()
                  : res.data?.result?.contacts[i].first_name + ' ' + res.data?.result?.contacts[i].last_name;
              conList.push({
                name: name,
                value: res.data?.result?.contacts[i]._id,
                tags: res.data?.result?.contacts[i].tags,
                contact: res.data?.result?.contacts[i],
              });
            }
          }
          this.setState({ dropDownValue: conList });
        })
        .catch((error) => { });
      const companylist = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/company/list', companylist)
        .then((res) => {
          //console.log("Companylist", res.data);
          if (res.data.status === 'success') {
            this.setState({ company_list: res.data.result });
          }
          if (res.data.status === 'no_record') {
            this.setState({ company_list: [] });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'no_record') {
              this.setState({ company_list: [] });
            }
          }
        });
      this.templates_listclick();
    }, 100);
    this.dataLst();
    $('.updcontactsel')
      .change(function () {
        $(this)
          .find('option:selected')
          .each(function () {
            var optionValue = $(this).attr('value');
            if (optionValue) {
              $('.updct')
                .not('.' + optionValue)
                .hide();
              $('.' + optionValue).show();
            } else {
              $('.updct').hide();
            }
          });
      })
      .change();
    // $('.elseif_view_tags').on('click', function () {
    //   var id = $(this).data('id');
    //   var tags = $(this).data('tags');
    //   console.log('id', id);
    //   console.log('tags', tags);
    //   return false;
    //   const tags_contact_count = {
    //     params: {
    //       apikey: API_KEY,
    //       secret: API_SECRET,
    //       user_id: this.state.user_id,
    //       business_id: this.state.business_id,
    //       tag_id: workflow.tags?.toString(),
    //     },
    //   };

    //   axios
    //     .get(API_CALL_ENDPOINT + '/tags/contacts/count', tags_contact_count)
    //     .then((res) => {
    //       if (res.data.status === 'success') {
    //         console.log('this.state.contactscount_tag_elsif', this.state.contactscount_tag_elsif);
    //         console.log('resresres', res?.data?.result?.total_contacts);
    //         this.setState({contactscount_tag_elsif: res?.data?.result?.total_contacts});
    //         $('.wf_tag_view_else_' + workflow._id).hide();
    //         $('.wf_tag_cont_else_' + workflow._id).show();
    //         $('#wf_tag_cont_else_' + workflow._id).text(res?.data?.result?.total_contacts);
    //         console.log('this.state.contactscount_tag_elsif', this.state.contactscount_tag_elsif);
    //       }
    //     })
    //     .catch((error) => {
    //       this.setState({contactscount_tag_elsif: 0});
    //     });
    // });
    $('.planback_clk').click(function () {
      $('.choosepackdtls_div').show();
      $('.creditcarddtls_div').hide();
    });
    $('#stepinbound').on('change', function () {
      if ($(this).val() === 'no_specification') {
        $('#inbvalue').val('');
      }
    });
    $(document).on('click', '.addmore_nft_keys', function () {
      nft_key_count++;
      var content =
        '<div class="w-100 d-flex flex-row flex-wrap pb-4 append_divs keys' +
        nft_key_count +
        '"><div class="col-12 col-sm-12 col-md-6 col-lg-6"><input type="text" class="form-control key_vals" data-id="' +
        nft_key_count +
        '" placeholder="Key" /></div><div class="col-5 col-sm-5 col-md-4 col-lg-4"><div class="icheck-darkgrey d-inline-block pt-1 pt-md-3"><input type="checkbox" id="keyrequired' +
        nft_key_count +
        '"><label for="keyrequired' +
        nft_key_count +
        '">Required</label></div></div><div class="col-7 col-sm-7 col-md-2 col-lg-2 pr-0 pt-1 pt-md-3"><a><i class="fas fa-trash-alt mt-2 mr-3 f_sz16 crsr_pntr fmaroon remove_keys" data-id="' +
        nft_key_count +
        '"></i></a></div></div>';
      $('.nftrequest_div').append(content);
    });
    $(document).on('click', '.remove_keys', function () {
      var $self = $(this);
      var id = $self.data('id');
      $('.keys' + id + '').remove();
    });
    $('.nftrequest_btn').on('click', function () {
      var continue_vals = '1';
      var nft_token_name = $('#nft_token_name').val();
      var nft_token_symbol = $('#nft_token_symbol').val();
      var token_limits = $('#token_limits').val();
      if (nft_token_name.length == 0) {
        toast.dark('Please enter the Token Name.', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      if (nft_token_symbol.length == 0) {
        toast.dark('Please enter the Token Symbol.', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      $('.key_vals')
        .each(function (index) {
          console.log($('#keyrequired' + $(this).data('id') + '').is(':checked'));
          if ($(this).val().length == 0 && $(this).data('id') !== 0) {
            continue_vals = '0';
            $(this).focus();
            toast.dark('Please enter the key value.', {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            return false;
          }
        })
        .promise()
        .done(function () {
          if (continue_vals == '1') {
            $('.nftrequest_btn').hide();
            $('.btn_confirmation').show();
            $('.nftrequest_confirm_btn').show();
          }
        });
    });

    AsyncStorage.getItem('_id').then((_id) => {
      if (_id) {
        this.setState({ _id });
        console.log('ID');
        console.log(_id);
      }
    });

    //NFT
    var that = this;
    $(document).on('click', '.nftavailable_receiptview_clk', function () {
      var $self = $(this);
      var id = $self.data('id');
      var vtype = $self.data('type');
      console.log('ididid', id);
      console.log('typetype', vtype);
      const token_list_params = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: that.state.user_id,
          business_id: that.state.business_id,
          flag: 'single',
          _id: that.state._id,
        },
      };
      // console.log('token_list_params', token_list_params);
      axios
        .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
        .then((res) => {
          if (res.data.status === 'success') {
            console.log('nftres.datasss', res.data.result[0]);
            console.log('nftres.vtype', vtype);
            that.setState({ nft_token: res.data.result[0] });
            $('.nftmintedlist_div').hide();
            if (vtype === 'minted') {
              $('.receiptnft_div').show();
            } else if (vtype === 'sent') {
              $('.sentreceiptnft_div').show();
            } else if (vtype === 'accepted') {
              $('.inprocessreceiptnft_div').show();
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status == 'no_record') {
            }
          }
        });
    });
    $(document).on('keyup', '.minted_nft_search', function () {
      var $self = $(this);
      var type = $self.data('type');
      var searchval = $self.val();
      console.log($self.val());
      console.log(type);
      var nft_type = 'available';
      if (type === 'minted') {
        nft_type = 'available';
      }
      if (type === 'sent') {
        nft_type = 'sent';
      }
      if (type === 'accepted') {
        nft_type = 'accepted';
      }
      that.setState({
        nft_available_cnt: 0,
        nft_sent_cnt: 0,
        nft_accept_cnt: 0,
        nft_available_load_more: true,
        nft_sent_load_more: true,
        nft_accept_load_more: true,
      });
      const token_list_params = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: that.state.user_id,
          business_id: that.state.business_id,
          flag: 'all',
          search_text: searchval,
          tab: nft_type,
        },
      };
      var arraval = [];
      console.log('token_list_params', token_list_params);
      axios
        .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
        .then((res) => {
          if (res.data.status === 'success') {
            for (var i = 0; i < res.data.result.length; i++) {
              if (res.data.result[i].status === type) {
                arraval.push(res.data.result[i]);
              }
            }
            // console.log('nftres.datasss1', res.data.result);
            if (type === 'minted') {
              that.setState({
                nft_minted_tokens_lists: arraval,
              });
              if (arraval.length < 20) {
                that.setState({
                  nft_available_load_more: false,
                });
              }
            } else if (type === 'accepted') {
              that.setState({
                nft_accept_tokens_lists: arraval,
              });
              if (arraval.length < 20) {
                that.setState({
                  nft_accept_load_more: false,
                });
              }
            } else if (type === 'sent') {
              that.setState({
                nft_sent_tokens_lists: arraval,
              });
              if (arraval.length < 20) {
                that.setState({
                  nft_sent_load_more: false,
                });
              }
            }
            that.setState({
              nft_token_file_extension: '',
              table_view: false,
              nft_tokens: res.data.result,
            });
          } else if (res.data.status === 'no_record') {
            if (type === 'minted') {
              that.setState({
                nft_minted_tokens_lists: arraval,
                nft_available_load_more: false,
              });
            } else if (type === 'accepted') {
              that.setState({
                nft_accept_tokens_lists: arraval,
                nft_accept_load_more: false,
              });
            } else if (type === 'sent') {
              that.setState({
                nft_sent_tokens_lists: arraval,
              });
            }
            that.setState({
              nft_token_file_extension: '',
              table_view: false,
              nft_tokens: res.data.result,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status == 'no_record') {
              if (type === 'minted') {
                that.setState({
                  nft_minted_tokens_lists: arraval,
                  nft_available_load_more: false,
                });
              } else if (type === 'accepted') {
                that.setState({
                  nft_accept_tokens_lists: arraval,
                  nft_accept_load_more: false,
                });
              } else if (type === 'sent') {
                that.setState({
                  nft_sent_tokens_lists: arraval,
                  nft_sent_load_more: false,
                });
              }
              that.setState({
                nft_minted_tokens_lists: arraval,
                nft_token_file_extension: '',
                table_view: false,
              });
              $('.receiptnft_div').hide();
              $('.sentreceiptnft_div').hide();
              $('.inprocessreceiptnft_div').hide();
              $('.nftmintedlist_div').show();
              $('.nftcreate_div').hide();
            }
          }
        });
    });
    $(document).on('click', '.nft_minted_li', function () {
      var $self = $(this);
      var type = $self.data('name');
      that.closeReceipt(type);
      $('.minted_nft_search').val('');
    });

    $(document).on('click', '.nftavailable_copy_clk', function () {
      var $self = $(this);
      var id = $self.data('id');
      that.mintingNextStep(2);
      $('#nft_name_minted').val($self.data('nft_name'));
      $('#nft_decription_minted').val($self.data('nft_description'));
      var uptodtype = $self.data('upload_type');
      that.setState({
        nft_file_type: uptodtype,
      });
      //alert($self.data('file_name'));
      $('#nft_file_name_minted').val($self.data('file_name'));
      $('#nft_file_url_minted').val($self.data('file_url'));
      $('#nft_thumb_file_url_minted').val($self.data('thumbnail_file_url'));
      if (uptodtype.length !== 0) {
        if (uptodtype === 'image/gif') {
          $('.chooseupload_nft_minted').val('choosegif');
          $('#uploaded_image_giff_minted').show();
          $('#uploaded_img_src_giff_minted').attr('src', $self.data('file_url'));
        } else {
          $('.chooseupload_nft_minted').val('chooseimage');
          $('#uploaded_image_minted').show();
          $('#uploaded_image_minted_src').attr('src', $self.data('file_url'));
        }
        $('.chooseupload_nft_minted').trigger('change');
      }

      // var nftmint_params = {
      //   apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      //   secret: 'R1eqD2twI3E4',
      //   user_id: that.state.user_id,
      //   business_id: that.state.business_id,
      //   file_url: $self.data('file_url'),
      //   nft_name: $self.data('nft_name'),
      //   nft_description: $self.data('nft_description'),
      //   file_name: $self.data('file_name'),
      //   upload_type: $self.data('upload_type'),
      // };
      // axios
      //   .post(API_CALL_ENDPOINT + '/blockchain/nft/mint', nftmint_params)
      //   .then((res) => {
      //     if (res.data.status === 'success') {
      //       that.closeReceipt();
      //       $('#custom-tabs-nftavailable-tab').trigger('click');
      //       toast.dark(res.data.message, {
      //         position: 'top-right',
      //         transition: Flip,
      //         autoClose: 5000,
      //         hideProgressBar: false,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //         progress: undefined,
      //       });
      //     }

      //     //console.log(res.data.message);
      //   })
      //   .catch((error) => {});
    });
    $(document).on('click', '.revert_nft', function () {
      var $self = $(this);
      var id = $self.data('id');
      var cid = $self.data('cid');
      var type = $self.data('type');
      console.log('ididid', id);
      console.log('typetype', cid);
      var revert_params = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: that.state.user_id,
        business_id: that.state.business_id,
        token_id: id,
        contact_id: cid,
        type: type,
      };
      // console.log('token_list_params', token_list_params);
      axios
        .post(API_CALL_ENDPOINT + '/blockchain/nft/changestatus', revert_params)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            that.closeReceipt();
            toast.dark(res.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          //console.log(res.data.message);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              console.log(error.response.data.error.message);
              that.closeReceipt();
              toast.dark(error.response.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }
        });
    });
    var append = 0;
    $(document).on('click', '.webhook_add', function () {
      append++;
      var classdetails = $('.web_hooks_lists').length;
      that.setState({ webhookdetails_count: classdetails });
      if (classdetails <= 9) {
        var append_content =
          '<div class="form-group row mt-3 mb-4 web_hooks_lists remove_webhook_urls remove_webhook_div_' +
          append +
          '"><div class="col-10 col-sm-10 col-md-10 col-lg-10"><input type="text" class="form-control webhook_urls" placeholder="Enter Webhook URL" /></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 pr-0"><a><i class="fas fa-trash-alt mt-2 mr-3 f_sz16 crsr_pntr fmaroon webhook_trash" data-id="' +
          append +
          '"/></a></div></div>';
        $('.webhooks_append_div').append(append_content);
      } else {
        append--;
      }
    });
    $(document).on('click', '.webhook_trash', function () {
      var $self = $(this);
      $('.remove_webhook_div_' + $self.data('id') + '').remove();
      var classdetails = $('.web_hooks_lists').length;
      that.setState({ webhookdetails_count: classdetails });
    });
    $(document).on('click', '.delete_webook', function () {
      var $self = $(this);
      $('#webhook_id').val($self.data('id'));
    });
    $(document).on('click', '.close_del', function () {
      $('.close').trigger('click');
    });

    $(document).on('click', '.del_webhook', function () {
      var id = $('#webhook_id').val();
      const webhoosdata = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: that.state.user_id,
        business_id: that.state.business_id,
        webhook_id: id,
      };

      axios
        .post(API_CALL_ENDPOINT + '/business/webhook/delete', webhoosdata)
        .then((res) => {
          if (res.data.status === 'success') {
            $('.close').trigger('click');
            that.loadWebhooks();
            toast.dark(res.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error.reason === 'Invalid Id') {
            }
          }
        });
    });
    $(document).on('click', '.webhook_save', function () {
      var numItems = $('.webhook_urls').length;
      var arr = [];
      var successmessage = 'Your webhook url has been created successfully.';
      $.each($('.webhook_urls'), function () {
        var $self = $(this);
        if ($self.val().length == 0) {
          toast.dark('Please enter the webhook url', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          $self.focus();
          return false;
        } else if (that.isValidURL($self.val()) === false) {
          toast.dark('Please enter a valid webhook url', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          $self.focus();
          return false;
        } else {
          arr.push($self.val());
        }
      })
        .promise()
        .done(function () {
          if (numItems == arr.length) {
            $('.webhook_save').addClass('isdisabled');
            $('.webhook_save').text('Processing...');
            $('.webhook_save').addClass('webhook_saving');
            $('.webhook_saving').removeClass('webhook_save');
            $.each($('.webhook_urls'), function () {
              var $self = $(this);
              const webhoosdata = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: that.state.user_id,
                business_id: that.state.business_id,
                setup: 'webhook',
                webhook_url: $self.val(),
              };

              axios
                .post(API_CALL_ENDPOINT + '/business/profile/settings', webhoosdata)
                .then((res) => {
                  if (res.data.status === 'success') {
                    successmessage = res.data.message;
                    $('.webhook_saving').addClass('webhook_save');
                    $('.webhook_save').removeClass('webhook_saving');
                    $('.webhook_save').text('Save');
                    $('.webhook_save').removeClass('isdisabled');
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error.reason === 'Invalid Id') {
                    }
                  }
                });
              console.log(webhoosdata);
            })
              .promise()
              .done(function () {
                setTimeout(() => {
                  that.loadWebhooks();
                  that.addwebhook_close();
                  toast.dark(successmessage, {
                    position: 'top-right',
                    transition: Flip,
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }, 2500);
              });
          }
        });
    });
    $(document).on('click', '.picknumber_clk', function () {
      $('.picknewnumber_div').show();
    });
    $(document).on('click', '.picknewnumber_close', function () {
      $('.picknewnumber_div').hide();
    });
    $(document).on('click', '.edit_webhook', function () {
      var $self = $(this);
      $('.edit_webhooks_div').show();
      $('.webhooklist_div').hide();
      $('#webhooks_updated_url').val($self.data('url'));
      $('#webhook_id').val($self.data('id'));
      console.log("$self.data('url')", $self.data('url'));
      console.log("$self.data('id')", $self.data('id'));
    });
    $(document).on('click', '.webhook_update', function () {
      var $self = $(this);
      var id = $('#webhook_id').val();
      var url = $('#webhooks_updated_url').val();
      if (url.length == 0) {
        toast.dark('Please enter the webhook url', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        $self.focus();
        return false;
      } else if (that.isValidURL(url) === false) {
        toast.dark('Please enter a valid webhook url', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        $self.focus();
        return false;
      } else {
        $('.webhook_update').addClass('webhook_saving');
        $('.webhook_update').addClass('isdisabled');
        $('.webhook_saving').removeClass('webhook_update');
        $('.webhook_save').text('Processing..');

        const webhoosdata = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: that.state.user_id,
          business_id: that.state.business_id,
          webhook_id: id,
          webhook_url: url,
        };

        axios
          .post(API_CALL_ENDPOINT + '/business/webhook/update', webhoosdata)
          .then((res) => {
            if (res.data.status === 'success') {
              $('.webhook_saving').addClass('webhook_update');
              $('.webhook_update').removeClass('webhook_saving');
              $('.webhook_update').text('Update');
              $('.webhook_update').removeClass('isdisabled');
              that.loadWebhooks();
              that.addwebhook_close();
              toast.dark(res.data.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error.reason === 'Invalid Id') {
              }
            }
          });
      }

      console.log('id', id);
      console.log('url', url);
    });
    $(document).on('click', '.addwebhook_clk', function () {
      $('.webhookadd_div').hide();
      $('.webhooklist_div').hide();
      $('.addwebhook_div').show();
    });
    $('.chooseupload').on('change', function () {
      var choosenval = $(this).val();
      if (choosenval === 'chooseimage') {
        $('.chooseimage').show();
        $('.choosegif').hide();
        $('.chooseaudio').hide();
      } else if (choosenval === 'chooseaudio') {
        $('.chooseaudio').show();
        $('.choosegif').hide();
        $('.chooseimage').hide();
      } else if (choosenval === 'choosegif') {
        $('.choosegif').show();
        $('.chooseimage').hide();
        $('.chooseaudio').hide();
      } else {
        $('.choosegif').hide();
        $('.chooseimage').hide();
        $('.chooseaudio').hide();
      }
    });

    $('.chooseupload_nft_minted').on('change', function () {
      var choosenval = $(this).val();
      if (choosenval === 'chooseimage') {
        $('.chooseimage').show();
        $('.choosegif').hide();
        $('.chooseaudio').hide();
      } else if (choosenval === 'chooseaudio') {
        $('.chooseaudio').show();
        $('.choosegif').hide();
        $('.chooseimage').hide();
      } else if (choosenval === 'choosegif') {
        $('.choosegif').show();
        $('.chooseimage').hide();
        $('.chooseaudio').hide();
      } else {
        $('.choosegif').hide();
        $('.chooseimage').hide();
        $('.chooseaudio').hide();
      }
    });

    $('.audio_select').change(function () {
      if ($(this).is(':checked')) {
        var selected = $(this).val();
        if (selected == 1) {
          $('#nftvoicemsg1').show();
          $('#nftvoicemsg2').hide();
        } else if (selected == 2) {
          $('#nftvoicemsg1').hide();
          $('#nftvoicemsg2').show();
        }
      }
    });

    // $('.audio_select').on('click', function () {
    //   var selectedVal = '';
    //   var selected = $(".audio_select input[type='radio']:checked");
    //   console.log("selectedselected",selected);
    //   if (selected == 1) {
    //     $('#nftvoicemsg1').show();
    //     $('#nftvoicemsg2').hide();
    //   } else if (selected == 2) {
    //     $('#nftvoicemsg1').hide();
    //     $('#nftvoicemsg2').show();
    //   }
    // });

    /****Business Id */
    $(document).on('click', '#custom-tabs-workspace_id-tab', function () {
      if (!that.state?.business_info_array?.busines_evaluation_details) {
        if (that.state.business_info_array?.business?.user_id !== that.state.user_id) {
          $('.business_evaluation_popup_assigned').click();
        } else {
          $('.business_evaluation_popup').click();
        }
        return false;
      } else if (that.state?.business_info_array?.busines_evaluation_details?.otp_status == 'not_verified') {
        if (that.state.business_info_array?.business?.user_id !== that.state.user_id) {
          $('.business_evaluation_popup_assigned').click();
        } else {
          $('.business_evaluation_popup').click();
        }

        return false;
      } else if (
        that.state?.business_info_array?.busines_evaluation_details?.status == 'not_verified' ||
        that.state?.business_info_array?.busines_evaluation_details?.status == 'rejected'
      ) {
        if (that.state.business_info_array?.business?.user_id !== that.state.user_id) {
          $('.business_evaluation_popup_assigned').click();
        } else {
          $('.business_evaluation_popup').click();
        }

        return false;
      } else if (that.state?.business_info_array?.busines_evaluation_details?.status == 'pending') {
        if (that.state.business_info_array?.business?.user_id !== that.state.user_id) {
          $('.business_evaluation_popup_assigned').click();
        } else {
          toast.dark(
            'Thank you for your patience, please note that your workspace is under verification. We will get back to you upon verification via email.',
            {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
        }

        return false;
      }
    });
    /*************Workflow****************/
    $(document).on('click', '.workflowcreate_clk', function () {
      if (!that.state?.business_info_array?.busines_evaluation_details) {
        $('.business_evaluation_popup').trigger('click');
        return false;
      } else if (that.state?.business_info_array?.busines_evaluation_details?.otp_status == 'not_verified') {
        $('.business_evaluation_popup').trigger('click');
        return false;
      } else if (
        that.state?.business_info_array?.busines_evaluation_details?.status == 'not_verified' ||
        that.state?.business_info_array?.busines_evaluation_details?.status == 'rejected'
      ) {
        $('.business_evaluation_popup').trigger('click');
        return false;
      } else if (that.state?.business_info_array?.busines_evaluation_details?.status == 'pending') {
        toast.dark(
          'Thank you for your patience, please note that your workspace is under verification. We will get back to you upon verification via email.',
          {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        return false;
      } else {
        $('.workflowcreate_div').hide();
        $('.addworkflow_div').show();
        $('.addentrypoints_div').hide();
        $('.workflowlist_div').hide();
      }

      // $('.addworkflow_div').hide();
    });

    // $('.startautomate_clk').on('click', function () {

    //   // $('.addworkflow_div').hide();

    // });

    $('.addentrypt_clk').on('click', function () {
      $('.workflowcreate_div').hide();
      $('.addworkflow_div').hide();
      $('.addentrypoints_div').hide();
      $('.workflowlist_div').show();
      // $('.addworkflow_div').hide();
    });
    $('.wfentrypt_contactstgl').click(function () {
      $('.wfentrypt_contactstgl_div').slideToggle('slow');
      // Alternative animation for example
      // slideToggle("fast");
    });

    $('.viewarchive_tgl').click(function () {
      $('.viewarchive_tgldiv').slideToggle();
      //$(".archivemessages_tgldiv").hide();
    });

    $('.viewarchivesearch_tgl').click(function () {
      $('.viewarchivesearch_tgldiv').slideToggle();
      //$(".archivemessages_tgldiv").hide();
    });
    $('#default_dateval').on('click', function () {
      $('.dashchartfiltercalendardrpdwn_pos').toggle();
    });
    $('.dailyemaildumphistory_tgl').click(function () {
      $('.dailyemaildumphistory_tgldiv').slideToggle();
      //$(".archivemessages_tgldiv").hide();
    });
    today = new Date();
    end_date = today.getMonth() + 1 + '-' + today.getDate() + '-' + today.getFullYear();
    var start = new Date('1/1/' + new Date().getFullYear());
    start_date = start.getMonth() + 1 + '-' + start.getDate() + '-' + start.getFullYear();
    var default_dateval = moment(start).format('MMM DD, yyyy') + ' - ' + moment(today).format('MMM DD, yyyy');
    $('#default_dateval').val(default_dateval);
    this.setState({
      start: moment(start).format('MMM DD, yyyy'),
      end: moment(today).format('MMM DD, yyyy'),
    });
  }

  paymentChecking = (checkout_id) => {
    const numberlist = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        checkout_id: checkout_id
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/payment/checkout/status', numberlist)
      .then((res) => {
        toast.dark('Your payment was processed successfully. The additional message pack has been added to your workspace.', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => {
          $('.processing_div').hide();
          $('.wrapper').show();
          this.props.history.push('/dashboard');
        }, 3000);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            toast.dark(error.response.data.error.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          if (error.response.data.status === 'conflict') {
            toast.dark(error.response.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        }
      });
  };
  numberpaymentChecking = (purchase_id) => {
    const numberlist = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        purchase_id: purchase_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/number/payment/status', numberlist)
      .then((res) => {
        if (res.data.result.status == 'paid') {
          // toast.dark(
          //   'Your payment was processed successfully. The additional message pack has been added to your workspace.',
          //   {
          //     position: 'top-right',
          //     transition: Flip,
          //     autoClose: 5000,
          //     hideProgressBar: true,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //   },
          // );
          setTimeout(() => {
            var plivo_numbers = '';

            if (this.state.test_mode === 'on') {
              toast.dark('This might take few minutes, please hold-on.', {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });

              const businessupdate = {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                phone_number: plivo_numbers,
                setup: 'phone',
              };
              axios
                .post(API_CALL_ENDPOINT + '/business/profile/update', businessupdate)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status === 'success') {
                    this.setState({ isLoading: false });
                    toast.dark(res.data.message, {
                      position: 'top-right',
                      transition: Flip,
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    setTimeout(() => {
                      $('.processing_div').hide();
                      $('.wrapper').show();
                      window.location.href = '/profile_settings';
                    }, 2000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              AsyncStorage.getItem('plivo_number').then((plivo_number) => {
                if (plivo_number) {
                  console.log('plivo_numberss', plivo_number);
                  console.log(purchase_id);
                  const plivo_numbers_changes = {
                    apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                    secret: 'R1eqD2twI3E4',
                    user_id: this.state.user_id,
                    business_id: this.state.business_id,
                    phone_number: plivo_number,
                    purchase_id: purchase_id,
                  };
                  axios
                    .post(API_CALL_ENDPOINT + '/plivo/number/change', plivo_numbers_changes)
                    .then((res) => {
                      console.log(res.data);
                      if (res.data.status === 'success') {
                        this.setState({ isLoading: false });
                        toast.dark(res.data.message, {
                          position: 'top-right',
                          transition: Flip,
                          autoClose: 5000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                        setTimeout(() => {
                          $('.processing_div').hide();
                          $('.wrapper').show();
                          window.location.href = '/profile_settings';
                        }, 2000);
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              });
            }
          }, 3000);
        }
        if (res.data.result.status != 'paid') {
          setTimeout(() => {
            this.numberpaymentChecking(purchase_id);
          }, 3000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            toast.dark(error.response.data.error.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          if (error.response.data.status === 'conflict') {
            toast.dark(error.response.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        }
      });
  }

  isValidURL(string) {
    var res = string.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    );
    return res !== null;
  }

  num_validate(plivo_number) {
    // we are going to store errors for all fields
    // in a signle array
    const errors = [];
    if (plivo_number.length === 0) {
      toast.dark('Please select a number to proceed.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      this.setState({ isLoading: false });
      return false;
    } else {
      return true;
    }
  }

  prefixsearch() {
    const numberlist = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        country: 'US',
        start: '0',
        limit: '7',
        pattern: this.state.prefix,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
      .then((res) => {
        console.log(res.data.result.phone_numbers);
        this.setState({ plivolist: res.data.result.phone_numbers });
        console.log(this.state.plivolist);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            toast.dark(error.response.data.error.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          if (error.response.data.status === 'conflict') {
            toast.dark(error.response.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        }
      });
  }

  onChangeregion(e) {
    // const values = [...e.target.selectedOptions].map((opt) => opt.value);
    this.setState({ region: e.target.value });
    setTimeout(() => {
      this.regionsearch();
    }, 500);
  }
  regionsearch() {
    var vals = this.state.region.split(',');
    const numberlist = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        country: vals[1],
        start: '0',
        limit: '7',
        region: vals[0],
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
      .then((res) => {
        // console.log(res.data.result.phone_numbers);
        this.setState({ rplivolist: res.data.result?.phone_numbers });
        // console.log(this.state.rplivolist.length);
        if (this.state.rplivolist.length === 0) {
          const errors = [];
          errors.push("This region doesn't have any phone numbers, please try by choosing the area code");
          this.setState({ errors });
          console.log(this.state.errors);
          setTimeout(() => {
            this.setState({ errors: [] });
            // this.props.history.push('/')
            // document.getElementById('error').style.display='none'
          }, 3000);
        }
        console.log(this.state.rplivolist);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            toast.dark(error.response.data.error.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          if (error.response.data.status === 'conflict') {
            toast.dark(error.response.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        }
      });
  }
  areacode() {
    document.getElementById('regionsearch').style.display = 'none';
    document.getElementById('plivoregionnumbers').style.display = 'none';
    document.getElementById('numbersearch').style.display = 'block';
    document.getElementById('plivonumbers').style.display = 'block';
  }
  onsubmit() {
    this.setState({ isLoading: true });
    console.log('splivonumber', this.state.plivonumber);
    AsyncStorage.setItem('plivo_number', this.state.plivonumber);
    const { plivonumber } = this.state;
    var validate = this.num_validate(plivonumber);

    if (validate) {
      toast.dark('This might take few minutes, please hold-on.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      const numberbuy = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        // phone_number: plivonumber,
        // type: 'change',
      };
      console.log(numberbuy);
      axios
        .post(API_CALL_ENDPOINT + '/number/payment/create', numberbuy)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            AsyncStorage.setItem('purchase_id', res.data.result.purchase_id);
            const check_out_session = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                purchase_id: res.data.result.purchase_id,
              },
            };

            axios
              .get(API_CALL_ENDPOINT + '/number/checkout/session', check_out_session)
              .then((res) => {
                if (res.data) {
                  if (res.data.status === 'success') {
                    this.setState({ isLoading: false });
                    toast.dark(res.data.message, {
                      position: 'top-right',
                      transition: Flip,
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    setTimeout(() => {
                      window.location.href = res.data.result.url;
                    }, 300);
                  }
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.status === 'no_record') {
                    this.setState({ admin_attach_list_cmb: [] });
                  }
                }
              });
          }
        })
        .catch((error) => {
          console.log('error.response', error.response);
          if (error.response) {
            toast.dark(error.response.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            this.numberpaymentChecking(error.response.data.result?.details?._id);
            this.setState({ isLoading: false });
          }
        });
    }
  }

  locationsearch() {
    document.getElementById('numbersearch').style.display = 'none';
    document.getElementById('plivonumbers').style.display = 'none';
    document.getElementById('regionsearch').style.display = 'block';
    document.getElementById('plivoregionnumbers').style.display = 'block';
  }
  regloadmore() {
    this.setState({ limit: this.state.limit + 5 });
    var vals = this.state.region.split(',');
    setTimeout(() => {
      if (vals[0] !== '') {
        const numberlist = {
          params: {
            apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
            secret: 'R1eqD2twI3E4',
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            country: vals[1],
            start: '0',
            limit: this.state.limit,
            region: vals[0],
          },
        };
        axios
          .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
          .then((res) => {
            console.log(res.data.result.phone_numbers);
            this.setState({ rplivolist: res.data.result.phone_numbers });
            console.log(this.state.rplivolist);
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                toast.dark(error.response.data.error.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
              if (error.response.data.status === 'conflict') {
                toast.dark(error.response.data.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            }
          });
      } else {
        const numberlist = {
          params: {
            apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
            secret: 'R1eqD2twI3E4',
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            country: 'US',
            start: '0',
            limit: this.state.limit,
            // pattern:'61534',
          },
        };
        axios
          .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
          .then((res) => {
            // console.log(res.data.result.phone_numbers);
            this.setState({ rplivolist: res.data.result?.phone_numbers });
            // console.log(this.state.rplivolist);
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                toast.dark(error.response.data.error.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
              if (error.response.data.status === 'conflict') {
                toast.dark(error.response.data.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            }
          });
      }
    }, 1000);
  }

  redirectToPage = (value) => {
    this.props.history.push(value);
  };

  loadmore = () => {
    this.setState({ limit: this.state.limit + 5 });
    setTimeout(() => {
      if (this.state.prefix) {
        const numberlist = {
          params: {
            apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
            secret: 'R1eqD2twI3E4',
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            country: 'US',
            start: '0',
            limit: this.state.limit,
            pattern: this.state.prefix,
          },
        };
        axios
          .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
          .then((res) => {
            console.log(res.data.result.phone_numbers);
            this.setState({ plivolist: res.data.result.phone_numbers });
            console.log(this.state.plivolist);
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                toast.dark(error.response.data.error.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
              if (error.response.data.status === 'conflict') {
                toast.dark(error.response.data.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            }
          });
      } else {
        const numberlist = {
          params: {
            apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
            secret: 'R1eqD2twI3E4',
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            country: 'US',
            start: '0',
            limit: this.state.limit,
            // pattern:'61534',
          },
        };
        axios
          .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
          .then((res) => {
            console.log(res.data.result.phone_numbers);
            this.setState({ plivolist: res.data.result.phone_numbers });
            console.log(this.state.plivolist);
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                toast.dark(error.response.data.error.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
              if (error.response.data.status === 'conflict') {
                toast.dark(error.response.data.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            }
          });
      }
    }, 1000);
  };

  loadWebhooks = () => {
    const webhooksdetails = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/webhook/list', webhooksdetails)
      .then((res) => {
        console.log('Business profile Details', res.data);
        if (res.data.status === 'success') {
          $('.edit_webhooks_div').hide();
          $('.webhook_urls').val('');
          //   this.setState({business_List: res.data.result})
          console.log(res.data.result);
          this.setState({
            webhookdetails: res.data.result,
            webhookdetails_count: res.data.result.length,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log('error.response', error.response.data.status);
          if (error.response.data.status === 'no_record') {
            //alert("yes")
            this.setState({
              webhookdetails: [],
              webhookdetails_count: 0,
            });
          }
        }
      });
  };

  editwebhooks = (id, url) => {
    console.log('id', id);
    console.log('url', url);
    var $self = $(this);
    $('.edit_webhooks_div').show();
    $('.webhooklist_div').hide();
    $('#webhooks_updated_url').val(url);
    $('#webhook_id').val(id);
  };

  deletewebhooks = (id, url) => {
    console.log('id', id);
    console.log('url', url);
    $('#webhook_id').val(id);
  };

  businessprofiledetails() {
    const businessprofiledetails = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/profile/details', businessprofiledetails)
      .then((res) => {
        console.log('Business profile Details', res.data);
        if (res.data.status === 'success') {
          //   this.setState({business_List: res.data.result})
          this.setState({
            businessprofiledetails: res.data.result,
            businessprofileplandetails: res.data?.result?.plan,
            attachmentlimit_count: 10,
            // res.data?.result?.plan?.plan_name === 'Trial'
            //   ? 5
            //   : res.data?.result?.plan?.plan_name === 'Basic'
            //     ? 5
            //     : res.data?.result?.plan?.plan_name === 'Pro'
            //       ? 8
            //       : res.data?.result?.plan?.plan_name === 'Premium' || res.data?.result?.flag === 'custom'
            //         ? 10
            //         : 0,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  onchangebusiness_info_name(e) {
    this.setState({
      business_info_name: e.target.value,
      chars_left_profilename: this.state.max_chars_profilename - e.target.value.length,
      business_info_name_blur: true,
    });
  }
  onchangebusiness_info_details(e) {
    this.setState({
      business_info_details: e.target.value,
      chars_left_description: this.state.max_chars_description - e.target.value.length,
      business_info_details_blur: true,
    });
  }
  start_fn = () => {
    //Initialize Select2 Elements
    $('.select2').select2();
    $('.js-select2').select2({
      placeholder: 'Pick states',
      theme: 'bootstrap4',
    });
    //Initialize Select2 Elements
    $('.select2bs4').select2({
      theme: 'bootstrap4',
    });
  };

  dataLst = () => {
    $('#webhookshistory_tbl1').DataTable({
      paging: true,
      lengthChange: false,
      ordering: false,
      searching: false,
    });

    $('#webhookshistory_tbl2').DataTable({
      paging: true,
      lengthChange: false,
      ordering: false,
      searching: false,
    });

    $('#apikey_tbl').DataTable({
      paging: true,
      lengthChange: false,
      ordering: false,
      searching: false,
      //"responsive": true,
    });

    $('#qrcodehistory_tbl1').DataTable({
      paging: true,
      lengthChange: false,
      ordering: false,
      searching: false,
    });

    $('#qrcodehistory_tbl2').DataTable({
      paging: true,
      lengthChange: false,
      ordering: false,
      searching: false,
    });

    $('#intphrases_tbl').DataTable({
      paging: true,
      lengthChange: false,
      ordering: false,
      searching: false,
      //"responsive": true,
    });
  };

  archivehistory_tgl = () => {
    $('.archivehistory_tgldiv').slideToggle();
    $('.archivemessages_tgldiv').hide();
  };

  summaryalert_tgl = () => {
    if ($('#summaryalert').is(':checked')) {
      $('.summaryalert_tgldiv').show();

      const smryalrt_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        summary: 'on',
        setup: 'summary',
        receive_alert: this.state.TmRcvdalrt,
      };

      console.log(smryalrt_Details);
      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', smryalrt_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          // window.location.reload(true);
        }
      });
    } else {
      $('.summaryalert_tgldiv').hide();

      const smryalrt_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        summary: 'off',
        setup: 'summary',
        receive_alert: this.state.TmRcvdalrt,
      };

      console.log(smryalrt_Details);
      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', smryalrt_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          // window.location.reload(true);
        }
      });
    }
  };

  autotxtrespnse_tgl = () => {
    if ($('#autotextresponse').is(':checked')) {
      $('.autotxtrespnse_tgldiv').show();
    } else {
      $('.autotxtrespnse_tgldiv').hide();
      const autotextresponse_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        auto_text: 'off',
        setup: 'auto_text',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', autotextresponse_details).then((res) => {
        if (res.data.status == 'success') {
          console.log(res);
          // console.log(res.data.message);
          // window.location.reload(true);
        }
      });
    }
  };
  autotextresponsemedia_tgl = () => {
    if ($('#autotextresponsemedia').is(':checked')) {
      $('.autotxtrespnsemedia_tgldiv').show();
    } else {
      $('.autotxtrespnsemedia_tgldiv').hide();
      const autotextresponsemedia_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        auto_text_unsupport_message: 'off',
        setup: 'auto_text_unsupport',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', autotextresponsemedia_details).then((res) => {
        if (res.data.status == 'success') {
          console.log(res);
          // console.log(res.data.message);
          // window.location.reload(true);
        }
      });
    }
  };
  autotextresponsemedia_del = () => {
    const autotextresponsemedia_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      auto_text_unsupport_message: 'off',
      setup: 'auto_text_unsupport',
    };

    axios.post(API_CALL_ENDPOINT + '/business/profile/settings', autotextresponsemedia_details).then((res) => {
      if (res.data.status == 'success') {
        this.setState({ atcharryDet_cmb: [] });
        // if (this.state.atcharryDet_cmb.length == 0) {
        $('.attchLstShow_cmb').hide();
        // }
        console.log(res);
        $('.autotxtrespnsemedia_tgldiv').hide();
        $('#autotextresponsemedia').prop('checked', false);
        this.setState({
          unsupportedtext: '',
          unsupportedtext_unique_id: '',
        });
        // console.log(res.data.message);
        // window.location.reload(true);
      }
    });
  };
  onChangeautotxtunsup = (e) => {
    this.setState({ unsupportedtext: e.target.value });
  };
  autotextresponsemedia_save = () => {
    if (this.state.unsupportedtext == '') {
      this.setState(() => ({
        AtoTxtMsg: 'R-Bot response message cannot be blank.',
        AtoTxtClsNm: 'alert alert-danger',
      }));
      setTimeout(() => {
        this.setState(() => ({
          AtoTxtMsg: '',
          AtoTxtClsNm: '',
        }));
      }, 5000);
    }
    // else if(ValidNum){
    else if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
      toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      const autotextresponsemedia_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        auto_text_unsupport_message: 'on',
        text_response: this.state.unsupportedtext,
        unique_id: this.state.atcharryDet_cmb.length != 0 ? Rnunique_id_cmb : '',
        setup: 'auto_text_unsupport',
      };

      axios
        .post(API_CALL_ENDPOINT + '/business/profile/settings', autotextresponsemedia_details)
        .then((res) => {
          if (res.data.status == 'success') {
            this.setState(() => ({
              unsupportedtext_unique_id: Rnunique_id_cmb,
              AtoTxtMsg: res.data.message,
              AtoTxtClsNm: 'alert alert-success',
            }));

            const AutotxtRes_details = {
              params: {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            console.log(AutotxtRes_details);
            axios.get(API_CALL_ENDPOINT + '/business/autotext/list', AutotxtRes_details).then((res) => {
              console.log(res.data);
              if (res.data.result) {
                this.setState({ AutoTxtArea: res.data.result });
              }
            });

            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              AtoTxtMsg: res.data.error.message,
              AtoTxtClsNm: 'alert alert-danger',
            }));
            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                AtoTxtMsg: error.response.data.error.message,
                AtoTxtClsNm: 'alert alert-danger',
              }));
              setTimeout(() => {
                this.setState(() => ({
                  AtoTxtMsg: '',
                  AtoTxtClsNm: '',
                }));
              }, 5000);
            }
          }
        });
    }
  };
  voicemsg_tgl = () => {
    if ($('#voicemsg').is(':checked')) {
      $('.voicemsg_tgldiv').show();
    } else {
      $('.voicemsg_tgldiv').hide();
      const voicemsg_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        voice_greetings_status: 'off',
        setup: 'voice_greetings',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', voicemsg_details).then((res) => {
        if (res.data.status == 'success') {
          console.log(res);
          // console.log(res.data.message);
          // window.location.reload(true);
        }
      });
    }
  };

  voice_message = (event) => {
    var test = event.target.value;

    $('div.voicedesc').hide();
    $('#voicemsg' + test).show();
  };

  autovoiceresponse_tgl = () => {
    if ($('#autovoiceresponse').is(':checked')) {
      $('.autovoiceresponse_tgldiv').show();
    } else {
      $('.autovoiceresponse_tgldiv').hide();
      const autovoiceresponse_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        auto_voice: 'off',
        setup: 'auto_voice',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', autovoiceresponse_details).then((res) => {
        if (res.data.status == 'success') {
          console.log(res);
          // console.log(res.data.message);
          // window.location.reload(true);
        }
      });
    }
  };

  autovoiceresp = (event) => {
    var test = event.target.value;

    $('div.autovoicedesc').hide();
    $('#autovoicemsg' + test).show();
  };

  bdaygreetings_tgl = () => {
    if ($('#bdaygreetings').is(':checked')) {
      $('.bdaygreetings_tgldiv').show();
    } else {
      $('.bdaygreetings_tgldiv').hide();
      const bdaygreetings_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        birthday_status: 'off',
        setup: 'birthday',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', bdaygreetings_details).then((res) => {
        if (res.data.status == 'success') {
          console.log(res);
          // console.log(res.data.message);
          // window.location.reload(true);
        }
      });
    }
  };

  profemailaddr_edit = () => {
    $('.profemailaddr_dsplydiv').hide();
    $('.profemailaddr_upddiv').show();
  };

  webhookshistory_tgl1 = () => {
    $('.webhookshistory_tgldiv1').slideToggle();
  };

  webhooksdelete = (id) => {
    alert(id);
  };

  webhookshistory_tgl2 = () => {
    $('.webhookshistory_tgldiv2').slideToggle();
  };

  addwebhook_clk = () => {
    $('.webhookadd_div').hide();
    $('.webhooklist_div').hide();
    $('.addwebhook_div').show();
    $('.edit_webhooks_div').hide();
  };

  addwebhook_close = () => {
    $('.webhooklist_div').show();
    $('.addwebhook_div').hide();
    $('.edit_webhooks_div').hide();
    $('.remove_webhook_urls').remove();
    $('.webhook_urls').val('');
    var classdetails = $('.web_hooks_lists').length;
    this.setState({ webhookdetails_count: classdetails });
  };

  apicreate_clk = () => {
    $('.apicreate_div').hide();
    $('.apilist_div').show();
  };

  tagcreate_clk = () => {
    $('#tagFrm').html('Add Tag');
    $('.tagcreate_div').hide();
    $('.addtag_div').show();
    $('.taglist_div').hide();
  };

  addinttag_close = () => {
    $('.taglist_div').show();
    $('.addtag_div').hide();

    this.setState(() => ({
      EditTagName: '',
      EditTagId: '',
    }));
  };

  psphrase_addtagname = () => {
    $('.psphrase_entertagname_drpdwn_div').hide();
    $('.psphrase_entertagname_txtbx_div').show();
  };

  psphrase_closeaddtagname = () => {
    $('.psphrase_entertagname_txtbx_div').hide();
    $('.psphrase_entertagname_drpdwn_div').show();
  };

  qrcodecreate_clk = () => {
    this.setState(() => ({
      QRGrtMsg: '',
      QRGrtcls: '',
      qr_title: '',
      qr_description: '',
      qr_message: '',
      qr_filtered_tag_list: [],
      qr_filtered_tag_list_up: [],
      qr_newtag: '',
      qr_addtag_save: false,
      atcharryDet_cmb: [],
      message_edit: false,
      qr_code_image_edit: '',
      qr_code_id_edit: '',
    }));
    Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
    $('.qr_codedisplay').hide();
    $('.generate_qr_btn').show();
    $('.attchLstShow_cmb').hide();
    $('.qrcodecreate_div').hide();
    $('.addqrcode_div').show();
    $('.qrcodelist_div').hide();
  };

  addqrcode_close = () => {
    this.setState(() => ({
      QRGrtMsg: '',
      QRGrtcls: '',
      qr_title: '',
      qr_description: '',
      qr_message: '',
      qr_filtered_tag_list: [],
      qr_filtered_tag_list_up: [],
      qr_newtag: '',
      qr_addtag_save: false,
      atcharryDet_cmb: [],
      message_edit: false,
      qr_code_image_edit: '',
      qr_code_id_edit: '',
    }));
    if (this.state.qr_code_list.length >= 1) {
      $('.qrcodelist_div').show();
      $('.addqrcode_div').hide();
    } else {
      $('.qrcodecreate_div').show();
      $('.addqrcode_div').hide();
      $('.qrcodelist_div').hide();
    }
  };

  qrcodehistory_tgl1 = (qrcode_det) => {
    const qr_history_details = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        qr_code: qrcode_det.qr_code,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/text/qrcode/logs', qr_history_details)
      .then((res) => {
        if (res.data) {
          console.log('info', res.data);
          this.setState({ qr_code_history: res.data.result });
        }
        if (res.data.error) {
        }
      })
      .catch((error) => {
        // console.log(error)
      });
    $('#qr_his_' + qrcode_det._id).slideToggle();
  };

  qrcodehistory_tgl2 = () => {
    $('.qrcodehistory_tgldiv2').slideToggle();
  };

  phrasecreate_clk = () => {
    $('.phrasecreate_div').hide();
    $('.addphrase_div').show();
    $('.phraselist_div').hide();
  };

  addintphrase_close = () => {
    $('.phraselist_div').show();
    $('.addphrase_div').hide();
  };

  psqrcode_addtagname = () => {
    $('.psqrcode_entertagname_drpdwn_div').hide();
    $('.psqrcode_entertagname_txtbx_div').show();
    this.setState({ qr_addtag_save: true });
  };

  psqrcode_closeaddtagname = () => {
    $('.psqrcode_entertagname_txtbx_div').hide();
    $('.psqrcode_entertagname_drpdwn_div').show();
    this.setState({ qr_addtag_save: false });
  };

  gmailconnect_clk = () => {
    $('.gmail_notconnected_div').hide();
    $('.gmail_connected_div').show();
  };

  qrcodesendmsgattach_clk = () => {
    $('.qrcodesendmsg_attachmentdiv').show();
  };

  ft_table_data = () => {
    this.setState({ ft_load_more: true });
    const archive_history = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        limit: '10',
        start: this.state.ft_load_more_start,
      },
    };
    if (this.state.ft_load_more_start === '0') {
      $('#ftsent_tbl tbody').html('');
    }

    axios.get(API_CALL_ENDPOINT + '/blockchain/fungibletoken/transactions', archive_history).then((res) => {
      console.log(res.data);
      var ftarray = [];
      var incval = 0;
      if (res.data.status == 'success') {
        if (res.data.result.length < 10) {
          this.setState({ ft_load_more_button: false });
        }

        $.each(res.data.result, function (index, values) {
          // var newdata = {
          //   id: values._id,
          //   Receiver: values?.contacts[0]?.first_name + ' ' + values?.contacts[0]?.last_name,
          //   Sent: values?.created_date,
          //   Accepted: values?.accepted_date,
          //   'No of Tokens': values?.amount,
          // };ftsent_tbl
          // ftarray.push(newdata);
          if (values.status === 'completed') {
            var data =
              '<tr><td>' +
              values?.contacts[0]?.first_name +
              ' ' +
              values?.contacts[0]?.last_name +
              '</td><td>' +
              moment(values?.sent_date).format('MM/DD/YYYY') +
              '</td><td>' +
              moment(values?.accepted_date).format('MM/DD/YYYY') +
              '</td><td><span className="fgreen4 font-weight-bold">' +
              values?.amount +
              '</span></td></tr>';
          } else {
            var data =
              '<tr><td>' +
              values?.contacts[0]?.first_name +
              ' ' +
              values?.contacts[0]?.last_name +
              '</td><td>' +
              moment(values?.sent_date).format('MM/DD/YYYY') +
              '</td><td></td><td><span className="fgreen4 font-weight-bold">' +
              values?.amount +
              '</span></td></tr>';
          }

          $('#ftsent_tbl tbody').append(data);
        });
        console.log('ftarray', ftarray);

        this.setState({
          ft_table_details: res.data.result,
          ft_load_more: false,
          ft_load_more_start: parseInt(this.state.ft_load_more_start) + parseInt('10'),
        });
      }
    });
  };

  archiveMode = () => {
    if ($('#archivemode').is(':checked')) {
      this.setState({ VwArchiewDisbl: false });

      const archivemode_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        archive: 'on',
        setup: 'archive',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', archivemode_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          // window.location.reload(true);

          ArchvHstryDtatble.destroy();
          const archive_history = {
            params: {
              apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
              secret: 'R1eqD2twI3E4',
              user_id: this.state.user_id,
              business_id: this.state.business_id,
            },
          };

          axios.get(API_CALL_ENDPOINT + '/business/archive/history', archive_history).then((res) => {
            console.log(res.data);
            if (res.data.result) {
              this.setState({ archiveHstry_detail: res.data.result });
              ArchvHstryDtatble = $('#archivehistory_tbl').DataTable({
                paging: true,
                lengthChange: false,
                ordering: false,
                searching: false,
              });

              var archiveMdStatus = res.data.result[0].archive_status;

              if (archiveMdStatus == 'on') {
                $('#archivemode').prop('checked', true);
                this.setState({ VwArchiewDisbl: false });
              }
              if (archiveMdStatus == 'off') {
                $('#archivemode').prop('checked', false);
                this.setState({ VwArchiewDisbl: true });
              }
            }
          });
        }
      });
    } else {
      const archivemode_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        archive: 'off',
        setup: 'archive',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', archivemode_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          // window.location.reload(true);

          ArchvHstryDtatble.destroy();
          const archive_history = {
            params: {
              apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
              secret: 'R1eqD2twI3E4',
              user_id: this.state.user_id,
              business_id: this.state.business_id,
            },
          };

          axios.get(API_CALL_ENDPOINT + '/business/archive/history', archive_history).then((res) => {
            console.log(res.data);
            if (res.data.result) {
              this.setState({ archiveHstry_detail: res.data.result });
              ArchvHstryDtatble = $('#archivehistory_tbl').DataTable({
                paging: true,
                lengthChange: false,
                ordering: false,
                searching: false,
              });

              var archiveMdStatus = res.data.result[0].archive_status;

              if (archiveMdStatus == 'on') {
                $('#archivemode').prop('checked', true);
                this.setState({ VwArchiewDisbl: false });
              }
              if (archiveMdStatus == 'off') {
                $('#archivemode').prop('checked', false);
                this.setState({ VwArchiewDisbl: true });
              }
            }
          });
        }
      });

      $('#archivemessages').prop('checked', false);

      const archiveView_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        view_archive: 'off',
        setup: 'view_archive',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', archiveView_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          // window.location.reload(true);
        }
      });
    }
  };

  ViewArchiveOnOff = () => {
    if ($('#archivemessages').is(':checked')) {
      const archiveView_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        view_archive: 'on',
        setup: 'view_archive',
      };

      console.log(archiveView_Details);

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', archiveView_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          // window.location.reload(true);
        }
      });
    } else {
      this.setState({ scResultContactList: [] });
      $('.viewarchive_tgldiv').hide();
      const archiveView_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        view_archive: 'off',
        setup: 'view_archive',
      };

      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', archiveView_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          // window.location.reload(true);
        }
      });
    }
  };

  onClickTagTxtboxAdder(event) {
    console.log(this.state.tagTxtBox.length);
    this.setState({
      tagTxtBox: [...this.state.tagTxtBox, ''],
    });
  }

  onChangeTagInput(index, event) {
    let tagTxtBox = [...this.state.tagTxtBox];
    tagTxtBox[index] = event.target.value;
    this.setState({ tagTxtBox });
  }

  onClickDelInput(index) {
    let tagTxtBox = [...this.state.tagTxtBox];
    tagTxtBox.splice(index, 1);
    this.setState({ tagTxtBox });
  }

  onClickTagTxtboxSubmit(event) {
    this.setState({ SaveTagBtnDsble: true });
    const filteredValues = this.state.tagTxtBox.filter((value) => value);
    const Tag_names = filteredValues.toString();

    $('#tag_saveBtb').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled');
    if (Tag_names == '') {
      this.setState(() => ({
        TagMsg: 'Please enter tag name',
        TagMsgClss: 'alert alert-danger',
        tagTxtBox: [''],
      }));

      setTimeout(() => {
        this.setState(() => ({
          TagMsg: '',
          TagMsgClss: '',
          tagTxtBox: [''],
          SaveTagBtnDsble: false,
        }));
        $('#tag_saveBtb').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
      }, 5000);
    } else {
      const createtag = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tag_name: Tag_names,
        tag_source: 'contacts',
      };
      console.log('createtag', createtag);
      axios
        .post(API_CALL_ENDPOINT + '/tags/create', createtag)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            this.setState(() => ({
              TagMsg: res.data.message,
              TagMsgClss: 'alert alert-success',
              tagTxtBox: [''],
            }));

            TagLstDtatable.destroy();

            const tagLst_details = {
              params: {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            console.log(tagLst_details);
            axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
              console.log(res.data);
              if (res.data.result) {
                this.setState({ tagList: res.data.result, tag_list: res.data.result });

                TagLstDtatable = $('#inttags_tbl').DataTable({
                  paging: true,
                  lengthChange: false,
                  ordering: false,
                  searching: false,
                  //"responsive": true,
                });
              }
            });

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
                tagTxtBox: [''],
                SaveTagBtnDsble: false,
              }));

              $('.taglist_div').show();
              $('.addtag_div').hide();
              $('#tag_saveBtb').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
            }, 5000);
          }

          if (res.data.status === 'conflict') {
            this.setState(() => ({
              TagMsg: res.data.message,
              TagMsgClss: 'alert alert-danger',
              tagTxtBox: [''],
            }));

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
                tagTxtBox: [''],
                SaveTagBtnDsble: false,
              }));
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              TagMsg: res.data.error.message,
              TagMsgClss: 'alert alert-danger',
              tagTxtBox: [''],
            }));

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
                tagTxtBox: [''],
                SaveTagBtnDsble: false,
              }));

              $('.taglist_div').show();
              $('.addtag_div').hide();
              $('#tag_saveBtb').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'conflict') {
              this.setState(() => ({
                TagMsg: error.response.data.message,
                TagMsgClss: 'alert alert-danger',
                tagTxtBox: [''],
              }));

              setTimeout(() => {
                this.setState(() => ({
                  TagMsg: '',
                  TagMsgClss: '',
                  tagTxtBox: [''],
                  SaveTagBtnDsble: false,
                }));
              }, 5000);
            }

            if (error.response.data.error) {
              this.setState(() => ({
                TagMsg: error.response.data.error.message,
                TagMsgClss: 'alert alert-danger',
                tagTxtBox: [''],
              }));

              setTimeout(() => {
                this.setState(() => ({
                  TagMsg: '',
                  TagMsgClss: '',
                  tagTxtBox: [''],
                  SaveTagBtnDsble: false,
                }));

                $('.taglist_div').show();
                $('.addtag_div').hide();
                $('#tag_saveBtb').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
              }, 5000);
            }
          }
        });
    }
  }

  getTagname = (event) => {
    console.log(event.target.id);
    console.log(event.target.dataset.txt);
    $('#tagFrm').html('Edit Tag');

    this.setState({
      EditTagName: event.target.dataset.txt,
      EditTagId: event.target.id,
    });

    $('.tagcreate_div').hide();
    $('.addtag_div').show();
    $('.taglist_div').hide();
  };

  EditTagOnChng = (event) => {
    console.log(event.target.value);

    this.setState({
      EditTagName: event.target.value,
    });
  };

  EditTagNameClick = () => {
    this.setState({ EditTagBtnDsble: true });
    $('#tag_update').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled');

    if (this.state.EditTagName === '') {
      this.setState(() => ({
        TagMsg: 'Please enter the Tag name',
        TagMsgClss: 'alert alert-danger',
      }));

      setTimeout(() => {
        this.setState(() => ({
          TagMsg: '',
          TagMsgClss: '',
          EditTagBtnDsble: false,
        }));

        $('#tag_update').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
      }, 5000);
    } else {
      const updatetag_details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tag_name: this.state.EditTagName,
        tag_id: this.state.EditTagId,
      };
      console.log(updatetag_details);
      axios
        .post(API_CALL_ENDPOINT + '/tags/update', updatetag_details)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            this.setState(() => ({
              TagMsg: res.data.message,
              TagMsgClss: 'alert alert-success',
            }));

            TagLstDtatable.destroy();

            const tagLst_details = {
              params: {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            console.log(tagLst_details);
            axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
              console.log(res.data);
              if (res.data.result) {
                this.setState({ tagList: res.data.result, tag_list: res.data.result });

                TagLstDtatable = $('#inttags_tbl').DataTable({
                  paging: true,
                  lengthChange: false,
                  ordering: false,
                  searching: false,
                  //"responsive": true,
                });
              }
            });

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
                EditTagBtnDsble: false,
                EditTagName: '',
                EditTagId: '',
              }));

              $('.taglist_div').show();
              $('.addtag_div').hide();
              $('#tag_update').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              TagMsg: res.data.error.message,
              TagMsgClss: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
                EditTagBtnDsble: false,
                EditTagName: '',
                EditTagId: '',
              }));

              $('.taglist_div').show();
              $('.addtag_div').hide();
              $('#tag_update').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                TagMsg: error.response.data.error.message,
                TagMsgClss: 'alert alert-danger',
              }));

              setTimeout(() => {
                this.setState(() => ({
                  TagMsg: '',
                  TagMsgClss: '',
                  EditTagBtnDsble: false,
                  EditTagName: '',
                  EditTagId: '',
                }));

                $('.taglist_div').show();
                $('.addtag_div').hide();
                $('#tag_update').attr('class', 'btn btn-black crsr_pntr m-2 btnpdng_sm');
              }, 5000);
            }
          }
        });
    }
  };

  DelTag = (event) => {
    console.log(event.target.id);

    const deltag_details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      tag_id: event.target.id,
    };
    console.log(deltag_details);
    axios
      .post(API_CALL_ENDPOINT + '/tags/delete', deltag_details)
      .then((res) => {
        console.log(res.data);
        if (res.data.status === 'success') {
          this.setState(() => ({
            TagMsg: res.data.message,
            TagMsgClss: 'alert alert-success',
          }));

          TagLstDtatable.destroy();

          const tagLst_details = {
            params: {
              apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
              secret: 'R1eqD2twI3E4',
              user_id: this.state.user_id,
              business_id: this.state.business_id,
            },
          };

          console.log(tagLst_details);
          axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
            console.log(res.data);
            if (res.data.result) {
              this.setState({ tagList: res.data.result, tag_list: res.data.result });

              TagLstDtatable = $('#inttags_tbl').DataTable({
                paging: true,
                lengthChange: false,
                ordering: false,
                searching: false,
                //"responsive": true,
              });
            }
          });

          setTimeout(() => {
            this.setState(() => ({
              TagMsg: '',
              TagMsgClss: '',
              EditTagBtnDsble: false,
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            TagMsg: res.data.error.message,
            TagMsgClss: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              TagMsg: '',
              TagMsgClss: '',
              EditTagBtnDsble: false,
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              TagMsg: error.response.data.error.message,
              TagMsgClss: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
                EditTagBtnDsble: false,
              }));
            }, 5000);
          }
        }
      });
  };

  chkInboundtag = (event) => {
    console.log(event.target.id);

    $('#' + event.target.id).prop('checked', true);

    const inBndSetUs_details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      tag_id: event.target.id,
      inbound_tag: 'true',
    };
    console.log('createtag', inBndSetUs_details);
    axios
      .post(API_CALL_ENDPOINT + '/tags/inbound/update', inBndSetUs_details)
      .then((res) => {
        console.log(res.data);
        if (res.data.status === 'success') {
          this.setState(() => ({
            TagMsg: res.data.message,
            TagMsgClss: 'alert alert-success',
          }));
          TagLstDtatable.destroy();
          const tagLst_details = {
            params: {
              apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
              secret: 'R1eqD2twI3E4',
              user_id: this.state.user_id,
              business_id: this.state.business_id,
            },
          };

          console.log(tagLst_details);
          axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
            console.log(res.data);
            if (res.data.result) {
              this.setState({ tagList: res.data.result, tag_list: res.data.result });

              TagLstDtatable = $('#inttags_tbl').DataTable({
                paging: true,
                lengthChange: false,
                ordering: false,
                searching: false,
                //"responsive": true,
              });
            }
          });

          setTimeout(() => {
            this.setState(() => ({
              TagMsg: '',
              TagMsgClss: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            TagMsg: res.data.error.message,
            TagMsgClss: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              TagMsg: '',
              TagMsgClss: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              TagMsg: error.response.data.error.message,
              TagMsgClss: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
              }));
            }, 5000);
          }
        }
      });
  };

  UnChkInbndTg = (event) => {
    console.log(event.target.id);
    $('#' + event.target.id).prop('checked', false);

    const inBndSetUs_details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      tag_id: event.target.id,
      inbound_tag: 'false',
    };
    console.log('createtag', inBndSetUs_details);
    axios
      .post(API_CALL_ENDPOINT + '/tags/inbound/update', inBndSetUs_details)
      .then((res) => {
        console.log(res.data);
        if (res.data.status === 'success') {
          this.setState(() => ({
            TagMsg: res.data.message,
            TagMsgClss: 'alert alert-success',
          }));

          TagLstDtatable.destroy();
          const tagLst_details = {
            params: {
              apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
              secret: 'R1eqD2twI3E4',
              user_id: this.state.user_id,
              business_id: this.state.business_id,
            },
          };

          console.log(tagLst_details);
          axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
            console.log(res.data);
            if (res.data.result) {
              this.setState({ tagList: res.data.result, tag_list: res.data.result });

              TagLstDtatable = $('#inttags_tbl').DataTable({
                paging: true,
                lengthChange: false,
                ordering: false,
                searching: false,
                //"responsive": true,
              });
            }
          });

          setTimeout(() => {
            this.setState(() => ({
              TagMsg: '',
              TagMsgClss: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            TagMsg: res.data.error.message,
            TagMsgClss: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              TagMsg: '',
              TagMsgClss: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              TagMsg: error.response.data.error.message,
              TagMsgClss: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                TagMsg: '',
                TagMsgClss: '',
              }));
            }, 5000);
          }
        }
      });
  };

  chkAllTem = () => {
    if ($('#allteam').is(':checked')) {
      for (var i in this.state.TemIdsMebrArry) {
        $('.smryTmIds' + this.state.TemIdsMebrArry[i]).prop('checked', true);
      }
    } else {
      for (var i in this.state.TemIdsMebrArry) {
        $('.smryTmIds' + this.state.TemIdsMebrArry[i]).prop('checked', false);
      }
    }
  };

  chkAllTem_email = () => {
    if ($('#emailallteam').is(':checked')) {
      for (var i in this.state.TemIdsMebrArry) {
        $('.emailteam' + this.state.TemIdsMebrArry[i]).prop('checked', true);
      }
    } else {
      for (var i in this.state.TemIdsMebrArry) {
        $('.emailteam' + this.state.TemIdsMebrArry[i]).prop('checked', false);
      }
    }
  };

  receiveAlrtChk = (event) => {
    console.log(event.target.dataset.id);
    this.setState({ TmRcvdalrt: event.target.dataset.id });
  };

  saveSmryalrt = () => {
    console.log(this.state.TemIdsMebrArry);
    var tmArry = [];
    for (var i in this.state.TemIdsMebrArry) {
      if ($('.smryTmIds' + this.state.TemIdsMebrArry[i]).is(':checked')) {
        var chdTmids = $('.smryTmIds' + this.state.TemIdsMebrArry[i]).attr('id');
        tmArry.push(chdTmids);
      }
    }

    console.log('Checked Team List: ' + tmArry);
    var chkTmIdDe = tmArry.filter((value) => value);
    var chkTmIdDetails = chkTmIdDe.toString();

    const smryalrt_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      summary: 'on',
      setup: 'summary',
      receive_alert: this.state.TmRcvdalrt,
      team_id: chkTmIdDetails,
    };

    console.log(smryalrt_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', smryalrt_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState(() => ({
            SmryAlrtMsg: res.data.message,
            SmryAlrtCls: 'alert alert-success',
          }));

          setTimeout(() => {
            this.setState(() => ({
              SmryAlrtMsg: '',
              SmryAlrtCls: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            SmryAlrtMsg: res.data.error.message,
            SmryAlrtCls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              SmryAlrtMsg: '',
              SmryAlrtCls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              SmryAlrtMsg: error.response.data.error.message,
              SmryAlrtCls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                SmryAlrtMsg: '',
                SmryAlrtCls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  reSetSmryalrt = () => {
    for (var i in this.state.TemIdsMebrArry) {
      $('.smryTmIds' + this.state.TemIdsMebrArry[i]).prop('checked', false);
    }

    this.setState({ TmRcvdalrt: 'week' });

    const smryalrt_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      summary: 'on',
      setup: 'summary',
      receive_alert: 'week',
      team_id: '',
    };

    console.log(smryalrt_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', smryalrt_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState(() => ({
            SmryAlrtMsg: res.data.message,
            SmryAlrtCls: 'alert alert-success',
          }));

          setTimeout(() => {
            this.setState(() => ({
              SmryAlrtMsg: '',
              SmryAlrtCls: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            SmryAlrtMsg: res.data.error.message,
            SmryAlrtCls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              SmryAlrtMsg: '',
              SmryAlrtCls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              SmryAlrtMsg: error.response.data.error.message,
              SmryAlrtCls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                SmryAlrtMsg: '',
                SmryAlrtCls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  AutoTxtPlsclick(event) {
    console.log(this.state.AutoTxtArea.length);
    this.setState({
      AutoTxtArea: [...this.state.AutoTxtArea, ''],
    });
    this.hide_emoji();
  }

  AutoTxtDelonClick(index, _id) {
    let AutoTxtArea = [...this.state.AutoTxtArea];
    AutoTxtArea.splice(index, 1);
    this.setState({ AutoTxtArea });

    if (_id) {
      var autotxtDel_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        autotext_id: _id,
      };

      console.log(autotxtDel_Details);
      axios
        .post(API_CALL_ENDPOINT + '/business/autotext/delete', autotxtDel_Details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            this.setState(() => ({
              AtoTxtMsg: res.data.message,
              AtoTxtClsNm: 'alert alert-success',
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              AtoTxtMsg: res.data.error.message,
              AtoTxtClsNm: 'alert alert-danger',
            }));
            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                AtoTxtMsg: error.response.data.error.message,
                AtoTxtClsNm: 'alert alert-danger',
              }));
              setTimeout(() => {
                this.setState(() => ({
                  AtoTxtMsg: '',
                  AtoTxtClsNm: '',
                }));
              }, 5000);
            }
          }
        });
    }
    this.hide_emoji();
  }

  AutoTxtOnChng(index, _id, event) {
    if (_id) {
      let AutoTxtArea = [...this.state.AutoTxtArea];
      AutoTxtArea[index] = { text_response: event.target.value, _id: _id };
      this.setState({ AutoTxtArea });
    } else {
      let AutoTxtArea = [...this.state.AutoTxtArea];

      AutoTxtArea[index] = event.target.value;
      this.setState({ AutoTxtArea });
    }
    this.hide_emoji();
  }

  AutoTxtMaxRspnsOnChg = (event) => {
    var value = event.target.value.replace(/^0+/, '');
    this.setState({ AutotxtMxRspnsVlue: value });
  };

  AutoTxtSaveclick() {
    var regex = /^[0-9]+$/;
    var ValidNum = regex.test(this.state.AutotxtMxRspnsVlue);

    if (this.state.AutoTxtArea[0] === '') {
      this.setState(() => ({
        AtoTxtMsg: 'R-Bot response message cannot be blank.',
        AtoTxtClsNm: 'alert alert-danger',
      }));
      setTimeout(() => {
        this.setState(() => ({
          AtoTxtMsg: '',
          AtoTxtClsNm: '',
        }));
      }, 5000);
    }
    // else if(ValidNum){
    else if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
      console.log(this.state.atcharryDet_cmb);
      toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      console.log(this.state.AutoTxtArea);
      const filteredValues = this.state.AutoTxtArea.filter((value) => value);
      var AryTxtRespn = [];
      var i;
      for (i = 0; i < this.state.AutoTxtArea.length; i++) {
        var obj = {};
        if (this.state.AutoTxtArea[i]._id) {
          obj['id'] = this.state.AutoTxtArea[i]._id;
          obj['text_response'] = this.state.AutoTxtArea[i].text_response;
          obj['unique_id'] = this.state.atcharryDet_cmb.length != 0 ? Rnunique_id_cmb : '';
        } else if (this.state.AutoTxtArea[i] != '') {
          obj['id'] = this.state.AutotxtListUniqId;
          obj['text_response'] = this.state.AutoTxtArea[i];
          obj['unique_id'] = this.state.atcharryDet_cmb.length != 0 ? Rnunique_id_cmb : '';
        }
        AryTxtRespn.push(obj);
      }

      var AryTxtRespnToObj = JSON.stringify(AryTxtRespn);
      console.log(typeof AryTxtRespn);
      console.log(AryTxtRespn);

      console.log(AryTxtRespnToObj);

      var autoTxtsav_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        setup: 'auto_text',
        auto_text: 'on',
        maximum_response: this.state.AutotxtMxRspnsVlue,
        text_response_array: AryTxtRespnToObj,
      };

      console.log(autoTxtsav_Details);
      axios
        .post(API_CALL_ENDPOINT + '/business/profile/settings', autoTxtsav_Details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);
          // Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
          if (res.data.status == 'success') {
            this.setState(() => ({
              AtoTxtMsg: res.data.message,
              AtoTxtClsNm: 'alert alert-success',
              AtoTxDelClkDisble: false,
            }));

            const AutotxtRes_details = {
              params: {
                apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                secret: 'R1eqD2twI3E4',
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            console.log(AutotxtRes_details);
            axios.get(API_CALL_ENDPOINT + '/business/autotext/list', AutotxtRes_details).then((res) => {
              console.log(res.data);
              if (res.data.result) {
                this.setState({ AutoTxtArea: res.data.result });
              }
            });

            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              AtoTxtMsg: res.data.error.message,
              AtoTxtClsNm: 'alert alert-danger',
            }));
            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                AtoTxtMsg: error.response.data.error.message,
                AtoTxtClsNm: 'alert alert-danger',
              }));
              setTimeout(() => {
                this.setState(() => ({
                  AtoTxtMsg: '',
                  AtoTxtClsNm: '',
                }));
              }, 5000);
            }
          }
        });
    }
  }

  AutoTxtTtlDel = () => {
    var TextareLngth = this.state.AutoTxtArea.length;
    var MinusTextareLngth = TextareLngth - parseInt(1);
    var i;
    for (i = 0; i < TextareLngth; i++) {
      var autotxtDel_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        autotext_id: this.state.AutoTxtArea[i]._id,
      };

      console.log(autotxtDel_Details);
      axios
        .post(API_CALL_ENDPOINT + '/business/autotext/delete', autotxtDel_Details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);
          $('#get_data_for_inbound').val('');
          if (res.data.status == 'success') {
            this.setState(() => ({
              AtoTxtMsg: res.data.message,
              AtoTxtClsNm: 'alert alert-success',
              AutoTxtArea: [''],
              AutotxtMxRspnsVlue: '',
              AtoTxDelClkDisble: true,
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
            this.setState({ atcharryDet_cmb: [] });
            $('.attchLstShow_cmb').hide();
            // if (this.state.atcharryDet_cmb.length == 0) {

            // }
          }

          if (res.data.error) {
            this.setState(() => ({
              AtoTxtMsg: res.data.error.message,
              AtoTxtClsNm: 'alert alert-danger',
            }));
            setTimeout(() => {
              this.setState(() => ({
                AtoTxtMsg: '',
                AtoTxtClsNm: '',
              }));
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                AtoTxtMsg: error.response.data.error.message,
                AtoTxtClsNm: 'alert alert-danger',
              }));
              setTimeout(() => {
                this.setState(() => ({
                  AtoTxtMsg: '',
                  AtoTxtClsNm: '',
                }));
              }, 5000);
            }
          }
        });

      var autoTxtOff_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        setup: 'auto_text',
        auto_text: 'off',
      };

      console.log(autoTxtOff_Details);
      axios.post(API_CALL_ENDPOINT + '/business/profile/settings', autoTxtOff_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
        }
      });
    }
  };

  VoiceGrtnaudio_start = () => {
    $('#audioStrtVoiceGrtng').hide();
    $('#audioStopVoiceGrtng').show();

    navigator.mediaDevices.getUserMedia(
      { audio: true },
      () => {
        console.log('Permission Granted');
        this.setState({ isBlocked: false });
      },
      () => {
        console.log('Permission Denied');
        this.setState({ isBlocked: true });
      },
    );

    if (this.state.isBlocked) {
      console.log('Permission Denied');
    } else {
      Mp3Recorder.start()
        .then(() => {
          this.setState({ isRecording: true });
        })
        .catch((e) => console.error(e));
    }
  };

  VoiceGrtnaudio_stop = () => {
    $('#audioStopVoiceGrtng').hide();
    $('#audioPlayVoiceGrtng').show();

    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const file = new File(buffer, Date.now() + '.mp3', {
          type: blob.type,
          lastModified: Date.now(),
        });
        const VoiceGrtngblobURL = URL.createObjectURL(file);
        this.setState({ VoiceGrtngblobURL, isRecording: false });

        var filename = new Date().toISOString();

        const data = new FormData();

        data.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
        data.append('secret', 'R1eqD2twI3E4');
        data.append('user_id', this.state.user_id);
        data.append('business_id', this.state.business_id);
        data.append('file', file);
        data.append('reference', 'text');

        axios.post(API_CALL_ENDPOINT + '/file/upload', data).then((res) => {
          console.log(res);
          console.log(res.data.message);
          console.log(res.data.result.files);

          if (res.data.status == 'success') {
            var file_url = res.data.result.files[0].file_url;
            var file_id = res.data.result.files[0]._id;

            console.log(file_url);

            this.setState({ VoiceGrtngRecUrl: file_url });
          }
        });
      })
      .catch((e) => console.log(e));
  };

  VoiceGrtnaudio_play = () => {
    $('#audioPlayVoiceGrtng').hide();
    $('#audioPauseVoiceGrtng').show();
    var playx = document.getElementById('voiceGretngRcrd');
    playx.play();
    playx.onended = function () {
      $('#audioPauseVoiceGrtng').hide();
      $('#audioPlayVoiceGrtng').show();
    };
  };

  VoiceGrtnaudio_pause = (e) => {
    var pausex = document.getElementById('voiceGretngRcrd');
    pausex.pause();
    $('#audioPauseVoiceGrtng').hide();
    $('#audioPlayVoiceGrtng').show();
  };

  SaveVoiceGrrtng = () => {
    console.log('R-Bot voiceGreeting Save');

    if (this.state.VoiceGrtngRecUrl != '') {
      $('#VoiceGrrtngRecSv_id').html('Saving...');
      $('#VoiceGrrtngRecSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2 isdisabled');
      var VoiceGrtng_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        voice_greetings_status: 'on',
        setup: 'voice_greetings',
        voice_greetings_type: 'record',
        greeting_url: this.state.VoiceGrtngRecUrl,
      };

      console.log(VoiceGrtng_Details);
      axios
        .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            this.setState(() => ({
              ViceGrtMsg: res.data.message,
              ViceGrtcls: 'alert alert-success',
              VoiceGrtngRecDeltDisble: false,
              TxtVoiceGrtngvlue: '',
              voiceGnrteResetdisble: true,
              VoiceLngRegn: 'en-US',
              TxtTypeVoiceUrl: '',
              generatePlayDisble: true,
            }));

            for (var i in this.state.GrntVoiveLngRegin) {
              if (this.state.GrntVoiveLngRegin[i]._id == 'en-US') {
                console.log(this.state.GrntVoiveLngRegin[i].voice_list);
                this.setState({ VoceLstBsOnLanguge: this.state.GrntVoiveLngRegin[i].voice_list });
              }
            }

            setTimeout(() => {
              this.setState(() => ({
                ViceGrtMsg: '',
                ViceGrtcls: '',
              }));
              $('#VoiceGrrtngRecSv_id').html('Save');
              $('#VoiceGrrtngRecSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              ViceGrtMsg: res.data.error.message,
              ViceGrtcls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                ViceGrtMsg: '',
                ViceGrtcls: '',
              }));
              $('#VoiceGrrtngRecSv_id').html('Save');
              $('#VoiceGrrtngRecSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                ViceGrtMsg: error.response.data.error.message,
                ViceGrtcls: 'alert alert-danger',
              }));

              setTimeout(() => {
                this.setState(() => ({
                  ViceGrtMsg: '',
                  ViceGrtcls: '',
                }));
                $('#VoiceGrrtngRecSv_id').html('Save');
                $('#VoiceGrrtngRecSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
              }, 5000);
            }
          }
        });
    } else {
      this.setState(() => ({
        ViceGrtMsg: 'Please record after save',
        ViceGrtcls: 'alert alert-danger',
      }));

      setTimeout(() => {
        this.setState(() => ({
          ViceGrtMsg: '',
          ViceGrtcls: '',
        }));
      }, 5000);
    }
  };

  DelVoiceGrrtng = () => {
    var VoiceGrtng_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      voice_greetings_status: 'off',
      setup: 'voice_greetings',
      voice_greetings_type: 'record',
    };

    console.log(VoiceGrtng_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState(() => ({
            ViceGrtMsg: 'R-Bot Voice Greetings Delete Successfully',
            ViceGrtcls: 'alert alert-success',
            VoiceGrtngRecDeltDisble: true,
            VoiceGrtngblobURL: '',
          }));
          $('#audioStrtVoiceGrtng').show();
          $('#audioPlayVoiceGrtng').hide();
          setTimeout(() => {
            this.setState(() => ({
              ViceGrtMsg: '',
              ViceGrtcls: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            ViceGrtMsg: res.data.error.message,
            ViceGrtcls: 'alert alert-danger',
          }));
          $('#audioStrtVoiceGrtng').show();
          $('#audioPlayVoiceGrtng').hide();
          setTimeout(() => {
            this.setState(() => ({
              ViceGrtMsg: '',
              ViceGrtcls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              ViceGrtMsg: error.response.data.error.message,
              ViceGrtcls: 'alert alert-danger',
            }));
            $('#audioStrtVoiceGrtng').show();
            $('#audioPlayVoiceGrtng').hide();
            setTimeout(() => {
              this.setState(() => ({
                ViceGrtMsg: '',
                ViceGrtcls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  TxtVoiceGrtngOnChg = (event) => {
    console.log(event.target.value);
    this.setState({ TxtVoiceGrtngvlue: event.target.value });
  };
  requestFungibleTokenConfirm = () => {
    var ft_token_name = $('#ft_token_name').val();
    var ft_token_symbol = $('#ft_token_symbol').val();
    var ft_token_number = $('#ft_token_number').val();
    if (ft_token_name.length === 0) {
      toast.dark('Please enter the Token Name.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      $('#ft_token_name').focus();
      return false;
    }
    if (ft_token_symbol.length === 0) {
      toast.dark('Please enter the Token Symbol.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      $('#ft_token_symbol').focus();
      return false;
    }
    if (ft_token_number.length === 0) {
      toast.dark('Please enter the No of Tokens.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      $('#ft_token_number').focus();
      return false;
    }
    var fungible_token_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      setup: 'fungible_token',
      token_name: ft_token_name,
      token_symbol: ft_token_symbol,
      token_limit: ft_token_number,
    };

    console.log(fungible_token_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', fungible_token_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          $('.ftrequest').hide();
          this.getBusinessDetails();
          $('#ft_token_name').val('');
          $('#ft_token_symbol').val('');
          $('#ft_token_number').val('');
          $('.ftrequest_btn').show();
          $('.ftrequest_confirm_btn').hide();
          $('.ftrequest_confirm_message').hide();
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
          }
        }
      });
  };

  requestFungibleToken = () => {
    var ft_token_name = $('#ft_token_name').val();
    var ft_token_symbol = $('#ft_token_symbol').val();
    var ft_token_number = $('#ft_token_number').val();
    if (ft_token_name.length === 0) {
      toast.dark('Please enter the Token Name.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      $('#ft_token_name').focus();
      return false;
    }
    if (ft_token_symbol.length === 0) {
      toast.dark('Please enter the Token Symbol.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      $('#ft_token_symbol').focus();
      return false;
    }
    if (ft_token_number.length === 0) {
      toast.dark('Please enter the No of Tokens.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      $('#ft_token_number').focus();
      return false;
    }
    $('.ftrequest_btn').hide();
    $('.ftrequest_confirm_btn').show();
    $('.ftrequest_confirm_message').show();
  };

  viewReceipt = (event, type) => {
    const token_list_params = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        flag: 'single',
        tran_hash: event,
      },
    };
    console.log('token_list_params', token_list_params);
    axios
      .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
      .then((res) => {
        if (res.data.status === 'success') {
          console.log('nftres.datasss', res.data.result[0]);
          this.setState({ nft_token: res.data.result[0], nft_token_file_extension: '' });
          $('.nftmintedlist_div').hide();
          if (type === 'minted') {
            $('.receiptnft_div').show();
          } else if (type === 'sent') {
            $('.sentreceiptnft_div').show();
          } else if (type === 'accept') {
            $('.inprocessreceiptnft_div').show();
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status == 'no_record') {
          }
        }
      });
  };

  NftCount = () => {
    const token_list_params = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/blockchain/nft/analytics', token_list_params)
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({
            nft_total_count: res.data.result.total_nft_count,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status == 'no_record') {
            this.setState({
              nft_total_count: 0,
            });
          }
        }
      });
  };

  closeReceipt = (event) => {
    this.setState({ nft_load_more: true });
    var nft_type = 'available';
    if ($('#custom-tabs-nftavailable-tab').hasClass('active')) {
      nft_type = 'available';
    }
    if ($('#custom-tabs-nftinprocess-tab').hasClass('active')) {
      nft_type = 'sent';
    }
    if ($('#custom-tabs-nftsent-tab').hasClass('active')) {
      nft_type = 'accepted';
    }
    var tab = nft_type;
    if (event == 'Available' || event == 'available' || event == '') {
      tab = 'available';
      $('#custom-tabs-nftavailable-tab').addClass('active');
      $('#custom-tabs-nftinprocess-tab').removeClass('active');
      $('#custom-tabs-nftsent-tab').removeClass('active');
      $('#custom-tabs-nftavailable').addClass('active show');
      $('#custom-tabs-nftinprocess').removeClass('active show');
      $('#custom-tabs-nftsent').removeClass('active show');
    }
    if (event == 'Sent' || event == 'sent') {
      tab = 'sent';
      $('#custom-tabs-nftavailable-tab').removeClass('active');
      $('#custom-tabs-nftinprocess-tab').addClass('active');
      $('#custom-tabs-nftsent-tab').removeClass('active');
      $('#custom-tabs-nftavailable').removeClass('active show');
      $('#custom-tabs-nftinprocess').addClass('active show');
      $('#custom-tabs-nftsent').removeClass('active show');
    }
    if (event == 'Accepted' || event == 'accepted') {
      tab = 'accepted';
      $('#custom-tabs-nftavailable-tab').removeClass('active');
      $('#custom-tabs-nftinprocess-tab').removeClass('active');
      $('#custom-tabs-nftsent-tab').addClass('active');
      $('#custom-tabs-nftavailable').removeClass('active show');
      $('#custom-tabs-nftinprocess').removeClass('active show');
      $('#custom-tabs-nftsent').addClass('active show');
    }
    $('.addnft_div').hide();
    const token_list_params = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        flag: 'all',
        tab: tab,
        // tran_hash: res.data.result.Tran_Hash,
      },
    };
    var tdataarr = [];
    var tdataarrsent = [];
    var tdataarraccept = [];

    axios
      .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
      .then((res) => {
        if (res.data.status === 'success') {
          console.log('nftres.datasss1', res.data.result);
          this.setState({
            nft_tokens: res.data.result,
            nft_token_file_extension: '',
            table_view: false,
            nft_load_more: false,
            nft_available_load_more: true,
            nft_sent_load_more: true,
            nft_accept_load_more: true,
          });
          $('.receiptnft_div').hide();
          $('.sentreceiptnft_div').hide();
          $('.inprocessreceiptnft_div').hide();
          $('.nftmintedlist_div').show();
          $('.addnft_div').hide();
          $('#nft_name_minted').val('');
          $('#nft_decription_minted').val('');
          $('#nft_file_name_minted').val('');
          $('#nft_thumb_file_url_minted').val('');
          $('.chooseupload_nft_minted').val('');
          $('.chooseupload_nft_minted').trigger('change');
          $('#uploaded_image_minted').hide();
          $('#uploaded_image_giff_minted').hide();

          for (var i = 0; i < res.data.result.length; i++) {
            if (res.data.result[i].status === 'minted') {
              tdataarr.push(res.data.result[i]);
            } else if (res.data.result[i].status === 'accepted') {
              tdataarraccept.push(res.data.result[i]);
            } else if (res.data.result[i].status === 'sent') {
              tdataarrsent.push(res.data.result[i]);
            }
          }
          if (tdataarr.length === 0) {
            $('#minted_search').hide();
          } else {
            $('#minted_search').show();
          }
          if (tdataarraccept.length === 0) {
            $('#accept_search').hide();
          } else {
            $('#accept_search').show();
          }
          if (tdataarrsent.length === 0) {
            $('#sent_search').hide();
          } else {
            $('#sent_search').show();
          }
          if (tdataarr.length < 20) {
            this.setState({ nft_available_load_more: false });
          }
          if (tdataarrsent.length < 20) {
            this.setState({ nft_sent_load_more: false });
          }
          if (tdataarraccept.length < 20) {
            this.setState({ nft_accept_load_more: false });
          }
          this.setState({
            nft_minted_tokens_lists: tdataarr,
            nft_accept_tokens_lists: tdataarraccept,
            nft_sent_tokens_lists: tdataarrsent,
            nft_available_cnt: 0,
            nft_sent_cnt: 0,
            nft_accept_cnt: 0,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status == 'no_record') {
            this.setState({
              nft_minted_tokens_lists: tdataarr,
              nft_accept_tokens_lists: tdataarraccept,
              nft_sent_tokens_lists: tdataarrsent,
              nft_load_more: false,
              nft_available_cnt: 0,
              nft_sent_cnt: 0,
              nft_accept_cnt: 0,
            });
            $('.receiptnft_div').hide();
            if (this.state.nft_total_count !== 0) {
              $('.nftmintedlist_div').show();
            }
          }
        }
        this.NftCount();
      });
  };

  LoadMoreNft = (event) => {
    var nft_type = 'available';
    var startval = 0;
    var searchval = '';
    this.setState({ nft_load_more: true });
    if ($('#custom-tabs-nftavailable-tab').hasClass('active')) {
      nft_type = 'available';
      startval = this.state.nft_available_cnt;
      startval = parseInt(startval) + 20;
      this.setState({ nft_available_cnt: startval });
      if ($('.nft_minted_search').val().length !== 0) {
        searchval = $('.nft_minted_search').val();
      }
    }
    if ($('#custom-tabs-nftinprocess-tab').hasClass('active')) {
      nft_type = 'sent';
      startval = this.state.nft_sent_cnt;
      startval = parseInt(startval) + 20;
      this.setState({ nft_sent_cnt: startval });
      if ($('.nft_sent_search').val().length !== 0) {
        searchval = $('.nft_sent_search').val();
      }
    }
    if ($('#custom-tabs-nftsent-tab').hasClass('active')) {
      nft_type = 'accepted';
      startval = this.state.nft_accept_cnt;
      startval = parseInt(startval) + 20;
      this.setState({ nft_accept_cnt: startval });
      if ($('.nft_accept_search').val().length !== 0) {
        searchval = $('.nft_accept_search').val();
      }
    }
    $('.addnft_div').hide();
    const token_list_params = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        flag: 'all',
        tab: nft_type,
        limit: '20',
        start: startval,

        // tran_hash: res.data.result.Tran_Hash,
      },
    };
    console.log('searchval', searchval);
    if (searchval.length != 0) {
      token_list_params.params.search_text = searchval;
    }
    var tdataarr = this.state.nft_minted_tokens_lists;
    var tdataarrsent = this.state.nft_sent_tokens_lists;
    var tdataarraccept = this.state.nft_accept_tokens_lists;
    var mintedarr = [];
    var sentarr = [];
    var acceptarr = [];
    axios
      .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
      .then((res) => {
        if (res.data.status === 'success') {
          console.log('nftres.datasss1', res.data.result);
          this.setState({ nft_tokens: res.data.result, nft_token_file_extension: '', table_view: false });
          $('.receiptnft_div').hide();
          $('.sentreceiptnft_div').hide();
          $('.inprocessreceiptnft_div').hide();
          $('.nftmintedlist_div').show();
          $('.addnft_div').hide();
          $('#nft_name_minted').val('');
          $('#nft_decription_minted').val('');
          $('#nft_file_name_minted').val('');
          $('#nft_file_url_minted').val('');
          $('.chooseupload_nft_minted').val('');
          $('.chooseupload_nft_minted').trigger('change');
          $('#uploaded_image_minted').hide();
          $('#uploaded_image_giff_minted').hide();

          for (var i = 0; i < res.data.result.length; i++) {
            if (res.data.result[i].status === 'minted') {
              tdataarr.push(res.data.result[i]);
              mintedarr.push(res.data.result[i]);
            } else if (res.data.result[i].status === 'accepted') {
              tdataarraccept.push(res.data.result[i]);
              acceptarr.push(res.data.result[i]);
            } else if (res.data.result[i].status === 'sent') {
              tdataarrsent.push(res.data.result[i]);
              sentarr.push(res.data.result[i]);
            }
          }
          if (tdataarr.length === 0) {
            $('#minted_search').hide();
          } else {
            $('#minted_search').show();
          }
          if (tdataarraccept.length === 0) {
            $('#accept_search').hide();
          } else {
            $('#accept_search').show();
          }
          if (tdataarrsent.length === 0) {
            $('#sent_search').hide();
          } else {
            $('#sent_search').show();
          }
          if ($('#custom-tabs-nftavailable-tab').hasClass('active')) {
            if (mintedarr.length < 20) {
              this.setState({ nft_available_load_more: false });
            }
          }
          if ($('#custom-tabs-nftinprocess-tab').hasClass('active')) {
            if (sentarr.length < 20) {
              this.setState({ nft_sent_load_more: false });
            }
          }
          if ($('#custom-tabs-nftsent-tab').hasClass('active')) {
            if (acceptarr.length < 20) {
              this.setState({ nft_accept_load_more: false });
            }
          }
          this.setState({
            nft_minted_tokens_lists: tdataarr,
            nft_accept_tokens_lists: tdataarraccept,
            nft_sent_tokens_lists: tdataarrsent,
            nft_load_more: false,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status == 'no_record') {
            this.setState({
              nft_minted_tokens_lists: tdataarr,
              nft_accept_tokens_lists: tdataarraccept,
              nft_sent_tokens_lists: tdataarrsent,
              nft_load_more: false,
              nft_available_load_more: false,
              nft_sent_load_more: false,
              nft_accept_load_more: false,
            });
            $('.receiptnft_div').hide();
          }
          if ($('#custom-tabs-nftavailable-tab').hasClass('active')) {
            startval = this.state.nft_available_cnt;
            startval = parseInt(startval) - 20;
            this.setState({ nft_available_cnt: startval });
          }
          if ($('#custom-tabs-nftinprocess-tab').hasClass('active')) {
            startval = this.state.nft_sent_cnt;
            startval = parseInt(startval) - 20;
            this.setState({ nft_sent_cnt: startval });
          }
          if ($('#custom-tabs-nftsent-tab').hasClass('active')) {
            startval = this.state.nft_accept_cnt;
            startval = parseInt(startval) - 20;
            this.setState({ nft_accept_cnt: startval });
          }
        }
      });
  };

  getNumberLists = () => {
    const numberlist = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        country: 'US',
        start: '0',
        limit: '7',
        // pattern:'61534',
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
      .then((res) => {
        console.log(res.data.result.phone_numbers);
        this.setState({ plivolist: res.data.result.phone_numbers });
        console.log('this.state.plivolist', this.state.plivolist);
        setTimeout(() => {
          this.setState({ errors: [] });
          this.areacode();
          $('#chooseareacode1').trigger('click');
        }, 100);
      })
      .catch((error) => {
        console.log(error);
      });

    const rnumberlist = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        country: 'US',
        start: '0',
        limit: '7',
        region: 'Texas',
        // pattern:'61534',
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/plivo/number/list', rnumberlist)
      .then((res) => {
        console.log(res.data.result.phone_numbers);
        this.setState({ rplivolist: res.data.result.phone_numbers });
        console.log(this.state.rplivolist);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  nftDetails = () => {
    const nft_details = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/business/nft/list', nft_details)
      .then((res) => {
        if (res.data.result) {
          console.log('nftres.data', res.data.result.nft);
          this.setState({ nft_details: res.data.result.nft });
          if (res.data.result.nft.token_name === '' && res.data.result.nft.token_symbol === '') {
            $('#nft_step_1').show();
            $('#nft_step_3').hide();
            $('#nft_step_2').hide();
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status == 'no_record') {
          }
        }
      });
  };

  contractNextStep = (step) => {
    if (step === 1) {
    } else if (step === 2) {
      $('#nft_step_1').hide();
      $('#nft_step_3').hide();
      $('#nft_step_2').show();
      $('#nftmint').addClass('active');
      $('#nftconfirm').removeClass('active');
      $('.receiptnft_div').hide();
      $('.sentreceiptnft_div').hide();
      $('.inprocessreceiptnft_div').hide();
      $('.nftmintedlist_div').hide();
      $('.nftcreate_div').show();
    } else if (step === 3) {
      var nft_name = $('#nft_name').val();
      var nft_decription = $('#nft_decription').val();
      var nft_file_name = $('#nft_file_name').val();
      var nft_file_url = $('#nft_file_url').val();
      var nft_thumb_file_url = $('#nft_thumb_file_url').val();
      var that = this;
      var continue_vals = '1';
      var keyarr = [];
      if (nft_name.length === 0) {
        toast.dark('Please enter the NFT name.', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      if (nft_decription.length === 0) {
        toast.dark('Please enter the NFT Decription.', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      if (nft_file_url.length === 0) {
        toast.dark('Please upload a file', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      $('.cnftkeyvalues')
        .each(function (index) {
          console.log($('#keyrequired' + $(this).data('id') + '').is(':checked'));
          if ($(this).data('required') && $(this).val().length == 0) {
            continue_vals = '0';
            $(this).focus();
            toast.dark('Please enter the key value.', {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            return false;
          } else {
            var keyvalues = { key: $(this).data('key'), value: $(this).val() };
            keyarr.push(keyvalues);
          }
        })
        .promise()
        .done(function () {
          if (continue_vals == '1') {
            var keyvals = keyarr;
            console.log('keyarrkeyarrkeyarr', keyarr);
            $('#nft_step_1').hide();
            $('#nft_step_2').hide();
            $('#nft_step_3').show();
            $('#nftconfirm').addClass('active');
            that.setState({
              nft_name: nft_name,
              nft_decription: nft_decription,
              nft_file_name: nft_file_name,
              nft_file_url: nft_file_url,
              nft_keys: keyvals,
            });
          }
        });
    } else if (step === 4) {
      $('.nftconfirm_receipt_clk').hide();
      $('.nftconfirm_receipt_clk_diabled').show();
      if (!$('#nftagree').is(':checked')) {
        toast.dark('Please agree to the terms of service', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        $('.nftconfirm_receipt_clk').show();
        $('.nftconfirm_receipt_clk_diabled').hide();
        return false;
      }
      // $('.nftconfirm_receipt_clk').addClass('isdisabled');

      var nftmint_params = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        file_url: this.state.nft_file_url,
        thumbnail_file_url: this.state.nft_thumb_file_url,
        nft_name: this.state.nft_name,
        nft_description: this.state.nft_decription,
        file_name: this.state.nft_file_name,
        upload_type: this.state.nft_file_type,
        token_key: JSON.stringify(this.state.nft_keys),
      };
      axios
        .post(API_CALL_ENDPOINT + '/blockchain/nft/mint', nftmint_params)
        .then((res) => {
          console.log(res.data);
          this.nftDetails();
          if (res.data.status === 'success') {
            this.closeReceipt();
            toast.dark(res.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            this.setState({ nft_mint_click: false });
            this.getBusinessDetails();
            $('.nftconfirm_receipt_clk').show();
            $('.nftconfirm_receipt_clk_diabled').hide();
            $('#nftagree').prop('checked', false);
            $('.nftkeyvalues').val('');

            const token_list_params = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                flag: 'single',
                _id: res.data.result.nft.token_id,
              },
            };
            console.log('token_list_params', token_list_params);
            axios
              .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
              .then((res) => {
                console.log('/blockchain/nft/token/list', res);
                if (res.data.status === 'success') {
                  console.log('nftres.datasss', res.data.result[0]);
                  this.setState({
                    nft_token: res.data.result,
                    nft_token_file_extension: '',
                    nft_available_cnt: 0,
                    nft_sent_cnt: 0,
                    nft_accept_cnt: 0,
                  });
                  $('.nftcreate_div').hide();
                  $('.receiptnft_div').show();
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.status == 'no_record') {
                  }
                }
              });
          }

          //console.log(res.data.message);
        })
        .catch((error) => { });
    }
  };

  mintingNextStep = (step) => {
    if (step === 1) {
    } else if (step === 2) {
      this.setState({
        table_view: true,
      });
      $('#nftminted_step_1').show();
      $('#nftminted_step_2').hide();
      $('.nftcreate_div').hide();
      $('.receiptnft_div').hide();
      $('.sentreceiptnft_div').hide();
      $('.inprocessreceiptnft_div').hide();
      $('.nftmintedlist_div').hide();
      $('.addnft_div').show();
      $('.nftconfirm_minted').removeClass('active');
    } else if (step === 3) {
      var nft_name = $('#nft_name_minted').val();
      var nft_decription = $('#nft_decription_minted').val();
      var nft_file_name = $('#nft_file_name_minted').val();
      var nft_file_url = $('#nft_file_url_minted').val();
      var nft_thumb_file_url = $('#nft_thumb_file_url_minted').val();
      var that = this;
      var continue_vals = '1';
      var keyarr = [];
      console.log('nft_name', nft_name);
      console.log('nft_decription', nft_decription);
      console.log('nft_file_name', nft_file_name);
      console.log('nft_file_url', nft_file_url);
      if (nft_name.length === 0) {
        toast.dark('Please enter the NFT name.', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      if (nft_decription.length === 0) {
        toast.dark('Please enter the NFT Decription.', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      if (nft_file_url.length === 0) {
        toast.dark('Please upload a file', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      $('.nftkeyvalues')
        .each(function (index) {
          console.log($('#keyrequired' + $(this).data('id') + '').is(':checked'));
          if ($(this).data('required') && $(this).val().length == 0) {
            continue_vals = '0';
            $(this).focus();
            toast.dark('Please enter the key value.', {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            return false;
          } else {
            var keyvalues = { key: $(this).data('key'), value: $(this).val() };
            keyarr.push(keyvalues);
          }
        })
        .promise()
        .done(function () {
          if (continue_vals == '1') {
            var keyvals = keyarr;
            console.log('keyarrkeyarrkeyarr', keyarr);
            $('#nftminted_step_1').hide();
            $('#nftminted_step_2').show();
            $('.nftconfirm_minted').addClass('active');
            that.setState({
              nft_name: nft_name,
              nft_decription: nft_decription,
              nft_file_name: nft_file_name,
              nft_file_url: nft_file_url,
              nft_keys: keyvals,
            });
          }
        });
    } else if (step === 4) {
      $('.nftconfirm_receipt_clk').hide();
      $('.nftconfirm_receipt_clk_diabled').show();
      if (!$('#nftagree_minted').is(':checked')) {
        toast.dark('Please agree to the terms of service', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        $('.nftconfirm_receipt_clk').show();
        $('.nftconfirm_receipt_clk_diabled').hide();
        return false;
      }
      var nftmint_params = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        file_url: this.state.nft_file_url,
        thumbnail_file_url: this.state.nft_thumb_file_url,
        nft_name: this.state.nft_name,
        nft_description: this.state.nft_decription,
        file_name: this.state.nft_file_name,
        upload_type: this.state.nft_file_type,
        token_key: JSON.stringify(this.state.nft_keys),
      };
      axios
        .post(API_CALL_ENDPOINT + '/blockchain/nft/mint', nftmint_params)
        .then((res) => {
          console.log(res.data);
          this.nftDetails();
          if (res.data.status === 'success') {
            this.setState({ nft_mint_click: false, nft_available_cnt: 0, nft_sent_cnt: 0, nft_accept_cnt: 0 });
            this.getBusinessDetails();
            $('.custom-tabs-nftavailable-tab').show();
            $('.nftconfirm_receipt_clk').show();
            $('.nftconfirm_receipt_clk_diabled').hide();
            $('#nftagree_minted').prop('checked', false);
            $('.nftkeyvalues').val('');
            const token_list_params = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                flag: 'single',
                _id: res.data.result.nft.token_id,
              },
            };
            console.log('token_list_params', token_list_params);
            axios
              .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
              .then((res) => {
                console.log('/blockchain/nft/token/list2', res);
                if (res.data.status === 'success') {
                  console.log('nftres.datasss', res.data.result.nft[0]);
                  this.setState({ nft_token: res.data.result.nft, nft_token_file_extension: '' });
                  $('.addnft_div').hide();
                  $('.receiptnft_div').show();
                  $('#nft_name_minted').val('');
                  $('#nft_decription_minted').val('');
                  $('#nft_file_name_minted').val('');
                  $('#nft_file_url_minted').val('');
                  $('.chooseupload_nft_minted').val('');
                  $('.chooseupload_nft_minted').trigger('change');
                  $('#uploaded_image_minted').hide();
                  $('#uploaded_image_giff_minted').hide();
                  $('.nftconfirm_receipt_clk').show();
                  $('.nftconfirm_receipt_clk_diabled').hide();
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.status == 'no_record') {
                  }
                }
              });
          }

          //console.log(res.data.message);
        })
        .catch((error) => { });
    }
  };

  nftFunctionalities = (val, type) => {
    if (type === 'view_receipt') {
      var id = val.token_hash;
      var vtype = val.status;
      console.log('ididid', id);
      console.log('typetype', vtype);
      const token_list_params = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          flag: 'single',
          _id: val._id,
        },
      };
      
      console.log('_id:', token_list_params.params._id);
      // console.log('token_list_params', token_list_params);
      axios
        .get(API_CALL_ENDPOINT + '/blockchain/nft/token/list', token_list_params)
        .then((res) => {
          if (res.data.status === 'success') {
            console.log('nftres.datasss', res.data.result);
            console.log('nftres.vtype', vtype);
            this.setState({ nft_token: res.data.result });
            $('.nftmintedlist_div').hide();
            if (vtype === 'minted') {
              $('.receiptnft_div').show();
            } else if (vtype === 'sent') {
              $('.sentreceiptnft_div').show();
            } else if (vtype === 'accepted') {
              $('.inprocessreceiptnft_div').show();
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status == 'no_record') {
            }
          }
        });
    } else if (type === 'copy') {
      var $self = $(this);
      var id = $self.data('id');
      this.mintingNextStep(2);
      $('#nft_name_minted').val(val.nft_name);
      $('#nft_decription_minted').val(val.nft_description);
      var uptodtype = val.upload_type;
      this.setState({
        nft_file_type: uptodtype,
      });
      //alert($self.data('file_name'));
      $('#nft_file_name_minted').val(val.file_name);
      $('#nft_file_url_minted').val(val.file_url);
      $('#nft_thumb_file_url_minted').val(val.thumbnail_file_url);
      if (uptodtype.length !== 0) {
        if (uptodtype === 'image/gif') {
          $('.chooseupload_nft_minted').val('choosegif');
          $('#uploaded_image_giff_minted').show();
          $('#uploaded_img_src_giff_minted').attr('src', val.file_url);
        } else {
          $('.chooseupload_nft_minted').val('chooseimage');
          $('#uploaded_image_minted').show();
          $('#uploaded_image_minted_src').attr('src', val.file_url);
        }
        $('.chooseupload_nft_minted').trigger('change');
      }
    } else if (type === 'delete') {
      var id = val._id;
      if (typeof val?.sent_to !== 'undefined' && val?.sent_to?.length !== 0) {
        var cid = val.sent_to;
      } else {
        var cid = '';
      }
      var revert_params = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        token_id: id,
        contact_id: cid,
        type: type,
      };
      // console.log('token_list_params', token_list_params);
      axios
        .post(API_CALL_ENDPOINT + '/blockchain/nft/changestatus', revert_params)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            this.closeReceipt();
            toast.dark(res.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          //console.log(res.data.message);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              console.log(error.response.data.error.message);
              this.closeReceipt();
              toast.dark(error.response.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }
        });
    } else if (type === 'revert') {
      var id = val._id;
      if (typeof val?.sent_to !== 'undefined' && val?.sent_to?.length !== 0) {
        var cid = val.sent_to;
      } else {
        var cid = '';
      }
      var revert_params = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        token_id: id,
        contact_id: cid,
        type: type,
      };
      // console.log('token_list_params', token_list_params);
      axios
        .post(API_CALL_ENDPOINT + '/blockchain/nft/changestatus', revert_params)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            this.closeReceipt();
            toast.dark(res.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          //console.log(res.data.message);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              console.log(error.response.data.error.message);
              this.closeReceipt();
              toast.dark(error.response.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }
        });
    }
    console.log('out', val);
    console.log('type', type);
  };

  progressbarCount = () => {
    var numItems = $('.added_class').length;
    return numItems;
  };

  fileGetDetails_cmb_imagesnft = (event) => {
    if (event.target.files.length !== 0) {
      var file_length = event.target.files.length;
      $('.corSticky').show();
      $('.corSticky_container').show();
      $('.chooseimage ').hide();
      $('.upload_div').hide();
      $('.nft_next_btn ').hide();
      $('.nft_next_btn_disabled').show();
      var progrescount = this.progressbarCount();
      if (progrescount == 0) {
        $('#attachement_progress_div').html('');
      }

      var i;
      if (upload_counts.length == 0) {
        $('#attachement_progress_div').html('');
        $('#attachement_progress_div').css({ height: '65px' });
      }
      if (file_length == 1) {
        $('#attachement_progress_div').css({ height: '65px' });
      } else if (file_length == 2) {
        $('#attachement_progress_div').css({ height: '130px' });
      } else if (file_length >= 3) {
        $('#attachement_progress_div').css({ height: '200px' });
      }
      var i;

      var flDc_id = [];
      var flDc_detils = [];
      var flDc_type = [];
      var filename = [];
      var configs = [];
      var filess = event.target.files;
      var idval;
      var FIle_Documentid_cmb = [];

      for (i = 0; i < file_length; i++) {
        console.log('event.target.files[i].type', event.target.files[i].type);
        if (
          event.target.files[i].type !== 'image/png' &&
          event.target.files[i].type !== 'image/x-png' &&
          event.target.files[i].type !== 'image/gif' &&
          event.target.files[i].type !== 'image/jpeg' &&
          event.target.files[i].type !== 'image/pipeg' &&
          event.target.files[i].type !== 'image/tiff' &&
          event.target.files[i].type !== 'image/svg+xml'
        ) {
          toast.dark('Sorry, this file is invalid. Please try using a different file.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          $('.corSticky').hide();
          $('.corSticky_container').hide();
          $('.chooseimage').show();
          $('.upload_div').show();
          $('.nft_next_btn ').show();
          $('.nft_next_btn_disabled').hide();
          return false;
        }

        var filetype = event.target.files[i].type;
        this.setState({ nft_file_type: filetype });
        // console.log("start",upload_count);
        upload_counts.push(upload_count);
        const file_detailsd = new FormData();
        filename.push(event.target.files[i].name);
        var filenametext = event.target.files[i].name;
        var finamecount = 40;
        var filenamefinal = filenametext.slice(0, finamecount) + (filenametext.length > finamecount ? '...' : '');
        if (upload_counts.length == 0) {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">Your attachment is being loaded<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        } else {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">${filenamefinal}<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        }
        file_detailsd.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
        file_detailsd.append('secret', 'R1eqD2twI3E4');
        file_detailsd.append('user_id', this.state.user_id);
        file_detailsd.append('business_id', this.state.business_id);
        file_detailsd.append('file', event.target.files[i]);
        file_detailsd.append('reference', 'text');
        file_detailsd.append('source', 'admin');
        idval = i;
        var configuration = {
          onUploadProgress: myUploadProgress(upload_count),
        };
        if (event.target.files.length != 0) {
          this.colapse_all_attachments();
          console.log('First I value: ' + i);
          var k = 1;
          axios
            .post(API_CALL_ENDPOINT + '/file/upload', file_detailsd, configuration)
            .then((res) => {
              console.log(res);
              console.log(res.data.message);

              if (res.data.status == 'success') {
                $('.nft_img_uploads').val(null);
                $('#uploaded_img_src').attr('src', '');
                $('.corSticky').hide();
                $('.corSticky_container').hide();
                $('.chooseimage').show();
                $('.upload_div').show();
                $('.nft_next_btn ').show();
                $('.nft_next_btn_disabled').hide();
                this.colapse_all_attachments();
                console.log('File_URL :' + res.data?.result?.files[0].file_url);
                console.log('ID_num :' + res.data?.result?.files[0]._id);
                var file_name = res.data?.result?.files[0].display_name;
              }
              if (res?.data?.error?.error_type == 'invalid_file_type') {
                const errors = [];
                errors.push('Sorry, this file is invalid. Please try using a different file.');
              }
              $('#file-input3')[0].value = '';
              $('#uploaded_img_src').attr('src', res.data?.result?.files[0].thumbnail_file_url);
              $('#uploaded_image').show();
              $('#nft_file_name').val(filenametext);
              $('#nft_file_url').val(res.data?.result?.files[0].file_url);
              $('#nft_thumb_file_url').val(res.data?.result?.files[0].thumbnail_file_url);
            })
            .catch((error) => {
              if (error.response) {
                if (error.response?.data?.error?.error_type == 'invalid_file_type') {
                  let filelength = event.target && event.target.files ? event.target.files.length - 1 : 0;

                  toast.dark('Sorry, this file is invalid. Please try using a different file.', {
                    position: 'top-right',
                    transition: Flip,
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
                $('#file-input3')[0].value = '';
              }
            });
        }
        //  upload_count++;
      }
    }
  };

  fileGetDetails_cmb_imagesnftgiff = (event) => {
    if (event.target.files.length !== 0) {
      var file_length = event.target.files.length;
      $('.corSticky').show();
      $('.corSticky_container').show();
      $('.choosegif').hide();
      $('.upload_div').hide();
      $('.nft_next_btn ').hide();
      $('.nft_next_btn_disabled').show();
      var progrescount = this.progressbarCount();
      if (progrescount == 0) {
        $('#attachement_progress_div').html('');
      }

      var i;
      if (upload_counts.length == 0) {
        $('#attachement_progress_div').html('');
        $('#attachement_progress_div').css({ height: '65px' });
      }
      if (file_length == 1) {
        $('#attachement_progress_div').css({ height: '65px' });
      } else if (file_length == 2) {
        $('#attachement_progress_div').css({ height: '130px' });
      } else if (file_length >= 3) {
        $('#attachement_progress_div').css({ height: '200px' });
      }
      var i;

      var flDc_id = [];
      var flDc_detils = [];
      var flDc_type = [];
      var filename = [];
      var configs = [];
      var filess = event.target.files;
      var idval;
      var FIle_Documentid_cmb = [];
      console.log('File Format', filess);
      for (i = 0; i < file_length; i++) {
        if (event.target.files[i].type !== 'image/gif') {
          toast.dark('Sorry, this file is invalid. Please try using a different file.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          $('.corSticky').hide();
          $('.corSticky_container').hide();
          $('.choosegif ').show();
          $('.upload_div').show();
          $('.nft_next_btn ').show();
          $('.nft_next_btn_disabled').hide();
          return false;
        }
        // console.log("start",upload_count);
        upload_counts.push(upload_count);
        var filetype = event.target.files[i].type;
        this.setState({ nft_file_type: filetype });
        const file_detailsd = new FormData();
        filename.push(event.target.files[i].name);
        var filenametext = event.target.files[i].name;
        var finamecount = 40;
        var filenamefinal = filenametext.slice(0, finamecount) + (filenametext.length > finamecount ? '...' : '');
        if (upload_counts.length == 0) {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">Your attachment is being loaded<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        } else {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">${filenamefinal}<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        }
        file_detailsd.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
        file_detailsd.append('secret', 'R1eqD2twI3E4');
        file_detailsd.append('user_id', this.state.user_id);
        file_detailsd.append('business_id', this.state.business_id);
        file_detailsd.append('file', event.target.files[i]);
        file_detailsd.append('reference', 'text');
        file_detailsd.append('source', 'admin');
        idval = i;
        var configuration = {
          onUploadProgress: myUploadProgress(upload_count),
        };
        if (event.target.files.length != 0) {
          this.colapse_all_attachments();
          console.log('First I value: ' + i);
          var k = 1;
          axios
            .post(API_CALL_ENDPOINT + '/file/upload', file_detailsd, configuration)
            .then((res) => {
              console.log(res);
              console.log(res.data.message);

              if (res.data.status == 'success') {
                $('.nft_img_uploads').val(null);
                $('#uploaded_img_src_giff').attr('src', '');
                $('.corSticky').hide();
                $('.corSticky_container').hide();
                $('.choosegif').show();
                $('.upload_div').show();
                $('.nft_next_btn').show();
                $('.nft_next_btn_disabled').hide();
                this.colapse_all_attachments();
                console.log('File_URL :' + res.data?.result?.files[0].file_url);
                console.log('ID_num :' + res.data?.result?.files[0]._id);
                var file_name = res.data?.result?.files[0].display_name;
              }
              if (res?.data?.error?.error_type == 'invalid_file_type') {
                const errors = [];
                errors.push('Sorry, this file is invalid. Please try using a different file.');
              }
              $('#file-input3')[0].value = '';
              $('#uploaded_img_src_giff').attr('src', res.data?.result?.files[0].thumbnail_file_url);
              $('#uploaded_image_giff').show();
              $('#nft_file_name').val(filenametext);
              $('#nft_file_url').val(res.data?.result?.files[0].file_url);
              $('#nft_thumb_file_url').val(res.data?.result?.files[0].thumbnail_file_url);
            })
            .catch((error) => {
              if (error.response) {
                if (error.response?.data?.error?.error_type == 'invalid_file_type') {
                  let filelength = event.target && event.target.files ? event.target.files.length - 1 : 0;

                  toast.dark('Sorry, this file is invalid. Please try using a different file.', {
                    position: 'top-right',
                    transition: Flip,
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
                $('#file-input3')[0].value = '';
              }
            });
        }
        //  upload_count++;
      }
    }
  };

  fileGetDetails_cmb_imagesnft_mint = (event) => {
    if (event.target.files.length !== 0) {
      var file_length = event.target.files.length;
      $('.corSticky').show();
      $('.corSticky_container').show();
      $('.chooseimage').hide();
      $('.upload_div').hide();
      $('.nft_next_btn ').hide();
      $('.nft_next_btn_disabled').show();
      var progrescount = this.progressbarCount();
      if (progrescount == 0) {
        $('#attachement_progress_div').html('');
      }

      var i;
      if (upload_counts.length == 0) {
        $('#attachement_progress_div').html('');
        $('#attachement_progress_div').css({ height: '65px' });
      }
      if (file_length == 1) {
        $('#attachement_progress_div').css({ height: '65px' });
      } else if (file_length == 2) {
        $('#attachement_progress_div').css({ height: '130px' });
      } else if (file_length >= 3) {
        $('#attachement_progress_div').css({ height: '200px' });
      }
      var i;

      var flDc_id = [];
      var flDc_detils = [];
      var flDc_type = [];
      var filename = [];
      var configs = [];
      var filess = event.target.files;
      var idval;
      var FIle_Documentid_cmb = [];

      for (i = 0; i < file_length; i++) {
        console.log('event.target.files[i].type', event.target.files[i].type);
        if (
          event.target.files[i].type !== 'image/png' &&
          event.target.files[i].type !== 'image/x-png' &&
          event.target.files[i].type !== 'image/gif' &&
          event.target.files[i].type !== 'image/jpeg' &&
          event.target.files[i].type !== 'image/pipeg' &&
          event.target.files[i].type !== 'image/tiff' &&
          event.target.files[i].type !== 'image/svg+xml'
        ) {
          toast.dark('Sorry, this file is invalid. Please try using a different file.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          $('.corSticky').hide();
          $('.corSticky_container').hide();
          $('.chooseimage').show();
          $('.upload_div').show();
          $('.nft_next_btn ').show();
          $('.nft_next_btn_disabled').hide();
          return false;
        }
        var filetype = event.target.files[i].type;
        this.setState({ nft_file_type: filetype });
        // console.log("start",upload_count);
        upload_counts.push(upload_count);
        const file_detailsd = new FormData();
        filename.push(event.target.files[i].name);
        var filenametext = event.target.files[i].name;
        var finamecount = 40;
        var filenamefinal = filenametext.slice(0, finamecount) + (filenametext.length > finamecount ? '...' : '');
        if (upload_counts.length == 0) {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">Your attachment is being loaded<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        } else {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">${filenamefinal}<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        }
        file_detailsd.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
        file_detailsd.append('secret', 'R1eqD2twI3E4');
        file_detailsd.append('user_id', this.state.user_id);
        file_detailsd.append('business_id', this.state.business_id);
        file_detailsd.append('file', event.target.files[i]);
        file_detailsd.append('reference', 'text');
        file_detailsd.append('source', 'admin');
        idval = i;
        var configuration = {
          onUploadProgress: myUploadProgress(upload_count),
        };
        if (event.target.files.length != 0) {
          this.colapse_all_attachments();
          console.log('First I value: ' + i);
          var k = 1;
          axios
            .post(API_CALL_ENDPOINT + '/file/upload', file_detailsd, configuration)
            .then((res) => {
              console.log(res);
              console.log(res.data.message);

              if (res.data.status == 'success') {
                $('.nft_img_uploads').val(null);
                $('#uploaded_image_minted_src').attr('src', '');
                $('.corSticky').hide();
                $('.corSticky_container').hide();
                $('.chooseimage').show();
                $('.upload_div').show();
                $('.nft_next_btn ').show();
                $('.nft_next_btn_disabled').hide();
                this.colapse_all_attachments();
                console.log('File_URL :' + res.data?.result?.files[0].file_url);
                console.log('ID_num :' + res.data?.result?.files[0]._id);
                var file_name = res.data?.result?.files[0].display_name;
              }
              if (res?.data?.error?.error_type == 'invalid_file_type') {
                const errors = [];
                errors.push('Sorry, this file is invalid. Please try using a different file.');
              }
              $('#file-input3')[0].value = '';
              $('#uploaded_image_minted_src').attr('src', res.data?.result?.files[0].thumbnail_file_url);
              $('#uploaded_image_minted').show();
              $('#nft_file_name_minted').val(filenametext);
              $('#nft_file_url_minted').val(res.data?.result?.files[0].file_url);
              $('#nft_thumb_file_url_minted').val(res.data?.result?.files[0].thumbnail_file_url);
            })
            .catch((error) => {
              if (error.response) {
                if (error.response?.data?.error?.error_type == 'invalid_file_type') {
                  let filelength = event.target && event.target.files ? event.target.files.length - 1 : 0;

                  toast.dark('Sorry, this file is invalid. Please try using a different file.', {
                    position: 'top-right',
                    transition: Flip,
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
                $('#file-input3')[0].value = '';
              }
            });
        }
        //  upload_count++;
      }
    }
  };

  fileGetDetails_cmb_imagesnftgiff_mint = (event) => {
    if (event.target.files.length !== 0) {
      var file_length = event.target.files.length;
      $('.corSticky').show();
      $('.corSticky_container').show();
      $('.choosegif ').hide();
      $('.upload_div').hide();
      $('.nft_next_btn ').hide();
      $('.nft_next_btn_disabled').show();
      var progrescount = this.progressbarCount();
      if (progrescount == 0) {
        $('#attachement_progress_div').html('');
      }

      var i;
      if (upload_counts.length == 0) {
        $('#attachement_progress_div').html('');
        $('#attachement_progress_div').css({ height: '65px' });
      }
      if (file_length == 1) {
        $('#attachement_progress_div').css({ height: '65px' });
      } else if (file_length == 2) {
        $('#attachement_progress_div').css({ height: '130px' });
      } else if (file_length >= 3) {
        $('#attachement_progress_div').css({ height: '200px' });
      }
      var i;

      var flDc_id = [];
      var flDc_detils = [];
      var flDc_type = [];
      var filename = [];
      var configs = [];
      var filess = event.target.files;
      var idval;
      var FIle_Documentid_cmb = [];
      console.log('File Format', filess);
      for (i = 0; i < file_length; i++) {
        if (event.target.files[i].type !== 'image/gif') {
          toast.dark('Sorry, this file is invalid. Please try using a different file.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          $('.corSticky').hide();
          $('.corSticky_container').hide();
          $('.choosegif').show();
          $('.upload_div').show();
          $('.nft_next_btn ').show();
          $('.nft_next_btn_disabled').hide();
          return false;
        }
        // console.log("start",upload_count);
        upload_counts.push(upload_count);
        var filetype = event.target.files[i].type;
        this.setState({ nft_file_type: filetype });
        const file_detailsd = new FormData();
        filename.push(event.target.files[i].name);
        var filenametext = event.target.files[i].name;
        var finamecount = 40;
        var filenamefinal = filenametext.slice(0, finamecount) + (filenametext.length > finamecount ? '...' : '');
        if (upload_counts.length == 0) {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">Your attachment is being loaded<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        } else {
          $('#attachement_progress_div').html(
            `<div class="added_class alert alert-light alert_hide completed_cls` +
            upload_count +
            `" role="alert">${filenamefinal}<div class="progress whole_progres` +
            upload_count +
            `"><div class="progress-bar progress_bar_color_cls progres_cnt` +
            upload_count +
            `" role="progressbar" style="width: 0%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></div>`,
          );
        }
        file_detailsd.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
        file_detailsd.append('secret', 'R1eqD2twI3E4');
        file_detailsd.append('user_id', this.state.user_id);
        file_detailsd.append('business_id', this.state.business_id);
        file_detailsd.append('file', event.target.files[i]);
        file_detailsd.append('reference', 'text');
        file_detailsd.append('source', 'admin');
        idval = i;
        var configuration = {
          onUploadProgress: myUploadProgress(upload_count),
        };
        if (event.target.files.length != 0) {
          this.colapse_all_attachments();
          console.log('First I value: ' + i);
          var k = 1;
          axios
            .post(API_CALL_ENDPOINT + '/file/upload', file_detailsd, configuration)
            .then((res) => {
              console.log(res);
              console.log(res.data.message);

              if (res.data.status == 'success') {
                $('.nft_img_uploads').val(null);
                $('#uploaded_img_src_giff_minted').attr('src', '');
                $('.corSticky').hide();
                $('.corSticky_container').hide();
                $('.choosegif').show();
                $('.upload_div').show();
                $('.nft_next_btn ').show();
                $('.nft_next_btn_disabled').hide();
                this.colapse_all_attachments();
                console.log('File_URL :' + res.data?.result?.files[0].file_url);
                console.log('ID_num :' + res.data?.result?.files[0]._id);
                var file_name = res.data?.result?.files[0].display_name;
              }
              if (res?.data?.error?.error_type == 'invalid_file_type') {
                const errors = [];
                errors.push('Sorry, this file is invalid. Please try using a different file.');
              }
              $('#file-input3')[0].value = '';
              $('#uploaded_image_giff_minted').show();
              $('#uploaded_img_src_giff_minted').attr('src', res.data?.result?.files[0].thumbnail_file_url);
              $('#nft_file_name_minted').val(filenametext);
              $('#nft_file_url_minted').val(res.data?.result?.files[0].file_url);
              $('#nft_thumb_file_url_minted').val(res.data?.result?.files[0].thumbnail_file_url);
            })
            .catch((error) => {
              if (error.response) {
                if (error.response?.data?.error?.error_type == 'invalid_file_type') {
                  let filelength = event.target && event.target.files ? event.target.files.length - 1 : 0;

                  toast.dark('Sorry, this file is invalid. Please try using a different file.', {
                    position: 'top-right',
                    transition: Flip,
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
                $('#file-input3')[0].value = '';
              }
            });
        }
        //  upload_count++;
      }
    }
  };
  contractRequest = () => {
    var nft_token_name = $('#nft_token_name').val();
    var nft_token_symbol = $('#nft_token_symbol').val();
    var token_limits = $('#token_limits').val();
    var continue_vals = '1';
    var keyarr = [];
    if (nft_token_name.length == 0) {
      toast.dark('Please enter the Token Name.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    if (nft_token_symbol.length == 0) {
      toast.dark('Please enter the Token Symbol.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    var that = this;
    $('.key_vals')
      .each(function (index) {
        console.log($('#keyrequired' + $(this).data('id') + '').is(':checked'));
        if ($(this).val().length == 0 && $(this).data('id') !== 0) {
          continue_vals = '0';
          $(this).focus();
          toast.dark('Please enter the key value.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return false;
        } else {
          if ($(this).val().length != 0) {
            var keyvalues = { key: $(this).val(), required: $('#keyrequired' + $(this).data('id') + '').is(':checked') };
            keyarr.push(keyvalues);
          }

        }
      })
      .promise()
      .done(function () {
        if (continue_vals == '1') {
          var keyvals = JSON.stringify(keyarr);

          console.log('arrayvalue', keyvals);
          var contractreq_params = {
            apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
            secret: 'R1eqD2twI3E4',
            user_id: that.state.user_id,
            business_id: that.state.business_id,
            setup: 'nft',
            token_name: nft_token_name,
            token_symbol: nft_token_symbol,
            token_limit: token_limits,
            // token_key: keyvals,
          };
          if (keyarr.length !== 0) {
            contractreq_params['token_key'] = keyvals;
          }
          axios
            .post(API_CALL_ENDPOINT + '/business/profile/settings', contractreq_params)
            .then((res) => {
              $('#nft_token_name').val('');
              $('#nft_token_symbol').val('');
              $('#token_limits').val('');
              console.log(res);
              that.nftDetails();
              $('.nftrequest_btn').show();
              $('.btn_confirmation').hide();
              $('.nftrequest_confirm_btn').hide();
              //console.log(res.data.message);
            })
            .catch((error) => { });
        }
      });
  };

  handleBlur() {
    $('#voiceGenerate_loding').show();
    $('#id_generateVoiceplay').hide();

    var voiceType_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      language: this.state.VoiceLngRegn,
      voice: this.state.VoiceClksId,
      voice_message: this.state.TxtVoiceGrtngvlue,
    };

    console.log(voiceType_Details);
    axios.post(API_CALL_ENDPOINT + '/voice/generate', voiceType_Details).then((res) => {
      console.log(res);
      console.log(res.data.message);

      if (res.data.status == 'success') {
        $('#voiceGenerate_loding').hide();
        $('#id_generateVoiceplay').show();
        console.log(res.data.result.file);
        this.setState({
          TxtTypeVoiceUrl: res.data.result.file,
          generatePlayDisble: false,
        });
      }
    });
  }
  LngRgnOnChg = (event) => {
    console.log(event.target.value);
    this.setState({
      VoiceLngRegn: event.target.value,
      TxtTypeVoiceUrl: '',
      generatePlayDisble: true,
    });

    if (this.state.getVoiceTypeMlrFml != '') {
      $(this.state.getVoiceTypeMlrFml ? '.' + this.state.getVoiceTypeMlrFml : undefined).prop('checked', false);
    }

    for (var i in this.state.GrntVoiveLngRegin) {
      if (this.state.GrntVoiveLngRegin[i]._id == event.target.value) {
        console.log(this.state.GrntVoiveLngRegin[i].voice_list);
        this.setState({ VoceLstBsOnLanguge: this.state.GrntVoiveLngRegin[i].voice_list });
      }
    }
  };

  VoiceTypeClick = (event) => {
    console.log(event.target.value);
    console.log(event.target.id);
    this.setState({ VoiceClksId: event.target.id });

    if (this.state.TxtVoiceGrtngvlue == '') {
      $('#' + event.target.id).prop('checked', false);
      this.setState(() => ({
        ViceGrtMsg: 'Type text is required',
        ViceGrtcls: 'alert alert-danger',
      }));

      setTimeout(() => {
        this.setState(() => ({
          ViceGrtMsg: '',
          ViceGrtcls: '',
        }));
      }, 5000);
    } else {
      $('#voiceGenerate_loding').show();
      $('#id_generateVoiceplay').hide();
      this.setState({
        getVoiceTypeMlrFml: event.target.value,
        voiceGnrteResetdisble: false,
      });
      var voiceType_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        language: this.state.VoiceLngRegn,
        voice: event.target.value,
        voice_message: this.state.TxtVoiceGrtngvlue,
      };

      console.log(voiceType_Details);
      axios.post(API_CALL_ENDPOINT + '/voice/generate', voiceType_Details).then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          $('#voiceGenerate_loding').hide();
          $('#id_generateVoiceplay').show();
          console.log(res.data.result.file);
          this.setState({
            TxtTypeVoiceUrl: res.data.result.file,
            generatePlayDisble: false,
          });
        }
      });
    }
  };

  generateVoice_play = () => {
    $('#id_generateVoiceplay').hide();
    $('#id_generateVoicepause').show();
    var playx = document.getElementById('generateVoiceUrl');
    playx.play();
    playx.onended = function () {
      $('#id_generateVoicepause').hide();
      $('#id_generateVoiceplay').show();
    };
  };

  generateVoice_pause = (e) => {
    var pausex = document.getElementById('generateVoiceUrl');
    pausex.pause();
    $('#id_generateVoicepause').hide();
    $('#id_generateVoiceplay').show();
  };

  upgradeWorkspace = (url) => {
    window.location.href = url;
  }

  ResetVoiceGenClk = () => {
    this.setState({
      TxtVoiceGrtngvlue: '',
      voiceGnrteResetdisble: true,
      VoiceLngRegn: 'en-US',
    });

    $(this.state.VoiceClksId ? '.' + this.state.VoiceClksId : '.Justin').prop('checked', false);

    for (var i in this.state.GrntVoiveLngRegin) {
      if (this.state.GrntVoiveLngRegin[i]._id == 'en-US') {
        console.log(this.state.GrntVoiveLngRegin[i].voice_list);
        this.setState({ VoceLstBsOnLanguge: this.state.GrntVoiveLngRegin[i].voice_list });
      }
    }

    var VoiceGrtng_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      voice_greetings_status: 'off',
      setup: 'voice_greetings',
      voice_greetings_type: 'record',
    };

    console.log(VoiceGrtng_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState(() => ({
            ViceGrtMsg: 'R-Bot Voice Greetings Reset Successfully',
            ViceGrtcls: 'alert alert-success',
          }));
          setTimeout(() => {
            this.setState(() => ({
              ViceGrtMsg: '',
              ViceGrtcls: '',
            }));

            $('#TxtVoiceGrtngvlue_id').val();
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            ViceGrtMsg: res.data.error.message,
            ViceGrtcls: 'alert alert-danger',
          }));
          setTimeout(() => {
            this.setState(() => ({
              ViceGrtMsg: '',
              ViceGrtcls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              ViceGrtMsg: error.response.data.error.message,
              ViceGrtcls: 'alert alert-danger',
            }));
            setTimeout(() => {
              this.setState(() => ({
                ViceGrtMsg: '',
                ViceGrtcls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  voiceGnrteTextSave = () => {
    if (this.state.TxtVoiceGrtngvlue == '') {
      this.setState(() => ({
        ViceGrtMsg: 'R-Bot Voice greetings for Inbound Calls message cannot be blank.',
        ViceGrtcls: 'alert alert-danger',
      }));

      setTimeout(() => {
        this.setState(() => ({
          ViceGrtMsg: '',
          ViceGrtcls: '',
        }));
      }, 5000);
    } else if (this.state.TxtTypeVoiceUrl == '') {
      this.setState(() => ({
        ViceGrtMsg: 'Please Choose R-Bot Voice Type',
        ViceGrtcls: 'alert alert-danger',
      }));

      setTimeout(() => {
        this.setState(() => ({
          ViceGrtMsg: '',
          ViceGrtcls: '',
        }));
      }, 5000);
    } else {
      $('#voiceGnrteTextSv_id').html('Saving...');
      $('#voiceGnrteTextSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2 isdisabled');
      var VoiceGrtng_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        setup: 'voice_greetings',
        voice_greetings_status: 'on',
        voice_greetings_type: 'text',
        language_region: this.state.VoiceLngRegn,
        voice: this.state.getVoiceTypeMlrFml,
        voice_greetings_text: this.state.TxtVoiceGrtngvlue,
        greeting_url: this.state.TxtTypeVoiceUrl,
      };

      console.log(VoiceGrtng_Details);
      axios
        .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            this.setState(() => ({
              ViceGrtMsg: res.data.message,
              ViceGrtcls: 'alert alert-success',
              VoiceGrtngTxtTypDeltDisble: false,
            }));

            setTimeout(() => {
              this.setState(() => ({
                ViceGrtMsg: '',
                ViceGrtcls: '',
              }));
              $('#voiceGnrteTextSv_id').html('Save');
              $('#voiceGnrteTextSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
              $('#audioPlayVoiceGrtng').hide();
              $('#audioStrtVoiceGrtng').show();
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              ViceGrtMsg: res.data.error.message,
              ViceGrtcls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                ViceGrtMsg: '',
                ViceGrtcls: '',
              }));
              $('#voiceGnrteTextSv_id').html('Save');
              $('#voiceGnrteTextSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                ViceGrtMsg: error.response.data.error.message,
                ViceGrtcls: 'alert alert-danger',
              }));

              setTimeout(() => {
                this.setState(() => ({
                  ViceGrtMsg: '',
                  ViceGrtcls: '',
                }));
                $('#voiceGnrteTextSv_id').html('Save');
                $('#voiceGnrteTextSv_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
              }, 5000);
            }
          }
        });
    }
  };

  voiceGnrteTextDelete = () => {
    this.setState({
      TxtVoiceGrtngvlue: '',
      voiceGnrteResetdisble: true,
      VoiceLngRegn: 'en-US',
    });

    $(this.state.VoiceClksId ? '.' + this.state.VoiceClksId : '.Justin').prop('checked', false);

    for (var i in this.state.GrntVoiveLngRegin) {
      if (this.state.GrntVoiveLngRegin[i]._id == 'en-US') {
        console.log(this.state.GrntVoiveLngRegin[i].voice_list);
        this.setState({ VoceLstBsOnLanguge: this.state.GrntVoiveLngRegin[i].voice_list });
      }
    }

    var VoiceGrtng_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      voice_greetings_status: 'off',
      setup: 'voice_greetings',
      voice_greetings_type: 'record',
    };

    console.log(VoiceGrtng_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState(() => ({
            ViceGrtMsg: 'R-Bot Voice Greetings Delete Successfully',
            ViceGrtcls: 'alert alert-success',
            VoiceGrtngTxtTypDeltDisble: true,
          }));

          setTimeout(() => {
            this.setState(() => ({
              ViceGrtMsg: '',
              ViceGrtcls: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            ViceGrtMsg: res.data.error.message,
            ViceGrtcls: 'alert alert-danger',
          }));
          setTimeout(() => {
            this.setState(() => ({
              ViceGrtMsg: '',
              ViceGrtcls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              ViceGrtMsg: error.response.data.error.message,
              ViceGrtcls: 'alert alert-danger',
            }));
            setTimeout(() => {
              this.setState(() => ({
                ViceGrtMsg: '',
                ViceGrtcls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  AtoVoicLeaveMSgonChng = (event) => {
    console.log(event.target.value);
    this.setState({ LeavAutoVceMsgVle: event.target.value });
  };

  AtoVoicLeaveMSgMxmRspnsOnChang = (event) => {
    console.log(event.target.value);
    var value = event.target.value.replace(/^0+/, '');
    this.setState({ LeavAutoVoiceMxmRspnsVlu: value });
  };

  AtoVcRspnsSaveClick = () => {
    var regex = /^[0-9]+$/;
    var ValidNum = regex.test(this.state.LeavAutoVoiceMxmRspnsVlu);

    if (this.state.LeavAutoVceMsgVle == '') {
      this.setState(() => ({
        AtoViceResMsg: 'R-Bot response message cannot be blank.',
        AtoViceRescls: 'alert alert-danger',
      }));

      setTimeout(() => {
        this.setState(() => ({
          AtoViceResMsg: '',
          AtoViceRescls: '',
        }));
      }, 5000);
    }
    // else if(this.state.LeavAutoVoiceMxmRspnsVlu == ""){

    // 	this.setState(() => ({
    // 		AtoViceResMsg:'Please Enter Max No.of Response',
    // 		AtoViceRescls:'alert alert-danger',
    // 	}));

    // 	setTimeout(() => {
    // 		this.setState(() => ({
    // 			AtoViceResMsg:'',
    // 			AtoViceRescls:'',
    // 		}));

    // 	}, 2500);

    // }else if(!ValidNum){

    // 	this.setState(() => ({
    // 		AtoViceResMsg:'Max No. of Response allow only number',
    // 		AtoViceRescls:'alert alert-danger',
    // 	}));

    // 	setTimeout(() => {
    // 		this.setState(() => ({
    // 			AtoViceResMsg:'',
    // 			AtoViceRescls:'',
    // 		}));

    // 	}, 2500);

    // }
    else if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
      toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      $('#AtoVcRspnsSave_id').html('Saving...');
      $('#AtoVcRspnsSave_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2 isdisabled');

      var VoiceGrtng_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        auto_voice: 'on',
        setup: 'auto_voice',
        auto_voice_type: 'leave_message',
        text_response: this.state.LeavAutoVceMsgVle,
        unique_id: this.state.atcharryDet_cmb.length != 0 ? Rnunique_id_cmb : '',
        maximum_response: this.state.LeavAutoVoiceMxmRspnsVlu,
      };

      console.log(VoiceGrtng_Details);
      axios
        .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            this.setState(() => ({
              LeavAutoVceMsgVle_unique_id: Rnunique_id_cmb,
              AtoViceResMsg: res.data.message,
              AtoViceRescls: 'alert alert-success',
              leaveMsgDelDisble: false,
              HangMsgValue: '',
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoViceResMsg: '',
                AtoViceRescls: '',
              }));
              $('#AtoVcRspnsSave_id').html('Save');
              $('#AtoVcRspnsSave_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              AtoViceResMsg: res.data.error.message,
              AtoViceRescls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoViceResMsg: '',
                AtoViceRescls: '',
              }));
              $('#AtoVcRspnsSave_id').html('Save');
              $('#AtoVcRspnsSave_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                AtoViceResMsg: error.response.data.error.message,
                AtoViceRescls: 'alert alert-danger',
              }));

              setTimeout(() => {
                this.setState(() => ({
                  AtoViceResMsg: '',
                  AtoViceRescls: '',
                }));
                $('#AtoVcRspnsSave_id').html('Save');
                $('#AtoVcRspnsSave_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
              }, 5000);
            }
          }
        });
    }
  };

  atoVcRspnLevMsgDelClk = () => {
    var VoiceGrtng_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      auto_voice: 'off',
      setup: 'auto_voice',
      auto_voice_type: 'leave_message',
    };

    console.log(VoiceGrtng_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState({ atcharryDet_cmb: [] });
          // if (this.state.atcharryDet_cmb.length == 0) {
          $('.attchLstShow_cmb').hide();
          // }
          this.setState(() => ({
            AtoViceResMsg: res.data.message,
            AtoViceRescls: 'alert alert-success',
            leaveMsgDelDisble: true,
            LeavAutoVceMsgVle: '',
            LeavAutoVceMsgVle_unique_id: '',
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
              LeavAutoVceMsgVle: '',
              LeavAutoVceMsgVle_unique_id: '',
              LeavAutoVoiceMxmRspnsVlu: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            AtoViceResMsg: res.data.error.message,
            AtoViceRescls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              AtoViceResMsg: error.response.data.error.message,
              AtoViceRescls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoViceResMsg: '',
                AtoViceRescls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  hangmsgOnChang = (event) => {
    console.log(event.target.value);
    var value = event.target.value.replace(/^0+/, '');
    this.setState({ HangMsgValue: value });
  };

  SaveHngMsgwithout = () => {
    var regex = /^[0-9]+$/;
    var ValidNum = regex.test(this.state.HangMsgValue);

    // if(this.state.HangMsgValue == ""){

    // 	this.setState(() => ({
    // 		AtoViceResMsg:'Please enter the leave message',
    // 		AtoViceRescls:'alert alert-danger',
    // 	}));

    // 	setTimeout(() => {
    // 		this.setState(() => ({
    // 			AtoViceResMsg:'',
    // 			AtoViceRescls:'',
    // 		}));

    // 	}, 2500);

    // }
    // else if(!ValidNum){

    // 	this.setState(() => ({
    // 		AtoViceResMsg:'Max No. of Response allow only number',
    // 		AtoViceRescls:'alert alert-danger',
    // 	}));

    // 	setTimeout(() => {
    // 		this.setState(() => ({
    // 			AtoViceResMsg:'',
    // 			AtoViceRescls:'',
    // 		}));

    // 	}, 2500);

    // }else{

    $('#SaveHngMsgwithout_id').html('Saving...');
    $('#SaveHngMsgwithout_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2 isdisabled');

    var VoiceGrtng_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      auto_voice: 'on',
      setup: 'auto_voice',
      auto_voice_type: 'hangup_message',
      maximum_response: this.state.HangMsgValue,
    };

    console.log(VoiceGrtng_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState(() => ({
            AtoViceResMsg: res.data.message,
            AtoViceRescls: 'alert alert-success',
            hangupMsgDelDisble: false,
            LeavAutoVceMsgVle: '',
            LeavAutoVceMsgVle_unique_id: '',
            LeavAutoVoiceMxmRspnsVlu: '',
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
            }));
            $('#SaveHngMsgwithout_id').html('Save');
            $('#SaveHngMsgwithout_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            AtoViceResMsg: res.data.error.message,
            AtoViceRescls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
            }));
            $('#SaveHngMsgwithout_id').html('Save');
            $('#SaveHngMsgwithout_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              AtoViceResMsg: error.response.data.error.message,
              AtoViceRescls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoViceResMsg: '',
                AtoViceRescls: '',
              }));
              $('#SaveHngMsgwithout_id').html('Save');
              $('#SaveHngMsgwithout_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }
        }
      });

    // }
  };

  DelHngMsgwithout = () => {
    var VoiceGrtng_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      auto_voice: 'off',
      setup: 'auto_voice',
      auto_voice_type: 'hangup_message',
    };

    console.log(VoiceGrtng_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', VoiceGrtng_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState(() => ({
            AtoViceResMsg: res.data.message,
            AtoViceRescls: 'alert alert-success',
            HangMsgValue: '',
            hangupMsgDelDisble: true,
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            AtoViceResMsg: res.data.error.message,
            AtoViceRescls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              AtoViceResMsg: error.response.data.error.message,
              AtoViceRescls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoViceResMsg: '',
                AtoViceRescls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  birthdyTxtOnChg = (event) => {
    console.log(event.target.value);
    this.setState({ birthdyTxtValue: event.target.value });
  };

  bithGrtngTimeOnchng = (event) => {
    this.setState({
      bithGrtngTime: event.target.value,
    });
  };
  ist2utc = (t) => {
    let d = new Date(t);
    console.log('d', d.getHours(), d.getMinutes());
    let timezone = this.state.bithGrtngTimeZone.substring(3);
    let addsubtoutc = timezone.substring(0, 1);
    let hrstoutc = timezone.substring(1, 3);
    let mintoutc = timezone.substring(3, 5);
    console.log('addsubtoutc', addsubtoutc);
    console.log('hrstoutc', hrstoutc);
    console.log('mintoutc', mintoutc);
    var x = addsubtoutc == '+' ? d.getHours() - parseInt(hrstoutc) : d.getHours() + parseInt(hrstoutc);
    console.log('x', x);
    var y = addsubtoutc == '+' ? d.getMinutes() - parseInt(mintoutc) : d.getMinutes() + parseInt(mintoutc);
    console.log('y', y);
    d.setHours(x);
    d.setMinutes(y);
    return d;
  };

  bithGrtngTimeZoneOnchng = (event) => {
    console.log(event.target.value);
    this.setState({ bithGrtngTimeZone: event.target.value });
  };

  saveBrthgrtng = () => {
    if (this.state.birthdyTxtValue == '') {
      this.setState(() => ({
        brtGrtMsg: 'R-Bot Birthday greetings text message cannot be blank.',
        brtGrtcls: 'alert alert-danger',
      }));

      setTimeout(() => {
        this.setState(() => ({
          brtGrtMsg: '',
          brtGrtcls: '',
        }));
      }, 5000);
    } else if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
      toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      $('#saveBrthgrtng_id').html('Saving...');
      $('#saveBrthgrtng_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2 isdisabled');
      var utcStart = new Date('1/15/2007 ' + this.state.bithGrtngTime);
      console.log('istStart', utcStart);
      let x = this.ist2utc(utcStart);

      var brthday_Details = {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        birthday_status: 'on',
        setup: 'birthday',
        birthday_time_utc: moment(x).format('h:mm A'),
        birthday_time_local: this.state.bithGrtngTime,
        birthday_offset: this.state.bithGrtngTimeZone,
        birthday_text: this.state.birthdyTxtValue,
        unique_id: this.state.atcharryDet_cmb.length != 0 ? Rnunique_id_cmb : '',
      };
      //       console.log(brthday_Details);
      // return;
      console.log(brthday_Details);
      axios
        .post(API_CALL_ENDPOINT + '/business/profile/settings', brthday_Details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            this.setState(() => ({
              birthdyTxtValue_unique_id: Rnunique_id_cmb,
              brtGrtMsg: res.data.message,
              brtGrtcls: 'alert alert-success',
              brthdyGrtngDelDisble: false,
            }));

            setTimeout(() => {
              this.setState(() => ({
                brtGrtMsg: '',
                brtGrtcls: '',
              }));
              $('#saveBrthgrtng_id').html('Save');
              $('#saveBrthgrtng_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }

          if (res.data.error) {
            this.setState(() => ({
              brtGrtMsg: res.data.error.message,
              brtGrtcls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                brtGrtMsg: '',
                brtGrtcls: '',
              }));

              $('#saveBrthgrtng_id').html('Save');
              $('#saveBrthgrtng_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                brtGrtMsg: error.response.data.error.message,
                brtGrtcls: 'alert alert-danger',
              }));

              setTimeout(() => {
                this.setState(() => ({
                  brtGrtMsg: '',
                  brtGrtcls: '',
                }));

                $('#saveBrthgrtng_id').html('Save');
                $('#saveBrthgrtng_id').attr('class', 'btn btn-black crsr_pntr btnpdng_sm mr-2');
              }, 5000);
            }
          }
        });
    }
  };

  DeltBrthgrtng = () => {
    var brthday_Details = {
      apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
      secret: 'R1eqD2twI3E4',
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      birthday_status: 'off',
      setup: 'birthday',
    };

    console.log(brthday_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', brthday_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState({ atcharryDet_cmb: [] });
          // if (this.state.atcharryDet_cmb.length == 0) {
          $('.attchLstShow_cmb').hide();
          // }
          this.setState(() => ({
            brtGrtMsg: 'R-Bot Birthday greetings successfully deleted',
            brtGrtcls: 'alert alert-success',
            birthdyTxtValue: '',
            bithGrtngTime: '12:00 AM',
            bithGrtngTimeZone: 'GMT-1200',
            brthdyGrtngDelDisble: true,
          }));

          setTimeout(() => {
            this.setState(() => ({
              brtGrtMsg: '',
              brtGrtcls: '',
            }));
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            brtGrtMsg: res.data.error.message,
            brtGrtcls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              brtGrtMsg: '',
              brtGrtcls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              brtGrtMsg: error.response.data.error.message,
              brtGrtcls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                brtGrtMsg: '',
                brtGrtcls: '',
              }));
            }, 5000);
          }
        }
      });
  };

  business_update = () => {
    var business_update_Details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      setup: 'info',
      business_name: this.state.business_info_name,
      business_description: this.state.business_info_details,
    };

    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', business_update_Details)
      .then((res) => {
        if (res.data.status == 'success') {
          this.setState(() => ({
            AtoViceResMsg: res.data.message,
            AtoViceRescls: 'alert alert-success',
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
            }));
            window.location.reload(true);
          }, 5000);
        }

        if (res.data.error) {
          this.setState(() => ({
            AtoViceResMsg: res.data.error.message,
            AtoViceRescls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              AtoViceResMsg: '',
              AtoViceRescls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              AtoViceResMsg: error.response.data.error.message,
              AtoViceRescls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                AtoViceResMsg: '',
                AtoViceRescls: '',
              }));
            }, 5000);
          }
        }
      });
  };
  disconnectslack = () => {
    const Slack_integrate = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state?.user_id,
      business_id: this.state?.business_id,
      setup: 'slack',
      slack: '',
    };
    console.log('Slack_integrate', Slack_integrate);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', Slack_integrate)
      .then((res1) => {
        const business_details = {
          params: {
            apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
            secret: 'R1eqD2twI3E4',
            user_id: this.state.user_id,
            business_id: this.state.business_id,
          },
        };
        console.log(business_details);
        axios
          .get(API_CALL_ENDPOINT + '/business/info', business_details)
          .then((res) => {
            console.log('/business/info', res.data);
            if (res.data.result) {
              this.setState({ business_info_array: res.data?.result });
            }
          })
          .catch((errr) => {
            console.log('ERROR', errr);
          });
      })
      .catch((err) => {
        console.log('ERROR', err);
      });
  };

  getBusinessDetails = (e) => {
    const business_details = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };
    console.log(business_details);
    axios
      .get(API_CALL_ENDPOINT + '/business/info', business_details)
      .then((res) => {
        console.log('/business/info', res.data);
        if (res.data.result) {
          this.setState({ business_info_array: res.data?.result });
        }
      })
      .catch((errr) => {
        console.log('ERROR', errr);
      });
  };

  onFileChangeHandler = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => this.setState({ src: reader.result }));
      reader.readAsDataURL(e.target.files[0]);
    }

    $('.popup_new').attr('style', 'display');

    e.preventDefault();
    this.setState({
      selectedFile: e.target.files[0],
    });
    const data = new FormData();

    data.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
    data.append('secret', 'R1eqD2twI3E4');
    data.append('user_id', this.state.user_id);
    data.append('business_id', this.state.business_id);
    data.append('file', e.target.files[0]);

    console.log('Form:' + data);
    console.log('File Values : ', data);
    console.log('file : ', e.target.files[0]);
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg');
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );

    const reader = new FileReader();
    canvas.toBlob((blob) => {
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        this.dataURLtoFile(reader.result, 'cropped.jpg');
      };
    });
  }

  dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let croppedImage = new File([u8arr], filename, { type: mime });
    this.setState({ croppedImage: croppedImage });
  }

  togglePopup = () => {
    $('.popup_new').attr('style', 'display');
  };

  save_imageCrop = () => {
    $('.popup_new').attr('style', 'display:none');

    console.log(this.state.croppedImage);

    const data = new FormData();

    data.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
    data.append('secret', 'R1eqD2twI3E4');
    data.append('user_id', this.state.user_id);
    data.append('business_id', this.state.business_id);
    data.append('file', this.state.croppedImage);

    console.log('Form:' + data);
    console.log('File Values : ', data);
    console.log(this.state.business_id);
    axios.post(API_CALL_ENDPOINT + '/file/upload', data).then((res) => {
      console.log(res);

      var file_url = '';

      if (res.data.status == 'success') {
        for (var i in res.data.result.files) {
          console.log(res.data.result.files[i].file_url);
          file_url += res.data.result.files[i].file_url;
        }

        console.log(file_url);
        this.setState({
          prfImag: file_url,
        });

        const business_upDetails = {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          setup: 'profile',
          profile_image: file_url,
        };

        axios.post(API_CALL_ENDPOINT + '/business/update', business_upDetails).then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status === 'success') {
            window.location.reload(true);
          }
        });
      }
    });
  };

  close_imageCrop = () => {
    $('.popup_new').hide();
  };
  update_qrcode_details = () => {
    let qr_filtered_tag_list_new = this.state.qr_filtered_tag_list;
    if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
      toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (this.state.qr_addtag_save === true) {
      console.log('newtagname', this.state.newtagname);
      const createtag = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tag_name: this.state.qr_newtag,
        tag_source: 'contacts',
      };
      console.log('createtag', createtag);
      axios
        .post(API_CALL_ENDPOINT + '/tags/create', createtag)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            if (qr_filtered_tag_list_new.indexOf(res.data?.result?._id) === -1) {
              qr_filtered_tag_list_new.push(res.data?.result?._id);
              // console.log(qr_filtered_tag_list_new);
            }
            // qr_newtag_id = ',' + res.data?.result?._id;
          } else if (res.data.status === 'conflict') {
            if (qr_filtered_tag_list_new.indexOf(res.data?.result?.details._id) === -1) {
              qr_filtered_tag_list_new.push(res.data?.result?.details._id);
              // console.log(qr_filtered_tag_list_new);
            }
            // qr_newtag_id = ',' + res.data?.result?.details._id;
          }
          const qrcode_upDetails = {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            qr_title: this.state.qr_title,
            auto_response: this.state.qr_message,
            description: this.state.qr_description,
            unique_id:
              this.state.atcharryDet_cmb.length != 0
                ? this.state.message_edit === false
                  ? Rnunique_id_cmb
                  : this.state.Rnunique_id_cmb
                    ? this.state.Rnunique_id_cmb
                    : Rnunique_id_cmb
                : '',
            attachment_url: this.state.atcharryDet_cmb.length != 0 ? true : false,
            tags: qr_filtered_tag_list_new.toString(),
            qr_code_id: this.state.qr_code_id_edit,
            qr_code_image: this.state.qr_code_image_edit,
          };
          console.log('inside alert', this.state.message_edit);
          axios
            .post(API_CALL_ENDPOINT + '/business/qrcodes/update', qrcode_upDetails)
            .then((res) => {
              if (res.data.status == 'success') {
                console.log('outside', res.data);
                window.scrollTo(0, 0);
                this.setState(() => ({
                  QRGrtMsg: res.data.message,
                  QRGrtcls: 'alert alert-success',
                }));

                setTimeout(() => {
                  this.setState(() => ({
                    QRGrtMsg: '',
                    QRGrtcls: '',
                    qr_title: '',
                    qr_description: '',
                    qr_message: '',
                    qr_filtered_tag_list: [],
                    qr_filtered_tag_list_up: [],
                    qr_newtag: '',
                    qr_addtag_save: false,
                    atcharryDet_cmb: [],
                    message_edit: false,
                    qr_code_image_edit: '',
                    qr_code_id_edit: '',
                  }));
                  Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
                  this.qrcode_listclick();
                  $('.qrcodelist_div').show();
                  $('.addqrcode_div').hide();
                  $('.qr_codedisplay').hide();
                  $('.generate_qr_btn').show();
                }, 5000);
              } else if (res.data.error) {
                this.setState(() => ({
                  QRGrtMsg: res.data.error.message,
                  QRGrtcls: 'alert alert-danger',
                }));
                window.scrollTo(0, 0);
                setTimeout(() => {
                  this.setState(() => ({
                    QRGrtMsg: '',
                    QRGrtcls: '',
                  }));
                }, 5000);
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.data.error) {
                  this.setState(() => ({
                    QRGrtMsg: error.response.data.error.message,
                    QRGrtcls: 'alert alert-danger',
                  }));
                  window.scrollTo(0, 0);
                  setTimeout(() => {
                    this.setState(() => ({
                      QRGrtMsg: '',
                      QRGrtcls: '',
                    }));
                  }, 5000);
                }
              }
            });
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'conflict') {
              if (qr_filtered_tag_list_new.indexOf(error.response.data?.result?.details._id) === -1) {
                qr_filtered_tag_list_new.push(error.response.data?.result?.details._id);
                // console.log(qr_filtered_tag_list_new);
              }
              // qr_newtag_id = ',' + res.data?.result?.details._id;
            }
          }
        });
    } else {
      const qrcode_upDetails = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        qr_title: this.state.qr_title,
        auto_response: this.state.qr_message,
        description: this.state.qr_description,
        unique_id:
          this.state.atcharryDet_cmb.length != 0
            ? this.state.message_edit === false
              ? Rnunique_id_cmb
              : this.state.Rnunique_id_cmb
                ? this.state.Rnunique_id_cmb
                : Rnunique_id_cmb
            : '',
        attachment_url: this.state.atcharryDet_cmb.length != 0 ? true : false,
        tags: qr_filtered_tag_list_new.toString(),
        qr_code_id: this.state.qr_code_id_edit,
        qr_code_image: this.state.qr_code_image_edit,
      };
      console.log('inside alert', this.state.message_edit);
      axios
        .post(API_CALL_ENDPOINT + '/business/qrcodes/update', qrcode_upDetails)
        .then((res) => {
          if (res.data.status == 'success') {
            console.log('outside', res.data);
            window.scrollTo(0, 0);
            this.setState(() => ({
              QRGrtMsg: res.data.message,
              QRGrtcls: 'alert alert-success',
            }));

            setTimeout(() => {
              this.setState(() => ({
                QRGrtMsg: '',
                QRGrtcls: '',
                qr_title: '',
                qr_description: '',
                qr_message: '',
                qr_filtered_tag_list: [],
                qr_filtered_tag_list_up: [],
                qr_newtag: '',
                qr_addtag_save: false,
                atcharryDet_cmb: [],
                message_edit: false,
                qr_code_image_edit: '',
                qr_code_id_edit: '',
              }));
              Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
              this.qrcode_listclick();
              $('.qrcodelist_div').show();
              $('.addqrcode_div').hide();
              $('.qr_codedisplay').hide();
              $('.generate_qr_btn').show();
            }, 5000);
          } else if (res.data.error) {
            this.setState(() => ({
              QRGrtMsg: res.data.error.message,
              QRGrtcls: 'alert alert-danger',
            }));
            window.scrollTo(0, 0);
            setTimeout(() => {
              this.setState(() => ({
                QRGrtMsg: '',
                QRGrtcls: '',
              }));
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                QRGrtMsg: error.response.data.error.message,
                QRGrtcls: 'alert alert-danger',
              }));
              window.scrollTo(0, 0);
              setTimeout(() => {
                this.setState(() => ({
                  QRGrtMsg: '',
                  QRGrtcls: '',
                }));
              }, 5000);
            }
          }
        });
    }
  };
  save_qrcode_details = () => {
    const canvas = document.getElementById('123456');
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const blob = this.dataURLtoBlob(pngUrl);
    var fileOfBlob = new File([blob], 'qr_' + Rnunique_id_cmb + '.png', { type: 'image/png' });
    const data = new FormData();
    let qr_filtered_tag_list_new = this.state.qr_filtered_tag_list;
    data.append('apikey', API_KEY);
    data.append('secret', API_SECRET);
    data.append('user_id', this.state.user_id);
    data.append('business_id', this.state.business_id);
    data.append('file', fileOfBlob);

    console.log('Form:' + data);
    console.log('File Values : ', data);
    console.log(this.state.business_id);
    axios.post(API_CALL_ENDPOINT + '/file/upload', data).then((res) => {
      if (res.data.status == 'success') {
        var file_url = '';
        for (var i in res.data.result.files) {
          console.log(res.data.result.files[i].file_url);
          file_url += res.data.result.files[i].file_url;
        }
        if (this.state.qr_addtag_save === true) {
          // console.log("newtagname",this.state.newtagname)
          const createtag = {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            tag_name: this.state.qr_newtag,
            tag_source: 'contacts',
          };
          console.log('createtag', createtag);
          axios
            .post(API_CALL_ENDPOINT + '/tags/create', createtag)
            .then((res) => {
              console.log(res.data);
              if (res.data.status === 'success') {
                if (qr_filtered_tag_list_new.indexOf(res.data?.result?._id) === -1) {
                  qr_filtered_tag_list_new.push(res.data?.result?._id);
                  // console.log(qr_filtered_tag_list_new);
                }
                // qr_newtag_id = ',' + res.data?.result?._id;
              } else if (res.data.status === 'conflict') {
                if (qr_filtered_tag_list_new.indexOf(res.data?.result?.details._id) === -1) {
                  qr_filtered_tag_list_new.push(res.data?.result?.details._id);
                  // console.log(qr_filtered_tag_list_new);
                }
                // qr_newtag_id = ',' + res.data?.result?.details._id;
              }
              const qrcode_upDetails = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                qr_title: this.state.qr_title,
                auto_response: this.state.qr_message,
                description: this.state.qr_description,
                unique_id: this.state.atcharryDet_cmb.length != 0 ? Rnunique_id_cmb : '',
                attachment_url: this.state.atcharryDet_cmb.length != 0 ? true : false,
                tags: qr_filtered_tag_list_new.toString(),
                qr_code: Rnunique_id_cmb,
                qr_code_image: file_url,
              };
              console.log('inside', qrcode_upDetails);
              axios
                .post(API_CALL_ENDPOINT + '/business/qrcodes/create', qrcode_upDetails)
                .then((res) => {
                  if (res.data.status == 'success') {
                    console.log('outside', res.data);
                    window.scrollTo(0, 0);
                    this.setState(() => ({
                      QRGrtMsg: res.data.message,
                      QRGrtcls: 'alert alert-success',
                    }));

                    setTimeout(() => {
                      this.setState(() => ({
                        QRGrtMsg: '',
                        QRGrtcls: '',
                        qr_title: '',
                        qr_description: '',
                        qr_message: '',
                        qr_filtered_tag_list: [],
                        qr_filtered_tag_list_up: [],
                        qr_newtag: '',
                        qr_addtag_save: false,
                        atcharryDet_cmb: [],
                      }));
                      Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
                      this.qrcode_listclick();
                      $('.qrcodelist_div').show();
                      $('.addqrcode_div').hide();
                      $('.qr_codedisplay').hide();
                      $('.generate_qr_btn').show();
                    }, 5000);
                  } else if (res.data.error) {
                    this.setState(() => ({
                      QRGrtMsg: res.data.error.message,
                      QRGrtcls: 'alert alert-danger',
                    }));
                    window.scrollTo(0, 0);
                    setTimeout(() => {
                      this.setState(() => ({
                        QRGrtMsg: '',
                        QRGrtcls: '',
                      }));
                    }, 5000);
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.data.error) {
                      this.setState(() => ({
                        QRGrtMsg: error.response.data.error.message,
                        QRGrtcls: 'alert alert-danger',
                      }));
                      window.scrollTo(0, 0);
                      setTimeout(() => {
                        this.setState(() => ({
                          QRGrtMsg: '',
                          QRGrtcls: '',
                        }));
                      }, 5000);
                    }
                  }
                });
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.data.status === 'conflict') {
                  if (qr_filtered_tag_list_new.indexOf(error.response.data?.result?.details._id) === -1) {
                    qr_filtered_tag_list_new.push(error.response.data?.result?.details._id);
                    // console.log(qr_filtered_tag_list_new);
                  }
                  // qr_newtag_id = ',' + res.data?.result?.details._id;
                }
              }
            });
        } else if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
          toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          const qrcode_upDetails = {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            qr_title: this.state.qr_title,
            auto_response: this.state.qr_message,
            description: this.state.qr_description,
            unique_id: this.state.atcharryDet_cmb.length != 0 ? Rnunique_id_cmb : '',
            attachment_url: this.state.atcharryDet_cmb.length != 0 ? true : false,
            tags: qr_filtered_tag_list_new.toString(),
            qr_code: Rnunique_id_cmb,
            qr_code_image: file_url,
          };
          console.log('outside', qrcode_upDetails);
          axios
            .post(API_CALL_ENDPOINT + '/business/qrcodes/create', qrcode_upDetails)
            .then((res) => {
              if (res.data.status == 'success') {
                console.log('outside', res.data);

                this.setState(() => ({
                  QRGrtMsg: res.data.message,
                  QRGrtcls: 'alert alert-success',
                }));
                window.scrollTo(0, 0);
                setTimeout(() => {
                  this.setState(() => ({
                    QRGrtMsg: '',
                    QRGrtcls: '',
                    qr_title: '',
                    qr_description: '',
                    qr_message: '',
                    qr_filtered_tag_list: [],
                    qr_filtered_tag_list_up: [],
                    qr_newtag: '',
                    qr_addtag_save: false,
                    atcharryDet_cmb: [],
                  }));
                  Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
                  this.qrcode_listclick();
                  $('.qrcodelist_div').show();
                  $('.addqrcode_div').hide();
                  $('.qr_codedisplay').hide();
                  $('.generate_qr_btn').show();
                }, 5000);
              } else if (res.data.error) {
                this.setState(() => ({
                  QRGrtMsg: res.data.error.message,
                  QRGrtcls: 'alert alert-danger',
                }));
                window.scrollTo(0, 0);
                setTimeout(() => {
                  this.setState(() => ({
                    QRGrtMsg: '',
                    QRGrtcls: '',
                  }));
                }, 5000);
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.data.error) {
                  this.setState(() => ({
                    QRGrtMsg: error.response.data.error.message,
                    QRGrtcls: 'alert alert-danger',
                  }));
                  window.scrollTo(0, 0);
                  setTimeout(() => {
                    this.setState(() => ({
                      QRGrtMsg: '',
                      QRGrtcls: '',
                    }));
                  }, 5000);
                }
              }
            });
        }
      }
    });
  };

  onChangeprefix(e) {
    console.log('1212121212');
    this.setState({ errors: [] });
    const res = e.target.value.substring(1, 0);
    if (res == '1' || res == '0') {
      this.setState({ prefix: e.target.value.substring(1) });
      const numberlist = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          country: 'US',
          start: '0',
          limit: '7',
          pattern: e.target.value.substring(1),
        },
      };
      axios
        .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
        .then((res) => {
          console.log(res.data.result.phone_numbers);
          this.setState({ plivolist: res.data.result.phone_numbers });
          console.log(this.state.plivolist);
          console.log(res.data.result.phone_numbers.length);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              toast.dark(error.response.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
            if (error.response.data.status === 'conflict') {
              toast.dark(error.response.data.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }
        });
    } else {
      this.setState({ prefix: e.target.value });
      const numberlist = {
        params: {
          apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
          secret: 'R1eqD2twI3E4',
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          country: 'US',
          start: '0',
          limit: '7',
          pattern: e.target.value,
        },
      };
      axios
        .get(API_CALL_ENDPOINT + '/plivo/number/list', numberlist)
        .then((res) => {
          // console.log(res.data.result.phone_numbers);
          this.setState({ plivolist: res.data.result.phone_numbers });
          // console.log(this.state.plivolist)
          // console.log(this.state.plivolist.length)
          if (this.state.plivolist.length === 0) {
            const errors = [];
            errors.push("The area code provided doesn't have any phone numbers, please enter a different area code");
            this.setState({ errors });
            // console.log(this.state.errors);
            setTimeout(() => {
              this.setState({ errors: [] });
              // this.props.history.push('/')
              // document.getElementById('error').style.display='none'
            }, 3000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              toast.dark(error.response.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
            if (error.response.data.status === 'conflict') {
              toast.dark(error.response.data.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }
        });
    }

    this.setState({ prefix: e.target.value });
  }
  // show_trial_payment(){
  // 	$(".modal_upgrade").show();
  // }
  qrcodeonMessageEdit(qr_code_individual) {
    console.log('qr_code_individual', qr_code_individual);
    let result = qr_code_individual.tags.map((a) => a._id);
    // $('.qrcode_taglist option').removeAttr('selected');
    for (var i = 0; i < result.length; i++) {
      console.log('result[i];', result[i]);
      $('.qrcode_taglist option').filter(`[value=${result[i]}]`).attr('selected', 'selected');
      // $('div.id_100  option[value="val2"]').prop('selected', true);
    }
    this.setState({
      qr_title: qr_code_individual.qr_title,
      qr_description: qr_code_individual.description,
      qr_message: qr_code_individual.auto_response,
      qr_filtered_tag_list: result,
      qr_addtag_save: false,
      message_edit: true,
      Rnunique_id_cmb: qr_code_individual.qr_code,
      qr_code_image_edit: qr_code_individual.qr_code_image,
      qr_code_id_edit: qr_code_individual._id,
    });
    if (qr_code_individual.attachment_url === 'true') {
      const attachmentinfo = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          unique_id: qr_code_individual.unique_id,
          // contact_id: conversation.conversation.contacts.toString()
        },
      };
      console.log(attachmentinfo);
      axios
        .get(API_CALL_ENDPOINT + '/attachment/edit/list', attachmentinfo)
        .then((res) => {
          console.log('EDIT', res.data);
          if (res.data.status === 'success') {
            this.setState({ messageAttachd: true });
            var arrayLength = res.data?.result?.attachment_list.length;

            var OrderIncr1 = this.state.attachOrderIncrs_cmb + parseInt(arrayLength);
            this.setState({ attachOrderIncrs_cmb: OrderIncr1 });

            for (var i = 0; i < arrayLength; i++) {
              if (res.data?.result?.attachment_list[i].attachment_type == 'notes') {
                $('.attchLstShow_cmb').show();
                $('#notestypearea').val('');
                this.setState({
                  atcharryDet_cmb: [
                    {
                      attach_id: res.data?.result?.attachment_list[i]._id,
                      notes_content: res.data?.result?.attachment_list[i].text,
                      notes_content1: 'Your text goes here',
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'audio') {
                $('.attchLstShow_cmb').show();
                this.setState({
                  atcharryDet_cmb: [
                    {
                      _id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                      second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                      audio_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      audio_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'video') {
                $('.attchLstShow_cmb').show();
                console.log('video_url: ' + res.data?.result?.attachment_list[i].attachment[0].file_url);
                this.setState({
                  atcharryDet_cmb: [
                    {
                      video_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      video_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                      second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                      file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'documents') {
                var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                var flDc_detils = [];
                var k = 1;
                this.colapse_all_attachments();
                for (var j = 0; j < arrayLength1; j++) {
                  flDc_detils.push({
                    file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                    file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                    file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                    file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                  });
                  this.colapse_all_attachments();
                  if (k == arrayLength1) {
                    var fileary = {
                      documents: flDc_detils,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    };
                    this.setState({
                      atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                    });
                  }
                  k++;
                  this.colapse_all_attachments();
                }
                this.colapse_all_attachments();
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'images') {
                var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                var flDc_detils = [];
                var k = 1;
                this.colapse_all_attachments();
                for (var j = 0; j < arrayLength1; j++) {
                  flDc_detils.push({
                    file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                    file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                    file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                    file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                  });
                  this.colapse_all_attachments();
                  if (k == arrayLength1) {
                    var fileary = {
                      images: flDc_detils,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    };
                    this.setState({
                      atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                    });
                  }
                  k++;
                  this.colapse_all_attachments();
                }
                this.colapse_all_attachments();
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
              }
            }
            this.colapse_all_attachments();
          }
          this.colapse_all_attachments();
          // console.log(this.state.attachment_list);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    $('.qr_codedisplay').show();
    $('.generate_qr_btn').hide();
    $('.qrcodecreate_div').hide();
    $('.addqrcode_div').show();
    $('.qrcodelist_div').hide();
  }
  downloadQR = () => {
    const canvas = document.getElementById('123456');
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = Rnunique_id_cmb + '.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  generate_qr = () => {
    $('.qr_codedisplay').show();
    $('.generate_qr_btn').hide();
  };
  qrcode_delete = (qrcode_det) => {
    const qr_delete = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      qrcode_id: qrcode_det._id,
    };
    axios
      .post(API_CALL_ENDPOINT + '/business/qrcodes/delete', qr_delete)
      .then((res) => {
        if (res.data) {
          if (res.data.status == 'success') {
            this.setState(() => ({
              QRGrtMsg: res.data.message,
              QRGrtcls: 'alert alert-success text-center',
            }));
            this.qrcode_listclick();
            setTimeout(() => {
              this.setState(() => ({
                QRGrtMsg: '',
                QRGrtcls: '',
              }));
            }, 5000);
          } else if (res.data.error) {
            this.setState(() => ({
              QRGrtMsg: res.data.error.message,
              QRGrtcls: 'alert alert-danger text-center',
            }));
            setTimeout(() => {
              this.setState(() => ({
                QRGrtMsg: '',
                QRGrtcls: '',
              }));
            }, 5000);
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState(() => ({
              QRGrtMsg: error.response.data.error.message,
              QRGrtcls: 'alert alert-danger text-center',
            }));
            setTimeout(() => {
              this.setState(() => ({
                QRGrtMsg: '',
                QRGrtcls: '',
              }));
            }, 5000);
          }
        }
      });
  };
  tags_list_click = () => {
    const tagLst_details = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };

    console.log(tagLst_details);
    axios.get(API_CALL_ENDPOINT + '/tags/list', tagLst_details).then((res) => {
      console.log(res.data);
      if (res.data.result) {
        this.setState({ tagList: res.data.result, tag_list: res.data.result });
      }
    });
  };
  qrcode_listclick = () => {
    const qrcode_list_details = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };

    axios.get(API_CALL_ENDPOINT + '/business/qrcodes/list', qrcode_list_details).then((res) => {
      console.log(res.data);
      if (res.data.result) {
        this.setState({ qr_code_list: res.data.result });
        if (res?.data?.result?.length != 0) {
          $('.qrcodelist_div').show();
          $('.addqrcode_div').hide();
          $('.qrcodecreate_div').hide();
        }
      } else {
        this.setState({ qr_code_list: [] });
        $('.qrcodelist_div').hide();
        $('.addqrcode_div').hide();
        $('.qrcodecreate_div').show();
      }
    });
    this.tags_list_click();
  };

  sendmsgattach_clkNotes2_cmb = () => {
    if (
      this.state.atcharryDet_cmb.length + this.state.attachmentdoc_count_cmb >= this.state.attachmentlimit_count ||
      docAttachmentsCount_cmb + this.state.atcharryDet_cmb.length >= this.state.attachmentlimit_count
    ) {
      this.setState(() => ({
        QRGrtMsg: `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        QRGrtcls: 'alert alert-danger',
      }));
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.setState(() => ({
          QRGrtMsg: '',
          QRGrtcls: '',
        }));
      }, 5000);
    } else {
      $('.sendmsg_attachmentdiv2_cmb').show();
      $('.sendmsgattach_clkNotes2_cmb').show();
      $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
      $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
    }
  };

  notesLetter2_cmb = (value) => {
    if (value.length <= 1200) {
      this.setState({
        notesValue2_cmb: value,
        chars_left_notes_cmb: this.state.max_chars_notes_cmb - value.length,
      });
    }
  };

  saveNotes2_cmb = () => {
    clearTimeout(this.timer);
    clearTimeout(this.savetimer);
    this.colapse_all_attachments();
    if (
      this.state.atcharryDet_cmb.length + this.state.attachmentdoc_count_cmb >= this.state.attachmentlimit_count ||
      docAttachmentsCount_cmb + this.state.atcharryDet_cmb.length >= this.state.attachmentlimit_count
    ) {
      toast.dark(
        `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      clearTimeout(this.savetimer);
      clearTimeout(this.timer);
      // this.setState(() => ({
      //   QRGrtMsg: `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
      //   QRGrtcls: 'alert alert-danger',
      // }));
      // window.scrollTo(0, 0);
      // setTimeout(() => {
      //   this.setState(() => ({
      //     QRGrtMsg: '',
      //     QRGrtcls: '',
      //   }));
      // }, 5000);
    } else {
      console.log(this.state.notesValue2_cmb);
      $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
      $('.sendmsg_attachmentdiv2_cmb').hide();
      $('.attachLoading_cmb').show();
      $('.attchLstShow_cmb').show();
      this.setState({ lodingicon_cmb: 'far fa-sticky-note bg_notes' });

      const notes_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        attachment_type: 'notes',
        unique_id:
          this.state.message_edit === false
            ? Rnunique_id_cmb
            : this.state.Rnunique_id_cmb
              ? this.state.Rnunique_id_cmb
              : Rnunique_id_cmb,
        text: '<p></p>',
        order: '' + this.state.attachOrderIncrs_cmb + '',
      };

      axios
        .post(API_CALL_ENDPOINT + '/text/attachment/create', notes_details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            // clearTimeout(this.savetimer);
            this.setState({ messageAttachd_cmb: true });
            this.setState({
              cmb_notesedit: true,
              active_edit_id: res.data?.result?._id,
              notesValue2_cmb: '<p></p>',
              atcharryDet_cmb: [
                {
                  attach_id: res.data?.result?._id,
                  notes_content: '<p></p>',
                  notes_content1: 'Your text goes here',
                },
                ...this.state.atcharryDet_cmb,
              ],
            });
            var OrderIncr = this.state.attachOrderIncrs_cmb + parseInt(1);
            this.setState({ attachOrderIncrs_cmb: OrderIncr });
            clearTimeout(this.timer);
            clearTimeout(this.savetimer);
            setTimeout(() => {
              // this.setState({notesValue2: '', chars_left_notes_compose: 0});
              this.setState({ savingprogress: '✔ Saved' });
              this.setState({ savingprogress: '' });
            }, 1000);
            setTimeout(() => {
              // this.setState({notesValue2_cmb: '', chars_left_notes_cmb: 0});
              $('.editor_cmb_' + res.data?.result?._id).show();
              $('.notecontent_cmb_' + res.data?.result?._id).hide();
              console.log(this.state.atcharryDet_cmb);
            }, 150);

            $('#notestypearea_cmb').val('');
            $('.sendmsgattach_clkNotes2_cmb').hide();
            $('.sendmsg_attachmentdiv2_cmb').hide();
            $('.attachLoading_cmb').hide();
            // $('.attachment_colapsed').show();
            //     $('.attachment_expanded').hide();
            $('.attachment_colapsed').show();
            $('.attachment_colapsed_' + res.data?.result?._id).hide();
            $('.attachment_expanded').hide();
            $('.attachment_expanded_' + res.data?.result?._id).show();
            $('.attchLstShow_cmb').show();
          }
          if (res.data.error) {
            if (res.data.error.message === 'Text required') {
              $('.sendmsgattach_clkNotes2_cmb').show();
              $('.sendmsg_attachmentdiv2_cmb').hide();
              $('.attachment_colapsed').show();
              $('.attachment_expanded').hide();
              $('.attachLoading_cmb').hide();
              $('.attchLstShow_cmb').show();
              const errors = [];
              errors.push("Notes can't be empty.");
              this.setState({ errors });

              setTimeout(() => {
                this.setState({ errors: [] });
              }, 3000);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              if (error.response.data.error.message === 'Text required') {
                $('.sendmsgattach_clkNotes2_cmb').show();
                $('.sendmsg_attachmentdiv2_cmb').hide();
                $('.attachment_colapsed').show();
                $('.attachment_expanded').hide();
                $('.attachLoading_cmb').hide();
                $('.attchLstShow_cmb').show();
                const errors = [];
                errors.push("Notes can't be empty.");
                this.setState({ errors });

                setTimeout(() => {
                  this.setState({ errors: [] });
                }, 3000);
              }
            }
          }
        });
    }
  };

  autoupdateNotes2_cmb = () => {
    // clearTimeout(this.timer);
    // this.timer = setTimeout(() => {
    //   if (this.state.cmb_notesedit === true) {
    if (this.state.notesValue2_cmb.length !== 0) {
      // this.setState({savingprogress: 'Saving...'});
      const notes_details = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        attachment_type: 'notes',
        attachment_id: this.state.active_edit_id,
        unique_id:
          this.state.message_edit == false
            ? Rnunique_id_cmb
            : this.state.Rnunique_id_cmb
              ? this.state.Rnunique_id_cmb
              : Rnunique_id_cmb,
        text: this.state.notesValue2_cmb ? this.state.notesValue2_cmb : '<p></p>',
        order: '' + this.state.attachOrderIncrs_cmb + '',
      };

      axios
        .post(API_CALL_ENDPOINT + '/text/attachment/update', notes_details)
        .then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            // this.setState({messageAttachd_cmb: true});
            let objIndex = 0;
            let myArray = this.state.atcharryDet_cmb;
            objIndex = myArray.findIndex((obj) => obj.attach_id == this.state.active_edit_id);
            if (myArray[objIndex]?.notes_content) {
              myArray[objIndex].notes_content = this.state.notesValue2_cmb ? this.state.notesValue2_cmb : '';
              myArray[objIndex].notes_content1 = 'Your text goes here!';
            }

            this.setState({
              atcharryDet_cmb: myArray,
            });
            // this.setState({savingprogress: '✔ Saved'});
            // setTimeout(() => {
            //   this.setState({savingprogress: ''});
            // }, 1000);
          }
          if (res.data.error) {
            if (res.data.error.message === 'Text required') {
              const errors = [];
              errors.push("Notes can't be empty.");
              this.setState({ errors });
              setTimeout(() => {
                this.setState({ errors: [] });
              }, 3000);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              if (error.response.data.error.message === 'Text required') {
                const errors = [];
                errors.push("Notes can't be empty.");
                this.setState({ errors });
                setTimeout(() => {
                  this.setState({ errors: [] });
                }, 3000);
              }
            }
          }
        });
    }
    //   }
    // }, 2000);
  };
  updateNotes2_cmb = () => {
    console.log(this.state.notesValue2_cmb);

    $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
    $('.sendmsg_attachmentdiv2_cmb').hide();
    // $('.attachLoading_cmb').show();
    $('.attchLstShow_cmb').show();
    this.setState({ lodingicon_cmb: 'far fa-sticky-note bg_notes' });

    const notes_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      attachment_type: 'notes',
      attachment_id: this.state.active_edit_id,
      unique_id:
        this.state.message_edit == false
          ? Rnunique_id_cmb
          : this.state.Rnunique_id_cmb
            ? this.state.Rnunique_id_cmb
            : Rnunique_id_cmb,
      text: this.state.notesValue2_cmb ? this.state.notesValue2_cmb : '<p></p>',
      order: '' + this.state.attachOrderIncrs_cmb + '',
    };

    axios
      .post(API_CALL_ENDPOINT + '/text/attachment/update', notes_details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState({ messageAttachd_cmb: true });
          let objIndex = 0;
          let myArray = this.state.atcharryDet_cmb;
          objIndex = myArray.findIndex((obj) => obj.attach_id == this.state.active_edit_id);
          if (myArray[objIndex].notes_content) {
            myArray[objIndex].notes_content = this.state.notesValue2_cmb;
            myArray[objIndex].notes_content1 = 'Your text goes here';
          }

          this.setState({
            atcharryDet_cmb: myArray,
          });
          var OrderIncr = this.state.attachOrderIncrs_cmb + parseInt(1);
          this.setState({ attachOrderIncrs_cmb: OrderIncr });

          setTimeout(() => {
            // this.setState({notesValue2_cmb: '', chars_left_notes_cmb: 0});

            console.log(this.state.atcharryDet_cmb);
          }, 150);

          $('#notestypearea_cmb').val('');
          // $('.attachLoading_cmb').hide();
          if (this.state.active_edit_id) {
            $('.editor_cmb_' + this.state.active_edit_id).hide();
            $('.notecontent_cmb_' + this.state.active_edit_id).show();
          }
        }
        if (res.data.error) {
          if (res.data.error.message === 'Text required') {
            $('.sendmsgattach_clkNotes2_cmb').show();
            $('.sendmsg_attachmentdiv2_cmb').hide();
            // $('.attachLoading_cmb').hide();
            $('.attchLstShow_cmb').show();
            const errors = [];
            errors.push("Notes can't be empty.");
            this.setState({ errors });

            setTimeout(() => {
              this.setState({ errors: [] });
            }, 3000);
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            if (error.response.data.error.message === 'Text required') {
              $('.sendmsgattach_clkNotes2_cmb').show();
              $('.sendmsg_attachmentdiv2_cmb').hide();
              // $('.attachLoading_cmb').hide();
              $('.attchLstShow_cmb').show();
              const errors = [];
              errors.push("Notes can't be empty.");
              this.setState({ errors });

              setTimeout(() => {
                this.setState({ errors: [] });
              }, 3000);
            }
          }
        }
      });
  };
  oneditnotecmb = (attachment) => {
    if (this.state.active_edit_id) {
      $('.editor_cmb_' + this.state.active_edit_id).hide();
      $('.notecontent_cmb_' + this.state.active_edit_id).show();
    }
    let objIndex = 0;
    let myArray = this.state.atcharryDet_cmb;
    objIndex = myArray.findIndex((obj) => obj.attach_id == attachment.attach_id);
    if (myArray[objIndex]?.notes_content) {
      myArray[objIndex].notes_content = attachment.notes_content ? attachment.notes_content : '';
      myArray[objIndex].notes_content1 = 'Your text goes here!';
    }

    this.setState({
      atcharryDet_cmb: myArray,
    });
    $('.sendmsg_attachmentdiv2_cmb').hide();
    $('.sendmsgattach_clkNotes2_cmb').hide();
    $('.sendmsgattach_clkcalender_cmb').hide();
    $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
    $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
    $('.editor_cmb_' + attachment.attach_id).show();
    $('.notecontent_cmb_' + attachment.attach_id).hide();
    this.setState({ cmb_notesedit: true });
    // window.scrollTo({top: 0, behavior: 'smooth'});
    this.setState({ active_edit_id: attachment.attach_id, notesValue2_cmb: attachment.notes_content });
    this.autoupdateNotes2_cmb();
  };
  sendmsgattach_clkAudio2_cmb = () => {
    this.colapse_all_attachments();
    if (
      this.state.atcharryDet_cmb.length + this.state.attachmentdoc_count_cmb >= this.state.attachmentlimit_count ||
      docAttachmentsCount_cmb + this.state.atcharryDet_cmb.length >= this.state.attachmentlimit_count
    ) {
      toast.dark(
        `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      // this.setState(() => ({
      //   QRGrtMsg: `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
      //   QRGrtcls: 'alert alert-danger',
      // }));
      // window.scrollTo(0, 0);
      // setTimeout(() => {
      //   this.setState(() => ({
      //     QRGrtMsg: '',
      //     QRGrtcls: '',
      //   }));
      // }, 5000);
      // const errors = [];
      // errors.push(
      //   `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
      // );
      // this.setState({errors});

      // setTimeout(() => {
      //   this.setState({errors: []});
      // }, 5000);
    } else {
      $('.sendmsg_attachmentdiv2_cmb').show();
      $('.sendmsgattach_clkAudio2_cmb').show();
      $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
      $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
    }
  };
  audio_start_cmb = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      var constraints = {
        audio: true,
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(() => {
          $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
          $('.audioRecordLoading_cmb').show();

          Mp3Recorder.start()
            .then(() => {
              this.setState({ isRecording_cmb: true });
            })
            .catch((e) => {
              this.setState({ isRecording_cmb: false });
              $('.sendmsgattach_clkAudio2_cmb').show();
              $('.audioRecordLoading_cmb').hide();
              toast.dark(
                'Sorry, this browser does not support audio recording. Please try using a different browser.',
                {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                },
              );
              // const errors = [];
              // errors.push(
              //   'Sorry, this browser does not support audio recording. Please try using a different browser.',
              // );
              // this.setState({errors});

              // setTimeout(() => {
              //   this.setState({errors: []});
              // }, 3000);
              // alert('Sorry this browser does not support audio recording yet');
              console.log(e);
            });
        })
        .catch((err) => {
          toast.dark('Sorry, this browser does not support audio recording. Please try using a different browser.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          // const errors = [];
          // errors.push('Sorry, this browser does not support audio recording. Please try using a different browser.');
          // this.setState({errors});

          // setTimeout(() => {
          //   this.setState({errors: []});
          // }, 3000);
          console.log(err);
        });
    } else {
      console.log('Sorry, this browser does not support audio recording. Please try using a different browser.');
    }
  };

  audio_start_cmb_nft = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      var constraints = {
        audio: true,
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(() => {
          $('.sendmsgattach_clkAudio2_cmb_nft').attr('style', 'display:none');
          $('.audioRecordLoading_cmb_nft').show();

          Mp3Recorder.start()
            .then(() => {
              this.setState({ isRecording_cmb: true });
            })
            .catch((e) => {
              this.setState({ isRecording_cmb: false });
              $('.sendmsgattach_clkAudio2_cmb').show();
              $('.audioRecordLoading_cmb').hide();
              toast.dark(
                'Sorry, this browser does not support audio recording. Please try using a different browser.',
                {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                },
              );
              // const errors = [];
              // errors.push(
              //   'Sorry, this browser does not support audio recording. Please try using a different browser.',
              // );
              // this.setState({errors});

              // setTimeout(() => {
              //   this.setState({errors: []});
              // }, 3000);
              // alert('Sorry this browser does not support audio recording yet');
              console.log(e);
            });
        })
        .catch((err) => {
          toast.dark('Sorry, this browser does not support audio recording. Please try using a different browser.', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          // const errors = [];
          // errors.push('Sorry, this browser does not support audio recording. Please try using a different browser.');
          // this.setState({errors});

          // setTimeout(() => {
          //   this.setState({errors: []});
          // }, 3000);
          console.log(err);
        });
    } else {
      console.log('Sorry, this browser does not support audio recording. Please try using a different browser.');
    }
  };

  audio_stop_cmb_nft = () => {
    $('.audioRecordLoading_cmb_nft').attr('style', 'display:none');
    $('.sendmsg_attachmentdiv2_cmb').hide();
    //$('.attachLoading_cmb').show();
    //$('.attchLstShow_cmb').show();
    this.setState({ lodingicon_cmb: 'fas fa-microphone-alt bg_audio' });

    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        this.setState({ blobURL, isRecording_cmb: false });

        var filename = new Date().toISOString();

        const data = new FormData();

        data.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
        data.append('secret', 'R1eqD2twI3E4');
        data.append('user_id', this.state.user_id);
        data.append('business_id', this.state.business_id);
        data.append('file', blob, filename);
        data.append('reference', 'text');

        axios.post(API_CALL_ENDPOINT + '/file/upload', data).then((res) => {
          console.log(res);
          console.log(res.data.message);
          console.log(res.data?.result?.files);

          if (res.data.status == 'success') {
            var file_url = '';
            var file_id = '';
            var file_path_audio = '';
            var second_file_path = '';
            for (var i in res.data?.result?.files) {
              console.log(res.data?.result?.files[i].file_url);
              file_url += res.data?.result?.files[i].file_url;
              file_id += res.data?.result?.files[i]._id;
              file_path_audio += res.data?.result?.files[i].file_path;
              second_file_path += res.data?.result?.files[i].second_file_path;
              var joined_audioId = this.state.attchmnt_audioId_cmb.concat(res.data?.result?.files[i]._id);
              this.setState({ attchmnt_audioId_cmb: joined_audioId });

              var joined_audioIdUrl = this.state.attchmnt_audioIdUrl_cmb.concat({
                _id: res.data?.result?.files[i]._id,
                file_path: res.data?.result?.files[i].file_path,
                audio_id: res.data?.result?.files[i]._id,
                audio_url: res.data?.result?.files[i].file_url,
              });
              this.setState({ attchmnt_audioIdUrl_cmb: joined_audioId });
            }

            console.log(file_url);

            console.log(this.state.atcharryDet_cmb);

            $('.attachLoading_cmb').hide();
            const audio_details = {
              apikey: API_KEY,
              secret: API_SECRET,
              user_id: this.state.user_id,
              business_id: this.state.business_id,
              attachment: file_id,
              attachment_type: 'audio',
              unique_id:
                this.state.message_edit === false
                  ? Rnunique_id_cmb
                  : this.state.Rnunique_id_cmb
                    ? this.state.Rnunique_id_cmb
                    : Rnunique_id_cmb,
              order: '' + this.state.attachOrderIncrs_cmb + '',
            };

            axios
              .post(API_CALL_ENDPOINT + '/text/attachment/create', audio_details)
              .then((res) => {
                console.log(res);
                console.log(res.data.message);

                if (res.data.status == 'success') {
                  this.setState({ messageAttachd_cmb: true });
                  $('#fileAudiosvBtn').hide();
                  this.setState({
                    atcharryDet_cmb: [
                      {
                        _id: file_id,
                        file_path: file_path_audio,
                        second_file_path: second_file_path,
                        audio_id: file_id,
                        audio_url: file_url,
                        attach_id: res.data?.result?._id,
                      },
                      ...this.state.atcharryDet_cmb,
                    ],
                  });
                  var OrderIncr = this.state.attachOrderIncrs_cmb + parseInt(1);
                  this.setState({ attachOrderIncrs_cmb: OrderIncr });
                  $('.attachment_expanded_nft').show();
                  // $('.attachment_colapsed_'+file_id).hide();
                  // $('.attachment_expanded').hide();
                  // $('.attachment_expanded_'+file_id).show();
                  console.log('Testing Logs', this.state.atcharryDet_cmb);
                }
                if (res.data.error) {
                  $('.attachment_expanded_nft').show();
                  // $('.attachment_colapsed_'+res.data?.result?.files[0]._id).hide();
                  //  $('.attachment_expanded').hide();
                  // $('.attachment_expanded_'+res.data?.result?.files[0]._id).show();
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.error) {
                    $('.attachment_colapsed').show();
                    // $('.attachment_colapsed_'+res.data?.result?.files[0]._id).hide();
                    $('.attachment_expanded').hide();
                    // $('.attachment_expanded_'+res.data?.result?.files[0]._id).show();
                  }
                }
              });
          }
        });
      })
      .catch((e) => console.log(e));
  };

  audio_stop_cmb = () => {
    $('.audioRecordLoading_cmb').attr('style', 'display:none');
    $('.sendmsg_attachmentdiv2_cmb').hide();
    $('.attachLoading_cmb').show();
    $('.attchLstShow_cmb').show();
    this.setState({ lodingicon_cmb: 'fas fa-microphone-alt bg_audio' });

    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        this.setState({ blobURL, isRecording_cmb: false });

        var filename = new Date().toISOString();

        const data = new FormData();

        data.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
        data.append('secret', 'R1eqD2twI3E4');
        data.append('user_id', this.state.user_id);
        data.append('business_id', this.state.business_id);
        data.append('file', blob, filename);
        data.append('reference', 'text');

        axios.post(API_CALL_ENDPOINT + '/file/upload', data).then((res) => {
          console.log(res);
          console.log(res.data.message);
          console.log(res.data?.result?.files);

          if (res.data.status == 'success') {
            var file_url = '';
            var file_id = '';
            var file_path_audio = '';
            var second_file_path = '';
            for (var i in res.data?.result?.files) {
              console.log(res.data?.result?.files[i].file_url);
              file_url += res.data?.result?.files[i].file_url;
              file_id += res.data?.result?.files[i]._id;
              file_path_audio += res.data?.result?.files[i].file_path;
              second_file_path += res.data?.result?.files[i].second_file_path;
              var joined_audioId = this.state.attchmnt_audioId_cmb.concat(res.data?.result?.files[i]._id);
              this.setState({ attchmnt_audioId_cmb: joined_audioId });

              var joined_audioIdUrl = this.state.attchmnt_audioIdUrl_cmb.concat({
                _id: res.data?.result?.files[i]._id,
                file_path: res.data?.result?.files[i].file_path,
                audio_id: res.data?.result?.files[i]._id,
                audio_url: res.data?.result?.files[i].file_url,
              });
              this.setState({ attchmnt_audioIdUrl_cmb: joined_audioId });
            }

            console.log(file_url);

            console.log(this.state.atcharryDet_cmb);

            $('.attachLoading_cmb').hide();
            const audio_details = {
              apikey: API_KEY,
              secret: API_SECRET,
              user_id: this.state.user_id,
              business_id: this.state.business_id,
              attachment: file_id,
              attachment_type: 'audio',
              unique_id:
                this.state.message_edit === false
                  ? Rnunique_id_cmb
                  : this.state.Rnunique_id_cmb
                    ? this.state.Rnunique_id_cmb
                    : Rnunique_id_cmb,
              order: '' + this.state.attachOrderIncrs_cmb + '',
            };

            axios
              .post(API_CALL_ENDPOINT + '/text/attachment/create', audio_details)
              .then((res) => {
                console.log(res);
                console.log(res.data.message);

                if (res.data.status == 'success') {
                  this.setState({ messageAttachd_cmb: true });
                  $('#fileAudiosvBtn').hide();
                  this.setState({
                    atcharryDet_cmb: [
                      {
                        _id: file_id,
                        file_path: file_path_audio,
                        second_file_path: second_file_path,
                        audio_id: file_id,
                        audio_url: file_url,
                        attach_id: res.data?.result?._id,
                      },
                      ...this.state.atcharryDet_cmb,
                    ],
                  });
                  var OrderIncr = this.state.attachOrderIncrs_cmb + parseInt(1);
                  this.setState({ attachOrderIncrs_cmb: OrderIncr });
                  $('.attachment_colapsed').show();
                  // $('.attachment_colapsed_'+file_id).hide();
                  $('.attachment_expanded').hide();
                  // $('.attachment_expanded_'+file_id).show();
                }
                if (res.data.error) {
                  $('.attachment_colapsed').show();
                  // $('.attachment_colapsed_'+res.data?.result?.files[0]._id).hide();
                  $('.attachment_expanded').hide();
                  // $('.attachment_expanded_'+res.data?.result?.files[0]._id).show();
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.error) {
                    $('.attachment_colapsed').show();
                    // $('.attachment_colapsed_'+res.data?.result?.files[0]._id).hide();
                    $('.attachment_expanded').hide();
                    // $('.attachment_expanded_'+res.data?.result?.files[0]._id).show();
                  }
                }
              });
          }
        });
      })
      .catch((e) => console.log(e));
  };
  sendmsgattach_clkVideo2_cmb = () => {
    this.colapse_all_attachments();
    if (
      this.state.atcharryDet_cmb.length + this.state.attachmentdoc_count_cmb >= this.state.attachmentlimit_count ||
      docAttachmentsCount_cmb + this.state.atcharryDet_cmb.length >= this.state.attachmentlimit_count
    ) {
      toast.dark(
        `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      // this.setState(() => ({
      //   QRGrtMsg: `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
      //   QRGrtcls: 'alert alert-danger',
      // }));
      // window.scrollTo(0, 0);
      // setTimeout(() => {
      //   this.setState(() => ({
      //     QRGrtMsg: '',
      //     QRGrtcls: '',
      //   }));
      // }, 5000);
      // const errors = [];
      // errors.push(
      //   `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
      // );
      // this.setState({errors});

      // setTimeout(() => {
      //   this.setState({errors: []});
      // }, 5000);
    } else {
      $('.sendmsg_attachmentdiv2_cmb').show();
      $('.sendmsgattach_clkVideo2_cmb').show();
      $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
      $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
    }
  };
  sendmsgattach_clkDocmnts2_cmb = () => {
    if (
      this.state.atcharryDet_cmb.length + this.state.attachmentdoc_count_cmb >= this.state.attachmentlimit_count ||
      docAttachmentsCount_cmb + this.state.atcharryDet_cmb.length >= this.state.attachmentlimit_count
    ) {
      this.setState(() => ({
        QRGrtMsg: `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        QRGrtcls: 'alert alert-danger',
      }));
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.setState(() => ({
          QRGrtMsg: '',
          QRGrtcls: '',
        }));
      }, 5000);
      // const errors = [];
      // errors.push(
      //   `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
      // );
      // this.setState({errors});

      // setTimeout(() => {
      //   this.setState({errors: []});
      // }, 5000);
    } else {
      $('.sendmsg_attachmentdiv2_cmb').show();
      $('.sendmsgattach_clkDocmnts2_cmb').show();
      $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
      $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
      $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
    }
  };
  fileGetDetails_cmb_images = (event) => {
    if (event.target.files.length !== 0) {
      this.setState(
        { attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb + (event.target.files.length - 1) },
        () => {
          console.log('attachmentdoc_count_cmb in callback log1', this.state.attachmentdoc_count_cmb);
        },
      );
      docAttachmentsCount_cmb += event.target.files.length;
      if (
        this.state.atcharryDet_cmb.length + this.state.attachmentdoc_count_cmb > this.state.attachmentlimit_count ||
        event.target.files.length > this.state.attachmentlimit_count ||
        docAttachmentsCount_cmb + this.state.atcharryDet_cmb.length > this.state.attachmentlimit_count
      ) {
        this.setState(
          { attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb - (event.target.files.length - 1) },
          () => {
            console.log('attachmentdoc_count_cmb in callback log2', this.state.attachmentdoc_count_cmb);
          },
        );
        docAttachmentsCount_cmb -= event.target.files.length;
        console.log('restrict', this.state.atcharryDet_cmb.length - this.state.attachmentdoc_count_cmb);
        toast.dark(
          `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
          {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        // this.setState(() => ({
        //   QRGrtMsg: `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        //   QRGrtcls: 'alert alert-danger',
        // }));
        // window.scrollTo(0, 0);
        // setTimeout(() => {
        //   this.setState(() => ({
        //     QRGrtMsg: '',
        //     QRGrtcls: '',
        //   }));
        // }, 5000);
        this.colapse_all_attachments();
        // const errors = [];
        // errors.push(
        //   `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        // );
        // this.setState({errors});

        // setTimeout(() => {
        //   this.setState({errors: []});
        // }, 3000);
      } else {
        docAttachmentsCount_cmb -= 1;
        $('.attachLoading_cmb').show();
        $('.attchLstShow_cmb').show();
        this.setState({ lodingicon_cmb: 'far fa-image bg_gallery ' });
        console.log(event.target.files);

        this.setState({ DcfilNm_cmb: event.target.files });

        var file_length = event.target.files.length;
        var i;

        var flDc_id = [];
        var flDc_detils = [];
        var flDc_type = [];
        for (i = 0; i < file_length; i++) {
          const file_detailsd = new FormData();

          file_detailsd.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
          file_detailsd.append('secret', 'R1eqD2twI3E4');
          file_detailsd.append('user_id', this.state.user_id);
          file_detailsd.append('business_id', this.state.business_id);
          file_detailsd.append('file', event.target.files[i]);
          file_detailsd.append('reference', 'text');
          file_detailsd.append('source', 'admin');

          if (event.target.files.length != 0) {
            this.colapse_all_attachments();
            console.log('First I value: ' + i);
            var k = 1;
            axios.post(API_CALL_ENDPOINT + '/file/upload', file_detailsd).then((res) => {
              console.log(res);
              console.log(res.data.message);

              if (res.data.status == 'success') {
                this.colapse_all_attachments();
                console.log('File_URL :' + res.data?.result?.files[0].file_url);
                console.log('ID_num :' + res.data?.result?.files[0]._id);
                var file_name = res.data?.result?.files[0].display_name;

                var joined_FileDocId = this.state.attchmnt_FileDocId_cmb.concat(res.data?.result?.files[0]._id);
                this.setState({ attchmnt_FileDocId_cmb: joined_FileDocId });

                var joined_UrlIdDets = this.state.attchmnt_UrlIdDets_cmb.concat({
                  id: res.data?.result?.files[0]._id,
                  file_name: file_name,
                });
                this.setState({ attchmnt_UrlIdDets_cmb: joined_UrlIdDets });
                this.colapse_all_attachments();
                flDc_id.push(res.data?.result?.files[0]._id);
                flDc_type.push(res.data?.result?.files[0].file_type);

                flDc_detils.push({
                  file_id: res.data?.result?.files[0]._id,
                  file_name: file_name,
                  file_url: res.data?.result?.files[0].file_url,
                  file_path: res.data?.result?.files[0].file_path,
                  thumbnail_file_url: res.data?.result?.files[0].thumbnail_file_url,
                  file_size: res.data?.result?.files[0].file_size,
                });
                this.colapse_all_attachments();
                if (k == file_length) {
                  setTimeout(() => {
                    console.log(this.state.atcharryDet_cmb);
                  }, 200);

                  const doct_attcId = flDc_id.filter((value) => value);
                  const atchId_docnt = doct_attcId.toString();
                  console.log(atchId_docnt);

                  const document_details = {
                    apikey: API_KEY,
                    secret: API_SECRET,
                    user_id: this.state.user_id,
                    business_id: this.state.business_id,
                    attachment: atchId_docnt,
                    attachment_type: 'images',
                    attachment_file_type: flDc_type.toString(),
                    unique_id:
                      this.state.message_edit == false
                        ? Rnunique_id_cmb
                        : this.state.Rnunique_id_cmb
                          ? this.state.Rnunique_id_cmb
                          : Rnunique_id_cmb,
                    order: '' + this.state.attachOrderIncrs_cmb + '',
                  };

                  axios.post(API_CALL_ENDPOINT + '/text/attachment/create', document_details).then((res) => {
                    console.log(res);
                    console.log(res.data.message);

                    if (res.data.status == 'success') {
                      setTimeout(() => {
                        this.colapse_all_attachments();
                      }, 1000);
                      setTimeout(() => {
                        this.colapse_all_attachments();
                      }, 2000);
                      setTimeout(() => {
                        this.colapse_all_attachments();
                      }, 3000);
                      this.setState({ messageAttachd: true });
                      $('#fileDocUsvBtn').hide();
                      var fileary = {
                        images: flDc_detils,
                        attach_id: res.data?.result?._id,
                      };
                      this.setState({
                        atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                      });
                      var OrderIncr = this.state.attachOrderIncrs_cmb + parseInt(1);
                      this.setState({ attachOrderIncrs_cmb: OrderIncr });
                    }
                    if (res.data.error) {
                    }
                  });

                  this.setState({
                    cmb_notesedit: false,
                    notesValue2_cmb: '',
                    max_chars_notes_cmb: 1200,
                    chars_left_notes_cmb: 1200,
                  });
                  clearTimeout(this.savetimer);
                  clearTimeout(this.timer);
                  // $('.attachment_colapsed').show();
                  // $('.attachment_colapsed_'+res.data?.result?._id).hide();
                  // $('.attachment_expanded').hide();
                  // $('.attachment_expanded_'+res.data?.result?._id).show();
                  this.colapse_all_attachments();
                  $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                  $('.sendmsg_attachmentdiv2_cmb').hide();
                  $('.attachLoading_cmb').hide();
                }
                k++;
              }
              if (res?.data?.error?.error_type == 'invalid_file_type') {
                let filelength = event.target && event.target.files ? event.target.files.length - 1 : 0;
                this.setState({
                  attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb - filelength,
                });
                toast.dark('Sorry, this file is invalid. Please try using a different file.', {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                // const errors = [];
                // errors.push('Sorry, this file is invalid. Please try using a different file.');
                // this.setState({errors});

                // setTimeout(() => {
                //   this.setState({errors: []});
                // }, 3000);

                this.setState({
                  cmb_notesedit: false,
                  notesValue2_cmb: '',
                  max_chars_notes_cmb: 1200,
                  chars_left_notes_cmb: 1200,
                });
                clearTimeout(this.savetimer);
                clearTimeout(this.timer);

                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                $('.sendmsg_attachmentdiv2_cmb').hide();
                $('.attachLoading_cmb').hide();
                this.colapse_all_attachments();
              }
              $('#file-input3')[0].value = '';
            });
          }
        }
      }
    }
  };
  fileGetDetails_cmb = (event) => {
    if (event.target.files.length !== 0) {
      this.setState(
        { attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb + (event.target.files.length - 1) },
        () => {
          console.log('attachmentdoc_count_cmb in callback log1', this.state.attachmentdoc_count_cmb);
        },
      );
      docAttachmentsCount_cmb += event.target.files.length;
      if (
        this.state.atcharryDet_cmb.length + this.state.attachmentdoc_count_cmb > this.state.attachmentlimit_count ||
        event.target.files.length > this.state.attachmentlimit_count ||
        docAttachmentsCount_cmb + this.state.atcharryDet_cmb.length > this.state.attachmentlimit_count
      ) {
        this.setState(
          { attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb - (event.target.files.length - 1) },
          () => {
            console.log('attachmentdoc_count_cmb in callback log2', this.state.attachmentdoc_count_cmb);
          },
        );
        docAttachmentsCount_cmb -= event.target.files.length;
        console.log('restrict', this.state.atcharryDet_cmb.length - this.state.attachmentdoc_count_cmb);
        toast.dark(
          `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
          {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        // this.setState(() => ({
        //   QRGrtMsg: `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        //   QRGrtcls: 'alert alert-danger',
        // }));
        // window.scrollTo(0, 0);
        // this.colapse_all_attachments()
        // setTimeout(() => {
        //   this.setState(() => ({
        //     QRGrtMsg: '',
        //     QRGrtcls: '',
        //   }));
        // }, 5000);
        // const errors = [];
        // errors.push(
        //   `The allowed limit on this plan is ${this.state.attachmentlimit_count}, please upgrade to add more files.`,
        // );
        // this.setState({errors});

        // setTimeout(() => {
        //   this.setState({errors: []});
        // }, 3000);
      } else {
        docAttachmentsCount_cmb -= 1;
        $('.attachLoading_cmb').show();
        $('.attchLstShow_cmb').show();
        this.setState({ lodingicon_cmb: 'far fa-file-alt bg_documents' });
        console.log(event.target.files);

        this.setState({ DcfilNm_cmb: event.target.files });

        var file_length = event.target.files.length;
        var i;

        var flDc_id = [];
        var flDc_detils = [];
        var flDc_type = [];
        for (i = 0; i < file_length; i++) {
          const file_detailsd = new FormData();

          file_detailsd.append('apikey', 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA');
          file_detailsd.append('secret', 'R1eqD2twI3E4');
          file_detailsd.append('user_id', this.state.user_id);
          file_detailsd.append('business_id', this.state.business_id);
          file_detailsd.append('file', event.target.files[i]);
          file_detailsd.append('reference', 'text');

          if (event.target.files.length != 0) {
            console.log('First I value: ' + i);
            var k = 1;
            axios
              .post(API_CALL_ENDPOINT + '/file/upload', file_detailsd)
              .then((res) => {
                if (res.data.status === 'success') {
                  console.log('File_URL :' + res.data?.result?.files[0].file_url);
                  console.log('ID_num :' + res.data?.result?.files[0]._id);
                  var file_name = res.data?.result?.files[0].display_name;

                  var joined_FileDocId = this.state.attchmnt_FileDocId_cmb.concat(res.data?.result?.files[0]._id);
                  this.setState({ attchmnt_FileDocId_cmb: joined_FileDocId });

                  var joined_UrlIdDets = this.state.attchmnt_UrlIdDets_cmb.concat({
                    id: res.data?.result?.files[0]._id,
                    file_name: file_name,
                  });
                  this.setState({ attchmnt_UrlIdDets_cmb: joined_UrlIdDets });

                  flDc_id.push(res.data?.result?.files[0]._id);
                  flDc_type.push(res.data?.result?.files[0].file_type);

                  flDc_detils.push({
                    file_id: res.data?.result?.files[0]._id,
                    file_name: file_name,
                    file_url: res.data?.result?.files[0].file_url,
                    file_path: res.data?.result?.files[0].file_path,
                    thumbnail_file_url: res.data?.result?.files[0].thumbnail_file_url,
                    file_size: res.data?.result?.files[0].file_size,
                  });
                  this.colapse_all_attachments();
                  if (k == file_length) {
                    setTimeout(() => {
                      console.log(this.state.atcharryDet_cmb);
                    }, 200);

                    const doct_attcId = flDc_id.filter((value) => value);
                    const atchId_docnt = doct_attcId.toString();
                    console.log(atchId_docnt);
                    this.colapse_all_attachments();
                    const document_details = {
                      apikey: API_KEY,
                      secret: API_SECRET,
                      user_id: this.state.user_id,
                      business_id: this.state.business_id,
                      attachment: atchId_docnt,
                      attachment_type: 'documents',
                      attachment_file_type: flDc_type.toString(),
                      unique_id:
                        this.state.message_edit === false
                          ? Rnunique_id_cmb
                          : this.state.Rnunique_id_cmb
                            ? this.state.Rnunique_id_cmb
                            : Rnunique_id_cmb,
                      order: '' + this.state.attachOrderIncrs_cmb + '',
                    };

                    axios.post(API_CALL_ENDPOINT + '/text/attachment/create', document_details).then((res) => {
                      console.log(res);
                      console.log(res.data.message);

                      if (res.data.status == 'success') {
                        setTimeout(() => {
                          this.colapse_all_attachments();
                        }, 1000);
                        setTimeout(() => {
                          this.colapse_all_attachments();
                        }, 2000);
                        setTimeout(() => {
                          this.colapse_all_attachments();
                        }, 3000);
                        this.setState({ messageAttachd: true });
                        $('#fileDocUsvBtn').hide();
                        var fileary = {
                          documents: flDc_detils,
                          attach_id: res.data?.result?._id,
                        };
                        this.setState({
                          atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                        });
                        var OrderIncr = this.state.attachOrderIncrs_cmb + parseInt(1);
                        this.setState({ attachOrderIncrs_cmb: OrderIncr });
                      }
                      if (res.data.error) {
                      }
                    });

                    this.setState({
                      cmb_notesedit: false,
                      notesValue2_cmb: '',
                      max_chars_notes_cmb: 1200,
                      chars_left_notes_cmb: 1200,
                    });
                    clearTimeout(this.savetimer);
                    clearTimeout(this.timer);
                    // this.colapse_all_attachments()
                    $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                    $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                    $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                    $('.sendmsg_attachmentdiv2_cmb').hide();
                    $('.attachLoading_cmb').hide();
                    this.colapse_all_attachments();
                  }
                  k++;
                }
                if (res?.data?.error?.error_type == 'invalid_file_type') {
                  let filelength = event.target && event.target.files ? event.target.files.length - 1 : 0;
                  this.setState({
                    attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb - filelength,
                  });
                  // const errors = [];
                  // errors.push('Sorry, this file is invalid. Please try using a different file.');
                  // this.setState({errors});

                  // setTimeout(() => {
                  //   this.setState({errors: []});
                  // }, 3000);
                  toast.dark('Sorry, this file is invalid. Please try using a different file.', {
                    position: 'top-right',
                    transition: Flip,
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                  this.setState({
                    cmb_notesedit: false,
                    notesValue2_cmb: '',
                    max_chars_notes_cmb: 1200,
                    chars_left_notes_cmb: 1200,
                  });
                  clearTimeout(this.savetimer);
                  clearTimeout(this.timer);
                  // $('.attachment_colapsed').show();
                  // // $('.attachment_colapsed_'+res.data?.result?.files[0]._id).hide();
                  // $('.attachment_expanded').hide();
                  // // $('.attachment_expanded_'+res.data?.result?.files[0]._id).show();

                  $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                  $('.sendmsg_attachmentdiv2_cmb').hide();
                  $('.attachLoading_cmb').hide();
                }
                $('#file-input')[0].value = '';
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response?.data?.error?.error_type == 'invalid_file_type') {
                    let filelength = event.target && event.target.files ? event.target.files.length - 1 : 0;
                    this.setState({
                      attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb - filelength,
                    });
                    // const errors = [];
                    // errors.push('Sorry, this file is invalid. Please try using a different file.');
                    // this.setState({errors});

                    // setTimeout(() => {
                    //   this.setState({errors: []});
                    // }, 3000);
                    toast.dark('Sorry, this file is invalid. Please try using a different file.', {
                      position: 'top-right',
                      transition: Flip,
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                    this.setState({
                      cmb_notesedit: false,
                      notesValue2_cmb: '',
                      max_chars_notes_cmb: 1200,
                      chars_left_notes_cmb: 1200,
                    });
                    clearTimeout(this.savetimer);
                    clearTimeout(this.timer);
                    // $('.attachment_colapsed').show();
                    // // $('.attachment_colapsed_'+res.data?.result?.files[0]._id).hide();
                    // $('.attachment_expanded').hide();
                    // // $('.attachment_expanded_'+res.data?.result?.files[0]._id).show();

                    $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                    $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                    $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                    $('.sendmsg_attachmentdiv2_cmb').hide();
                    $('.attachLoading_cmb').hide();
                  }
                }
              });
          }
        }
        this.colapse_all_attachments();
      }
    }
  };

  DocLclDlete_cmb = (event) => {
    console.log(this.state.atcharryDet_cmb);
    console.log(event.target.id);

    /*const data = this.state.atcharryDet.filter(
      i => i.documents !== event.target.id 
    )
    this.setState({ atcharryDet: data }); */

    var array = this.state.atcharryDet_cmb;
    var arrayLength = this.state.atcharryDet_cmb.length;
    for (var i = 0; i < arrayLength; i++) {
      if (array[i].documents) {
        for (var j = 0; j < array[i].documents.length; j++) {
          console.log(array[i].documents[j]);
          if (array[i].documents[j].file_id === event.target.id) {
            array[i].documents.splice(j, 1);
            docAttachmentsCount_cmb -= 1;
          }
        }
      }
    }
    this.setState({ atcharryDet_cmb: array });
    if (this.state.atcharryDet_cmb.length == 0) {
      $('.attchLstShow_cmb').hide();
    }

    setTimeout(() => {
      console.log(this.state.atcharryDet_cmb);
    }, 100);

    const attchDel_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      file_id: event.target.id,
      attachment_id: event.target.dataset.id,
    };

    axios.post(API_CALL_ENDPOINT + '/text/attachment/delete', attchDel_details).then((res) => {
      console.log(res);
      console.log(res.data.message);

      if (res.data.status == 'success') {
      }
      if (res.data.error) {
      }
    });
  };
  audioAtchDelte_cmb = (event) => {
    var array = this.state.atcharryDet_cmb;
    var arrayLength = this.state.atcharryDet_cmb.length;
    for (var i = 0; i < arrayLength; i++) {
      if (array[i]) {
        console.log(array[i]);
        if (array[i].attach_id === event.target.id) {
          array.splice(i, 1);
        }
      }
    }
    this.setState({ atcharryDet_cmb: array });
    if (this.state.atcharryDet_cmb.length == 0) {
      $('.attchLstShow_cmb').hide();
    }
    this.colapse_all_attachments();
    const attchDel_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      attachment_id: event.target.id,
    };

    axios.post(API_CALL_ENDPOINT + '/text/attachment/delete', attchDel_details).then((res) => {
      console.log(res);
      console.log(res.data.message);

      if (res.data.status == 'success') {
        this.colapse_all_attachments();
      }
      if (res.data.error) {
        this.colapse_all_attachments();
      }
    });
  };
  notesAtchDelte_cmb_edit = (id) => {
    $('.editor_cmb_' + id).hide();
    var array = this.state.atcharryDet_cmb;
    var arrayLength = this.state.atcharryDet_cmb.length;
    for (var i = 0; i < arrayLength; i++) {
      if (array[i]) {
        if (array[i].attach_id === id) {
          array.splice(i, 1);
        }
      }
    }
    this.setState({ atcharryDet_cmb: array });
    $('.notecontent_cmb_show').show();
    if (this.state.atcharryDet_cmb.length == 0) {
      $('.attchLstShow_cmb').hide();
    }

    const attchDel_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      attachment_id: id,
    };

    axios
      .post(API_CALL_ENDPOINT + '/text/attachment/delete', attchDel_details)
      .then((res) => {
        if (res.data.status == 'success') {
          // $('.sendmsg_attachmentdiv2_cmb').hide();
          // $('.sendmsgattach_clkNotes2_cmb').hide();
          // $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
          // $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
          this.setState({ cmb_notesedit: false });
          // window.scrollTo({top: 0, behavior: 'smooth'});
          this.setState({ active_edit_id: '', notesValue2_cmb: '' });
          clearTimeout(this.savetimer);
          clearTimeout(this.timer);
          this.colapse_all_attachments();
        }
        if (res.data.error) {
          this.colapse_all_attachments();
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.colapse_all_attachments();
          }
        }
      });
  };
  notesAtchDelte_cmb = (event) => {
    var array = this.state.atcharryDet_cmb;
    var arrayLength = this.state.atcharryDet_cmb.length;
    for (var i = 0; i < arrayLength; i++) {
      if (array[i]) {
        console.log(array[i]);
        if (array[i].attach_id === event.target.id) {
          array.splice(i, 1);
        }
      }
    }
    this.setState({ atcharryDet_cmb: array });
    if (this.state.atcharryDet_cmb.length == 0) {
      $('.attchLstShow_cmb').hide();
    }

    const attchDel_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      attachment_id: event.target.id,
    };

    axios
      .post(API_CALL_ENDPOINT + '/text/attachment/delete', attchDel_details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          if (this.state.active_edit_id) {
            $('.editor_cmb_' + this.state.active_edit_id).hide();
            $('.notecontent_cmb_' + this.state.active_edit_id).show();
          }

          $('.sendmsg_attachmentdiv2_cmb').hide();
          $('.sendmsgattach_clkNotes2_cmb').hide();
          $('.sendmsgattach_clkcalender_cmb').hide();
          $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
          $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
          this.setState({ cmb_notesedit: false });
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.setState({ active_edit_id: '', notesValue2_cmb: '' });
          clearTimeout(this.timer);
          clearTimeout(this.savetimer);
          this.colapse_all_attachments();
        }
        if (res.data.error) {
          this.colapse_all_attachments();
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.colapse_all_attachments();
          }
        }
      });
  };
  videAtchDelte_cmb = (event) => {
    var array = this.state.atcharryDet_cmb;
    var arrayLength = this.state.atcharryDet_cmb.length;
    for (var i = 0; i < arrayLength; i++) {
      if (array[i]) {
        console.log(array[i]);
        if (array[i].attach_id === event.target.id) {
          array.splice(i, 1);
        }
      }
    }
    this.setState({ atcharryDet_cmb: array });
    if (this.state.atcharryDet_cmb.length == 0) {
      $('.attchLstShow_cmb').hide();
    }
    this.colapse_all_attachments();
    const attchDel_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      attachment_id: event.target.id,
    };

    axios.post(API_CALL_ENDPOINT + '/text/attachment/delete', attchDel_details).then((res) => {
      console.log(res);
      console.log(res.data.message);

      if (res.data.status == 'success') {
        this.colapse_all_attachments();
      }
      if (res.data.error) {
        this.colapse_all_attachments();
      }
    });
  };

  videoLclDelte_cmb = () => {
    $('.sendmsgattach_clkVideo2_cmb').hide();
    $('.sendmsg_attachmentdiv2_cmb').hide();
  };
  documntAtchDelte_cmb = (event, attachment) => {
    var array = this.state.atcharryDet_cmb;
    var arrayLength = this.state.atcharryDet_cmb.length;
    for (var i = 0; i < arrayLength; i++) {
      if (array[i]) {
        console.log(array[i]);
        if (array[i].attach_id === event.target.id) {
          array.splice(i, 1);
        }
      }
    }
    this.setState({
      atcharryDet_cmb: array,
      attachmentdoc_count_cmb: this.state.attachmentdoc_count_cmb - attachment.length + 1,
    });
    docAttachmentsCount_cmb -= attachment.length - 1;
    if (this.state.atcharryDet_cmb.length == 0) {
      $('.attchLstShow_cmb').hide();
    }

    const attchDel_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      attachment_id: event.target.id,
    };

    axios.post(API_CALL_ENDPOINT + '/text/attachment/delete', attchDel_details).then((res) => {
      console.log(res);
      console.log(res.data.message);

      if (res.data.status == 'success') {
        this.colapse_all_attachments();
      }
      if (res.data.error) {
        this.colapse_all_attachments();
      }
    });
  };
  notesLclDelte_cmb = () => {
    $('.sendmsgattach_clkNotes2_cmb').hide();
    $('.sendmsg_attachmentdiv2_cmb').hide();
    this.setState({ cmb_notesedit: false });
    // window.scrollTo({top: 0, behavior: 'smooth'});
    this.setState({ active_edit_id: '', notesValue2_cmb: '' });
    clearTimeout(this.savetimer);
  };
  audioLclDelte_cmb = () => {
    $('.sendmsgattach_clkAudio2_cmb').hide();
    $('.sendmsg_attachmentdiv2_cmb').hide();
  };
  audioLclDelte_cmb_nft = () => {
    $('.sendmsgattach_clkAudio2_cmb').hide();
    $('.sendmsg_attachmentdiv2_cmb').hide();
  };
  dragStart_cmb(e) {
    this.dragged = e.currentTarget;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', this.dragged);
  }
  dragEnd_cmb(e) {
    this.dragged.style.display = 'block';
    // this.dragged.parentNode.removeChild(placeholder);

    // update state
    var data = this.state.atcharryDet_cmb;
    var from = Number(this.dragged.dataset.id);
    var to = Number(this.over?.dataset?.id);
    if (from < to) to--;
    if (from > to) from--;
    data.splice(to, 0, data.splice(from, 1)[0]);
    this.setState({ atcharryDet_cmb: data });
    console.log('Drag drop', this.state.atcharryDet_cmb);
    var array = data;
    var arrayLength = data.length;
    for (var i = 0; i < arrayLength; i++) {
      if (array[i]) {
        console.log(array[i]);
        const Attachment_update_order = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          order: i + 1,
          attachment_id: array[i].attach_id,
        };

        console.log(Attachment_update_order);

        axios.post(API_CALL_ENDPOINT + '/text/attachment/update', Attachment_update_order).then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            console.log('Done');
          }
          if (res.data.error) {
          }
        });
      }
    }
  }
  dragOver_cmb(e) {
    e.preventDefault();
    this.dragged.style.display = 'none';
    if (e.target.className === 'placeholder_cmb') return;
    this.over = e.target;
    e.target.parentNode.insertBefore(placeholder_cmb, e.target);
  }
  closeLightbox = () => {
    console.log('Clicked here');
    this.setState({ Lightbox_open: false });
    // $('#btnTrigger').click();
  };
  closeLightbox_video = () => {
    this.setState({ Lightbox_open_video: false });
    // $('#btnTrigger').click();
  };
  view_presignedurl = (image) => {
    console.log('image', image);
    const url = new URL(image);
    if (url.searchParams.get('object_key')) {
      const object_key = url.searchParams.get('object_key');
      const document_url_detail = {
        params: {
          object_key: object_key ? object_key : undefined,
        },
      };
      axios.get(API_CALL_ENDPOINT + '/file/presigned/url', document_url_detail).then((res) => {
        if (res.data) {
          console.log('/file/presigned/url', res.data);
          this.setState({ qr_download_link: res.data });
        }
        if (res.data.error) {
        }
      });
    }
  };
  document_read(attachment) {
    console.log('attachment_detail', attachment);
    var fileType = attachment.file_path.split('.');
    const document_url_detail = {
      params: {
        object_key: attachment.file_path ? attachment.file_path : undefined,
      },
    };

    console.log(document_url_detail);
    console.log('fileType', fileType[fileType.length - 1]);

    axios.get(API_CALL_ENDPOINT + '/file/presigned/url', document_url_detail).then((res) => {
      // console.log("/file/presigned/url",res)
      if (res.data) {
        console.log('/file/presigned/url', res.data);

        this.setState({
          document_url: res.data,
          Lightbox_open:
            fileType[fileType.length - 1] === 'jpg' ||
              fileType[fileType.length - 1] === 'jpeg' ||
              fileType[fileType.length - 1] === 'png'
              ? true
              : false,
        });

        // fileType[fileType.length - 1] === "jpg" ||
        // fileType[fileType.length - 1] === "jpeg" ||
        // fileType[fileType.length - 1] === "png"
        //   ? null
        //   : fileType[fileType.length - 1] === "pdf" ||
        //     fileType[fileType.length - 1] === "PDF"
        //   ? AsyncStorage.setItem("PDF_View_url", res.data) &&
        //     window.open(
        //       "http://" + window.location.href.split("/")[2] + "/pdf_viewer/",
        //       "_blank"
        //     )
        //   : window.open(res.data, "_blank");
        if (
          fileType[fileType.length - 1] === 'jpg' ||
          fileType[fileType.length - 1] === 'jpeg' ||
          fileType[fileType.length - 1] === 'png'
        ) {
          // null
        } else if (fileType[fileType.length - 1] === 'pdf' || fileType[fileType.length - 1] === 'PDF') {
          AsyncStorage.setItem('PDF_View_url', res.data);
          window.open('http://' + window.location.href.split('/')[2] + '/pdf_viewer/', '_blank');
        } else {
          window.open(res.data, '_blank');
        }
        // window.open(res.data, "_blank")
      }
      if (res.data.error) {
      }
    });
  }
  document_read_auto(attachment) {
    console.log('attachment_detail', attachment);
    var fileType = attachment.file_path.split('.');
    const document_url_detail = {
      params: {
        object_key: attachment.file_path ? attachment.file_path : undefined,
      },
    };

    console.log(document_url_detail);
    console.log('fileType', fileType[fileType.length - 1]);

    axios.get(API_CALL_ENDPOINT + '/file/presigned/url', document_url_detail).then((res) => {
      // console.log("/file/presigned/url",res)
      if (res.data) {
        console.log('/file/presigned/url', res.data);

        this.setState({
          document_url: res.data,
          Lightbox_open:
            fileType[fileType.length - 1] === 'jpg' ||
              fileType[fileType.length - 1] === 'jpeg' ||
              fileType[fileType.length - 1] === 'png'
              ? true
              : false,
        });

        // fileType[fileType.length - 1] === "jpg" ||
        // fileType[fileType.length - 1] === "jpeg" ||
        // fileType[fileType.length - 1] === "png"
        //   ? null
        //   : fileType[fileType.length - 1] === "pdf" ||
        //     fileType[fileType.length - 1] === "PDF"
        //   ? AsyncStorage.setItem("PDF_View_url", res.data) &&
        //     window.open(
        //       "http://" + window.location.href.split("/")[2] + "/pdf_viewer/",
        //       "_blank"
        //     )
        //   : window.open(res.data, "_blank");
        if (
          fileType[fileType.length - 1] === 'jpg' ||
          fileType[fileType.length - 1] === 'jpeg' ||
          fileType[fileType.length - 1] === 'png'
        ) {
          // null
          $('.auto_txt_model_close').click();
          // $('.modal_template_confirmation_close').click();
        } else if (fileType[fileType.length - 1] === 'pdf' || fileType[fileType.length - 1] === 'PDF') {
          AsyncStorage.setItem('PDF_View_url', res.data);
          window.open('http://' + window.location.href.split('/')[2] + '/pdf_viewer/', '_blank');
        } else {
          window.open(res.data, '_blank');
        }
        // window.open(res.data, "_blank")
      }
      if (res.data.error) {
      }
    });
  }

  audioPly_temp = (attachment) => {
    if (this.state.audio_play_id) {
      this.audioStop();
    }
    console.log('attachment_detail', attachment);

    var PlyIdn = attachment._id;

    var playx = document.getElementById('audio_temp_' + attachment._id);
    const audio_url_detail = {
      params: {
        object_key: attachment.file_path,
        // attachment.file_path.split(".")[1] === "mp3" ||
        // attachment.file_path.split(".")[1] === "mp4"
        //   ? attachment.file_path
        //   : attachment.second_file_path,
      },
    };

    console.log(audio_url_detail);

    axios.get(API_CALL_ENDPOINT + '/file/presigned/url', audio_url_detail).then((res) => {
      // console.log("/file/presigned/url",res)
      if (res.data) {
        console.log('/file/presigned/url', res.data);

        this.setState({
          play_audio_url: res.data,
          audio_play_id: attachment._id,
        });
        playx.play();
        $('.audio_temp_' + attachment._id).show();
        $('.adiPlyICn_' + attachment._id).hide();
      }
      if (res.data.error) {
      }
    });

    $('.adiPusIcn_' + attachment._id).hide();
    playx.onended = function () {
      $('.adiPusIcn_' + PlyIdn).hide();
      $('.adiPlyICn_' + PlyIdn).show();
      $('.audio_temp_' + PlyIdn).hide();
    };
  };
  audioPly_work = (attachment) => {
    if (this.state.audio_play_id) {
      this.audioStop();
    }
    console.log('attachment_detail', attachment);

    var PlyIdn = attachment._id;

    var playx = document.getElementById('audio_work_' + attachment._id);
    const audio_url_detail = {
      params: {
        object_key: attachment.file_path,
        // attachment.file_path.split(".")[1] === "mp3" ||
        // attachment.file_path.split(".")[1] === "mp4"
        //   ? attachment.file_path
        //   : attachment.second_file_path,
      },
    };

    console.log(audio_url_detail);

    axios.get(API_CALL_ENDPOINT + '/file/presigned/url', audio_url_detail).then((res) => {
      // console.log("/file/presigned/url",res)
      if (res.data) {
        console.log('/file/presigned/url', res.data);

        this.setState({
          play_audio_url: res.data,
          audio_play_id: attachment._id,
        });
        playx.play();
        $('#audio_work_' + attachment._id).show();
        $('.adiPlyICn_' + attachment._id).hide();
      }
      if (res.data.error) {
      }
    });

    $('.adiPusIcn_' + attachment._id).hide();
    playx.onended = function () {
      $('.adiPusIcn_' + PlyIdn).hide();
      $('.adiPlyICn_' + PlyIdn).show();
      $('#audio_work_' + PlyIdn).hide();
    };
  };
  audioPly = (attachment) => {
    if (this.state.audio_play_id) {
      this.audioStop();
    }
    console.log('attachment_detail', attachment);

    var PlyIdn = attachment._id;

    var playx = document.getElementById('audio_' + attachment._id);
    const audio_url_detail = {
      params: {
        object_key: attachment.file_path,
        // attachment.file_path.split(".")[1] === "mp3" ||
        // attachment.file_path.split(".")[1] === "mp4"
        //   ? attachment.file_path
        //   : attachment.second_file_path,
      },
    };

    console.log(audio_url_detail);

    axios.get(API_CALL_ENDPOINT + '/file/presigned/url', audio_url_detail).then((res) => {
      // console.log("/file/presigned/url",res)
      if (res.data) {
        console.log('/file/presigned/url', res.data);

        this.setState({
          play_audio_url: res.data,
          audio_play_id: attachment._id,
        });
        playx.play();
        $('#audio_' + attachment._id).show();
        $('.adiPlyICn_' + attachment._id).hide();
      }
      if (res.data.error) {
      }
    });

    $('.adiPusIcn_' + attachment._id).hide();
    playx.onended = function () {
      $('.adiPusIcn_' + PlyIdn).hide();
      $('.adiPlyICn_' + PlyIdn).show();
      $('#audio_' + PlyIdn).hide();
    };
  };

  audioPaue = (e) => {
    var pausex = document.getElementById('audio_' + e.target.id);
    pausex.pause();
    $('.adiPusIcn_' + e.target.id).hide();
    $('.adiPlyICn_' + e.target.id).show();
    $('#audio_' + e.target.id).hide();
  };
  audioStop() {
    if (this.state.audio_play_id) {
      //   var pausex = document.getElementById("audio_" + this.state.audio_play_id);
      //   pausex.pause();
      $('.adiPusIcn_tostop').hide();
      $('.adiPlyICn_toshow').show();
      $('#audio_' + this.state.audio_play_id).hide();
    }
  }
  Video_play_url(attachment) {
    console.log('attachment_detail', attachment);
    const document_url_detail = {
      params: {
        object_key: attachment.file_path,
        // attachment.file_path.split(".")[1] == "mp4"
        //   ? attachment.file_path
        //   : attachment.second_file_path,
      },
    };

    console.log(document_url_detail);

    axios.get(API_CALL_ENDPOINT + '/file/presigned/url', document_url_detail).then((res) => {
      // console.log("/file/presigned/url",res)
      if (res.data) {
        console.log('/file/presigned/url', res.data);

        this.setState({
          video_play_link: res.data,
          Lightbox_open_video: true,
        });

        // window.open(res.data, "_blank")
      }
      if (res.data.error) {
      }
    });
  }
  tagonChange_send = (e) => {
    const values = [...e.target.selectedOptions].map((opt) => opt.value);

    this.setState({
      qr_filtered_tag_list: values,
    });
  };
  tagonChange_chat = (e) => {
    const values = [...e.target.selectedOptions].map((opt) => opt.value);

    this.setState({
      chat_filtered_tag_list: values,
    });
  };
  chkAllTem_chat = () => {
    if ($('#allteam_chat').is(':checked')) {
      for (var i in this.state.TemIdsMebrArry_chat) {
        $('.chatTmIds_' + this.state.TemIdsMebrArry_chat[i]).prop('checked', true);
      }
    } else {
      for (var i in this.state.TemIdsMebrArry_chat) {
        $('.chatTmIds_' + this.state.TemIdsMebrArry_chat[i]).prop('checked', false);
      }
    }
  };
  pschat_addtagname = () => {
    $('.pschat_entertagname_drpdwn_div').hide();
    $('.pschat_entertagname_txtbx_div').show();
    this.setState({ chat_addtag_save: true });
  };

  pschat_closeaddtagname = () => {
    $('.pschat_entertagname_txtbx_div').hide();
    $('.pschat_entertagname_drpdwn_div').show();
    this.setState({ chat_addtag_save: false });
  };

  copy_chat_link = () => {
    let textarea = document.getElementById('chat_script_link');
    textarea.select();
    document.execCommand('copy');
    this.setState(() => ({
      ChatGrtMsg: 'Link Copied Successfully',
      ChatGrtcls: 'alert alert-success text-center',
    }));
    window.scrollTo(0, 0);
    setTimeout(() => {
      this.setState(() => ({
        ChatGrtMsg: '',
        ChatGrtcls: '',
      }));
    }, 5000);
  };

  save_chat_details = () => {
    // console.log(this.state.TemIdsMebrArry_chat);
    var tmArry = [];
    for (var i in this.state.TemIdsMebrArry_chat) {
      if ($('.chatTmIds_' + this.state.TemIdsMebrArry_chat[i]).is(':checked')) {
        var chdTmids = $('.chatTmIds_' + this.state.TemIdsMebrArry_chat[i]).attr('id');
        // console.log(chdTmids.split('_')[1]);
        tmArry.push(chdTmids.split('_')[1]);
      }
    }

    // console.log('Checked Team List: ' + tmArry);
    var chkTmIdDe = tmArry.filter((value) => value);
    var chkTmIdDetails = chkTmIdDe.toString();
    let chat_filtered_tag_list_new = this.state.chat_filtered_tag_list;
    if (this.state.chat_addtag_save === true) {
      // console.log("newtagname",this.state.newtagname)
      const createtag = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tag_name: this.state.chat_newtag,
        tag_source: 'contacts',
      };
      console.log('createtag', createtag);
      axios
        .post(API_CALL_ENDPOINT + '/tags/create', createtag)
        .then((res) => {
          console.log(res.data);
          if (res.data.status === 'success') {
            if (chat_filtered_tag_list_new.indexOf(res.data?.result?._id) === -1) {
              chat_filtered_tag_list_new.push(res.data?.result?._id);
              // console.log(qr_filtered_tag_list_new);
            }
            // qr_newtag_id = ',' + res.data?.result?._id;
          } else if (res.data.status === 'conflict') {
            if (chat_filtered_tag_list_new.indexOf(res.data?.result?.details._id) === -1) {
              chat_filtered_tag_list_new.push(res.data?.result?.details._id);
              // console.log(qr_filtered_tag_list_new);
            }
            // qr_newtag_id = ',' + res.data?.result?.details._id;
          }
          const chat_upDetails = {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            tags: chat_filtered_tag_list_new.toString(),
            team_id: chkTmIdDetails,
            nick_name: undefined,
            greeting: this.state.chat_grtmsg,
            reply_message: this.state.chat_replymsg,
            new_contact_message: this.state.chat_newcontactmsg,
            existing_contact_message: this.state.chat_existcontactmsg,
          };
          console.log('inside', chat_upDetails);
          axios
            .post(API_CALL_ENDPOINT + '/chat/widget/update', chat_upDetails)
            .then((res) => {
              if (res.data.status == 'success') {
                console.log('outside', res.data);
                window.scrollTo(0, 0);
                this.setState(() => ({
                  ChatGrtMsg: res.data.message,
                  ChatGrtcls: 'alert alert-success',
                }));

                setTimeout(() => {
                  this.setState(() => ({
                    ChatGrtMsg: '',
                    ChatGrtcls: '',
                  }));
                }, 5000);
              } else if (res.data.error) {
                this.setState(() => ({
                  ChatGrtMsg: res.data.error.message,
                  ChatGrtcls: 'alert alert-danger',
                }));
                window.scrollTo(0, 0);
                setTimeout(() => {
                  this.setState(() => ({
                    ChatGrtMsg: '',
                    ChatGrtcls: '',
                  }));
                }, 5000);
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.data.error) {
                  this.setState(() => ({
                    ChatGrtMsg: error.response.data.error.message,
                    ChatGrtcls: 'alert alert-danger',
                  }));
                  window.scrollTo(0, 0);
                  setTimeout(() => {
                    this.setState(() => ({
                      ChatGrtMsg: '',
                      ChatGrtcls: '',
                    }));
                  }, 5000);
                }
              }
            });
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'conflict') {
              if (chat_filtered_tag_list_new.indexOf(error.response.data?.result?.details._id) === -1) {
                chat_filtered_tag_list_new.push(error.response.data?.result?.details._id);
                // console.log(qr_filtered_tag_list_new);
              }
              // qr_newtag_id = ',' + res.data?.result?.details._id;
            }
          }
        });
    } else {
      const chat_upDetails = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tags: chat_filtered_tag_list_new.toString(),
        team_id: chkTmIdDetails,
        nick_name: undefined,
        greeting: this.state.chat_grtmsg,
        reply_message: this.state.chat_replymsg,
        new_contact_message: this.state.chat_newcontactmsg,
        existing_contact_message: this.state.chat_existcontactmsg,
      };
      console.log('outside', chat_upDetails);
      axios
        .post(API_CALL_ENDPOINT + '/chat/widget/update', chat_upDetails)
        .then((res) => {
          if (res.data.status == 'success') {
            console.log('outside', res.data);

            this.setState(() => ({
              ChatGrtMsg: res.data.message,
              ChatGrtcls: 'alert alert-success',
            }));
            window.scrollTo(0, 0);
            setTimeout(() => {
              this.setState(() => ({
                ChatGrtMsg: '',
                ChatGrtcls: '',
              }));
            }, 5000);
          } else if (res.data.error) {
            this.setState(() => ({
              ChatGrtMsg: res.data.error.message,
              ChatGrtcls: 'alert alert-danger',
            }));
            window.scrollTo(0, 0);
            setTimeout(() => {
              this.setState(() => ({
                ChatGrtMsg: '',
                ChatGrtcls: '',
              }));
            }, 5000);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error) {
              this.setState(() => ({
                ChatGrtMsg: error.response.data.error.message,
                ChatGrtcls: 'alert alert-danger',
              }));
              window.scrollTo(0, 0);
              setTimeout(() => {
                this.setState(() => ({
                  ChatGrtMsg: '',
                  ChatGrtcls: '',
                }));
              }, 5000);
            }
          }
        });
    }
  };
  getExtensionFromUrl = (url = '') => {
    if (url) {
      let urlPathArray = url.split('/');
      let extArr = urlPathArray[urlPathArray.length - 1].split('.');
      let extension = extArr[extArr.length - 1];
      return extension;
    }
    return null;
  };
  bytesToKb = (bytes) => {
    let KB = bytes / Math.pow(1024, 1);
    let KBSplit = KB.toString().split('.')[0];
    return KBSplit;
  };
  toHHMMSS = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map((v) => (v < 10 ? '0' + v : v))
      .filter((v, i) => v !== '00' || i > 0)
      .join(':');
  };
  dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  handleJoyrideCallback = (data) => {
    AsyncStorage.setItem('tour_firsttime', '');
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      if (index + (action === ACTIONS.PREV ? -1 : 1) === 4) {
        $('#custom-tabs-general-tab').removeClass('active');
        $('#custom-tabs-integrations-tab').removeClass('active');
        $('#custom-tabs-autoresponse-tab').addClass('active');
        $('#custom-tabs-general').removeClass('active show');
        $('#custom-tabs-integrations').removeClass('active show');
        $('#custom-tabs-autoresponse').addClass('active show');
        $('#custom-tabs-packs-tab').removeClass('active');
        $('#custom-tabs-packs').removeClass('active');
        $('#custom-tabs-workflow').removeClass('active show');
        $('#custom-tabs-workflow-tab').removeClass('active');
        $('#custom-tabs-templates-tab').removeClass('active');
        $('#custom-tabs-templates').removeClass('active');
      }
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      this.setState({ run: false });
    }

    console.groupCollapsed(type);
    console.log(data); //eslint-disable-line no-console
    console.groupEnd();
  };
  update = (value) => {
    return () => {
      this.setState({
        run: value,
      });
    };
  };

  cart_update = (value) => {
    if (value === 'true') {
      const cart_list = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };

      axios.get(API_CALL_ENDPOINT + '/booster/cart/list', cart_list).then((res) => {
        console.log('/booster/cart/list', res.data);
        if (res.data.result) {
          let price_quantity_list = [...this.state.price_quantity_list];
          let order_amount = 0;
          let order_doller = 0;
          let exist_cart_id = [];
          for (let i = 0; i < res.data?.result?.length; i++) {
            const item = res.data.result[i];

            let selectedQlist = price_quantity_list.find((x) => x._id === item.master_pack_id);
            selectedQlist.quantity = item.pack_quantity;

            var removeIndex = price_quantity_list.map((listitem) => listitem._id).indexOf(item.master_pack_id);
            price_quantity_list.splice(removeIndex, 1);
            price_quantity_list = [...price_quantity_list, selectedQlist];
            // order_amount = order_amount.push("'" + res.data?.result[i]?.order_amount + "'");

            order_amount += res.data?.result[i]?.order_amount;
            order_doller += parseInt(res.data?.result[i]?.order_doller);
            // order_amount = order_amount.join(', ');
            // exist_cart_id = exist_cart_id.push("'" + res.data?.result[i]?._id + "'");
            exist_cart_id = [...exist_cart_id, res.data?.result[i]?._id];
            // exist_cart_id = exist_cart_id.join(', ');
          }
          console.log('price_quantity_list', price_quantity_list);
          this.setState({
            price_quantity_list,
            order_amount,
            exist_cart_id,
            order_doller,
          });

          this.setState({ packcart_list: res.data.result });
        } else if (res.data.status == 'no_record') {
          this.setState({
            pack_quantity_message: 1,
            order_data_count: '',
            order_doller: '',
            packcart_list: [],
            exist_cart_id: '',
          });
          $('.choosepackdtls_div').show();
          $('.creditcarddtls_div').hide();
        }
      });
    }
  };

  save_email_integrations = () => {
    var tmArry = [];
    for (var i in this.state.TemIdsMebrArry) {
      if ($('.emailteam' + this.state.TemIdsMebrArry[i]).is(':checked')) {
        tmArry.push(this.state.TemIdsMebrArry[i]);
      }
    }

    var chkTmIdDe = tmArry.filter((value) => value);
    var chkTmIdDetails = chkTmIdDe.toString();
    console.log('Checked Team List: ' + chkTmIdDetails);
    const emailint_Details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      email_address: this.state.business_email_name + APP_EMAIL_ENDPOINT,
      setup: 'integration_email',
      team_id: chkTmIdDetails,
    };

    console.log(emailint_Details);
    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', emailint_Details)
      .then((res) => {
        console.log(res);
        console.log(res.data.message);

        if (res.data.status == 'success') {
          this.setState({ business_email_address: this.state.business_email_name + APP_EMAIL_ENDPOINT });

          $('.profemailaddr_dsplydiv').show();
          $('.profemailaddr_upddiv').hide();
          this.setState(() => ({
            EmlAlrtMsg: res.data.message,
            EmlAlrtCls: 'alert alert-success',
          }));

          setTimeout(() => {
            this.setState(() => ({
              EmlAlrtMsg: '',
              EmlAlrtCls: '',
            }));
          }, 5000);
        } else if (res.data.error) {
          this.setState(() => ({
            EmlAlrtMsg: res.data.error.message,
            EmlAlrtCls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              EmlAlrtMsg: '',
              EmlAlrtCls: '',
            }));
          }, 5000);
        } else if (res.data.status == 'conflict') {
          this.setState(() => ({
            EmlAlrtMsg: res.data.message,
            EmlAlrtCls: 'alert alert-danger',
          }));

          setTimeout(() => {
            this.setState(() => ({
              EmlAlrtMsg: '',
              EmlAlrtCls: '',
            }));
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status == 'conflict') {
            this.setState(() => ({
              EmlAlrtMsg: error.response.data.message,
              EmlAlrtCls: 'alert alert-danger',
            }));

            setTimeout(() => {
              this.setState(() => ({
                EmlAlrtMsg: '',
                EmlAlrtCls: '',
              }));
            }, 5000);
          }
        }
      });
  };
  onChangebusiness = (business) => {
    console.log(business.business._id);
    AsyncStorage.setItem('business_id', business.business._id);
    window.location.reload(true);
  };
  getQuantity = (pack, _id) => {
    if (this.state.price_quantity_list?.length > 0) {
      let selectedQlist = this.state.price_quantity_list.find((x) => x._id === _id);
      return selectedQlist.quantity;
    } else {
      return 1;
    }
  };
  getQuantity_cart = (pack, _id) => {
    if (this.state.price_quantity_list?.length > 0) {
      let selectedQlist = this.state.price_quantity_list.find((x) => x?._id === _id);

      return selectedQlist?.quantity;
    } else {
      return 1;
    }
  };
  onupdatecart_add = (pack, _id) => {
    this.setState({
      boosterpack_active_id: _id,
    });
    if (this.state.boosterpack_active_id === _id) {
      let price_quantity_list = [...this.state.price_quantity_list];
      let selectedQlist = price_quantity_list.find((x) => x._id === _id);
      selectedQlist.quantity = selectedQlist.quantity + 1;

      var removeIndex = price_quantity_list.map((item) => item._id).indexOf(_id);
      price_quantity_list.splice(removeIndex, 1);
      price_quantity_list = [...price_quantity_list, selectedQlist];

      this.setState({
        pack_quantity_message: this.state.pack_quantity_message + 1,
        price_quantity_list,
      });
    }
  };
  onupdatecart_delete = (pack, _id) => {
    this.setState({
      boosterpack_active_id: _id,
    });
    if (this.state.boosterpack_active_id === _id) {
      let price_quantity_list = [...this.state.price_quantity_list];
      let selectedQlist = price_quantity_list.find((x) => x._id === _id);
      selectedQlist.quantity = selectedQlist.quantity !== 1 ? selectedQlist.quantity - 1 : selectedQlist.quantity;

      var removeIndex = price_quantity_list.map((item) => item._id).indexOf(_id);
      price_quantity_list.splice(removeIndex, 1);
      price_quantity_list = [...price_quantity_list, selectedQlist];

      this.setState({
        pack_quantity_message:
          this.state.pack_quantity_message !== 1
            ? this.state.pack_quantity_message - 1
            : this.state.pack_quantity_message,
        price_quantity_list,
      });
    }
  };
  onupdatecart_add_cart = (pack, _id) => {
    this.onupdatecart_add(pack, _id);
    const Add_cart = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      master_pack_id: _id,
      pack_quantity: this.getQuantity_cart(pack, _id),
    };

    axios.post(API_CALL_ENDPOINT + '/booster/add/cart', Add_cart).then((res) => {
      if (res.data.status == 'success') {
        console.log('res.data', res.data);
        const cart_list = {
          params: {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
          },
        };

        axios.get(API_CALL_ENDPOINT + '/booster/cart/list', cart_list).then((res) => {
          console.log('/booster/cart/list', res.data);
          if (res.data.result) {
            let price_quantity_list = [...this.state.price_quantity_list];
            let order_amount = 0;
            let order_doller = 0;
            let exist_cart_id = [];
            for (let i = 0; i < res.data?.result?.length; i++) {
              const item = res.data.result[i];

              let selectedQlist = price_quantity_list.find((x) => x._id === item.master_pack_id);
              selectedQlist.quantity = item.pack_quantity;

              var removeIndex = price_quantity_list.map((listitem) => listitem._id).indexOf(item.master_pack_id);
              price_quantity_list.splice(removeIndex, 1);
              price_quantity_list = [...price_quantity_list, selectedQlist];
              // order_amount = order_amount.push("'" + res.data?.result[i]?.order_amount + "'");

              order_amount += res.data?.result[i]?.order_amount;
              order_doller += parseInt(res.data?.result[i]?.order_doller);
              // order_amount = order_amount.join(', ');
              // exist_cart_id = exist_cart_id.push("'" + res.data?.result[i]?._id + "'");
              exist_cart_id = [...exist_cart_id, res.data?.result[i]?._id];
              // exist_cart_id = exist_cart_id.join(', ');
            }
            console.log('price_quantity_list', price_quantity_list);
            this.setState({
              price_quantity_list,
              order_amount,
              exist_cart_id,
              order_doller,
            });
            // for (var i in res.data?.result) {
            //   if (res.data?.result[i]?.pack_type === 'message') {
            //     this.setState({
            //       pack_quantity_message: res.data?.result[i]?.pack_quantity,
            //       order_data_count: res.data?.result[i]?.order_data_count,
            //       order_doller: res.data?.result[i]?.order_doller,
            //       order_amount: res.data?.result[i]?.order_amount,
            //       exist_cart_id: res.data?.result[i]?._id,
            //     });
            //   }
            // }

            this.setState({ packcart_list: res.data.result });
          } else if (res.data.status == 'no_record') {
          }
        });
      }
      if (res.data.error) {
        console.log('res.data.error', res.data.error);
      }
    });
  };
  onupdatecart_delete_cart = (pack, _id) => {
    this.onupdatecart_delete(pack, _id);
    const Add_cart = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      master_pack_id: _id,
      pack_quantity: this.getQuantity_cart(pack, _id),
    };

    axios.post(API_CALL_ENDPOINT + '/booster/add/cart', Add_cart).then((res) => {
      if (res.data.status == 'success') {
        console.log('res.data', res.data);
        const cart_list = {
          params: {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
          },
        };

        axios.get(API_CALL_ENDPOINT + '/booster/cart/list', cart_list).then((res) => {
          console.log('/booster/cart/list', res.data);
          if (res.data.result) {
            let price_quantity_list = [...this.state.price_quantity_list];
            let order_amount = 0;
            let order_doller = 0;
            let exist_cart_id = [];
            for (let i = 0; i < res.data?.result?.length; i++) {
              const item = res.data.result[i];

              let selectedQlist = price_quantity_list.find((x) => x._id === item.master_pack_id);
              selectedQlist.quantity = item.pack_quantity;

              var removeIndex = price_quantity_list.map((listitem) => listitem._id).indexOf(item.master_pack_id);
              price_quantity_list.splice(removeIndex, 1);
              price_quantity_list = [...price_quantity_list, selectedQlist];
              // order_amount = order_amount.push("'" + res.data?.result[i]?.order_amount + "'");

              order_amount += res.data?.result[i]?.order_amount;
              order_doller += parseInt(res.data?.result[i]?.order_doller);
              // order_amount = order_amount.join(', ');
              // exist_cart_id = exist_cart_id.push("'" + res.data?.result[i]?._id + "'");
              exist_cart_id = [...exist_cart_id, res.data?.result[i]?._id];
              // exist_cart_id = exist_cart_id.join(', ');
            }
            console.log('price_quantity_list', price_quantity_list);
            this.setState({
              price_quantity_list,
              order_amount,
              exist_cart_id,
              order_doller,
            });
            // for (var i in res.data?.result) {
            //   if (res.data?.result[i]?.pack_type === 'message') {
            //     this.setState({
            //       pack_quantity_message: res.data?.result[i]?.pack_quantity,
            //       order_data_count: res.data?.result[i]?.order_data_count,
            //       order_doller: res.data?.result[i]?.order_doller,
            //       order_amount: res.data?.result[i]?.order_amount,
            //       exist_cart_id: res.data?.result[i]?._id,
            //     });
            //   }
            // }

            this.setState({ packcart_list: res.data.result });
          } else if (res.data.status == 'no_record') {
          }
        });
      }
      if (res.data.error) {
        console.log('res.data.error', res.data.error);
      }
    });
  };
  add_to_cart(pack, _id) {
    console.log('add_to_cart', pack);
    const Add_cart = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      master_pack_id: _id,
      pack_quantity: this.getQuantity(pack, _id),
    };
    console.log('Add_cart', Add_cart);

    axios.post(API_CALL_ENDPOINT + '/booster/add/cart', Add_cart).then((res) => {
      if (res.data.status == 'success') {
        if (res.data.message === 'Addtocart updated successfully') {
        } else {
          toast.dark(pack.pack_name + ' ' + 'has been added to your cart successfully', {
            position: 'top-right',
            transition: Flip,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        console.log('res.data', res.data);
        const cart_list = {
          params: {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
          },
        };

        axios.get(API_CALL_ENDPOINT + '/booster/cart/list', cart_list).then((res) => {
          console.log('/booster/cart/list', res.data);
          if (res.data.result) {
            let price_quantity_list = [...this.state.price_quantity_list];
            let order_amount = 0;
            let order_doller = 0;
            let exist_cart_id = [];
            for (let i = 0; i < res.data?.result?.length; i++) {
              const item = res.data.result[i];

              let selectedQlist = price_quantity_list.find((x) => x._id === item.master_pack_id);
              selectedQlist.quantity = item.pack_quantity;

              var removeIndex = price_quantity_list.map((listitem) => listitem._id).indexOf(item.master_pack_id);
              price_quantity_list.splice(removeIndex, 1);
              price_quantity_list = [...price_quantity_list, selectedQlist];
              // order_amount = order_amount.push("'" + res.data?.result[i]?.order_amount + "'");

              order_amount += res.data?.result[i]?.order_amount;
              order_doller += parseInt(res.data?.result[i]?.order_doller);
              // order_amount = order_amount.join(', ');
              // exist_cart_id = exist_cart_id.push("'" + res.data?.result[i]?._id + "'");
              exist_cart_id = [...exist_cart_id, res.data?.result[i]?._id];
              // exist_cart_id = exist_cart_id.join(', ');
            }
            console.log('price_quantity_list', price_quantity_list);
            this.setState({
              price_quantity_list,
              order_amount,
              exist_cart_id,
              order_doller,
            });
            // for (var i in res.data?.result) {
            //   if (res.data?.result[i]?.pack_type === 'message') {
            //     this.setState({
            //       pack_quantity_message: res.data?.result[i]?.pack_quantity,
            //       order_data_count: res.data?.result[i]?.order_data_count,
            //       order_doller: res.data?.result[i]?.order_doller,
            //       order_amount: res.data?.result[i]?.order_amount,
            //       exist_cart_id: res.data?.result[i]?._id,
            //     });
            //   }
            // }

            this.setState({ packcart_list: res.data.result });
          } else if (res.data.status == 'no_record') {
          }
        });
      }
      if (res.data.error) {
        console.log('res.data.error', res.data.error);
      }
    });
  }

  delete_cart_pack = (pack) => {
    const delete_cart = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      cart_id: pack._id,
    };

    axios.post(API_CALL_ENDPOINT + '/booster/cart/delete', delete_cart).then((res) => {
      if (res.data.status == 'success') {
        const cart_list = {
          params: {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
          },
        };

        axios
          .get(API_CALL_ENDPOINT + '/booster/cart/list', cart_list)
          .then((res) => {
            console.log('/booster/cart/list', res.data);
            if (res.data.result) {
              let price_quantity_list = [...this.state.price_quantity_list];
              let order_amount = 0;
              let order_doller = 0;
              let exist_cart_id = [];
              for (let i = 0; i < res.data?.result?.length; i++) {
                const item = res.data.result[i];

                let selectedQlist = price_quantity_list.find((x) => x._id === item.master_pack_id);
                selectedQlist.quantity = item.pack_quantity;

                var removeIndex = price_quantity_list.map((listitem) => listitem._id).indexOf(item.master_pack_id);
                price_quantity_list.splice(removeIndex, 1);
                price_quantity_list = [...price_quantity_list, selectedQlist];
                // order_amount = order_amount.push("'" + res.data?.result[i]?.order_amount + "'");

                order_amount += res.data?.result[i]?.order_amount;
                order_doller += parseInt(res.data?.result[i]?.order_doller);
                // order_amount = order_amount.join(', ');
                // exist_cart_id = exist_cart_id.push("'" + res.data?.result[i]?._id + "'");
                exist_cart_id = [...exist_cart_id, res.data?.result[i]?._id];
                // exist_cart_id = exist_cart_id.join(', ');
              }
              console.log('price_quantity_list', price_quantity_list);
              this.setState({
                price_quantity_list,
                order_amount,
                exist_cart_id,
                order_doller,
              });

              this.setState({ packcart_list: res.data.result });
            } else if (res.data.status == 'no_record') {
              this.setState({
                pack_quantity_message: 1,
                order_data_count: '',
                order_doller: '',
                packcart_list: [],
                exist_cart_id: '',
              });
              $('.choosepackdtls_div').show();
              $('.creditcarddtls_div').hide();
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.status == 'no_record') {
                this.setState({
                  pack_quantity_message: 1,
                  order_data_count: '',
                  order_doller: '',
                  packcart_list: [],
                  exist_cart_id: '',
                });
                $('.choosepackdtls_div').show();
                $('.creditcarddtls_div').hide();
              }
            }
          });
      }
      if (res.data.error) {
        console.log('res.data.error', res.data.error);
      }
    });
  };
  proceed_checkout = () => {
    $('.choosepackdtls_div').hide();
    $('.creditcarddtls_div').show();
  };
  onChangecard_id = (e) => {
    if (e.target.value == 'Select') {
      this.setState({ existcard_id: '' });
    } else {
      this.setState({ existcard_id: e.target.value });
    }
  };
  onChangecardnumber = (e) => {
    e.target.value = e.target.value
      .replace(/[^\dA-Z]/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim();
    this.setState({ card_number: e.target.value });
  };
  onChangecardname = (e) => {
    // const errors = [];
    var regx = /^[a-zA-Z\s]*$/;
    if (regx.test(e.target.value)) {
      this.setState({ card_name: e.target.value });
    }
    // e.target.value = e.target.value.replace(/^[A-Za-z ]+$/,'').replace(/[^\d\/]/g,'').trim();
    // e.target.value = e.target.value.replace(/^([a-zA-Z0-9 _-]+)$/, '').trim();
    // this.setState({ card_name: e.target.value })
  };
  onChangeexpdate = (e) => {
    e.target.value = e.target.value
      .replace(/^(\d\d)(\d)$/g, '$1/$2')
      .replace(/[^\d\/]/g, '')
      .trim();
    this.setState({ exp_date: e.target.value });
  };
  onChangecvc = (e) => {
    // const re = /^[0-9\b]+$/;
    e.target.value = e.target.value
      .replace(/[^\dA-Z]/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim();
    this.setState({ cvc: e.target.value });
  };
  onPayexistCard = (e) => {
    e.preventDefault();
    const existcardpayment = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      // card_id: this.state.existcard_id,
      cart_id: this.state.exist_cart_id.toString(),
      invoice_amount: this.state.order_amount.toString(),
    };
    // console.log(existcardpayment);
    // return;

    axios
      .post(API_CALL_ENDPOINT + '/booster/payment/create', existcardpayment)
      .then((res) => {
        console.log(res.data);
        if (res.data.status == 'success') {
          window.location.href = res?.data?.result?.url;
          this.setState({
            isLoading: false,
            cartmsg: res.data.message,
            cartcls: 'alert alert-success text-center',
          });
          setTimeout(() => {
            this.setState({ cartmsg: '', cartcls: '' });
            this.setState({
              pack_quantity_message: 1,
              order_data_count: '',
              order_doller: '',
              packcart_list: [],
              exist_cart_id: '',
            });
            this.setState({ cart_updated_count: this.state.cart_updated_count + 1 });
            $('.choosepackdtls_div').show();
            $('.creditcarddtls_div').hide();
          }, 5000);
        } else if (res.data.error) {
          this.setState({
            isLoading: false,
            cartmsg: res.data.error.message,
            cartcls: 'alert alert-danger text-center',
          });
          setTimeout(() => {
            this.setState({ cartmsg: '', cartcls: '' });
          }, 5000);
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.error) {
            this.setState({
              isLoading: false,
              cartmsg: error.response.data.error.message,
              cartcls: 'alert alert-danger text-center',
            });
            setTimeout(() => {
              this.setState({ cartmsg: '', cartcls: '' });
            }, 5000);
          }
        }
      });
  };
  paymentonSubmit(e) {
    this.setState({ isLoading: true });
    e.preventDefault();
    const { card_name, card_number, exp_date, cvc } = this.state;

    const errors = validate(card_name, card_number, exp_date, cvc);
    if (errors.length > 0) {
      this.setState({
        isLoading: false,
        cartmsg: errors,
        cartcls: 'alert alert-danger text-center',
      });
      this.setState({ isLoading: false });
      setTimeout(() => {
        this.setState({ cartmsg: '', cartcls: '' });
      }, 5000);
      return;
    } else {
      var vals = this.state.exp_date.split('/');
      var exp_month = vals[0];
      var exp_year = vals[1];
      const card_create = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        card_name: this.state.card_name,
        card_number: this.state.card_number,
        exp_month: exp_month,
        exp_year: exp_year,
        cvc: this.state.cvc,
      };
      console.log(card_create);
      axios
        .post(API_CALL_ENDPOINT + '/stripe/cards/create', card_create)
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 'success') {
            this.setState({ isLoading: false });

            const userpayment = {
              apikey: API_KEY,
              secret: API_SECRET,
              user_id: this.state.user_id,
              business_id: this.state.business_id,
              cart_id: this.state.exist_cart_id.toString(),
              invoice_amount: this.state.order_amount.toString(),
              card_id: res.data.result.card_id,
            };
            console.log(userpayment);
            //  return

            axios
              .post(API_CALL_ENDPOINT + '/booster/payment/create', userpayment)
              .then((res) => {
                console.log(res.data);
                if (res.data.status == 'success') {
                  this.setState({
                    isLoading: false,
                    cartmsg: res.data.message,
                    cartcls: 'alert alert-success text-center',
                  });
                  setTimeout(() => {
                    this.setState({ cartmsg: '', cartcls: '' });
                    this.setState({
                      pack_quantity_message: 1,
                      order_data_count: '',
                      order_doller: '',
                      packcart_list: [],
                      exist_cart_id: '',
                    });
                    this.setState({ cart_updated_count: this.state.cart_updated_count + 1 });
                    $('.choosepackdtls_div').show();
                    $('.creditcarddtls_div').hide();
                  }, 5000);
                }

                if (res.data.error) {
                  this.setState({
                    isLoading: false,
                    cartmsg: res.data.error.message,
                    cartcls: 'alert alert-danger text-center',
                  });
                  this.setState({ isLoading: false });
                  setTimeout(() => {
                    this.setState({ cartmsg: '', cartcls: '' });
                  }, 5000);
                  return;
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.error) {
                    this.setState({
                      isLoading: false,
                      cartmsg: error.response.data.error.message,
                      cartcls: 'alert alert-danger text-center',
                    });
                    this.setState({ isLoading: false });
                    setTimeout(() => {
                      this.setState({ cartmsg: '', cartcls: '' });
                    }, 5000);
                    return;
                  }
                }
              });
          } else if (res.data.status == 'conflict') {
            const existcardpayment = {
              apikey: API_KEY,
              secret: API_SECRET,
              user_id: this.state.user_id,
              business_id: this.state.business_id,
              cart_id: this.state.exist_cart_id.toString(),
              invoice_amount: this.state.order_amount.toString(),
              card_id: res.data.result.details.card_no,
            };
            // console.log(userpayment)
            axios
              .post(API_CALL_ENDPOINT + '/booster/payment/create', existcardpayment)
              .then((res) => {
                console.log(res.data);
                if (res.data.status == 'success') {
                  this.setState({
                    isLoading: false,
                    cartmsg: res.data.message,
                    cartcls: 'alert alert-success text-center',
                  });
                  setTimeout(() => {
                    this.setState({ cartmsg: '', cartcls: '' });
                    this.setState({
                      pack_quantity_message: 1,
                      order_data_count: '',
                      order_doller: '',
                      packcart_list: [],
                      exist_cart_id: '',
                    });
                    this.setState({ cart_updated_count: this.state.cart_updated_count + 1 });
                    $('.choosepackdtls_div').show();
                    $('.creditcarddtls_div').hide();
                  }, 5000);
                }

                if (res.data.error) {
                  this.setState({
                    isLoading: false,
                    cartmsg: res.data.error.message,
                    cartcls: 'alert alert-danger text-center',
                  });
                  this.setState({ isLoading: false });
                  setTimeout(() => {
                    this.setState({ cartmsg: '', cartcls: '' });
                  }, 5000);
                  return;
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.error) {
                    this.setState({
                      isLoading: false,
                      cartmsg: error.response.data.error.message,
                      cartcls: 'alert alert-danger text-center',
                    });
                    this.setState({ isLoading: false });
                    setTimeout(() => {
                      this.setState({ cartmsg: '', cartcls: '' });
                    }, 5000);
                    return;
                  }
                }
              });
          }
          // console.log(res.data.error.message)
          else if (res.data.error) {
            this.setState({
              isLoading: false,
              cartmsg: res.data.error.message,
              cartcls: 'alert alert-danger text-center',
            });
            this.setState({ isLoading: false });
            setTimeout(() => {
              this.setState({ cartmsg: '', cartcls: '' });
            }, 5000);
            return;
          }
          const card_List = {
            params: {
              apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
              secret: 'R1eqD2twI3E4',
              user_id: this.state.user_id,
            },
          };
          axios
            .get(API_CALL_ENDPOINT + '/stripe/cards/list', card_List)
            .then((res) => {
              console.log(res.data.result);

              if (res.data.result) {
                this.setState({ cardList: res.data.result.cards });
              } else {
                console.log('no cards found');
                this.setState({ cardList: [] });
                document.getElementById('choosecrd').style.display = 'none';
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.error.reason === 'payment error') {
              this.setState({ isLoading: false });
              toast.dark(error.response.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
            if (error.response.data.status == 'conflict') {
              const existcardpayment = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                cart_id: this.state.exist_cart_id.toString(),
                invoice_amount: this.state.order_amount.toString(),
                card_id: error.response.data.result.details.card_no,
              };
              // console.log(userpayment)
              axios
                .post(API_CALL_ENDPOINT + '/booster/payment/create', existcardpayment)
                .then((res) => {
                  console.log(res.data);
                  if (res.data.status == 'success') {
                    this.setState({
                      isLoading: false,
                      cartmsg: res.data.message,
                      cartcls: 'alert alert-success text-center',
                    });
                    setTimeout(() => {
                      this.setState({ cartmsg: '', cartcls: '' });
                      this.setState({
                        pack_quantity_message: 1,
                        order_data_count: '',
                        order_doller: '',
                        packcart_list: [],
                        exist_cart_id: '',
                      });
                      this.setState({ cart_updated_count: this.state.cart_updated_count + 1 });
                      $('.choosepackdtls_div').show();
                      $('.creditcarddtls_div').hide();
                    }, 5000);
                  }

                  if (res.data.error) {
                    this.setState({
                      isLoading: false,
                      cartmsg: res.data.error.message,
                      cartcls: 'alert alert-danger text-center',
                    });
                    this.setState({ isLoading: false });
                    setTimeout(() => {
                      this.setState({ cartmsg: '', cartcls: '' });
                    }, 5000);
                    return;
                  }
                })
                .catch((error) => {
                  // errors.push(error.message);

                  console.log(error);
                });
            }
          }
        });
    }
  }
  view_pack_history = () => {
    const view_pack_history = {
      params: {
        apikey: 'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
        secret: 'R1eqD2twI3E4',
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/booster/invoice/list', view_pack_history)
      .then((res) => {
        if (res.data.result) {
          this.setState({ pack_history_list: res.data.result });
          // $('#packshistory_tbl').DataTable({
          //   paging: true,
          //   lengthChange: false,
          //   ordering: false,
          //   searching: false,
          // });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    $('.packshistory_tgldiv').slideToggle();
  };
  InvoiceViewClk = (_id) => {
    AsyncStorage.setItem('Invoice_id_cart', _id);
    window.open('/pack_invoice', '_blank');
  };

  handleclick = () => {
    gapi.load('client:auth2', () => {
      gapi.client.init({
        apiKey: API_KEY_gapi,
        clientId: CLIENT_ID,
        scope: SCOPE,
        access_type: 'offline',
        approval_prompt: 'force',
        discoveryDocs: DISCOVERY_DOCS,
      });
      gapi.client.load('calendar', 'v3', () => {
        console.log('load calendar');
      });
      gapi.auth2
        .getAuthInstance()
        .grantOfflineAccess()
        .then((code) => {
          console.log('signin');
          console.log(code);
          if (code.code) {
            const access_token = {
              grant_type: 'authorization_code',
              code: code.code,
              client_id: CLIENT_ID,
              client_secret: CLIENT_SECRET,
              redirect_uri: APP_ENDPOINT,
            };
            // console.log(userpayment)
            axios
              .post('https://www.googleapis.com/oauth2/v4/token', access_token)
              .then((res) => {
                console.log(res.data);
                if (res.data) {
                  const view_user_info = {
                    params: {
                      access_token: res.data.access_token,
                    },
                  };
                  axios
                    .get('https://www.googleapis.com/oauth2/v3/userinfo', view_user_info)
                    .then((res1) => {
                      console.log(res1.data);

                      if (res1.data) {
                        toast.dark('Meeting connection has been initiated', {
                          position: 'top-right',
                          transition: Flip,
                          autoClose: 5000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                        const meeting_details = {
                          apikey: API_KEY,
                          secret: API_SECRET,
                          user_id: this.state.user_id,
                          business_id: this.state.business_id,
                          setup: 'google_calendar',
                          google_calendar: res.data,
                          user_info: res1.data,
                        };

                        axios
                          .post(API_CALL_ENDPOINT + '/business/profile/settings', meeting_details)
                          .then((res) => {
                            if (res.data.status == 'success') {
                              console.log(res);
                              const business_details = {
                                params: {
                                  apikey: API_KEY,
                                  secret: API_SECRET,
                                  user_id: this.state.user_id,
                                  business_id: this.state.business_id,
                                },
                              };
                              console.log(business_details);
                              axios.get(API_CALL_ENDPOINT + '/business/info', business_details).then((res) => {
                                console.log('/business/info', res.data);
                                if (res.data.result) {
                                  this.setState({
                                    business_info_array: res.data?.result,
                                  });
                                }
                              });
                              toast.dark('Connection established successfully', {
                                position: 'top-right',
                                transition: Flip,
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              });
                              $('.gmailmeet_notconnected_div').hide();
                              $('.gmailmeet_connected_div').show();
                            }
                          })
                          .catch((error) => {
                            // errors.push(error.message);

                            console.log(error);
                          });
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                // errors.push(error.message);

                console.log(error);
              });
          }
        });
    });
  };
  disconnectcalender = () => {
    const meeting_details = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      setup: 'google_calendar',
      google_calendar: null,
      user_info: null,
    };

    axios
      .post(API_CALL_ENDPOINT + '/business/profile/settings', meeting_details)
      .then((res) => {
        if (res.data.status == 'success') {
          console.log(res);
          const business_details = {
            params: {
              apikey: API_KEY,
              secret: API_SECRET,
              user_id: this.state.user_id,
              business_id: this.state.business_id,
            },
          };
          console.log(business_details);
          axios.get(API_CALL_ENDPOINT + '/business/info', business_details).then((res) => {
            console.log('/business/info', res.data);
            if (res.data.result) {
              this.setState({
                business_info_array: res.data?.result,
              });
            }
          });
          $('.gmailmeet_notconnected_div').show();
          $('.gmailmeet_connected_div').hide();
        }
      })
      .catch((error) => {
        // errors.push(error.message);

        console.log(error);
      });
  };
  copyToClipboard = (elementId) => {
    // Create a "hidden" input
    var aux = document.createElement('input');

    // Assign it the value of the specified element
    aux.setAttribute('value', document.getElementById(elementId).innerHTML);

    // Append it to the body
    document.body.appendChild(aux);

    // Highlight its content
    aux.select();

    // Copy the highlighted text
    document.execCommand('copy');

    // Remove it from the body
    document.body.removeChild(aux);
    toast.dark('Copied successfully', {
      position: 'top-right',
      transition: Flip,
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  // Workflow

  workflow_search_list = (e) => {
    const workflow_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        search_text: e.target.value,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list)
      .then((res) => {
        // if (res1.data.result) {
        if (res.data.status === 'success') {
          this.setState({
            workflow_list_array: res.data?.result,
          });
          $('#workflow_nil').hide();
        } else if (res.data.status === 'no_record') {
          this.setState({
            workflow_list_array: [],
          });
          $('#workflow_nil').show();

          // $('.workflowcreate_div').show();
          // $('.addworkflow_div').hide();
          // $('.addentrypoints_div').hide();
          // $('.workflowlist_div').hide();
        }
        // }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            this.setState({
              workflow_list_array: [],
            });
            $('#workflow_nil').show();

            // $('.workflowcreate_div').show();
            // $('.addworkflow_div').hide();
            // $('.addentrypoints_div').hide();
            // $('.workflowlist_div').hide();
          }
        }
      });
  };

  onupdate_workflow_status = (data, status) => {
    console.log(data);
    if (data.entry_point_count === 0 && status !== 'deactive') {
      toast.dark('Please add an entry point to activate workflow', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      this.setState({
        workflow_edit_data: data,
        workflow_edit_name: data.workflow_name,
      });
      $('.workflowcreate_div').hide();
      $('.addworkflow_div').hide();
      $('.addentrypoints_div').show();
      $('.workflowlist_div').hide();
      this.workflow_steps_list(data._id);
      this.workflow_entry_list(data._id);
    } else {
      const workflow_data = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: data._id,
        setup: 'delete_workflow',
        workflow_status: status,
      };

      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.workflow_entry_list(data._id);
            const workflow_list = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };
            axios
              .get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list)
              .then((res1) => {
                // if (res1.data.result) {
                if (res1.data.status === 'success') {
                  this.setState({
                    workflow_list_array: res1.data?.result,
                    workflow_name: '',
                    workflow_description: '',
                    workflow_editenable: false,
                  });
                  const workflow_info = {
                    params: {
                      apikey: API_KEY,
                      secret: API_SECRET,
                      user_id: this.state.user_id,
                      business_id: this.state.business_id,
                      workflow_id: data._id,
                    },
                  };
                  axios.get(API_CALL_ENDPOINT + '/business/workflow/info', workflow_info).then((res2) => {
                    if (res1.data.status === 'success') {
                      this.setState({
                        workflow_edit_data: res2.data?.result[0],
                        workflow_edit_name: res2.data?.result[0].workflow_name,
                      });
                    }
                  });
                } else if (res1.data.status === 'no_record') {
                  this.setState({
                    workflow_list_array: [],
                    workflow_edit_name: res.data?.result.workflow_name,
                    workflow_name: '',
                    workflow_description: '',
                    workflow_editenable: false,
                  });
                  $('.workflowcreate_div').show();
                  $('.addworkflow_div').hide();
                  $('.addentrypoints_div').hide();
                  $('.workflowlist_div').hide();
                }

                // }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.status === 'no_record') {
                    this.setState({
                      workflow_list_array: [],
                      workflow_edit_name: error.response.data?.result.workflow_name,
                      workflow_name: '',
                      workflow_description: '',
                      workflow_editenable: false,
                    });
                    $('.workflowcreate_div').show();
                    $('.addworkflow_div').hide();
                    $('.addentrypoints_div').hide();
                    $('.workflowlist_div').hide();
                  }
                }
              });
          }
        })
        .catch((error) => {
          // errors.push(error.message);

          console.log(error);
        });
    }
  };

  onupdate_integration_view = (data) => {
    $('#custom-tabs-integrations-tab')[0].click();
    if (data == 'email') {
      $('#custom-tabs-psemail-tab')[0].click();
    } else if (data == 'chat') {
      $('#custom-tabs-pschat-tab')[0].click();
    } else if (data == 'slack') {
      $('#custom-tabs-psslack-tab')[0].click();
    } else if (data == 'qr_codes') {
      $('#custom-tabs-psqrcodes-tab')[0].click();
    } else if (data == 'meetings') {
      $('#custom-tabs-meeting-tab')[0].click();
    }

    // $('#custom-tabs-integrations-tab')[0].click();
    // // $('#custom-tabs-general-tab').removeClass('active');
    // // $('#custom-tabs-general').removeClass('active show');
    // // $('#custom-tabs-integrations-tab').addClass('active');
    // // $('#custom-tabs-integrations').addClass('active show');

    // if (data == 'email') {
    //   $('#custom-tabs-psemail-tab')[0].click();
    //   // $('#custom-tabs-psemail-tab').addClass('active');
    //   // $('#custom-tabs-psemail').addClass('active show');
    // }
    // else if (data == 'chat') {
    //   // $('#custom-tabs-psemail-tab').removeClass('active');
    //   // $('#custom-tabs-psemail').removeClass('active show');
    //   $('#custom-tabs-pschat-tab')[0].click();
    //   // $('#custom-tabs-pschat-tab').addClass('active');
    //   // $('#custom-tabs-pschat').addClass('active show');
    // }
    // else if (data == 'slack') {
    //   // $('#custom-tabs-psemail-tab').removeClass('active');
    //   // $('#custom-tabs-psemail').removeClass('active show');
    //   $('#custom-tabs-psslack-tab')[0].click();
    //   // $('#custom-tabs-psslack-tab').addClass('active');
    //   // $('#custom-tabs-psslack').addClass('active show');
    // }
    // else if (data == 'qr_codes') {
    //   // $('#custom-tabs-psemail-tab').removeClass('active');
    //   // $('#custom-tabs-psemail').removeClass('active show');
    //   $("#custom-tabs-psqrcodes-tab")[0].click();
    //   //$('a #custom-tabs-psqrcodes-tab').trigger('click');
    //   // $('#custom-tabs-psqrcodes-tab').addClass('active');
    //   // $('#custom-tabs-psqrcodes').addClass('active show');
    // }
    // else if (data == 'meetings') {
    //   // $('#custom-tabs-psemail-tab').removeClass('active');
    //   // $('#custom-tabs-psemail').removeClass('active show');
    //   $('#custom-tabs-meeting-tab')[0].click();
    //   // $('#custom-tabs-meeting-tab').addClass('active');
    //   // $('#custom-tabs-meeting').addClass('active show');
    // }
  };

  onupdate_workflow_view = (data) => {
    var workflow_id = data;
    const workflow_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: data,
      },
    };
    axios.get(API_CALL_ENDPOINT + '/business/workflow/details', workflow_list).then((res1) => {
      // if (res1.data.result) {
      if (res1.data.status == 'success') {
        // const obj = JSON.parse(res1.data);
        // console.log("WF Response", obj);
        console.log('workflow response', res1.data.result[0].allow_contacts);
        var data = {
          allow_contacts: res1.data.result[0].allow_contacts,
          business_id: res1.data.result[0].business_id,
          created_date: res1.data.result[0].created_date,
          description: res1.data.result[0].description,
          entry_point_count: res1.data.result[0].entry_point_count,
          parent_id: res1.data.result[0].parent_id,
          status: res1.data.result[0].status,
          updated_date: res1.data.result[0].updated_date,
          user_id: res1.data.result[0].user_id,
          workflow_name: res1.data.result[0].workflow_name,
          _id: res1.data.result[0]._id,
        };
        this.setState({
          workflow_edit_data: data,
          workflow_edit_name: data.workflow_name,
        });
        setTimeout(() => {
          $(".nav_links_prof").removeClass('active');
          $('.nav_links_prof_tabs').removeClass('active show');
          $('#custom-tabs-general-tab').removeClass('active');
          $('#custom-tabs-general').removeClass('active show');
          $('#custom-tabs-workflow-tab').addClass('active');
          $('#custom-tabs-workflow').addClass('active show');
          $('.workflowcreate_div').hide();
          $('.addworkflow_div').hide();
          $('.addentrypoints_div').show();
          $('.workflowlist_div').hide();
        }, 1000);
        $('.workflowcreate_div').hide();
        $('.addworkflow_div').hide();
        $('.addentrypoints_div').show();
        $('.workflowlist_div').hide();
        this.workflow_steps_list(workflow_id);
        const workflow_entry_list = {
          params: {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            workflow_id: workflow_id,
          },
        };
        axios
          .get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list)
          .then((res2) => {
            if (res2.data.result) {
              this.setState({
                workflow_entry_list_array: res2.data?.result,
              });

            }
            if (res2.data.status === 'no_record') {
              this.setState({
                workflow_entry_list_array: [],
              });
              // this.onupdate_workflow_status(this.state.workflow_edit_data, 'deactive');
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.status === 'no_record') {
                this.setState({
                  workflow_entry_list_array: [],
                });
                // this.onupdate_workflow_status(this.state.workflow_edit_data, 'deactive');
              }
            }
          });
        const workflow_list = {
          params: {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
          },
        };
        // axios
        //   .get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list)
        //   .then((res1) => {
        //     // if (res1.data.result) {
        //     if (res1.data.status == 'success') {
        //       this.setState({
        //         workflow_list_array: res1.data?.result,
        //         // workflow_edit_name: res.data?.result.workflow_name,
        //         workflow_name: '',
        //         workflow_description: '',
        //         workflow_editenable: false,
        //       });
        //     } else if (res1.data.status == 'no_record') {
        //       this.setState({
        //         workflow_list_array: [],
        //         // workflow_edit_name: res.data?.result.workflow_name,
        //         workflow_name: '',
        //         workflow_description: '',
        //         workflow_editenable: false,
        //       });
        //       $('.workflowcreate_div').show();
        //       $('.addworkflow_div').hide();
        //       $('.addentrypoints_div').hide();
        //       $('.workflowlist_div').hide();
        //     }

        //     // }
        //   })
        //   .catch((error) => {
        //     if (error.response) {
        //       if (error.response.data.status == 'no_record') {
        //         this.setState({
        //           workflow_list_array: [],
        //           // workflow_edit_name: res.data?.result.workflow_name,
        //           workflow_name: '',
        //           workflow_description: '',
        //           workflow_editenable: false,
        //         });
        //         $('.workflowcreate_div').show();
        //         $('.addworkflow_div').hide();
        //         $('.addentrypoints_div').hide();
        //         $('.workflowlist_div').hide();
        //       }
        //     }
        //   });
        console.log('workflow response1', data);
        // this.workflow_steps_list(data._id);
        // this.workflow_entry_list(data._id);
      } else if (res1.data.status == 'no_record') {
      }
      // }
    });

  };
  Workflow_create = () => {
    if (this.state.workflow_name?.length === 0) {
      toast.dark('Workflow name is mandatory', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      const workflow_data = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_name: this.state.workflow_name,
        description: this.state.workflow_description,
        allow_contacts: $('#workspaceopt').is(':checked') === true ? true : false,
      };

      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/create', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            $('.workflowcreate_div').hide();
            $('.addworkflow_div').hide();
            $('.addentrypoints_div').show();
            $('.workflowlist_div').hide();
            this.setState({ workflow_edit_data: res.data.result });
            this.workflow_steps_list(res.data.result._id);
            this.workflow_entry_list(res.data.result._id);
            const workflow_list = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };
            axios
              .get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list)
              .then((res1) => {
                // if (res1.data.result) {
                if (res1.data.status == 'success') {
                  this.setState({
                    workflow_list_array: res1.data?.result,
                    workflow_edit_name: res.data?.result.workflow_name,
                    workflow_name: '',
                    workflow_description: '',
                    workflow_editenable: false,
                  });
                } else if (res1.data.status == 'no_record') {
                  this.setState({
                    workflow_list_array: [],
                    workflow_edit_name: res.data?.result.workflow_name,
                    workflow_name: '',
                    workflow_description: '',
                    workflow_editenable: false,
                  });
                  $('.workflowcreate_div').show();
                  $('.addworkflow_div').hide();
                  $('.addentrypoints_div').hide();
                  $('.workflowlist_div').hide();
                }
                // }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.status == 'no_record') {
                    this.setState({
                      workflow_list_array: [],
                      workflow_edit_name: error.response.data?.result.workflow_name,
                      workflow_name: '',
                      workflow_description: '',
                      workflow_editenable: false,
                    });
                    $('.workflowcreate_div').show();
                    $('.addworkflow_div').hide();
                    $('.addentrypoints_div').hide();
                    $('.workflowlist_div').hide();
                  }
                }
              });
          }
        })
        .catch((error) => {
          // errors.push(error.message);

          console.log(error);
        });
    }
  };
  Workflow_update = () => {
    if (this.state.workflow_name?.length === 0) {
      toast.dark('Workflow name is mandatory', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      const workflow_data = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_name: this.state.workflow_name,
        description: this.state.workflow_description,
        allow_contacts: $('#workspaceopt').is(':checked') === true ? true : false,
        workflow_id: this.state.workflow_edit_data._id,
        setup: 'workflow_name',
      };

      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            $('.workflowcreate_div').hide();
            $('.addworkflow_div').hide();
            $('.addentrypoints_div').show();
            $('.workflowlist_div').hide();
            this.workflow_steps_list(this.state.workflow_edit_data._id);
            const workflow_entry_list = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
              },
            };
            axios
              .get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list)
              .then((res2) => {
                if (res.data.result) {
                  this.setState({
                    workflow_entry_list_array: res2.data?.result,
                  });
                }
                if (res2.data.status === 'no_record') {
                  this.setState({
                    workflow_entry_list_array: [],
                  });
                  // this.onupdate_workflow_status(this.state.workflow_edit_data, 'deactive');
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.status === 'no_record') {
                    this.setState({
                      workflow_entry_list_array: [],
                    });
                    // this.onupdate_workflow_status(this.state.workflow_edit_data, 'deactive');
                  }
                }
              });
            const workflow_list = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };
            axios
              .get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list)
              .then((res1) => {
                // if (res1.data.result) {
                if (res1.data.status == 'success') {
                  this.setState({
                    workflow_list_array: res1.data?.result,
                    // workflow_edit_name: res.data?.result.workflow_name,
                    workflow_name: '',
                    workflow_description: '',
                    workflow_editenable: false,
                  });
                } else if (res1.data.status == 'no_record') {
                  this.setState({
                    workflow_list_array: [],
                    // workflow_edit_name: res.data?.result.workflow_name,
                    workflow_name: '',
                    workflow_description: '',
                    workflow_editenable: false,
                  });
                  $('.workflowcreate_div').show();
                  $('.addworkflow_div').hide();
                  $('.addentrypoints_div').hide();
                  $('.workflowlist_div').hide();
                }

                // }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data.status == 'no_record') {
                    this.setState({
                      workflow_list_array: [],
                      // workflow_edit_name: res.data?.result.workflow_name,
                      workflow_name: '',
                      workflow_description: '',
                      workflow_editenable: false,
                    });
                    $('.workflowcreate_div').show();
                    $('.addworkflow_div').hide();
                    $('.addentrypoints_div').hide();
                    $('.workflowlist_div').hide();
                  }
                }
              });
          }
        })
        .catch((error) => {
          // errors.push(error.message);

          console.log(error);
        });
    }
  };
  addworkflow_close = () => {
    this.setState({ workflow_editenable: false });
    if (this.state.workflow_list_array.length !== 0) {
      $('.addworkflow_div').hide();
      $('.workflowcreate_div').hide();
      $('.addentrypoints_div').hide();
      $('.workflowlist_div').show();
    } else {
      $('.addworkflow_div').hide();
      $('.workflowcreate_div').show();
      $('.addentrypoints_div').hide();
      $('.workflowlist_div').hide();
    }
  };
  addworkflow_clk = () => {
    if (!this.state?.business_info_array?.busines_evaluation_details) {
      $('.business_evaluation_popup').trigger('click');
      return false;
    } else if (this.state?.business_info_array?.busines_evaluation_details?.otp_status == 'not_verified') {
      $('.business_evaluation_popup').trigger('click');
      return false;
    } else if (
      this.state?.business_info_array?.busines_evaluation_details?.status == 'not_verified' ||
      this.state?.business_info_array?.busines_evaluation_details?.status == 'rejected'
    ) {
      $('.business_evaluation_popup').trigger('click');
      return false;
    } else if (this.state?.business_info_array?.busines_evaluation_details?.status == 'pending') {
      toast.dark(
        'Thank you for your patience, please note that your workspace is under verification. We will get back to you upon verification via email.',
        {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      return false;
    } else {
      $('.workflowcreate_div').hide();
      $('.addworkflow_div').show();
      $('.addentrypoints_div').hide();
      $('.workflowlist_div').hide();
      $('#workspaceopt').prop('checked', false);
      this.setState({
        workflow_name: '',
        workflow_description: '',
      });
    }
  };

  onedit_workflow = (editdata) => {
    console.log(editdata);
    if (editdata.allow_contacts === 'true') {
      $('#workspaceopt').prop('checked', true);
    } else {
      $('#workspaceopt').prop('checked', false);
    }
    this.setState({
      workflow_edit_data: editdata,
      workflow_editenable: true,
      workflow_edit_name: editdata.workflow_name,
      workflow_name: editdata.workflow_name,
      workflow_description: editdata.description,
    });
    $('.addworkflow_div').show();
    $('.workflowcreate_div').hide();
    $('.addentrypoints_div').hide();
    $('.workflowlist_div').hide();
  };

  workflow_list_del = () => {
    const workflow_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/list', workflow_list)
      .then((res) => {
        // if (res1.data.result) {
        if (res.data.status === 'success') {
          this.setState({
            workflow_list_array: res.data.result,
            workflow_name: '',
            workflow_description: '',
            workflow_editenable: false,
          });
        } else if (res.data.status === 'no_record') {
          this.setState({
            workflow_list_array: [],
            workflow_name: '',
            workflow_description: '',
            workflow_editenable: false,
          });
          $('.workflowcreate_div').show();
          $('.addworkflow_div').hide();
          $('.addentrypoints_div').hide();
          $('.workflowlist_div').hide();
        }

        // }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            this.setState({
              workflow_list_array: [],
              workflow_name: '',
              workflow_description: '',
              workflow_editenable: false,
            });
            $('.workflowcreate_div').show();
            $('.addworkflow_div').hide();
            $('.addentrypoints_div').hide();
            $('.workflowlist_div').hide();
          }
        }
      });
  };
  ondelete_workflow = (data) => {
    const workflow_data = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      workflow_id: data._id,
      setup: 'delete_workflow',
      workflow_status: 'deleted',
    };

    axios
      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
      .then((resdata) => {
        if (resdata.data.status === 'success') {
          this.workflow_list_del();
        }
      })
      .catch((error) => {
        // errors.push(error.message);

        console.log(error);
      });
  };
  onEdit_entrypoint_contacts = (contac_val) => {
    this.setState({
      contact_id: contac_val.contacts,
      edit_entrypnt_contacts: true,
      edit_entrypnt_contacts_data: contac_val,
    });
    for (var i in contac_val.contacts) {
      var slcted_vl = $('#rw_' + contac_val.contacts[i]).attr('class');
      if (slcted_vl !== 'selected') {
        $('#rw_' + contac_val.contacts[i]).attr('class', 'selected');
        $('.selected_' + contac_val.contacts[i]).show();
        $('.notselected_' + contac_val.contacts[i]).hide();
      }
    }
  };

  choose_Contacts = () => {
    this.setState({ contact_id: [] });
  };
  onAdd_entry_point_all_contacts = () => {
    const workflow_data = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      workflow_id: this.state.workflow_edit_data._id,
      select_entry_point: 'contacts',
      startpoint: this.state.workflow_entry_list_array?.length ? this.state.workflow_entry_list_array?.length + 1 : 1,
      setup: 'add_entry_point',
      contacts: '',
    };

    this.setState({ disable_contact: true });
    axios
      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({ disable_contact: false });
          // var contac_id = this.state.contact_id;
          // for (var i in contac_id) {
          //   $('#rw_' + contac_id[i]).attr('class', '');
          //   $('.selected_' + contac_id[i]).hide();
          //   $('.notselected_' + contac_id[i]).show();
          // }
          this.setState({ contact_id: [] });
          $('.entry_point_close').click();
          $('.entry_point_close_allcontact').click();
          $('.wfentrypt_contactstgl_div').hide();
          this.workflow_info(this.state.workflow_edit_data._id);
          this.workflow_list_del();
          const workflow_entry_list = {
            params: {
              apikey: API_KEY,
              secret: API_SECRET,
              user_id: this.state.user_id,
              business_id: this.state.business_id,
              workflow_id: this.state.workflow_edit_data._id,
            },
          };
          axios.get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list).then((res2) => {
            if (res.data.result) {
              this.setState({
                workflow_entry_list_array: res2.data?.result,
              });
            }
          });
        }
      })
      .catch((error) => {
        // errors.push(error.message);
        this.setState({ disable_contact: false });
        console.log(error);
      });
  };
  onAdd_entry_point = () => {
    this.setState({ disable_contact: true });
    if (this.state.contact_id?.length === 0) {
      this.setState({ disable_contact: false });
      toast.dark('Please Select a contact to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      // const workflow_data = {
      //   apikey: API_KEY,
      //   secret: API_SECRET,
      //   user_id: this.state.user_id,
      //   business_id: this.state.business_id,
      //   workflow_id: this.state.workflow_edit_data._id,
      //   select_entry_point: 'contacts',
      //   startpoint: this.state.workflow_entry_list_array?.length ? this.state.workflow_entry_list_array?.length + 1 : 1,
      //   setup: 'add_entry_point',
      //   contacts: this.state.contact_id.toString(),
      // };
      let workflow_data = {};
      if (!this.state.edit_entrypnt_contacts) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          select_entry_point: 'contacts',
          startpoint: this.state.workflow_entry_list_array?.length
            ? this.state.workflow_entry_list_array?.length + 1
            : 1,
          setup: 'add_entry_point',
          contacts: this.state.contact_id.toString(),
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          select_entry_point: 'contacts',
          startpoint: this.state.workflow_entry_list_array?.length
            ? this.state.workflow_entry_list_array?.length + 1
            : 1,
          setup: 'add_entry_point',
          contacts: this.state.contact_id.toString(),
          entry_point_id: this.state.edit_entrypnt_contacts_data._id,
        };
      }

      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.setState({ disable_contact: false, edit_entrypnt_contacts: false });
            var contac_id = this.state.contact_id;
            for (var i in contac_id) {
              $('#rw_' + contac_id[i]).attr('class', '');
              $('.selected_' + contac_id[i]).hide();
              $('.notselected_' + contac_id[i]).show();
            }
            this.setState({ contact_id: [], search_content: '' });
            $('.entry_point_close').click();
            var event = new CustomEvent('newMessage', {
              detail: {
                message: 'Hello World!',
                time: new Date(),
              },
              bubbles: true,
              cancelable: true,
            });
            this.contactSearch(event, true);
            $('.wfentrypt_contactstgl_div').hide();
            this.workflow_info(this.state.workflow_edit_data._id);
            this.workflow_list_del();
            const workflow_entry_list = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
              },
            };
            axios.get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list).then((res2) => {
              if (res.data.result) {
                this.setState({
                  workflow_entry_list_array: res2.data?.result,
                });
              }
            });
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_contact: false });
          console.log(error);
        });
    }
  };
  onEdit_elsif_edit = (tagval) => {
    var inbound_type = tagval.inbound_type;
    var inbound_content = tagval.inbound_content;
    var field_name = tagval.field_name;
    this.setState({
      edit_startpnt_elseif_steps: tagval.steps,
      edit_step_inbound: true,
      edit_step_inbound_data: tagval,
      edit_startpnt_elseif_steps_ifelse_condition: tagval.ifelse_condition,
    });
    current_step_id = tagval.steps;
    if (tagval.ifelse_type === 'tags') {
      this.onEdit_entrypoint_tag(tagval);
    } else if (tagval.ifelse_type === 'inbound') {
      $('#stepinbound').val(inbound_type);
      console.log('inbound_contentinbound_content', inbound_content);
      if (inbound_type === 'no_specification') {
        $('#inbvalue').val('');
      } else {
        $('#inbvalue').val(inbound_content);
      }
    } else if (tagval.ifelse_type === 'contacts') {
      $('#custom_properties_select').val(field_name);
      $('#condition_dropdown').val(inbound_type);
      $('#condition_value').val(inbound_content);
    } else if (tagval.type === 'update_contact') {
      $('.updcontactsel').val(tagval.update_contact_type);
      $('.updcontactsel').trigger('change');
      if (tagval.update_contact_type === 'contacts') {
        $('#custome_properties_updated_contact').val(tagval.field_name);
        $('#company_updated_value').val(tagval.field_value);
      } else if (tagval.update_contact_type === 'notes') {
        $('#update_contact_notes').val(tagval.field_value);
      } else if (tagval.update_contact_type === 'assign_tags') {
        $('.selected_tags').each(function () {
          var $this = $(this);
          if ($.inArray($this.val(), tagval.tags) != -1) {
            $this.prop('checked', true);
          }
        });
      } else if (tagval.update_contact_type === 'remove_tags') {
        $('.remove_tags').each(function () {
          var $this = $(this);
          if ($.inArray($this.val(), tagval.tags) != -1) {
            $this.prop('checked', true);
          }
        });
      }
    }
    console.log('AAAAAA', tagval);
    console.log('edit_startpnt_elseif_steps', this.state.edit_startpnt_elseif_steps);
  };
  getLable = (tagval) => {
    // for (var i = 0; i < this.state?.business_info_array?.business?.add_property?.length; i++) {
    //   if (tagval.field_name == this.state?.business_info_array?.business?.add_property[i]._id) {
    //     var texts = this.state?.business_info_array?.business?.add_property[i].label_name + ' - ';
    //     $('#get_label' + tagval._id + '').text(texts);
    //   }
    // }
    return this.state?.business_info_array?.business?.add_property?.map((properties, index) => {
      if (tagval.field_name == properties._id) {
        var texts = properties.label_name + ' - ';
        $('#get_label' + tagval._id + '').text(texts);
      }
    });
  };
  getTagsLable = (tagval) => {
    var tagsarr = [];
    // for (var i = 0; i < this.state?.tagList?.length; i++) {
    //   if ($.inArray(this.state?.tagList[i]._id, tagval.tags) != '-1') {
    //     tagsarr.push(this.state?.tagList[i].tag_name);
    //   }
    //   $('#get_tags_label' + tagval._id + '').text(tagsarr.toString());
    // }
    return this.state?.tagList?.map((properties, index) => {
      if ($.inArray(properties._id, tagval.tags) != '-1') {
        tagsarr.push(properties.tag_name);
      }
      $('#get_tags_label' + tagval._id + '').text(tagsarr.toString());
    });
  };
  onEdit_entrypoint_tag = (tagval) => {
    console.log('tagval', tagval);
    for (var i in tagval.tags) {
      $('#tg_' + tagval.tags[i]).attr('class', 'selectedtg');
      $('.tgselected_' + tagval.tags[i]).show();
      $('.tgnotselected_' + tagval.tags[i]).hide();
    }
    console.log('onEdit_entrypoint_tag', tagval.tags);
    this.setState({ edit_entrypnt_tags: true, send_filtered_tag_list_up: tagval.tags, edit_entrypnt_tags_data: tagval });
    const tags_contact_count = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tag_id: tagval.tags?.toString(),
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/tags/contacts/count', tags_contact_count)
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({ tags_contact_count: res?.data?.result?.total_contacts });
        } else {
          this.setState({ tags_contact_count: 0 });
        }
      })
      .catch((error) => {
        this.setState({ tags_contact_count: 0 });
      });
  };
  onAdd_entry_point_tags = () => {
    if (this.state.send_filtered_tag_list_up?.length === 0) {
      this.setState({ disable_tag: false });
      toast.dark('Please Select a tag to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({ disable_tag: true });
      let workflow_data = {};
      if (!this.state.edit_entrypnt_tags) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          select_entry_point: 'tags',
          startpoint: this.state.workflow_entry_list_array?.length
            ? this.state.workflow_entry_list_array?.length + 1
            : 1,
          setup: 'add_entry_point',
          tags: this.state.send_filtered_tag_list_up?.toString(),
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          select_entry_point: 'tags',
          startpoint: this.state.workflow_entry_list_array?.length
            ? this.state.workflow_entry_list_array?.length + 1
            : 1,
          setup: 'add_entry_point',
          tags: this.state.send_filtered_tag_list_up?.toString(),
          entry_point_id: this.state.edit_entrypnt_tags_data._id,
        };
      }
      console.log('workflow_data', workflow_data);
      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            $('.entry_pointtag_close').click();
            var event = new CustomEvent('newMessage', {
              detail: {
                message: 'Hello World!',
                time: new Date(),
              },
              bubbles: true,
              cancelable: true,
            });
            this.tagcomp_search(event);
            this.setState({ disable_tag: false });
            for (var i in this.state.tag_list) {
              $('#tg_' + this.state.tag_list[i]._id).attr('class', '');
              $('.tgselected_' + this.state.tag_list[i]._id).hide();
              $('.tgnotselected_' + this.state.tag_list[i]._id).show();
            }
            this.workflow_info(this.state.workflow_edit_data._id);
            this.workflow_list_del();
            const workflow_entry_list = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
              },
            };
            axios.get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list).then((res2) => {
              if (res.data.result) {
                this.setState({
                  workflow_entry_list_array: res2.data?.result,
                  send_filtered_tag_list_up: [],
                  tags_contact_count: 0,
                });
              }
            });
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_tag: false });
          console.log(error);
        });
    }
  };
  onAdd_if_entry_point_tags = () => {
    if (this.state.send_filtered_tag_list_up?.length === 0) {
      this.setState({ disable_tag: false });
      toast.dark('Please Select a tag to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({ disable_tag: true });
      let workflow_data = {};
      if (!this.state.edit_step_inbound) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          parent_steps_id: this.state.workflow_step_id_create,
          steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          ifelse_condition: this.state.Workflow_step_if_else_data,
          inbound_content: '',
          inbound_type: '',
          field_name: '',
          tags: this.state.send_filtered_tag_list_up?.toString(),
          ifelse_type: 'tags',
          type: 'if_else',
          setup: 'add_workflow',
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          parent_steps_id: this.state.workflow_step_id_create,
          steps:
            this.state.edit_startpnt_elseif_steps != '' || this.state.edit_startpnt_elseif_steps != 0
              ? this.state.edit_startpnt_elseif_steps
              : this.state.workflow_steps_list_array?.length
                ? this.state.workflow_steps_list_array?.length + 1
                : 1,
          //steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          ifelse_condition: this.state.Workflow_step_if_else_data,
          setup: 'add_workflow',
          inbound_content: '',
          inbound_type: '',
          field_name: '',
          tags: this.state.send_filtered_tag_list_up?.toString(),
          ifelse_type: 'tags',
          type: 'if_else',
          entry_point_id: this.state.edit_entrypnt_tags_data._id,
          // steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          ifelse_yes: this.state.edit_step_inbound_data.ifelse_yes,
          ifelse_no: this.state.edit_step_inbound_data.ifelse_no,
          add_workflow_id: this.state.edit_step_inbound_data._id,
        };
      }

      console.log('workflow_data', workflow_data);
      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.setState({ disable_step_inbound: false });
            // this.setState({disable_tag: false});
            var add_workflow_id_edit = res?.data?.result;
            if (!this.state.edit_step_inbound) {
              var ifelse_yes = {};
              var ifelse_no = {};

              let workflow_data_yes = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
                steps: 0,
                type: 'yes',
                setup: 'add_workflow',
                parent_steps_id: res.data.result._id,
              };
              let workflow_data_no = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
                steps: 0,
                type: 'no',
                setup: 'add_workflow',
                parent_steps_id: res.data.result._id,
              };
              axios
                .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_yes)
                .then((res) => {
                  if (res.data.status === 'success') {
                    ifelse_yes = res.data.result;
                    console.log(res.data.result);
                    axios
                      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_no)
                      .then((res) => {
                        if (res.data.status === 'success') {
                          ifelse_no = res.data.result;
                          console.log(res.data.result);
                          var workflow_data_up = {
                            apikey: API_KEY,
                            secret: API_SECRET,
                            user_id: this.state.user_id,
                            business_id: this.state.business_id,
                            workflow_id: this.state.workflow_edit_data._id,
                            parent_steps_id: add_workflow_id_edit.parent_steps_id,
                            setup: 'add_workflow',
                            ifelse_condition: add_workflow_id_edit.ifelse_condition,
                            ifelse_yes: JSON.stringify(ifelse_yes),
                            ifelse_no: JSON.stringify(ifelse_no),
                            add_workflow_id: add_workflow_id_edit._id,
                            inbound_content: '',
                            inbound_type: '',
                            type: 'if_else',
                            steps: add_workflow_id_edit.steps,
                            ifelse_type: 'tags',
                            field_name: '',
                            tags: this.state.send_filtered_tag_list_up?.toString(),
                          };
                          axios
                            .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_up)
                            .then((res) => {
                              if (res.data.status === 'success') {
                                this.workflow_steps_list(this.state.workflow_edit_data._id);
                              }
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        }
                      })
                      .catch((error) => {
                        // errors.push(error.message);

                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  // errors.push(error.message);

                  console.log(error);
                });
            }

            $('.step_ifelse_inbound_close').click();
            this.workflow_steps_list(this.state.workflow_edit_data._id);
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_step_inbound: false });
          console.log(error);
        });
    }
  };

  onAdd_if_else_update_contcat = () => {
    this.setState({ disable_tag: true });
    var update_contact_type = $('.updcontactsel').val();
    var inbcont = '';
    var inbtype = '';
    var selectedtagsvalues = [];
    var tagsvals = "tags:''";
    if (update_contact_type === '' || update_contact_type.length === 0) {
      this.setState({ disable_tag: false });
      toast.dark('Please Select update contact type.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    console.log('update_contact_type', update_contact_type);
    if (update_contact_type === 'contacts') {
      inbtype = $('#custome_properties_updated_contact').val();
      inbcont = $('#company_updated_value').val();
      if (inbtype?.length === 0) {
        this.setState({ disable_tag: false });
        toast.dark('Please Select a custome property to proceed', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      if (inbcont?.length === 0) {
        this.setState({ disable_tag: false });
        toast.dark('Please enter the value to proceed', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
    } else if (update_contact_type === 'assign_tags') {
      $('.selected_tags').each(function () {
        var $this = $(this);
        if ($this.is(':checked')) {
          selectedtagsvalues.push($this.val());
        }
      });
      if (selectedtagsvalues.length === 0) {
        this.setState({ disable_tag: false });
        toast.dark('Please Select a tag to proceed', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      tagsvals = 'tags:' + selectedtagsvalues.toString();
    } else if (update_contact_type === 'remove_tags') {
      $('.removed_tags').each(function () {
        var $this = $(this);
        if ($this.is(':checked')) {
          selectedtagsvalues.push($this.val());
        }
      });
      if (selectedtagsvalues.length === 0) {
        this.setState({ disable_tag: false });
        toast.dark('Please Select a tag to proceed', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
      tagsvals = 'tags:' + selectedtagsvalues.toString();
      console.log('selectedtagsvalues', selectedtagsvalues);
      console.log(selectedtagsvalues.length);
    } else if (update_contact_type === 'notes') {
      inbtype = 'Notes';
      inbcont = $('#update_contact_notes').val();
      if (inbcont.length === 0) {
        this.setState({ disable_tag: false });
        toast.dark('Please enter the notes to proceed', {
          position: 'top-right',
          transition: Flip,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
    }
    console.log('update_contact_type', update_contact_type);
    console.log('update_contact_type', update_contact_type);
    console.log('update_contact_type', update_contact_type);
    //this.setState({disable_tag: true});
    let workflow_data = {};
    if (!this.state.edit_step_inbound) {
      workflow_data = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: this.state.workflow_edit_data._id,
        parent_steps_id: this.state.workflow_step_id_create,
        steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
        ifelse_condition: this.state.Workflow_step_if_else_data,
        field_value: inbcont,
        field_name: inbtype,
        //tags: selectedtagsvalues?.length != 0 ? selectedtagsvalues?.toString() : '',
        ifelse_type: '',
        type: 'update_contact',
        setup: 'add_workflow',
        update_contact_type: update_contact_type,
        tags: selectedtagsvalues.length != 0 ? selectedtagsvalues.toString() : '',
      };
    } else {
      workflow_data = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: this.state.workflow_edit_data._id,
        parent_steps_id: this.state.workflow_step_id_create,
        steps:
          this.state.edit_startpnt_elseif_steps != '' || this.state.edit_startpnt_elseif_steps != 0
            ? this.state.edit_startpnt_elseif_steps
            : this.state.workflow_steps_list_array?.length
              ? this.state.workflow_steps_list_array?.length + 1
              : 1,
        //steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
        ifelse_condition: this.state.edit_startpnt_elseif_steps_ifelse_condition,
        setup: 'add_workflow',
        field_value: inbcont,
        field_name: inbtype,
        // tags: this.state.send_filtered_tag_list_up?.toString(),
        ifelse_type: '',
        type: 'update_contact',
        entry_point_id: this.state.edit_entrypnt_tags_data._id,
        // steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
        ifelse_yes: this.state.edit_step_inbound_data.ifelse_yes,
        ifelse_no: this.state.edit_step_inbound_data.ifelse_no,
        add_workflow_id: this.state.edit_step_inbound_data._id,
        update_contact_type: update_contact_type,
        tags: selectedtagsvalues.length != 0 ? selectedtagsvalues.toString() : '',
      };
    }
    console.log('workflow_data', workflow_data);
    this.setState({ disable_tag: true });
    axios
      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
      .then((res) => {
        if (res.data.status === 'success') {
          //  this.setState({disable_step_inbound: false});

          var add_workflow_id_edit = res?.data?.result;
          //   $('.step_ifelse_inbound_close').click();
          this.workflow_steps_list(this.state.workflow_edit_data._id);
        }
      })
      .catch((error) => {
        // errors.push(error.message);
        this.setState({ disable_step_inbound: false });
        console.log(error);
      });
  };
  onEdit_entrypoint_inbound = (inbound_val) => {
    $('#entryinbound').val(inbound_val.inbound_type);
    this.setState({
      inbound_content: inbound_val.inbound_content,
      inbound_cond: inbound_val.inbound_type,
      edit_entrypnt_inbound_data: inbound_val,
      edit_entrypnt_inbound: true,
    });
  };
  onAdd_entry_point_inbound = () => {
    if (this.state.inbound_cond === '') {
      this.setState({ disable_inbound: false });
      toast.dark('Please select a condition to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (!this.state.inbound_content && this.state.inbound_cond !== 'no_specification') {
      this.setState({ disable_inbound: false });
      toast.dark('value cannot be empty', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({ disable_inbound: true });

      let workflow_data = {};
      if (!this.state.edit_entrypnt_inbound) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          select_entry_point: 'inbound',
          startpoint: this.state.workflow_entry_list_array?.length
            ? this.state.workflow_entry_list_array?.length + 1
            : 1,
          setup: 'add_entry_point',
          inbound_content: this.state.inbound_cond === 'no_specification' ? '' : this.state.inbound_content.trim(),
          inbound_type: this.state.inbound_cond,
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          select_entry_point: 'inbound',
          startpoint: this.state.workflow_entry_list_array?.length
            ? this.state.workflow_entry_list_array?.length + 1
            : 1,
          setup: 'add_entry_point',
          inbound_content: this.state.inbound_cond === 'no_specification' ? '' : this.state.inbound_content.trim(),
          inbound_type: this.state.inbound_cond,
          entry_point_id: this.state.edit_entrypnt_inbound_data._id,
        };
      }

      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.setState({ disable_inbound: false });
            $('.entry_pointinbound_close').click();
            this.workflow_info(this.state.workflow_edit_data._id);
            this.workflow_list_del();
            const workflow_entry_list = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
              },
            };
            axios.get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list).then((res2) => {
              if (res.data.result) {
                this.setState({
                  workflow_entry_list_array: res2.data?.result,
                });
              }
            });
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_inbound: false });
          console.log(error);
        });
    }
  };
  delete_entry_point = (data) => {
    const workflow_data = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      workflow_id: this.state.workflow_edit_data._id,
      entry_point_id: data._id,
      // startpoint: this.state.workflow_entry_list_array?.length ? this.state.workflow_entry_list_array?.length + 1 : 1,
      setup: 'delete_entry_point',
    };

    axios
      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
      .then((res) => {
        if (res.data.status === 'success') {
          // $(".entry_point_close").click();

          const workflow_entry_list = {
            params: {
              apikey: API_KEY,
              secret: API_SECRET,
              user_id: this.state.user_id,
              business_id: this.state.business_id,
              workflow_id: this.state.workflow_edit_data._id,
            },
          };
          axios
            .get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list)
            .then((res2) => {
              if (res.data.result) {
                this.setState({
                  workflow_entry_list_array: res2.data?.result,
                });
              }
              if (res2.data.status === 'no_record') {
                this.setState({
                  workflow_entry_list_array: [],
                });
                this.onupdate_workflow_status(this.state.workflow_edit_data, 'deactive');
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.data.status === 'no_record') {
                  this.setState({
                    workflow_entry_list_array: [],
                  });
                  this.onupdate_workflow_status(this.state.workflow_edit_data, 'deactive');
                }
              }
            });
          this.workflow_info(this.state.workflow_edit_data._id);
          this.workflow_list_del();
        }
      })
      .catch((error) => {
        // errors.push(error.message);

        console.log(error);
      });
  };
  onchange_tagsearch_txt = (e) => {
    this.setState({ compsrch_txt: e.target.value });
    setTimeout(() => {
      this.tagcomp_search(e);
    }, 100);
  };
  tagcomp_search = (e) => {
    e.preventDefault();

    const Searchtags = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        search_text: this.state.compsrch_txt,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/tags/list', Searchtags)
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({ tag_list: res?.data?.result });
          $('#tags_nil').hide();
          $('.tags_update_create').show();

          for (var j in res?.data?.result) {
            $('#tg_' + res?.data?.result[j]._id).attr('class', '');
            $('.tgselected_' + res?.data?.result[j]._id).hide();
            $('.tgnotselected_' + res?.data?.result[j]._id).show();
          }
          for (var i in this.state.send_filtered_tag_list_up) {
            $('#tg_' + this.state.send_filtered_tag_list_up[i]).attr('class', 'selectedtg');
            $('.tgselected_' + this.state.send_filtered_tag_list_up[i]).show();
            $('.tgnotselected_' + this.state.send_filtered_tag_list_up[i]).hide();
          }
        } else if (res.data.status === 'no_record') {
          $('#tags_nil').show();
          $('.tags_update_create').hide();
          this.setState({ tag_list: [] });
        } else {
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            $('#tags_nil').show();
            $('.tags_update_create').hide();
            this.setState({ tag_list: [] });
          }
        }
      });
  };
  view_cttaggedlist = (_id) => {
    if (this.state.cttagactiv_id) {
      $('.cttag_' + this.state.cttagactiv_id).hide();
    }
    this.setState({ cttagactiv_id: _id });
    if (this.state.cttagactiv_id !== _id) {
      const tags_cnt_list = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          tag_id: _id,
        },
      };
      axios
        .get(API_CALL_ENDPOINT + '/tags/contacts/list', tags_cnt_list)
        .then((res) => {
          if (res.data) {
            if (res.data.status === 'success') {
              this.setState({
                tagcnt_list: res.data.result,
              });
              $('.cttag_' + _id).slideToggle();
            } else if (res.data.status === 'no_record') {
              toast.dark('No contacts to be shown', {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              this.setState({ isLoading: false });

              // this.setState({receiver_attach_list: []});
            } else if (res.data.error) {
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.status === 'no_record') {
              toast.dark('No contacts to be shown', {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              this.setState({ isLoading: false });

              // this.setState({receiver_attach_list: []});
            }
          }
        });
    } else {
      this.setState({ cttagactiv_id: '' });
    }
  };
  tag_selct = (id) => {
    var slcted_vl = $('#tg_' + id).attr('class');
    if (slcted_vl === 'selectedtg') {
      //$('#rw_' + e.target.id).attr('class', '');
      //$('.selchk_' + e.target.id).remove();

      var array = this.state.send_filtered_tag_list_up; // make a separate copy of the array
      console.log('tag_selct', this.state.send_filtered_tag_list_up);
      var index = array.indexOf(id);
      if (index !== -1) {
        array.splice(index, 1);
        this.setState({ send_filtered_tag_list_up: array });
      }
      $('#tg_' + id).attr('class', '');
      $('.tgselected_' + id).hide();
      $('.tgnotselected_' + id).show();
    } else {
      var joined_ary = this.state.send_filtered_tag_list_up.concat(id);
      this.setState({
        send_filtered_tag_list_up: joined_ary,
      });
      $('#tg_' + id).attr('class', 'selectedtg');
      $('.tgselected_' + id).show();
      $('.tgnotselected_' + id).hide();
    }
    setTimeout(() => {
      const tags_contact_count = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          tag_id: this.state.send_filtered_tag_list_up?.toString(),
        },
      };
      console.log(this.state.send_filtered_tag_list_up.toString());
      axios
        .get(API_CALL_ENDPOINT + '/tags/contacts/count', tags_contact_count)
        .then((res) => {
          if (res.data.status === 'success') {
            this.setState({ tags_contact_count: res?.data?.result?.total_contacts });
          } else {
            this.setState({ tags_contact_count: 0 });
          }
        })
        .catch((error) => {
          this.setState({ tags_contact_count: 0 });
        });
    }, 1000);
  };
  view_tag_contact_count(workflow) {
    $('.wftags_viewct').show();
    $('.wftags_ctcount').hide();
    const tags_contact_count = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tag_id: workflow.tags?.toString(),
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/tags/contacts/count', tags_contact_count)
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({ contactscount_tag: res?.data?.result?.total_contacts });
          $('.wf_tag_view_' + workflow._id).hide();
          $('.wf_tag_cont_' + workflow._id).show();
        } else {
        }
      })
      .catch((error) => {
        this.setState({ contactscount_tag: 0 });
      });
  }

  view_tag_contact_count_elseif(workflow) {
    $('.elseif_view_contcs').hide();
    $('.elseif_view_tags').show();
    console.log('workflow', workflow);
    //  console.log('workflow', id);
    //return false;
    const tags_contact_count = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        tag_id: workflow.tags?.toString(),
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/tags/contacts/count', tags_contact_count)
      .then((res) => {
        if (res.data.status === 'success') {
          console.log('this.state.contactscount_tag_elsif', this.state.contactscount_tag_elsif);
          console.log('resresres', res?.data?.result?.total_contacts);
          this.setState({ contactscount_tag_elsif: res?.data?.result?.total_contacts });
          $('.wf_tag_view_else_' + workflow._id).hide();
          $('.wf_tag_cont_else_' + workflow._id).show();
          $('#wf_tag_cont_else_' + workflow._id).text(res?.data?.result?.total_contacts);
          console.log('this.state.contactscount_tag_elsif', this.state.contactscount_tag_elsif);
        }
      })
      .catch((error) => {
        this.setState({ contactscount_tag_elsif: 0 });
      });
  }
  entry_pointtag_close() {
    for (var i in this.state.tag_list) {
      $('#tg_' + this.state.tag_list[i]._id).attr('class', '');
      $('.tgselected_' + this.state.tag_list[i]._id).hide();
      $('.tgnotselected_' + this.state.tag_list[i]._id).show();
    }
    this.setState({
      compsrch_txt: '',
      tags_contact_count: 0,
      send_filtered_tag_list_up: [],
      edit_entrypnt_tags: false,
      edit_entrypnt_tags_data: {},
    });
    var event = new CustomEvent('newMessage', {
      detail: {
        message: 'Hello World!',
        time: new Date(),
      },
      bubbles: true,
      cancelable: true,
    });
    setTimeout(() => {
      this.tagcomp_search(event);
      this.setState({ tags_contact_count: 0 });
    }, 100);
  }

  entry_pointinbound_close() {
    $('#entryinbound').val('');
    this.setState({
      inbound_content: '',
      inbound_cond: '',
      edit_entrypnt_inbound_data: {},
      edit_entrypnt_inbound: false,
    });
  }
  entry_point_close = () => {
    $('.wfentrypt_contactstgl_div').hide();
    this.setState({ disable_contact: false, edit_entrypnt_contacts: false, edit_entrypnt_contacts_data: {} });
    var contac_id = this.state.contact_id;
    for (var i in contac_id) {
      $('#rw_' + contac_id[i]).attr('class', '');
      $('.selected_' + contac_id[i]).hide();
      $('.notselected_' + contac_id[i]).show();
    }
    this.setState({ contact_id: [], search_content: '' });
    var event = new CustomEvent('newMessage', {
      detail: {
        message: 'Hello World!',
        time: new Date(),
      },
      bubbles: true,
      cancelable: true,
    });
    this.contactSearch(event, true);
  };

  contactSearch = (e, cond) => {
    e.preventDefault();
    let Searchcontactslist = {};
    if (!cond && this.state.search_content?.length !== 0) {
      Searchcontactslist = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          search_text: !cond ? this.state.search_content : '',
        },
      };
    } else {
      Searchcontactslist = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
        },
      };
    }

    axios
      .get(API_CALL_ENDPOINT + '/contacts/list', Searchcontactslist)
      .then((res) => {
        if (res.data.status === 'no_record') {
          if (this.state.contacts.length === 0) {
            // document.getElementById('contact_nil').style.display = 'none';
          }
          this.setState({ contacts: [] });
          $('#contacts_nil').show();
          $('.contact_update_create').hide();

          // document.getElementsByClassName('contactsearch_nil').style.display = 'block';

          // setTimeout(() => {
          // 	document.getElementById('contactsearch_nil').style.display = 'none'
          // }, 3000)
        } else {
          $('#contacts_nil').hide();
          $('.contact_update_create').show();
          this.setState({ contacts: res.data?.result?.contacts });
          console.log('Search Result', this.state.contact_id);
          for (var j in res.data?.result?.contacts) {
            $('#rw_' + res.data?.result?.contacts[j]._id).attr('class', '');
            $('.selected_' + res.data?.result?.contacts[j]._id).hide();
            $('.notselected_' + res.data?.result?.contacts[j]._id).show();
          }
          // for (var i in this.state.contact_id) {
          //  // alert("testing");
          //   var slcted_vl = $('#rw_' + this.state.contact_id[i]).attr('class');
          //   if (slcted_vl !== 'selected') {
          //     $('#rw_' + this.state.contact_id[i]).attr('class', 'selected');
          //     $('.selected_' + this.state.contact_id[i]).show();
          //     $('.notselected_' + this.state.contact_id[i]).hide();
          //   }
          // }

          // document.getElementsByClassName('contactsearch_nil').style.display = 'none';
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            if (this.state.contacts.length === 0) {
              // document.getElementById('contact_nil').style.display = 'none';
            }
            this.setState({ contacts: [] });
            $('#contacts_nil').show();
            $('.contact_update_create').hide();

            // document.getElementsByClassName('contactsearch_nil').style.display = 'block';

            // setTimeout(() => {
            // 	document.getElementById('contactsearch_nil').style.display = 'none'
            // }, 3000)
          }
        }
      });
  };
  selct(contact) {
    var slcted_vl = $('#rw_' + contact.contact._id).attr('class');
    var slct = '#opn_' + contact.contact._id;
    if (slcted_vl == 'selected') {
      console.log('inside selected');
      //$('#rw_' + e.target.id).attr('class', '');
      //$('.selchk_' + e.target.id).remove();

      var array = this.state.contact_id; // make a separate copy of the array
      var index = array.indexOf(contact.contact._id);
      if (index !== -1) {
        array.splice(index, 1);

        this.setState({ contact_id: array });
      }
      $('#rw_' + contact.contact._id).attr('class', '');
      $('.selected_' + contact.contact._id).hide();
      $('.notselected_' + contact.contact._id).show();
    } else {
      console.log('inside not selected');

      //$('#rw_' + e.target.id).attr('class', 'selected');
      //$('<span className="selcheck" id="selchk_'+e.target.id+'"><i className="fas fa-check-circle mr-2"></i></span>').insertBefore('#slcttd_'+e.target.id);
      //$('.slcttd_' + e.target.id).prepend('<span className="selcheck selchk_' + e.target.id + '" id="' + e.target.id + '"><i className="fas fa-check-circle mr-2" id="' + e.target.id + '"></i></span>');
      var joined_ary = this.state.contact_id.concat(contact.contact._id);
      this.setState({
        contact_id: joined_ary,
      });
      $('#rw_' + contact.contact._id).attr('class', 'selected');
      $('.selected_' + contact.contact._id).show();
      $('.notselected_' + contact.contact._id).hide();
    }

    console.log(this.state.contact_id);
  }
  onChangeSeacrchcnt = (event) => {
    this.setState({ search_content: event.target.value });

    setTimeout(() => {
      this.contactSearch(event, false);
    }, 100);
  };
  onScrollToBottom_contact(e) {
    const target = e.target;

    const bottom = target?.clientHeight + target?.scrollTop + 1 > target?.scrollHeight;
    if (bottom) {
      const contactslist = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          start: this.state.contacts ? this.state.contacts?.length : 0,
          limit: 20,
        },
      };

      axios
        .get(API_CALL_ENDPOINT + '/contacts/list', contactslist)
        .then((res) => {
          if (res.data.status === 'no_record') {
          }
          if (res.data?.result?.contacts.length > 0) {
            // document.getElementById('contact_nil').style.display = 'none';
            this.setState({
              contacts: [...this.state.contacts, ...res.data?.result?.contacts],
              // disablecontactsearch: false,
            });
          }
          // this.setState({
          //   contacts: res.data?.result?.contacts,
          //   disablecontactsearch: false,
          // });
          for (var j in this.state.contact_id) {
            var slcted_vl = $('#rw_' + this.state.contact_id[j]).attr('class');
            if (slcted_vl !== 'selected') {
              $('#rw_' + this.state.contact_id[j]).attr('class', 'selected');
              $('.selected_' + this.state.contact_id[j]).show();
              $('.notselected_' + this.state.contact_id[j]).hide();
            }
          }
        })
        .catch((error) => {
          // console.log(error)
        });
    }
  }
  //Workflow steps list
  set_workflow_step_id_create_send_message = (workflow) => {
    this.setState({
      firstlevel_click: true,
      workflow_step_id_create: workflow.parent_steps_id,
      Workflow_step_if_else_data: workflow.ifelse_condition,
    });
    console.log(workflow);
  };
  set_workflow_step_id_create = (workflow) => {
    this.setState({
      firstlevel_click: false,
      workflow_step_id_create: workflow.parent_steps_id,
      Workflow_step_if_else_data: workflow.ifelse_condition,
    });
    console.log(workflow);
  };
  set_workflow_step_id_create_ifelse_no = (workflow) => {
    this.setState({
      firstlevel_click: false,
      workflow_step_id_create: JSON.parse(workflow.ifelse_no)._id,
      Workflow_step_if_else_data: workflow.ifelse_no,
    });
    console.log(workflow);
  };
  set_workflow_step_id_create_ifelse_yes = (workflow) => {
    this.setState({
      firstlevel_click: false,
      workflow_step_id_create: JSON.parse(workflow.ifelse_yes)._id,
      Workflow_step_if_else_data: workflow.ifelse_yes,
    });
    console.log(workflow);
  };
  workflow_steps_list(wf_id) {
    const steps_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: wf_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/steps/list', steps_list)
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({ workflow_steps_list_array: res?.data?.result });
          var append_id = 'first_level';
          var append_id_hide = '';
          var first_level_count = 0;
          var feed_yes = {};
          var feed_no = {};
          var append_id_no = '';
          var append_id_yes = '';
          var ifelse_no_data_id = [];
          var ifelse_yes_data_id = [];
          var ifelse_no_data_id_count = 0;
          var ifelse_yes_data_id_count = 0;
          ReactDOM.unmountComponentAtNode(document.getElementById(append_id));
          var workflowlatestdata = [];
          for (var i = 0; i < res?.data?.result.length; i++) {
            workflowlatestdata.push(res?.data?.result[i]);
            var id = res?.data?.result[i]._id;
            const onClick_elseif_edit = this.onEdit_elsif_edit.bind(this, res?.data?.result[i]);
            const getLable = this.getLable.bind(this, res?.data?.result[i]);
            const getTagsLable = this.getTagsLable.bind(this, res?.data?.result[i]);
            const onClick_del = this.delete_start_point.bind(this, res?.data?.result[i]);
            const onClickViewTags = this.view_tag_contact_count_elseif.bind(this, res?.data?.result[i]);
            const onEdit_startpoint_sendmsg = this.onEdit_startpoint_sendmsg.bind(this, res?.data?.result[i]);
            const onEdit_startpoint_delay = this.onEdit_startpoint_delay.bind(this, res?.data?.result[i]);
            const onEdit_step_ifelse = this.onEdit_step_ifelse.bind(this, res?.data?.result[i]);
            const set_workflow_step_id_create = this.set_workflow_step_id_create.bind(this, res?.data?.result[i]);
            const set_workflow_step_id_create_send_message = this.set_workflow_step_id_create_send_message.bind(
              this,
              res?.data?.result[i],
            );
            const set_workflow_step_id_create_ifelse_no = this.set_workflow_step_id_create_ifelse_no.bind(
              this,
              res?.data?.result[i],
            );
            const set_workflow_step_id_create_ifelse_yes = this.set_workflow_step_id_create_ifelse_yes.bind(
              this,
              res?.data?.result[i],
            );

            // console.log('ifelse_yes_data_id', ifelse_yes_data_id);
            // console.log('ifelse_no_data_id', ifelse_no_data_id);
            if (res?.data?.result[i].parent_steps_id === this.state.workflow_edit_data._id) {
              console.log('Asteps' + i, res?.data?.result[i]);
              first_level_count += 1;
              if (res?.data?.result[i].type === 'send_message') {
                ReactDOM.render(
                  <>
                    <a>
                      <div className="wfbox bgblue position-relative mt-2">
                        <span className="wf_icondiv wf_icondivpos">
                          <i className="far fa-comment-alt" />
                        </span>
                        <span className="font-weight-bold">Send Message</span>
                        <br />
                        <span>
                          Message Content -{' '}
                          <span className="font-weight-bold fmaroon">{res?.data?.result[i].message}</span>
                        </span>
                        <br />
                        <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                        <div className="wf_actnbtnsdiv">
                          <span
                            className="wf_actionicondiv bg_delete"
                            id={res?.data?.result[i]._id}
                            onClick={onClick_del}>
                            <i className="fas fa-trash-alt" />
                          </span>
                          <span
                            id={res?.data?.result[i]._id}
                            onClick={onEdit_startpoint_sendmsg}
                            className="wf_actionicondiv"
                            data-toggle="modal"
                            data-target="#modal_wfsendsms"
                            data-backdrop="static">
                            <i className="fas fa-pen" />
                          </span>
                        </div>
                      </div>
                    </a>
                    <ul>
                      <li>
                        <a
                          id={'append_id_hide_' + res?.data?.result[i]._id}
                          data-toggle="modal"
                          data-target="#modal_wfstep"
                          data-backdrop="static"
                          className="crsr_pntr pb-2"
                          onClick={set_workflow_step_id_create_send_message}>
                          <div className="wfbox p-0 brdr_none">
                            <span className="wf_icondiv">
                              <i className="fas fa-plus" />
                            </span>
                          </div>
                        </a>
                        <ul>
                          <li id={'append_id_' + res?.data?.result[i]._id}></li>
                        </ul>
                      </li>
                    </ul>
                  </>,
                  document.getElementById(append_id),
                );

                append_id = 'append_id_' + res?.data?.result[i]._id;
                $(append_id_hide).hide();
                append_id_hide = '#append_id_hide_' + res?.data?.result[i]._id;
              } else if (res?.data?.result[i].type === 'delay') {
                ReactDOM.render(
                  <>
                    <a>
                      <div className="wfbox bgyellow position-relative mt-2">
                        <span className="wf_icondiv wf_icondivpos">
                          <i className="fas fa-spinner" />
                        </span>
                        <span className="font-weight-bold">Wait</span>
                        <br />
                        <span>
                          For{' '}
                          <span className="font-weight-bold fmaroon">
                            {res?.data?.result[i].delay_count}{' '}
                            {res?.data?.result[i].delay_time === 'minutes'
                              ? 'Minute(s)'
                              : res?.data?.result[i].delay_time === 'hours'
                                ? 'Hour(s)'
                                : res?.data?.result[i].delay_time === 'days'
                                  ? 'Day(s)'
                                  : res?.data?.result[i].delay_time === 'weeks'
                                    ? 'Week(s)'
                                    : 'Month(s)'}
                          </span>
                        </span>
                        <br />
                        <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                        <div className="wf_actnbtnsdiv">
                          <span
                            id={res?.data?.result[i]._id}
                            onClick={onClick_del}
                            className="wf_actionicondiv bg_delete">
                            <i className="fas fa-trash-alt" />
                          </span>
                          <span
                            id={res?.data?.result[i]._id}
                            onClick={onEdit_startpoint_delay}
                            className="wf_actionicondiv"
                            data-toggle="modal"
                            data-target="#modal_wfdelay"
                            data-backdrop="static">
                            <i className="fas fa-pen" />
                          </span>
                        </div>
                      </div>
                    </a>
                    <ul>
                      <li>
                        <a
                          id={'append_id_hide_' + res?.data?.result[i]._id}
                          data-toggle="modal"
                          data-target="#modal_wfstep"
                          data-backdrop="static"
                          className="crsr_pntr pb-2"
                          onClick={set_workflow_step_id_create}>
                          <div className="wfbox p-0 brdr_none">
                            <span className="wf_icondiv">
                              <i className="fas fa-plus" />
                            </span>
                          </div>
                        </a>
                        <ul>
                          <li id={'append_id_' + res?.data?.result[i]._id}></li>
                        </ul>
                      </li>
                    </ul>
                  </>,
                  document.getElementById(append_id),
                );

                append_id = 'append_id_' + res?.data?.result[i]._id;
                $(append_id_hide).hide();
                append_id_hide = '#append_id_hide_' + res?.data?.result[i]._id;
              } else if (res?.data?.result[i].type === 'update_contact') {
                ReactDOM.render(
                  <>
                    <a>
                      <div className="wfbox bgblue  position-relative mt-2">
                        <span className="wf_icondiv wf_icondivpos">
                          <i className="fas fa-user" />
                        </span>
                        <span className="font-weight-bold">Update Contacts</span>
                        <br />
                        <span>
                          <span
                            onClick={res?.data?.result[i].update_contact_type === 'contacts' ? getLable : null}
                            id={'get_label' + res?.data?.result[i]._id}>
                            {res?.data?.result[i].update_contact_type === 'assign_tags'
                              ? 'Assign contact to the Tag -'
                              : res?.data?.result[i].update_contact_type === 'remove_tags'
                                ? 'Remove contact from the Tag -'
                                : res?.data?.result[i].update_contact_type === 'notes'
                                  ? 'Notes -'
                                  : res?.data?.result[i].update_contact_type === 'contacts'
                                    ? ''
                                    : 'For -'}{' '}
                          </span>
                          <span
                            className="font-weight-bold fmaroon"
                            onClick={
                              res?.data?.result[i].update_contact_type === 'assign_tags' ||
                                res?.data?.result[i].update_contact_type === 'remove_tags'
                                ? getTagsLable
                                : null
                            }
                            id={'get_tags_label' + res?.data?.result[i]._id}>
                            {res?.data?.result[i].update_contact_type === 'assign_tags' ? 'Tags Assigned' : ''}
                            {res?.data?.result[i].update_contact_type === 'remove_tags' ? 'Tags Removed' : ''}
                            {res?.data?.result[i].update_contact_type === 'notes'
                              ? res?.data?.result[i].field_value
                              : res?.data?.result[i].update_contact_type === 'contacts'
                                ? res?.data?.result[i].field_value
                                : ''}{' '}
                          </span>
                        </span>
                        <br />
                        <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                        <div className="wf_actnbtnsdiv">
                          <span
                            id={res?.data?.result[i]._id}
                            onClick={onClick_del}
                            className="wf_actionicondiv bg_delete">
                            <i className="fas fa-trash-alt" />
                          </span>
                          <span
                            id={res?.data?.result[i]._id}
                            onClick={onClick_elseif_edit}
                            className="wf_actionicondiv"
                            data-toggle="modal"
                            data-target="#modal_wfupdcontact"
                            data-backdrop="static">
                            <i className="fas fa-pen" />
                          </span>
                        </div>
                      </div>
                    </a>
                    <ul>
                      <li>
                        <a
                          id={'append_id_hide_' + res?.data?.result[i]._id}
                          data-toggle="modal"
                          data-target="#modal_wfstep"
                          data-backdrop="static"
                          className="crsr_pntr pb-2"
                          onClick={set_workflow_step_id_create}>
                          <div className="wfbox p-0 brdr_none">
                            <span className="wf_icondiv">
                              <i className="fas fa-plus" />
                            </span>
                          </div>
                        </a>
                        <ul>
                          <li id={'append_id_' + res?.data?.result[i]._id}></li>
                        </ul>
                      </li>
                    </ul>
                  </>,
                  document.getElementById(append_id),
                );

                append_id = 'append_id_' + res?.data?.result[i]._id;
                $(append_id_hide).hide();
                append_id_hide = '#append_id_hide_' + res?.data?.result[i]._id;
              } else if (res?.data?.result[i].type === 'if_else') {
                console.log('Elseif1');
                ReactDOM.render(
                  <>
                    <a>
                      <div className="wfbox bgblue position-relative mt-2">
                        <span className="wf_icondiv wf_icondivpos">
                          <i className="far fa-comment-alt" />
                        </span>
                        <span className="font-weight-bold">If / Else</span>
                        <br />
                        <span>
                          Filter -{' '}
                          {res?.data?.result[i].inbound_type === 'equal_to'
                            ? 'Equal to'
                            : res?.data?.result[i].inbound_type === 'start_with'
                              ? 'Starts with'
                              : res?.data?.result[i].inbound_type === 'contains'
                                ? 'Contains'
                                : res?.data?.result[i].inbound_type === 'no_specification'
                                  ? 'No Specification'
                                  : res?.data?.result[i].ifelse_type === 'tags'
                                    ? 'Tags'
                                    : ''}{' '}
                          <span className="font-weight-bold fmaroon">
                            {res?.data?.result[i].ifelse_type === 'tags'
                              ? res?.data?.result[i].tags?.length
                              : res?.data?.result[i].inbound_content}
                          </span>
                          {res?.data?.result[i].ifelse_type === 'tags' ? (
                            <>
                              <span
                                onClick={onClickViewTags}
                                className={
                                  'fmaroon ml-2 crsr_pntr wftags_viewct elseif_view_tags wf_tag_view_else_' +
                                  res?.data?.result[i]._id
                                }>
                                (View)
                              </span>
                              <span
                                className={
                                  'ml-2 crsr_pntr wftags_ctcount elseif_view_contcs wf_tag_cont_else_' +
                                  res?.data?.result[i]._id
                                }
                                style={{ display: 'none' }}>
                                (
                                <span
                                  className="fmaroon font-weight-bold"
                                  id={'wf_tag_cont_else_' + res?.data?.result[i]._id}>
                                  0
                                </span>{' '}
                                contact(s))
                              </span>
                            </>
                          ) : (
                            ''
                          )}
                        </span>
                        <br />
                        <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                        <div className="wf_actnbtnsdiv">
                          <span
                            id={res?.data?.result[i]._id}
                            className="wf_actionicondiv bg_delete"
                            onClick={onClick_del}>
                            <i className="fas fa-trash-alt" />
                          </span>
                          <span
                            id={res?.data?.result[i]._id}
                            className="wf_actionicondiv"
                            data-toggle="modal"
                            data-target={
                              res?.data?.result[i].ifelse_type === 'inbound'
                                ? '#modal_wfifelse_inboundmsg'
                                : res?.data?.result[i].ifelse_type === 'tags'
                                  ? '#modal_entrypt_tags_if'
                                  : res?.data?.result[i].ifelse_type === 'contacts'
                                    ? '#modal_entrypt_customprop'
                                    : ''
                            }
                            data-backdrop="static"
                            onClick={onClick_elseif_edit}>
                            <i className="fas fa-pen" />
                          </span>
                        </div>
                      </div>
                    </a>
                    <ul>
                      <li>
                        <a>
                          <div className="wfbox_sm bgyes font-weight-semibold">YES</div>
                        </a>
                        <ul>
                          <li>
                            <a
                              id={'append_id_yes_hide_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}
                              data-toggle="modal"
                              data-target="#modal_wfstep"
                              data-backdrop="static"
                              className="crsr_pntr pb-2"
                              onClick={set_workflow_step_id_create_ifelse_yes}>
                              <div className="wfbox p-0 brdr_none">
                                <span className="wf_icondiv">
                                  <i className="fas fa-plus" />
                                </span>
                              </div>
                            </a>
                            <ul>
                              <li id={'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}></li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a>
                          <div className="wfbox_sm bgno font-weight-semibold">NO</div>
                        </a>
                        <ul>
                          <li>
                            <a
                              id={'append_id_no_hide_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}
                              data-toggle="modal"
                              data-target="#modal_wfstep"
                              data-backdrop="static"
                              className="crsr_pntr pb-2"
                              onClick={set_workflow_step_id_create_ifelse_no}>
                              <div className="wfbox p-0 brdr_none">
                                <span className="wf_icondiv">
                                  <i className="fas fa-plus" />
                                </span>
                              </div>
                            </a>
                            <ul>
                              <li id={'append_id_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}></li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </>,
                  document.getElementById(append_id),
                );
                $(append_id_hide).hide();
                // append_id = 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                append_id = 'append_id_' + res?.data?.result[i]._id;
                feed_yes = {
                  parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                  ifelse_yes_data_id_count: 1,
                  append_id_yes: 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                  append_id_yes_hide: '#append_id_yes_hide_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                };
                feed_no = {
                  parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_no)._id,
                  ifelse_no_data_id_count: 1,
                  append_id_no: 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                  append_id_no_hide: '#append_id_no_hide_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                };
                console.log('feed_yes', feed_yes);
                console.log('feed_no', feed_no);
                ifelse_yes_data_id.push(feed_yes);
                ifelse_no_data_id.push(feed_no);
              }
            }
            //first
            else {
              console.log('Bsteps' + i, res?.data?.result[i]);
              if (JSON.parse(res?.data?.result[i].ifelse_condition).type === 'yes') {
                console.log('Csteps' + i, res?.data?.result[i]);
                for (var j = 0; j < ifelse_yes_data_id.length; j++) {
                  console.log('out', ifelse_yes_data_id[j]);
                  if (res?.data?.result[i].parent_steps_id === ifelse_yes_data_id[j].parent_steps_id) {
                    console.log('in', ifelse_yes_data_id[j]);
                    if (res?.data?.result[i].type === 'send_message') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">Send Message</span>
                              <br />
                              <span>
                                Message Content -{' '}
                                <span className="font-weight-bold fmaroon">{res?.data?.result[i].message}</span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_yes_data_id[j].ifelse_yes_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  className="wf_actionicondiv bg_delete"
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_del}>
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onEdit_startpoint_sendmsg}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target="#modal_wfsendsms"
                                  data-backdrop="static">
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a
                                id={'append_id_yes_hide_' + res?.data?.result[i]._id}
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                className="crsr_pntr pb-2"
                                onClick={set_workflow_step_id_create_send_message}>
                                <div className="wfbox p-0 brdr_none">
                                  <span className="wf_icondiv">
                                    <i className="fas fa-plus" />
                                  </span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_' + res?.data?.result[i]._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_yes_data_id[j].append_id_yes),
                      );
                      ifelse_yes_data_id[j].ifelse_yes_data_id_count += 1;
                      ifelse_yes_data_id[j].append_id_yes = 'append_id_' + res?.data?.result[i]._id;
                      $(ifelse_yes_data_id[j].append_id_yes_hide).hide();
                      ifelse_yes_data_id[j].append_id_yes_hide = '#append_id_yes_hide_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'delay') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgyellow position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="fas fa-spinner" />
                              </span>
                              <span className="font-weight-bold">Wait</span>
                              <br />
                              <span>
                                For{' '}
                                <span className="font-weight-bold fmaroon">
                                  {res?.data?.result[i].delay_count}{' '}
                                  {res?.data?.result[i].delay_time === 'minutes'
                                    ? 'Minute(s)'
                                    : res?.data?.result[i].delay_time === 'hours'
                                      ? 'Hour(s)'
                                      : res?.data?.result[i].delay_time === 'days'
                                        ? 'Day(s)'
                                        : res?.data?.result[i].delay_time === 'weeks'
                                          ? 'Week(s)'
                                          : 'Month(s)'}
                                </span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_yes_data_id[j].ifelse_yes_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_del}
                                  className="wf_actionicondiv bg_delete">
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onEdit_startpoint_delay}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target="#modal_wfdelay"
                                  data-backdrop="static">
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a
                                id={'append_id_yes_hide_' + res?.data?.result[i]._id}
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                className="crsr_pntr pb-2"
                                onClick={set_workflow_step_id_create}>
                                <div className="wfbox p-0 brdr_none">
                                  <span className="wf_icondiv">
                                    <i className="fas fa-plus" />
                                  </span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_' + res?.data?.result[i]._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_yes_data_id[j].append_id_yes),
                      );
                      ifelse_yes_data_id[j].ifelse_yes_data_id_count += 1;
                      ifelse_yes_data_id[j].append_id_yes = 'append_id_' + res?.data?.result[i]._id;
                      $(ifelse_yes_data_id[j].append_id_yes_hide).hide();
                      ifelse_yes_data_id[j].append_id_yes_hide = '#append_id_yes_hide_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'update_contact') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue  position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="fas fa-user" />
                              </span>
                              <span className="font-weight-bold">Update Contacts</span>
                              <br />
                              <span>
                                <span
                                  onClick={res?.data?.result[i].update_contact_type === 'contacts' ? getLable : null}
                                  id={'get_label' + res?.data?.result[i]._id}>
                                  {res?.data?.result[i].update_contact_type === 'assign_tags'
                                    ? 'Assign contact to the Tag -'
                                    : res?.data?.result[i].update_contact_type === 'remove_tags'
                                      ? 'Remove contact from the Tag -'
                                      : res?.data?.result[i].update_contact_type === 'notes'
                                        ? 'Notes -'
                                        : res?.data?.result[i].update_contact_type === 'contacts'
                                          ? ''
                                          : 'For -'}{' '}
                                </span>
                                <span
                                  className="font-weight-bold fmaroon"
                                  onClick={
                                    res?.data?.result[i].update_contact_type === 'assign_tags' ||
                                      res?.data?.result[i].update_contact_type === 'remove_tags'
                                      ? getTagsLable
                                      : null
                                  }
                                  id={'get_tags_label' + res?.data?.result[i]._id}>
                                  {res?.data?.result[i].update_contact_type === 'assign_tags' ? 'Tags Assigned' : ''}
                                  {res?.data?.result[i].update_contact_type === 'remove_tags' ? 'Tags Removed' : ''}
                                  {res?.data?.result[i].update_contact_type === 'notes'
                                    ? res?.data?.result[i].field_value
                                    : res?.data?.result[i].update_contact_type === 'contacts'
                                      ? res?.data?.result[i].field_value
                                      : ''}{' '}
                                </span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_del}
                                  className="wf_actionicondiv bg_delete">
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_elseif_edit}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target="#modal_wfupdcontact"
                                  data-backdrop="static">
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a
                                id={'append_id_yes_hide_' + res?.data?.result[i]._id}
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                className="crsr_pntr pb-2"
                                onClick={set_workflow_step_id_create}>
                                <div className="wfbox p-0 brdr_none">
                                  <span className="wf_icondiv">
                                    <i className="fas fa-plus" />
                                  </span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_' + res?.data?.result[i]._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_yes_data_id[j].append_id_yes),
                      );
                      ifelse_yes_data_id[j].ifelse_yes_data_id_count += 1;
                      ifelse_yes_data_id[j].append_id_yes = 'append_id_' + res?.data?.result[i]._id;
                      $(ifelse_yes_data_id[j].append_id_yes_hide).hide();
                      ifelse_yes_data_id[j].append_id_yes_hide = '#append_id_yes_hide_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'if_else') {
                      console.log('Ifelse2');
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">If / Else</span>
                              <br />
                              <span>
                                Filter -{' '}
                                {res?.data?.result[i].inbound_type === 'equal_to'
                                  ? 'Equal to'
                                  : res?.data?.result[i].inbound_type === 'start_with'
                                    ? 'Starts with'
                                    : res?.data?.result[i].inbound_type === 'contains'
                                      ? 'Contains'
                                      : res?.data?.result[i].inbound_type === 'no_specification'
                                        ? 'No Specification'
                                        : res?.data?.result[i].ifelse_type === 'tags'
                                          ? 'Tags'
                                          : ''}{' '}
                                <span className="font-weight-bold fmaroon">
                                  {res?.data?.result[i].ifelse_type === 'tags'
                                    ? res?.data?.result[i].tags?.length
                                    : res?.data?.result[i].inbound_content}
                                </span>
                                {res?.data?.result[i].ifelse_type === 'tags' ? (
                                  <>
                                    <span
                                      onClick={onClickViewTags}
                                      className={
                                        'fmaroon ml-2 crsr_pntr wftags_viewct elseif_view_tags wf_tag_view_else_' +
                                        res?.data?.result[i]._id
                                      }>
                                      (View)
                                    </span>
                                    <span
                                      className={
                                        'ml-2 crsr_pntr wftags_ctcount elseif_view_contcs wf_tag_cont_else_' +
                                        res?.data?.result[i]._id
                                      }
                                      style={{ display: 'none' }}>
                                      (
                                      <span
                                        className="fmaroon font-weight-bold"
                                        id={'wf_tag_cont_else_' + res?.data?.result[i]._id}>
                                        0
                                      </span>{' '}
                                      contact(s))
                                    </span>
                                  </>
                                ) : (
                                  ''
                                )}
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_yes_data_id[j].ifelse_yes_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  id={res?.data?.result[i]._id}
                                  className="wf_actionicondiv bg_delete"
                                  onClick={onClick_del}>
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target={
                                    res?.data?.result[i].ifelse_type === 'inbound'
                                      ? '#modal_wfifelse_inboundmsg'
                                      : res?.data?.result[i].ifelse_type === 'tags'
                                        ? '#modal_entrypt_tags_if'
                                        : res?.data?.result[i].ifelse_type === 'contacts'
                                          ? '#modal_entrypt_customprop'
                                          : ''
                                  }
                                  data-backdrop="static"
                                  onClick={onClick_elseif_edit}>
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a>
                                <div className="wfbox_sm bgyes font-weight-semibold">YES</div>
                              </a>
                              <ul>
                                <li>
                                  <a
                                    id={'append_id_yes_hide_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}
                                    data-toggle="modal"
                                    data-target="#modal_wfstep"
                                    data-backdrop="static"
                                    className="crsr_pntr pb-2"
                                    onClick={set_workflow_step_id_create_ifelse_yes}>
                                    <div className="wfbox p-0 brdr_none">
                                      <span className="wf_icondiv">
                                        <i className="fas fa-plus" />
                                      </span>
                                    </div>
                                  </a>
                                  <ul>
                                    <li id={'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}></li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a>
                                <div className="wfbox_sm bgno font-weight-semibold">NO</div>
                              </a>
                              <ul>
                                <li>
                                  <a
                                    id={'append_id_no_hide_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}
                                    data-toggle="modal"
                                    data-target="#modal_wfstep"
                                    data-backdrop="static"
                                    className="crsr_pntr pb-2"
                                    onClick={set_workflow_step_id_create_ifelse_no}>
                                    <div className="wfbox p-0 brdr_none">
                                      <span className="wf_icondiv">
                                        <i className="fas fa-plus" />
                                      </span>
                                    </div>
                                  </a>
                                  <ul>
                                    <li id={'append_id_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}></li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_yes_data_id[j].append_id_yes),
                      );
                      $(ifelse_yes_data_id[j].append_id_yes_hide).hide();
                      feed_yes = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                        ifelse_yes_data_id_count: 1,
                        append_id_yes: 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                        append_id_yes_hide: '#append_id_yes_hide_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                      };
                      feed_no = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_no)._id,
                        ifelse_no_data_id_count: 1,
                        append_id_no: 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                        append_id_no_hide: '#append_id_no_hide_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                      };

                      ifelse_yes_data_id.push(feed_yes);
                      ifelse_no_data_id.push(feed_no);
                      // append_id = 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                      //  ifelse_no_data_id_1_yes = JSON.parse(res?.data?.result[i].ifelse_no)._id;
                      //  ifelse_yes_data_id_1_yes =JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                    }
                  }
                }
              } else {
                console.log('Dsteps' + i, res?.data?.result[i]);
                for (var k = 0; k < ifelse_no_data_id.length; k++) {
                  console.log('out no', ifelse_no_data_id[k]);
                  console.log('dataa', res?.data?.result[i]);
                  if (res?.data?.result[i].parent_steps_id === ifelse_no_data_id[k].parent_steps_id) {
                    console.log('in no', ifelse_no_data_id[k]);
                    if (res?.data?.result[i].type === 'send_message') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">Send Message</span>
                              <br />
                              <span>
                                Message Content -{' '}
                                <span className="font-weight-bold fmaroon">{res?.data?.result[i].message}</span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_no_data_id[k].ifelse_no_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  className="wf_actionicondiv bg_delete"
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_del}>
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onEdit_startpoint_sendmsg}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target="#modal_wfsendsms"
                                  data-backdrop="static">
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a
                                id={'append_id_no_hide_' + res?.data?.result[i]._id}
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                className="crsr_pntr pb-2"
                                onClick={set_workflow_step_id_create_send_message}>
                                <div className="wfbox p-0 brdr_none">
                                  <span className="wf_icondiv">
                                    <i className="fas fa-plus" />
                                  </span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_' + res?.data?.result[i]._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_no_data_id[k].append_id_no),
                      );

                      ifelse_no_data_id[k].ifelse_no_data_id_count += 1;
                      ifelse_no_data_id[k].append_id_no = 'append_id_' + res?.data?.result[i]._id;
                      $(ifelse_no_data_id[k].append_id_no_hide).hide();
                      ifelse_no_data_id[k].append_id_no_hide = '#append_id_no_hide_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'delay') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgyellow position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="fas fa-spinner" />
                              </span>
                              <span className="font-weight-bold">Wait</span>
                              <br />
                              <span>
                                For{' '}
                                <span className="font-weight-bold fmaroon">
                                  {res?.data?.result[i].delay_count}{' '}
                                  {res?.data?.result[i].delay_time === 'minutes'
                                    ? 'Minute(s)'
                                    : res?.data?.result[i].delay_time === 'hours'
                                      ? 'Hour(s)'
                                      : res?.data?.result[i].delay_time === 'days'
                                        ? 'Day(s)'
                                        : res?.data?.result[i].delay_time === 'weeks'
                                          ? 'Week(s)'
                                          : 'Month(s)'}
                                </span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_no_data_id[k].ifelse_no_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_del}
                                  className="wf_actionicondiv bg_delete">
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onEdit_startpoint_delay}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target="#modal_wfdelay"
                                  data-backdrop="static">
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a
                                id={'append_id_no_hide_' + res?.data?.result[i]._id}
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                className="crsr_pntr pb-2"
                                onClick={set_workflow_step_id_create}>
                                <div className="wfbox p-0 brdr_none">
                                  <span className="wf_icondiv">
                                    <i className="fas fa-plus" />
                                  </span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_' + res?.data?.result[i]._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_no_data_id[k].append_id_no),
                      );
                      ifelse_no_data_id[k].ifelse_no_data_id_count += 1;
                      ifelse_no_data_id[k].append_id_no = 'append_id_' + res?.data?.result[i]._id;
                      $(ifelse_no_data_id[k].append_id_no_hide).hide();
                      ifelse_no_data_id[k].append_id_no_hide = '#append_id_no_hide_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'update_contact') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue  position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="fas fa-user" />
                              </span>
                              <span className="font-weight-bold">Update Contacts</span>
                              <br />
                              <span>
                                <span
                                  onClick={res?.data?.result[i].update_contact_type === 'contacts' ? getLable : null}
                                  id={'get_label' + res?.data?.result[i]._id}>
                                  {res?.data?.result[i].update_contact_type === 'assign_tags'
                                    ? 'Assign contact to the Tag -'
                                    : res?.data?.result[i].update_contact_type === 'remove_tags'
                                      ? 'Remove contact from the Tag -'
                                      : res?.data?.result[i].update_contact_type === 'notes'
                                        ? 'Notes -'
                                        : res?.data?.result[i].update_contact_type === 'contacts'
                                          ? ''
                                          : 'For -'}{' '}
                                </span>
                                <span
                                  className="font-weight-bold fmaroon"
                                  onClick={
                                    res?.data?.result[i].update_contact_type === 'assign_tags' ||
                                      res?.data?.result[i].update_contact_type === 'remove_tags'
                                      ? getTagsLable
                                      : null
                                  }
                                  id={'get_tags_label' + res?.data?.result[i]._id}>
                                  {res?.data?.result[i].update_contact_type === 'assign_tags' ? 'Tags Assigned' : ''}
                                  {res?.data?.result[i].update_contact_type === 'remove_tags' ? 'Tags Removed' : ''}
                                  {res?.data?.result[i].update_contact_type === 'notes'
                                    ? res?.data?.result[i].field_value
                                    : res?.data?.result[i].update_contact_type === 'contacts'
                                      ? res?.data?.result[i].field_value
                                      : ''}{' '}
                                </span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_del}
                                  className="wf_actionicondiv bg_delete">
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  onClick={onClick_elseif_edit}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target="#modal_wfupdcontact"
                                  data-backdrop="static">
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a
                                id={'append_id_no_hide_' + res?.data?.result[i]._id}
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                className="crsr_pntr pb-2"
                                onClick={set_workflow_step_id_create}>
                                <div className="wfbox p-0 brdr_none">
                                  <span className="wf_icondiv">
                                    <i className="fas fa-plus" />
                                  </span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_' + res?.data?.result[i]._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_no_data_id[k].append_id_no),
                      );

                      ifelse_no_data_id[k].ifelse_no_data_id_count += 1;
                      ifelse_no_data_id[k].append_id_no = 'append_id_' + res?.data?.result[i]._id;
                      $(ifelse_no_data_id[k].append_id_no_hide).hide();
                      ifelse_no_data_id[k].append_id_no_hide = '#append_id_no_hide_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'if_else') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">If / Else</span>
                              <br />
                              <span>
                                Filter -{' '}
                                {res?.data?.result[i].inbound_type === 'equal_to'
                                  ? 'Equal to'
                                  : res?.data?.result[i].inbound_type === 'start_with'
                                    ? 'Starts with'
                                    : res?.data?.result[i].inbound_type === 'contains'
                                      ? 'Contains'
                                      : res?.data?.result[i].inbound_type === 'no_specification'
                                        ? 'No Specification'
                                        : res?.data?.result[i].ifelse_type === 'tags'
                                          ? 'Tags'
                                          : ''}{' '}
                                <span className="font-weight-bold fmaroon">
                                  {res?.data?.result[i].ifelse_type === 'tags'
                                    ? res?.data?.result[i].tags?.length
                                    : res?.data?.result[i].inbound_content}
                                </span>
                                {res?.data?.result[i].ifelse_type === 'tags' ? (
                                  <>
                                    <span
                                      onClick={onClickViewTags}
                                      className={
                                        'fmaroon ml-2 crsr_pntr wftags_viewct elseif_view_tags wf_tag_view_else_' +
                                        res?.data?.result[i]._id
                                      }>
                                      (View)
                                    </span>
                                    <span
                                      className={
                                        'ml-2 crsr_pntr wftags_ctcount elseif_view_contcs wf_tag_cont_else_' +
                                        res?.data?.result[i]._id
                                      }
                                      style={{ display: 'none' }}>
                                      (
                                      <span
                                        className="fmaroon font-weight-bold"
                                        id={'wf_tag_cont_else_' + res?.data?.result[i]._id}>
                                        0
                                      </span>{' '}
                                      contact(s))
                                    </span>
                                  </>
                                ) : (
                                  ''
                                )}
                              </span>

                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_no_data_id[k].ifelse_no_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  id={res?.data?.result[i]._id}
                                  className="wf_actionicondiv bg_delete"
                                  onClick={onClick_del}>
                                  <i className="fas fa-trash-alt" />
                                </span>
                                <span
                                  id={res?.data?.result[i]._id}
                                  className="wf_actionicondiv"
                                  data-toggle="modal"
                                  data-target={
                                    res?.data?.result[i].ifelse_type === 'inbound'
                                      ? '#modal_wfifelse_inboundmsg'
                                      : res?.data?.result[i].ifelse_type === 'tags'
                                        ? '#modal_entrypt_tags_if'
                                        : res?.data?.result[i].ifelse_type === 'contacts'
                                          ? '#modal_entrypt_customprop'
                                          : ''
                                  }
                                  data-backdrop="static"
                                  onClick={onClick_elseif_edit}>
                                  <i className="fas fa-pen" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a>
                                <div className="wfbox_sm bgyes font-weight-semibold">YES</div>
                              </a>
                              <ul>
                                <li>
                                  <a
                                    id={'append_id_yes_hide_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}
                                    data-toggle="modal"
                                    data-target="#modal_wfstep"
                                    data-backdrop="static"
                                    className="crsr_pntr pb-2"
                                    onClick={set_workflow_step_id_create_ifelse_yes}>
                                    <div className="wfbox p-0 brdr_none">
                                      <span className="wf_icondiv">
                                        <i className="fas fa-plus" />
                                      </span>
                                    </div>
                                  </a>
                                  <ul>
                                    <li id={'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}></li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a>
                                <div className="wfbox_sm bgno font-weight-semibold">NO</div>
                              </a>
                              <ul>
                                <li>
                                  <a
                                    id={'append_id_no_hide_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}
                                    data-toggle="modal"
                                    data-target="#modal_wfstep"
                                    data-backdrop="static"
                                    className="crsr_pntr pb-2"
                                    onClick={set_workflow_step_id_create_ifelse_no}>
                                    <div className="wfbox p-0 brdr_none">
                                      <span className="wf_icondiv">
                                        <i className="fas fa-plus" />
                                      </span>
                                    </div>
                                  </a>
                                  <ul>
                                    <li id={'append_id_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}></li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_no_data_id[k].append_id_no),
                      );
                      $(ifelse_no_data_id[k].append_id_no_hide).hide();
                      feed_yes = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                        ifelse_yes_data_id_count: 1,
                        append_id_yes: 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                        append_id_yes_hide: '#append_id_yes_hide_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                      };
                      feed_no = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_no)._id,
                        ifelse_no_data_id_count: 1,
                        append_id_no: 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                        append_id_no_hide: '#append_id_no_hide_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                      };

                      ifelse_yes_data_id.push(feed_yes);
                      ifelse_no_data_id.push(feed_no);
                      // append_id = 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                      //  ifelse_no_data_id_1_yes = JSON.parse(res?.data?.result[i].ifelse_no)._id;
                      //  ifelse_yes_data_id_1_yes =JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                    }
                  }
                }
              }
            }

            if (res?.data?.result[i].update_contact_type === 'contacts') {
              $('#get_label' + res?.data?.result[i]._id + '').trigger('click');
            }
            if (
              res?.data?.result[i].update_contact_type === 'assign_tags' ||
              res?.data?.result[i].update_contact_type === 'remove_tags'
            ) {
              $('#get_tags_label' + res?.data?.result[i]._id + '').trigger('click');
            }
          }
          $('.postop_5').trigger('click');
          this.setState({
            disable_tag: false,
            disable_send_msg: false,
            disable_start_delay: false,
            disable_step_inbound: false,
          });
          // console.log(document.getElementById('first_level').outerHTML)
          //           this.first_level_wf.push(document.getElementById('first_level').outerHTML);

          // $("#first_level").append('<li> <a> <div class="wfbox bgblue position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="far fa-comment-alt"></i></span> <span class="font-weight-bold">Send Message</span><br/> <span>Message Content - <span class="font-weight-bold fmaroon">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Type "1".</span></span><br/> <span class="wf_startpt_pos flightgrey3">#1</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete" onClick={()=>alert("clicked")}><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfsendsms" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgblue position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="far fa-comment-alt"></i></span> <span class="font-weight-bold">If / Else</span><br/> <span>Filter - <span class="font-weight-bold fmaroon">inbound message with "1"</span></span><br/> <span class="wf_startpt_pos flightgrey3">#2</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfifelse_inboundmsg" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a><div class="wfbox_sm bgyes font-weight-semibold">YES</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgyellow position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="fas fa-spinner"></i></span> <span class="font-weight-bold">Wait</span><br/> <span>For <span class="font-weight-bold fmaroon">1 day(s)</span></span><br/> <span class="wf_startpt_pos flightgrey3">#3</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfdelay" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgblue position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="far fa-comment-alt"></i></span> <span class="font-weight-bold">Send Message</span><br/> <span>Message Content - <span class="font-weight-bold fmaroon">Lorem Ipsum is simply dummy text of the print</span></span><br/> <span class="wf_startpt_pos flightgrey3">#4</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfsendsms" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgyellow position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="fas fa-spinner"></i></span> <span class="font-weight-bold">Wait</span><br/> <span>For <span class="font-weight-bold fmaroon">3 day(s)</span></span><br/> <span>Until - <span class="font-weight-bold fmaroon">inbound message with "1"</span></span><br/> <span class="wf_startpt_pos flightgrey3">#5</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfwaituntil_inboundmsg" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a><div class="wfbox_sm bgyes font-weight-semibold">YES</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> </li> </ul> </li> <li> <a><div class="wfbox_sm bgno font-weight-semibold">NO</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> <li> <a><div class="wfbox_sm bgno font-weight-semibold">NO</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li>')
        } else if (res.data.status === 'no_record') {
          ReactDOM.unmountComponentAtNode(document.getElementById('first_level'));
          this.setState({
            workflow_steps_list_array: [],
          });
        }
      })
      .catch((error) => {
        console.log('error_check', error);
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            ReactDOM.unmountComponentAtNode(document.getElementById('first_level'));
            this.setState({
              workflow_steps_list_array: [],
            });
          }
        }
      });
  }
  workflow_steps_list_array_map(wf_list) { }
  workflow_info = (wf_id) => {
    const workflow_info = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: wf_id,
      },
    };
    axios.get(API_CALL_ENDPOINT + '/business/workflow/info', workflow_info).then((res) => {
      if (res.data.status === 'success') {
        this.setState({
          workflow_edit_data: res.data?.result[0],
          workflow_edit_name: res.data?.result[0].workflow_name,
        });
      }
    });
  };
  workflow_entry_list = (wf_id) => {
    const workflow_entry_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: wf_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/entry/list', workflow_entry_list)
      .then((res) => {
        if (res.data.result) {
          this.setState({
            workflow_entry_list_array: res.data?.result,
          });
        }
        if (res.data.status === 'no_record') {
          this.setState({
            workflow_entry_list_array: [],
          });
        }
      })
      .catch((error) => {
        console.log('error_check', error);
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            this.setState({
              workflow_entry_list_array: [],
            });
          }
        }
      });
  };
  onEdit_startpoint_sendmsg = (workflow) => {
    this.setState({
      workflow_msg: workflow.message,
      edit_startpnt_msg: true,
      edit_startpnt_msg_data: workflow,
      edit_startpnt_msg_data_steps: workflow.steps,
      chars_left_wfmsg: this.state.max_chars_wfmsg - workflow.message.length,
    });
    this.setState({
      atcharryDet_cmb: [],
      cmb_notesedit: false,
      notesValue2_cmb: '',
      max_chars_notes_cmb: 1200,
      chars_left_notes_cmb: 1200,
    });

    Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
    $('.auto_response_all_container').hide();
    $('.attchLstShow_cmb').hide();
    if (workflow.unique_id) {
      Rnunique_id_cmb = workflow.unique_id;
      this.setState({
        Rnunique_id_cmb: workflow.unique_id,
      });
      const attachmentinfo = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          unique_id: workflow.unique_id,
          // contact_id: conversation.conversation.contacts.toString()
        },
      };
      console.log(attachmentinfo);
      axios
        .get(API_CALL_ENDPOINT + '/attachment/edit/list', attachmentinfo)
        .then((res) => {
          console.log('EDIT', res.data);
          if (res.data.status === 'success') {
            $('.auto_response_all_container').show();
            this.setState({ messageAttachd: true });
            var arrayLength = res.data?.result?.attachment_list.length;

            var OrderIncr1 = this.state.attachOrderIncrs + parseInt(arrayLength);
            this.setState({ attachOrderIncrs: OrderIncr1 });

            for (var i = 0; i < arrayLength; i++) {
              if (res.data?.result?.attachment_list[i].attachment_type == 'notes') {
                $('.attchLstShow_cmb').show();

                $('#notestypearea').val('');
                this.setState({
                  atcharryDet_cmb: [
                    {
                      attach_id: res.data?.result?.attachment_list[i]._id,
                      notes_content: res.data?.result?.attachment_list[i].text,
                      notes_content1: 'Your Text goes here',
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'audio') {
                $('.attchLstShow_cmb').show();

                this.setState({
                  atcharryDet_cmb: [
                    {
                      _id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                      second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                      audio_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      audio_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'video') {
                $('.attchLstShow_cmb').show();
                console.log('video_url: ' + res.data?.result?.attachment_list[i].attachment[0].file_url);
                this.setState({
                  atcharryDet_cmb: [
                    {
                      video_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      video_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                      second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                      file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'documents') {
                var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                var flDc_detils = [];
                var k = 1;
                this.colapse_all_attachments();
                for (var j = 0; j < arrayLength1; j++) {
                  flDc_detils.push({
                    file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                    file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                    file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                    file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                  });
                  this.colapse_all_attachments();
                  if (k == arrayLength1) {
                    var fileary = {
                      documents: flDc_detils,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    };
                    this.setState({
                      atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                    });
                  }
                  k++;
                  this.colapse_all_attachments();
                }
                this.colapse_all_attachments();
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'images') {
                var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                var flDc_detils = [];
                var k = 1;
                this.colapse_all_attachments();
                for (var j = 0; j < arrayLength1; j++) {
                  flDc_detils.push({
                    file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                    file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                    file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                    file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                  });
                  this.colapse_all_attachments();
                  if (k == arrayLength1) {
                    var fileary = {
                      images: flDc_detils,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    };
                    this.setState({
                      atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                    });
                  }
                  k++;
                  this.colapse_all_attachments();
                }
                this.colapse_all_attachments();
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'google_calendar') {
                var fileary = {
                  calendar_name: res.data?.result?.attachment_list[i]?.calendar_name,
                  calendar_startdate: res.data?.result?.attachment_list[i]?.calendar_startdate,
                  calendar_enddate: res.data?.result?.attachment_list[i]?.calendar_enddate,
                  event_recurrence: res.data?.result?.attachment_list[i]?.event_recurrence,
                  time_zone: res.data?.result?.attachment_list[i]?.time_zone,
                  event_description: res.data?.result?.attachment_list[i]?.event_description,
                  attach_id: res.data?.result?.attachment_list[i]._id,
                };
                this.setState({
                  atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                });
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                this.colapse_all_attachments();
              }
              this.colapse_all_attachments();
            }
            this.colapse_all_attachments();
          }
          console.log(this.state.atcharryDet);
          this.colapse_all_attachments();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.setState({
        Rnunique_id_cmb: '',
      });
    }
  };
  onAdd_step_send_message = () => {
    console.log(this.state.Workflow_step_if_else_data);
    if (this.state.workflow_msg?.length === 0) {
      toast.dark('Please enter message to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
      toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      let workflow_data = {};
      if (this.state.atcharryDet_cmb.length != 0) {
        var attachmnt_Url = true;
        var unqID = Rnunique_id_cmb;
      } else {
        var attachmnt_Url = false;
        var unqID = '';
      }
      if (!this.state.edit_startpnt_msg) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          setup: 'add_workflow',
          type: 'send_message',
          message: this.state.workflow_msg,
          parent_steps_id: this.state.workflow_step_id_create,
          ifelse_condition: this.state.Workflow_step_if_else_data,
          unique_id: unqID,
          attachment_url: attachmnt_Url,
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          //  steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          steps: this.state.edit_startpnt_msg_data_steps
            ? this.state.edit_startpnt_msg_data_steps
            : this.state.workflow_steps_list_array?.length
              ? this.state.workflow_steps_list_array?.length + 1
              : 1,
          setup: 'add_workflow',
          type: 'send_message',
          message: this.state.workflow_msg,
          ifelse_condition: this.state.edit_startpnt_msg_data?.ifelse_condition,
          parent_steps_id: this.state.edit_startpnt_msg_data.parent_steps_id,
          add_workflow_id: this.state.edit_startpnt_msg_data._id,
          unique_id:
            this.state.atcharryDet_cmb.length !== 0
              ? this.state.Rnunique_id_cmb
                ? this.state.Rnunique_id_cmb
                : unqID
              : undefined,
          attachment_url: attachmnt_Url,
        };
      }

      console.log('workflow_datas', workflow_data);
      // return false;
      this.setState({ disable_send_msg: true });
      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            // $('.workflow_sendmsg_close').click();
            this.workflow_steps_list(this.state.workflow_edit_data._id);
            this.setState({
              workflow_msg: '',
              //  disable_send_msg: false,
              edit_startpnt_msg: false,
              chars_left_wfmsg: 300,
              max_chars_wfmsg: 300,
              Rnunique_id_cmb: '',
              atcharryDet_cmb: [],
              cmb_notesedit: false,
              notesValue2_cmb: '',
              max_chars_notes_cmb: 1200,
              chars_left_notes_cmb: 1200,
            });

            Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_contact: false });
          console.log(error);
        });
    }
  };
  onchange_send_wfmessage = (event) => {
    this.setState({
      workflow_msg: event.target.value,
      chars_left_wfmsg: this.state.max_chars_wfmsg - event.target.value.length,
    });

    // console.log(event.target.value);
  };

  workflow_sendmsg_close() {
    this.setState({
      workflow_msg: '',
      disable_send_msg: false,
      edit_startpnt_msg: false,
      chars_left_wfmsg: 300,
      max_chars_wfmsg: 300,
    });
  }
  onEdit_startpoint_delay = (workflow) => {
    $('#startstepdelay').val(workflow.delay_time);
    this.setState({
      workflow_delay_count: workflow.delay_count,
      edit_startpnt_delay: true,
      edit_startpnt_delay_steps: workflow.steps,
      edit_startpnt_delay_data: workflow,
      workflow_delay_time: workflow.delay_time,
      disable_start_delay: false,
    });
  };
  onAdd_step_delay = () => {
    console.log(this.state.Workflow_step_if_else_data);
    if (this.state.workflow_delay_count?.length === 0 || parseInt(this.state.workflow_delay_count) === 0) {
      toast.dark('Please enter valid count to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      let workflow_data = {};
      if (!this.state.edit_startpnt_delay) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          setup: 'add_workflow',
          type: 'delay',
          delay_time: this.state.workflow_delay_time,
          delay_count: this.state.workflow_delay_count,
          parent_steps_id: this.state.workflow_step_id_create,
          ifelse_condition: this.state.Workflow_step_if_else_data,
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          //steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          steps: this.state.edit_startpnt_delay_steps
            ? this.state.edit_startpnt_delay_steps
            : this.state.workflow_steps_list_array?.length
              ? this.state.workflow_steps_list_array?.length + 1
              : 1,
          setup: 'add_workflow',
          type: 'delay',
          delay_time: this.state.workflow_delay_time,
          delay_count: this.state.workflow_delay_count,
          ifelse_condition: this.state.edit_startpnt_delay_data?.ifelse_condition,
          parent_steps_id: this.state.edit_startpnt_delay_data.parent_steps_id,
          add_workflow_id: this.state.edit_startpnt_delay_data._id,
        };
      }
      console.log('workflow_datas', workflow_data);
      //return false;
      this.setState({ disable_start_delay: true });
      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            //  $('.workflow_stepdelay_close').click();
            $('#startstepdelay').val('');
            this.workflow_steps_list(this.state.workflow_edit_data._id);
            this.setState({
              workflow_delay_time: '',
              workflow_delay_count: '',
              // disable_start_delay: false,
              edit_startpnt_delay: false,
            });
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_start_delay: false });
          console.log(error);
        });
    }
  };
  workflow_stepdelay_close() {
    $('#startstepdelay').val('');
    this.setState({
      workflow_delay_count: '',
      edit_startpnt_delay: false,
      edit_startpnt_delay_data: {},
      workflow_delay_time: '',
      disable_start_delay: false,
    });
  }
  step_ifelse_inbound_close() {
    $('#stepinbound').val('');
    $('#inbvalue').val('');
    this.setState({
      inbound_content_ifelse: '',
      inbound_cond_ifelse: '',
      edit_step_inbound_data: {},
      edit_step_inbound: false,
    });
  }
  workflow_update_contact_close = (inbound_val) => {
    this.setState({
      edit_step_inbound: false,
    });
  };

  onEdit_step_ifelse = (inbound_val) => {
    $('#stepinbound').val(inbound_val.inbound_type);
    this.setState({
      inbound_content_ifelse: inbound_val.inbound_content,
      inbound_cond_ifelse: inbound_val.inbound_type,
      edit_step_inbound_data: inbound_val,
      edit_step_inbound_data_steps: inbound_val.steps,
      edit_step_inbound: true,
    });
  };
  onAdd_step_ifelse = () => {
    var condition = $('#stepinbound').val();
    var values = $('#inbvalue').val();
    if (condition === '' || condition.length === 0) {
      this.setState({ disable_step_inbound: false });
      toast.dark('Please select a condition to proceed3', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (values === '' && condition !== 'no_specification') {
      this.setState({ disable_step_inbound: false });
      toast.dark('value cannot be empty', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({ disable_step_inbound: true });

      let workflow_data = {};
      if (!this.state.edit_step_inbound) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          parent_steps_id: this.state.workflow_step_id_create,
          steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          ifelse_condition: this.state.Workflow_step_if_else_data,
          setup: 'add_workflow',
          inbound_content: condition === 'no_specification' ? '' : values.trim(),
          inbound_type: condition,
          type: 'if_else',
          ifelse_type: 'inbound',
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          parent_steps_id: this.state.edit_step_inbound_data.parent_steps_id,
          steps:
            this.state.edit_startpnt_elseif_steps != ''
              ? this.state.edit_startpnt_elseif_steps
              : this.state.workflow_steps_list_array?.length
                ? this.state.workflow_steps_list_array?.length + 1
                : 1,
          setup: 'add_workflow',
          ifelse_condition: this.state.edit_step_inbound_data.ifelse_condition,
          ifelse_yes: this.state.edit_step_inbound_data.ifelse_yes,
          ifelse_no: this.state.edit_step_inbound_data.ifelse_no,
          inbound_content: condition === 'no_specification' ? '' : values.trim(),
          inbound_type: condition,
          add_workflow_id: this.state.edit_step_inbound_data._id,
          type: 'if_else',
          ifelse_type: 'inbound',
        };
      }

      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            this.setState({ disable_step_inbound: false });

            var add_workflow_id_edit = res?.data?.result;
            if (!this.state.edit_step_inbound) {
              var ifelse_yes = {};
              var ifelse_no = {};

              let workflow_data_yes = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
                steps: 0,
                type: 'yes',
                setup: 'add_workflow',
                parent_steps_id: res.data.result._id,
              };
              let workflow_data_no = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
                steps: 0,
                type: 'no',
                setup: 'add_workflow',
                parent_steps_id: res.data.result._id,
              };
              axios
                .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_yes)
                .then((res) => {
                  if (res.data.status === 'success') {
                    ifelse_yes = res.data.result;
                    console.log(res.data.result);
                  }
                })
                .catch((error) => {
                  // errors.push(error.message);

                  console.log(error);
                });
              axios
                .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_no)
                .then((res) => {
                  if (res.data.status === 'success') {
                    ifelse_no = res.data.result;
                    console.log(res.data.result);
                    var workflow_data_up = {
                      apikey: API_KEY,
                      secret: API_SECRET,
                      user_id: this.state.user_id,
                      business_id: this.state.business_id,
                      workflow_id: this.state.workflow_edit_data._id,
                      parent_steps_id: add_workflow_id_edit.parent_steps_id,
                      setup: 'add_workflow',
                      ifelse_condition: add_workflow_id_edit.ifelse_condition,
                      ifelse_yes: JSON.stringify(ifelse_yes),
                      ifelse_no: JSON.stringify(ifelse_no),
                      add_workflow_id: add_workflow_id_edit._id,
                      inbound_content: add_workflow_id_edit.inbound_content,
                      inbound_type: add_workflow_id_edit.inbound_type,
                      type: 'if_else',
                      steps: add_workflow_id_edit.steps,
                      ifelse_type: 'inbound',
                    };
                    axios
                      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_up)
                      .then((res) => {
                        if (res.data.status === 'success') {
                          this.workflow_steps_list(this.state.workflow_edit_data._id);
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  // errors.push(error.message);

                  console.log(error);
                });
            }
            $('.step_ifelse_inbound_close').click();
            this.workflow_steps_list(this.state.workflow_edit_data._id);
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_step_inbound: false });
          console.log(error);
        });
    }
  };

  updateifElseCustomProperties = () => {
    var custom_properties_select = $('#custom_properties_select').val();
    var condition_dropdown = $('#condition_dropdown').val();
    var condition_value = $('#condition_value').val();
    console.log('custom_properties_select', custom_properties_select);
    console.log('condition_dropdown', condition_dropdown);
    console.log('condition_value', condition_value);
    if (custom_properties_select === '') {
      this.setState({ disable_step_inbound: false });
      toast.dark('Please select a custom property to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (condition_dropdown === '') {
      this.setState({ disable_step_inbound: false });
      toast.dark('Please select a condition to proceed', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (!condition_value && condition_dropdown !== 'no_specification') {
      this.setState({ disable_step_inbound: false });
      toast.dark('value cannot be empty', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({ disable_step_inbound: true });

      let workflow_data = {};
      if (!this.state.edit_step_inbound) {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          parent_steps_id: this.state.workflow_step_id_create,
          steps: this.state.workflow_steps_list_array?.length ? this.state.workflow_steps_list_array?.length + 1 : 1,
          ifelse_condition: this.state.Workflow_step_if_else_data,
          setup: 'add_workflow',
          inbound_content: condition_dropdown === 'no_specification' ? '' : condition_value.trim(),
          inbound_type: condition_dropdown,
          field_name: custom_properties_select,
          type: 'if_else',
          ifelse_type: 'contacts',
        };
      } else {
        workflow_data = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          workflow_id: this.state.workflow_edit_data._id,
          parent_steps_id: this.state.edit_step_inbound_data.parent_steps_id,
          steps:
            this.state.edit_startpnt_elseif_steps != '' || this.state.edit_startpnt_elseif_steps != 0
              ? this.state.edit_startpnt_elseif_steps
              : this.state.workflow_steps_list_array?.length
                ? this.state.workflow_steps_list_array?.length + 1
                : 1,
          setup: 'add_workflow',
          ifelse_condition: this.state.edit_step_inbound_data.ifelse_condition,
          ifelse_yes: this.state.edit_step_inbound_data.ifelse_yes,
          ifelse_no: this.state.edit_step_inbound_data.ifelse_no,
          inbound_content: condition_dropdown === 'no_specification' ? '' : condition_value.trim(),
          inbound_type: condition_dropdown,
          field_name: custom_properties_select,
          add_workflow_id: this.state.edit_step_inbound_data._id,
          type: 'if_else',
          ifelse_type: 'contacts',
        };
      }
      console.log('workflow_data', workflow_data);
      axios
        .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
        .then((res) => {
          if (res.data.status === 'success') {
            //  this.setState({disable_step_inbound: false});

            var add_workflow_id_edit = res?.data?.result;
            if (!this.state.edit_step_inbound) {
              var ifelse_yes = {};
              var ifelse_no = {};

              let workflow_data_yes = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
                steps: 0,
                type: 'yes',
                setup: 'add_workflow',
                parent_steps_id: res.data.result._id,
              };
              let workflow_data_no = {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
                workflow_id: this.state.workflow_edit_data._id,
                steps: 0,
                type: 'no',
                setup: 'add_workflow',
                parent_steps_id: res.data.result._id,
              };
              axios
                .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_yes)
                .then((res) => {
                  if (res.data.status === 'success') {
                    ifelse_yes = res.data.result;
                    console.log(res.data.result);
                    axios
                      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_no)
                      .then((res) => {
                        if (res.data.status === 'success') {
                          ifelse_no = res.data.result;
                          console.log(res.data.result);
                          var workflow_data_up = {
                            apikey: API_KEY,
                            secret: API_SECRET,
                            user_id: this.state.user_id,
                            business_id: this.state.business_id,
                            workflow_id: this.state.workflow_edit_data._id,
                            parent_steps_id: add_workflow_id_edit.parent_steps_id,
                            setup: 'add_workflow',
                            ifelse_condition: add_workflow_id_edit.ifelse_condition,
                            ifelse_yes: JSON.stringify(ifelse_yes),
                            ifelse_no: JSON.stringify(ifelse_no),
                            add_workflow_id: add_workflow_id_edit._id,
                            inbound_content: add_workflow_id_edit.inbound_content,
                            inbound_type: add_workflow_id_edit.inbound_type,
                            type: 'if_else',
                            steps: add_workflow_id_edit.steps,
                            ifelse_type: 'contacts',
                            field_name: custom_properties_select,
                          };
                          axios
                            .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data_up)
                            .then((res) => {
                              if (res.data.status === 'success') {
                                this.workflow_steps_list(this.state.workflow_edit_data._id);
                              }
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        }
                      })
                      .catch((error) => {
                        // errors.push(error.message);

                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  // errors.push(error.message);

                  console.log(error);
                });
            }

            $('.step_ifelse_inbound_close').click();
            this.workflow_steps_list(this.state.workflow_edit_data._id);
          }
        })
        .catch((error) => {
          // errors.push(error.message);
          this.setState({ disable_step_inbound: false });
          console.log(error);
        });
    }
  };
  delete_start_point(data) {
    const workflow_data = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      workflow_id: this.state.workflow_edit_data._id,
      setup: 'delete_workflow_step',
      steps: data.steps,
      parent_steps_id: data.parent_steps_id,
      add_workflow_id: data._id,
    };
    axios
      .post(API_CALL_ENDPOINT + '/business/workflow/update', workflow_data)
      .then((res) => {
        if (res.data.status === 'success') {
          this.workflow_steps_list(this.state.workflow_edit_data._id);
          // $(".entry_point_close").click();
        }
      })
      .catch((error) => {
        // errors.push(error.message);

        console.log(error);
      });
    // }
    // });
  }
  wfhistory_logclk = (workflow) => {
    this.setState({ workflow_history_data: workflow });
    this.workflow_steps_list_history(workflow._id);
    this.workflow_entry_list(workflow._id);
    $('.workflowlist_div').hide();
    $('.workflow_cardbodyhistorystat_div').show();
  };
  wfcrdbdyhistoryback = () => {
    $('.workflow_cardbodyhistorystat_div').hide();
    $('.workflowlist_div').show();
  };
  workflow_steps_list_history(wf_id) {
    const steps_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        workflow_id: wf_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/steps/list', steps_list)
      .then((res) => {
        if (res.data.status === 'success') {
          ReactDOM.unmountComponentAtNode(document.getElementById('first_level_his'));
          this.setState({ workflow_steps_list_array: res?.data?.result });
          var append_id = 'first_level_his';
          var first_level_count = 0;
          var feed_yes = {};
          var feed_no = {};
          var ifelse_no_data_id = [];
          var ifelse_yes_data_id = [];

          for (var i = 0; i < res?.data?.result.length; i++) {
            // const onClick_del = this.delete_start_point.bind(this, res?.data?.result[i]);
            // const onEdit_startpoint_sendmsg = this.onEdit_startpoint_sendmsg.bind(this, res?.data?.result[i]);
            // const onEdit_startpoint_delay = this.onEdit_startpoint_delay.bind(this, res?.data?.result[i]);
            // const onEdit_step_ifelse = this.onEdit_step_ifelse.bind(this, res?.data?.result[i]);
            // const set_workflow_step_id_create = this.set_workflow_step_id_create.bind(this, res?.data?.result[i]);
            // const set_workflow_step_id_create_ifelse_no = this.set_workflow_step_id_create_ifelse_no.bind(
            //   this,
            //   res?.data?.result[i],
            // );
            // const set_workflow_step_id_create_ifelse_yes = this.set_workflow_step_id_create_ifelse_yes.bind(
            //   this,
            //   res?.data?.result[i],
            // );

            const workflow_steps_contact_list = this.workflow_steps_contact_list.bind(this, res?.data?.result[i]);

            if (res?.data?.result[i].parent_steps_id === wf_id) {
              first_level_count += 1;
              if (res?.data?.result[i].type === 'send_message') {
                ReactDOM.render(
                  <>
                    <a>
                      <div className="wfbox bgblue position-relative mt-2">
                        <span className="wf_icondiv wf_icondivpos">
                          <i className="far fa-comment-alt" />
                        </span>
                        <span className="font-weight-bold">Send Message</span>
                        <br />
                        <span>
                          Message Content -{' '}
                          <span className="font-weight-bold fmaroon">{res?.data?.result[i].message}</span>
                        </span>
                        <br />
                        <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                        <div className="wf_actnbtnsdiv">
                          <span
                            onClick={workflow_steps_contact_list}
                            className="wf_actionicondiv bg_orange"
                            data-toggle="modal"
                            data-target="#modal_historycontacts_steps"
                            data-backdrop="static">
                            <i className="fas fa-users" />
                          </span>
                        </div>
                      </div>
                    </a>
                    <ul>
                      <li id={'append_id_his_' + res?.data?.result[i]._id}></li>
                    </ul>
                  </>,
                  document.getElementById(append_id),
                );

                append_id = 'append_id_his_' + res?.data?.result[i]._id;
              } else if (res?.data?.result[i].type === 'delay') {
                ReactDOM.render(
                  <>
                    <a>
                      <div className="wfbox bgyellow position-relative mt-2">
                        <span className="wf_icondiv wf_icondivpos">
                          <i className="fas fa-spinner" />
                        </span>
                        <span className="font-weight-bold">Wait</span>
                        <br />
                        <span>
                          For{' '}
                          <span className="font-weight-bold fmaroon">
                            {res?.data?.result[i].delay_count}{' '}
                            {res?.data?.result[i].delay_time === 'minutes'
                              ? 'Minute(s)'
                              : res?.data?.result[i].delay_time === 'hours'
                                ? 'Hour(s)'
                                : res?.data?.result[i].delay_time === 'days'
                                  ? 'Day(s)'
                                  : res?.data?.result[i].delay_time === 'weeks'
                                    ? 'Week(s)'
                                    : 'Month(s)'}
                          </span>
                        </span>
                        <br />
                        <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                      </div>
                    </a>
                    <ul>
                      <li id={'append_id_his_' + res?.data?.result[i]._id}></li>
                    </ul>
                  </>,
                  document.getElementById(append_id),
                );

                append_id = 'append_id_his_' + res?.data?.result[i]._id;
              } else if (res?.data?.result[i].type === 'if_else') {
                // consol.log('Ifelse4');
                ReactDOM.render(
                  <>
                    <a>
                      <div className="wfbox bgblue position-relative mt-2">
                        <span className="wf_icondiv wf_icondivpos">
                          <i className="far fa-comment-alt" />
                        </span>
                        <span className="font-weight-bold">If / Else</span>
                        <br />
                        <span>
                          Filter -{' '}
                          {res?.data?.result[i].inbound_type === 'equal_to'
                            ? 'Equal to'
                            : res?.data?.result[i].inbound_type === 'start_with'
                              ? 'Starts with'
                              : res?.data?.result[i].inbound_type === 'contains'
                                ? 'Contains'
                                : res?.data?.result[i].inbound_type === 'no_specification'
                                  ? 'No Specification'
                                  : ''}{' '}
                          <span className="font-weight-bold fmaroon">{res?.data?.result[i].inbound_content}</span>
                        </span>
                        <br />
                        <span className="wf_startpt_pos flightgrey3">#{first_level_count}</span>
                      </div>
                    </a>
                    <ul>
                      <li>
                        <a>
                          <div className="wfbox_sm bgyes position-relative">
                            <span className="font-weight-semibold">YES</span>
                          </div>
                        </a>

                        <ul>
                          <li id={'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}></li>
                        </ul>
                      </li>
                      <li>
                        <a>
                          <div className="wfbox_sm bgno position-relative">
                            <span className="font-weight-semibold">NO</span>
                          </div>
                        </a>

                        <ul>
                          <li id={'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}></li>
                        </ul>
                      </li>
                    </ul>
                  </>,
                  document.getElementById(append_id),
                );

                // append_id = 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id;

                feed_yes = {
                  parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                  ifelse_yes_data_id_count: 1,
                  append_id_yes: 'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                };
                feed_no = {
                  parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_no)._id,
                  ifelse_no_data_id_count: 1,
                  append_id_no: 'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                };

                ifelse_yes_data_id.push(feed_yes);
                ifelse_no_data_id.push(feed_no);
              }
            }
            //first
            else {
              if (JSON.parse(res?.data?.result[i].ifelse_condition).type === 'yes') {
                for (var j = 0; j < ifelse_yes_data_id.length; j++) {
                  console.log('out', ifelse_yes_data_id[j]);
                  if (res?.data?.result[i].parent_steps_id === ifelse_yes_data_id[j].parent_steps_id) {
                    console.log('in', ifelse_yes_data_id[j]);
                    if (res?.data?.result[i].type === 'send_message') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">Send Message</span>
                              <br />
                              <span>
                                Message Content -{' '}
                                <span className="font-weight-bold fmaroon">{res?.data?.result[i].message}</span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_yes_data_id[j].ifelse_yes_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  onClick={workflow_steps_contact_list}
                                  className="wf_actionicondiv bg_orange"
                                  data-toggle="modal"
                                  data-target="#modal_historycontacts_steps"
                                  data-backdrop="static">
                                  <i className="fas fa-users" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li id={'append_id_his_' + res?.data?.result[i]._id}></li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_yes_data_id[j].append_id_yes),
                      );
                      ifelse_yes_data_id[j].ifelse_yes_data_id_count += 1;
                      ifelse_yes_data_id[j].append_id_yes = 'append_id_his_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'delay') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgyellow position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="fas fa-spinner" />
                              </span>
                              <span className="font-weight-bold">Wait</span>
                              <br />
                              <span>
                                For{' '}
                                <span className="font-weight-bold fmaroon">
                                  {res?.data?.result[i].delay_count}{' '}
                                  {res?.data?.result[i].delay_time === 'minutes'
                                    ? 'Minute(s)'
                                    : res?.data?.result[i].delay_time === 'hours'
                                      ? 'Hour(s)'
                                      : res?.data?.result[i].delay_time === 'days'
                                        ? 'Day(s)'
                                        : res?.data?.result[i].delay_time === 'weeks'
                                          ? 'Week(s)'
                                          : 'Month(s)'}
                                </span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_yes_data_id[j].ifelse_yes_data_id_count}
                              </span>
                            </div>
                          </a>
                          <ul>
                            <li id={'append_id_his_' + res?.data?.result[i]._id}></li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_yes_data_id[j].append_id_yes),
                      );

                      ifelse_yes_data_id[j].ifelse_yes_data_id_count += 1;
                      ifelse_yes_data_id[j].append_id_yes = 'append_id_his_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'if_else') {
                      // consol.log('Ifelse5');
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">If / Else</span>
                              <br />
                              <span>
                                Filter -{' '}
                                {res?.data?.result[i].inbound_type === 'equal_to'
                                  ? 'Equal to'
                                  : res?.data?.result[i].inbound_type === 'start_with'
                                    ? 'Starts with'
                                    : res?.data?.result[i].inbound_type === 'contains'
                                      ? 'Contains'
                                      : res?.data?.result[i].inbound_type === 'no_specification'
                                        ? 'No Specification'
                                        : ''}{' '}
                                <span className="font-weight-bold fmaroon">{res?.data?.result[i].inbound_content}</span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_yes_data_id[j].ifelse_yes_data_id_count}
                              </span>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a>
                                <div className="wfbox_sm bgyes position-relative">
                                  <span className="font-weight-semibold">YES</span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}></li>
                              </ul>
                            </li>
                            <li>
                              <a>
                                <div className="wfbox_sm bgno position-relative">
                                  <span className="font-weight-semibold">NO</span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_yes_data_id[j].append_id_yes),
                      );
                      feed_yes = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                        ifelse_yes_data_id_count: 1,
                        append_id_yes: 'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                      };
                      feed_no = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_no)._id,
                        ifelse_no_data_id_count: 1,
                        append_id_no: 'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                      };

                      ifelse_yes_data_id.push(feed_yes);
                      ifelse_no_data_id.push(feed_no);
                      // append_id = 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                      //  ifelse_no_data_id_1_yes = JSON.parse(res?.data?.result[i].ifelse_no)._id;
                      //  ifelse_yes_data_id_1_yes =JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                    }
                  }
                }
              } else {
                for (var k = 0; k < ifelse_no_data_id.length; k++) {
                  console.log('out no', ifelse_no_data_id[k]);
                  if (res?.data?.result[i].parent_steps_id === ifelse_no_data_id[k].parent_steps_id) {
                    console.log('in no', ifelse_no_data_id[k]);
                    if (res?.data?.result[i].type === 'send_message') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">Send Message</span>
                              <br />
                              <span>
                                Message Content -{' '}
                                <span className="font-weight-bold fmaroon">{res?.data?.result[i].message}</span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_no_data_id[k].ifelse_no_data_id_count}
                              </span>
                              <div className="wf_actnbtnsdiv">
                                <span
                                  onClick={workflow_steps_contact_list}
                                  className="wf_actionicondiv bg_orange"
                                  data-toggle="modal"
                                  data-target="#modal_historycontacts_steps"
                                  data-backdrop="static">
                                  <i className="fas fa-users" />
                                </span>
                              </div>
                            </div>
                          </a>
                          <ul>
                            <li id={'append_id_his_' + res?.data?.result[i]._id}></li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_no_data_id[k].append_id_no),
                      );

                      ifelse_no_data_id[k].ifelse_no_data_id_count += 1;
                      ifelse_no_data_id[k].append_id_no = 'append_id_his_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'delay') {
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgyellow position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="fas fa-spinner" />
                              </span>
                              <span className="font-weight-bold">Wait</span>
                              <br />
                              <span>
                                For{' '}
                                <span className="font-weight-bold fmaroon">
                                  {res?.data?.result[i].delay_count}{' '}
                                  {res?.data?.result[i].delay_time === 'minutes'
                                    ? 'Minute(s)'
                                    : res?.data?.result[i].delay_time === 'hours'
                                      ? 'Hour(s)'
                                      : res?.data?.result[i].delay_time === 'days'
                                        ? 'Day(s)'
                                        : res?.data?.result[i].delay_time === 'weeks'
                                          ? 'Week(s)'
                                          : 'Month(s)'}
                                </span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_no_data_id[k].ifelse_no_data_id_count}
                              </span>
                            </div>
                          </a>
                          <ul>
                            <li id={'append_id_his_' + res?.data?.result[i]._id}></li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_no_data_id[k].append_id_no),
                      );

                      ifelse_no_data_id[k].ifelse_no_data_id_count += 1;
                      ifelse_no_data_id[k].append_id_no = 'append_id_his_' + res?.data?.result[i]._id;
                    } else if (res?.data?.result[i].type === 'if_else') {
                      // consol.log('Ifelse6');
                      ReactDOM.render(
                        <>
                          <a>
                            <div className="wfbox bgblue position-relative mt-2">
                              <span className="wf_icondiv wf_icondivpos">
                                <i className="far fa-comment-alt" />
                              </span>
                              <span className="font-weight-bold">If / Else</span>
                              <br />
                              <span>
                                Filter -{' '}
                                {res?.data?.result[i].inbound_type === 'equal_to'
                                  ? 'Equal to'
                                  : res?.data?.result[i].inbound_type === 'start_with'
                                    ? 'Starts with'
                                    : res?.data?.result[i].inbound_type === 'contains'
                                      ? 'Contains'
                                      : res?.data?.result[i].inbound_type === 'no_specification'
                                        ? 'No Specification'
                                        : ''}{' '}
                                <span className="font-weight-bold fmaroon">{res?.data?.result[i].inbound_content}</span>
                              </span>
                              <br />
                              <span className="wf_startpt_pos flightgrey3">
                                #{ifelse_no_data_id[k].ifelse_no_data_id_count}
                              </span>
                            </div>
                          </a>
                          <ul>
                            <li>
                              <a>
                                <div className="wfbox_sm bgyes position-relative">
                                  <span className="font-weight-semibold">YES</span>
                                  <div className="wf_actnbtnsdiv">
                                    <span
                                      onClick={workflow_steps_contact_list}
                                      className="wf_actionicondiv bg_orange"
                                      data-toggle="modal"
                                      data-target="#modal_historyifelse_yes_steps"
                                      data-backdrop="static">
                                      <i className="fas fa-users" />
                                    </span>
                                  </div>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id}></li>
                              </ul>
                            </li>
                            <li>
                              <a>
                                <div className="wfbox_sm bgno position-relative">
                                  <span className="font-weight-semibold">NO</span>
                                </div>
                              </a>
                              <ul>
                                <li id={'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_no)._id}></li>
                              </ul>
                            </li>
                          </ul>
                        </>,
                        document.getElementById(ifelse_no_data_id[k].append_id_no),
                      );
                      feed_yes = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                        ifelse_yes_data_id_count: 1,
                        append_id_yes: 'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id,
                      };
                      feed_no = {
                        parent_steps_id: JSON.parse(res?.data?.result[i].ifelse_no)._id,
                        ifelse_no_data_id_count: 1,
                        append_id_no: 'append_id_his_' + JSON.parse(res?.data?.result[i].ifelse_no)._id,
                      };

                      ifelse_yes_data_id.push(feed_yes);
                      ifelse_no_data_id.push(feed_no);

                      // append_id = 'append_id_' + JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                      //  ifelse_no_data_id_1_yes = JSON.parse(res?.data?.result[i].ifelse_no)._id;
                      //  ifelse_yes_data_id_1_yes =JSON.parse(res?.data?.result[i].ifelse_yes)._id;
                    }
                  }
                }
              }
            }
          }
          // console.log(document.getElementById('first_level').outerHTML)
          //           this.first_level_wf.push(document.getElementById('first_level').outerHTML);

          // $("#first_level").append('<li> <a> <div class="wfbox bgblue position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="far fa-comment-alt"></i></span> <span class="font-weight-bold">Send Message</span><br/> <span>Message Content - <span class="font-weight-bold fmaroon">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Type "1".</span></span><br/> <span class="wf_startpt_pos flightgrey3">#1</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete" onClick={()=>alert("clicked")}><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfsendsms" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgblue position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="far fa-comment-alt"></i></span> <span class="font-weight-bold">If / Else</span><br/> <span>Filter - <span class="font-weight-bold fmaroon">inbound message with "1"</span></span><br/> <span class="wf_startpt_pos flightgrey3">#2</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfifelse_inboundmsg" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a><div class="wfbox_sm bgyes font-weight-semibold">YES</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgyellow position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="fas fa-spinner"></i></span> <span class="font-weight-bold">Wait</span><br/> <span>For <span class="font-weight-bold fmaroon">1 day(s)</span></span><br/> <span class="wf_startpt_pos flightgrey3">#3</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfdelay" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgblue position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="far fa-comment-alt"></i></span> <span class="font-weight-bold">Send Message</span><br/> <span>Message Content - <span class="font-weight-bold fmaroon">Lorem Ipsum is simply dummy text of the print</span></span><br/> <span class="wf_startpt_pos flightgrey3">#4</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfsendsms" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> <ul> <li> <a> <div class="wfbox bgyellow position-relative"> <span class="wf_icondiv wf_icondivpos"><i class="fas fa-spinner"></i></span> <span class="font-weight-bold">Wait</span><br/> <span>For <span class="font-weight-bold fmaroon">3 day(s)</span></span><br/> <span>Until - <span class="font-weight-bold fmaroon">inbound message with "1"</span></span><br/> <span class="wf_startpt_pos flightgrey3">#5</span> <div class="wf_actnbtnsdiv"> <span class="wf_actionicondiv bg_delete"><i class="fas fa-trash-alt"></i></span> <span class="wf_actionicondiv" data-toggle="modal" data-target="#modal_wfwaituntil_inboundmsg" data-backdrop="static"><i class="fas fa-pen"></i></span> </div> </div> </a> <ul> <li> <a><div class="wfbox_sm bgyes font-weight-semibold">YES</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> </li> </ul> </li> <li> <a><div class="wfbox_sm bgno font-weight-semibold">NO</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li> <li> <a><div class="wfbox_sm bgno font-weight-semibold">NO</div></a> <ul> <li> <a data-toggle="modal" data-target="#modal_wfstep" data-backdrop="static" class="crsr_pntr pb-2"><div class="wfbox p-0 brdr_none"><span class="wf_icondiv"><i class="fas fa-plus"></i></span></div></a> </li> </ul> </li> </ul> </li> </ul> </li> </ul> </li>')
        } else if (res.data.status === 'no_record') {
          ReactDOM.unmountComponentAtNode(document.getElementById('first_level_his'));
          this.setState({
            workflow_steps_list_array: [],
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            ReactDOM.unmountComponentAtNode(document.getElementById('first_level_his'));
            this.setState({
              workflow_steps_list_array: [],
            });
          }
        }
      });
  }
  workflow_steps_contact_list = (workflow) => {
    const workflow_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        contacts_type: 'steps',
        add_workflow_id: workflow._id,
        workflow_id: workflow.workflow_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/contacts/list', workflow_list)
      .then((res) => {
        // if (res1.data.result) {
        if (res.data.status === 'success') {
          if (!firsttime_stepsdatatbl) {
            stepsdatatbl.destroy();
          }
          this.setState({
            workflow_steps_contact_array: res.data?.result,
            workflow_steps_contact_array_data: workflow,
          });

          stepsdatatbl = $('#wfhistorysendmsgcts_tbl').DataTable({
            paging: true,
            lengthChange: true,
            ordering: false,
            searching: true,
          });
          firsttime_stepsdatatbl = false;
        } else if (res.data.status === 'no_record') {
          if (!firsttime_stepsdatatbl) {
            stepsdatatbl.destroy();
          }
          this.setState({
            workflow_steps_contact_array: [],
            workflow_steps_contact_array_data: workflow,
          });
          stepsdatatbl = $('#wfhistorysendmsgcts_tbl').DataTable({
            paging: true,
            lengthChange: true,
            ordering: false,
            searching: true,
          });
          firsttime_stepsdatatbl = false;
        }
        // }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            if (!firsttime_stepsdatatbl) {
              stepsdatatbl.destroy();
            }
            this.setState({
              workflow_steps_contact_array: [],
              workflow_steps_contact_array_data: workflow,
            });
            stepsdatatbl = $('#wfhistorysendmsgcts_tbl').DataTable({
              paging: true,
              lengthChange: true,
              ordering: false,
              searching: true,
            });
            firsttime_stepsdatatbl = false;
          }
        }
      });
  };
  workflow_entrypoint_contact_list = (workflow) => {
    const workflow_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        contacts_type: 'entry_point',
        entry_point_id: workflow._id,
        workflow_id: workflow.workflow_id,
      },
    };
    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/contacts/list', workflow_list)
      .then((res) => {
        // if (res1.data.result) {
        if (res.data.status === 'success') {
          if (!firsttime_entrypntdatatbl) {
            entrypntdatatbl.destroy();
          }

          this.setState({
            workflow_entry_contact_array: res.data?.result,
            workflow_entry_contact_data: workflow,
          });

          entrypntdatatbl = $('#wfhistorycts_tbl').DataTable({
            paging: true,
            lengthChange: true,
            ordering: false,
            searching: true,
          });
          firsttime_entrypntdatatbl = false;
        } else if (res.data.status === 'no_record') {
          if (!firsttime_entrypntdatatbl) {
            entrypntdatatbl.destroy();
          }
          this.setState({
            workflow_entry_contact_array: [],
            workflow_entry_contact_data: [],
          });
          entrypntdatatbl = $('#wfhistorycts_tbl').DataTable({
            paging: true,
            lengthChange: true,
            ordering: false,
            searching: true,
          });
          firsttime_entrypntdatatbl = false;
        }
        // }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            if (!firsttime_entrypntdatatbl) {
              entrypntdatatbl.destroy();
            }
            this.setState({
              workflow_entry_contact_array: [],
              workflow_entry_contact_data: [],
            });
            entrypntdatatbl = $('#wfhistorycts_tbl').DataTable({
              paging: true,
              lengthChange: true,
              ordering: false,
              searching: true,
            });
            firsttime_entrypntdatatbl = false;
          }
        }
      });
  };
  workflow_contacts_list = (workflow, wfcontacts_type) => {
    const contacts_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        contacts_type: wfcontacts_type,
        workflow_id: workflow._id,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/business/workflow/contacts/list', contacts_list)
      .then((res) => {
        if (res.data.status === 'success') {
          if (!firsttime_wfcontactsdatatbl) {
            wfcontactsdatatbl.destroy();
          }
          this.setState({
            workflow_contacts_list_arr: res?.data?.result,
            workflow_contacts_list_data: workflow,
            workflow_contacts_list_type: wfcontacts_type,
          });
          wfcontactsdatatbl = $('#wfactivects_tbl').DataTable({
            paging: true,
            lengthChange: true,
            ordering: false,
            searching: true,
            //"responsive": true,
          });
          firsttime_wfcontactsdatatbl = false;
        } else if (res.data.status === 'no_record') {
          if (!firsttime_wfcontactsdatatbl) {
            wfcontactsdatatbl.destroy();
          }
          this.setState({
            workflow_contacts_list_arr: [],
            workflow_contacts_list_data: workflow,
            workflow_contacts_list_type: wfcontacts_type,
          });
          wfcontactsdatatbl = $('#wfactivects_tbl').DataTable({
            paging: false,
            lengthChange: false,
            ordering: false,
            searching: false,
            info: false,
            //"responsive": true,
          });
          firsttime_wfcontactsdatatbl = false;
        } else {
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            if (!firsttime_wfcontactsdatatbl) {
              wfcontactsdatatbl.destroy();
            }
            this.setState({
              workflow_contacts_list_arr: [],
              workflow_contacts_list_data: workflow,
              workflow_contacts_list_type: wfcontacts_type,
            });
            wfcontactsdatatbl = $('#wfactivects_tbl').DataTable({
              paging: false,
              lengthChange: false,
              ordering: false,
              searching: false,
              info: false,
              //"responsive": true,
            });
            firsttime_wfcontactsdatatbl = false;
          }
        }
      });
  };
  workflow_contacts_list_close = () => {
    this.setState({
      workflow_contacts_list_data: [],
      workflow_contacts_list_type: '',
    });
  };
  //Templates
  templates_listclick = () => {
    const template_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/text/template/list', template_list)
      .then((res) => {
        if (res.data.status === 'success') {
          if (!firsttime_templatedatatbl) {
            templatedatatbl.destroy();
          }
          this.setState({ template_list_data: res?.data?.result });
          templatedatatbl = $('#templates_tbl').DataTable({
            paging: true,
            lengthChange: false,
            ordering: false,
            searching: true,
            //"responsive": true,
          });
          firsttime_templatedatatbl = false;
          $('.templatelist_div').show();
          $('.addtemplate_div').hide();
          $('.templatecreate_div').hide();
        } else if (res.data.status === 'no_record') {
          if (!firsttime_templatedatatbl) {
            templatedatatbl.destroy();
          }
          this.setState({ template_list_data: [] });
          templatedatatbl = $('#templates_tbl').DataTable({
            paging: true,
            lengthChange: false,
            ordering: false,
            searching: true,
            //"responsive": true,
          });
          firsttime_templatedatatbl = false;
          $('.templatelist_div').hide();
          $('.addtemplate_div').hide();
          $('.templatecreate_div').show();
        } else {
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.status === 'no_record') {
            if (!firsttime_templatedatatbl) {
              templatedatatbl.destroy();
            }
            this.setState({ template_list_data: [] });
            templatedatatbl = $('#templates_tbl').DataTable({
              paging: true,
              lengthChange: false,
              ordering: false,
              searching: true,
              //"responsive": true,
            });
            firsttime_templatedatatbl = false;
            $('.templatelist_div').hide();
            $('.addtemplate_div').hide();
            $('.templatecreate_div').show();
          }
        }
      });
  };
  templatecreate_clk = () => {
    $('.templatecreate_div').hide();
    $('.addtemplate_div').show();
    $('.templatelist_div').hide();
    this.setState({
      atcharryDet_cmb: [],
      templ_name: '',
      templ_msg: '',
      chars_left_templ_msg: 300,
      cmb_notesedit: false,
      notesValue2_cmb: '',
      max_chars_notes_cmb: 1200,
      chars_left_notes_cmb: 1200,
    });
    Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
  };
  on_temp_MessageEdit = (conversation) => {
    this.setState({
      atcharryDet_cmb: [],
      templ_name: '',
      templ_msg: '',
      chars_left_templ_msg: 300,
      cmb_notesedit: false,
      notesValue2_cmb: '',
      max_chars_notes_cmb: 1200,
      chars_left_notes_cmb: 1200,
    });
    console.log(conversation);
    this.setState({
      templ_msg: conversation.text_message,
      templ_name: conversation.template_name,
      templ_message_edit: true,
      templ_msg_update_details: conversation,
      Rnunique_id_cmb: conversation.unique_id,
      chars_left_templ_msg: this.state.max_chars_templ_msg - conversation.text_message?.length,
    });

    $('.templatecreate_div').hide();
    $('.addtemplate_div').show();
    $('.templatelist_div').hide();
    $('.attchLstShow_cmb').hide();
    if (conversation.unique_id) {
      Rnunique_id_cmb = conversation.unique_id;
      const attachmentinfo = {
        params: {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          unique_id: conversation.unique_id,
          // contact_id: conversation.conversation.contacts.toString()
        },
      };
      console.log(attachmentinfo);
      axios
        .get(API_CALL_ENDPOINT + '/attachment/edit/list', attachmentinfo)
        .then((res) => {
          console.log('EDIT', res.data);
          if (res.data.status === 'success') {
            this.setState({ messageAttachd: true });
            var arrayLength = res.data?.result?.attachment_list.length;

            var OrderIncr1 = this.state.attachOrderIncrs + parseInt(arrayLength);
            this.setState({ attachOrderIncrs: OrderIncr1 });

            for (var i = 0; i < arrayLength; i++) {
              if (res.data?.result?.attachment_list[i].attachment_type == 'notes') {
                $('.attchLstShow_cmb').show();
                $('#notestypearea').val('');
                this.setState({
                  atcharryDet_cmb: [
                    {
                      attach_id: res.data?.result?.attachment_list[i]._id,
                      notes_content: res.data?.result?.attachment_list[i].text,
                      notes_content1: 'Your Text goes here',
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'audio') {
                $('.attchLstShow_cmb').show();
                this.setState({
                  atcharryDet_cmb: [
                    {
                      _id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                      second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                      audio_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      audio_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'video') {
                $('.attchLstShow_cmb').show();
                console.log('video_url: ' + res.data?.result?.attachment_list[i].attachment[0].file_url);
                this.setState({
                  atcharryDet_cmb: [
                    {
                      video_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                      video_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                      second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                      file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                    },
                    ...this.state.atcharryDet_cmb,
                  ],
                });
                this.colapse_all_attachments();
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'documents') {
                var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                var flDc_detils = [];
                var k = 1;
                this.colapse_all_attachments();
                for (var j = 0; j < arrayLength1; j++) {
                  flDc_detils.push({
                    file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                    file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                    file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                    file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                  });
                  this.colapse_all_attachments();
                  if (k == arrayLength1) {
                    var fileary = {
                      documents: flDc_detils,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    };
                    this.setState({
                      atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                    });
                  }
                  k++;
                  this.colapse_all_attachments();
                }
                this.colapse_all_attachments();
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'images') {
                var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                var flDc_detils = [];
                var k = 1;
                this.colapse_all_attachments();
                for (var j = 0; j < arrayLength1; j++) {
                  flDc_detils.push({
                    file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                    file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                    file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                    file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                  });
                  this.colapse_all_attachments();
                  if (k == arrayLength1) {
                    var fileary = {
                      images: flDc_detils,
                      attach_id: res.data?.result?.attachment_list[i]._id,
                    };
                    this.setState({
                      atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                    });
                  }
                  k++;
                  this.colapse_all_attachments();
                }
                this.colapse_all_attachments();
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
              }
              if (res.data?.result?.attachment_list[i].attachment_type == 'google_calendar') {
                var fileary = {
                  calendar_name: res.data?.result?.attachment_list[i]?.calendar_name,
                  calendar_startdate: res.data?.result?.attachment_list[i]?.calendar_startdate,
                  calendar_enddate: res.data?.result?.attachment_list[i]?.calendar_enddate,
                  event_recurrence: res.data?.result?.attachment_list[i]?.event_recurrence,
                  time_zone: res.data?.result?.attachment_list[i]?.time_zone,
                  event_description: res.data?.result?.attachment_list[i]?.event_description,
                  attach_id: res.data?.result?.attachment_list[i]._id,
                };
                this.setState({
                  atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                });
                $('.attchLstShow_cmb').show();
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                this.colapse_all_attachments();
              }
              this.colapse_all_attachments();
            }
            this.colapse_all_attachments();
          }
          console.log(this.state.atcharryDet);
          this.colapse_all_attachments();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  template_save = () => {
    const { templ_msg, templ_name } = this.state;
    var Api_temp_url = '';
    if (templ_name.length === 0) {
      toast.dark('Template name cannot be empty', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (templ_msg.length === 0) {
      toast.dark('Template message cannot be empty', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (this.validate_notes(this.state.atcharryDet_cmb) !== 0) {
      toast.dark('Notes is empty, please be sure to either create a note or discard it.', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      if (this.state.atcharryDet_cmb.length != 0) {
        var text_msg_dtl = templ_msg;
        var attachmnt_Url = true;
        var unqID = Rnunique_id_cmb;
      } else {
        var text_msg_dtl = templ_msg;
        var attachmnt_Url = false;
        var unqID = '';
      }
      if (!this.state.templ_message_edit) {
        Api_temp_url = '/text/template/create';
      } else {
        Api_temp_url = '/text/template/update';
      }

      const template_add = {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        template_name: templ_name,
        text_message: text_msg_dtl,
        unique_id: unqID,
        attachment_url: attachmnt_Url,
        template_id: this.state.templ_msg_update_details?._id,
      };

      if (templ_msg != '') {
        axios
          .post(API_CALL_ENDPOINT + Api_temp_url, template_add)
          .then((res) => {
            if (res.data.status == 'success') {
              toast.dark(res.data.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });

              this.setState({ attachmentdoc_count_cmb: 0 });
              docAttachmentsCount_cmb = 0;
              setTimeout(() => {
                // this.setState({success: []});
                this.templates_listclick();
                Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
                $('.attchLstShow').hide();
                this.setState({
                  templ_msg_update_details: {},
                  templ_message_edit: false,
                  atcharryDet_cmb: [],
                  templ_name: '',
                  templ_msg: '',
                  chars_left_templ_msg: 300,
                  cmb_notesedit: false,
                  notesValue2_cmb: '',
                  max_chars_notes_cmb: 1200,
                  chars_left_notes_cmb: 1200,
                });
                clearTimeout(this.savetimer);
                clearTimeout(this.timer);
                $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                $('.sendmsg_attachmentdiv2_cmb').hide();
                $('.attchLstShow_cmb').hide();
                // $('.send_message_div1').hide();
                $('.addtemplate_modaldiv').hide();
                $('.searchtemplates_modaldiv').show();
                $('.searchtemplates_modaltxt').hide();
                $('.addtemplates_modaltxt').show();
              }, 5000);
            }
            if (res.data.error) {
              toast.dark(res.data.error.message, {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
            if (res.data.status === 'conflict') {
              toast.dark('This template name already exixts', {
                position: 'top-right',
                transition: Flip,
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.error) {
                toast.dark(error.response.data.error.message, {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
              if (error.response.data.status === 'conflict') {
                toast.dark('This template name already exixts', {
                  position: 'top-right',
                  transition: Flip,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            }
          });
      }
    }
  };
  onTemplateDelete = (temp_id) => {
    const template_list_del = {
      apikey: API_KEY,
      secret: API_SECRET,
      user_id: this.state.user_id,
      business_id: this.state.business_id,
      template_id: temp_id,
    };

    axios
      .post(API_CALL_ENDPOINT + '/text/template/delete', template_list_del)
      .then((res) => {
        if (res.data.status === 'success') {
          this.templates_listclick();
        }
      })
      .catch((error) => { });
  };
  render_emoji = (append_id, index, _id) => {
    if ($('#' + append_id).css('display') === 'block') {
      $('.emoji_disable').hide();
      $('.emoji_close_all').hide();
      $('.emoji_show_all').show();
      $('.' + append_id + '_show').show();
      $('.' + append_id + '_close').hide();
    } else {
      $('.emoji_disable').hide();
      $('.emoji_close_all').hide();
      $('.emoji_show_all').show();
      $('#' + append_id).show();
      $('.' + append_id + '_show').hide();
      $('.' + append_id + '_close').show();
      ReactDOM.render(
        <Picker
          theme={$('body').hasClass('dark-theme') ? 'dark' : 'light'}
          title="Pick your emoji"
          emoji="point_up"
          style={{ width: 'inherit' }}
          onSelect={(emoji) => this.onchange_emoji(emoji, append_id, index, _id)}
        />,
        document.getElementById(append_id),
      );
    }
  };
  onchange_emoji = (emoji, append_id, index, _id) => {
    if (append_id === 'Auto_txt_inbound') {
      var message_length = $('#get_data_for_inbound').val() + emoji.native;
      var if_check = 300 - message_length.length;
      if (if_check >= 0) {
        if (_id) {
          let AutoTxtArea = [...this.state.AutoTxtArea];
          AutoTxtArea[index] = { text_response: $('#get_data_for_inbound').val() + emoji.native, _id: _id };
          this.setState({ AutoTxtArea });
        } else {
          var value = $('#get_data_for_inbound').val();
          var value2 = $('#get_data_for_inbound').val(value + emoji.native);
          value = $('#get_data_for_inbound').val();
          let AutoTxtArea = [...this.state.AutoTxtArea];
          AutoTxtArea[index] = value;
          this.setState({ AutoTxtArea });
        }
      }
    } else if (append_id === 'Auto_txt_unsupport') {
      var message_length1 = this.state.unsupportedtext + emoji.native;
      var if_check1 = 300 - message_length1.length;
      if (if_check1 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          unsupportedtext: this.state.unsupportedtext + emoji.native,
        });
      }
    } else if (append_id === 'Auto_txt_inbound_calls') {
      var message_length2 = this.state.LeavAutoVceMsgVle + emoji.native;
      var if_check2 = 300 - message_length2.length;
      if (if_check2 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          LeavAutoVceMsgVle: this.state.LeavAutoVceMsgVle + emoji.native,
        });
      }
    } else if (append_id === 'Auto_txt_voice_greetings') {
      var message_length3 = this.state.TxtVoiceGrtngvlue + emoji.native;
      var if_check3 = 300 - message_length3.length;
      if (if_check3 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          TxtVoiceGrtngvlue: this.state.TxtVoiceGrtngvlue + emoji.native,
        });
      }
    } else if (append_id === 'Auto_txt_birth_greetings') {
      var message_length4 = this.state.birthdyTxtValue + emoji.native;
      var if_check4 = 300 - message_length4.length;
      if (if_check4 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          birthdyTxtValue: this.state.birthdyTxtValue + emoji.native,
        });
      }
    } else if (append_id === 'chat_widgit_greeting') {
      var message_length5 = this.state.chat_grtmsg + emoji.native;
      var if_check5 = 300 - message_length5.length;
      if (if_check5 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          chat_grtmsg: this.state.chat_grtmsg + emoji.native,
        });
      }
    } else if (append_id === 'chat_widgit_reply') {
      var message_length6 = this.state.chat_replymsg + emoji.native;
      var if_check6 = 300 - message_length6.length;
      if (if_check6 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          chat_replymsg: this.state.chat_replymsg + emoji.native,
        });
      }
    } else if (append_id === 'chat_widgit_new_con') {
      var message_length7 = this.state.chat_newcontactmsg + emoji.native;
      var if_check7 = 300 - message_length7.length;
      if (if_check7 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          chat_newcontactmsg: this.state.chat_newcontactmsg + emoji.native,
        });
      }
    } else if (append_id === 'chat_widgit_exist_con') {
      var message_length8 = this.state.chat_existcontactmsg + emoji.native;
      var if_check8 = 300 - message_length8.length;
      if (if_check8 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          chat_existcontactmsg: this.state.chat_existcontactmsg + emoji.native,
        });
      }
    } else if (append_id === 'template_message_text') {
      var message_length9 = this.state.templ_msg + emoji.native;
      var if_check9 = this.state.max_chars_templ_msg - message_length9.length;
      if (if_check9 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          templ_msg: this.state.templ_msg + emoji.native,
          chars_left_templ_msg: this.state.max_chars_templ_msg - message_length9.length,
        });
      }
    } else if (append_id === 'workflow_message') {
      var message_length10 = this.state.workflow_msg + emoji.native;
      var if_check10 = this.state.max_chars_wfmsg - message_length10.length;
      if (if_check10 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          workflow_msg: this.state.workflow_msg + emoji.native,
          chars_left_wfmsg: this.state.max_chars_wfmsg - message_length10.length,
        });
      }
    } else if (append_id === 'QR_code_response') {
      var message_length11 = this.state.qr_message + emoji.native;
      var if_check11 = 300 - message_length11.length;
      if (if_check11 >= 0) {
        // this.setState({unsupportedtext: e.target.value});
        this.setState({
          qr_message: this.state.qr_message + emoji.native,
        });
      }
    }
  };
  hide_emoji = () => {
    $('.emoji_disable').hide();
    $('.emoji_show_all').show();
    $('.emoji_close_all').hide();
  };

  colapsed_attach = (id) => {
    this.setState({ cmb_notesedit: false });
    $('.attachment_colapsed').show();
    $('.attachment_colapsed_' + id).hide();
    $('.attachment_expanded').hide();
    $('.attachment_expanded_' + id).show();
  };
  expanded_attach = (id) => {
    $('.attachment_colapsed').show();
    // $('.attachment_colapsed_'+id).show();
    $('.attachment_expanded').hide();
    $('.attachment_expanded_' + id).hide();
  };
  colapse_all_attachments = () => {
    $('.attachment_colapsed').show();
    $('.attachment_expanded').hide();
  };
  on_auto_MessageEdit = (unique_id, class_name, active_container, condition) => {
    if (condition) {
      $('.' + class_name).slideToggle(400);
    } else {
      $('.' + class_name).hide(400);
    }
    // $('.auto_all_inbound').hide(400);

    if (this.state.active_class_attachment !== class_name) {
      if (this.state.active_class_attachment) {
        $('.' + this.state.active_class_attachment).hide(400);
      }
      $('.auto_response_all_container').hide();
      $('.' + active_container).show();

      this.setState({ active_class_attachment: class_name });
      this.setState({
        atcharryDet_cmb: [],
        templ_name: '',
        templ_msg: '',
        chars_left_templ_msg: 300,
        cmb_notesedit: false,
        notesValue2_cmb: '',
        max_chars_notes_cmb: 1200,
        chars_left_notes_cmb: 1200,
      });
      console.log(unique_id);
      this.setState({
        Rnunique_id_cmb: unique_id,
      });
      Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);

      $('.attchLstShow_cmb').hide();

      if (unique_id) {
        Rnunique_id_cmb = unique_id;
        const attachmentinfo = {
          params: {
            apikey: API_KEY,
            secret: API_SECRET,
            user_id: this.state.user_id,
            business_id: this.state.business_id,
            unique_id: unique_id,
            // contact_id: conversation.conversation.contacts.toString()
          },
        };
        console.log(attachmentinfo);
        axios
          .get(API_CALL_ENDPOINT + '/attachment/edit/list', attachmentinfo)
          .then((res) => {
            console.log('EDIT', res.data);
            if (res.data.status === 'success') {
              this.setState({ messageAttachd: true });
              var arrayLength = res.data?.result?.attachment_list.length;

              var OrderIncr1 = this.state.attachOrderIncrs + parseInt(arrayLength);
              this.setState({ attachOrderIncrs: OrderIncr1 });

              for (var i = 0; i < arrayLength; i++) {
                if (res.data?.result?.attachment_list[i].attachment_type == 'notes') {
                  $('.attchLstShow_cmb').show();
                  $('#notestypearea').val('');
                  this.setState({
                    atcharryDet_cmb: [
                      {
                        attach_id: res.data?.result?.attachment_list[i]._id,
                        notes_content: res.data?.result?.attachment_list[i].text,
                        notes_content1: 'Your text goes here',
                      },
                      ...this.state.atcharryDet_cmb,
                    ],
                  });
                }
                if (res.data?.result?.attachment_list[i].attachment_type == 'audio') {
                  $('.attchLstShow_cmb').show();
                  this.setState({
                    atcharryDet_cmb: [
                      {
                        _id: res.data?.result?.attachment_list[i].attachment[0]._id,
                        file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                        second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                        audio_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                        audio_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                        attach_id: res.data?.result?.attachment_list[i]._id,
                      },
                      ...this.state.atcharryDet_cmb,
                    ],
                  });
                }
                if (res.data?.result?.attachment_list[i].attachment_type == 'video') {
                  $('.attchLstShow_cmb').show();
                  console.log('video_url: ' + res.data?.result?.attachment_list[i].attachment[0].file_url);
                  this.setState({
                    atcharryDet_cmb: [
                      {
                        video_id: res.data?.result?.attachment_list[i].attachment[0]._id,
                        video_url: res.data?.result?.attachment_list[i].attachment[0].file_url,
                        attach_id: res.data?.result?.attachment_list[i]._id,
                        second_file_path: res.data?.result?.attachment_list[i].attachment[0].second_file_path,
                        file_path: res.data?.result?.attachment_list[i].attachment[0].file_path,
                      },
                      ...this.state.atcharryDet_cmb,
                    ],
                  });
                }
                if (res.data?.result?.attachment_list[i].attachment_type == 'documents') {
                  var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                  this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                  var flDc_detils = [];
                  var k = 1;

                  for (var j = 0; j < arrayLength1; j++) {
                    flDc_detils.push({
                      file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                      file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                      file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                      file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                    });

                    if (k == arrayLength1) {
                      var fileary = {
                        documents: flDc_detils,
                        attach_id: res.data?.result?.attachment_list[i]._id,
                      };
                      this.setState({
                        atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                      });
                    }
                    k++;
                  }

                  $('.attchLstShow_cmb').show();
                  $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                }
                if (res.data?.result?.attachment_list[i].attachment_type == 'images') {
                  var arrayLength1 = res.data?.result?.attachment_list[i].attachment.length;
                  this.setState({ attachmentdoc_count: res.data?.result?.attachment_list[i].attachment.length });
                  var flDc_detils = [];
                  var k = 1;

                  for (var j = 0; j < arrayLength1; j++) {
                    flDc_detils.push({
                      file_id: res.data?.result?.attachment_list[i].attachment[j]._id,
                      file_name: res.data?.result?.attachment_list[i].attachment[j].display_name,
                      file_url: res.data?.result?.attachment_list[i].attachment[j].file_url,
                      file_path: res.data?.result?.attachment_list[i].attachment[j].file_path,
                    });

                    if (k == arrayLength1) {
                      var fileary = {
                        images: flDc_detils,
                        attach_id: res.data?.result?.attachment_list[i]._id,
                      };
                      this.setState({
                        atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                      });
                    }
                    k++;
                  }

                  $('.attchLstShow_cmb').show();
                  $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                }
                if (res.data?.result?.attachment_list[i].attachment_type == 'google_calendar') {
                  var fileary = {
                    calendar_name: res.data?.result?.attachment_list[i]?.calendar_name,
                    calendar_startdate: res.data?.result?.attachment_list[i]?.calendar_startdate,
                    calendar_enddate: res.data?.result?.attachment_list[i]?.calendar_enddate,
                    event_recurrence: res.data?.result?.attachment_list[i]?.event_recurrence,
                    time_zone: res.data?.result?.attachment_list[i]?.time_zone,
                    event_description: res.data?.result?.attachment_list[i]?.event_description,
                    attach_id: res.data?.result?.attachment_list[i]._id,
                  };
                  this.setState({
                    atcharryDet_cmb: [fileary, ...this.state.atcharryDet_cmb],
                  });
                  $('.attchLstShow_cmb').show();
                  $('.sendmsgattach_clkAudio2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkNotes2_cmb').attr('style', 'display:none');
                  $('.sendmsgattach_clkVideo2_cmb').attr('style', 'display:none');
                }
                $('.attchLstShow_cmb').show();
                $('.attachment_colapsed').show();
                $('.attachment_expanded').hide();
              }
            }
            console.log(this.state.atcharryDet);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  status_hide = (class_name) => {
    $('.' + class_name).hide();
  };
  validate_notes = (arr) => {
    var arrayLength = arr.length;

    var count = 0;
    if (arr.length !== 0) {
      for (var i = 0; i < arrayLength; i++) {
        if (arr[i].notes_content1) {
          var string = arr[i].notes_content.replace(/(<([^>]+)>)/gi, '');
          if (string.length == 0) {
            count += 1;
          }
        }
      }
    }
    return count;
  };
  remove_attach = () => {
    this.setState({
      atcharryDet_cmb: [],
      cmb_notesedit: false,
      notesValue2_cmb: '',
      max_chars_notes_cmb: 1200,
      chars_left_notes_cmb: 1200,
    });

    Rnunique_id_cmb = Math.random().toString(36).substr(2, 16);
  };
  update_contact_popup = () => {
    $('.updcontactsel').val('');
    $('.updct').hide();
    $('#update_contact_notes').val('');
    $('#custome_properties_updated_contact').val('');
    $('#company_updated_value').val('');
    $('.selected_tags').prop('checked', false);
    $('.remove_tags').prop('checked', false);
    $('.updcontactsel').trigger('click');
  };
  addWorkflow = (data) => {
    setTimeout(() => {
      $(".nav_links_prof").removeClass('active');
      $('.nav_links_prof_tabs').removeClass('active show');
      $('#custom-tabs-general-tab').removeClass('active');
      $('#custom-tabs-general').removeClass('active show');
      $('#custom-tabs-workflow-tab').addClass('active');
      $('#custom-tabs-workflow').addClass('active show');
      $('.workflowcreate_div').hide();
      $('.addworkflow_div').show();
      $('.addentrypoints_div').hide();
      $('.workflowlist_div').hide();
    }, 2000);
  };
  archive_search = async () => {
    toast.dark('Your data is being processed please wait.', {
      position: 'top-right',
      transition: Flip,
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    var contactVl_id = [];
    for (var i in this.state.checked) {
      console.log(this.state.checked[i].data_value);
      contactVl_id.push(this.state.checked[i].data_value);
    }

    console.log(contactVl_id);
    this.setState({ contact_id: contactVl_id });
    const archive_con_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        source: 'admin',
        search_text: this.state.archive_search_keyword,
        from_date: this.state.start,
        to_date: this.state.end,
        type: this.state.archive_search_type,
        contacts: contactVl_id?.toString(),
        // attachment_types: this.state.scSelectedCategories.toString(),
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/text/archive/conversation', archive_con_list)
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({
            scResultContactList: res.data.result.contact_list,
            show_download_all: false,
          });
          for (var i in res.data.result.contact_list) {
            if (res.data.result.contact_list[i]?.text_conversation?.length !== 0) {
              this.setState({ show_download_all: true });
            }
            // console.log(drvlone);
            // this.setState({dropDownValue: drvlone});
            // this.setState({dropDownValue: drvl})
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
          if (error.response.data) {
            this.setState({
              scResultContactList: [],
              show_download_all: false,
            });
            toast.dark(error.response.data.message, {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        }
      });
    // let scSearchResult = await axios.get(API_CALL_ENDPOINT + '/text/archive/conversation', {
    //   params: {
    //     apikey: API_KEY,
    //     secret: API_SECRET,
    //     user_id: this.state.user_id,
    //     business_id: this.state.business_id,
    //     source: 'admin',
    //     search_text: this.state.archive_search_keyword,
    //     from_date: this.state.start,
    //     to_date: this.state.end,
    //     type: this.state.archive_search_type,
    //     contacts: this.state.archive_search_contact.toString(),

    //   },
    // });
    // if (scSearchResult) {
    //   console.log(scSearchResult);
    //   this.setState({scSearching: false});
    //   if (scSearchResult?.data?.result?.contact_list) {
    //     this.setState({scResultContactList: scSearchResult.data.result.contact_list});
    //   } else if (scSearchResult?.data?.message) {
    //     toast.dark(scSearchResult.data.message, {
    //       position: 'top-center',
    //       transition: Flip,
    //       autoClose: 5000,
    //       hideProgressBar: true,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //   }
    // } else {
    //   // this.setState({scSearching: false});
    // }
  };
  scContactList = (contact_list) => {
    var moment = require('moment');

    // CONTACT_LIST MAP
    // console.log('contact_list', contact_list);

    return contact_list.map((contact, contIndex) => {
      if (contact?.text_conversation?.length > 0) {
        return (
          <>
            <div className="searchdsply_item mb-4">
              <div className="w-100">
                <h5 className="mb-3 f_sz15 d-inline-block">
                  <div className="icheck-darkgrey d-inline-block py-1">
                    {/* <input type="checkbox"  id={"searchct_"+contact._id} /> */}
                    <span>
                      {contact.first_name == 'Guest'
                        ? '+91 ' +
                        contact.phone_number
                          .toString()
                          .substring(1)
                          .replace(/[^\dA-Z]/g, '')
                          .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                          .trim()
                        : contact.first_name + ' ' + contact.last_name}
                    </span>
                  </div>
                </h5>
                <div className="text-right d-inline-block float-right">
                  <div class="dropdown">
                    <button
                      className="btn btn-sm btn-black-dark2 f_sz14 btnpdng_sm dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false">
                      Download as
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a
                        className="dropdown-item"
                        onClick={() => this.downloadDiv('.txt', 'Arch_' + contact._id, 'text/plain')}
                        href="#">
                        Text
                      </a>
                      <a
                        className="dropdown-item"
                        onClick={() => this.downloadDiv('.html', 'Arch_' + contact._id, 'text/html')}
                        href="#">
                        HTML
                      </a>
                      <a
                        className="dropdown-item"
                        onClick={() => this.downloadDiv_pdf(contact.text_conversation)}
                        href="#">
                        Pdf
                      </a>
                      <a
                        className="dropdown-item"
                        onClick={() => this.download_as_excel(contact.text_conversation)}
                        href="#">
                        Excel
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <span id={'Arch_' + contact._id}>
                {contact.text_conversation.map((conversation, convIndex) => {
                  if (
                    conversation.campaign_type === 'in' ||
                    (conversation.campaign_type === 'out' &&
                      (conversation.receiver_reply === 'no' || conversation.receiver_reply === 'saved'))
                  ) {
                    return (
                      <>
                        <div className="searchdsply_content border p-2 mb-2">
                          <ul className="products-list product-list-in-card pl-2 pr-2 contact_converselist w-100">
                            <li className="item ">
                              <div className="product-img">
                                <span
                                  className="usercircle_md "
                                  style={{
                                    backgroundColor: conversation.contact_info[0]?.color_code
                                      ? conversation.contact_info[0]?.color_code
                                      : '#097952',

                                    textTransform: 'uppercase',
                                  }}>
                                  {conversation.campaign_type === 'in' && !conversation.parent_reply_id ? (
                                    conversation.contact_info[0]?.first_name &&
                                      conversation.contact_info[0]?.first_name !== 'Guest' ? (
                                      conversation.contact_info[0]?.first_name.substring(-1, 1)
                                    ) : (
                                      <i className="far fa-user" />
                                    )
                                  ) : conversation.user_info[0]?.first_name &&
                                    conversation.user_info[0]?.first_name !== 'Guest' ? (
                                    conversation.user_info[0]?.first_name.substring(-1, 1)
                                  ) : (
                                    <i className="far fa-user" />
                                  )}
                                </span>
                                {/*<span class="usercircleimg_md"><img src="../dist/img/no_image.png" border="0"/></span>*/}
                              </div>
                              <div className="product-info">
                                <span className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0">
                                  <span className="product-title fmaroon">
                                    {conversation.campaign_type === 'in' && !conversation.parent_reply_id
                                      ? `${conversation.contact_info[0]?.first_name
                                        ? conversation.contact_info[0]?.first_name
                                        : 'First Name'
                                      } ${conversation.contact_info[0]?.last_name
                                        ? conversation.contact_info[0]?.last_name
                                        : ''
                                      }`
                                      : `${conversation.user_info[0]?.first_name
                                        ? conversation.user_info[0]?.first_name
                                        : 'First Name'
                                      } ${conversation.user_info[0]?.last_name
                                        ? conversation.user_info[0]?.last_name
                                        : ''
                                      }`}
                                    <span className="ml-0 ml-sm-2 text-xs flightgrey3 d-inline-block">
                                      Archived on <i className="far fa-clock mr-1" />
                                      {moment(conversation.updated_date).format('MMMM DD,YYYY hh:mma')}
                                    </span>
                                  </span>
                                  <span className="product-description">
                                    <span>
                                      <Linkify
                                        componentDecorator={(decoratedHref, decoratedText, key) => (
                                          <a target="blank" href={decoratedHref} key={key}>
                                            {decoratedText}
                                          </a>
                                        )}>
                                        {conversation.parent_text_message
                                          ? conversation.parent_text_message + ' '
                                          : conversation.text_message
                                            ? conversation.text_message + ' '
                                            : 'Currently Unavailable '}
                                      </Linkify>
                                      {conversation?.parent_shorten_url &&
                                        conversation?.reference !== 'auto_unsupport' ? (
                                        <a
                                          href={() => false}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="fmaroon crsr_pntr mr-1">
                                          {conversation?.parent_shorten_url}
                                        </a>
                                      ) : conversation?.shorten_attachment_url &&
                                        conversation?.reference !== 'auto_unsupport' ? (
                                        <a
                                          href={() => false}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="fmaroon crsr_pntr mr-1">
                                          {conversation?.shorten_attachment_url}
                                        </a>
                                      ) : null}
                                    </span>
                                  </span>
                                </span>
                              </div>
                            </li>
                            {/* /.item */}
                          </ul>
                        </div>

                        {/* {convIndex === contact?.text_conversation?.length - 1 ? (
                      <div
                        className="Col-12 col-sm-12 col-md-12 mt-2 text-right"
                        onClick={() => this.scViewMore(contIndex, contact?.text_conversation?.length)}>
                        <a href={() => false} className="fmaroon" style={{cursor: 'pointer'}}>
                          View More
                        </a>
                      </div>
                    ) : null} */}
                      </>
                    );
                  } else {
                    return null;
                  }
                })}
              </span>
            </div>
          </>
        );
      } else {
        return null;
      }
    });
  };
  dateRangePickerSelect = (range, states, dates, start, end, value) => {
    console.log('datesdates', dates);
    this.setState({ dates });
    this.setState({
      value: range,
      states: states,
    });
    setTimeout(() => {
      let selectedStartDate = this.state.value.start.format('DD/MMM/YYYY');
      let selectedEndDate = this.state.value.end.format('DD/MMM/YYYY');
      console.log('Selected Start:  ', selectedStartDate);
      console.log('Selected End:    ', selectedEndDate);
      var diffInMs = Math.abs(new Date(selectedStartDate) - new Date(selectedEndDate));
      var diffindays = diffInMs / (1000 * 60 * 60 * 24);
      if (diffindays > 1) {
        this.setState({ hoursDisabled: true });
      } else {
        this.setState({ hoursDisabled: false });
      }
      // $("#buttons_div").
      var default_dateval =
        moment(this.state.value.start).format('MMM DD, yyyy') +
        ' - ' +
        moment(this.state.value.end).format('MMM DD, yyyy');
      $('#default_dateval').val(default_dateval);
      // this.getAllBusinessDetails(moment(this.state.value.start).format("MM-DD-yyyy"), moment(this.state.value.end).format("MM-DD-yyyy"), this.state.selectedBtnType);
      this.setState({
        start: selectedStartDate,
        end: selectedEndDate,
      });
    }, 1000);
  };
  onChangearchive_contacts(e) {
    const values = [...e.target.selectedOptions].map((opt) => opt.value);
    // this.props.onChange(values);
    this.setState({ archive_search_contact: values });
  }
  downloadDiv(filename, elementId, mimeType) {
    var elementHtml = '';
    if (mimeType === 'text/plain') {
      elementHtml = document.getElementById(elementId).textContent;
    } else {
      elementHtml = document.getElementById(elementId).innerHTML;
    }

    var link = document.createElement('a');
    mimeType = mimeType || 'text/plain';

    link.setAttribute('download', new Date() + filename);
    link.setAttribute('href', 'data:' + mimeType + ';charset=utf-8,' + encodeURIComponent(elementHtml));
    link.click();
  }
  downloadDiv_pdf(json) {
    var doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'a1',
      compress: true,
      putOnlyUsedFonts: true,
      floatPrecision: 'smart', // or "smart", default is 16
    });
    var workflow_result = {};
    var workflow_result_array = [];
    json.forEach(function (conversation) {
      workflow_result['Name'] =
        conversation.campaign_type === 'in' && !conversation.parent_reply_id
          ? `${conversation.contact_info[0]?.first_name ? conversation.contact_info[0]?.first_name : 'First Name'} ${conversation.contact_info[0]?.last_name ? conversation.contact_info[0]?.last_name : ''
          }`
          : `${conversation.user_info[0]?.first_name ? conversation.user_info[0]?.first_name : 'First Name'} ${conversation.user_info[0]?.last_name ? conversation.user_info[0]?.last_name : ''
          }`;
      workflow_result['Message'] = conversation.parent_text_message
        ? conversation.parent_text_message + ' '
        : conversation.text_message
          ? conversation.text_message + ' '
          : 'Currently Unavailable ';
      workflow_result['Link'] =
        conversation?.parent_shorten_url && conversation?.reference !== 'auto_unsupport'
          ? conversation?.parent_shorten_url
          : conversation?.shorten_attachment_url && conversation?.reference !== 'auto_unsupport'
            ? conversation?.shorten_attachment_url
            : 'Nill';
      workflow_result['Time'] = moment(conversation.updated_date).format('MMMM DD,YYYY hh:mma');
      workflow_result_array.push(workflow_result);
      workflow_result = {};
    });

    workflow_result_array.forEach(function (conversation, i) {
      var splitTitle = doc.splitTextToSize(
        'Name: ' +
        conversation.Name +
        '    ' +
        'Message: ' +
        conversation.Message +
        '    ' +
        'Attachment: ' +
        conversation.Link +
        '    ' +
        'Time: ' +
        conversation.Time,
        280,
      );
      var options = {
        pagesplit: true,
      };
      doc.text(splitTitle, 20, 20 + i * 40);
      var pageHeight = doc.internal.pageSize.height;
      var pagetouse = 0;
      if (20 + i * 40 >= pageHeight) {
        pagetouse += 1;
        doc.addPage();
        doc.setPage(pagetouse);
      }
    });

    doc.save(new Date() + '.pdf');
    // var elementHtml = ''
    // if(mimeType === 'text/plain'){
    //   elementHtml = document.getElementById(elementId).textContent;
    // }else{
    //   elementHtml = document.getElementById(elementId).innerHTML;
    // }

    // var link = document.createElement('a');
    // mimeType = mimeType || 'text/plain';

    // link.setAttribute('download', filename);
    // link.setAttribute('href', 'data:' + mimeType  +  ';charset=utf-8,' + encodeURIComponent(elementHtml));
    // link.click();
  }
  download_as_excel = (xlsRows) => {
    var createXLSLFormatObj = [];

    /* XLS Head Columns */
    var xlsHeader = ['Name', 'Message', 'Attachment', 'Time'];
    var workflow_result = {};
    var workflow_result_array = [];
    xlsRows.forEach(function (conversation) {
      workflow_result['Name'] =
        conversation.campaign_type === 'in' && !conversation.parent_reply_id
          ? `${conversation.contact_info[0]?.first_name ? conversation.contact_info[0]?.first_name : 'First Name'} ${conversation.contact_info[0]?.last_name ? conversation.contact_info[0]?.last_name : ''
          }`
          : `${conversation.user_info[0]?.first_name ? conversation.user_info[0]?.first_name : 'First Name'} ${conversation.user_info[0]?.last_name ? conversation.user_info[0]?.last_name : ''
          }`;
      workflow_result['Message'] = conversation.parent_text_message
        ? conversation.parent_text_message + ' '
        : conversation.text_message
          ? conversation.text_message + ' '
          : 'Currently Unavailable ';
      workflow_result['Link'] =
        conversation?.parent_shorten_url && conversation?.reference !== 'auto_unsupport'
          ? conversation?.parent_shorten_url
          : conversation?.shorten_attachment_url && conversation?.reference !== 'auto_unsupport'
            ? conversation?.shorten_attachment_url
            : 'Nill';
      workflow_result['Time'] = moment(conversation.updated_date).format('MMMM DD,YYYY hh:mma');
      workflow_result_array.push(workflow_result);
      workflow_result = {};
    });
    createXLSLFormatObj.push(xlsHeader);
    $.each(workflow_result_array, function (index, conversation) {
      var innerRowData = [];
      $('tbody').append(
        '<tr><td>' +
        conversation.Name +
        '</td><td>' +
        conversation.Message +
        '</td><td>' +
        conversation.Link +
        '</td><td>' +
        conversation.Time +
        '</td></tr>',
      );
      $.each(conversation, function (ind, val) {
        innerRowData.push(val);
      });
      createXLSLFormatObj.push(innerRowData);
    });

    /* File Name */
    var filename = new Date() + '.xlsx';

    /* Sheet Name */
    var ws_name = 'ArchiveSheet';

    if (typeof console !== 'undefined') console.log(new Date());
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);

    /* Add worksheet to workbook */
    XLSX.utils.book_append_sheet(wb, ws, ws_name);

    /* Write workbook and Download */
    if (typeof console !== 'undefined') console.log(new Date());
    XLSX.writeFile(wb, filename);
    if (typeof console !== 'undefined') console.log(new Date());
  };
  download_as_excel_all = (contacts) => {
    var createXLSLFormatObj = [];
    var wb = XLSX.utils.book_new();
    var count = 0;
    /* File Name */
    var filename = new Date() + '.xlsx';
    for (var i = 0; i < contacts.length; i++) {
      if (contacts[i]?.text_conversation?.length > 0) {
        count += 1;
        /* XLS Head Columns */
        let ws;
        var xlsHeader = ['Name', 'Message', 'Attachment', 'Time'];
        var workflow_result = {};
        var workflow_result_array = [];
        var contact_text_con = contacts[i].text_conversation;
        contact_text_con.forEach(function (conversation) {
          workflow_result['Name'] =
            conversation.campaign_type === 'in' && !conversation.parent_reply_id
              ? `${conversation.contact_info[0]?.first_name ? conversation.contact_info[0]?.first_name : 'First Name'
              } ${conversation.contact_info[0]?.last_name ? conversation.contact_info[0]?.last_name : ''}`
              : `${conversation.user_info[0]?.first_name ? conversation.user_info[0]?.first_name : 'First Name'} ${conversation.user_info[0]?.last_name ? conversation.user_info[0]?.last_name : ''
              }`;
          workflow_result['Message'] = conversation.parent_text_message
            ? conversation.parent_text_message + ' '
            : conversation.text_message
              ? conversation.text_message + ' '
              : 'Currently Unavailable ';
          workflow_result['Link'] =
            conversation?.parent_shorten_url && conversation?.reference !== 'auto_unsupport'
              ? conversation?.parent_shorten_url
              : conversation?.shorten_attachment_url && conversation?.reference !== 'auto_unsupport'
                ? conversation?.shorten_attachment_url
                : 'Nill';
          workflow_result['Time'] = moment(conversation.updated_date).format('MMMM DD,YYYY hh:mma');
          workflow_result_array.push(workflow_result);
          workflow_result = {};
        });
        createXLSLFormatObj.push(xlsHeader);
        $.each(workflow_result_array, function (index, conversation) {
          var innerRowData = [];
          $('tbody').append(
            '<tr><td>' +
            conversation.Name +
            '</td><td>' +
            conversation.Message +
            '</td><td>' +
            conversation.Link +
            '</td><td>' +
            conversation.Time +
            '</td></tr>',
          );
          $.each(conversation, function (ind, val) {
            innerRowData.push(val);
          });
          createXLSLFormatObj.push(innerRowData);
        });

        /* Sheet Name */
        var ws_name = 'ArchiveSheet' + count;

        if (typeof console !== 'undefined') console.log(new Date());

        ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);

        /* Add worksheet to workbook */
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        createXLSLFormatObj = [];
        workflow_result_array = [];
      }
    }
    /* Write workbook and Download */
    if (typeof console !== 'undefined') console.log(new Date());
    XLSX.writeFile(wb, filename);
    if (typeof console !== 'undefined') console.log(new Date());
  };

  onClickButtonAdder(e) {
    e.preventDefault();
    if (this.state.dump_emails?.length < this.state.dump_members) {
      console.log('added');
      this.setState({
        dump_emails: ['', ...this.state?.dump_emails],
      });
    } else {
      var errors = [];
      errors.push('To add more contacts, please upgrade your plan');
      this.setState({ errors });
      // console.log(this.state.errors);
      setTimeout(() => {
        this.setState({ errors: [] });
        // this.props.history.push('/')
        // document.getElementById('error').style.display='none'
      }, 3000);
    }
    if (this.state?.dump_emails.length + 1 == this.state.dump_members) console.log('limit');
  }

  onClickFormGroupButton(index, e) {
    e.preventDefault();
    let dump_emails = [...this.state?.dump_emails];
    dump_emails.splice(index, 1);
    this.setState({ dump_emails });
  }

  onChangeFormGroupInput(index, e) {
    let dump_emails = [...this.state?.dump_emails];
    dump_emails[index] = e.target.value;
    // var regx = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g
    // if(new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(team_emails[index])){
    //   this.setState({ team_emails });
    // }
    console.log(new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(dump_emails[index]));

    this.setState({ dump_emails });
  }

  email_dump_on_off = (clicked_from) => {
    const filteredValues = this.state.dump_emails.filter((value) => value);
    const regExp = new RegExp(/^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/);
    if (filteredValues?.toString()?.length !== 0) {
      var result = regExp.test(filteredValues.toString());
    } else {
      var result = true;
    }

    if (result === true) {
      if ($('#dailyemaildump').is(':checked')) {
        this.setState({ VwArchiewDisbl: false });

        const email_dump_header = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          status: 'on',
          setup: 'email_dump',
          email_address: filteredValues.toString(),
        };

        axios.post(API_CALL_ENDPOINT + '/business/profile/settings', email_dump_header).then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            // window.location.reload(true);
            toast.dark('Daily email dump has been updated', {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

            emaildumpDtatble.destroy();
            const dump_history = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            axios.get(API_CALL_ENDPOINT + '/business/emaildump/history', dump_history).then((res) => {
              console.log(res.data);
              if (res.data.result) {
                this.setState({ emaildump_Hstry_detail: res.data.result });
                emaildumpDtatble = $('#dailyemaildumphistory_tbl').DataTable({
                  paging: true,
                  lengthChange: false,
                  ordering: false,
                  searching: false,
                });
              }
            });
          }
        });
      } else {
        const email_dump_header = {
          apikey: API_KEY,
          secret: API_SECRET,
          user_id: this.state.user_id,
          business_id: this.state.business_id,
          status: 'off',
          setup: 'email_dump',
          email_address: filteredValues.toString(),
        };

        axios.post(API_CALL_ENDPOINT + '/business/profile/settings', email_dump_header).then((res) => {
          console.log(res);
          console.log(res.data.message);

          if (res.data.status == 'success') {
            // window.location.reload(true);
            toast.dark('Daily email dump has been updated', {
              position: 'top-right',
              transition: Flip,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            emaildumpDtatble.destroy();
            const dump_history = {
              params: {
                apikey: API_KEY,
                secret: API_SECRET,
                user_id: this.state.user_id,
                business_id: this.state.business_id,
              },
            };

            axios.get(API_CALL_ENDPOINT + '/business/emaildump/history', dump_history).then((res) => {
              console.log(res.data);
              if (res.data.result) {
                this.setState({ emaildump_Hstry_detail: res.data.result });
                emaildumpDtatble = $('#dailyemaildumphistory_tbl').DataTable({
                  paging: true,
                  lengthChange: false,
                  ordering: false,
                  searching: false,
                });
              }
            });
          }
        });
      }
    } else {
      if (clicked_from == 'radio') {
        if ($('#dailyemaildump').is(':checked')) {
          $('#dailyemaildump').prop('checked', false);
        } else {
          $('#dailyemaildump').prop('checked', true);
        }
      }
      toast.dark('Please enter a valid email address (example@example.com)', {
        position: 'top-right',
        transition: Flip,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  //Contact multiselect
  removeChip(value) {
    this.checkBox(value, false);
  }

  checkBox(value, condition, name, contact) {
    console.log('contact', contact);
    let checkedValue = this.state.checked;
    if (condition) {
      $('.search-result').attr('style');
      checkedValue.push({ data_value: value, data_name: name });
    } else {
      //let index = checkedValue.indexOf(value);
      //checkedValue.splice(index, 1);
      console.log('this.state.checked', this.state.checked);

      checkedValue = this.state.checked.filter((i) => i.data_value !== value);

      console.log('checkedValue', checkedValue);
    }
    this.setState({
      checked: checkedValue,
    });
  }

  searchFun(e) {
    console.log(e.target.value);
    console.log(e.target.value.length);
    console.log(this.state.dropDownValue);
    // if (e.target.value.length !== 0) {
    let enteredValue = e.target.value;
    //   let presentValue = this.state.dropDownValue.filter(function (data) {
    //     return data.name.indexOf(enteredValue) > -1;
    //   });
    //   this.setState({dropDownValue: presentValue});
    // } else {
    const contactslist = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        business_id: this.state.business_id,
        search_text: enteredValue,
      },
    };

    axios.get(API_CALL_ENDPOINT + '/contacts/list', contactslist).then((res) => {
      // this.businessprofiledetails();
      // var drvl =this.state.dropDownValue;
      var drvlone = [];

      for (var i in res.data?.result?.contacts) {
        if (res.data?.result?.contacts[i].text_archive !== 'false') {
          // console.log(res.data?.result?.contacts[i]._id);
          var name =
            res.data?.result?.contacts[i].first_name == 'Guest'
              ? '+91 ' +
              res.data?.result?.contacts[i].phone_number
                .toString()
                .substring(1)
                .replace(/[^\dA-Z]/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                .trim()
              : res.data?.result?.contacts[i].first_name + ' ' + res.data?.result?.contacts[i].last_name;
          // drvl.push({ name: name, value: res.data?.result?.contacts[i]._id });
          drvlone.push({
            name: name,
            value: res.data?.result?.contacts[i]._id,
            tags: res.data?.result?.contacts[i].tags,
            contact: res.data?.result?.contacts[i],
          });
        }
        console.log(drvlone);
        this.setState({ dropDownValue: drvlone });
        // this.setState({dropDownValue: drvl})
      }
    });
    // }
  }
  returnChip() {
    const chip = this.state.checked
      ? this.state.checked.map((data, index) => (
        <div className="chip-body" key={index}>
          <p className="chip-text"> {data.data_name}</p>
          <button className="chip-close" onClick={(e) => this.removeChip(data.data_value)}>
            &times;
          </button>
        </div>
      ))
      : [];

    return chip;
  }
  returnList() {
    const list = this.state.dropDownValue
      ? this.state.dropDownValue.map((data, index) => (
        <label className="container" key={index} id={'labl_' + data.value}>
          {data.name}
          <input
            type="checkbox"
            value={data.value}
            id={data.name}
            data-chk={'chk_' + data.value}
            onChange={(e) => this.checkBox(e.target.value, e.target.checked, e.target.id, data)}
            checked={this.state.checked.some((person) => person.data_value === data.value) ? true : false}
          />
          <span className="checkmark"></span>
        </label>
      ))
      : null;
    return list;
  }

  opnDrpwn() {
    $('.search-result').toggle();
  }

  //Role based restriction
  user_views_list = () => {
    const user_views_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/admin/views/list', user_views_list)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          var assigned_views = res?.data?.result?.find((view) => view.views === 'WorkspaceSettings');
          if (assigned_views) {
            this.setState({ user_views_list_arr: assigned_views.permission_assign });
            console.log('user_views_list_arr', this.state.user_views_list_arr);
            for (var k in assigned_views.permission_assign) {
              console.log('array3 each', assigned_views.permission_assign[k]);
              $('.' + assigned_views.permission_assign[k]).attr('style', 'display: inline-block !important');
            }
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          // console.log('error.response', error.response);
          this.setState({ user_views_list_arr: [] });
        }
      });
  };
  user_roles_info = (role_id_data) => {
    const user_views_list = {
      params: {
        apikey: API_KEY,
        secret: API_SECRET,
        user_id: this.state.user_id,
        role_id: role_id_data,
      },
    };

    axios
      .get(API_CALL_ENDPOINT + '/admin/roles/info', user_views_list)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          // this.setState({user_roles_info_arr: res.data.result});

          // var assigned_views = res?.data?.result?.find((view) => view.views === "WorkspaceSettings");
          for (let i = 0; i < res?.data?.result?.views?.length; i++) {
            // var assigned_role_restrict = res?.data?.result?.views[i]?.views_id.views
            if (res?.data?.result?.views[i]?.views_id.views === 'WorkspaceSettings') {
              var restricted_permission = res?.data?.result?.views[i]?.permission;
              var all_permission = this.state.user_views_list_arr;
              var array3 = all_permission.filter(function (obj) {
                return restricted_permission.indexOf(obj) == -1;
              });
              // console.log("array3",array3)
              for (var k in array3) {
                if (array3[k] == 'IntegrationEmail') {
                  $('#custom-tabs-psemail').removeClass('active show');
                } else if (array3[k] == 'GeneralInfo') {
                  $('#custom-tabs-psinfodtls').removeClass('active show');
                }
                console.log('array3 each', array3[k]);
                $('.' + array3[k]).attr('style', 'display: none !important');
              }
              //     for (let j = 0; i < array3?.length; j++) {

              //       $('.'+array3[j]).hide();
              // }
            }
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          // console.log('error.response', error.response);
          this.setState({ user_roles_info_arr: [] });
        }
      });
  };
  render() {
    console.log('this.state.business_info_array?.business?.user_id', this.state.business_info_array?.business?.user_id);
    let initialYear = this.state.setYear;
    let initialMonths = this.state.setMonth;
    let noOfMonths = 2;
    let smallCalenderMinDate = new Date(new Date().setFullYear(new Date().getFullYear() - 4));
    let smallCalenderMaxDate = new Date();
    new Date().setDate(new Date().getDate() - 1);
    let minimumDate = new Date(new Date().setFullYear(new Date().getFullYear() - 4));
    let maximumDate = this.state.date;
    new Date().setDate(new Date().getDate() - 1);
    var moment = require('moment');
    const { business_id } = this.state;
    const isTagFormGroupDeletionAllowed = this.state.tagTxtBox.length > 1 ? true : false;
    const { run, steps } = this.state;
    return (
      <div className="hold-transition  accent-custom">
        <div className="wrapper">
          <ToastContainer
            transition={Flip}
            position="top-right"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Joyride
            callback={this.handleJoyrideCallback}
            steps={this.state.steps}
            continuous={true}
            run={run}
            scrollToFirstStep={true}
            // showProgress={true}
            hideBackButton={true}
            showSkipButton={true}
            styles={{
              options: {
                arrowColor: '#ffffff',
                backgroundColor: '#ffffff',
                // overlayColor: '#1f41378c',
                primaryColor: '#e50038',
                textColor: '#000000',
                beaconSize: 60,
                // width: 900,
                zIndex: 10000,
              },
            }}
          // styles={{
          //   options: {
          //     zIndex: 10000,
          //   },
          // }}
          />
          {/* Navbar */}
          <span onClick={() => this.hide_emoji()}>
            <Header_component
              redirectToPage={this.redirectToPage.bind(this)}
              data={this.update.bind(this)}
              cart_data={this.cart_update.bind(this)}
              cart_access={this.state.packcart_list}
              cart_updated_count={this.state.cart_updated_count}
              trigger={this.without_refresh.bind(this)}
            />
          </span>
          {/* /.navbar */}
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-12">
                    <div className="header_pagetitle d-block d-sm-block d-md-none">
                      <div className="text-center pt-2">
                        <div className="allheader_profile_drpdwn crsr_pntr">
                          <h4 className="d-inline-block">
                            {/* {this.state.prfImag != '' ? (
                    <span className="workspacelogo mr-2">
                      <img src={this.state.prfImag} alt="Redtie" className="brand-image" />
                    </span>
                  ) : this.state.business_name1 ?<span
                  className="workspacecircle mr-2"
                  style={{
                    backgroundColor: this.state.business_color_code ? this.state.business_color_code : '#097952',
                    color: '#ffffff',
                  }}>
                  {this.state.business_name1 ? this.state.business_name1.substring(1, 0).toUpperCase() : 'I'}
                </span>:null} */}
                            <span className="fmaroon" id="business_list_header">
                              {this.state.business_name1}
                            </span>
                          </h4>

                          {/* <div className="dropdown d-inline-block">
                            <div
                              style={this.state.business_List.length == 1 ? {display: 'none'} : undefined}
                              data-toggle="dropdown">
                              <i className="fas fa-angle-down f_sz20" />
                            </div>
                            
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right scrollbar_style">
                              <div className="dropdown-item">
                                <div className="allheader_profile_drplist text-center">
                                  {this.state.business_List.map((business, index) => {
                                    return business.payment_status === 'plan_cancel' ? undefined : (
                                      <>
                                        <div
                                          className="allheader_profile_drpitem"
                                          onClick={() => {
                                            business.payment_status === 'plan_cancel'
                                              ? undefined
                                              : this.onChangebusiness({business});
                                          }}>
                                          <a>
                                            {business.payment_status == 'payment_failed' ? (
                                              <span className="fred">Payment Failed Workspace</span>
                                            ) : business.business_name.length === 0 ? (
                                              <span class="fred">Incomplete Workspace</span>
                                            ) : (
                                              business.business_name
                                            )}
                                            <br />
                                            <span
                                              style={
                                                business.payment_status === 'plan_cancel'
                                                  ? {display: 'block'}
                                                  : {display: 'none'}
                                              }
                                              class="f_sz13 fred">
                                              Cancelled
                                            </span>
                                            <span
                                              style={
                                                business.user_id === this.state.user_id ||
                                                business.payment_status === 'plan_cancel'
                                                  ? {display: 'none'}
                                                  : {display: 'block'}
                                              }
                                              class="f_sz13 forange">
                                              Assigned
                                            </span>
                                          </a>
                                        </div>
                                        <div className="dropdown-divider" />
                                      </>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                          <a
                            href={
                              this.state?.businessprofileplandetails?.plan_name === 'Trial'
                                ? undefined
                                : '/create-profile'
                            }
                            className={
                              this.state?.businessprofileplandetails?.plan_name === 'Trial' ? 'isdisabled' : undefined
                            }>
                            <div className="header_wrkspace ml-3">
                              <i className="fas fa-plus-circle f_sz20 fgreen4"></i>
                            </div>
                          </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.row */}
              </div>
              {/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <div className="content">
              <div className="container-fluid">
                <div className="row mt-3 position-relative">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                    <div className="card flex-lg-row acctstngs_profstngs_card profilesettings_card shadow-none">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2" onClick={() => this.hide_emoji()}>
                        <div className="card-header p-0 border-bottom-0">
                          <ul className="nav nav-tabs" id="custom-tabs-profilestngs-tab" role="tablist">
                            <li className="nav-item">
                              <a
                                className="nav-link active joyride_general nav_links_prof"
                                id="custom-tabs-general-tab"
                                data-toggle="pill"
                                href="#custom-tabs-general"
                                role="tab"
                                aria-controls="custom-tabs-general"
                                aria-selected="false">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <i className="fas fa-sliders-h" />
                                </span>
                                <span className="d-none d-md-inline-block">General</span>
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link nav_links_prof"
                                id="custom-tabs-autoresponse-tab"
                                data-toggle="pill"
                                href="#custom-tabs-autoresponse"
                                role="tab"
                                aria-controls="custom-tabs-autoresponse"
                                aria-selected="false">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <span className="usercircleimg_sm1">
                                    <img
                                      src={redtie_bot1}
                                      className="redtiebotframe"
                                      style={{
                                        border: '0px',
                                      }}
                                      border={0}
                                    />
                                  </span>
                                </span>
                                <span className="d-none d-md-inline-block">R-Bot Responses</span>
                              </a>
                            </li>
                            <li className="nav-item WorkspaceSettingsWorkflow">
                              <a
                                className="nav-link"
                                id="custom-tabs-workflow-tab"
                                data-toggle="pill"
                                href="#custom-tabs-workflow"
                                role="tab"
                                aria-controls="custom-tabs-workflow"
                                aria-selected="true">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <i className="fas fa-project-diagram" />
                                </span>
                                <span className="d-none d-md-none d-lg-inline-block">Workflow</span>
                              </a>
                            </li>

                            <li className="nav-item">
                              <a
                                onClick={() => this.qrcode_listclick()}
                                className="nav-link nav_links_prof"
                                id="custom-tabs-integrations-tab"
                                data-toggle="pill"
                                href="#custom-tabs-integrations"
                                role="tab"
                                aria-controls="custom-tabs-integrations"
                                aria-selected="true">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <i className="fas fa-draw-polygon" />
                                </span>
                                <span className="d-none d-md-inline-block">Integrations</span>
                              </a>
                            </li>
                            <li className="nav-item MessgaePack">
                              <a
                                className="nav-link nav_links_prof"
                                id="custom-tabs-packs-tab"
                                data-toggle="pill"
                                href="#custom-tabs-packs"
                                role="tab"
                                aria-controls="custom-tabs-packs"
                                aria-selected="true">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <i className="fas fa-boxes" />
                                </span>
                                <span className="d-none d-md-inline-block">Message Packs</span>
                              </a>
                            </li>
                            <li className="nav-item WorkspaceSettingsTemplate">
                              <a
                                onClick={() => {
                                  this.templates_listclick();
                                }}
                                className="nav-link nav_links_prof"
                                id="custom-tabs-templates-tab"
                                data-toggle="pill"
                                href="#custom-tabs-templates"
                                role="tab"
                                aria-controls="custom-tabs-templates"
                                aria-selected="false">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <i className="fas fa-file-alt" />
                                </span>
                                <span className="d-none d-md-none d-lg-inline-block">Templates</span>
                              </a>
                            </li>
                            <li className="nav-item WorkspaceSettingsId">
                              <a
                                className="nav-link nav_links_prof"
                                id="custom-tabs-workspace_id-tab"
                                data-toggle="pill"
                                href="#custom-tabs-workspace_id"
                                role="tab"
                                aria-controls="custom-tabs-workspace_id"
                                aria-selected="false">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <i className="fas fa-key" />
                                </span>
                                <span className="d-none d-md-none d-lg-inline-block">Workspace Id</span>
                              </a>
                            </li>
                            <li className="nav-item d-none d-md-none d-lg-inline-block">
                              <a className="nav-link nav_links_prof">
                                <span className="d-none d-md-none d-lg-inline-block font-weight-semibold txtdecoration_underline">
                                  Tokens
                                </span>
                              </a>
                            </li>
                            <li className="nav-item ml-0 ml-lg-4">
                              <a
                                className="nav-link nav_links_prof"
                                id="custom-tabs-nft-tab"
                                data-toggle="pill"
                                href="#custom-tabs-nft"
                                role="tab"
                                aria-controls="custom-tabs-nft"
                                aria-selected="false">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <img src={nft_img} className="psall_img psnft_img postop_2up" />
                                </span>
                                <span className="d-none d-md-none d-lg-inline-block">Non Fungible</span>
                              </a>
                            </li>
                            <li className="nav-item ml-0 ml-lg-4">
                              <a
                                className="nav-link nav_links_prof"
                                id="custom-tabs-ft-tab"
                                data-toggle="pill"
                                href="#custom-tabs-ft"
                                role="tab"
                                aria-controls="custom-tabs-ft"
                                aria-selected="false">
                                <span className="d-block d-md-inline-block mr-0 mr-md-2">
                                  <img src={ft_img} className="psall_img psft_img postop_2up" />
                                </span>
                                <span className="d-none d-md-none d-lg-inline-block">Fungible</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-10">
                        <div className="card-body px-0 py-3 py-lg-0">
                          <div className="tab-content" id="custom-tabs-profilestngs-tabContent">
                            <div
                              className="tab-pane fade active show nav_links_prof_tabs"
                              id="custom-tabs-general"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-general-tab">
                              <div className="card w-100 shadow-none integrations_card">
                                <div className="card-header px-2 py-2 border-bottom-0">
                                  {/* START TABS DIV */}
                                  <div className="tabbable-responsive">
                                    <div className="tabbable">
                                      <ul
                                        className="nav nav-tabs border-bottom"
                                        id="custom-tabs-profgeneralsettings-tab"
                                        role="tablist">
                                        <li class="nav-item GeneralInfo">
                                          <a
                                            class="nav-link active joyride_info"
                                            id="custom-tabs-psinfodtls-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psinfodtls"
                                            role="tab"
                                            aria-controls="custom-tabs-psinfodtls"
                                            aria-selected="true">
                                            <span class="d-inline-block">Info</span>
                                          </a>
                                        </li>
                                        <li className="nav-item joyride_archive GeneralArchiveMode">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-psarchive-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psarchive"
                                            role="tab"
                                            aria-controls="custom-tabs-psarchive"
                                            aria-selected="false">
                                            <span className="d-inline-block">Archive Mode</span>
                                          </a>
                                        </li>
                                        <li className="nav-item GeneralDailyEmailDump">
                                          <a
                                            className="nav-link "
                                            id="custom-tabs-psdailyemaildump-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psdailyemaildump"
                                            role="tab"
                                            aria-controls="custom-tabs-psdailyemaildump"
                                            aria-selected="false">
                                            <span className="d-inline-block">Daily Email Dump</span>
                                          </a>
                                        </li>

                                        <li className="nav-item GeneralTags">
                                          <a
                                            className="nav-link joyride_tags"
                                            id="custom-tabs-pstags-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-pstags"
                                            role="tab"
                                            aria-controls="custom-tabs-pstags"
                                            aria-selected="false">
                                            <span className="d-inline-block">Tags</span>
                                          </a>
                                        </li>
                                        <li className="nav-item GeneralSummaryAlert">
                                          <a
                                            className="nav-link joyride_summary"
                                            id="custom-tabs-pssummaryalert-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-pssummaryalert"
                                            role="tab"
                                            aria-controls="custom-tabs-pssummaryalert"
                                            aria-selected="true">
                                            <span className="d-inline-block">Summary Alert</span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>

                                <div className="card-body px-0 ">
                                  <div className="tab-content" id="custom-tabs-profgeneralsettings-tabContent">
                                    <div
                                      className="tab-pane fade active show"
                                      id="custom-tabs-psinfodtls"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psinfodtls-tab">
                                      
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="all_contentcntr_1024">
                                            <div className="row">
                                              <div className="col-lg-4">
                                                <div className="w-100 d-inline-block account_panel pl-0 pb-5 pdngtop_12 mt-5">
                                                  <div className="ctsprofpiccntr">
                                                    <div className="ctsaddprofpic">
                                                      {/* <span className="usercircle_xl">A</span> */}
                                                      {this.state.prfImag != '' ? (
                                                        <span>
                                                          <img src={this.state.prfImag} border={0} />
                                                        </span>
                                                      ) : (
                                                        <span className="usercircle_xl">
                                                          {this.state?.business_info_name
                                                            ?.substring(1, 0)
                                                            ?.toUpperCase()}
                                                        </span>
                                                      )}
                                                      <div className="s_profileupld s_profileupld_top clearfix">
                                                        <label className="btn-bs-file btn btn-black">
                                                          {/*Upload*/}
                                                          <i className="fas fa-camera" />
                                                          <input
                                                            type="file"
                                                            name="file"
                                                            accept="image/x-png,image/gif,image/jpeg"
                                                            onChange={this.onFileChangeHandler}
                                                          />
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {/* /input-group */}
                                              </div>
                                              {/* /.col-lg-6 */}
                                              <div className="col-lg-8">
                                                <div className="form-horizontal formbiglbl">
                                                  <div className={this.state.AtoViceRescls}>
                                                    {this.state.AtoViceResMsg}
                                                  </div>
                                                  <div className="card-body">
                                                    <div className="form-group row mt-3 mb-4 mb-md-5">
                                                      <label className="col-12 col-sm-12 col-md-4 col-lg-4 col-form-label pdngtop_10">
                                                        Phone Number
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                        <h5 className="mt-0 mb-0">
                                                          <span id="business_number_cpy">
                                                            {this.state.business_info_phone}
                                                          </span>
                                                          <span
                                                            className="ml-3 crsr_pntr"
                                                            onClick={() => this.copyToClipboard('business_number_cpy')}>
                                                            <i
                                                              className="far fa-copy fmaroon f_sz16"
                                                              data-toggle="tooltip"
                                                              data-placement="bottom"
                                                              title
                                                              data-original-title="Copy"
                                                            />
                                                          </span>
                                                          <span class="ml-3">
                                                            <span
                                                              class={
                                                                'crsr_pntr fmaroon f_sz14 picknumber_clk'
                                                                // (this.state.business_info_array?.plivo_rental_days !=
                                                                //   null &&
                                                                //   this.state.business_info_array?.plivo_rental_days >=
                                                                //     30 &&
                                                                //   this.state.number_click === true) ||
                                                                // (this.state.business_info_array?.business?.number_change
                                                                //   ?.is_spam_flagged === true &&
                                                                //   this.state.number_click === true)
                                                                //   ? 'crsr_pntr fmaroon f_sz14 picknumber_clk'
                                                                //   : 'crsr_pntr f_sz14 isdisabled'
                                                              }>
                                                              Pick a new number
                                                            </span>
                                                          </span>
                                                        </h5>
                                                        <small className="text-gray d-inline-block">
                                                          This is your primary contact number to send and receive
                                                          messages.
                                                        </small>
                                                      </div>
                                                    </div>

                                                    <div className="picknewnumber_div" style={{ display: 'none' }}>
                                                      <div className="all_contentflex_div p-3 mb-5 bx_shadow_sm position-relative">
                                                        <div className="picknewnumber_close">
                                                          <i className="fas fa-times mr-2" />
                                                        </div>
                                                        <div className="form-group row w-100 mb-4 mt-2 p-2">
                                                          {/* <label className="col-12 col-sm-12 col-md-3 col-form-label mt-1">
                                                            Choose
                                                          </label> */}
                                                          <div className="col-12 col-sm-12 col-md-12 px-0">
                                                            <div className="d-flex flex-row flex-wrap icheck_lbl justify-content-center">
                                                              <div className="icheck-darkgrey d-inline p-2 mr-3">
                                                                <input
                                                                  onClick={this.areacode}
                                                                  type="radio"
                                                                  name="choosephonetype"
                                                                  id="chooseareacode1"
                                                                  defaultValue={1}
                                                                />
                                                                <label htmlFor="chooseareacode1">Area Code</label>
                                                              </div>
                                                              <div className="icheck-darkgrey d-inline p-2">
                                                                <input
                                                                  onClick={this.locationsearch}
                                                                  type="radio"
                                                                  name="choosephonetype"
                                                                  id="chooselocation1"
                                                                  defaultValue={2}
                                                                />
                                                                <label htmlFor="chooselocation1">Location</label>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div
                                                          className="phonepicknumberopt w-100"
                                                          id="numbersearch"
                                                          style={{ display: 'none' }}>
                                                          {/* {errors.map((error) => (
                                                            <div
                                                              id="error"
                                                              className="alert alert-danger text-center"
                                                              key={error}>
                                                              {error}
                                                            </div>
                                                          ))} */}
                                                          <div className="form-group row mb-4 p-2">
                                                            <label className="col-12 col-sm-12 col-md-3 col-form-label mt-1">
                                                              Area Code
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-9 px-0 mt-2">
                                                              <div className="w-100 d-flex flex-row flex-wrap">
                                                                <div className="col-12 col-sm-12 col-md-12 mb-3">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter a prefix"
                                                                    value={this.state.prefix}
                                                                    onChange={this.onChangeprefix}
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className="choosephonenumberlist_div w-100"
                                                          id="plivonumbers"
                                                          style={{ display: 'none' }}>
                                                          <div className="form-group row mb-4 p-2">
                                                            <label className="col-12 col-sm-12 col-md-12 col-form-label">
                                                              Pick a New Number
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-12 px-0">
                                                              <div className="d-flex flex-row flex-wrap icheck_lbl">
                                                                {this.state.plivolist.map((pnumber, index) => {
                                                                  return (
                                                                    <div className="col-6 col-sm-6 col-md-4 col-lg-3">
                                                                      <div className="icheck-darkgrey d-inline-block py-2">
                                                                        <input
                                                                          onClick={() =>
                                                                            this.setState({ plivonumber: pnumber.number })
                                                                          }
                                                                          type="radio"
                                                                          value={pnumber.number}
                                                                          name="chno"
                                                                          id={index}
                                                                        />
                                                                        <label key={pnumber.number} htmlFor={index}>
                                                                          {pnumber.number}
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                  );
                                                                })}
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="text-center w-100 mt-4"
                                                            style={{
                                                              display:
                                                                this.state.plivolist?.length !== 1 ? 'block' : 'none',
                                                            }}>
                                                            <span
                                                              onClick={this.loadmore}
                                                              className="fmaroon crsr_pntr font-weight-semibold">
                                                              Load More
                                                            </span>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className="phonepicknumberopt w-100"
                                                          id="regionsearch"
                                                          style={{ display: 'none' }}>
                                                          {/* {errors.map((error) => (
                                                            <div
                                                              id="error"
                                                              className="alert alert-danger text-center"
                                                              key={error}>
                                                              {error}
                                                            </div>
                                                          ))} */}
                                                          <div className="form-group row mb-4 p-2">
                                                            <label className="col-12 col-sm-12 col-md-3 col-form-label mt-1">
                                                              Location
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-8 px-0 mt-2">
                                                              <div className="w-100 d-flex flex-row flex-wrap">
                                                                <div className="col-12 col-sm-12 col-md-12 mb-3">
                                                                  <div className="select_style">
                                                                    <select
                                                                      onChange={this.onChangeregion}
                                                                      className="form-control">
                                                                      <option value=",US">--Random--</option>
                                                                      <option
                                                                        style={{ backgroundColor: '#cccccc' }}
                                                                        disabled>
                                                                        United States
                                                                      </option>
                                                                      <option value="Alabama,US">Alabama</option>
                                                                      <option value="Alaska,US">Alaska</option>
                                                                      <option value="Arizona,US">Arizona</option>
                                                                      <option value="Arkansas,US">Arkansas</option>
                                                                      <option value="California,US">California</option>
                                                                      <option value="Colorado,US">Colorado</option>
                                                                      <option value="Connecticut,US">
                                                                        Connecticut
                                                                      </option>
                                                                      <option value="Delaware,US">Delaware</option>
                                                                      <option value="Florida,US">Florida</option>
                                                                      <option value="Georgia,US">Georgia</option>
                                                                      <option value="Hawaii,US">Hawaii</option>
                                                                      <option value="Idaho,US">Idaho</option>
                                                                      <option value="Illinois,US">Illinois</option>
                                                                      <option value="Indiana,US">Indiana</option>
                                                                      <option value="Iowa,US">Iowa</option>
                                                                      <option value="Kansas,US">Kansas</option>
                                                                      <option value="Kentucky,US">Kentucky</option>
                                                                      <option value="Louisiana,US">Louisiana</option>
                                                                      <option value="Maine,US">Maine</option>
                                                                      <option value="Maryland,US">Maryland</option>
                                                                      <option value="Massachusetts,US">
                                                                        Massachusetts
                                                                      </option>
                                                                      <option value="Michigan,US">Michigan</option>
                                                                      <option value="Minnesota,US">Minnesota</option>
                                                                      <option value="Mississippi,US">
                                                                        Mississippi
                                                                      </option>
                                                                      <option value="Missouri,US">Missouri</option>
                                                                      <option value="Montana,US">Montana</option>
                                                                      <option value="Nebraska,US">Nebraska</option>
                                                                      <option value="Nevada,US">Nevada</option>
                                                                      <option value="New Hampshire,US">
                                                                        New Hampshire
                                                                      </option>
                                                                      <option value="New Jersey,US">New Jersey</option>
                                                                      <option value="New Mexico,US">New Mexico</option>
                                                                      <option value="New York,US">New York</option>
                                                                      <option value="North Carolina,US">
                                                                        North Carolina
                                                                      </option>
                                                                      <option value="North Dakota,US">
                                                                        North Dakota
                                                                      </option>
                                                                      <option value="Ohio,US">Ohio</option>
                                                                      <option value="Oklahoma,US">Oklahoma</option>
                                                                      <option value="Oregon,US">Oregon</option>
                                                                      <option value="Pennsylvania,US">
                                                                        Pennsylvania
                                                                      </option>
                                                                      <option value="Rhode Island,US">
                                                                        Rhode Island
                                                                      </option>
                                                                      <option value="South Carolina,US">
                                                                        South Carolina
                                                                      </option>
                                                                      <option value="South Dakota,US">
                                                                        South Dakota
                                                                      </option>
                                                                      <option value="Tennessee,US">Tennessee</option>
                                                                      <option value="Texas,US">Texas</option>
                                                                      <option value="Utah,US">Utah</option>
                                                                      <option value="Vermont,US">Vermont</option>
                                                                      <option value="Virginia,US">Virginia</option>
                                                                      <option value="Washington,US">Washington</option>
                                                                      <option value="West Virginia,US">
                                                                        West Virginia
                                                                      </option>
                                                                      <option value="Wisconsin,US">Wisconsin</option>
                                                                      <option value="Wyoming,US">Wyoming</option>
                                                                      <option
                                                                        style={{ backgroundColor: '#cccccc' }}
                                                                        disabled>
                                                                        Canada
                                                                      </option>

                                                                      <option value="Alberta,CA">Alberta</option>
                                                                      <option value="British Columbia,CA">
                                                                        British Columbia
                                                                      </option>
                                                                      <option value="Manitoba,CA">Manitoba</option>
                                                                      <option value="New Brunswick,CA">
                                                                        New Brunswick
                                                                      </option>
                                                                      <option value="New Foundland,CA">
                                                                        New Foundland
                                                                      </option>
                                                                      <option value="Northwest Territories,CA">
                                                                        Northwest Territories
                                                                      </option>
                                                                      <option value="Nova Scotia,CA">
                                                                        Nova Scotia
                                                                      </option>
                                                                      <option value="Ontario,CA">Ontario</option>
                                                                      <option value="Price Edward Island,CA">
                                                                        Price Edward Island
                                                                      </option>
                                                                      <option value="Quebec,CA">Quebec</option>
                                                                      <option value="Saskatchewan,CA">
                                                                        Saskatchewan
                                                                      </option>
                                                                      <option value="Yukon Territories,CA">
                                                                        Yukon Territories
                                                                      </option>
                                                                    </select>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div
                                                          className="choosephonenumberlist_div w-100"
                                                          id="plivoregionnumbers"
                                                          style={{ display: 'none' }}>
                                                          <div className="form-group row mb-4 p-2">
                                                            <label className="col-12 col-sm-12 col-md-12 col-form-label">
                                                              Pick a New Number
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-12 px-0">
                                                              <div className="d-flex flex-row flex-wrap icheck_lbl">
                                                                {this.state.rplivolist?.map((pnumber, index) => {
                                                                  return (
                                                                    <div className="col-6 col-sm-6 col-md-4 col-lg-3">
                                                                      <div className="icheck-darkgrey d-inline-block py-2">
                                                                        <input
                                                                          onClick={() =>
                                                                            this.setState({ plivonumber: pnumber.number })
                                                                          }
                                                                          type="radio"
                                                                          value={pnumber.number}
                                                                          name="chno"
                                                                          id={'r' + index}
                                                                        />
                                                                        <label
                                                                          key={pnumber.number}
                                                                          htmlFor={'r' + index}>
                                                                          {pnumber.number}
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                  );
                                                                })}
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="text-center w-100 mt-4"
                                                            style={{
                                                              display:
                                                                this.state.rplivolist?.length !== 1 ? 'block' : 'none',
                                                            }}>
                                                            <span
                                                              onClick={this.regloadmore}
                                                              className="fmaroon crsr_pntr font-weight-semibold">
                                                              Load More
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div className="choosephonenumberlist_div w-100 mt-2">
                                                          <div className="text-center mb-2">
                                                            <a
                                                              onClick={(e) =>
                                                                this.state.isLoading ? null : this.onsubmit()
                                                              }
                                                              disabled={this.state.isLoading}
                                                              className="btn btn-black crsr_pntr m-2 btnpdng_sm picknewnumber_done">
                                                              {this.state.isLoading ? 'Processing...' : 'Done'}
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="form-group row mt-3 mb-4">
                                                      <label className="col-12 col-sm-12 col-md-4 col-lg-4 col-form-label pdngtop_10">
                                                        Workspace Name
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                        <input
                                                          onBlur={() => this.setState({ business_info_name_blur: false })}
                                                          className="form-control"
                                                          placeholder="Enter the Workspace Name"
                                                          value={this.state.business_info_name}
                                                          onChange={this.onchangebusiness_info_name}
                                                          maxLength="32"
                                                        />
                                                        <div className="f_sz12 fred mt-1 text-left text-md-right">
                                                          {this.state.business_info_name_blur == false
                                                            ? '32 characters max'
                                                            : this.state.chars_left_profilename + ' characters left'}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="form-group row mt-4 mt-md-5 mb-4">
                                                      <label className="col-12 col-sm-12 col-md-4 col-lg-4 col-form-label pdngtop_10">
                                                        Description
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                        <textarea
                                                          onBlur={() =>
                                                            this.setState({ business_info_details_blur: false })
                                                          }
                                                          className="form-control textarea_hgt100 txtarea_resizenone"
                                                          placeholder="Write something about your Workspace"
                                                          value={this.state.business_info_details}
                                                          onChange={this.onchangebusiness_info_details}
                                                          maxLength="200"
                                                        />
                                                        <div className="f_sz12 fred mt-1 text-left text-md-right">
                                                          {this.state.business_info_details_blur == false
                                                            ? '200 characters max'
                                                            : this.state.chars_left_description + ' characters left'}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="form-group w-100 mt-4 mb-2 text-center">
                                                      <a
                                                        onClick={this.business_update}
                                                        className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                                        Save
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                                {/* /input-group */}
                                              </div>
                                              {/* /.col-lg-6 */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* /input-group */}

                                      {/* <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div class="row">
                                            <div className="all_contentcntr_1024">
                                              <div className="col-lg-4">
                                                <div className="w-100 d-inline-block account_panel pl-0 pb-5 pdngtop_12 mt-5">
                                                  <div className="ctsprofpiccntr">
                                                    <div className="ctsaddprofpic">
                                                      <span className="usercircle_xl">A</span>
                                                      <span style={{display: 'none'}}>
                                                        <img src="../dist/img/no_image.png" border={0} />
                                                      </span>
                                                      <div className="s_profileupld s_profileupld_top clearfix">
                                                        <label className="btn-bs-file btn btn-black">
                                                          
                                                          <i className="fas fa-camera" />
                                                          <input type="file" />
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                
                                              </div>
                                              <div className="col-lg-8">
                                                <div className="form-horizontal formbiglbl">
                                                  <div className={this.state.AtoViceRescls}>
                                                    {this.state.AtoViceResMsg}
                                                  </div>
                                                  <div className="card-body">
                                                    <div className="form-group row mt-3 mb-4 mb-md-5">
                                                      <label className="col-12 col-sm-12 col-md-4 col-lg-4 col-form-label pdngtop_10">
                                                        Phone Number
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                        <h5 className="forange mt-0 mb-0">
                                                          {this.state.business_info_phone}
                                                        </h5>
                                                        <small className="text-gray d-inline-block">
                                                          This is your primary contact number to send and receive
                                                          messages.
                                                        </small>
                                                      </div>
                                                    </div>
                                                    <div className="form-group row mt-3 mb-4">
                                                      <label className="col-12 col-sm-12 col-md-4 col-lg-4 col-form-label pdngtop_10">
                                                        Profile Name
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                        <input
                                                          onBlur={() => this.setState({business_info_name_blur: false})}
                                                          className="form-control"
                                                          placeholder="Enter the Profile Name"
                                                          value={this.state.business_info_name}
                                                          onChange={this.onchangebusiness_info_name}
                                                          maxLength="32"
                                                        />
                                                        <div className="f_sz12 fred mt-1 text-left text-md-right">
                                                          {this.state.business_info_name_blur == false
                                                            ? '32 characters max'
                                                            : this.state.chars_left_profilename + ' characters left'}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="form-group row mt-4 mt-md-5 mb-4">
                                                      <label className="col-12 col-sm-12 col-md-4 col-lg-4 col-form-label pdngtop_10">
                                                        Description
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                        <textarea
                                                          onBlur={() =>
                                                            this.setState({business_info_details_blur: false})
                                                          }
                                                          className="form-control textarea_hgt100 txtarea_resizenone"
                                                          placeholder="Write something about your Profile"
                                                          value={this.state.business_info_details}
                                                          onChange={this.onchangebusiness_info_details}
                                                          maxLength="200"
                                                        />
                                                        <div className="f_sz12 fred mt-1 text-left text-md-right">
                                                          {this.state.business_info_details_blur == false
                                                            ? '200 characters max'
                                                            : this.state.chars_left_description + ' characters left'}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="form-group w-100 mt-4 mb-2 text-center">
                                                      <a
                                                        onClick={this.business_update}
                                                        className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                                        Save
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div> */}
                                    </div>

                                    <div
                                      className="tab-pane fade w-100 "
                                      id="custom-tabs-psarchive"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psarchive-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="all_contentcntr_700">
                                            <div className="form-horizontal formbiglbl">
                                              <div className="card-body">
                                                {this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                  'Trial' ||
                                                  this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                  'Free' ? (
                                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                                    <div className="f_sz16 w-100 d-inline-block pb-2">
                                                      To utilize{' '}
                                                      <span className="fmaroon font-weight-semibold">Archive Mode</span>
                                                      , please upgrade.
                                                    </div>
                                                    {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    <a
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      onClick={() =>
                                                        this.upgradeWorkspace(
                                                          '/create-profile?bid=' +
                                                          this.state.business_info_array?.business?._id,
                                                        )
                                                      }>
                                                      Upgrade
                                                    </a>
                                                  </div>
                                                ) : (
                                                  <div>
                                                    <div>
                                                      <div className="form-group row mt-3 mb-4">
                                                        <label className="col-12 col-sm-12 col-md-5 col-lg-5 col-form-label">
                                                          Archive Mode
                                                        </label>
                                                        <div className="col-12 col-sm-12 col-md-7 col-lg-7 pt-1">
                                                          <div className="float-left switchbtn_wdth">
                                                            <div className="custom-control custom-switch">
                                                              <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="archivemode"
                                                                onClick={this.archiveMode}
                                                              />
                                                              <label
                                                                className="custom-control-label"
                                                                htmlFor="archivemode"
                                                              />
                                                            </div>
                                                          </div>
                                                          <div className="d-inline-block mt-1">
                                                            <span
                                                              className="fmaroon f_sz13 archivehistory_tgl crsr_pntr"
                                                              onClick={this.archivehistory_tgl}>
                                                              View History
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="archivehistory_tgldiv" style={{ display: 'none' }}>
                                                        <div className="all_contentcntr_700">
                                                          <div className="all_contentflex_div">
                                                            <div className="card w-100 mt-2 mb-5">
                                                              <div className="card-header">
                                                                <h5 className="fmaroon f_sz15">History</h5>
                                                              </div>
                                                              <div className="card-body p-0">
                                                                <div className="table-responsive">
                                                                  <table
                                                                    className="table table-hover tbl_valignmdle tbl_archivehistory border-bottom"
                                                                    id="archivehistory_tbl"
                                                                    cellPadding={0}
                                                                    cellSpacing={0}
                                                                    style={{ width: '100%' }}>
                                                                    <thead>
                                                                      <tr>
                                                                        <th>Date</th>
                                                                        <th>Time</th>
                                                                        <th>Status</th>
                                                                      </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                      {this.state.archiveHstry_detail.map(
                                                                        (archiveHstry, index) => {
                                                                          var stsMod =
                                                                            archiveHstry.archive_status?.toUpperCase();
                                                                          return (
                                                                            <tr>
                                                                              <td>
                                                                                {moment(
                                                                                  archiveHstry.updated_date,
                                                                                ).format('MM/DD/YYYY')}
                                                                              </td>
                                                                              <td>
                                                                                {moment(
                                                                                  archiveHstry.updated_date,
                                                                                ).format('hh:mm A')}
                                                                              </td>
                                                                              <td>
                                                                                {archiveHstry?.archive_status ==
                                                                                  'on' ? (
                                                                                  <span className="font-weight-bold fgreen4">
                                                                                    {stsMod}
                                                                                  </span>
                                                                                ) : (
                                                                                  <span className="font-weight-bold fred">
                                                                                    {stsMod}
                                                                                  </span>
                                                                                )}
                                                                              </td>
                                                                            </tr>
                                                                          );
                                                                        },
                                                                      )}
                                                                    </tbody>
                                                                  </table>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div>
                                                      <div className="form-group row mt-3 mb-4">
                                                        <label className="col-12 col-sm-12 col-md-5 col-lg-5 col-form-label">
                                                          View Archived
                                                        </label>
                                                        <div className="col-12 col-sm-12 col-md-7 col-lg-7 pt-1">
                                                          <div className="float-left switchbtn_wdth">
                                                            <div className="custom-control custom-switch">
                                                              <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="archivemessages"
                                                                onClick={this.ViewArchiveOnOff}
                                                                disabled={this.state.VwArchiewDisbl}
                                                              />
                                                              <label
                                                                className="custom-control-label"
                                                                htmlFor="archivemessages"
                                                              />
                                                            </div>
                                                          </div>
                                                          <div className="d-inline-block mt-1">
                                                            <span
                                                              className="fmaroon f_sz13 viewarchive_tgl crsr_pntr"
                                                              style={{
                                                                display:
                                                                  this.state.dropDownValue.length !== 0
                                                                    ? 'block'
                                                                    : 'none',
                                                              }}>
                                                              View Archived Messages
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="card-body py-0">
                                            <div className="viewarchive_tgldiv" style={{ display: 'none' }}>
                                              <div className="all_contentflex_div">
                                                <h5 className="fmaroon f_sz15">Archived Messages</h5>
                                                <div className="card w-100 mt-2 mb-5">
                                                  <div className="card-header">
                                                    <div className="w-100 d-flex flex-row flex-wrap">
                                                      <div className="col-12 col-sm-6 col-md-6 col-lg-6 px-0">
                                                        <div className="icheck-darkgrey d-inline-block py-1">
                                                          {/* <input type="checkbox" class="all_archived" id="searchctall" />
                                                          <label htmlFor="searchctall">Select All</label> */}
                                                        </div>
                                                      </div>
                                                      <div className="col-12 col-sm-6 col-md-6 col-lg-6 px-0 text-left text-sm-right">
                                                        <div className="d-inline-block pt-2 mr-3">
                                                          <span className="fmaroon crsr_pntr viewarchivesearch_tgl">
                                                            <i className="fas fa-search mr-1 mt-1" />
                                                            Search
                                                          </span>
                                                        </div>
                                                        <div className="d-inline-block">
                                                          <div className="btn-group archivedwnldbtns_div">
                                                            <button
                                                              className="btn btn-sm btn-black-dark2 f_sz14 btnpdng_sm mb-2"
                                                              onClick={() =>
                                                                this.download_as_excel_all(
                                                                  this.state.scResultContactList,
                                                                )
                                                              }
                                                              type="button"
                                                              style={{
                                                                display: !this.state.show_download_all
                                                                  ? 'none'
                                                                  : 'block',
                                                              }}
                                                            // id="dropdownMenuButton"
                                                            // data-toggle="dropdown"
                                                            // aria-haspopup="true"
                                                            // aria-expanded="false"
                                                            >
                                                              Download all
                                                            </button>
                                                            {/* <div class="dropdown" style={{display: this.state.scResultContactList
                                                        ? "inline-block"
                                                        : "none"}}>
                                                                            <button className="btn btn-sm btn-black-dark2 f_sz14 btnpdng_sm dropdown-toggle" type="button" 
                                                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                              Download All
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                              <a className="dropdown-item" onClick={()=> this.downloadDiv("test.txt","downloadDIV","text/plain")} href="#">Text</a>
                                                                              <a className="dropdown-item" onClick={()=> this.downloadDiv("test.html","downloadDIV","text/html")} href="#">HTML</a>
                                                                              
                                                                            </div>
                                                                          </div> */}
                                                            {/* <button
                                                            onClick={()=> this.downloadDiv("test.html","downloadDIV","text/html")}
                                                              type="button"
                                                              className="btn btn-sm btn-black-dark2 f_sz14 btnpdng_sm">
                                                              Download
                                                            </button> */}
                                                            {/* <button
                                                            onClick={()=> this.downloadDiv("test.txt","downloadDIV","text/plain")}
                                                              type="button"
                                                              className="btn btn-sm btn-black-dark2 f_sz14 btnpdng_sm">
                                                              Download 
                                                            </button>
                                                            
                                                            
                                                            <button
                                                              type="button"
                                                              className="btn btn-sm btn-black pr-3 dropdown-toggle dropdown-icon f_sz14"
                                                              data-toggle="dropdown">
                                                              <span className="sr-only">Toggle Dropdown</span>
                                                              <div className="dropdown-menu" role="menu">
                                                                <a className="dropdown-item">JSON</a>
                                                                <a className="dropdown-item" >HTML</a>
                                                                <a className="dropdown-item">PDF</a>
                                                              </div>
                                                            </button> */}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="viewarchivesearch_tgldiv">
                                                      <div className="w-100 bx_shadow_sm p-2 mt-2">
                                                        <div className="all_contentcntr_800">
                                                          <div className="w-100 d-flex flex-row flex-wrap">
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                                              <div className="form-group row mt-3 mb-4">
                                                                <label className="col-12 col-sm-6 col-md-6 col-lg-5 col-form-label">
                                                                  Choose Date
                                                                </label>
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-7">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control text-center"
                                                                    id="default_dateval"
                                                                    defaultValue="Sep 15, 2021 - Sep 23, 2021"
                                                                  />
                                                                  <div
                                                                    className="dashchartfiltercalendardrpdwn_pos"
                                                                    style={{ display: 'none' }}>
                                                                    <div className="chartoverallcounts_div text-center">
                                                                      <div className="all_contentflex_div py-2">
                                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                          {/* {this.state.showNewMonth && ( */}
                                                                          <DateRangePicker
                                                                            selectionType="range"
                                                                            stateDefinitions={stateDefinitions}
                                                                            // dateStates={dateRanges}
                                                                            defaultState="available"
                                                                            value={this.state.value}
                                                                            onSelect={this.dateRangePickerSelect}
                                                                            numberOfCalendars={noOfMonths}
                                                                            initialMonth={initialMonths}
                                                                            initialYear={initialYear}
                                                                            minimumDate={minimumDate}
                                                                            maximumDate={maximumDate}
                                                                          />
                                                                          {/* )} */}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                                              <div className="form-group row mt-3 mb-4">
                                                                <label className="col-12 col-sm-6 col-md-6 col-lg-5 col-form-label">
                                                                  Contact
                                                                </label>
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-7">
                                                                  <span class="sendmessage_ctselectdropdwn">
                                                                    {/* <select
                                                                      class="selectpicker"
                                                                      multiple
                                                                      data-live-search="true"
                                                                      onChange={(e) =>
                                                                        this.onChangearchive_contacts(e)
                                                                      }>
                                                                      {this.state?.contacts_archive?.map(
                                                                        (contact, index) => {
                                                                          if (contact.text_archive !== 'false') {
                                                                            return (
                                                                              <option value={contact._id}>
                                                                                {contact.first_name == 'Guest'
                                                                                  ? contact.phone_number
                                                                                      .toString()
                                                                                      .substring(1)
                                                                                      .replace(/[^\dA-Z]/g, '')
                                                                                      .replace(
                                                                                        /(\d{3})(\d{3})(\d{4})/,
                                                                                        '($1) $2-$3',
                                                                                      )
                                                                                      .trim()
                                                                                  : contact.first_name +
                                                                                    ' ' +
                                                                                    contact.last_name}
                                                                              </option>
                                                                            );
                                                                          }
                                                                        },
                                                                      )}
                                                                    </select> */}
                                                                    <div className="multiSelect">
                                                                      <div className="chip" onClick={this.opnDrpwn}>
                                                                        {this.state.checked.length ? (
                                                                          <p className="chip-text">
                                                                            {this.state.checked[0].data_name}
                                                                          </p>
                                                                        ) : null}
                                                                      </div>
                                                                      <span onClick={this.opnDrpwn}>
                                                                        <input
                                                                          type="text"
                                                                          name="Search"
                                                                          placeholder="Select"
                                                                          className="input-box form-control"
                                                                          id="shwDrpwnclk"
                                                                          disabled
                                                                        />
                                                                      </span>
                                                                      <div className="search-result scrollbar_style1">
                                                                        <input
                                                                          type="text"
                                                                          name="Search"
                                                                          placeholder="Search"
                                                                          className="input-box form-control"
                                                                          onChange={(e) => this.searchFun(e)}
                                                                        />
                                                                        <div className="list-result">
                                                                          {this.returnList()}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </span>
                                                                  {/* <select multiple className="form-control f_sz14" >
                          {this.state?.contacts?.map((contact, index) => {
                                            if(contact.text_archive !== 'false'){
                                            return (
                                              <option>{contact.first_name == 'Guest' ? contact.phone_number
                                              .toString()
                                              .substring(1)
                                              .replace(/[^\dA-Z]/g, '')
                                              .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                              .trim() :
                                              contact.first_name + " " + contact.last_name
                                              }</option>                                            

                                              );
                                            }
                                            })}                          

                          </select> */}
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                                              <div className="form-group row mt-3 mb-4">
                                                                <label className="col-12 col-sm-6 col-md-6 col-lg-5 col-form-label">
                                                                  Keyword
                                                                </label>
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-7">
                                                                  <input
                                                                    type="text"
                                                                    onChange={(e) =>
                                                                      this.setState({
                                                                        archive_search_keyword: e.target.value,
                                                                      })
                                                                    }
                                                                    className="form-control text-center"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                                              <div className="form-group row mt-3 mb-4">
                                                                <label className="col-12 col-sm-6 col-md-6 col-lg-5 col-form-label">
                                                                  Choose Type
                                                                </label>
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-7">
                                                                  <div className="select_style">
                                                                    <select
                                                                      className="form-control f_sz14"
                                                                      onChange={(e) =>
                                                                        this.setState({
                                                                          archive_search_type: e.target.value,
                                                                        })
                                                                      }>
                                                                      <option value="all">All</option>
                                                                      <option value="sent">Sent</option>
                                                                      <option value="received">Received</option>
                                                                    </select>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="w-100 d-inline-block text-center mt-2 mb-3">
                                                              <a
                                                                className="btn btn-black crsr_pntr btnpdng_sm"
                                                                onClick={() => this.archive_search()}>
                                                                Search
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="card-body">
                                                    <div className="archivedmsgs_hgt scrollbar_style" id="downloadDIV">
                                                      {/* <div className="w-100 d-inline-block text-center mt-2 mb-3">
                                                              <a
                                                                className="btn btn-black crsr_pntr btnpdng_sm"
                                                                style={{display: this.state.scResultContactList ? "block": "none" }}
                                                                onClick={() => this.download_as_excel_all(this.state.scResultContactList)}>
                                                                Download all
                                                              </a>
                                                            </div> */}

                                                      {this.state.scResultContactList
                                                        ? this.scContactList(this.state.scResultContactList)
                                                        : null}
                                                      {/* <div className="searchdsply_item mb-4">
              <div className="w-100">
                <h5 className="mb-3 f_sz15 d-inline-block">
                  <div className="icheck-darkgrey d-inline-block py-1">
                    <input type="checkbox" id="searchct1" />
                    <label htmlFor="searchct1">Garrett Winters</label>
                  </div>
                </h5> 
                <div className="text-right d-inline-block float-right"><a href="#"><i className="fas fa-compress-arrows-alt f_sz17 mt-3 mr-2 fmaroon" data-toggle="tooltip" data-placement="bottom" title="Collapse" /></a></div>
              </div>
              <div className="searchdsply_content border p-2 mb-2">
                <ul className="products-list product-list-in-card pl-2 pr-2 contact_converselist w-100">
                  <li className="item unreadmsg">
                    <div className="product-img">
                      <span className="usercircle_md bg_teammember1">A</span>
                      
                    </div>
                    <div className="product-info">
                      <span className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0">
                        <span className="product-title fmaroon">Alexander Pierce <span className="ml-0 ml-sm-2 text-xs flightgrey3 d-inline-block">Archived on <i className="far fa-clock mr-1" />Oct 06, 2021 10:08am</span></span>
                        <span className="product-description">
                          <span>This is the Ble Media Solutions. Date has not yet confirmed. Please send photocopy of your residence address to send invitation.</span>
                        </span>
                      </span>
                    </div>
                  </li>
                  
                </ul>
              </div>
              <div className="searchdsply_content border p-2 mb-2">
                <ul className="products-list product-list-in-card pl-2 pr-2 contact_converselist w-100">
                  <li className="item unreadmsg">
                    <div className="product-img">
                      <span className="usercircle_md bg_teammember1">A</span>
                      
                    </div>
                    <div className="product-info">
                      <span className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  px-0">
                        <span className="product-title fmaroon">Alexander Pierce <span className="ml-0 ml-sm-2 text-xs flightgrey3 d-inline-block">Archived on <i className="far fa-clock mr-1" />Sep 06, 2021 10:08am</span></span>
                        <span className="product-description">
                          <span>Welcome Garrett! Good to see you. Hope you have enjoyed a lot. Love to hear your feedbacks regarding the party organised. Since you're a valuable customer,
                            we provide rewards for you to explore. <a href="javascript:void(0)" className="fmaroon viewsentmessagebtn_clk">https://redtie.co/attach_garrett</a>.</span>
                        </span>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div> */}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="tab-pane fade w-100 "
                                      id="custom-tabs-psdailyemaildump"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psdailyemaildump-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="all_contentcntr_700">
                                            <div className="form-horizontal formbiglbl">
                                              <div className="card-body">
                                                <div>
                                                  <div className="form-group row mt-3 mb-4">
                                                    <label className="col-12 col-sm-12 col-md-5 col-lg-5 col-form-label">
                                                      Daily Email Dump
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-7 col-lg-7 pt-1">
                                                      <div className="float-left switchbtn_wdth">
                                                        <div className="custom-control custom-switch">
                                                          <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="dailyemaildump"
                                                            onClick={() => this.email_dump_on_off('radio')}
                                                          />
                                                          <label
                                                            className="custom-control-label"
                                                            htmlFor="dailyemaildump"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="mt-3 w-100 d-inline-block">
                                                        <small className="text-gray d-inline-block">
                                                          When this is turned ON, we will send the emails of all
                                                          messages, sent and received, for the past 24 hours to the
                                                          email address you provide here and to the account holder.
                                                        </small>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mt-3 mb-4">
                                                    <label className="col-12 col-sm-12 col-md-5 col-lg-5 col-form-label">
                                                      Email Address{' '}
                                                      <span className="f_sz14 fmaroon crsr_pntr">(Optional)</span>
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-7 col-lg-7 pt-1">
                                                      {this.state.dump_emails?.map((value, index) => (
                                                        <FormGroup
                                                          inputChange={this.onChangeFormGroupInput.bind(this, index)}
                                                          buttonClick={
                                                            index === 0
                                                              ? this.onClickButtonAdder
                                                              : this.onClickFormGroupButton.bind(this, index)
                                                          }
                                                          buttonDisabled={
                                                            this.state.dump_members == 1
                                                              ? { display: 'none' }
                                                              : { display: 'block' }
                                                          }
                                                          buttonIcon={
                                                            index === 0
                                                              ? 'fas fa-plus-circle mt-2 f_sz17 crsr_pntr fmaroon'
                                                              : 'fas fa-trash-alt mt-2 f_sz17 crsr_pntr fmaroon'
                                                          }
                                                          value={value}
                                                          key={index}
                                                        />
                                                      ))}
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mt-5 mb-4">
                                                    <div className="text-center w-100">
                                                      <a
                                                        onClick={() => this.email_dump_on_off('button')}
                                                        className="btn btn-black crsr_pntr btnpdng_sm">
                                                        Save
                                                      </a>
                                                    </div>
                                                    <div className="text-center w-100 mt-1">
                                                      <span className="fmaroon f_sz13 dailyemaildumphistory_tgl crsr_pntr">
                                                        View History
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="dailyemaildumphistory_tgldiv"
                                                    style={{ display: 'none' }}>
                                                    <div className="all_contentcntr_700">
                                                      <div className="all_contentflex_div">
                                                        <div className="card w-100 mt-2 mb-5">
                                                          <div className="card-header">
                                                            <h5 className="fmaroon f_sz15">History</h5>
                                                          </div>
                                                          <div className="card-body p-0">
                                                            <div className="table-responsive">
                                                              <table
                                                                className="table table-hover tbl_valignmdle tbl_dailyemaildumphistory border-bottom"
                                                                id="dailyemaildumphistory_tbl"
                                                                cellPadding={0}
                                                                cellSpacing={0}
                                                                style={{ width: '100%' }}>
                                                                <thead>
                                                                  <tr>
                                                                    <th>Date</th>
                                                                    <th>Status</th>
                                                                    <th>Email</th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {this.state.emaildump_Hstry_detail?.map(
                                                                    (emaildump_Hstry, index) => {
                                                                      var stsMod =
                                                                        emaildump_Hstry.email_dump_status?.toUpperCase();
                                                                      return (
                                                                        <tr>
                                                                          <td>
                                                                            {moment(
                                                                              emaildump_Hstry.updated_date,
                                                                            ).format('MM/DD/YYYY')}
                                                                          </td>
                                                                          <td>
                                                                            {emaildump_Hstry?.email_dump_status ==
                                                                              'on' ? (
                                                                              <span className="font-weight-bold fgreen4">
                                                                                {stsMod}
                                                                              </span>
                                                                            ) : (
                                                                              <span className="font-weight-bold fred">
                                                                                {stsMod}
                                                                              </span>
                                                                            )}
                                                                          </td>
                                                                          <td>
                                                                            {emaildump_Hstry?.email_address?.length !==
                                                                              0
                                                                              ? emaildump_Hstry?.email_address?.toString()
                                                                              : '-'}
                                                                          </td>
                                                                        </tr>
                                                                      );
                                                                    },
                                                                  )}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className="tab-pane fade w-100 "
                                      id="custom-tabs-pstags"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-pstags-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          {this.state.tagList.length === 0 ? (
                                            <div className="tagcreate_div">
                                              <div className="card w-100 shadow-none">
                                                <div className="form-horizontal formbiglbl">
                                                  <div className="card-body">
                                                    <div className="form-group row mt-5 mb-4">
                                                      <h5 className="col-12 col-sm-12 text-center fmaroon">Tags</h5>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <div className="text-center mt-3">
                                                          <a onClick={this.tagcreate_clk}>
                                                            <span
                                                              className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm tagcreate_clk"
                                                              onClick={this.tagcreate_clk}>
                                                              Create Tag
                                                            </span>
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}

                                          {this.state.tagList.length > 0 ? (
                                            <div className="taglist_div">
                                              <div className="card w-100 shadow-none">
                                                <div className="card-header d-flex flex-row flex-wrap">
                                                  <div className="col-6 col-sm-6 col-md-6 pl-0">
                                                    <h5 className="fmaroon pt-2">Tags</h5>
                                                  </div>
                                                  <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                                    <a
                                                      className="btn btn-black crsr_pntr btn-sm mt-1 tagcreate_clk"
                                                      onClick={this.tagcreate_clk}>
                                                      Add New
                                                    </a>
                                                  </div>
                                                </div>
                                                <div className="card-body p-0">
                                                  <div className={this.state.TagMsgClss}>{this.state.TagMsg}</div>
                                                  <div className="table-responsive">
                                                    <table
                                                      className="table table-hover tbl_valignmdle tbl_inttags border-bottom"
                                                      id="inttags_tbl"
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      style={{ width: '100%' }}>
                                                      <thead>
                                                        <tr>
                                                          <th>Tags</th>
                                                          <th className="text-center">Set as Inbound</th>
                                                          <th className="text-center">Action</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {this.state.tagList.map((tglst_details, index) => {
                                                          return (
                                                            <tr>
                                                              <td>{tglst_details.tag_name}</td>
                                                              <td align="center">
                                                                <div className="icheck_lbl">
                                                                  <div className="icheck-darkgrey">
                                                                    <input
                                                                      type="radio"
                                                                      name="inboundtag"
                                                                      className="unChkBox"
                                                                      id={tglst_details._id}
                                                                      onClick={
                                                                        tglst_details.inbound_tag === 'true'
                                                                          ? this.UnChkInbndTg
                                                                          : this.chkInboundtag
                                                                      }
                                                                      checked={
                                                                        tglst_details.inbound_tag === 'true'
                                                                          ? true
                                                                          : false
                                                                      }
                                                                    />
                                                                    <label htmlFor={tglst_details._id}></label>
                                                                  </div>
                                                                </div>
                                                              </td>
                                                              <td align="center">
                                                                <div className="tbl_actionbtns">
                                                                  <a className="tagcreate_clk crsr_pntr">
                                                                    <i
                                                                      className="fas fa-pen"
                                                                      title="Edit"
                                                                      id={tglst_details._id}
                                                                      onClick={this.getTagname}
                                                                      data-txt={tglst_details.tag_name}
                                                                    />
                                                                  </a>
                                                                  <a>
                                                                    <i
                                                                      className="far fa-trash-alt"
                                                                      title="Delete"
                                                                      id={tglst_details._id}
                                                                      onClick={this.DelTag}
                                                                    />
                                                                  </a>
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          );
                                                        })}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div className="addtag_div" style={{ display: 'none' }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                                <h5>
                                                  <span
                                                    className="fmaroon mr-3 d-block d-sm-inline-block mb-2"
                                                    id="tagFrm">
                                                    Add Tag
                                                  </span>
                                                  <span className="addinttag_close mr-2 mt-1">
                                                    <i className="fas fa-times" onClick={this.addinttag_close} />
                                                  </span>
                                                </h5>
                                              </div>

                                              <div className="all_contentcntr_700">
                                                <div className="form-horizontal formbiglbl">
                                                  <div className="card-body">
                                                    <div className={this.state.TagMsgClss}>{this.state.TagMsg}</div>
                                                    {/*Element to be Looped*/}
                                                    {this.state.EditTagId != '' ? (
                                                      <div className="form-group row mt-3 mb-4">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter the New Tag"
                                                            onChange={this.EditTagOnChng}
                                                            value={this.state.EditTagName}
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <>
                                                        {this.state.tagTxtBox.map((value, index) => (
                                                          <TagTxtbxFormGroup
                                                            TaginputChange={this.onChangeTagInput.bind(this, index)}
                                                            TagDelonClick={this.onClickDelInput.bind(this, index)}
                                                            TagPlsclick={this.onClickTagTxtboxAdder.bind(this, index)}
                                                            TagbuttonDisabled={
                                                              index === 0 ? !isTagFormGroupDeletionAllowed : undefined
                                                            }
                                                            value={value}
                                                            key={index}
                                                            ttllngth={this.state.tagTxtBox.length}
                                                            rw={index}
                                                          />
                                                        ))}
                                                      </>
                                                    )}

                                                    {/*Element to be Looped*/}
                                                  </div>
                                                </div>
                                                <div className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3">
                                                  {this.state.EditTagId != '' ? (
                                                    <a
                                                      className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                      onClick={this.EditTagNameClick}
                                                      disable={this.state.EditTagBtnDsble}
                                                      id="tag_update">
                                                      Update
                                                    </a>
                                                  ) : (
                                                    <TagTxtbxAddButton TagSaveclick={this.onClickTagTxtboxSubmit} />
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade w-100 "
                                      id="custom-tabs-pssummaryalert"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-pssummaryalert-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="all_contentcntr_700">
                                            <div className="form-horizontal formbiglbl">
                                              <div className="card-body">
                                                {this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                  'Trial' ||
                                                  this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                  'Free' ? (
                                                  <div class="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                                    <div class="f_sz16 w-100 d-inline-block pb-2">
                                                      To get{' '}
                                                      <span class="fmaroon font-weight-semibold">Summary Alert</span>,
                                                      please upgrade.
                                                    </div>

                                                    {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <TrialPaymentButton
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      name="Upgrade"
                                                    /> */}
                                                    <a
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      onClick={() => this.upgradeWorkspace('/create-profile?bid=' + this.state.business_info_array?.business?._id)}
                                                    >Upgrade</a>
                                                  </div>
                                                ) : (
                                                  <div>
                                                    <div className="form-group row mt-4 mb-4">
                                                      <label className="col-12 col-sm-12 col-md-6 col-lg-5 col-form-label">
                                                        Summary Alert
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-6 col-lg-7 pt-1">
                                                        <div>
                                                          <div className="custom-control custom-switch">
                                                            <input
                                                              type="checkbox"
                                                              className="custom-control-input summaryalert_tgl"
                                                              id="summaryalert"
                                                              onClick={this.summaryalert_tgl}
                                                            />
                                                            <label
                                                              className="custom-control-label"
                                                              htmlFor="summaryalert"
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="summaryalert_tgldiv" style={{ display: 'none' }}>
                                                      <div className="card w-100 mt-2 mb-5">
                                                        <div className="card-body py-0">
                                                          <div className={this.state.SmryAlrtCls}>
                                                            {this.state.SmryAlrtMsg}
                                                          </div>
                                                          <div className="form-group row mt-2 mb-2">
                                                            <label className="col-12 col-sm-12 col-md-6 col-lg-5 col-form-label pdngtop_10">
                                                              <span className="f_sz15">Receive Alert</span>
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
                                                              <div className="all_contentflex_div icheck_lbl">
                                                                <div className="col-6 col-sm-4 col-md-4 col-lg-4 pl-0">
                                                                  <div className="icheck-darkgrey d-inline-block py-2">
                                                                    <input
                                                                      type="radio"
                                                                      name="sumryalert"
                                                                      id="sumrydaily"
                                                                      checked={
                                                                        this.state.TmRcvdalrt === 'day' ? true : false
                                                                      }
                                                                      onClick={this.receiveAlrtChk}
                                                                      data-id="day"
                                                                    />
                                                                    <label htmlFor="sumrydaily">Daily</label>
                                                                  </div>
                                                                </div>
                                                                <div className="col-6 col-sm-4 col-md-4 col-lg-4">
                                                                  <div className="icheck-darkgrey d-inline-block py-2">
                                                                    <input
                                                                      type="radio"
                                                                      name="sumryalert"
                                                                      id="sumryweekly"
                                                                      checked={
                                                                        this.state.TmRcvdalrt === 'week' ? true : false
                                                                      }
                                                                      onClick={this.receiveAlrtChk}
                                                                      data-id="week"
                                                                    />
                                                                    <label htmlFor="sumryweekly">Weekly</label>
                                                                  </div>
                                                                </div>
                                                                <div className="col-6 col-sm-4 col-md-4 col-lg-4 pl-0 pl-sm-2">
                                                                  <div className="icheck-darkgrey d-inline-block py-2">
                                                                    <input
                                                                      type="radio"
                                                                      name="sumryalert"
                                                                      id="sumrymonthly"
                                                                      checked={
                                                                        this.state.TmRcvdalrt === 'month' ? true : false
                                                                      }
                                                                      onClick={this.receiveAlrtChk}
                                                                      data-id="month"
                                                                    />
                                                                    <label htmlFor="sumrymonthly">Monthly</label>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="form-group row mt-2 mb-2">
                                                            <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                              <span className="f_sz15">Team</span>
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="table-responsive">
                                                                <table
                                                                  className="table table-hover tbl_valignmdle tbl_teammember border-bottom"
                                                                  id="profteammember"
                                                                  cellPadding={0}
                                                                  cellSpacing={0}
                                                                  style={{ width: '100%' }}>
                                                                  <thead>
                                                                    <tr>
                                                                      <th className="text-center">
                                                                        <div className="icheck-darkgrey d-inline-block">
                                                                          <input
                                                                            type="checkbox"
                                                                            id="allteam"
                                                                            onClick={this.chkAllTem}
                                                                          />
                                                                          <label htmlFor="allteam">&nbsp;</label>
                                                                        </div>
                                                                      </th>
                                                                      <th>Photo</th>
                                                                      <th>Email Address</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    {this.state.TeamMbrLst.map((teamList, index) => {
                                                                      var frst_ltr =
                                                                        teamList.user_info[0].email_address.charAt(0);
                                                                      var frstLtrCaps = frst_ltr.toUpperCase();
                                                                      var randomClr = randDarkColor();
                                                                      return (
                                                                        <tr>
                                                                          <td align="center">
                                                                            <div className="icheck-darkgrey d-inline-block">
                                                                              <input
                                                                                type="checkbox"
                                                                                id={teamList.user_info[0]._id}
                                                                                className={
                                                                                  'smryTmIds' +
                                                                                  teamList.user_info[0]._id
                                                                                }
                                                                              />
                                                                              <label
                                                                                htmlFor={teamList.user_info[0]._id}>
                                                                                &nbsp;
                                                                              </label>
                                                                            </div>
                                                                          </td>
                                                                          {teamList.user_info[0].profile_image != '' ? (
                                                                            <td>
                                                                              <span className="usercircleimg_md">
                                                                                <img
                                                                                  src={
                                                                                    teamList.user_info[0].profile_image
                                                                                  }
                                                                                  border="0"
                                                                                />
                                                                              </span>
                                                                            </td>
                                                                          ) : (
                                                                            <td>
                                                                              <span
                                                                                className="usercircle_md bg_teammember1"
                                                                                style={{ backgroundColor: randomClr }}>
                                                                                {frstLtrCaps}
                                                                              </span>
                                                                            </td>
                                                                          )}
                                                                          <td>{teamList.user_info[0].email_address}</td>
                                                                        </tr>
                                                                      );
                                                                    })}
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3">
                                                          <a
                                                            className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                            onClick={this.saveSmryalrt}>
                                                            Save
                                                          </a>
                                                          <a
                                                            className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                            onClick={this.reSetSmryalrt}>
                                                            Reset
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade nav_links_prof_tabs"
                              id="custom-tabs-autoresponse"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-autoresponse-tab">
                              {/*Auto-Responses*/}
                              <div className="all_contentflex_div">
                                <div className="card w-100 bx_shadow_sm">
                                  <div className="all_contentcntr_700">
                                    {this.state.business_info_array?.business?.plan_id?.plan_name === 'Trial' ||
                                      this.state.business_info_array?.business?.plan_id?.plan_name === 'Free' ? (
                                      <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                        <div className="f_sz16 w-100 d-inline-block pb-2">
                                          To utilize{' '}
                                          <span className="fmaroon font-weight-semibold">R-Bot Responses</span>, please
                                          upgrade.
                                        </div>
                                        {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                        {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                        {/* <TrialPaymentButton
                                          class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                          name="Upgrade"
                                        /> */}
                                        <a
                                          class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                          onClick={() =>
                                            this.upgradeWorkspace(
                                              '/create-profile?bid=' + this.state.business_info_array?.business?._id,
                                            )
                                          }>
                                          Upgrade
                                        </a>
                                      </div>
                                    ) : (
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body">
                                          <div className={this.state.AtoTxtClsNm}>{this.state.AtoTxtMsg}</div>
                                          <div className="joyride_autores1 w-100 RbotInboundMessage">
                                            <div className="form-group row mt-3 mb-5" onClick={() => this.hide_emoji()}>
                                              <label className="col-12 col-sm-12 col-md-7 col-lg-7 col-form-label">
                                                R-Bot Response for Inbound Messages
                                              </label>
                                              <div className="col-12 col-sm-12 col-md-5 col-lg-5 pt-1">
                                                <div>
                                                  <div className="custom-control custom-switch">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input autotxtrespnse_tgl"
                                                      id="autotextresponse"
                                                      onClick={this.autotxtrespnse_tgl}
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor="autotextresponse"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="autotxtrespnse_tgldiv" style={{ display: 'none' }}>
                                              <div className="card w-100 mt-2 mb-5">
                                                <div className="card-body py-0">
                                                  {this.state.AutoTxtArea.map((value, index) => (
                                                    <AutoTxtRespnsFrmGrp
                                                      AutoTxtOnChngFrm={this.AutoTxtOnChng.bind(this, index, value._id)}
                                                      AutoTxtPlsFrm={this.AutoTxtPlsclick.bind(this, index)}
                                                      AutoTxtDelFrm={this.AutoTxtDelonClick.bind(
                                                        this,
                                                        index,
                                                        value._id,
                                                      )}
                                                      value={value.text_response ? value.text_response : undefined}
                                                      key={index}
                                                      arealabel={index}
                                                      ttl_lgth={this.state.AutoTxtArea.length}
                                                      onClick={() => {
                                                        this.render_emoji('Auto_txt_inbound', index, value._id);
                                                      }}
                                                      unique_id_check={value.unique_id}
                                                      attachment_load={() =>
                                                        this.on_auto_MessageEdit(
                                                          value.unique_id,
                                                          'auto_inbound_message',
                                                          'auto_inbound_message_container',
                                                          false,
                                                        )
                                                      }
                                                      onClickclose={() => this.hide_emoji()}
                                                    />
                                                  ))}

                                                  {/* <div className="form-group row mt-4 mb-2">
                                                      <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10"><span className="f_sz15">Max No. of Response</span></label>
                                                      <div className="col-12 col-sm-12 col-md-6 col-lg-8">
                                                        <input type="text" className="form-control text-center txtbx_sm" onChange={this.AutoTxtMaxRspnsOnChg} value={this.state.AutotxtMxRspnsVlue} maxlength="2"/> 
                                                      </div>      
                                                    </div>  */}
                                                  <div
                                                    className="form-group w-100 mt-4 mb-2 text-center"
                                                    onClick={() => this.hide_emoji()}>
                                                    <div className="sendmessage_btnsdiv">
                                                      <div className="dropdown attachment_drpdwn d-inline-block">
                                                        <span className="sendmessage_btnsspan">
                                                          <span
                                                            className="btn btn-lg btn-black crsr_pntr btnpdng_sm"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.AutoTxtArea[0].unique_id,
                                                                'auto_inbound_message',
                                                                'auto_inbound_message_container',
                                                                true,
                                                              )
                                                            }>
                                                            <i className="fas fa-paperclip" />
                                                          </span>
                                                        </span>

                                                        <div
                                                          className="dropdown-menu dropdown-menu-lg dropdown-menu-right auto_inbound_message auto_all_inbound"
                                                          onMouseLeave={() => this.status_hide('auto_inbound_message')}
                                                          onClick={() => this.status_hide('auto_inbound_message')}>
                                                          <div className="dropdown-item">
                                                            <div className="overallattachment_div">
                                                              <div
                                                                className="overallattach_item sendmsgtempattach_clk"
                                                                onClick={
                                                                  this.state.savingprogress === '...'
                                                                    ? null
                                                                    : this.saveNotes2_cmb
                                                                }>
                                                                <div className="overallattach_icon bg_notes bx_shadow_sm">
                                                                  <i className="far fa-sticky-note" />
                                                                </div>
                                                                <div className="fgrey">Notes</div>
                                                              </div>
                                                              <div className="overallattach_item sendmsgtempattach_clk">
                                                                <label for="file-input">
                                                                  <div
                                                                    className="overallattach_icon bg_documents bx_shadow_sm"
                                                                    id="fdupld">
                                                                    <i className="far fa-file-alt" />
                                                                    <input
                                                                      id="file-input"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      onChange={this.fileGetDetails_cmb}
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                </label>
                                                                <div className="fgrey">Documents</div>
                                                              </div>
                                                              <div className="overallattach_item">
                                                                <label htmlFor="file-input3">
                                                                  <div
                                                                    className="overallattach_icon bg_gallery bx_shadow_sm"
                                                                    id="fdupld_2">
                                                                    <i
                                                                      className="far fa-image"
                                                                      data-place="bottom"
                                                                      data-tip="Images"
                                                                    />
                                                                    <input
                                                                      id="file-input3"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                                                      onChange={(event) =>
                                                                        this.fileGetDetails_cmb_images(event)
                                                                      }
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                  {/* <ReactTooltip /> */}
                                                                </label>
                                                                <div className="fgrey">Gallery</div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.AutoTxtArea[0].unique_id,
                                                            'auto_inbound_message',
                                                            'auto_inbound_message_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkAudio2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkAudio2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-microphone-alt" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.AutoTxtArea[0].unique_id,
                                                            'auto_inbound_message',
                                                            'auto_inbound_message_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkVideo2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkVideo2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-video" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      {/* <div className="d-inline-block">
                                                    <a onClick={()=>this.AutoTxtSaveclick()} className="btn btn-black crsr_pntr m-1 btnpdng_sm">Save</a>
                                                  </div> */}
                                                      <AutoRspnsSaveButton AutoSvePrps={this.AutoTxtSaveclick} />
                                                      {this.state.AtoTxDelClkDisble ? (
                                                        <a
                                                          className="btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled"
                                                          id="autoTxtrespnsDel_id">
                                                          Delete
                                                        </a>
                                                      ) : (
                                                        <a
                                                          className="btn btn-black crsr_pntr m-2 btnpdng_sm "
                                                          onClick={this.AutoTxtTtlDel}
                                                          id="autoTxtrespnsDel_id">
                                                          Delete
                                                        </a>
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="card-body px-0 pb-0 auto_response_all_container auto_inbound_message_container">
                                                    <div
                                                      className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb scrollbar_style"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="row position-relative">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <div className="attachment_timelinediv">
                                                            {/* The time line */}
                                                            <div className="timeline">
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkAudio2_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span className="ml-2">
                                                                            <span className="crsr_pntr">
                                                                              <i
                                                                                className="fas fa-record-vinyl fa-2x fbred"
                                                                                onClick={this.audio_start_cmb}
                                                                              />
                                                                              <span
                                                                                className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                onClick={this.audio_start_cmb}>
                                                                                Start Recording
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.audioLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>

                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="audioRecordLoading_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span>
                                                                            <span className="d-inline-block">
                                                                              <span className="crsr_pntr">
                                                                                <i
                                                                                  className="far fa-stop-circle f_sz30 fbred"
                                                                                  onClick={this.audio_stop_cmb}></i>
                                                                                <span
                                                                                  className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                  onClick={this.audio_stop_cmb}>
                                                                                  Stop Recording
                                                                                </span>
                                                                              </span>
                                                                              <span className="f_sz16">
                                                                                <span>
                                                                                  <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkNotes2_cmb">
                                                                <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <textarea
                                                                      className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                                                      placeholder="Enter the notes"
                                                                      value={this.state.notesValue2_cmb}
                                                                      onChange={this.notesLetter2_cmb}
                                                                      id="notestypearea"
                                                                    />
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a
                                                                      className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.saveNotes2_cmb}>
                                                                      Save
                                                                    </a>
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.notesLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkVideo2_cmb">
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                                            <VideoRecorder
                                                                              replayVideoAutoplayAndLoopOff={true}
                                                                              // showReplayControls={true}
                                                                              // mimeType="video/mp4"
                                                                              // constraints={{audio: true}}
                                                                              timeLimit={120000}
                                                                              onRecordingComplete={(
                                                                                videoBlob,
                                                                                thumbnailBlob,
                                                                                videoUrl,
                                                                              ) => {
                                                                                $(
                                                                                  '.sendmsgattach_clkVideo2_cmb',
                                                                                ).hide();
                                                                                $('.sendmsg_attachmentdiv2_cmb').hide();

                                                                                $('.attachLoading_cmb').show();
                                                                                $('.attchLstShow_cmb').show();
                                                                                this.setState({
                                                                                  lodingicon_cmb:
                                                                                    'fas fa-film bg_video',
                                                                                });

                                                                                // Do something with the video...
                                                                                console.log(
                                                                                  'videoBloburl',
                                                                                  window.URL.createObjectURL(videoBlob),
                                                                                );
                                                                                console.log('videoBlob', videoBlob);
                                                                                console.log(
                                                                                  'thumbnailBlob',
                                                                                  thumbnailBlob,
                                                                                );
                                                                                console.log('videoUrl', videoUrl);
                                                                                var reader = new FileReader();
                                                                                reader.readAsDataURL(videoBlob);
                                                                                reader.onloadend = function () {
                                                                                  var base64data = reader.result;
                                                                                  // console.log(base64data);
                                                                                };
                                                                                var filename = new Date().toISOString();
                                                                                const data = new FormData();
                                                                                var mp4file = new File(
                                                                                  [videoBlob],
                                                                                  filename + '.mp4',
                                                                                  {
                                                                                    type: 'video/mp4',
                                                                                    lastModified: new Date(),
                                                                                  },
                                                                                );

                                                                                data.append(
                                                                                  'apikey',
                                                                                  'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                                                );
                                                                                data.append('secret', 'R1eqD2twI3E4');
                                                                                data.append(
                                                                                  'user_id',
                                                                                  this.state.user_id,
                                                                                );
                                                                                data.append(
                                                                                  'business_id',
                                                                                  this.state.business_id,
                                                                                );
                                                                                data.append(
                                                                                  'file',
                                                                                  videoBlob,
                                                                                  filename,
                                                                                );
                                                                                data.append('reference', 'text');
                                                                                // data.append('type', 'video');

                                                                                axios
                                                                                  .post(
                                                                                    API_CALL_ENDPOINT + '/file/upload',
                                                                                    data,
                                                                                  )
                                                                                  .then((res) => {
                                                                                    // console.log(res);
                                                                                    // console.log(res.data.message);
                                                                                    // console.log(res.data?.result?.files);

                                                                                    if (res.data.status == 'success') {
                                                                                      var file_url = '';
                                                                                      var file_path = '';
                                                                                      var file_url2 = '';
                                                                                      var second_file_path = '';
                                                                                      var file_url3 = '';
                                                                                      var file_url4 = '';
                                                                                      var file_id = '';
                                                                                      for (var i in res.data.result
                                                                                        .files) {
                                                                                        console.log(
                                                                                          res.data.result.files[i]
                                                                                            .file_url,
                                                                                        );
                                                                                        file_url +=
                                                                                          res.data.result.files[i]
                                                                                            .file_url;
                                                                                        file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .file_path;
                                                                                        file_url2 +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_url;
                                                                                        second_file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_path;
                                                                                        file_url3 +=
                                                                                          res.data.result.files[i]
                                                                                            .third_file_url;
                                                                                        file_url4 +=
                                                                                          res.data.result.files[i]
                                                                                            .fourth_file_url;
                                                                                        file_id +=
                                                                                          res.data.result.files[i]._id;
                                                                                        var joined_videoId =
                                                                                          this.state.attchmnt_videoId_cmb.concat(
                                                                                            res.data.result.files[i]
                                                                                              ._id,
                                                                                          );
                                                                                        this.setState({
                                                                                          attchmnt_videoId_cmb:
                                                                                            joined_videoId,
                                                                                        });
                                                                                      }
                                                                                      const atchId_recrd =
                                                                                        res.data.result.files[0]._id;
                                                                                      console.log(atchId_recrd);

                                                                                      setTimeout(() => {
                                                                                        console.log(
                                                                                          this.state.atcharryDet_cmb,
                                                                                        );
                                                                                      }, 150);

                                                                                      $('.attachLoading_cmb').hide();
                                                                                      $(
                                                                                        '#attachLoading_cmb_video',
                                                                                      ).hide();

                                                                                      const video_details = {
                                                                                        apikey: API_KEY,
                                                                                        secret: API_SECRET,
                                                                                        user_id: this.state.user_id,
                                                                                        business_id:
                                                                                          this.state.business_id,
                                                                                        attachment: atchId_recrd,
                                                                                        attachment_type: 'video',
                                                                                        unique_id:
                                                                                          this.state.message_edit ===
                                                                                            false
                                                                                            ? Rnunique_id_cmb
                                                                                            : this.state.Rnunique_id_cmb
                                                                                              .append
                                                                                              ? this.state.Rnunique_id_cmb
                                                                                              : Rnunique_id_cmb,
                                                                                        order:
                                                                                          '' +
                                                                                          this.state
                                                                                            .attachOrderIncrs_cmb +
                                                                                          '',
                                                                                      };

                                                                                      axios
                                                                                        .post(
                                                                                          API_CALL_ENDPOINT +
                                                                                          '/text/attachment/create',
                                                                                          video_details,
                                                                                        )
                                                                                        .then((res) => {
                                                                                          console.log(res);
                                                                                          console.log(res.data.message);

                                                                                          if (
                                                                                            res.data.status == 'success'
                                                                                          ) {
                                                                                            this.setState({
                                                                                              messageAttachd_cmb: true,
                                                                                            });
                                                                                            this.setState({
                                                                                              atcharryDet_cmb: [
                                                                                                {
                                                                                                  file_path: file_path,
                                                                                                  second_file_path:
                                                                                                    second_file_path,
                                                                                                  video_id: file_id,
                                                                                                  video_url: file_url,
                                                                                                  video_url2: file_url2,
                                                                                                  video_url3: file_url3,
                                                                                                  video_url4: file_url4,
                                                                                                  attach_id:
                                                                                                    res.data.result._id,
                                                                                                },
                                                                                                ...this.state
                                                                                                  .atcharryDet_cmb,
                                                                                              ],
                                                                                            });
                                                                                            var OrderIncr =
                                                                                              this.state
                                                                                                .attachOrderIncrs_cmb +
                                                                                              parseInt(1);
                                                                                            this.setState({
                                                                                              attachOrderIncrs_cmb:
                                                                                                OrderIncr,
                                                                                            });
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            $(
                                                                                              '.attachment_colapsed_' +
                                                                                              file_id,
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded_' +
                                                                                              file_id,
                                                                                            ).show();
                                                                                          }
                                                                                          if (res.data.error) {
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            // $('.attachment_colapsed_'+file_id).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            // $('.attachment_expanded_'+file_id).show();
                                                                                          }
                                                                                        })
                                                                                        .catch((error) => {
                                                                                          if (error.response) {
                                                                                            if (
                                                                                              error.response.data.error
                                                                                            ) {
                                                                                              $(
                                                                                                '.attachment_colapsed',
                                                                                              ).show();
                                                                                              // $('.attachment_colapsed_'+file_id).hide();
                                                                                              $(
                                                                                                '.attachment_expanded',
                                                                                              ).hide();
                                                                                              // $('.attachment_expanded_'+file_id).show();
                                                                                            }
                                                                                          }
                                                                                        });

                                                                                      console.log(file_url);
                                                                                    }
                                                                                  });
                                                                              }}
                                                                              setVideo={(blob) => {
                                                                                let blobUrl = URL.createObjectURL(blob);
                                                                                console.log(blobUrl);
                                                                                // this.setState({ captureVideoUrl: blobUrl })
                                                                              }}
                                                                            />
                                                                            {/* </div> */}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.videoLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell w-70 align-top">
                                                                          <span className="attachrecord_icon bg_video crsr_pntr">
                                                                            <i className="fas fa-film" />
                                                                          </span>
                                                                        </div>
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="f_sz16">
                                                                            <span>
                                                                              <i className="fas fa-spinner fa-spin f_sz24" />
                                                                            </span>
                                                                            <span
                                                                              className="ml-2"
                                                                              style={{
                                                                                display: 'none',
                                                                              }}>
                                                                              0.10
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}

                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                          defaultValue={10}
                                                                          disabled
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              <div id="attachLoading_cmb_video">
                                                                <i
                                                                  className="fas fa-circle bg-gray"
                                                                  style={{ fontSize: 'x-small' }}
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className="attchLstShow_cmb"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                                                        <div className="attachment_timelinediv">
                                                          {/* The time line */}

                                                          {/* The time line */}
                                                          <div
                                                            // onDragOver={this.dragOver_cmb}
                                                            className="timeline"
                                                            id="timelineprepend">
                                                            <div
                                                              id="attachLoading_cmb"
                                                              className="attachLoading_cmb"
                                                              style={{ display: 'none' }}>
                                                              <i
                                                                className={
                                                                  this.state.lodingicon_cmb + ' attachtype_timelineicon'
                                                                }
                                                              />
                                                              <div className="timeline-item">
                                                                <div className="timeline-body">
                                                                  <div className="attachmentbody_div d-table">
                                                                    <span>
                                                                      <span className="d-inline-block">
                                                                        <span>
                                                                          <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                                        </span>
                                                                        <span className="postop_5up">
                                                                          This might take few mins, please hold on while
                                                                          we process your attachment
                                                                        </span>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                                <div className="timeline-footer"></div>
                                                              </div>
                                                            </div>

                                                            {this.state.atcharryDet_cmb.map((attachment, index) => {
                                                              return attachment.notes_content1 ? (
                                                                <>
                                                                  <div
                                                                    className={'editor_cmb_' + attachment.attach_id}
                                                                    style={{ display: 'none' }}>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        // onClick={() => {
                                                                        //   this.oneditnotecmb(attachment);
                                                                        // }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          {/* <ReactQuill
                                                                            // theme="bubble"

                                                                            modules={{
                                                                              toolbar: [
                                                                                [
                                                                                  'bold',
                                                                                  'italic',
                                                                                  'underline',
                                                                                  'strike',
                                                                                ],
                                                                                [
                                                                                  {header: '1'},
                                                                                  {header: '2'},
                                                                                  {font: []},
                                                                                ],
                                                                                [
                                                                                  {list: 'ordered'},
                                                                                  {list: 'bullet'},
                                                                                  {indent: '-1'},
                                                                                  {indent: '+1'},
                                                                                ],
                                                                                ['link', 'video'],
                                                                                ['clean'],
                                                                              ],

                                                                              clipboard: {
                                                                                // toggle to add extra line breaks when pasting HTML:
                                                                                matchVisual: false,
                                                                              },
                                                                            }}
                                                                            formats={[
                                                                              'header',
                                                                              'font',
                                                                              'size',
                                                                              'bold',
                                                                              'italic',
                                                                              'underline',
                                                                              'strike',
                                                                              'list',
                                                                              'bullet',
                                                                              'indent',
                                                                              'link',
                                                                              'video',
                                                                            ]}
                                                                            value={this.state.notesValue2_cmb}
                                                                            onChange={this.notesLetter2_cmb}
                                                                            maxLength="600"
                                                                          /> */}
                                                                          <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={this.state.notesValue2_cmb}
                                                                            id="mytext"
                                                                            config={editorConfiguration}
                                                                            onReady={(editor) => {
                                                                              // You can store the "editor" and use when it is needed.
                                                                              // console.log( 'Editor is ready to use!', editor );
                                                                            }}
                                                                            onChange={(event, editor) => {
                                                                              const data = editor.getData();
                                                                              // console.log( { event, editor, data } );
                                                                              // if (data.length <= 1200) {
                                                                              this.setState({
                                                                                notesValue2_cmb: data,
                                                                                chars_left_notes_cmb:
                                                                                  this.state.max_chars_notes_cmb -
                                                                                  data.length,
                                                                              });
                                                                              // }
                                                                            }}
                                                                            onBlur={(event, editor) => {
                                                                              // console.log( 'Blur.', editor );
                                                                            }}
                                                                            onFocus={(event, editor) => {
                                                                              // console.log( 'Focus.', editor );
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </div>

                                                                      {/* {this.state.cmb_notesedit === true ? (
                                                                        <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                                                                          {this.state.savingprogress}
                                                                        </div>
                                                                      ) : null} */}

                                                                      {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                                                        
                                                                        Maximum 1200 characters
                                                                      </div> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        {/* {this.state.cmb_notesedit === true ? (
                                                                          <a
                                                                            className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                            onClick={() => {
                                                                              this.updateNotes2_cmb();
                                                                            }}>
                                                                            Update
                                                                          </a>
                                                                        ) : null} */}
                                                                        <a
                                                                          className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() => {
                                                                            this.updateNotes2_cmb();
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                                          Save
                                                                        </a>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() =>
                                                                            this.notesAtchDelte_cmb_edit(
                                                                              attachment.attach_id,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>

                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                    // draggable="true"
                                                                    // onDragEnd={this.dragEnd_cmb}
                                                                    // onDragStart={this.dragStart_cmb}
                                                                    className={
                                                                      'notecontent_cmb_show notecontent_cmb_' +
                                                                      attachment.attach_id
                                                                    }>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        onClick={() => {
                                                                          this.oneditnotecmb(attachment);
                                                                        }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          <Linkify
                                                                            componentDecorator={(
                                                                              decoratedHref,
                                                                              decoratedText,
                                                                              key,
                                                                            ) => (
                                                                              <a
                                                                                target="blank"
                                                                                href={decoratedHref}
                                                                                key={key}>
                                                                                {decoratedText}
                                                                              </a>
                                                                            )}>
                                                                            <div
                                                                              dangerouslySetInnerHTML={{
                                                                                __html: attachment.notes_content,
                                                                              }}
                                                                            />
                                                                            {/* {attachment.notes_content} */}
                                                                          </Linkify>
                                                                        </div>
                                                                      </div>

                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={this.notesAtchDelte_cmb}>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                          {/* </span> */}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              ) : attachment.documents ? (
                                                                attachment.documents.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                  // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                  >
                                                                    <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          <span className="font-weight-bold">
                                                                            Documents:
                                                                          </span>
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.documents.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.documents,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>

                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Document Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.images ? (
                                                                attachment.images.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={this.dragEnd_cmb}
                                                                  // onDragStart={this.dragStart_cmb}
                                                                  >
                                                                    <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          {/* <span className="font-weight-bold">Images:</span> */}
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.images.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                    {/* <div className="attachdoc_delete">
                                                                                      <a
                                                                                        href="javascript:void(0)"
                                                                                        className="crsr_pntr">
                                                                                        <i
                                                                                          className="far fa-trash-alt f_sz15"
                                                                                          onClick={this.DocLclDlete_cmb}
                                                                                          id={documentList.file_id}
                                                                                          data-id={attachment.attach_id}
                                                                                        />
                                                                                      </a>
                                                                                    </div> */}
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.images,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Image Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.audio_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                  <div className="timeline-item ">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <div className="attachmentbody_div d-table">
                                                                        <div className="d-table-row">
                                                                          <div className="d-table-cell align-middle">
                                                                            <span>
                                                                              <span className="d-inline-block">
                                                                                <span className="crsr_pntr">
                                                                                  <i
                                                                                    className={
                                                                                      'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={() => {
                                                                                      this.audioPly_temp(attachment);
                                                                                    }}
                                                                                    id={attachment.audio_id}
                                                                                  />
                                                                                  <i
                                                                                    className={
                                                                                      'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={this.audioPaue}
                                                                                    id={attachment.audio_id}
                                                                                    style={{
                                                                                      display: 'none',
                                                                                    }}></i>
                                                                                  <span
                                                                                    className="ml-2 d-inline-block postop_5up"
                                                                                  // style={{
                                                                                  //   display: 'none',
                                                                                  // }}
                                                                                  ></span>
                                                                                  <audio
                                                                                    className={
                                                                                      'audioplayer123 audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    style={{
                                                                                      width: '258px',
                                                                                      display: 'none',
                                                                                    }}
                                                                                    src={
                                                                                      this.state.play_audio_url
                                                                                        ? this.state.play_audio_url
                                                                                        : undefined
                                                                                    }
                                                                                    controls="controls"
                                                                                    controlsList="nodownload"
                                                                                    //hidden
                                                                                    id={
                                                                                      'audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                  />
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.audioAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.audio_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.audio_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Audio Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.audio_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : attachment.video_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                                                  <div className="timeline-item">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                        <span className="font-weight-bold">Video:</span>
                                                                        <br />
                                                                        <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                          <a
                                                                            onClick={() =>
                                                                              this.Video_play_url(attachment)
                                                                            }>
                                                                            {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                              <div className="attachdoc_type text-center">
                                                                <i className="fas fa-video" />
                                                              </div>
                                                              <div className="attachdoc_name">
                                                                Click here to
                                                                play video
                                                              </div>
                                                            </div> */}
                                                                            <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                                              <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                                                {/* <img src={} border={0} /> */}
                                                                                <i className="fas fa-video fa-3x" />
                                                                              </div>
                                                                              <div className="attachvideo_gif">
                                                                                {/* <img src={} border={0} /> */}
                                                                                Click here to play video
                                                                              </div>
                                                                            </div>
                                                                            {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* <div className="attachmentbody_div d-table">
                                                        <div className="d-table-row">
                                                          <div className="d-table-cell align-middle">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="videoWrapper">
                                                                <video
                                                                  onPlay={() =>
                                                                    this.Video_play_url(
                                                                      attachment
                                                                    )
                                                                  }
                                                                  width="300"
                                                                  controls
                                                                  playsinline
                                                                >
                                                                  
                                                                  <source
                                                                    src={
                                                                      this.state
                                                                        .video_play_link
                                                                    }
                                                                    type="video/mp4"
                                                                  />                                                                
                                                                </video>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div> */}
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.videAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className={
                                                                          'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                        }
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.attach_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.attach_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Video Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : null;
                                                            })}

                                                            <div>
                                                              <i
                                                                className="fas fa-circle bg-gray"
                                                                style={{ fontSize: 'x-small' }}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="joyride_autores2 w-100 RbotUnsupportedMedia">
                                            <div className="form-group row mt-3 mb-5" onClick={() => this.hide_emoji()}>
                                              <label className="col-12 col-sm-12 col-md-7 col-lg-7 col-form-label">
                                                R-Bot Response for Unsupported Media
                                              </label>
                                              <div className="col-12 col-sm-12 col-md-5 col-lg-5 pt-1">
                                                <div>
                                                  <div className="custom-control custom-switch">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input autotxtrespnsemedia_tgl"
                                                      id="autotextresponsemedia"
                                                      onClick={this.autotextresponsemedia_tgl}
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor="autotextresponsemedia"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="autotxtrespnsemedia_tgldiv" style={{ display: 'none' }}>
                                              <div className="card w-100 mt-2 mb-5">
                                                <div className="card-body py-0">
                                                  <div className="form-group row mt-2 mb-2">
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <textarea
                                                        className="form-control textarea_hgt100 txtarea_resizenone"
                                                        onChange={(e) => this.onChangeautotxtunsup(e)}
                                                        placeholder="Enter the Message"
                                                        value={this.state.unsupportedtext}
                                                        onClick={() => this.hide_emoji()}
                                                        maxLength="300"
                                                      />
                                                      <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                        <div className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_unsupport_show emoji_show_all">
                                                          <i
                                                            className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative"
                                                            onClick={() => {
                                                              this.render_emoji('Auto_txt_unsupport');
                                                            }}
                                                          />

                                                          <a
                                                            className="crsr_pntr auto_txt_res_open1"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.unsupportedtext_unique_id,
                                                                'auto_unsupport_media',
                                                                'auto_unsupport_media_container',
                                                                false,
                                                              )
                                                            }>
                                                            <i
                                                              className={
                                                                this.state.unsupportedtext_unique_id
                                                                  ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                                  : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                                              }
                                                            />
                                                          </a>
                                                        </div>
                                                        <div
                                                          className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_unsupport_close emoji_close_all"
                                                          style={{ display: 'none' }}>
                                                          <i
                                                            className={
                                                              'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                            }
                                                            onClick={() => {
                                                              this.render_emoji('Auto_txt_unsupport');
                                                            }}
                                                          />
                                                          <a
                                                            className="crsr_pntr auto_txt_res_open1"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.unsupportedtext_unique_id,
                                                                'auto_unsupport_media',
                                                                'auto_unsupport_media_container',
                                                                false,
                                                              )
                                                            }>
                                                            <i
                                                              className={
                                                                this.state.unsupportedtext_unique_id
                                                                  ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                                  : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                                              }
                                                            />
                                                          </a>
                                                        </div>
                                                        <button
                                                          className="btn btn-primary btn-lg"
                                                          id="btnTrigger"
                                                          style={{ display: 'none' }}></button>
                                                        {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                      </div>
                                                      <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                        <span
                                                          className="flex-row flex-wrap emoji_position emoji_disable"
                                                          style={{
                                                            display: 'none',
                                                            position: 'inherit',
                                                            width: 'inherit',
                                                            zIndex: '10',
                                                          }}
                                                          id="Auto_txt_unsupport"></span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group w-100 mt-4 mb-2 text-center"
                                                    onClick={() => this.hide_emoji()}>
                                                    <div className="sendmessage_btnsdiv">
                                                      <div className="dropdown attachment_drpdwn d-inline-block">
                                                        <span className="sendmessage_btnsspan">
                                                          <span
                                                            className="btn btn-lg btn-black crsr_pntr btnpdng_sm"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.unsupportedtext_unique_id,
                                                                'auto_unsupport_media',
                                                                'auto_unsupport_media_container',
                                                                true,
                                                              )
                                                            }>
                                                            <i className="fas fa-paperclip" />
                                                          </span>
                                                        </span>

                                                        <div
                                                          className="dropdown-menu dropdown-menu-lg dropdown-menu-right auto_unsupport_media auto_all_inbound"
                                                          onMouseLeave={() => this.status_hide('auto_unsupport_media')}
                                                          onClick={() => this.status_hide('auto_unsupport_media')}>
                                                          <div className="dropdown-item">
                                                            <div className="overallattachment_div">
                                                              <div
                                                                className="overallattach_item sendmsgtempattach_clk"
                                                                onClick={
                                                                  this.state.savingprogress === '...'
                                                                    ? null
                                                                    : this.saveNotes2_cmb
                                                                }>
                                                                <div className="overallattach_icon bg_notes bx_shadow_sm">
                                                                  <i className="far fa-sticky-note" />
                                                                </div>
                                                                <div className="fgrey">Notes</div>
                                                              </div>
                                                              <div className="overallattach_item sendmsgtempattach_clk">
                                                                <label for="file-input">
                                                                  <div
                                                                    className="overallattach_icon bg_documents bx_shadow_sm"
                                                                    id="fdupld">
                                                                    <i className="far fa-file-alt" />
                                                                    <input
                                                                      id="file-input"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      onChange={this.fileGetDetails_cmb}
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                </label>
                                                                <div className="fgrey">Documents</div>
                                                              </div>
                                                              <div className="overallattach_item">
                                                                <label htmlFor="file-input3">
                                                                  <div
                                                                    className="overallattach_icon bg_gallery bx_shadow_sm"
                                                                    id="fdupld_2">
                                                                    <i
                                                                      className="far fa-image"
                                                                      data-place="bottom"
                                                                      data-tip="Images"
                                                                    />
                                                                    <input
                                                                      id="file-input3"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                                                      onChange={(event) =>
                                                                        this.fileGetDetails_cmb_images(event)
                                                                      }
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                  {/* <ReactTooltip /> */}
                                                                </label>
                                                                <div className="fgrey">Gallery</div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.unsupportedtext_unique_id,
                                                            'auto_unsupport_media',
                                                            'auto_unsupport_media_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkAudio2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkAudio2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-microphone-alt" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.unsupportedtext_unique_id,
                                                            'auto_unsupport_media',
                                                            'auto_unsupport_media_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkVideo2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkVideo2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-video" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <a
                                                        className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                        onClick={() => this.autotextresponsemedia_save()}>
                                                        Save
                                                      </a>
                                                      <a
                                                        className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                        onClick={this.autotextresponsemedia_del}>
                                                        Delete
                                                      </a>
                                                    </div>
                                                  </div>
                                                  <div className="card-body px-0 pb-0 auto_response_all_container auto_unsupport_media_container">
                                                    <div
                                                      className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb scrollbar_style"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="row position-relative">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <div className="attachment_timelinediv">
                                                            {/* The time line */}
                                                            <div className="timeline">
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkAudio2_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span className="ml-2">
                                                                            <span className="crsr_pntr">
                                                                              <i
                                                                                className="fas fa-record-vinyl fa-2x fbred"
                                                                                onClick={this.audio_start_cmb}
                                                                              />
                                                                              <span
                                                                                className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                onClick={this.audio_start_cmb}>
                                                                                Start Recording
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.audioLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>

                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="audioRecordLoading_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span>
                                                                            <span className="d-inline-block">
                                                                              <span className="crsr_pntr">
                                                                                <i
                                                                                  className="far fa-stop-circle f_sz30 fbred"
                                                                                  onClick={this.audio_stop_cmb}></i>
                                                                                <span
                                                                                  className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                  onClick={this.audio_stop_cmb}>
                                                                                  Stop Recording
                                                                                </span>
                                                                              </span>
                                                                              <span className="f_sz16">
                                                                                <span>
                                                                                  <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkNotes2_cmb">
                                                                <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <textarea
                                                                      className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                                                      placeholder="Enter the notes"
                                                                      value={this.state.notesValue2_cmb}
                                                                      onChange={this.notesLetter2_cmb}
                                                                      id="notestypearea"
                                                                    />
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a
                                                                      className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.saveNotes2_cmb}>
                                                                      Save
                                                                    </a>
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.notesLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkVideo2_cmb">
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                                            <VideoRecorder
                                                                              replayVideoAutoplayAndLoopOff={true}
                                                                              // showReplayControls={true}
                                                                              // mimeType="video/mp4"
                                                                              // constraints={{audio: true}}
                                                                              timeLimit={120000}
                                                                              onRecordingComplete={(
                                                                                videoBlob,
                                                                                thumbnailBlob,
                                                                                videoUrl,
                                                                              ) => {
                                                                                $(
                                                                                  '.sendmsgattach_clkVideo2_cmb',
                                                                                ).hide();
                                                                                $('.sendmsg_attachmentdiv2_cmb').hide();

                                                                                $('.attachLoading_cmb').show();
                                                                                $('.attchLstShow_cmb').show();
                                                                                this.setState({
                                                                                  lodingicon_cmb:
                                                                                    'fas fa-film bg_video',
                                                                                });

                                                                                // Do something with the video...
                                                                                console.log(
                                                                                  'videoBloburl',
                                                                                  window.URL.createObjectURL(videoBlob),
                                                                                );
                                                                                console.log('videoBlob', videoBlob);
                                                                                console.log(
                                                                                  'thumbnailBlob',
                                                                                  thumbnailBlob,
                                                                                );
                                                                                console.log('videoUrl', videoUrl);
                                                                                var reader = new FileReader();
                                                                                reader.readAsDataURL(videoBlob);
                                                                                reader.onloadend = function () {
                                                                                  var base64data = reader.result;
                                                                                  // console.log(base64data);
                                                                                };
                                                                                var filename = new Date().toISOString();
                                                                                const data = new FormData();
                                                                                var mp4file = new File(
                                                                                  [videoBlob],
                                                                                  filename + '.mp4',
                                                                                  {
                                                                                    type: 'video/mp4',
                                                                                    lastModified: new Date(),
                                                                                  },
                                                                                );

                                                                                data.append(
                                                                                  'apikey',
                                                                                  'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                                                );
                                                                                data.append('secret', 'R1eqD2twI3E4');
                                                                                data.append(
                                                                                  'user_id',
                                                                                  this.state.user_id,
                                                                                );
                                                                                data.append(
                                                                                  'business_id',
                                                                                  this.state.business_id,
                                                                                );
                                                                                data.append(
                                                                                  'file',
                                                                                  videoBlob,
                                                                                  filename,
                                                                                );
                                                                                data.append('reference', 'text');
                                                                                // data.append('type', 'video');

                                                                                axios
                                                                                  .post(
                                                                                    API_CALL_ENDPOINT + '/file/upload',
                                                                                    data,
                                                                                  )
                                                                                  .then((res) => {
                                                                                    // console.log(res);
                                                                                    // console.log(res.data.message);
                                                                                    // console.log(res.data?.result?.files);

                                                                                    if (res.data.status == 'success') {
                                                                                      var file_url = '';
                                                                                      var file_path = '';
                                                                                      var file_url2 = '';
                                                                                      var second_file_path = '';
                                                                                      var file_url3 = '';
                                                                                      var file_url4 = '';
                                                                                      var file_id = '';
                                                                                      for (var i in res.data.result
                                                                                        .files) {
                                                                                        console.log(
                                                                                          res.data.result.files[i]
                                                                                            .file_url,
                                                                                        );
                                                                                        file_url +=
                                                                                          res.data.result.files[i]
                                                                                            .file_url;
                                                                                        file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .file_path;
                                                                                        file_url2 +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_url;
                                                                                        second_file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_path;
                                                                                        file_url3 +=
                                                                                          res.data.result.files[i]
                                                                                            .third_file_url;
                                                                                        file_url4 +=
                                                                                          res.data.result.files[i]
                                                                                            .fourth_file_url;
                                                                                        file_id +=
                                                                                          res.data.result.files[i]._id;
                                                                                        var joined_videoId =
                                                                                          this.state.attchmnt_videoId_cmb.concat(
                                                                                            res.data.result.files[i]
                                                                                              ._id,
                                                                                          );
                                                                                        this.setState({
                                                                                          attchmnt_videoId_cmb:
                                                                                            joined_videoId,
                                                                                        });
                                                                                      }
                                                                                      const atchId_recrd =
                                                                                        res.data.result.files[0]._id;
                                                                                      console.log(atchId_recrd);

                                                                                      setTimeout(() => {
                                                                                        console.log(
                                                                                          this.state.atcharryDet_cmb,
                                                                                        );
                                                                                      }, 150);

                                                                                      $('.attachLoading_cmb').hide();
                                                                                      $(
                                                                                        '#attachLoading_cmb_video',
                                                                                      ).hide();

                                                                                      const video_details = {
                                                                                        apikey: API_KEY,
                                                                                        secret: API_SECRET,
                                                                                        user_id: this.state.user_id,
                                                                                        business_id:
                                                                                          this.state.business_id,
                                                                                        attachment: atchId_recrd,
                                                                                        attachment_type: 'video',
                                                                                        unique_id:
                                                                                          this.state.message_edit ===
                                                                                            false
                                                                                            ? Rnunique_id_cmb
                                                                                            : this.state.Rnunique_id_cmb
                                                                                              .append
                                                                                              ? this.state.Rnunique_id_cmb
                                                                                              : Rnunique_id_cmb,
                                                                                        order:
                                                                                          '' +
                                                                                          this.state
                                                                                            .attachOrderIncrs_cmb +
                                                                                          '',
                                                                                      };

                                                                                      axios
                                                                                        .post(
                                                                                          API_CALL_ENDPOINT +
                                                                                          '/text/attachment/create',
                                                                                          video_details,
                                                                                        )
                                                                                        .then((res) => {
                                                                                          console.log(res);
                                                                                          console.log(res.data.message);

                                                                                          if (
                                                                                            res.data.status == 'success'
                                                                                          ) {
                                                                                            this.setState({
                                                                                              messageAttachd_cmb: true,
                                                                                            });
                                                                                            this.setState({
                                                                                              atcharryDet_cmb: [
                                                                                                {
                                                                                                  file_path: file_path,
                                                                                                  second_file_path:
                                                                                                    second_file_path,
                                                                                                  video_id: file_id,
                                                                                                  video_url: file_url,
                                                                                                  video_url2: file_url2,
                                                                                                  video_url3: file_url3,
                                                                                                  video_url4: file_url4,
                                                                                                  attach_id:
                                                                                                    res.data.result._id,
                                                                                                },
                                                                                                ...this.state
                                                                                                  .atcharryDet_cmb,
                                                                                              ],
                                                                                            });
                                                                                            var OrderIncr =
                                                                                              this.state
                                                                                                .attachOrderIncrs_cmb +
                                                                                              parseInt(1);
                                                                                            this.setState({
                                                                                              attachOrderIncrs_cmb:
                                                                                                OrderIncr,
                                                                                            });
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            $(
                                                                                              '.attachment_colapsed_' +
                                                                                              file_id,
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded_' +
                                                                                              file_id,
                                                                                            ).show();
                                                                                          }
                                                                                          if (res.data.error) {
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            // $('.attachment_colapsed_'+file_id).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            // $('.attachment_expanded_'+file_id).show();
                                                                                          }
                                                                                        })
                                                                                        .catch((error) => {
                                                                                          if (error.response) {
                                                                                            if (
                                                                                              error.response.data.error
                                                                                            ) {
                                                                                              $(
                                                                                                '.attachment_colapsed',
                                                                                              ).show();
                                                                                              // $('.attachment_colapsed_'+file_id).hide();
                                                                                              $(
                                                                                                '.attachment_expanded',
                                                                                              ).hide();
                                                                                              // $('.attachment_expanded_'+file_id).show();
                                                                                            }
                                                                                          }
                                                                                        });

                                                                                      console.log(file_url);
                                                                                    }
                                                                                  });
                                                                              }}
                                                                              setVideo={(blob) => {
                                                                                let blobUrl = URL.createObjectURL(blob);
                                                                                console.log(blobUrl);
                                                                                // this.setState({ captureVideoUrl: blobUrl })
                                                                              }}
                                                                            />
                                                                            {/* </div> */}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.videoLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell w-70 align-top">
                                                                          <span className="attachrecord_icon bg_video crsr_pntr">
                                                                            <i className="fas fa-film" />
                                                                          </span>
                                                                        </div>
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="f_sz16">
                                                                            <span>
                                                                              <i className="fas fa-spinner fa-spin f_sz24" />
                                                                            </span>
                                                                            <span
                                                                              className="ml-2"
                                                                              style={{
                                                                                display: 'none',
                                                                              }}>
                                                                              0.10
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}

                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                          defaultValue={10}
                                                                          disabled
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              <div id="attachLoading_cmb_video">
                                                                <i
                                                                  className="fas fa-circle bg-gray"
                                                                  style={{ fontSize: 'x-small' }}
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className="attchLstShow_cmb"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                                                        <div className="attachment_timelinediv">
                                                          {/* The time line */}

                                                          {/* The time line */}
                                                          <div
                                                            // onDragOver={this.dragOver_cmb}
                                                            className="timeline"
                                                            id="timelineprepend">
                                                            <div
                                                              id="attachLoading_cmb"
                                                              className="attachLoading_cmb"
                                                              style={{ display: 'none' }}>
                                                              <i
                                                                className={
                                                                  this.state.lodingicon_cmb + ' attachtype_timelineicon'
                                                                }
                                                              />
                                                              <div className="timeline-item">
                                                                <div className="timeline-body">
                                                                  <div className="attachmentbody_div d-table">
                                                                    <span>
                                                                      <span className="d-inline-block">
                                                                        <span>
                                                                          <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                                        </span>
                                                                        <span className="postop_5up">
                                                                          This might take few mins, please hold on while
                                                                          we process your attachment
                                                                        </span>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                                <div className="timeline-footer"></div>
                                                              </div>
                                                            </div>

                                                            {this.state.atcharryDet_cmb.map((attachment, index) => {
                                                              return attachment.notes_content1 ? (
                                                                <>
                                                                  <div
                                                                    className={'editor_cmb_' + attachment.attach_id}
                                                                    style={{ display: 'none' }}>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        // onClick={() => {
                                                                        //   this.oneditnotecmb(attachment);
                                                                        // }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          {/* <ReactQuill
                                                                            // theme="bubble"

                                                                            modules={{
                                                                              toolbar: [
                                                                                [
                                                                                  'bold',
                                                                                  'italic',
                                                                                  'underline',
                                                                                  'strike',
                                                                                ],
                                                                                [
                                                                                  {header: '1'},
                                                                                  {header: '2'},
                                                                                  {font: []},
                                                                                ],
                                                                                [
                                                                                  {list: 'ordered'},
                                                                                  {list: 'bullet'},
                                                                                  {indent: '-1'},
                                                                                  {indent: '+1'},
                                                                                ],
                                                                                ['link', 'video'],
                                                                                ['clean'],
                                                                              ],

                                                                              clipboard: {
                                                                                // toggle to add extra line breaks when pasting HTML:
                                                                                matchVisual: false,
                                                                              },
                                                                            }}
                                                                            formats={[
                                                                              'header',
                                                                              'font',
                                                                              'size',
                                                                              'bold',
                                                                              'italic',
                                                                              'underline',
                                                                              'strike',
                                                                              'list',
                                                                              'bullet',
                                                                              'indent',
                                                                              'link',
                                                                              'video',
                                                                            ]}
                                                                            value={this.state.notesValue2_cmb}
                                                                            onChange={this.notesLetter2_cmb}
                                                                            maxLength="600"
                                                                          /> */}
                                                                          <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={this.state.notesValue2_cmb}
                                                                            id="mytext"
                                                                            config={editorConfiguration}
                                                                            onReady={(editor) => {
                                                                              // You can store the "editor" and use when it is needed.
                                                                              // console.log( 'Editor is ready to use!', editor );
                                                                            }}
                                                                            onChange={(event, editor) => {
                                                                              const data = editor.getData();
                                                                              // console.log( { event, editor, data } );
                                                                              // if (data.length <= 1200) {
                                                                              this.setState({
                                                                                notesValue2_cmb: data,
                                                                                chars_left_notes_cmb:
                                                                                  this.state.max_chars_notes_cmb -
                                                                                  data.length,
                                                                              });
                                                                              // }
                                                                            }}
                                                                            onBlur={(event, editor) => {
                                                                              // console.log( 'Blur.', editor );
                                                                            }}
                                                                            onFocus={(event, editor) => {
                                                                              // console.log( 'Focus.', editor );
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </div>

                                                                      {/* {this.state.cmb_notesedit === true ? (
                                                                        <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                                                                          {this.state.savingprogress}
                                                                        </div>
                                                                      ) : null} */}

                                                                      {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                                                        
                                                                        Maximum 1200 characters
                                                                      </div> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        {/* {this.state.cmb_notesedit === true ? (
                                                                          <a
                                                                            className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                            onClick={() => {
                                                                              this.updateNotes2_cmb();
                                                                            }}>
                                                                            Update
                                                                          </a>
                                                                        ) : null} */}
                                                                        <a
                                                                          className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() => {
                                                                            this.updateNotes2_cmb();
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                                          Save
                                                                        </a>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() =>
                                                                            this.notesAtchDelte_cmb_edit(
                                                                              attachment.attach_id,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>

                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                    // draggable="true"
                                                                    // onDragEnd={this.dragEnd_cmb}
                                                                    // onDragStart={this.dragStart_cmb}
                                                                    className={
                                                                      'notecontent_cmb_show notecontent_cmb_' +
                                                                      attachment.attach_id
                                                                    }>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        onClick={() => {
                                                                          this.oneditnotecmb(attachment);
                                                                        }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          <Linkify
                                                                            componentDecorator={(
                                                                              decoratedHref,
                                                                              decoratedText,
                                                                              key,
                                                                            ) => (
                                                                              <a
                                                                                target="blank"
                                                                                href={decoratedHref}
                                                                                key={key}>
                                                                                {decoratedText}
                                                                              </a>
                                                                            )}>
                                                                            <div
                                                                              dangerouslySetInnerHTML={{
                                                                                __html: attachment.notes_content,
                                                                              }}
                                                                            />
                                                                            {/* {attachment.notes_content} */}
                                                                          </Linkify>
                                                                        </div>
                                                                      </div>

                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={this.notesAtchDelte_cmb}>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                          {/* </span> */}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              ) : attachment.documents ? (
                                                                attachment.documents.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                  // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                  >
                                                                    <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          <span className="font-weight-bold">
                                                                            Documents:
                                                                          </span>
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.documents.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.documents,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>

                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Document Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.images ? (
                                                                attachment.images.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={this.dragEnd_cmb}
                                                                  // onDragStart={this.dragStart_cmb}
                                                                  >
                                                                    <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          {/* <span className="font-weight-bold">Images:</span> */}
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.images.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                    {/* <div className="attachdoc_delete">
                                                                                      <a
                                                                                        href="javascript:void(0)"
                                                                                        className="crsr_pntr">
                                                                                        <i
                                                                                          className="far fa-trash-alt f_sz15"
                                                                                          onClick={this.DocLclDlete_cmb}
                                                                                          id={documentList.file_id}
                                                                                          data-id={attachment.attach_id}
                                                                                        />
                                                                                      </a>
                                                                                    </div> */}
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.images,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Image Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.audio_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                  <div className="timeline-item ">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <div className="attachmentbody_div d-table">
                                                                        <div className="d-table-row">
                                                                          <div className="d-table-cell align-middle">
                                                                            <span>
                                                                              <span className="d-inline-block">
                                                                                <span className="crsr_pntr">
                                                                                  <i
                                                                                    className={
                                                                                      'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={() => {
                                                                                      this.audioPly_temp(attachment);
                                                                                    }}
                                                                                    id={attachment.audio_id}
                                                                                  />
                                                                                  <i
                                                                                    className={
                                                                                      'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={this.audioPaue}
                                                                                    id={attachment.audio_id}
                                                                                    style={{
                                                                                      display: 'none',
                                                                                    }}></i>
                                                                                  <span
                                                                                    className="ml-2 d-inline-block postop_5up"
                                                                                  // style={{
                                                                                  //   display: 'none',
                                                                                  // }}
                                                                                  ></span>
                                                                                  <audio
                                                                                    className={
                                                                                      'audioplayer123 audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    style={{
                                                                                      width: '258px',
                                                                                      display: 'none',
                                                                                    }}
                                                                                    src={
                                                                                      this.state.play_audio_url
                                                                                        ? this.state.play_audio_url
                                                                                        : undefined
                                                                                    }
                                                                                    controls="controls"
                                                                                    controlsList="nodownload"
                                                                                    //hidden
                                                                                    id={
                                                                                      'audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                  />
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.audioAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.audio_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.audio_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Audio Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.audio_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : attachment.video_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                                                  <div className="timeline-item">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                        <span className="font-weight-bold">Video:</span>
                                                                        <br />
                                                                        <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                          <a
                                                                            onClick={() =>
                                                                              this.Video_play_url(attachment)
                                                                            }>
                                                                            {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                              <div className="attachdoc_type text-center">
                                                                <i className="fas fa-video" />
                                                              </div>
                                                              <div className="attachdoc_name">
                                                                Click here to
                                                                play video
                                                              </div>
                                                            </div> */}
                                                                            <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                                              <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                                                {/* <img src={} border={0} /> */}
                                                                                <i className="fas fa-video fa-3x" />
                                                                              </div>
                                                                              <div className="attachvideo_gif">
                                                                                {/* <img src={} border={0} /> */}
                                                                                Click here to play video
                                                                              </div>
                                                                            </div>
                                                                            {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* <div className="attachmentbody_div d-table">
                                                        <div className="d-table-row">
                                                          <div className="d-table-cell align-middle">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="videoWrapper">
                                                                <video
                                                                  onPlay={() =>
                                                                    this.Video_play_url(
                                                                      attachment
                                                                    )
                                                                  }
                                                                  width="300"
                                                                  controls
                                                                  playsinline
                                                                >
                                                                  
                                                                  <source
                                                                    src={
                                                                      this.state
                                                                        .video_play_link
                                                                    }
                                                                    type="video/mp4"
                                                                  />                                                                
                                                                </video>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div> */}
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.videAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className={
                                                                          'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                        }
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.attach_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.attach_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Video Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : null;
                                                            })}

                                                            <div>
                                                              <i
                                                                className="fas fa-circle bg-gray"
                                                                style={{ fontSize: 'x-small' }}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="joyride_autores3 w-100 RbotInboundCall">
                                            <div className="form-group row mt-5 mb-5" onClick={() => this.hide_emoji()}>
                                              <label className="col-12 col-sm-12 col-md-7 col-lg-7 col-form-label">
                                                R-Bot Response for Inbound Calls
                                              </label>
                                              <div className="col-12 col-sm-12 col-md-5 col-lg-5 pt-1">
                                                <div className="custom-control custom-switch">
                                                  <input
                                                    type="checkbox"
                                                    className="custom-control-input autovoiceresponse_tgl"
                                                    id="autovoiceresponse"
                                                    onClick={this.autovoiceresponse_tgl}
                                                  />
                                                  <label className="custom-control-label" htmlFor="autovoiceresponse" />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="autovoiceresponse_tgldiv" style={{ display: 'none' }}>
                                              <div style={{ display: 'none' }}>
                                                <div className="card w-100 mt-3">
                                                  <div className="card-body py-0">
                                                    <div className={this.state.AtoViceRescls}>
                                                      {this.state.AtoViceResMsg}
                                                    </div>
                                                    <div className="form-group mt-2 mb-2">
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0">
                                                        <div className="all_contentflex_div icheck_lbl">
                                                          <div className="col-6 col-sm-6 col-md-6 col-lg-6 pl-0">
                                                            <div className="icheck-darkgrey d-inline-block py-2">
                                                              <input
                                                                type="radio"
                                                                name="autovoiceresp"
                                                                id="autovoicemsg"
                                                                defaultValue={1}
                                                                onClick={this.autovoiceresp}
                                                              />
                                                              <label htmlFor="autovoicemsg">Leave a message</label>
                                                            </div>
                                                          </div>
                                                          <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                                            <div className="icheck-darkgrey d-inline-block py-2">
                                                              <input
                                                                type="radio"
                                                                name="autovoiceresp"
                                                                id="autovoicehangup"
                                                                defaultValue={2}
                                                                onClick={this.autovoiceresp}
                                                              />
                                                              <label htmlFor="autovoicehangup">
                                                                Hangup without message
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="autovoicedesc"
                                                      id="autovoicemsg1"
                                                      style={{ display: 'none' }}>
                                                      <div className="all_contentflex_div">
                                                        <div className="card w-100 mt-2 mb-4 shadow-none">
                                                          <div className="card-header">
                                                            <h5 className="fmaroon f_sz15">Leave a message</h5>
                                                          </div>
                                                          <div className="card-body">
                                                            <div className="form-group row mt-2 mb-2">
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <textarea
                                                                  className="form-control textarea_hgt100 txtarea_resizenone"
                                                                  placeholder="Enter the Message"
                                                                  value={this.state.LeavAutoVceMsgVle}
                                                                  onChange={this.AtoVoicLeaveMSgonChng}
                                                                />
                                                              </div>
                                                            </div>
                                                            {/* <div className="form-group row mt-4 mb-2">
                                                              <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10"><span className="f_sz15">Max No. of Response</span></label>
                                                              <div className="col-12 col-sm-12 col-md-6 col-lg-8">
                                                                <input type="text" className="form-control text-center txtbx_sm" value={this.state.LeavAutoVoiceMxmRspnsVlu} onChange={this.AtoVoicLeaveMSgMxmRspnsOnChang} maxlength="2"/> 
                                                              </div>      
                                                            </div> */}
                                                          </div>
                                                          <div className="card-footer bg-transparent text-center ">
                                                            <a
                                                              className="btn btn-black crsr_pntr btnpdng_sm mr-2"
                                                              onClick={this.AtoVcRspnsSaveClick}
                                                              id="AtoVcRspnsSave_id">
                                                              Save
                                                            </a>
                                                            {this.state.leaveMsgDelDisble ? (
                                                              <a className="btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled">
                                                                Delete
                                                              </a>
                                                            ) : (
                                                              <a
                                                                className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                                onClick={this.atoVcRspnLevMsgDelClk}>
                                                                Delete
                                                              </a>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="autovoicedesc"
                                                      id="autovoicemsg2"
                                                      style={{ display: 'none' }}>
                                                      <div className="all_contentflex_div">
                                                        <div className="card w-100 mt-2 mb-4 shadow-none">
                                                          <div className="card-header">
                                                            <h5 className="fmaroon f_sz15">Hangup without message</h5>
                                                          </div>
                                                          {/* <div className="card-body">
                                                            <div className="form-group row mt-2 mb-2">
                                                              <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10"><span className="f_sz15">Max No. of Response</span></label>
                                                              <div className="col-12 col-sm-12 col-md-6 col-lg-8">
                                                                <input type="text" className="form-control text-center txtbx_sm" value={this.state.HangMsgValue} onChange={this.hangmsgOnChang} maxlength="2"/> 
                                                              </div>      
                                                            </div>
                                                          </div> */}
                                                          <div className="card-footer bg-transparent text-center ">
                                                            <a
                                                              className="btn btn-black crsr_pntr btnpdng_sm mr-2"
                                                              onClick={this.SaveHngMsgwithout}
                                                              id="SaveHngMsgwithout_id">
                                                              Save
                                                            </a>
                                                            {this.state.hangupMsgDelDisble ? (
                                                              <a className="btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled">
                                                                Delete
                                                              </a>
                                                            ) : (
                                                              <a
                                                                className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                                onClick={this.DelHngMsgwithout}>
                                                                Delete
                                                              </a>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              {/*New design*/}
                                              <div className="card w-100 mt-3">
                                                <div className="card-body py-0">
                                                  <div className={this.state.AtoViceRescls}>
                                                    {this.state.AtoViceResMsg}
                                                  </div>
                                                  <div className="form-group row mt-2 mb-2">
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <textarea
                                                        className="form-control textarea_hgt100 txtarea_resizenone"
                                                        placeholder="Enter the Message"
                                                        value={this.state.LeavAutoVceMsgVle}
                                                        onChange={this.AtoVoicLeaveMSgonChng}
                                                        onClick={() => this.hide_emoji()}
                                                        maxLength="300"
                                                      />
                                                      <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                        <div className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_inbound_calls_show emoji_show_all">
                                                          <i
                                                            onClick={() => {
                                                              this.render_emoji('Auto_txt_inbound_calls');
                                                            }}
                                                            className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative"
                                                          />
                                                          <a
                                                            className="crsr_pntr auto_txt_res_open1"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.LeavAutoVceMsgVle_unique_id,
                                                                'auto_inbound_calls',
                                                                'auto_inbound_calls_container',
                                                                false,
                                                              )
                                                            }>
                                                            <i
                                                              className={
                                                                this.state.LeavAutoVceMsgVle_unique_id
                                                                  ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                                  : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                                              }
                                                            />
                                                          </a>
                                                        </div>
                                                        <div
                                                          className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_inbound_calls_close emoji_close_all"
                                                          style={{ display: 'none' }}>
                                                          <i
                                                            onClick={() => {
                                                              this.render_emoji('Auto_txt_inbound_calls');
                                                            }}
                                                            className={
                                                              'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                            }
                                                          />
                                                          <a
                                                            className="crsr_pntr auto_txt_res_open1"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.LeavAutoVceMsgVle_unique_id,
                                                                'auto_inbound_calls',
                                                                'auto_inbound_calls_container',
                                                                false,
                                                              )
                                                            }>
                                                            <i
                                                              className={
                                                                this.state.LeavAutoVceMsgVle_unique_id
                                                                  ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                                  : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                                              }
                                                            />
                                                          </a>
                                                        </div>
                                                        {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                      </div>
                                                      <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                        <span
                                                          className="flex-row flex-wrap emoji_position emoji_disable"
                                                          style={{
                                                            display: 'none',
                                                            position: 'inherit',
                                                            width: 'inherit',
                                                            zIndex: '10',
                                                          }}
                                                          id="Auto_txt_inbound_calls"></span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group w-100 mt-4 mb-2 text-center"
                                                    onClick={() => this.hide_emoji()}>
                                                    <div className="sendmessage_btnsdiv">
                                                      <div className="dropdown attachment_drpdwn d-inline-block">
                                                        <span className="sendmessage_btnsspan">
                                                          <span
                                                            className="btn btn-lg btn-black crsr_pntr btnpdng_sm"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.LeavAutoVceMsgVle_unique_id,
                                                                'auto_inbound_calls',
                                                                'auto_inbound_calls_container',
                                                                true,
                                                              )
                                                            }>
                                                            <i className="fas fa-paperclip" />
                                                          </span>
                                                        </span>

                                                        <div
                                                          className="dropdown-menu dropdown-menu-lg dropdown-menu-right auto_inbound_calls auto_all_inbound"
                                                          onMouseLeave={() => this.status_hide('auto_inbound_calls')}
                                                          onClick={() => this.status_hide('auto_inbound_calls')}>
                                                          <div className="dropdown-item">
                                                            <div className="overallattachment_div">
                                                              <div
                                                                className="overallattach_item sendmsgtempattach_clk"
                                                                onClick={
                                                                  this.state.savingprogress === '...'
                                                                    ? null
                                                                    : this.saveNotes2_cmb
                                                                }>
                                                                <div className="overallattach_icon bg_notes bx_shadow_sm">
                                                                  <i className="far fa-sticky-note" />
                                                                </div>
                                                                <div className="fgrey">Notes</div>
                                                              </div>
                                                              <div className="overallattach_item sendmsgtempattach_clk">
                                                                <label for="file-input">
                                                                  <div
                                                                    className="overallattach_icon bg_documents bx_shadow_sm"
                                                                    id="fdupld">
                                                                    <i className="far fa-file-alt" />
                                                                    <input
                                                                      id="file-input"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      onChange={this.fileGetDetails_cmb}
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                </label>
                                                                <div className="fgrey">Documents</div>
                                                              </div>
                                                              <div className="overallattach_item">
                                                                <label htmlFor="file-input3">
                                                                  <div
                                                                    className="overallattach_icon bg_gallery bx_shadow_sm"
                                                                    id="fdupld_2">
                                                                    <i
                                                                      className="far fa-image"
                                                                      data-place="bottom"
                                                                      data-tip="Images"
                                                                    />
                                                                    <input
                                                                      id="file-input3"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                                                      onChange={(event) =>
                                                                        this.fileGetDetails_cmb_images(event)
                                                                      }
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                  {/* <ReactTooltip /> */}
                                                                </label>
                                                                <div className="fgrey">Gallery</div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.birthdyTxtValue_unique_id,
                                                            'auto_inbound_calls',
                                                            'auto_inbound_calls_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkAudio2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkAudio2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-microphone-alt" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.birthdyTxtValue_unique_id,
                                                            'auto_inbound_calls',
                                                            'auto_inbound_calls_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkVideo2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkVideo2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-video" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <a
                                                        className="btn btn-black crsr_pntr btnpdng_sm mr-2"
                                                        onClick={this.AtoVcRspnsSaveClick}
                                                        id="AtoVcRspnsSave_id">
                                                        Save
                                                      </a>
                                                      {this.state.leaveMsgDelDisble ? (
                                                        <a className="btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled">
                                                          Delete
                                                        </a>
                                                      ) : (
                                                        <a
                                                          className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                          onClick={this.atoVcRspnLevMsgDelClk}>
                                                          Delete
                                                        </a>
                                                      )}
                                                    </div>

                                                    {/* <a className="btn btn-black crsr_pntr m-2 btnpdng_sm">Save</a>   
                                                            <a className="btn btn-black crsr_pntr m-2 btnpdng_sm">Delete</a> */}
                                                  </div>
                                                  <div className="card-body px-0 pb-0 auto_response_all_container auto_inbound_calls_container">
                                                    <div
                                                      className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb scrollbar_style"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="row position-relative">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <div className="attachment_timelinediv">
                                                            {/* The time line */}
                                                            <div className="timeline">
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkAudio2_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span className="ml-2">
                                                                            <span className="crsr_pntr">
                                                                              <i
                                                                                className="fas fa-record-vinyl fa-2x fbred"
                                                                                onClick={this.audio_start_cmb}
                                                                              />
                                                                              <span
                                                                                className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                onClick={this.audio_start_cmb}>
                                                                                Start Recording
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.audioLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>

                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="audioRecordLoading_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span>
                                                                            <span className="d-inline-block">
                                                                              <span className="crsr_pntr">
                                                                                <i
                                                                                  className="far fa-stop-circle f_sz30 fbred"
                                                                                  onClick={this.audio_stop_cmb}></i>
                                                                                <span
                                                                                  className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                  onClick={this.audio_stop_cmb}>
                                                                                  Stop Recording
                                                                                </span>
                                                                              </span>
                                                                              <span className="f_sz16">
                                                                                <span>
                                                                                  <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkNotes2_cmb">
                                                                <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <textarea
                                                                      className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                                                      placeholder="Enter the notes"
                                                                      value={this.state.notesValue2_cmb}
                                                                      onChange={this.notesLetter2_cmb}
                                                                      id="notestypearea"
                                                                    />
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a
                                                                      className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.saveNotes2_cmb}>
                                                                      Save
                                                                    </a>
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.notesLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkVideo2_cmb">
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                                            <VideoRecorder
                                                                              replayVideoAutoplayAndLoopOff={true}
                                                                              // showReplayControls={true}
                                                                              // mimeType="video/mp4"
                                                                              // constraints={{audio: true}}
                                                                              timeLimit={120000}
                                                                              onRecordingComplete={(
                                                                                videoBlob,
                                                                                thumbnailBlob,
                                                                                videoUrl,
                                                                              ) => {
                                                                                $(
                                                                                  '.sendmsgattach_clkVideo2_cmb',
                                                                                ).hide();
                                                                                $('.sendmsg_attachmentdiv2_cmb').hide();

                                                                                $('.attachLoading_cmb').show();
                                                                                $('.attchLstShow_cmb').show();
                                                                                this.setState({
                                                                                  lodingicon_cmb:
                                                                                    'fas fa-film bg_video',
                                                                                });

                                                                                // Do something with the video...
                                                                                console.log(
                                                                                  'videoBloburl',
                                                                                  window.URL.createObjectURL(videoBlob),
                                                                                );
                                                                                console.log('videoBlob', videoBlob);
                                                                                console.log(
                                                                                  'thumbnailBlob',
                                                                                  thumbnailBlob,
                                                                                );
                                                                                console.log('videoUrl', videoUrl);
                                                                                var reader = new FileReader();
                                                                                reader.readAsDataURL(videoBlob);
                                                                                reader.onloadend = function () {
                                                                                  var base64data = reader.result;
                                                                                  // console.log(base64data);
                                                                                };
                                                                                var filename = new Date().toISOString();
                                                                                const data = new FormData();
                                                                                var mp4file = new File(
                                                                                  [videoBlob],
                                                                                  filename + '.mp4',
                                                                                  {
                                                                                    type: 'video/mp4',
                                                                                    lastModified: new Date(),
                                                                                  },
                                                                                );

                                                                                data.append(
                                                                                  'apikey',
                                                                                  'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                                                );
                                                                                data.append('secret', 'R1eqD2twI3E4');
                                                                                data.append(
                                                                                  'user_id',
                                                                                  this.state.user_id,
                                                                                );
                                                                                data.append(
                                                                                  'business_id',
                                                                                  this.state.business_id,
                                                                                );
                                                                                data.append(
                                                                                  'file',
                                                                                  videoBlob,
                                                                                  filename,
                                                                                );
                                                                                data.append('reference', 'text');
                                                                                // data.append('type', 'video');

                                                                                axios
                                                                                  .post(
                                                                                    API_CALL_ENDPOINT + '/file/upload',
                                                                                    data,
                                                                                  )
                                                                                  .then((res) => {
                                                                                    // console.log(res);
                                                                                    // console.log(res.data.message);
                                                                                    // console.log(res.data?.result?.files);

                                                                                    if (res.data.status == 'success') {
                                                                                      var file_url = '';
                                                                                      var file_path = '';
                                                                                      var file_url2 = '';
                                                                                      var second_file_path = '';
                                                                                      var file_url3 = '';
                                                                                      var file_url4 = '';
                                                                                      var file_id = '';
                                                                                      for (var i in res.data.result
                                                                                        .files) {
                                                                                        console.log(
                                                                                          res.data.result.files[i]
                                                                                            .file_url,
                                                                                        );
                                                                                        file_url +=
                                                                                          res.data.result.files[i]
                                                                                            .file_url;
                                                                                        file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .file_path;
                                                                                        file_url2 +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_url;
                                                                                        second_file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_path;
                                                                                        file_url3 +=
                                                                                          res.data.result.files[i]
                                                                                            .third_file_url;
                                                                                        file_url4 +=
                                                                                          res.data.result.files[i]
                                                                                            .fourth_file_url;
                                                                                        file_id +=
                                                                                          res.data.result.files[i]._id;
                                                                                        var joined_videoId =
                                                                                          this.state.attchmnt_videoId_cmb.concat(
                                                                                            res.data.result.files[i]
                                                                                              ._id,
                                                                                          );
                                                                                        this.setState({
                                                                                          attchmnt_videoId_cmb:
                                                                                            joined_videoId,
                                                                                        });
                                                                                      }
                                                                                      const atchId_recrd =
                                                                                        res.data.result.files[0]._id;
                                                                                      console.log(atchId_recrd);

                                                                                      setTimeout(() => {
                                                                                        console.log(
                                                                                          this.state.atcharryDet_cmb,
                                                                                        );
                                                                                      }, 150);

                                                                                      $('.attachLoading_cmb').hide();
                                                                                      $(
                                                                                        '#attachLoading_cmb_video',
                                                                                      ).hide();

                                                                                      const video_details = {
                                                                                        apikey: API_KEY,
                                                                                        secret: API_SECRET,
                                                                                        user_id: this.state.user_id,
                                                                                        business_id:
                                                                                          this.state.business_id,
                                                                                        attachment: atchId_recrd,
                                                                                        attachment_type: 'video',
                                                                                        unique_id:
                                                                                          this.state.message_edit ===
                                                                                            false
                                                                                            ? Rnunique_id_cmb
                                                                                            : this.state.Rnunique_id_cmb
                                                                                              .append
                                                                                              ? this.state.Rnunique_id_cmb
                                                                                              : Rnunique_id_cmb,
                                                                                        order:
                                                                                          '' +
                                                                                          this.state
                                                                                            .attachOrderIncrs_cmb +
                                                                                          '',
                                                                                      };

                                                                                      axios
                                                                                        .post(
                                                                                          API_CALL_ENDPOINT +
                                                                                          '/text/attachment/create',
                                                                                          video_details,
                                                                                        )
                                                                                        .then((res) => {
                                                                                          console.log(res);
                                                                                          console.log(res.data.message);

                                                                                          if (
                                                                                            res.data.status == 'success'
                                                                                          ) {
                                                                                            this.setState({
                                                                                              messageAttachd_cmb: true,
                                                                                            });
                                                                                            this.setState({
                                                                                              atcharryDet_cmb: [
                                                                                                {
                                                                                                  file_path: file_path,
                                                                                                  second_file_path:
                                                                                                    second_file_path,
                                                                                                  video_id: file_id,
                                                                                                  video_url: file_url,
                                                                                                  video_url2: file_url2,
                                                                                                  video_url3: file_url3,
                                                                                                  video_url4: file_url4,
                                                                                                  attach_id:
                                                                                                    res.data.result._id,
                                                                                                },
                                                                                                ...this.state
                                                                                                  .atcharryDet_cmb,
                                                                                              ],
                                                                                            });
                                                                                            var OrderIncr =
                                                                                              this.state
                                                                                                .attachOrderIncrs_cmb +
                                                                                              parseInt(1);
                                                                                            this.setState({
                                                                                              attachOrderIncrs_cmb:
                                                                                                OrderIncr,
                                                                                            });
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            $(
                                                                                              '.attachment_colapsed_' +
                                                                                              file_id,
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded_' +
                                                                                              file_id,
                                                                                            ).show();
                                                                                          }
                                                                                          if (res.data.error) {
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            // $('.attachment_colapsed_'+file_id).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            // $('.attachment_expanded_'+file_id).show();
                                                                                          }
                                                                                        })
                                                                                        .catch((error) => {
                                                                                          if (error.response) {
                                                                                            if (
                                                                                              error.response.data.error
                                                                                            ) {
                                                                                              $(
                                                                                                '.attachment_colapsed',
                                                                                              ).show();
                                                                                              // $('.attachment_colapsed_'+file_id).hide();
                                                                                              $(
                                                                                                '.attachment_expanded',
                                                                                              ).hide();
                                                                                              // $('.attachment_expanded_'+file_id).show();
                                                                                            }
                                                                                          }
                                                                                        });

                                                                                      console.log(file_url);
                                                                                    }
                                                                                  });
                                                                              }}
                                                                              setVideo={(blob) => {
                                                                                let blobUrl = URL.createObjectURL(blob);
                                                                                console.log(blobUrl);
                                                                                // this.setState({ captureVideoUrl: blobUrl })
                                                                              }}
                                                                            />
                                                                            {/* </div> */}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.videoLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell w-70 align-top">
                                                                          <span className="attachrecord_icon bg_video crsr_pntr">
                                                                            <i className="fas fa-film" />
                                                                          </span>
                                                                        </div>
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="f_sz16">
                                                                            <span>
                                                                              <i className="fas fa-spinner fa-spin f_sz24" />
                                                                            </span>
                                                                            <span
                                                                              className="ml-2"
                                                                              style={{
                                                                                display: 'none',
                                                                              }}>
                                                                              0.10
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}

                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                          defaultValue={10}
                                                                          disabled
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              <div id="attachLoading_cmb_video">
                                                                <i
                                                                  className="fas fa-circle bg-gray"
                                                                  style={{ fontSize: 'x-small' }}
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className="attchLstShow_cmb"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                                                        <div className="attachment_timelinediv">
                                                          {/* The time line */}

                                                          {/* The time line */}
                                                          <div
                                                            // onDragOver={this.dragOver_cmb}
                                                            className="timeline"
                                                            id="timelineprepend">
                                                            <div
                                                              id="attachLoading_cmb"
                                                              className="attachLoading_cmb"
                                                              style={{ display: 'none' }}>
                                                              <i
                                                                className={
                                                                  this.state.lodingicon_cmb + ' attachtype_timelineicon'
                                                                }
                                                              />
                                                              <div className="timeline-item">
                                                                <div className="timeline-body">
                                                                  <div className="attachmentbody_div d-table">
                                                                    <span>
                                                                      <span className="d-inline-block">
                                                                        <span>
                                                                          <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                                        </span>
                                                                        <span className="postop_5up">
                                                                          This might take few mins, please hold on while
                                                                          we process your attachment
                                                                        </span>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                                <div className="timeline-footer"></div>
                                                              </div>
                                                            </div>

                                                            {this.state.atcharryDet_cmb.map((attachment, index) => {
                                                              return attachment.notes_content1 ? (
                                                                <>
                                                                  <div
                                                                    className={'editor_cmb_' + attachment.attach_id}
                                                                    style={{ display: 'none' }}>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        // onClick={() => {
                                                                        //   this.oneditnotecmb(attachment);
                                                                        // }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          {/* <ReactQuill
                                                                            // theme="bubble"

                                                                            modules={{
                                                                              toolbar: [
                                                                                [
                                                                                  'bold',
                                                                                  'italic',
                                                                                  'underline',
                                                                                  'strike',
                                                                                ],
                                                                                [
                                                                                  {header: '1'},
                                                                                  {header: '2'},
                                                                                  {font: []},
                                                                                ],
                                                                                [
                                                                                  {list: 'ordered'},
                                                                                  {list: 'bullet'},
                                                                                  {indent: '-1'},
                                                                                  {indent: '+1'},
                                                                                ],
                                                                                ['link', 'video'],
                                                                                ['clean'],
                                                                              ],

                                                                              clipboard: {
                                                                                // toggle to add extra line breaks when pasting HTML:
                                                                                matchVisual: false,
                                                                              },
                                                                            }}
                                                                            formats={[
                                                                              'header',
                                                                              'font',
                                                                              'size',
                                                                              'bold',
                                                                              'italic',
                                                                              'underline',
                                                                              'strike',
                                                                              'list',
                                                                              'bullet',
                                                                              'indent',
                                                                              'link',
                                                                              'video',
                                                                            ]}
                                                                            value={this.state.notesValue2_cmb}
                                                                            onChange={this.notesLetter2_cmb}
                                                                            maxLength="600"
                                                                          /> */}
                                                                          <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={this.state.notesValue2_cmb}
                                                                            id="mytext"
                                                                            config={editorConfiguration}
                                                                            onReady={(editor) => {
                                                                              // You can store the "editor" and use when it is needed.
                                                                              // console.log( 'Editor is ready to use!', editor );
                                                                            }}
                                                                            onChange={(event, editor) => {
                                                                              const data = editor.getData();
                                                                              // console.log( { event, editor, data } );
                                                                              // if (data.length <= 1200) {
                                                                              this.setState({
                                                                                notesValue2_cmb: data,
                                                                                chars_left_notes_cmb:
                                                                                  this.state.max_chars_notes_cmb -
                                                                                  data.length,
                                                                              });
                                                                              // }
                                                                            }}
                                                                            onBlur={(event, editor) => {
                                                                              // console.log( 'Blur.', editor );
                                                                            }}
                                                                            onFocus={(event, editor) => {
                                                                              // console.log( 'Focus.', editor );
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </div>

                                                                      {/* {this.state.cmb_notesedit === true ? (
                                                                        <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                                                                          {this.state.savingprogress}
                                                                        </div>
                                                                      ) : null} */}

                                                                      {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                                                        
                                                                        Maximum 1200 characters
                                                                      </div> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        {/* {this.state.cmb_notesedit === true ? (
                                                                          <a
                                                                            className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                            onClick={() => {
                                                                              this.updateNotes2_cmb();
                                                                            }}>
                                                                            Update
                                                                          </a>
                                                                        ) : null} */}
                                                                        <a
                                                                          className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() => {
                                                                            this.updateNotes2_cmb();
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                                          Save
                                                                        </a>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() =>
                                                                            this.notesAtchDelte_cmb_edit(
                                                                              attachment.attach_id,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>

                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                    // draggable="true"
                                                                    // onDragEnd={this.dragEnd_cmb}
                                                                    // onDragStart={this.dragStart_cmb}
                                                                    className={
                                                                      'notecontent_cmb_show notecontent_cmb_' +
                                                                      attachment.attach_id
                                                                    }>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        onClick={() => {
                                                                          this.oneditnotecmb(attachment);
                                                                        }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          <Linkify
                                                                            componentDecorator={(
                                                                              decoratedHref,
                                                                              decoratedText,
                                                                              key,
                                                                            ) => (
                                                                              <a
                                                                                target="blank"
                                                                                href={decoratedHref}
                                                                                key={key}>
                                                                                {decoratedText}
                                                                              </a>
                                                                            )}>
                                                                            <div
                                                                              dangerouslySetInnerHTML={{
                                                                                __html: attachment.notes_content,
                                                                              }}
                                                                            />
                                                                            {/* {attachment.notes_content} */}
                                                                          </Linkify>
                                                                        </div>
                                                                      </div>

                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={this.notesAtchDelte_cmb}>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                          {/* </span> */}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              ) : attachment.documents ? (
                                                                attachment.documents.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                  // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                  >
                                                                    <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          <span className="font-weight-bold">
                                                                            Documents:
                                                                          </span>
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.documents.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.documents,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>

                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Document Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.images ? (
                                                                attachment.images.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={this.dragEnd_cmb}
                                                                  // onDragStart={this.dragStart_cmb}
                                                                  >
                                                                    <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          {/* <span className="font-weight-bold">Images:</span> */}
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.images.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                    {/* <div className="attachdoc_delete">
                                                                                      <a
                                                                                        href="javascript:void(0)"
                                                                                        className="crsr_pntr">
                                                                                        <i
                                                                                          className="far fa-trash-alt f_sz15"
                                                                                          onClick={this.DocLclDlete_cmb}
                                                                                          id={documentList.file_id}
                                                                                          data-id={attachment.attach_id}
                                                                                        />
                                                                                      </a>
                                                                                    </div> */}
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.images,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Image Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.audio_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                  <div className="timeline-item ">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <div className="attachmentbody_div d-table">
                                                                        <div className="d-table-row">
                                                                          <div className="d-table-cell align-middle">
                                                                            <span>
                                                                              <span className="d-inline-block">
                                                                                <span className="crsr_pntr">
                                                                                  <i
                                                                                    className={
                                                                                      'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={() => {
                                                                                      this.audioPly_temp(attachment);
                                                                                    }}
                                                                                    id={attachment.audio_id}
                                                                                  />
                                                                                  <i
                                                                                    className={
                                                                                      'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={this.audioPaue}
                                                                                    id={attachment.audio_id}
                                                                                    style={{
                                                                                      display: 'none',
                                                                                    }}></i>
                                                                                  <span
                                                                                    className="ml-2 d-inline-block postop_5up"
                                                                                  // style={{
                                                                                  //   display: 'none',
                                                                                  // }}
                                                                                  ></span>
                                                                                  <audio
                                                                                    className={
                                                                                      'audioplayer123 audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    style={{
                                                                                      width: '258px',
                                                                                      display: 'none',
                                                                                    }}
                                                                                    src={
                                                                                      this.state.play_audio_url
                                                                                        ? this.state.play_audio_url
                                                                                        : undefined
                                                                                    }
                                                                                    controls="controls"
                                                                                    controlsList="nodownload"
                                                                                    //hidden
                                                                                    id={
                                                                                      'audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                  />
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.audioAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.audio_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.audio_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Audio Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.audio_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : attachment.video_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                                                  <div className="timeline-item">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                        <span className="font-weight-bold">Video:</span>
                                                                        <br />
                                                                        <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                          <a
                                                                            onClick={() =>
                                                                              this.Video_play_url(attachment)
                                                                            }>
                                                                            {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                              <div className="attachdoc_type text-center">
                                                                <i className="fas fa-video" />
                                                              </div>
                                                              <div className="attachdoc_name">
                                                                Click here to
                                                                play video
                                                              </div>
                                                            </div> */}
                                                                            <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                                              <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                                                {/* <img src={} border={0} /> */}
                                                                                <i className="fas fa-video fa-3x" />
                                                                              </div>
                                                                              <div className="attachvideo_gif">
                                                                                {/* <img src={} border={0} /> */}
                                                                                Click here to play video
                                                                              </div>
                                                                            </div>
                                                                            {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* <div className="attachmentbody_div d-table">
                                                        <div className="d-table-row">
                                                          <div className="d-table-cell align-middle">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="videoWrapper">
                                                                <video
                                                                  onPlay={() =>
                                                                    this.Video_play_url(
                                                                      attachment
                                                                    )
                                                                  }
                                                                  width="300"
                                                                  controls
                                                                  playsinline
                                                                >
                                                                  
                                                                  <source
                                                                    src={
                                                                      this.state
                                                                        .video_play_link
                                                                    }
                                                                    type="video/mp4"
                                                                  />                                                                
                                                                </video>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div> */}
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.videAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className={
                                                                          'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                        }
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.attach_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.attach_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Video Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : null;
                                                            })}

                                                            <div>
                                                              <i
                                                                className="fas fa-circle bg-gray"
                                                                style={{ fontSize: 'x-small' }}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="brdrtop_dashed"></div>
                                          <div className="joyride_autores4 w-100 RbotVoiceGreetingInboundCall">
                                            <div className="form-group row mt-5 mb-4" onClick={() => this.hide_emoji()}>
                                              <label className="col-12 col-sm-12 col-md-7 col-lg-7 col-form-label">
                                                R-Bot Voice Greetings for Inbound Calls
                                              </label>
                                              <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                                                <div>
                                                  <div className="custom-control custom-switch">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input voicemsg_tgl"
                                                      id="voicemsg"
                                                      onClick={this.voicemsg_tgl}
                                                    />
                                                    <label className="custom-control-label" htmlFor="voicemsg" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="voicemsg_tgldiv" style={{ display: 'none' }}>
                                              <div className="card w-100 mt-3">
                                                <div className="card-body py-0">
                                                  <div
                                                    className="form-group mt-2 mb-2"
                                                    onClick={() => this.hide_emoji()}>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0">
                                                      <div className="all_contentflex_div icheck_lbl">
                                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 pl-0">
                                                          <div className="icheck-darkgrey d-inline-block py-2">
                                                            <input
                                                              type="radio"
                                                              name="voice_message"
                                                              id="voice_record"
                                                              defaultValue={1}
                                                              onClick={this.voice_message}
                                                            />
                                                            <label htmlFor="voice_record">Record</label>
                                                          </div>
                                                        </div>
                                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                                          <div className="icheck-darkgrey d-inline-block py-2">
                                                            <input
                                                              type="radio"
                                                              name="voice_message"
                                                              id="voice_typetxt"
                                                              defaultValue={2}
                                                              onClick={this.voice_message}
                                                            />
                                                            <label htmlFor="voice_typetxt">Type a text</label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="voicedesc" id="voicemsg1" style={{ display: 'none' }}>
                                                    <div className="all_contentflex_div">
                                                      <div className="card w-100 mt-2 mb-4 shadow-none">
                                                        <div className="card-header">
                                                          <h5 className="fmaroon f_sz15">Record</h5>
                                                        </div>
                                                        <div className="card-body">
                                                          <div className={this.state.ViceGrtcls}>
                                                            {this.state.ViceGrtMsg}
                                                          </div>
                                                          <div className="d-table w-100">
                                                            <div className="d-table-row">
                                                              <div className="d-table-cell w-70 align-top">
                                                                <span className="attachrecord_icon bg_audio crsr_pntr">
                                                                  <i className="fas fa-microphone-alt" />
                                                                </span>
                                                              </div>
                                                              <div className="d-table-cell align-middle">
                                                                <span style={{ display: 'none' }}>
                                                                  <span className="d-inline-block">
                                                                    <span className="crsr_pntr">
                                                                      <i className="fas fa-record-vinyl fa-2x" />
                                                                      <span className="ml-2 d-inline-block postop_5up mr-2 fmaroon">
                                                                        Start Recording
                                                                      </span>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                                <span style={{ display: 'none' }}>
                                                                  <span className="d-inline-block">
                                                                    <span className="crsr_pntr">
                                                                      <i className="far fa-stop-circle f_sz30" />
                                                                      <span className="ml-2 d-inline-block postop_5up mr-2 fmaroon">
                                                                        Stop Recording
                                                                      </span>
                                                                    </span>
                                                                    <span className="f_sz16">
                                                                      <span>
                                                                        <i className="fas fa-spinner fa-spin f_sz24" />
                                                                      </span>
                                                                      <span className="ml-2 d-inline-block postop_3up">
                                                                        0.08
                                                                      </span>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                                <span style={{ display: 'block' }}>
                                                                  <span className="d-inline-block">
                                                                    <span className="crsr_pntr">
                                                                      <i
                                                                        className="far fa-play-circle fa-2x"
                                                                        style={{ display: 'none' }}
                                                                        onClick={this.VoiceGrtnaudio_play}
                                                                        id="audioPlayVoiceGrtng"
                                                                      />
                                                                      <i
                                                                        className="far fa-stop-circle f_sz30"
                                                                        onClick={this.VoiceGrtnaudio_stop}
                                                                        id="audioStopVoiceGrtng"
                                                                        style={{ display: 'none' }}
                                                                      />
                                                                      <i
                                                                        className="fas fa-record-vinyl fa-2x"
                                                                        onClick={this.VoiceGrtnaudio_start}
                                                                        id="audioStrtVoiceGrtng"
                                                                      />
                                                                      <i
                                                                        className="fas fa-pause f_sz24"
                                                                        onClick={this.VoiceGrtnaudio_pause}
                                                                        id="audioPauseVoiceGrtng"
                                                                        style={{ display: 'none' }}
                                                                      />
                                                                      <audio
                                                                        hidden
                                                                        src={this.state.VoiceGrtngblobURL}
                                                                        controls="controls"
                                                                        id="voiceGretngRcrd"
                                                                      />
                                                                      {/*<span className="ml-2 d-inline-block postop_5up">1:08</span>*/}
                                                                    </span>
                                                                    {/*<i class="far fa-pause-circle"></i> ----Pls use this for pause----*/}
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="card-footer bg-transparent text-center ">
                                                          {this.state.VoiceGrtngblobURL ? (
                                                            <a
                                                              className="btn btn-black crsr_pntr btnpdng_sm mr-2"
                                                              onClick={this.SaveVoiceGrrtng}
                                                              id="VoiceGrrtngRecSv_id">
                                                              Save
                                                            </a>
                                                          ) : (
                                                            <a className="btn btn-black crsr_pntr btnpdng_sm mr-2 isdisabled">
                                                              Save
                                                            </a>
                                                          )}
                                                          {/* <a className="btn btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.SaveVoiceGrrtng} id="VoiceGrrtngRecSv_id">Save</a> */}
                                                          {this.state.VoiceGrtngRecDeltDisble ? (
                                                            <a className="btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled">
                                                              Delete
                                                            </a>
                                                          ) : (
                                                            <a
                                                              className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                              onClick={this.DelVoiceGrrtng}>
                                                              Delete
                                                            </a>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="voicedesc" id="voicemsg2" style={{ display: 'none' }}>
                                                    <div className="all_contentflex_div">
                                                      <div className="card w-100 mt-2 mb-4 shadow-none">
                                                        <div className="card-header">
                                                          <h5 className="fmaroon f_sz15">Type a Text</h5>
                                                        </div>
                                                        <div className="card-body">
                                                          <div className={this.state.ViceGrtcls}>
                                                            {this.state.ViceGrtMsg}
                                                          </div>
                                                          <div className="form-group row mt-2 mb-2">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <textarea
                                                                className="form-control textarea_hgt100 txtarea_resizenone"
                                                                placeholder="Enter Text Message"
                                                                value={this.state.TxtVoiceGrtngvlue}
                                                                onChange={this.TxtVoiceGrtngOnChg}
                                                                onBlur={this.handleBlur}
                                                                id="TxtVoiceGrtngvlue_id"
                                                                onClick={() => this.hide_emoji()}
                                                                maxLength="300"
                                                              />
                                                              <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                                <div
                                                                  className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_voice_greetings_show emoji_show_all"
                                                                  onClick={() => {
                                                                    this.render_emoji('Auto_txt_voice_greetings');
                                                                  }}>
                                                                  <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" />
                                                                </div>
                                                                <div
                                                                  className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_voice_greetings_close emoji_close_all"
                                                                  style={{ display: 'none' }}
                                                                  onClick={() => {
                                                                    this.render_emoji('Auto_txt_voice_greetings');
                                                                  }}>
                                                                  <i
                                                                    className={
                                                                      'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                                    }
                                                                  />
                                                                </div>
                                                                {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                                <span
                                                                  className="flex-row flex-wrap emoji_position emoji_disable"
                                                                  style={{
                                                                    display: 'none',
                                                                    position: 'inherit',
                                                                    width: 'inherit',
                                                                    zIndex: '10',
                                                                  }}
                                                                  id="Auto_txt_voice_greetings"></span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="form-group row mt-4 mb-2"
                                                            onClick={() => this.hide_emoji()}>
                                                            <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10">
                                                              <span className="f_sz15">Language and Region</span>
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-8">
                                                              <div className="select_style">
                                                                <select
                                                                  className="form-control"
                                                                  onChange={this.LngRgnOnChg}>
                                                                  {/*<option>--Select--</option>*/}
                                                                  {this.state.GrntVoiveLngRegin.map(
                                                                    (languageV, index) => {
                                                                      return (
                                                                        <option
                                                                          value={
                                                                            languageV.language_info[0].language_code
                                                                          }
                                                                          selected={
                                                                            this.state.VoiceLngRegn ==
                                                                              languageV.language_info[0].language_code
                                                                              ? true
                                                                              : false
                                                                          }>
                                                                          {languageV.language_info[0].language}
                                                                        </option>
                                                                      );
                                                                    },
                                                                  )}
                                                                </select>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="form-group row mt-4 mb-2"
                                                            onClick={() => this.hide_emoji()}>
                                                            <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10">
                                                              <span className="f_sz15">Voice</span>
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-8 px-0">
                                                              <div className="all_contentflex_div icheck_lbl">
                                                                {this.state.VoceLstBsOnLanguge.map((voice, index) => {
                                                                  return (
                                                                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                                                      <div className="icheck-darkgrey d-inline-block py-2">
                                                                        <input
                                                                          type="radio"
                                                                          name="vcelang"
                                                                          id={voice.voice}
                                                                          value={voice.voice}
                                                                          onClick={this.VoiceTypeClick}
                                                                          className={voice.voice}
                                                                        />
                                                                        <label htmlFor={voice.voice}>
                                                                          {voice.voice + ', ' + voice.gender}
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                  );
                                                                })}
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="form-group row mt-4 mb-2"
                                                            onClick={() => this.hide_emoji()}>
                                                            <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label">
                                                              <span className="f_sz15">Play</span>
                                                            </label>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-8">
                                                              <div className="w-100 d-inline-block mt-2">
                                                                <span style={{ display: 'block' }}>
                                                                  <span className="d-inline-block">
                                                                    <span className="fgrey mr-2">
                                                                      <i
                                                                        className="fas fa-play f_sz24 mr-2"
                                                                        title="Play"
                                                                        onClick={
                                                                          this.state.generatePlayDisble
                                                                            ? null
                                                                            : this.generateVoice_play
                                                                        }
                                                                        id="id_generateVoiceplay"
                                                                      />
                                                                      <i
                                                                        className="fas fa-spinner fa-spin f_sz24 mr-2"
                                                                        style={{ display: 'none' }}
                                                                        id="voiceGenerate_loding"
                                                                      />
                                                                      <i
                                                                        className="fas fa-pause f_sz24"
                                                                        onClick={this.generateVoice_pause}
                                                                        id="id_generateVoicepause"
                                                                        style={{ display: 'none' }}
                                                                      />
                                                                      <audio
                                                                        hidden
                                                                        src={this.state.TxtTypeVoiceUrl}
                                                                        controls="controls"
                                                                        id="generateVoiceUrl"
                                                                      />
                                                                      {/*<span className="postop_3up">1.05</span>*/}
                                                                    </span>
                                                                    <span className="postop_3up">
                                                                      or{' '}
                                                                      <a>
                                                                        <span
                                                                          className="fmaroon crsr_pntr"
                                                                          onClick={
                                                                            this.state.voiceGnrteResetdisble
                                                                              ? null
                                                                              : this.ResetVoiceGenClk
                                                                          }>
                                                                          {this.state.voiceGnrteResetdisble
                                                                            ? 'Generating'
                                                                            : 'Reset'}
                                                                        </span>
                                                                      </a>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                                <span style={{ display: 'none' }}>
                                                                  <span className="d-inline-block">
                                                                    <span className="fgrey mr-2">
                                                                      <span>
                                                                        <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                                      </span>
                                                                      <span className="postop_3up">Generating</span>
                                                                    </span>
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div
                                                          className="card-footer bg-transparent text-center "
                                                          onClick={() => this.hide_emoji()}>
                                                          <a
                                                            className="btn btn-black crsr_pntr btnpdng_sm mr-2"
                                                            onClick={this.voiceGnrteTextSave}
                                                            id="voiceGnrteTextSv_id">
                                                            Save
                                                          </a>
                                                          {this.state.VoiceGrtngTxtTypDeltDisble ? (
                                                            <a className="btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled">
                                                              Delete
                                                            </a>
                                                          ) : (
                                                            <a
                                                              className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                              onClick={this.voiceGnrteTextDelete}>
                                                              Delete
                                                            </a>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="joyride_autores5 w-100 RbotBirthdayGreeting">
                                            <div className="form-group row mt-5 mb-5" onClick={() => this.hide_emoji()}>
                                              <label className="col-12 col-sm-12 col-md-7 col-lg-7 col-form-label">
                                                R-Bot Birthday Greetings for Your Contacts
                                              </label>
                                              <div className="col-12 col-sm-12 col-md-5 col-lg-5 pt-1">
                                                <div>
                                                  <div className="custom-control custom-switch">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input bdaygreetings_tgl"
                                                      id="bdaygreetings"
                                                      onClick={this.bdaygreetings_tgl}
                                                    />
                                                    <label className="custom-control-label" htmlFor="bdaygreetings" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="bdaygreetings_tgldiv" style={{ display: 'none' }}>
                                              <div className="card w-100 mt-2 mb-5">
                                                <div className="card-body py-0">
                                                  <div className={this.state.brtGrtcls}>{this.state.brtGrtMsg}</div>

                                                  <div
                                                    className="form-group row mt-4 mb-2"
                                                    onClick={() => this.hide_emoji()}>
                                                    <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10">
                                                      <span className="f_sz15">Time</span>
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-8">
                                                      <div className="select_style selectbx_sm">
                                                        <select
                                                          className="form-control"
                                                          onChange={this.bithGrtngTimeOnchng}>
                                                          <option
                                                            value="12:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '12:00 AM' ? true : false
                                                            }>
                                                            12:00 AM
                                                          </option>
                                                          <option
                                                            value="1:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '1:00 AM' ? true : false
                                                            }>
                                                            01:00 AM
                                                          </option>
                                                          <option
                                                            value="2:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '2:00 AM' ? true : false
                                                            }>
                                                            02:00 AM
                                                          </option>
                                                          <option
                                                            value="3:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '3:00 AM' ? true : false
                                                            }>
                                                            03:00 AM
                                                          </option>
                                                          <option
                                                            value="4:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '4:00 AM' ? true : false
                                                            }>
                                                            04:00 AM
                                                          </option>
                                                          <option
                                                            value="5:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '5:00 AM' ? true : false
                                                            }>
                                                            05:00 AM
                                                          </option>
                                                          <option
                                                            value="6:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '6:00 AM' ? true : false
                                                            }>
                                                            06:00 AM
                                                          </option>
                                                          <option
                                                            value="7:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '7:00 AM' ? true : false
                                                            }>
                                                            07:00 AM
                                                          </option>
                                                          <option
                                                            value="8:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '8:00 AM' ? true : false
                                                            }>
                                                            08:00 AM
                                                          </option>
                                                          <option
                                                            value="9:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '9:00 AM' ? true : false
                                                            }>
                                                            09:00 AM
                                                          </option>
                                                          <option
                                                            value="10:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '10:00 AM' ? true : false
                                                            }>
                                                            10:00 AM
                                                          </option>
                                                          <option
                                                            value="11:00 AM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '11:00 AM' ? true : false
                                                            }>
                                                            11:00 AM
                                                          </option>
                                                          <option
                                                            value="12:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '12:00 PM' ? true : false
                                                            }>
                                                            12:00 PM
                                                          </option>
                                                          <option
                                                            value="1:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '1:00 PM' ? true : false
                                                            }>
                                                            01:00 PM
                                                          </option>
                                                          <option
                                                            value="2:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '2:00 PM' ? true : false
                                                            }>
                                                            02:00 PM
                                                          </option>
                                                          <option
                                                            value="3:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '3:00 PM' ? true : false
                                                            }>
                                                            03:00 PM
                                                          </option>
                                                          <option
                                                            value="4:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '4:00 PM' ? true : false
                                                            }>
                                                            04:00 PM
                                                          </option>
                                                          <option
                                                            value="5:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '5:00 PM' ? true : false
                                                            }>
                                                            05:00 PM
                                                          </option>
                                                          <option
                                                            value="6:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '6:00 PM' ? true : false
                                                            }>
                                                            06:00 PM
                                                          </option>
                                                          <option
                                                            value="7:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '7:00 PM' ? true : false
                                                            }>
                                                            07:00 PM
                                                          </option>
                                                          <option
                                                            value="8:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '8:00 PM' ? true : false
                                                            }>
                                                            08:00 PM
                                                          </option>
                                                          <option
                                                            value="9:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '9:00 PM' ? true : false
                                                            }>
                                                            09:00 PM
                                                          </option>
                                                          <option
                                                            value="10:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '10:00 PM' ? true : false
                                                            }>
                                                            10:00 PM
                                                          </option>
                                                          <option
                                                            value="11:00 PM"
                                                            selected={
                                                              this.state.bithGrtngTimeSelt == '11:00 PM' ? true : false
                                                            }>
                                                            11:00 PM
                                                          </option>
                                                        </select>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group row mt-4 mb-2"
                                                    onClick={() => this.hide_emoji()}>
                                                    <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10">
                                                      <span className="f_sz15">Time Zone</span>
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-8">
                                                      <div className="select_style">
                                                        <select
                                                          className="form-control"
                                                          onChange={this.bithGrtngTimeZoneOnchng}>
                                                          <option
                                                            value="GMT-1200"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-1200'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -12:00) Eniwetok, Kwajalein
                                                          </option>
                                                          <option
                                                            value="GMT-1100"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-1100'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -11:00) Midway Island, Samoa
                                                          </option>
                                                          <option
                                                            value="GMT-1000"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-1000'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -10:00) Hawaii
                                                          </option>
                                                          <option
                                                            value="GMT-0930"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0930'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -9:30) Taiohae
                                                          </option>
                                                          <option
                                                            value="GMT-0900"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0900'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -9:00) Alaska
                                                          </option>
                                                          <option
                                                            value="GMT-0700"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0800'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -8:00) Pacific Time (US &amp; Canada)
                                                          </option>
                                                          <option
                                                            value="GMT-0700"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0700'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -7:00) Mountain Time (US &amp; Canada)
                                                          </option>
                                                          <option
                                                            value="GMT-0600"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0600'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -6:00) Central Time (US &amp; Canada), Mexico City
                                                          </option>
                                                          <option
                                                            value="GMT-0500"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0500'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima
                                                          </option>
                                                          <option
                                                            value="GMT-0430"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0430'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -4:30) Caracas
                                                          </option>
                                                          <option
                                                            value="GMT-0400"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0400'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -4:00) Atlantic Time (Canada), Caracas, La Paz
                                                          </option>
                                                          <option
                                                            value="GMT-0330"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0330'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -3:30) Newfoundland
                                                          </option>
                                                          <option
                                                            value="GMT-0300"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0300'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -3:00) Brazil, Buenos Aires, Georgetown
                                                          </option>
                                                          <option
                                                            value="GMT-0200"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0200'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -2:00) Mid-Atlantic
                                                          </option>
                                                          <option
                                                            value="GMT-0100"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT-0100'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT -1:00) Azores, Cape Verde Islands
                                                          </option>
                                                          <option
                                                            value="GMT+0000"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0000'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT) Western Europe Time, London, Lisbon, Casablanca
                                                          </option>
                                                          <option
                                                            value="GMT+0100"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0100'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +1:00) Brussels, Copenhagen, Madrid, Paris
                                                          </option>
                                                          <option
                                                            value="GMT+0200"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0200'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +2:00) Kaliningrad, South Africa
                                                          </option>
                                                          <option
                                                            value="GMT+0300"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0300'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg
                                                          </option>
                                                          <option
                                                            value="GMT+0330"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0330'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +3:30) Tehran
                                                          </option>
                                                          <option
                                                            value="GMT+0400"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0400'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi
                                                          </option>
                                                          <option
                                                            value="GMT+0430"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0430'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +4:30) Kabul
                                                          </option>
                                                          <option
                                                            value="GMT+0500"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0500'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent
                                                          </option>
                                                          <option
                                                            value="GMT+0530"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0530'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +5:30) Bombay, Calcutta, Madras, New Delhi
                                                          </option>
                                                          <option
                                                            value="GMT+0545"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0545'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +5:45) Kathmandu, Pokhara
                                                          </option>
                                                          <option
                                                            value="GMT+0600"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0600'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +6:00) Almaty, Dhaka, Colombo
                                                          </option>
                                                          <option
                                                            value="GMT+0630"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0630'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +6:30) Yangon, Mandalay
                                                          </option>
                                                          <option
                                                            value="GMT+0700"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0700'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +7:00) Bangkok, Hanoi, Jakarta
                                                          </option>
                                                          <option
                                                            value="GMT+0800"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0800'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +8:00) Beijing, Perth, Singapore, Hong Kong
                                                          </option>
                                                          <option
                                                            value="GMT+0845"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0845'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +8:45) Eucla
                                                          </option>
                                                          <option
                                                            value="GMT+0900"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0900'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk
                                                          </option>
                                                          <option
                                                            value="GMT+0930"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+0930'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +9:30) Adelaide, Darwin
                                                          </option>
                                                          <option
                                                            value="GMT+1000"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1000'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +10:00) Eastern Australia, Guam, Vladivostok
                                                          </option>
                                                          <option
                                                            value="GMT+1030"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1030'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +10:30) Lord Howe Island
                                                          </option>
                                                          <option
                                                            value="GMT+1100"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1100'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +11:00) Magadan, Solomon Islands, New Caledonia
                                                          </option>
                                                          <option
                                                            value="GMT+1130"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1130'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +11:30) Norfolk Island
                                                          </option>
                                                          <option
                                                            value="GMT+1200"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1200'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +12:00) Auckland, Wellington, Fiji, Kamchatka
                                                          </option>
                                                          <option
                                                            value="GMT+1245"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1245'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +12:45) Chatham Islands
                                                          </option>
                                                          <option
                                                            value="GMT+1300"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1300'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +13:00) Apia, Nukualofa
                                                          </option>
                                                          <option
                                                            value="GMT+1400"
                                                            selected={
                                                              this.state.bithGrtngTimeZoneSelt == 'GMT+1400'
                                                                ? true
                                                                : false
                                                            }>
                                                            (GMT +14:00) Line Islands, Tokelau
                                                          </option>
                                                        </select>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mt-2 mb-2">
                                                    <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label pdngtop_10">
                                                      <span className="f_sz15">R-Bot Birthday Text</span>
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <textarea
                                                        className="form-control textarea_hgt100 txtarea_resizenone"
                                                        placeholder="Enter Text Message"
                                                        value={this.state.birthdyTxtValue}
                                                        onChange={this.birthdyTxtOnChg}
                                                        onClick={() => this.hide_emoji()}
                                                        maxLength="300"
                                                      />
                                                      <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                        <div className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_birth_greetings_show emoji_show_all">
                                                          <i
                                                            className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative"
                                                            onClick={() => {
                                                              this.render_emoji('Auto_txt_birth_greetings');
                                                            }}
                                                          />
                                                          <a
                                                            className="crsr_pntr auto_txt_res_open1"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.birthdyTxtValue_unique_id,
                                                                'auto_birthday_greeting',
                                                                'auto_birthday_greeting_container',
                                                                false,
                                                              )
                                                            }>
                                                            <i
                                                              className={
                                                                this.state.birthdyTxtValue_unique_id
                                                                  ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                                  : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                                              }
                                                            />
                                                          </a>
                                                        </div>

                                                        <div
                                                          className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_birth_greetings_close emoji_close_all"
                                                          style={{ display: 'none' }}>
                                                          <i
                                                            onClick={() => {
                                                              this.render_emoji('Auto_txt_birth_greetings');
                                                            }}
                                                            className={
                                                              'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                            }
                                                          />
                                                          <a
                                                            className="crsr_pntr auto_txt_res_open1"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.birthdyTxtValue_unique_id,
                                                                'auto_birthday_greeting',
                                                                'auto_birthday_greeting_container',
                                                                false,
                                                              )
                                                            }>
                                                            <i
                                                              className={
                                                                this.state.birthdyTxtValue_unique_id
                                                                  ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                                  : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                                              }
                                                            />
                                                          </a>
                                                        </div>

                                                        {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                      </div>
                                                      <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                        <span
                                                          className="flex-row flex-wrap emoji_position emoji_disable"
                                                          style={{
                                                            display: 'none',
                                                            position: 'inherit',
                                                            width: 'inherit',
                                                            zIndex: '10',
                                                          }}
                                                          id="Auto_txt_birth_greetings"></span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group w-100 mt-4 mb-2 text-center"
                                                    onClick={() => this.hide_emoji()}>
                                                    <div className="sendmessage_btnsdiv">
                                                      <div className="dropdown attachment_drpdwn d-inline-block">
                                                        <span className="sendmessage_btnsspan">
                                                          <span
                                                            className="btn btn-lg btn-black crsr_pntr btnpdng_sm"
                                                            onClick={() =>
                                                              this.on_auto_MessageEdit(
                                                                this.state.birthdyTxtValue_unique_id,
                                                                'auto_birthday_greeting',
                                                                'auto_birthday_greeting_container',
                                                                true,
                                                              )
                                                            }>
                                                            <i className="fas fa-paperclip" />
                                                          </span>
                                                        </span>

                                                        <div
                                                          className="dropdown-menu dropdown-menu-lg dropdown-menu-right auto_birthday_greeting auto_all_inbound"
                                                          onMouseLeave={() =>
                                                            this.status_hide('auto_birthday_greeting')
                                                          }
                                                          onClick={() => this.status_hide('auto_birthday_greeting')}>
                                                          <div className="dropdown-item">
                                                            <div className="overallattachment_div">
                                                              <div
                                                                className="overallattach_item sendmsgtempattach_clk"
                                                                onClick={
                                                                  this.state.savingprogress === '...'
                                                                    ? null
                                                                    : this.saveNotes2_cmb
                                                                }>
                                                                <div className="overallattach_icon bg_notes bx_shadow_sm">
                                                                  <i className="far fa-sticky-note" />
                                                                </div>
                                                                <div className="fgrey">Notes</div>
                                                              </div>
                                                              <div className="overallattach_item sendmsgtempattach_clk">
                                                                <label for="file-input">
                                                                  <div
                                                                    className="overallattach_icon bg_documents bx_shadow_sm"
                                                                    id="fdupld">
                                                                    <i className="far fa-file-alt" />
                                                                    <input
                                                                      id="file-input"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      onChange={this.fileGetDetails_cmb}
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                </label>
                                                                <div className="fgrey">Documents</div>
                                                              </div>
                                                              <div className="overallattach_item">
                                                                <label htmlFor="file-input3">
                                                                  <div
                                                                    className="overallattach_icon bg_gallery bx_shadow_sm"
                                                                    id="fdupld_2">
                                                                    <i
                                                                      className="far fa-image"
                                                                      data-place="bottom"
                                                                      data-tip="Images"
                                                                    />
                                                                    <input
                                                                      id="file-input3"
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                                                      onChange={(event) =>
                                                                        this.fileGetDetails_cmb_images(event)
                                                                      }
                                                                    // multiple
                                                                    />
                                                                  </div>
                                                                  {/* <ReactTooltip /> */}
                                                                </label>
                                                                <div className="fgrey">Gallery</div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.birthdyTxtValue_unique_id,
                                                            'auto_birthday_greeting',
                                                            'auto_birthday_greeting_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkAudio2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkAudio2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-microphone-alt" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="d-inline-block sendmsgtempattach_clk"
                                                        onClick={() => {
                                                          this.on_auto_MessageEdit(
                                                            this.state.birthdyTxtValue_unique_id,
                                                            'auto_birthday_greeting',
                                                            'auto_birthday_greeting_container',
                                                            false,
                                                          );
                                                          this.sendmsgattach_clkVideo2_cmb();
                                                        }}
                                                      // onClick={this.sendmsgattach_clkVideo2_cmb}
                                                      >
                                                        <span className="sendmessage_btnsspan">
                                                          <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                            <i className="fas fa-video" />
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <a
                                                        className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                        onClick={this.saveBrthgrtng}
                                                        id="saveBrthgrtng_id">
                                                        Save
                                                      </a>
                                                      {this.state.brthdyGrtngDelDisble ? (
                                                        <a className="btn btn-black crsr_pntr m-2 btnpdng_sm isdisabled">
                                                          Delete
                                                        </a>
                                                      ) : (
                                                        <a
                                                          className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                          onClick={this.DeltBrthgrtng}>
                                                          Delete
                                                        </a>
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="card-body px-0 pb-0 auto_response_all_container auto_birthday_greeting_container">
                                                    <div
                                                      className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb scrollbar_style"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="row position-relative">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <div className="attachment_timelinediv">
                                                            {/* The time line */}
                                                            <div className="timeline">
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkAudio2_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span className="ml-2">
                                                                            <span className="crsr_pntr">
                                                                              <i
                                                                                className="fas fa-record-vinyl fa-2x fbred"
                                                                                onClick={this.audio_start_cmb}
                                                                              />
                                                                              <span
                                                                                className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                onClick={this.audio_start_cmb}>
                                                                                Start Recording
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.audioLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>

                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="audioRecordLoading_cmb">
                                                                <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <span>
                                                                            <span className="d-inline-block">
                                                                              <span className="crsr_pntr">
                                                                                <i
                                                                                  className="far fa-stop-circle f_sz30 fbred"
                                                                                  onClick={this.audio_stop_cmb}></i>
                                                                                <span
                                                                                  className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                  onClick={this.audio_stop_cmb}>
                                                                                  Stop Recording
                                                                                </span>
                                                                              </span>
                                                                              <span className="f_sz16">
                                                                                <span>
                                                                                  <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkNotes2_cmb">
                                                                <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <textarea
                                                                      className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                                                      placeholder="Enter the notes"
                                                                      value={this.state.notesValue2_cmb}
                                                                      onChange={this.notesLetter2_cmb}
                                                                      id="notestypearea"
                                                                    />
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a
                                                                      className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.saveNotes2_cmb}>
                                                                      Save
                                                                    </a>
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.notesLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div
                                                                style={{ display: 'none' }}
                                                                className="sendmsgattach_clkVideo2_cmb">
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                                            <VideoRecorder
                                                                              replayVideoAutoplayAndLoopOff={true}
                                                                              // showReplayControls={true}
                                                                              // mimeType="video/mp4"
                                                                              // constraints={{audio: true}}
                                                                              timeLimit={120000}
                                                                              onRecordingComplete={(
                                                                                videoBlob,
                                                                                thumbnailBlob,
                                                                                videoUrl,
                                                                              ) => {
                                                                                $(
                                                                                  '.sendmsgattach_clkVideo2_cmb',
                                                                                ).hide();
                                                                                $('.sendmsg_attachmentdiv2_cmb').hide();

                                                                                $('.attachLoading_cmb').show();
                                                                                $('.attchLstShow_cmb').show();
                                                                                this.setState({
                                                                                  lodingicon_cmb:
                                                                                    'fas fa-film bg_video',
                                                                                });

                                                                                // Do something with the video...
                                                                                console.log(
                                                                                  'videoBloburl',
                                                                                  window.URL.createObjectURL(videoBlob),
                                                                                );
                                                                                console.log('videoBlob', videoBlob);
                                                                                console.log(
                                                                                  'thumbnailBlob',
                                                                                  thumbnailBlob,
                                                                                );
                                                                                console.log('videoUrl', videoUrl);
                                                                                var reader = new FileReader();
                                                                                reader.readAsDataURL(videoBlob);
                                                                                reader.onloadend = function () {
                                                                                  var base64data = reader.result;
                                                                                  // console.log(base64data);
                                                                                };
                                                                                var filename = new Date().toISOString();
                                                                                const data = new FormData();
                                                                                var mp4file = new File(
                                                                                  [videoBlob],
                                                                                  filename + '.mp4',
                                                                                  {
                                                                                    type: 'video/mp4',
                                                                                    lastModified: new Date(),
                                                                                  },
                                                                                );

                                                                                data.append(
                                                                                  'apikey',
                                                                                  'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                                                );
                                                                                data.append('secret', 'R1eqD2twI3E4');
                                                                                data.append(
                                                                                  'user_id',
                                                                                  this.state.user_id,
                                                                                );
                                                                                data.append(
                                                                                  'business_id',
                                                                                  this.state.business_id,
                                                                                );
                                                                                data.append(
                                                                                  'file',
                                                                                  videoBlob,
                                                                                  filename,
                                                                                );
                                                                                data.append('reference', 'text');
                                                                                // data.append('type', 'video');

                                                                                axios
                                                                                  .post(
                                                                                    API_CALL_ENDPOINT + '/file/upload',
                                                                                    data,
                                                                                  )
                                                                                  .then((res) => {
                                                                                    // console.log(res);
                                                                                    // console.log(res.data.message);
                                                                                    // console.log(res.data?.result?.files);

                                                                                    if (res.data.status == 'success') {
                                                                                      var file_url = '';
                                                                                      var file_path = '';
                                                                                      var file_url2 = '';
                                                                                      var second_file_path = '';
                                                                                      var file_url3 = '';
                                                                                      var file_url4 = '';
                                                                                      var file_id = '';
                                                                                      for (var i in res.data.result
                                                                                        .files) {
                                                                                        console.log(
                                                                                          res.data.result.files[i]
                                                                                            .file_url,
                                                                                        );
                                                                                        file_url +=
                                                                                          res.data.result.files[i]
                                                                                            .file_url;
                                                                                        file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .file_path;
                                                                                        file_url2 +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_url;
                                                                                        second_file_path +=
                                                                                          res.data.result.files[i]
                                                                                            .second_file_path;
                                                                                        file_url3 +=
                                                                                          res.data.result.files[i]
                                                                                            .third_file_url;
                                                                                        file_url4 +=
                                                                                          res.data.result.files[i]
                                                                                            .fourth_file_url;
                                                                                        file_id +=
                                                                                          res.data.result.files[i]._id;
                                                                                        var joined_videoId =
                                                                                          this.state.attchmnt_videoId_cmb.concat(
                                                                                            res.data.result.files[i]
                                                                                              ._id,
                                                                                          );
                                                                                        this.setState({
                                                                                          attchmnt_videoId_cmb:
                                                                                            joined_videoId,
                                                                                        });
                                                                                      }
                                                                                      const atchId_recrd =
                                                                                        res.data.result.files[0]._id;
                                                                                      console.log(atchId_recrd);

                                                                                      setTimeout(() => {
                                                                                        console.log(
                                                                                          this.state.atcharryDet_cmb,
                                                                                        );
                                                                                      }, 150);

                                                                                      $('.attachLoading_cmb').hide();
                                                                                      $(
                                                                                        '#attachLoading_cmb_video',
                                                                                      ).hide();

                                                                                      const video_details = {
                                                                                        apikey: API_KEY,
                                                                                        secret: API_SECRET,
                                                                                        user_id: this.state.user_id,
                                                                                        business_id:
                                                                                          this.state.business_id,
                                                                                        attachment: atchId_recrd,
                                                                                        attachment_type: 'video',
                                                                                        unique_id:
                                                                                          this.state.message_edit ===
                                                                                            false
                                                                                            ? Rnunique_id_cmb
                                                                                            : this.state.Rnunique_id_cmb
                                                                                              .append
                                                                                              ? this.state.Rnunique_id_cmb
                                                                                              : Rnunique_id_cmb,
                                                                                        order:
                                                                                          '' +
                                                                                          this.state
                                                                                            .attachOrderIncrs_cmb +
                                                                                          '',
                                                                                      };

                                                                                      axios
                                                                                        .post(
                                                                                          API_CALL_ENDPOINT +
                                                                                          '/text/attachment/create',
                                                                                          video_details,
                                                                                        )
                                                                                        .then((res) => {
                                                                                          console.log(res);
                                                                                          console.log(res.data.message);

                                                                                          if (
                                                                                            res.data.status == 'success'
                                                                                          ) {
                                                                                            this.setState({
                                                                                              messageAttachd_cmb: true,
                                                                                            });
                                                                                            this.setState({
                                                                                              atcharryDet_cmb: [
                                                                                                {
                                                                                                  file_path: file_path,
                                                                                                  second_file_path:
                                                                                                    second_file_path,
                                                                                                  video_id: file_id,
                                                                                                  video_url: file_url,
                                                                                                  video_url2: file_url2,
                                                                                                  video_url3: file_url3,
                                                                                                  video_url4: file_url4,
                                                                                                  attach_id:
                                                                                                    res.data.result._id,
                                                                                                },
                                                                                                ...this.state
                                                                                                  .atcharryDet_cmb,
                                                                                              ],
                                                                                            });
                                                                                            var OrderIncr =
                                                                                              this.state
                                                                                                .attachOrderIncrs_cmb +
                                                                                              parseInt(1);
                                                                                            this.setState({
                                                                                              attachOrderIncrs_cmb:
                                                                                                OrderIncr,
                                                                                            });
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            $(
                                                                                              '.attachment_colapsed_' +
                                                                                              file_id,
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            $(
                                                                                              '.attachment_expanded_' +
                                                                                              file_id,
                                                                                            ).show();
                                                                                          }
                                                                                          if (res.data.error) {
                                                                                            $(
                                                                                              '.attachment_colapsed',
                                                                                            ).show();
                                                                                            // $('.attachment_colapsed_'+file_id).hide();
                                                                                            $(
                                                                                              '.attachment_expanded',
                                                                                            ).hide();
                                                                                            // $('.attachment_expanded_'+file_id).show();
                                                                                          }
                                                                                        })
                                                                                        .catch((error) => {
                                                                                          if (error.response) {
                                                                                            if (
                                                                                              error.response.data.error
                                                                                            ) {
                                                                                              $(
                                                                                                '.attachment_colapsed',
                                                                                              ).show();
                                                                                              // $('.attachment_colapsed_'+file_id).hide();
                                                                                              $(
                                                                                                '.attachment_expanded',
                                                                                              ).hide();
                                                                                              // $('.attachment_expanded_'+file_id).show();
                                                                                            }
                                                                                          }
                                                                                        });

                                                                                      console.log(file_url);
                                                                                    }
                                                                                  });
                                                                              }}
                                                                              setVideo={(blob) => {
                                                                                let blobUrl = URL.createObjectURL(blob);
                                                                                console.log(blobUrl);
                                                                                // this.setState({ captureVideoUrl: blobUrl })
                                                                              }}
                                                                            />
                                                                            {/* </div> */}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a
                                                                      className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                      onClick={this.videoLclDelte_cmb}>
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="attachmentbody_div d-table">
                                                                      <div className="d-table-row">
                                                                        <div className="d-table-cell w-70 align-top">
                                                                          <span className="attachrecord_icon bg_video crsr_pntr">
                                                                            <i className="fas fa-film" />
                                                                          </span>
                                                                        </div>
                                                                        <div className="d-table-cell align-middle">
                                                                          <div className="f_sz16">
                                                                            <span>
                                                                              <i className="fas fa-spinner fa-spin f_sz24" />
                                                                            </span>
                                                                            <span
                                                                              className="ml-2"
                                                                              style={{
                                                                                display: 'none',
                                                                              }}>
                                                                              0.10
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}

                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                          defaultValue={10}
                                                                          disabled
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">
                                                                      Delete
                                                                    </a>
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              {/* timeline item */}
                                                              <div style={{ display: 'none' }}>
                                                                <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                <div className="timeline-item">
                                                                  <div className="timeline-body">
                                                                    <div className="form-group row">
                                                                      <label className="col-form-label pull-left pl-2 f_sz16">
                                                                        No. of Rewards
                                                                      </label>
                                                                      <div className="pull-left ml-3">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control text-center txtbx_sm"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="timeline-footer">
                                                                    <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      Save
                                                                    </a>
                                                                    <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                      Delete
                                                                    </a>
                                                                    {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              {/* END timeline item */}
                                                              <div id="attachLoading_cmb_video">
                                                                <i
                                                                  className="fas fa-circle bg-gray"
                                                                  style={{ fontSize: 'x-small' }}
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className="attchLstShow_cmb"
                                                      style={{ display: 'none' }}
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                                                        <div className="attachment_timelinediv">
                                                          {/* The time line */}

                                                          {/* The time line */}
                                                          <div
                                                            // onDragOver={this.dragOver_cmb}
                                                            className="timeline"
                                                            id="timelineprepend">
                                                            <div
                                                              id="attachLoading_cmb"
                                                              className="attachLoading_cmb"
                                                              style={{ display: 'none' }}>
                                                              <i
                                                                className={
                                                                  this.state.lodingicon_cmb + ' attachtype_timelineicon'
                                                                }
                                                              />
                                                              <div className="timeline-item">
                                                                <div className="timeline-body">
                                                                  <div className="attachmentbody_div d-table">
                                                                    <span>
                                                                      <span className="d-inline-block">
                                                                        <span>
                                                                          <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                                        </span>
                                                                        <span className="postop_5up">
                                                                          This might take few mins, please hold on while
                                                                          we process your attachment
                                                                        </span>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                                <div className="timeline-footer"></div>
                                                              </div>
                                                            </div>

                                                            {this.state.atcharryDet_cmb.map((attachment, index) => {
                                                              return attachment.notes_content1 ? (
                                                                <>
                                                                  <div
                                                                    className={'editor_cmb_' + attachment.attach_id}
                                                                    style={{ display: 'none' }}>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        // onClick={() => {
                                                                        //   this.oneditnotecmb(attachment);
                                                                        // }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          {/* <ReactQuill
                                                                            // theme="bubble"

                                                                            modules={{
                                                                              toolbar: [
                                                                                [
                                                                                  'bold',
                                                                                  'italic',
                                                                                  'underline',
                                                                                  'strike',
                                                                                ],
                                                                                [
                                                                                  {header: '1'},
                                                                                  {header: '2'},
                                                                                  {font: []},
                                                                                ],
                                                                                [
                                                                                  {list: 'ordered'},
                                                                                  {list: 'bullet'},
                                                                                  {indent: '-1'},
                                                                                  {indent: '+1'},
                                                                                ],
                                                                                ['link', 'video'],
                                                                                ['clean'],
                                                                              ],

                                                                              clipboard: {
                                                                                // toggle to add extra line breaks when pasting HTML:
                                                                                matchVisual: false,
                                                                              },
                                                                            }}
                                                                            formats={[
                                                                              'header',
                                                                              'font',
                                                                              'size',
                                                                              'bold',
                                                                              'italic',
                                                                              'underline',
                                                                              'strike',
                                                                              'list',
                                                                              'bullet',
                                                                              'indent',
                                                                              'link',
                                                                              'video',
                                                                            ]}
                                                                            value={this.state.notesValue2_cmb}
                                                                            onChange={this.notesLetter2_cmb}
                                                                            maxLength="600"
                                                                          /> */}
                                                                          <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={this.state.notesValue2_cmb}
                                                                            id="mytext"
                                                                            config={editorConfiguration}
                                                                            onReady={(editor) => {
                                                                              // You can store the "editor" and use when it is needed.
                                                                              // console.log( 'Editor is ready to use!', editor );
                                                                            }}
                                                                            onChange={(event, editor) => {
                                                                              const data = editor.getData();
                                                                              // console.log( { event, editor, data } );
                                                                              // if (data.length <= 1200) {
                                                                              this.setState({
                                                                                notesValue2_cmb: data,
                                                                                chars_left_notes_cmb:
                                                                                  this.state.max_chars_notes_cmb -
                                                                                  data.length,
                                                                              });
                                                                              // }
                                                                            }}
                                                                            onBlur={(event, editor) => {
                                                                              // console.log( 'Blur.', editor );
                                                                            }}
                                                                            onFocus={(event, editor) => {
                                                                              // console.log( 'Focus.', editor );
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </div>

                                                                      {/* {this.state.cmb_notesedit === true ? (
                                                                        <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                                                                          {this.state.savingprogress}
                                                                        </div>
                                                                      ) : null} */}

                                                                      {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                                                        
                                                                        Maximum 1200 characters
                                                                      </div> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        {/* {this.state.cmb_notesedit === true ? (
                                                                          <a
                                                                            className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                            onClick={() => {
                                                                              this.updateNotes2_cmb();
                                                                            }}>
                                                                            Update
                                                                          </a>
                                                                        ) : null} */}
                                                                        <a
                                                                          className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() => {
                                                                            this.updateNotes2_cmb();
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                                          Save
                                                                        </a>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={() =>
                                                                            this.notesAtchDelte_cmb_edit(
                                                                              attachment.attach_id,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>

                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                    // draggable="true"
                                                                    // onDragEnd={this.dragEnd_cmb}
                                                                    // onDragStart={this.dragStart_cmb}
                                                                    className={
                                                                      'notecontent_cmb_show notecontent_cmb_' +
                                                                      attachment.attach_id
                                                                    }>
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        onClick={() => {
                                                                          this.oneditnotecmb(attachment);
                                                                        }}
                                                                        style={{ wordWrap: 'break-word' }}>
                                                                        <div className="attachmentbody_div">
                                                                          <Linkify
                                                                            componentDecorator={(
                                                                              decoratedHref,
                                                                              decoratedText,
                                                                              key,
                                                                            ) => (
                                                                              <a
                                                                                target="blank"
                                                                                href={decoratedHref}
                                                                                key={key}>
                                                                                {decoratedText}
                                                                              </a>
                                                                            )}>
                                                                            <div
                                                                              dangerouslySetInnerHTML={{
                                                                                __html: attachment.notes_content,
                                                                              }}
                                                                            />
                                                                            {/* {attachment.notes_content} */}
                                                                          </Linkify>
                                                                        </div>
                                                                      </div>

                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={this.notesAtchDelte_cmb}>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Notes Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                              this.oneditnotecmb(attachment);
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                          {/* </span> */}
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              ) : attachment.documents ? (
                                                                attachment.documents.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                  // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                  >
                                                                    <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          <span className="font-weight-bold">
                                                                            Documents:
                                                                          </span>
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.documents.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.documents,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>

                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Document Attached
                                                                          <a
                                                                            className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.images ? (
                                                                attachment.images.length > 0 ? (
                                                                  <div
                                                                    data-id={index}
                                                                    key={index}
                                                                  // draggable="true"
                                                                  // onDragEnd={this.dragEnd_cmb}
                                                                  // onDragStart={this.dragStart_cmb}
                                                                  >
                                                                    <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                                                    <div className="timeline-item ">
                                                                      {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                      <div
                                                                        className={
                                                                          'timeline-body attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                          {/* <span className="font-weight-bold">Images:</span> */}
                                                                          <br />

                                                                          <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                            {attachment.images.map(
                                                                              (documentList, index) => {
                                                                                var fileType =
                                                                                  documentList.file_name.split('.');
                                                                                return (
                                                                                  <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                    <a
                                                                                      onClick={() =>
                                                                                        this.document_read(documentList)
                                                                                      }>
                                                                                      {documentList?.thumbnail_file_url ? (
                                                                                        <div className="attachdoc_thumb">
                                                                                          <img
                                                                                            src={
                                                                                              documentList?.thumbnail_file_url
                                                                                            }
                                                                                            border={0}
                                                                                          />
                                                                                        </div>
                                                                                      ) : (
                                                                                        <div className="attachdoc_type text-center">
                                                                                          <i className="far fa-file-alt flightgrey1"></i>
                                                                                        </div>
                                                                                      )}

                                                                                      <div className="attachdoc_filenmesze py-1 px-2">
                                                                                        <table
                                                                                          width="100%"
                                                                                          cellPadding={0}
                                                                                          cellSpacing={0}>
                                                                                          <tbody>
                                                                                            <tr>
                                                                                              <td>
                                                                                                {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                {fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pdf' ? (
                                                                                                  <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'docx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'doc' ? (
                                                                                                  <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'jpg' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'jpeg' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'png' ? (
                                                                                                  <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'csv' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xls' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'xlsx' ? (
                                                                                                  <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                ) : fileType[
                                                                                                  fileType.length - 1
                                                                                                ] === 'pptx' ||
                                                                                                  fileType[
                                                                                                  fileType.length - 1
                                                                                                  ] === 'ppt' ? (
                                                                                                  <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                ) : (
                                                                                                  <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                )}

                                                                                                <span className="f_sz13 mr-2">
                                                                                                  {/* {documentList.file_name} */}
                                                                                                  {documentList
                                                                                                    ?.file_name
                                                                                                    ?.length > 5
                                                                                                    ? documentList?.file_name.substring(
                                                                                                      0,
                                                                                                      5,
                                                                                                    ) +
                                                                                                    '...' +
                                                                                                    this.getExtensionFromUrl(
                                                                                                      documentList?.file_name,
                                                                                                    )
                                                                                                    : documentList?.file_name}
                                                                                                </span>
                                                                                              </td>
                                                                                              <td align="right">
                                                                                                <span className="f_sz12 flightgrey">
                                                                                                  {this.bytesToKb(
                                                                                                    documentList?.file_size,
                                                                                                  )}{' '}
                                                                                                  kB
                                                                                                </span>
                                                                                              </td>
                                                                                            </tr>
                                                                                          </tbody>
                                                                                        </table>
                                                                                      </div>
                                                                                    </a>
                                                                                    {/* <div className="attachdoc_delete">
                                                                                      <a
                                                                                        href="javascript:void(0)"
                                                                                        className="crsr_pntr">
                                                                                        <i
                                                                                          className="far fa-trash-alt f_sz15"
                                                                                          onClick={this.DocLclDlete_cmb}
                                                                                          id={documentList.file_id}
                                                                                          data-id={attachment.attach_id}
                                                                                        />
                                                                                      </a>
                                                                                    </div> */}
                                                                                  </div>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          'timeline-footer attachment_expanded attachment_expanded_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          id={attachment.attach_id}
                                                                          onClick={(e) =>
                                                                            this.documntAtchDelte_cmb(
                                                                              e,
                                                                              attachment.images,
                                                                            )
                                                                          }>
                                                                          Delete
                                                                        </a>
                                                                        <a
                                                                          className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                          onClick={() => {
                                                                            this.expanded_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                                      </div>
                                                                      {/* </span> */}
                                                                      {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                    </div>
                                                                    <div className="timeline-item ">
                                                                      <div
                                                                        className={
                                                                          'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                          attachment.attach_id
                                                                        }
                                                                        style={{ display: 'none' }}>
                                                                        <div className="attachmentbody_div">
                                                                          Image Attached
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.colapsed_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* </span> */}
                                                                    </div>
                                                                  </div>
                                                                ) : undefined
                                                              ) : attachment.audio_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                  <div className="timeline-item ">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <div className="attachmentbody_div d-table">
                                                                        <div className="d-table-row">
                                                                          <div className="d-table-cell align-middle">
                                                                            <span>
                                                                              <span className="d-inline-block">
                                                                                <span className="crsr_pntr">
                                                                                  <i
                                                                                    className={
                                                                                      'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={() => {
                                                                                      this.audioPly_temp(attachment);
                                                                                    }}
                                                                                    id={attachment.audio_id}
                                                                                  />
                                                                                  <i
                                                                                    className={
                                                                                      'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    onClick={this.audioPaue}
                                                                                    id={attachment.audio_id}
                                                                                    style={{
                                                                                      display: 'none',
                                                                                    }}></i>
                                                                                  <span
                                                                                    className="ml-2 d-inline-block postop_5up"
                                                                                  // style={{
                                                                                  //   display: 'none',
                                                                                  // }}
                                                                                  ></span>
                                                                                  <audio
                                                                                    className={
                                                                                      'audioplayer123 audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                    style={{
                                                                                      width: '258px',
                                                                                      display: 'none',
                                                                                    }}
                                                                                    src={
                                                                                      this.state.play_audio_url
                                                                                        ? this.state.play_audio_url
                                                                                        : undefined
                                                                                    }
                                                                                    controls="controls"
                                                                                    controlsList="nodownload"
                                                                                    //hidden
                                                                                    id={
                                                                                      'audio_temp_' +
                                                                                      attachment.audio_id
                                                                                    }
                                                                                  />
                                                                                </span>
                                                                              </span>
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.audio_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.audioAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.audio_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.audio_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Audio Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.audio_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : attachment.video_url ? (
                                                                <div
                                                                  data-id={index}
                                                                  key={index}
                                                                // draggable="true"
                                                                // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                >
                                                                  <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                                                  <div className="timeline-item">
                                                                    {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                    <div
                                                                      className={
                                                                        'timeline-body attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                        <span className="font-weight-bold">Video:</span>
                                                                        <br />
                                                                        <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                          <a
                                                                            onClick={() =>
                                                                              this.Video_play_url(attachment)
                                                                            }>
                                                                            {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                              <div className="attachdoc_type text-center">
                                                                <i className="fas fa-video" />
                                                              </div>
                                                              <div className="attachdoc_name">
                                                                Click here to
                                                                play video
                                                              </div>
                                                            </div> */}
                                                                            <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                                              <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                                                {/* <img src={} border={0} /> */}
                                                                                <i className="fas fa-video fa-3x" />
                                                                              </div>
                                                                              <div className="attachvideo_gif">
                                                                                {/* <img src={} border={0} /> */}
                                                                                Click here to play video
                                                                              </div>
                                                                            </div>
                                                                            {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                      {/* <div className="attachmentbody_div d-table">
                                                        <div className="d-table-row">
                                                          <div className="d-table-cell align-middle">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="videoWrapper">
                                                                <video
                                                                  onPlay={() =>
                                                                    this.Video_play_url(
                                                                      attachment
                                                                    )
                                                                  }
                                                                  width="300"
                                                                  controls
                                                                  playsinline
                                                                >
                                                                  
                                                                  <source
                                                                    src={
                                                                      this.state
                                                                        .video_play_link
                                                                    }
                                                                    type="video/mp4"
                                                                  />                                                                
                                                                </video>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div> */}
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        'timeline-footer attachment_expanded attachment_expanded_' +
                                                                        attachment.attach_id
                                                                      }>
                                                                      <a
                                                                        className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                        id={attachment.attach_id}
                                                                        onClick={this.videAtchDelte_cmb}>
                                                                        Delete
                                                                      </a>
                                                                      <a
                                                                        className={
                                                                          'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                        }
                                                                        onClick={() => {
                                                                          this.expanded_attach(attachment.attach_id);
                                                                        }}>
                                                                        <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a>
                                                                      {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                      </a> */}
                                                                    </div>
                                                                    {/* </span> */}
                                                                    {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                  </div>
                                                                  <div className="timeline-item ">
                                                                    <div
                                                                      className={
                                                                        'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                        attachment.attach_id
                                                                      }
                                                                      style={{ display: 'none' }}>
                                                                      <div className="attachmentbody_div">
                                                                        Video Attached
                                                                        <a
                                                                          className={
                                                                            'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                          }
                                                                          onClick={() => {
                                                                            this.colapsed_attach(attachment.attach_id);
                                                                          }}>
                                                                          <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                        {/* </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              ) : null;
                                                            })}

                                                            <div>
                                                              <i
                                                                className="fas fa-circle bg-gray"
                                                                style={{ fontSize: 'x-small' }}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="brdrtop_dashed"></div>
                                        </div>
                                        <div
                                          className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3"
                                          style={{ display: 'none' }}>
                                          <a className="btn btn-black crsr_pntr m-2 btnpdng_sm">Reset</a>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Workflow begin */}
                            <div
                              className="tab-pane fade "
                              id="custom-tabs-workflow"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-workflow-tab">
                              <div className="all_contentflex_div">
                                <div className="card w-100 bx_shadow_sm">
                                  <div className="workflowcreate_div" style={{ display: 'none' }}>
                                    <button
                                      class="btn btn-sm btnpdng_sm1 btn-gray business_evaluation_popup"
                                      name="Verification"
                                      data-toggle="modal"
                                      data-target="#modal_business_verification"
                                      style={{ display: 'none' }}
                                    />
                                    <button
                                      class="btn btn-sm btnpdng_sm1 btn-gray business_evaluation_popup_assigned"
                                      name="Verification"
                                      data-toggle="modal"
                                      data-target="#modal_business_verification_assigned"
                                      style={{ display: 'none' }}
                                    />
                                    <div className="card w-100 shadow-none">
                                      <div className="all_contentcntr_700">
                                        <div className="form-horizontal formbiglbl">
                                          <div className="card-body">
                                            <div className="form-group row mt-5 mb-4">
                                              <h5 className="col-12 col-sm-12 text-center fmaroon">Workflow</h5>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="text-center mt-3">
                                                  <span className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm workflowcreate_clk">
                                                    Create
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="addworkflow_div" style={{ display: 'none' }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                        <h5>
                                          <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                            {this.state.workflow_editenable
                                              ? 'Update Workflow'
                                              : 'Start a workflow from scratch'}
                                          </span>
                                          <span
                                            className="addworkflow_close mr-2 mt-1"
                                            onClick={this.addworkflow_close}>
                                            <i className="fas fa-times" />
                                          </span>
                                        </h5>
                                      </div>
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body px-0">
                                          <div>
                                            <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="Enter the workflow name"
                                                  value={this.state.workflow_name}
                                                  onChange={(e) => {
                                                    this.setState({ workflow_name: e.target.value });
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <textarea
                                                  className="form-control textarea_hgt100 txtarea_resizenone"
                                                  placeholder="Add a description to your workflow"
                                                  value={this.state.workflow_description}
                                                  onChange={(e) => {
                                                    this.setState({ workflow_description: e.target.value });
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="icheck-darkgrey d-inline-block py-1">
                                                  <input type="checkbox" id="workspaceopt" />
                                                  <label htmlFor="workspaceopt" className="font-weight-semibold">
                                                    Allow your contacts to enter the workflow more than once.
                                                  </label>
                                                  <div className="ml-4 pl-2 f_sz13 flightgrey">
                                                    Enabling this option will allow contacts to enter this workflow
                                                    several times
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3">
                                          <span
                                            className="btn btn-black crsr_pntr m-2 btnpdng_sm startautomate_clk"
                                            onClick={() =>
                                              this.state.workflow_editenable
                                                ? this.Workflow_update()
                                                : this.Workflow_create()
                                            }>
                                            Start Automating
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="addentrypoints_div" style={{ display: 'none' }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                        <h5>
                                          <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                            {this.state.workflow_edit_name}
                                          </span>
                                          <span className="addentrypoints_close mr-2 mt-1 addentrypt_clk">
                                            <i className="fas fa-times" />
                                          </span>
                                        </h5>
                                      </div>
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body px-0">
                                          <div className="workflow_flowchart">
                                            <div className="text-right">
                                              <a
                                                className={
                                                  this.state.workflow_entry_list_array?.length === 0
                                                    ? 'btn btn-black-dark crsr_pntr btn-sm btnpdng_sm mr-2 isdisabled'
                                                    : 'btn btn-black-dark crsr_pntr btn-sm btnpdng_sm mr-2'
                                                }
                                                onClick={() => {
                                                  this.onupdate_workflow_status(
                                                    this.state.workflow_edit_data,
                                                    'active',
                                                  );
                                                }}
                                                style={{
                                                  display:
                                                    this.state.workflow_edit_data.status === 'deactive'
                                                      ? 'inline-block'
                                                      : 'none',
                                                  pointerEvents:
                                                    this.state.workflow_entry_list_array?.length === 0 ? 'none' : null,
                                                }}>
                                                Activate this Workflow
                                              </a>
                                              <div
                                                className="mr-2"
                                                style={{
                                                  display:
                                                    this.state.workflow_edit_data.status === 'deactive'
                                                      ? 'none'
                                                      : 'inline-block',
                                                }}>
                                                <a
                                                  data-toggle="dropdown"
                                                  href="#"
                                                  className="btn btn-black crsr_pntr btn-sm">
                                                  {this.state.workflow_edit_data.status === 'active' ? (
                                                    <span>
                                                      <i className="fas fa-circle f_sz12 mr-2 fgreen4" />
                                                      Status: <span className="fgreen4 mr-1">Active</span>
                                                      <i className="fas fa-caret-down" />
                                                    </span>
                                                  ) : this.state.workflow_edit_data.status === 'inactive' ? (
                                                    <span>
                                                      <i className="fas fa-circle f_sz12 mr-2 forange" />
                                                      Status: <span className="forange mr-1">Paused</span>
                                                      <i className="fas fa-caret-down" />
                                                    </span>
                                                  ) : (
                                                    <span>
                                                      <i className="fas fa-circle f_sz12 mr-2 flightgrey" />
                                                      Status: <span className="flightgrey mr-1">Inactive</span>
                                                      <i className="fas fa-caret-down" />
                                                    </span>
                                                  )}
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                                  <a
                                                    href="#"
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                      this.onupdate_workflow_status(
                                                        this.state.workflow_edit_data,
                                                        'active',
                                                      );
                                                    }}>
                                                    {/* Message Start */}
                                                    <div className="media">
                                                      <div className="media-body">
                                                        <p>
                                                          <i className="fas fa-circle f_sz12 mr-2 fgreen4" />
                                                          Active
                                                        </p>
                                                        <p className="text-sm">
                                                          New contacts can enter the workflow and existing one can
                                                          continue.
                                                        </p>
                                                      </div>
                                                    </div>
                                                    {/* Message End */}
                                                  </a>
                                                  <div className="dropdown-divider" />
                                                  <a
                                                    href="#"
                                                    className="dropdown-item"
                                                    data-toggle="modal"
                                                    data-target="#modal_wfpause"
                                                    data-backdrop="static"
                                                    onClick={() => {
                                                      this.setState({
                                                        workflow_status_data: this.state.workflow_edit_data,
                                                      });
                                                    }}>
                                                    {/* Message Start */}
                                                    <div className="media">
                                                      <div className="media-body">
                                                        <p>
                                                          <i className="fas fa-circle f_sz12 mr-2 forange" />
                                                          Pause
                                                        </p>
                                                        <p className="text-sm">
                                                          No new contacts can enter the workflow but existing one can
                                                          continue.
                                                        </p>
                                                      </div>
                                                    </div>
                                                    {/* Message End */}
                                                  </a>
                                                  <div className="dropdown-divider" />
                                                  <a
                                                    href="#"
                                                    className="dropdown-item"
                                                    data-toggle="modal"
                                                    data-target="#modal_wfdeactivate"
                                                    data-backdrop="static"
                                                    onClick={() => {
                                                      this.setState({
                                                        workflow_status_data: this.state.workflow_edit_data,
                                                      });
                                                    }}>
                                                    {/* Message Start */}
                                                    <div className="media">
                                                      <div className="media-body">
                                                        <p>
                                                          <i className="fas fa-circle f_sz12 mr-2 flightgrey" />
                                                          Inactive
                                                        </p>
                                                        <p className="text-sm">
                                                          No new contacts can enter the workflow and existing one are
                                                          removed.
                                                        </p>
                                                      </div>
                                                    </div>
                                                    {/* Message End */}
                                                  </a>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="w-100 d-flex flex-row flex-wrap justify-content-center mt-3">
                                              <a
                                                data-toggle="modal"
                                                data-target="#modal_entrypoint"
                                                data-backdrop="static"
                                                className="crsr_pntr">
                                                <div className="wf_addentryexitpt wf_entryptwdth">
                                                  <span className="wf_icondiv wf_icondivpos">
                                                    <i className="fas fa-plus" />
                                                  </span>
                                                  <span className="font-weight-bold">Add an entry point</span>
                                                  <br />
                                                  <span>Click to add more entry points</span>
                                                  <br />
                                                  <span className="font-weight-bold">
                                                    Added Entry Points -{' '}
                                                    <span className="fmaroon">
                                                      {!this.state.workflow_entry_list_array
                                                        ? 0
                                                        : this.state.workflow_entry_list_array?.length}
                                                    </span>
                                                  </span>
                                                </div>
                                              </a>
                                            </div>
                                            <div>
                                              <div className="w-100 d-flex flex-row flex-wrap justify-content-center">
                                                <div className="tree ">
                                                  <ul className="tree_entrypoint_ul scrollbar_style1">
                                                    {this.state.workflow_entry_list_array?.map((workflow, index) => {
                                                      return workflow.select_entry_point === 'contacts' ? (
                                                        <li className="entrypt_li">
                                                          <a>
                                                            <div className="wfbox bggreen position-relative">
                                                              <span className="wf_icondiv wf_icondivpos">
                                                                <i className="fas fa-user-friends" />
                                                              </span>
                                                              <span className="font-weight-bold">
                                                                For given contact(s)
                                                              </span>
                                                              <br />
                                                              {workflow.contacts?.length !== 0 ? (
                                                                <span>
                                                                  Filter -{' '}
                                                                  <span className="font-weight-bold fmaroon">
                                                                    {workflow.contacts?.length + ' contact(s)'}
                                                                  </span>
                                                                </span>
                                                              ) : (
                                                                <span className="font-weight-bold fmaroon">
                                                                  {'All contact(s) -  ' +
                                                                    this.state.businessprofiledetails.contacts}
                                                                </span>
                                                              )}
                                                              <br />
                                                              <span className="wf_startpt_pos flightgrey3">
                                                                startpoint #{index + 1}
                                                              </span>
                                                              <div className="wf_actnbtnsdiv">
                                                                <span
                                                                  className="wf_actionicondiv bg_delete"
                                                                  onClick={() => this.delete_entry_point(workflow)}>
                                                                  <i className="fas fa-trash-alt" />
                                                                </span>
                                                                <span
                                                                  style={{
                                                                    display:
                                                                      workflow.contacts?.length !== 0
                                                                        ? 'inline-block'
                                                                        : 'none',
                                                                  }}
                                                                  onClick={() =>
                                                                    this.onEdit_entrypoint_contacts(workflow)
                                                                  }
                                                                  className="wf_actionicondiv"
                                                                  data-toggle="modal"
                                                                  data-target="#modal_entrypt_contacts"
                                                                  data-backdrop="static">
                                                                  <i className="fas fa-pen" />
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </a>
                                                        </li>
                                                      ) : workflow.select_entry_point === 'tags' ? (
                                                        <li className="entrypt_li">
                                                          <a>
                                                            <div className="wfbox bggreen position-relative">
                                                              <span className="wf_icondiv wf_icondivpos">
                                                                <i className="fas fa-tags f_sz12" />
                                                              </span>
                                                              <span className="font-weight-bold">For given tag(s)</span>
                                                              <br />
                                                              <span>
                                                                Filter -{' '}
                                                                <span className="font-weight-bold fmaroon">
                                                                  {workflow.tags?.length}
                                                                </span>{' '}
                                                                tags
                                                              </span>

                                                              <span
                                                                onClick={() => this.view_tag_contact_count(workflow)}
                                                                className={
                                                                  'fmaroon ml-2 crsr_pntr wftags_viewct wf_tag_view_' +
                                                                  workflow._id
                                                                }>
                                                                (View)
                                                              </span>
                                                              <span
                                                                className={
                                                                  'ml-2 crsr_pntr wftags_ctcount wf_tag_cont_' +
                                                                  workflow._id
                                                                }
                                                                style={{ display: 'none' }}>
                                                                (
                                                                <span className="fmaroon font-weight-bold">
                                                                  {this.state.contactscount_tag}
                                                                </span>{' '}
                                                                contact(s))
                                                              </span>

                                                              <br />
                                                              <span className="wf_startpt_pos flightgrey3">
                                                                startpoint #{index + 1}
                                                              </span>
                                                              <div className="wf_actnbtnsdiv">
                                                                <span
                                                                  className="wf_actionicondiv bg_delete"
                                                                  onClick={() => this.delete_entry_point(workflow)}>
                                                                  <i className="fas fa-trash-alt" />
                                                                </span>
                                                                <span
                                                                  onClick={() => this.onEdit_entrypoint_tag(workflow)}
                                                                  className="wf_actionicondiv"
                                                                  data-toggle="modal"
                                                                  data-target="#modal_entrypt_tags"
                                                                  data-backdrop="static">
                                                                  <i className="fas fa-pen" />
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </a>
                                                        </li>
                                                      ) : (
                                                        <li className="entrypt_li">
                                                          <a>
                                                            <div className="wfbox bggreen position-relative">
                                                              <span className="wf_icondiv wf_icondivpos">
                                                                <i className="far fa-arrow-alt-circle-down" />
                                                              </span>
                                                              <span className="font-weight-bold">Inbound message</span>
                                                              <br />
                                                              <span>
                                                                Filter -{' '}
                                                                {workflow.inbound_type === 'equal_to'
                                                                  ? 'Equal to'
                                                                  : workflow.inbound_type === 'start_with'
                                                                    ? 'Starts with'
                                                                    : workflow.inbound_type === 'contains'
                                                                      ? 'Contains'
                                                                      : workflow.inbound_type === 'no_specification'
                                                                        ? 'No Specification'
                                                                        : ''}{' '}
                                                                <span className="font-weight-bold fmaroon">
                                                                  {workflow.inbound_content}
                                                                </span>
                                                              </span>
                                                              <br />
                                                              <span className="wf_startpt_pos flightgrey3">
                                                                startpoint #{index + 1}
                                                              </span>
                                                              <div className="wf_actnbtnsdiv">
                                                                <span
                                                                  className="wf_actionicondiv bg_delete"
                                                                  onClick={() => this.delete_entry_point(workflow)}>
                                                                  <i className="fas fa-trash-alt" />
                                                                </span>
                                                                <span
                                                                  onClick={() =>
                                                                    this.onEdit_entrypoint_inbound(workflow)
                                                                  }
                                                                  className="wf_actionicondiv"
                                                                  data-toggle="modal"
                                                                  data-target="#modal_entrypt_inboundmsg"
                                                                  data-backdrop="static">
                                                                  <i className="fas fa-pen" />
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </a>
                                                        </li>
                                                      );
                                                    })}
                                                    {/* <li className="entrypt_li">
                                                      <a>
                                                        <div className="wfbox bggreen position-relative">
                                                          <span className="wf_icondiv wf_icondivpos">
                                                            <i className="far fa-arrow-alt-circle-down" />
                                                          </span>
                                                          <span className="font-weight-bold">Inbound message</span>
                                                          <br />
                                                          <span>
                                                            Filter - contains{' '}
                                                            <span className="font-weight-bold fmaroon">service</span>
                                                          </span>
                                                          <br />
                                                          <span className="wf_startpt_pos flightgrey3">
                                                            startpoint #1
                                                          </span>
                                                          <div className="wf_actnbtnsdiv">
                                                            <span className="wf_actionicondiv bg_delete">
                                                              <i className="fas fa-trash-alt" />
                                                            </span>
                                                            <span
                                                              className="wf_actionicondiv"
                                                              data-toggle="modal"
                                                              data-target="#modal_entrypt_inboundmsg"
                                                              data-backdrop="static">
                                                              <i className="fas fa-pen" />
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </a>
                                                    </li>
                                                    <li className="entrypt_li">
                                                      <a>
                                                        <div className="wfbox bggreen position-relative">
                                                          <span className="wf_icondiv wf_icondivpos">
                                                            <i className="fas fa-tags f_sz12" />
                                                          </span>
                                                          <span className="font-weight-bold">For given tag(s)</span>
                                                          <br />
                                                          <span>
                                                            Filter - <span className="font-weight-bold fmaroon">2</span>{' '}
                                                            tags
                                                          </span>
                                                          <br />
                                                          <span className="wf_startpt_pos flightgrey3">
                                                            startpoint #2
                                                          </span>
                                                          <div className="wf_actnbtnsdiv">
                                                            <span className="wf_actionicondiv bg_delete">
                                                              <i className="fas fa-trash-alt" />
                                                            </span>
                                                            <span
                                                              className="wf_actionicondiv"
                                                              data-toggle="modal"
                                                              data-target="#modal_entrypt_tags"
                                                              data-backdrop="static">
                                                              <i className="fas fa-pen" />
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </a>
                                                    </li> */}
                                                  </ul>
                                                  <ul className="pt-4 tree_steps_ul scrollbar_style1">
                                                    <li>
                                                      <span className="font-weight-bold">Steps to your workflow</span>
                                                      <ul>
                                                        <li>
                                                          <a
                                                            style={{
                                                              display:
                                                                this.state.workflow_steps_list_array.length !== 0
                                                                  ? 'none'
                                                                  : 'inline-block',
                                                            }}
                                                            data-toggle="modal"
                                                            data-target="#modal_wfstep"
                                                            data-backdrop="static"
                                                            className="crsr_pntr pb-2"
                                                            onClick={() =>
                                                              this.setState({
                                                                firstlevel_click: true,
                                                                workflow_step_id_create:
                                                                  this.state.workflow_edit_data._id,
                                                              })
                                                            }>
                                                            <div className="wfbox p-0 brdr_none">
                                                              <span className="wf_icondiv">
                                                                <i className="fas fa-plus" />
                                                              </span>
                                                            </div>
                                                          </a>
                                                          {/* <ul>{this.first_level_wf}</ul> */}
                                                          <ul>
                                                            {/* {this.first_level_wf} */}
                                                            {/* {this.state.workflow_steps_list_array
                                      ? this.workflow_steps_list_array_map(this.state.workflow_steps_list_array)
                                      : null} */}
                                                            <li id="first_level">
                                                              {/*{this.state.workflow_steps_list_array?.map(
                                                                (workflow_step, index) => {
                                                                  
                                                                  return workflow_step.type === 'send_message' ? (
                                                                    <>
                                                                      <a>
                                                                        <div className="wfbox bgblue position-relative mt-2">
                                                                          <span className="wf_icondiv wf_icondivpos">
                                                                            <i className="far fa-comment-alt" />
                                                                          </span>
                                                                          <span className="font-weight-bold">
                                                                            Send Message
                                                                          </span>
                                                                          <br />
                                                                          <span>
                                                                            Message Content -{' '}
                                                                            <span className="font-weight-bold fmaroon">
                                                                              {workflow_step.message}
                                                                            </span>
                                                                          </span>
                                                                          <br />
                                                                          <span className="wf_startpt_pos flightgrey3">
                                                                            #{index + 1}
                                                                          </span>
                                                                          <div className="wf_actnbtnsdiv">
                                                                            <span
                                                                              className="wf_actionicondiv bg_delete"
                                                                              onClick={() =>
                                                                                this.delete_start_point(workflow_step)
                                                                              }>
                                                                              <i className="fas fa-trash-alt" />
                                                                            </span>
                                                                            <span
                                                                              onClick={() =>
                                                                                this.onEdit_startpoint_sendmsg(
                                                                                  workflow_step,
                                                                                )
                                                                              }
                                                                              className="wf_actionicondiv"
                                                                              data-toggle="modal"
                                                                              data-target="#modal_wfsendsms"
                                                                              data-backdrop="static">
                                                                              <i className="fas fa-pen" />
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </a>
                                                                      <ul>
                                                                        <li>
                                                                          <a
                                                                            data-toggle="modal"
                                                                            data-target="#modal_wfstep"
                                                                            data-backdrop="static"
                                                                            className="crsr_pntr pb-2">
                                                                            <div className="wfbox p-0 brdr_none">
                                                                              <span className="wf_icondiv">
                                                                                <i className="fas fa-plus" />
                                                                              </span>
                                                                            </div>
                                                                          </a>
                                                                        </li>
                                                                      </ul>
                                                                    </>
                                                                  ) : workflow_step.type === 'delay' ? (
                                                                    <>
                                                                      <a>
                                                                        <div className="wfbox bgyellow position-relative mt-2">
                                                                          <span className="wf_icondiv wf_icondivpos">
                                                                            <i className="fas fa-spinner" />
                                                                          </span>
                                                                          <span className="font-weight-bold">Wait</span>
                                                                          <br />
                                                                          <span>
                                                                            For{' '}
                                                                            <span className="font-weight-bold fmaroon">
                                                                              {workflow_step.delay_count}{' '}
                                                                              {workflow_step.delay_time === 'minutes'
                                                                                ? 'Minute(s)'
                                                                                : workflow_step.delay_time === 'hours'
                                                                                ? 'Hour(s)'
                                                                                : workflow_step.delay_time === 'days'
                                                                                ? 'Day(s)'
                                                                                : workflow_step.delay_time === 'weeks'
                                                                                ? 'Week(s)'
                                                                                : 'Month(s)'}
                                                                            </span>
                                                                          </span>
                                                                          <br />
                                                                          <span className="wf_startpt_pos flightgrey3">
                                                                            #{index + 1}
                                                                          </span>
                                                                          <div className="wf_actnbtnsdiv">
                                                                            <span
                                                                              onClick={() =>
                                                                                this.delete_start_point(workflow_step)
                                                                              }
                                                                              className="wf_actionicondiv bg_delete">
                                                                              <i className="fas fa-trash-alt" />
                                                                            </span>
                                                                            <span
                                                                              onClick={() =>
                                                                                this.onEdit_startpoint_delay(
                                                                                  workflow_step,
                                                                                )
                                                                              }
                                                                              className="wf_actionicondiv"
                                                                              data-toggle="modal"
                                                                              data-target="#modal_wfdelay"
                                                                              data-backdrop="static">
                                                                              <i className="fas fa-pen" />
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </a>
                                                                      <ul>
                                                                        <li>
                                                                          <a
                                                                            data-toggle="modal"
                                                                            data-target="#modal_wfstep"
                                                                            data-backdrop="static"
                                                                            className="crsr_pntr pb-2">
                                                                            <div className="wfbox p-0 brdr_none">
                                                                              <span className="wf_icondiv">
                                                                                <i className="fas fa-plus" />
                                                                              </span>
                                                                            </div>
                                                                          </a>
                                                                        </li>
                                                                      </ul>
                                                                    </>
                                                                  ) : workflow_step.type === 'if_else' ? (
                                                                    <>
                                                                      <a>
                                                                        <div className="wfbox bgblue position-relative mt-2">
                                                                          <span className="wf_icondiv wf_icondivpos">
                                                                            <i className="far fa-comment-alt" />
                                                                          </span>
                                                                          <span className="font-weight-bold">
                                                                            If / Else
                                                                          </span>
                                                                          <br />
                                                                          <span>
                                                                            Filter -{' '}
                                                                            {workflow_step.inbound_type === 'equal_to'
                                                                              ? 'Equal to'
                                                                              : workflow_step.inbound_type ===
                                                                                'start_with'
                                                                              ? 'Starts with'
                                                                              : workflow_step.inbound_type ===
                                                                                'contains'
                                                                              ? 'Contains'
                                                                              : workflow_step.inbound_type ===
                                                                                'no_specification'
                                                                              ? 'No Specification'
                                                                              : ''}{' '}
                                                                            <span className="font-weight-bold fmaroon">
                                                                              {workflow_step.inbound_content}
                                                                            </span>
                                                                          </span>
                                                                          <br />
                                                                          <span className="wf_startpt_pos flightgrey3">
                                                                            #2
                                                                          </span>
                                                                          <div className="wf_actnbtnsdiv">
                                                                            <span
                                                                              className="wf_actionicondiv bg_delete"
                                                                              onClick={() =>
                                                                                this.delete_start_point(workflow_step)
                                                                              }>
                                                                              <i className="fas fa-trash-alt" />
                                                                            </span>
                                                                            <span
                                                                              className="wf_actionicondiv"
                                                                              data-toggle="modal"
                                                                              data-target="#modal_wfifelse_inboundmsg"
                                                                              data-backdrop="static"
                                                                              onClick={() =>
                                                                                this.onEdit_step_ifelse(workflow_step)
                                                                              }>
                                                                              <i className="fas fa-pen" />
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </a>
                                                                      <ul>
                                                                        <li>
                                                                          <a>
                                                                            <div className="wfbox_sm bgyes font-weight-semibold">
                                                                              YES
                                                                            </div>
                                                                          </a>
                                                                          <ul>
                                                                            <li>
                                                                              <a
                                                                                data-toggle="modal"
                                                                                data-target="#modal_wfstep"
                                                                                data-backdrop="static"
                                                                                className="crsr_pntr pb-2">
                                                                                <div className="wfbox p-0 brdr_none">
                                                                                  <span className="wf_icondiv">
                                                                                    <i className="fas fa-plus" />
                                                                                  </span>
                                                                                </div>
                                                                              </a>
                                                                            </li>
                                                                          </ul>
                                                                        </li>
                                                                        <li>
                                                                          <a>
                                                                            <div className="wfbox_sm bgno font-weight-semibold">
                                                                              NO
                                                                            </div>
                                                                          </a>
                                                                          <ul>
                                                                            <li>
                                                                              <a
                                                                                data-toggle="modal"
                                                                                data-target="#modal_wfstep"
                                                                                data-backdrop="static"
                                                                                className="crsr_pntr pb-2">
                                                                                <div className="wfbox p-0 brdr_none">
                                                                                  <span className="wf_icondiv">
                                                                                    <i className="fas fa-plus" />
                                                                                  </span>
                                                                                </div>
                                                                              </a>
                                                                            </li>
                                                                          </ul>
                                                                        </li>
                                                                      </ul>
                                                                    </>
                                                                  ) : null;
                                                                },
                                                              )}*/}
                                                            </li>
                                                            {/* <li>
                                                              <a>
                                                                <div className="wfbox bgblue position-relative">
                                                                  <span className="wf_icondiv wf_icondivpos">
                                                                    <i className="far fa-comment-alt" />
                                                                  </span>
                                                                  <span className="font-weight-bold">Send Message</span>
                                                                  <br />
                                                                  <span>
                                                                    Message Content -{' '}
                                                                    <span className="font-weight-bold fmaroon">
                                                                      Lorem Ipsum is simply dummy text of the printing
                                                                      and typesetting industry. Type "1".
                                                                    </span>
                                                                  </span>
                                                                  <br />
                                                                  <span className="wf_startpt_pos flightgrey3">#1</span>
                                                                  <div className="wf_actnbtnsdiv">
                                                                    <span className="wf_actionicondiv bg_delete">
                                                                      <i className="fas fa-trash-alt" />
                                                                    </span>
                                                                    <span
                                                                      className="wf_actionicondiv"
                                                                      data-toggle="modal"
                                                                      data-target="#modal_wfsendsms"
                                                                      data-backdrop="static">
                                                                      <i className="fas fa-pen" />
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              </a>
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    data-toggle="modal"
                                                                    data-target="#modal_wfstep"
                                                                    data-backdrop="static"
                                                                    className="crsr_pntr pb-2">
                                                                    <div className="wfbox p-0 brdr_none">
                                                                      <span className="wf_icondiv">
                                                                        <i className="fas fa-plus" />
                                                                      </span>
                                                                    </div>
                                                                  </a>
                                                                  <ul>
                                                                    <li>

                                                                      <a>
                                                                        <div className="wfbox bgblue position-relative">
                                                                          <span className="wf_icondiv wf_icondivpos">
                                                                            <i className="far fa-comment-alt" />
                                                                          </span>
                                                                          <span className="font-weight-bold">
                                                                            If / Else
                                                                          </span>
                                                                          <br />
                                                                          <span>
                                                                            Filter -{' '}
                                                                            <span className="font-weight-bold fmaroon">
                                                                              inbound message with "1"
                                                                            </span>
                                                                          </span>
                                                                          <br />
                                                                          <span className="wf_startpt_pos flightgrey3">
                                                                            #2
                                                                          </span>
                                                                          <div className="wf_actnbtnsdiv">
                                                                            <span className="wf_actionicondiv bg_delete">
                                                                              <i className="fas fa-trash-alt" />
                                                                            </span>
                                                                            <span
                                                                              className="wf_actionicondiv"
                                                                              data-toggle="modal"
                                                                              data-target="#modal_wfifelse_inboundmsg"
                                                                              data-backdrop="static">
                                                                              <i className="fas fa-pen" />
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </a>

                                                                      <ul>
                                                                        <li>
                                                                          <a>
                                                                            <div className="wfbox_sm bgyes font-weight-semibold">
                                                                              YES
                                                                            </div>
                                                                          </a>
                                                                          <ul>
                                                                            <li>
                                                                              <a
                                                                                data-toggle="modal"
                                                                                data-target="#modal_wfstep"
                                                                                data-backdrop="static"
                                                                                className="crsr_pntr pb-2">
                                                                                <div className="wfbox p-0 brdr_none">
                                                                                  <span className="wf_icondiv">
                                                                                    <i className="fas fa-plus" />
                                                                                  </span>
                                                                                </div>
                                                                              </a>
                                                                              <ul>
                                                                                <li>
                                                                                  <a>
                                                                                    <div className="wfbox bgyellow position-relative">
                                                                                      <span className="wf_icondiv wf_icondivpos">
                                                                                        <i className="fas fa-spinner" />
                                                                                      </span>
                                                                                      <span className="font-weight-bold">
                                                                                        Wait
                                                                                      </span>
                                                                                      <br />
                                                                                      <span>
                                                                                        For{' '}
                                                                                        <span className="font-weight-bold fmaroon">
                                                                                          1 day(s)
                                                                                        </span>
                                                                                      </span>
                                                                                      <br />
                                                                                      <span className="wf_startpt_pos flightgrey3">
                                                                                        #3
                                                                                      </span>
                                                                                      <div className="wf_actnbtnsdiv">
                                                                                        <span className="wf_actionicondiv bg_delete">
                                                                                          <i className="fas fa-trash-alt" />
                                                                                        </span>
                                                                                        <span
                                                                                          className="wf_actionicondiv"
                                                                                          data-toggle="modal"
                                                                                          data-target="#modal_wfdelay"
                                                                                          data-backdrop="static">
                                                                                          <i className="fas fa-pen" />
                                                                                        </span>
                                                                                      </div>
                                                                                    </div>
                                                                                  </a>
                                                                                  <ul>
                                                                                    <li>
                                                                                      <a
                                                                                        data-toggle="modal"
                                                                                        data-target="#modal_wfstep"
                                                                                        data-backdrop="static"
                                                                                        className="crsr_pntr pb-2">
                                                                                        <div className="wfbox p-0 brdr_none">
                                                                                          <span className="wf_icondiv">
                                                                                            <i className="fas fa-plus" />
                                                                                          </span>
                                                                                        </div>
                                                                                      </a>
                                                                                      <ul>
                                                                                        <li>
                                                                                          <a>
                                                                                            <div className="wfbox bgblue position-relative">
                                                                                              <span className="wf_icondiv wf_icondivpos">
                                                                                                <i className="far fa-comment-alt" />
                                                                                              </span>
                                                                                              <span className="font-weight-bold">
                                                                                                Send Message
                                                                                              </span>
                                                                                              <br />
                                                                                              <span>
                                                                                                Message Content -{' '}
                                                                                                <span className="font-weight-bold fmaroon">
                                                                                                  Lorem Ipsum is simply
                                                                                                  dummy text of the
                                                                                                  print
                                                                                                </span>
                                                                                              </span>
                                                                                              <br />
                                                                                              <span className="wf_startpt_pos flightgrey3">
                                                                                                #4
                                                                                              </span>
                                                                                              <div className="wf_actnbtnsdiv">
                                                                                                <span className="wf_actionicondiv bg_delete">
                                                                                                  <i className="fas fa-trash-alt" />
                                                                                                </span>
                                                                                                <span
                                                                                                  className="wf_actionicondiv"
                                                                                                  data-toggle="modal"
                                                                                                  data-target="#modal_wfsendsms"
                                                                                                  data-backdrop="static">
                                                                                                  <i className="fas fa-pen" />
                                                                                                </span>
                                                                                              </div>
                                                                                            </div>
                                                                                          </a>
                                                                                          <ul>
                                                                                            <li>
                                                                                              <a
                                                                                                data-toggle="modal"
                                                                                                data-target="#modal_wfstep"
                                                                                                data-backdrop="static"
                                                                                                className="crsr_pntr pb-2">
                                                                                                <div className="wfbox p-0 brdr_none">
                                                                                                  <span className="wf_icondiv">
                                                                                                    <i className="fas fa-plus" />
                                                                                                  </span>
                                                                                                </div>
                                                                                              </a>
                                                                                              <ul>
                                                                                                <li>
                                                                                                  <a>
                                                                                                    <div className="wfbox bgyellow position-relative">
                                                                                                      <span className="wf_icondiv wf_icondivpos">
                                                                                                        <i className="fas fa-spinner" />
                                                                                                      </span>
                                                                                                      <span className="font-weight-bold">
                                                                                                        Wait
                                                                                                      </span>
                                                                                                      <br />
                                                                                                      <span>
                                                                                                        For{' '}
                                                                                                        <span className="font-weight-bold fmaroon">
                                                                                                          3 day(s)
                                                                                                        </span>
                                                                                                      </span>
                                                                                                      <br />
                                                                                                      <span>
                                                                                                        Until -{' '}
                                                                                                        <span className="font-weight-bold fmaroon">
                                                                                                          inbound
                                                                                                          message with
                                                                                                          "1"
                                                                                                        </span>
                                                                                                      </span>
                                                                                                      <br />
                                                                                                      <span className="wf_startpt_pos flightgrey3">
                                                                                                        #5
                                                                                                      </span>
                                                                                                      <div className="wf_actnbtnsdiv">
                                                                                                        <span className="wf_actionicondiv bg_delete">
                                                                                                          <i className="fas fa-trash-alt" />
                                                                                                        </span>
                                                                                                        <span
                                                                                                          className="wf_actionicondiv"
                                                                                                          data-toggle="modal"
                                                                                                          data-target="#modal_wfwaituntil_inboundmsg"
                                                                                                          data-backdrop="static">
                                                                                                          <i className="fas fa-pen" />
                                                                                                        </span>
                                                                                                      </div>
                                                                                                    </div>
                                                                                                  </a>
                                                                                                  <ul>
                                                                                                    <li>
                                                                                                      <a>
                                                                                                        <div className="wfbox_sm bgyes font-weight-semibold">
                                                                                                          YES
                                                                                                        </div>
                                                                                                      </a>
                                                                                                      <ul>
                                                                                                        <li>
                                                                                                          <a
                                                                                                            data-toggle="modal"
                                                                                                            data-target="#modal_wfstep"
                                                                                                            data-backdrop="static"
                                                                                                            className="crsr_pntr pb-2">
                                                                                                            <div className="wfbox p-0 brdr_none">
                                                                                                              <span className="wf_icondiv">
                                                                                                                <i className="fas fa-plus" />
                                                                                                              </span>
                                                                                                            </div>
                                                                                                          </a>
                                                                                                        </li>
                                                                                                      </ul>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                      <a>
                                                                                                        <div className="wfbox_sm bgno font-weight-semibold">
                                                                                                          NO
                                                                                                        </div>
                                                                                                      </a>
                                                                                                      <ul>
                                                                                                        <li>
                                                                                                          <a
                                                                                                            data-toggle="modal"
                                                                                                            data-target="#modal_wfstep"
                                                                                                            data-backdrop="static"
                                                                                                            className="crsr_pntr pb-2">
                                                                                                            <div className="wfbox p-0 brdr_none">
                                                                                                              <span className="wf_icondiv">
                                                                                                                <i className="fas fa-plus" />
                                                                                                              </span>
                                                                                                            </div>
                                                                                                          </a>
                                                                                                        </li>
                                                                                                      </ul>
                                                                                                    </li>
                                                                                                  </ul>
                                                                                                </li>
                                                                                              </ul>
                                                                                            </li>
                                                                                          </ul>
                                                                                        </li>
                                                                                      </ul>
                                                                                    </li>
                                                                                  </ul>
                                                                                </li>
                                                                              </ul>
                                                                            </li>
                                                                          </ul>
                                                                        </li>
                                                                        <li>
                                                                          <a>
                                                                            <div className="wfbox_sm bgno font-weight-semibold">
                                                                              NO
                                                                            </div>
                                                                          </a>
                                                                          <ul>
                                                                            <li>
                                                                              <a
                                                                                data-toggle="modal"
                                                                                data-target="#modal_wfstep"
                                                                                data-backdrop="static"
                                                                                className="crsr_pntr pb-2">
                                                                                <div className="wfbox p-0 brdr_none">
                                                                                  <span className="wf_icondiv">
                                                                                    <i className="fas fa-plus" />
                                                                                  </span>
                                                                                </div>
                                                                              </a>
                                                                            </li>
                                                                          </ul>
                                                                        </li>
                                                                      </ul>

                                                                    </li>
                                                                  </ul>
                                                                </li>
                                                              </ul>
                                                            </li>
                                                           */}
                                                          </ul>
                                                        </li>
                                                      </ul>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="w-100 d-flex flex-row flex-wrap justify-content-center mt-3">
                                              <a
                                                data-toggle="modal"
                                                data-target="#modal_exitpoint"
                                                data-backdrop="static"
                                                className="crsr_pntr"></a>
                                              <div className="wf_addentryexitpt wf_exitptwdth">
                                                <a
                                                  data-toggle="modal"
                                                  data-target="#modal_exitpoint"
                                                  data-backdrop="static"
                                                  className="crsr_pntr">
                                                  <span className="wf_icondiv wf_icondivpos">
                                                    <i className="fas fa-sign-out-alt" />
                                                  </span>
                                                  <span className="font-weight-bold">
                                                    Exit &amp; Restart the workflow
                                                  </span>
                                                  <br />
                                                  
                                                  <div className="w-100 d-flex flex-row flex-wrap mt-3 text-left">
                                                    <div className="w-100 font-weight-bold">Exit the workflow</div>
                                                    <p className="w-100">If any of these conditions are true:</p>
                                                    <ol className="mrgnlft_25lft">
                                                      <li> When there is inbound message</li>
                                                    </ol>
                                                  </div>
                                                  <div className="w-100 d-flex flex-row flex-wrap text-left mt-3">
                                                    <div className="w-100 font-weight-bold">Restart the workflow</div>
                                                    <p className="w-100">If any of these conditions are true:</p>
                                                    <ol className="mrgnlft_25lft">
                                                      <li> When there is inbound message</li>
                                                    </ol>
                                                  </div>
                                                </a>
                                                <div className="text-left">
                                                  <a
                                                    data-toggle="modal"
                                                    data-target="#modal_exitpoint"
                                                    data-backdrop="static"
                                                    className="crsr_pntr"
                                                  />
                                                  <a
                                                    data-toggle="modal"
                                                    data-target="#modal_exitpoint"
                                                    data-backdrop="static"
                                                    className="crsr_pntr fmaroon">
                                                    Edit conditions
                                                  </a>
                                                </div>
                                              </div>
                                            </div> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="workflowlist_div" style={{ display: 'none' }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="card-header d-flex flex-row flex-wrap">
                                        <div className="col-6 col-sm-6 col-md-6 pl-0">
                                          <h5 className="fmaroon pt-2">Workflow</h5>
                                        </div>
                                        <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                          <a
                                            className="btn btn-black crsr_pntr btn-sm mt-1 addworkflow_clk"
                                            onClick={() => this.addworkflow_clk()}>
                                            Add New
                                          </a>
                                        </div>
                                      </div>
                                      <div className="card-body p-0 workflow_cardbdy">
                                        <div className="tabbable-responsive scrollbar_style1">
                                          <div className="tabbable">
                                            <ul
                                              className="nav nav-tabs border-bottom"
                                              id="custom-tabs-workflow-tab"
                                              role="tablist">
                                              <li className="nav-item">
                                                <a
                                                  className="nav-link active"
                                                  id="custom-tabs-wfall-tab"
                                                  data-toggle="pill"
                                                  href="#custom-tabs-wfall"
                                                  role="tab"
                                                  aria-controls="custom-tabs-wfall"
                                                  aria-selected="true">
                                                  <span className="d-inline-block">All</span>
                                                </a>
                                              </li>
                                              {/* <li className="nav-item">
                                                <a
                                                  className="nav-link"
                                                  id="custom-tabs-wfactive-tab"
                                                  data-toggle="pill"
                                                  href="#custom-tabs-wfactive"
                                                  role="tab"
                                                  aria-controls="custom-tabs-wfactive"
                                                  aria-selected="false">
                                                  <span className="d-inline-block">Active</span>
                                                </a>
                                              </li>
                                              <li className="nav-item">
                                                <a
                                                  className="nav-link"
                                                  id="custom-tabs-wfpaused-tab"
                                                  data-toggle="pill"
                                                  href="#custom-tabs-wfpaused"
                                                  role="tab"
                                                  aria-controls="custom-tabs-wfpaused"
                                                  aria-selected="false">
                                                  <span className="d-inline-block">Paused</span>
                                                </a>
                                              </li> */}
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="tab-content" id="custom-tabs-workflow-tabContent">
                                          <div
                                            className="tab-pane fade active show"
                                            id="custom-tabs-wfall"
                                            role="tabpanel"
                                            aria-labelledby="custom-tabs-wfall-tab">
                                            <div className="all_contentflex_div">
                                              <div className="card w-100 p-0 shadow-none mb-0">
                                                <div className="card-header py-0 border-bottom-0">
                                                  <div className="all_contentcntr_300">
                                                    <div className="input-group bx_shadow_smlight brdr_radius_mrdiv mt-3 mb-2">
                                                      <div className="input-group-prepend">
                                                        <span className="input-group-text search_inptgrptxt search_ctsinptgrptxt">
                                                          <button className="btn btn-sm" type="submit">
                                                            <i className="fas fa-search" />
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <input
                                                        type="text"
                                                        className="form-control search_frmcntrl3 bgclr1"
                                                        placeholder="Search Workflow"
                                                        onChange={(e) => this.workflow_search_list(e)}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="card-body p-0">
                                                  <div
                                                    id="workflow_nil"
                                                    className="all_contentcntr_450"
                                                    style={{ display: 'none' }}>
                                                    <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-4 mt-5">
                                                      <img src={alert_search} alt="Redtie" className="img-size-180" />
                                                      <div className="f_sz16 d-inline-block w-100">
                                                        No specific Workflow found for the search term
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="workflowgallery_boxes all_contentflex_div pt-1 pb-3 justify-content-center">
                                                    {this.state.workflow_list_array?.map((workflow, index) => {
                                                      return (
                                                        <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                          <div
                                                            className={
                                                              workflow.status === 'deactive'
                                                                ? 'card bx_shadow_sm brdrtop_red1'
                                                                : workflow.status === 'active'
                                                                  ? 'card bx_shadow_sm brdrtop_green1'
                                                                  : 'card bx_shadow_sm brdrtop_orange'
                                                            }>
                                                            <div className="card-header border-bottom-0 position-relative">
                                                              <div className="card-title w-100 text-center">
                                                                <h3 className="f_sz15 mb-2 pb-1">
                                                                  {workflow.workflow_name}
                                                                </h3>
                                                                <div>
                                                                  <span className="flightgrey3 f_sz13">
                                                                    {moment(workflow.updated_date).format(
                                                                      'MMMM DD,YYYY hh:mma',
                                                                    )}
                                                                  </span>{' '}
                                                                  {workflow.status === 'deactive' ? (
                                                                    <span className="badge badge-inactive">
                                                                      Inactive
                                                                    </span>
                                                                  ) : workflow.status === 'active' ? (
                                                                    <span className="badge badge-active">Active</span>
                                                                  ) : (
                                                                    <span className="badge badge-paused">Paused</span>
                                                                  )}
                                                                </div>
                                                              </div>
                                                            </div>
                                                            {/* /.card-header */}
                                                            <div className="card-body fgrey pt-0 pb-1 text-center">
                                                              <table
                                                                className="text-center f_sz12 table-bordered wfcount_tbl"
                                                                width="100%"
                                                                cellSpacing={0}
                                                                cellPadding={0}>
                                                                <tbody>
                                                                  <tr>
                                                                    <td className="text-center">
                                                                      <span
                                                                        className="crsr_pntr"
                                                                        data-toggle="modal"
                                                                        data-target="#modal_activecontacts"
                                                                        data-backdrop="static"
                                                                        onClick={() => {
                                                                          this.workflow_contacts_list(
                                                                            workflow,
                                                                            'active',
                                                                          );
                                                                        }}>
                                                                        <div className="font-weight-bold">
                                                                          Active
                                                                          <span className="flightgrey f_sz15 ml-3 text-right">
                                                                            <i className="fas fa-chart-line " />
                                                                          </span>
                                                                          {/* <span
                                                                            className="badge"
                                                                            style={{
                                                                              color: '#000000',
                                                                              backgroundColor: '#a8ebff',
                                                                              fontSize: 'inherit',
                                                                            }}>
                                                                            View
                                                                          </span> */}
                                                                        </div>
                                                                      </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                      <span
                                                                        className="crsr_pntr"
                                                                        data-toggle="modal"
                                                                        data-target="#modal_activecontacts"
                                                                        data-backdrop="static"
                                                                        onClick={() => {
                                                                          this.workflow_contacts_list(
                                                                            workflow,
                                                                            'started',
                                                                          );
                                                                        }}>
                                                                        <div className="font-weight-bold ">
                                                                          Started
                                                                          <span className="flightgrey f_sz15 ml-3 text-right">
                                                                            <i className="fas fa-chart-line " />
                                                                          </span>
                                                                          {/* <span
                                                                            className="badge"
                                                                            style={{
                                                                              color: '#000000',
                                                                              backgroundColor: '#a8ebff',
                                                                              fontSize: 'inherit',
                                                                            }}>
                                                                            View
                                                                          </span> */}
                                                                        </div>
                                                                      </span>
                                                                    </td>
                                                                  </tr>
                                                                  <tr>
                                                                    <td className="text-center">
                                                                      <span
                                                                        className="crsr_pntr"
                                                                        data-toggle="modal"
                                                                        data-target="#modal_activecontacts"
                                                                        data-backdrop="static"
                                                                        onClick={() => {
                                                                          this.workflow_contacts_list(
                                                                            workflow,
                                                                            'finished',
                                                                          );
                                                                        }}>
                                                                        <div className="font-weight-bold ">
                                                                          Finished
                                                                          <span className="flightgrey f_sz15 ml-3 text-right">
                                                                            <i className="fas fa-chart-line " />
                                                                          </span>
                                                                          {/* <span
                                                                            className="badge"
                                                                            style={{
                                                                              color: '#000000',
                                                                              backgroundColor: '#a8ebff',
                                                                              fontSize: 'inherit',
                                                                            }}>
                                                                            View
                                                                          </span> */}
                                                                        </div>
                                                                      </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                      <span
                                                                        className="crsr_pntr"
                                                                        data-toggle="modal"
                                                                        data-target="#modal_activecontacts"
                                                                        data-backdrop="static"
                                                                        onClick={() => {
                                                                          this.workflow_contacts_list(
                                                                            workflow,
                                                                            'suspended',
                                                                          );
                                                                        }}>
                                                                        <div className="font-weight-bold ">
                                                                          Suspended
                                                                          <span className="flightgrey f_sz15 ml-3 text-right">
                                                                            <i className="fas fa-chart-line " />
                                                                          </span>
                                                                          {/* <span
                                                                            className="badge"
                                                                            style={{
                                                                              color: '#000000',
                                                                              backgroundColor: '#a8ebff',
                                                                              fontSize: 'inherit',
                                                                            }}>
                                                                            View
                                                                          </span> */}
                                                                        </div>
                                                                      </span>
                                                                    </td>
                                                                  </tr>
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                            {/* /.card-body */}
                                                            <div className="card-footer text-center bg-transparent">
                                                              <div className="tbl_actionbtns text-center">
                                                                {/* <a href="#"><i class="far fa-play-circle f_sz18" data-toggle="tooltip" data-placement="bottom" title="Activate"></i></a> */}
                                                                <a
                                                                  style={{
                                                                    display:
                                                                      workflow.status === 'deactive'
                                                                        ? 'none'
                                                                        : 'inline-block',
                                                                  }}
                                                                  data-toggle="modal"
                                                                  data-target="#modal_wfdeactivate"
                                                                  data-backdrop="static"
                                                                  onClick={() => {
                                                                    this.setState({ workflow_status_data: workflow });
                                                                  }}>
                                                                  <i
                                                                    className="fas fa-power-off fmaroon f_sz15 crsr_pntr"
                                                                    data-toggle="tooltip"
                                                                    data-placement="bottom"
                                                                    title="Deactivate"
                                                                  />
                                                                </a>
                                                                <a
                                                                  style={{
                                                                    display:
                                                                      workflow.status === 'inactive' ||
                                                                        workflow.status === 'deactive'
                                                                        ? 'none'
                                                                        : 'inline-block',
                                                                  }}
                                                                  data-toggle="modal"
                                                                  data-target="#modal_wfpause"
                                                                  data-backdrop="static"
                                                                  onClick={() => {
                                                                    this.setState({ workflow_status_data: workflow });
                                                                  }}>
                                                                  <i
                                                                    className="far fa-pause-circle fmaroon f_sz19 crsr_pntr"
                                                                    data-toggle="tooltip"
                                                                    data-placement="bottom"
                                                                    title="Pause"
                                                                  />
                                                                </a>
                                                                <a
                                                                  style={{
                                                                    display:
                                                                      workflow.status === 'active'
                                                                        ? 'none'
                                                                        : 'inline-block',
                                                                  }}
                                                                  onClick={() => {
                                                                    this.onupdate_workflow_status(workflow, 'active');
                                                                  }}>
                                                                  <i
                                                                    className="far fa-play-circle f_sz18 crsr_pntr"
                                                                    data-toggle="tooltip"
                                                                    data-placement="bottom"
                                                                    title="activate"
                                                                  />
                                                                </a>
                                                                {/*<a>
                                                                    <i
                                                                      className="far fa-copy fmaroon f_sz16 crsr_pntr"
                                                                      data-toggle="tooltip"
                                                                      data-placement="bottom"
                                                                      title="Duplicate"
                                                                    />
                                                                  </a> */}
                                                                <a className="addworkflow_clk">
                                                                  <i
                                                                    onClick={() => this.onedit_workflow(workflow)}
                                                                    className="fas fa-pen fmaroon f_sz15 crsr_pntr"
                                                                    data-toggle="tooltip"
                                                                    data-placement="bottom"
                                                                    title="Edit"
                                                                  />
                                                                </a>
                                                                <a>
                                                                  <i
                                                                    onClick={() => this.ondelete_workflow(workflow)}
                                                                    className="far fa-trash-alt fmaroon f_sz15 crsr_pntr"
                                                                    data-toggle="tooltip"
                                                                    data-placement="bottom"
                                                                    title="Delete"
                                                                  />
                                                                </a>
                                                                <a
                                                                  className="wfhistory_logclk"
                                                                  onClick={() => this.wfhistory_logclk(workflow)}>
                                                                  <i
                                                                    className="fas fa-history fmaroon f_sz15 crsr_pntr"
                                                                    data-toggle="tooltip"
                                                                    data-placement="bottom"
                                                                    title
                                                                    data-original-title="History"
                                                                  />
                                                                </a>
                                                              </div>
                                                            </div>
                                                            {/* /.card-footer */}
                                                          </div>
                                                          {/* /.card */}
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="workflow_cardbodyhistorystat_div" style={{ display: 'none' }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="card-header d-flex flex-row flex-wrap">
                                        <div className="col-6 col-sm-6 col-md-6 pl-0">
                                          <h5 className="fmaroon">
                                            History - {this.state.workflow_history_data.workflow_name}
                                          </h5>
                                        </div>
                                        <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                          <div
                                            className="text-right fmaroon crsr_pntr wfcrdbdyhistoryback"
                                            onClick={() => {
                                              this.wfcrdbdyhistoryback();
                                            }}>
                                            <i className="fas fa-long-arrow-alt-left mr-2" />
                                            Back
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-body p-0 workflow_cardbdy">
                                        <div className="workflow_flowchart">
                                          <div>
                                            <div className="w-100 d-flex flex-row flex-wrap justify-content-center">
                                              <div className="tree">
                                                <p className="text-right f_sz12 m-1">
                                                  <span className="font-weight-bold">Note:</span> Mouseover on the boxes
                                                  to view history logs
                                                </p>
                                                <div className="font-weight-bold w-100 text-center pt-2">
                                                  Entry Points
                                                </div>
                                                <ul className="tree_entrypoint_ul scrollbar_style1">
                                                  {this.state.workflow_entry_list_array?.map((workflow, index) => {
                                                    return workflow.select_entry_point === 'contacts' ? (
                                                      <li className="entrypt_li">
                                                        <a>
                                                          <div className="wfbox bggreen position-relative">
                                                            <span className="wf_icondiv wf_icondivpos">
                                                              <i className="fas fa-user-friends" />
                                                            </span>
                                                            <span className="font-weight-bold">
                                                              For given contact(s)
                                                            </span>
                                                            <br />
                                                            {workflow.contacts?.length !== 0 ? (
                                                              <span>
                                                                Filter -{' '}
                                                                <span className="font-weight-bold fmaroon">
                                                                  {workflow.contacts?.length + ' contact(s)'}
                                                                </span>
                                                              </span>
                                                            ) : (
                                                              <span className="font-weight-bold fmaroon">
                                                                {'All contact(s) -  ' +
                                                                  this.state.businessprofiledetails.contacts}
                                                              </span>
                                                            )}
                                                            <br />
                                                            <span className="wf_startpt_pos flightgrey3">
                                                              startpoint #{index + 1}
                                                            </span>

                                                            <div className="wf_actnbtnsdiv">
                                                              <span
                                                                onClick={() =>
                                                                  this.workflow_entrypoint_contact_list(workflow)
                                                                }
                                                                className="wf_actionicondiv bg_orange"
                                                                data-toggle="modal"
                                                                data-target="#modal_historycontacts"
                                                                data-backdrop="static">
                                                                <i className="fas fa-users" />
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </a>
                                                      </li>
                                                    ) : workflow.select_entry_point === 'tags' ? (
                                                      <li className="entrypt_li">
                                                        <a>
                                                          <div className="wfbox bggreen position-relative">
                                                            <span className="wf_icondiv wf_icondivpos">
                                                              <i className="fas fa-tags f_sz12" />
                                                            </span>
                                                            <span className="font-weight-bold">For given tag(s)</span>
                                                            <br />
                                                            <span>
                                                              Filter -{' '}
                                                              <span className="font-weight-bold fmaroon">
                                                                {workflow.tags?.length}
                                                              </span>{' '}
                                                              tags
                                                            </span>

                                                            <span
                                                              onClick={() => this.view_tag_contact_count(workflow)}
                                                              className={
                                                                'fmaroon ml-2 crsr_pntr wftags_viewct wf_tag_view_' +
                                                                workflow._id
                                                              }>
                                                              (View)
                                                            </span>
                                                            <span
                                                              className={
                                                                'ml-2 crsr_pntr wftags_ctcount wf_tag_cont_' +
                                                                workflow._id
                                                              }
                                                              style={{ display: 'none' }}>
                                                              (
                                                              <span className="fmaroon font-weight-bold">
                                                                {this.state.contactscount_tag}
                                                              </span>{' '}
                                                              contact(s))
                                                            </span>

                                                            <br />
                                                            <span className="wf_startpt_pos flightgrey3">
                                                              startpoint #{index + 1}
                                                            </span>
                                                            <div className="wf_actnbtnsdiv">
                                                              <span
                                                                onClick={() =>
                                                                  this.workflow_entrypoint_contact_list(workflow)
                                                                }
                                                                className="wf_actionicondiv bg_orange"
                                                                data-toggle="modal"
                                                                data-target="#modal_historycontacts"
                                                                data-backdrop="static">
                                                                <i className="fas fa-users" />
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </a>
                                                      </li>
                                                    ) : (
                                                      <li className="entrypt_li">
                                                        <a>
                                                          <div className="wfbox bggreen position-relative">
                                                            <span className="wf_icondiv wf_icondivpos">
                                                              <i className="far fa-arrow-alt-circle-down" />
                                                            </span>
                                                            <span className="font-weight-bold">Inbound message</span>
                                                            <br />
                                                            <span>
                                                              Filter -{' '}
                                                              {workflow.inbound_type === 'equal_to'
                                                                ? 'Equal to'
                                                                : workflow.inbound_type === 'start_with'
                                                                  ? 'Starts with'
                                                                  : workflow.inbound_type === 'contains'
                                                                    ? 'Contains'
                                                                    : workflow.inbound_type === 'no_specification'
                                                                      ? 'No Specification'
                                                                      : ''}{' '}
                                                              <span className="font-weight-bold fmaroon">
                                                                {workflow.inbound_content}
                                                              </span>
                                                            </span>
                                                            <br />
                                                            <span className="wf_startpt_pos flightgrey3">
                                                              startpoint #{index + 1}
                                                            </span>
                                                          </div>
                                                        </a>
                                                      </li>
                                                    );
                                                  })}
                                                </ul>
                                                <ul className="pt-4 tree_steps_ul scrollbar_style1">
                                                  <li>
                                                    <span className="font-weight-bold">Steps to your workflow</span>
                                                    <ul>
                                                      <li id="first_level_his"></li>
                                                    </ul>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="tab-pane fade nav_links_prof_tabs"
                              id="custom-tabs-integrations"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-integrations-tab">
                              {/*Integrations*/}
                              <div className="card w-100 shadow-none integrations_card">
                                <div
                                  className="card-header px-2 py-2 border-bottom-0"
                                  onClick={() => this.hide_emoji()}>
                                  {/* START TABS DIV */}
                                  <div className="tabbable-responsive">
                                    <div className="tabbable">
                                      <ul
                                        className="nav nav-tabs border-bottom"
                                        id="custom-tabs-profilesettings-tab"
                                        role="tablist">
                                        <li className="nav-item IntegrationEmail">
                                          <a
                                            className="nav-link active"
                                            id="custom-tabs-psemail-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psemail"
                                            role="tab"
                                            aria-controls="custom-tabs-psemail"
                                            aria-selected="false">
                                            <i
                                              class="far fa-envelope f_sz22 postop_2 mr-3"
                                              style={{ color: '#20c997' }}></i>
                                            <span className="d-inline-block">Email</span>
                                          </a>
                                        </li>
                                        <li className="nav-item IntegrationChat">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-pschat-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-pschat"
                                            role="tab"
                                            aria-controls="custom-tabs-pschat"
                                            aria-selected="false">
                                            <i
                                              class="far fa-comment f_sz22 postop_2 mr-3"
                                              style={{ color: '#20c997' }}></i>
                                            <span className="d-inline-block">Chat</span>
                                          </a>
                                        </li>
                                        <li className="nav-item  IntegrationSlack">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-psslack-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psslack"
                                            role="tab"
                                            aria-controls="custom-tabs-psslack"
                                            aria-selected="true">
                                            <i class="fab fa-slack f_sz22 postop_2 mr-3" style={{ color: '#20c997' }}></i>
                                            <span className="d-inline-block">Slack</span>
                                          </a>
                                        </li>
                                        <li
                                          className="nav-item"
                                          style={{
                                            display:
                                              this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                'Trial' ||
                                                this.state.business_info_array?.business?.plan_id?.plan_name === 'Free'
                                                ? 'none'
                                                : 'inline-block',
                                          }}>
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-pswebhooks-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-pswebhooks"
                                            role="tab"
                                            aria-controls="custom-tabs-pswebhooks"
                                            aria-selected="false">
                                            <img
                                              src={prof_webhooks}
                                              border="0"
                                              class="img-size-20 postop_2up mr-3"></img>
                                            <span className="d-inline-block">Webhooks</span>
                                          </a>
                                        </li>
                                        {/* <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-psapi-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psapi"
                                            role="tab"
                                            aria-controls="custom-tabs-psapi"
                                            aria-selected="false">
                                            <span className="d-inline-block">API</span>
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-psphrases-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psphrases"
                                            role="tab"
                                            aria-controls="custom-tabs-psphrases"
                                            aria-selected="true">
                                            <span className="d-inline-block">Phrases</span>
                                          </a>
                                        </li> */}
                                        <li className="nav-item  IntegrationQrCodes">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-psqrcodes-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psqrcodes"
                                            role="tab"
                                            aria-controls="custom-tabs-psqrcodes"
                                            aria-selected="false"
                                            onClick={() => this.qrcode_listclick()}>
                                            <i
                                              class="fas fa-qrcode f_sz22 postop_2 mr-3"
                                              style={{ color: '#20c997' }}></i>
                                            <span className="d-inline-block">QR Codes</span>
                                          </a>
                                        </li>
                                        {/*<li className="nav-item">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-psgmail-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-psgmail"
                                            role="tab"
                                            aria-controls="custom-tabs-psgmail"
                                            aria-selected="false">
                                            <span className="d-inline-block">Gmail</span>
                                          </a>
                                        </li> */}
                                        {/*<li class="nav-item">
                  <a class="nav-link" id="custom-tabs-psrewards-tab" data-toggle="pill" href="#custom-tabs-psrewards" role="tab" aria-controls="custom-tabs-psrewards" aria-selected="false"><span class="d-inline-block">Rewards</span></a>
                </li>*/}
                                        <li className="nav-item IntegrationMeeting">
                                          <a
                                            className="nav-link"
                                            id="custom-tabs-meeting-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-meeting"
                                            role="tab"
                                            aria-controls="custom-tabs-meeting"
                                            aria-selected="false">
                                            <i
                                              class="fab fa-google f_sz22 postop_2 mr-3"
                                              style={{ color: '#20c997' }}></i>
                                            <span className="d-inline-block">Meeting</span>
                                          </a>
                                        </li>
                                        <li className="nav-item GeneralSummaryAlert">
                                          <a
                                            className="nav-link joyride_summary"
                                            id="custom-tabs-zapier-tab"
                                            data-toggle="pill"
                                            href="#custom-tabs-zapier"
                                            role="tab"
                                            aria-controls="custom-tabs-zapier"
                                            aria-selected="false">
                                            <img src={zapier_logo} className="mr-3" />
                                            <span className="d-inline-block">Zapier</span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="card-body px-0">
                                  <div className="tab-content" id="custom-tabs-profilesettings-tabContent">
                                    <div
                                      className="tab-pane fade active show "
                                      id="custom-tabs-psemail"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psemail-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="all_contentcntr_700">
                                            <div className="form-horizontal formbiglbl">
                                              {this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                'Trial' ||
                                                this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                'Free' ? (
                                                <div className="card-body">
                                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                                    <div className="f_sz16 w-100 d-inline-block pb-2">
                                                      To utilize{' '}
                                                      <span className="fmaroon font-weight-semibold">Email</span>,
                                                      please upgrade.
                                                    </div>
                                                    {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <TrialPaymentButton
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      name="Upgrade"
                                                    /> */}
                                                    <a
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      onClick={() => this.upgradeWorkspace('/create-profile?bid=' + this.state.business_info_array?.business?._id)}
                                                    >Upgrade</a>
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                  <div className="card-body">
                                                    <div className={this.state.EmlAlrtCls}>{this.state.EmlAlrtMsg}</div>

                                                    <div className="form-group row mt-3 mb-4">
                                                      <label className="col-12 col-sm-12 col-md-6 col-lg-5 col-form-label">
                                                        Workspace Email Address
                                                      </label>
                                                      <div className="col-12 col-sm-12 col-md-6 col-lg-7">
                                                        <div className="profemailaddr_dsplydiv">
                                                          <span className="mt-2 d-inline-block mr-2 f_sz16">
                                                            {this.state.business_email_address}
                                                            {/*[phone-number]@redtiemail.com*/}
                                                          </span>
                                                          <span className="fmaroon crsr_pntr profemailaddr_edit">
                                                            <i
                                                              className="fas fa-pen"
                                                              onClick={this.profemailaddr_edit}
                                                            />
                                                          </span>
                                                        </div>
                                                        <div className="profemailaddr_upddiv" style={{ display: 'none' }}>
                                                          <div className="w-100 d-flex flex-row mb-3">
                                                            <div className="col-11 col-sm-10 col-md-10 pl-0">
                                                              <div className="input-group">
                                                                <input
                                                                  type="text"
                                                                  className="form-control"
                                                                  value={this.state.business_email_name}
                                                                  onChange={(e) => {
                                                                    this.setState({
                                                                      business_email_name: e.target.value,
                                                                    });
                                                                  }}
                                                                />
                                                                <div className="input-group-append">
                                                                  <span className="input-group-text nobrdr_bg">
                                                                    {APP_EMAIL_ENDPOINT}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="col-1 col-sm-2 col-md-2 px-0">
                                                              <a
                                                                onClick={() => {
                                                                  this.save_email_integrations();
                                                                }}>
                                                                <i className="far fa-save mt-3 f_sz17 crsr_pntr fmaroon" />
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="form-group row mt-2 mb-2">
                                                      <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                        <span className="f_sz15">Permitted Team Members</span>
                                                      </label>
                                                      <small className="text-gray d-inline-block mt-1 ml-2">
                                                        Note: Include the members to be notified via Email when there is
                                                        an inbound text message .
                                                      </small>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <div className="card w-100 bx_shadow_sm mt-3">
                                                          <div className="card-body p-0">
                                                            <div className="table-responsive">
                                                              <table
                                                                className="table table-hover tbl_valignmdle tbl_teammember border-bottom"
                                                                id="emailprofteammember"
                                                                cellPadding={0}
                                                                cellSpacing={0}
                                                                style={{ width: '100%' }}>
                                                                <thead>
                                                                  <tr>
                                                                    <th className="text-center">
                                                                      <div className="icheck-darkgrey d-inline-block">
                                                                        <input
                                                                          type="checkbox"
                                                                          id="emailallteam"
                                                                          onClick={() => {
                                                                            this.chkAllTem_email();
                                                                          }}
                                                                        />
                                                                        <label htmlFor="emailallteam">&nbsp;</label>
                                                                      </div>
                                                                    </th>
                                                                    <th>Photo</th>
                                                                    <th>Email Address</th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {this.state.TeamMbrLst.map((teamList, index) => {
                                                                    var frst_ltr =
                                                                      teamList.user_info[0].email_address.charAt(0);
                                                                    var frstLtrCaps = frst_ltr.toUpperCase();
                                                                    var randomClr = randDarkColor();
                                                                    return (
                                                                      <tr>
                                                                        <td align="center">
                                                                          <div className="icheck-darkgrey d-inline-block">
                                                                            <input
                                                                              type="checkbox"
                                                                              id={
                                                                                'emailteam' + teamList.user_info[0]._id
                                                                              }
                                                                              className={
                                                                                'emailteam' + teamList.user_info[0]._id
                                                                              }
                                                                            />
                                                                            <label
                                                                              htmlFor={
                                                                                'emailteam' + teamList.user_info[0]._id
                                                                              }>
                                                                              &nbsp;
                                                                            </label>
                                                                          </div>
                                                                        </td>
                                                                        {teamList.user_info[0].profile_image != '' ? (
                                                                          <td>
                                                                            <span className="usercircleimg_md">
                                                                              <img
                                                                                src={
                                                                                  teamList.user_info[0].profile_image
                                                                                }
                                                                                border="0"
                                                                              />
                                                                            </span>
                                                                          </td>
                                                                        ) : (
                                                                          <td>
                                                                            <span
                                                                              className="usercircle_md bg_teammember1"
                                                                              style={{ backgroundColor: randomClr }}>
                                                                              {frstLtrCaps}
                                                                            </span>
                                                                          </td>
                                                                        )}
                                                                        <td>{teamList.user_info[0].email_address}</td>
                                                                      </tr>
                                                                    );
                                                                  })}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3">
                                                    <a
                                                      className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                      onClick={() => {
                                                        this.save_email_integrations();
                                                      }}>
                                                      Save
                                                    </a>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade "
                                      id="custom-tabs-pschat"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-pschat-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="all_contentcntr_700">
                                            <div className="form-horizontal formbiglbl">
                                              {this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                'Trial' ||
                                                this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                'Free' ? (
                                                <div className="card-body">
                                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                                    <div className="f_sz16 w-100 d-inline-block pb-2">
                                                      To utilize{' '}
                                                      <span className="fmaroon font-weight-semibold">Chat</span>, please
                                                      upgrade.
                                                    </div>
                                                    {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <TrialPaymentButton
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      name="Upgrade"
                                                    /> */}
                                                    <a
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      onClick={() =>
                                                        this.upgradeWorkspace(
                                                          '/create-profile?bid=' +
                                                          this.state.business_info_array?.business?._id,
                                                        )
                                                      }>
                                                      Upgrade
                                                    </a>
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                  <div className="card-body">
                                                    <div className={this.state.ChatGrtcls}>{this.state.ChatGrtMsg}</div>
                                                    <div>
                                                      <div
                                                        className="form-group row mt-3 mb-4"
                                                        onClick={() => this.hide_emoji()}>
                                                        <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                          Widget Code
                                                        </label>
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-2">
                                                          <textarea
                                                            className="form-control textarea_hgt80 txtarea_resizenone f_sz13 "
                                                            id="chat_script_link"
                                                            value={
                                                              '<script type="text/javascript" language="javascript" src="' +
                                                              CHAT_APP_ENDPOINT +
                                                              '/chat/cwidget.js" key="' +
                                                              business_id +
                                                              '"></script>\n'
                                                            }
                                                          />
                                                          <small className="text-gray d-inline-block mt-1">
                                                            Note: You can copy the code snippet and paste it on any of
                                                            your websites and start providing support to your end users.
                                                          </small>
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="bg-transparent text-right"
                                                        onClick={() => this.hide_emoji()}>
                                                        {/* <a className="btn btn-black crsr_pntr m-2 btnpdng_sm">Preview</a> */}
                                                        <a
                                                          onClick={() => this.copy_chat_link()}
                                                          className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                                          Copy
                                                        </a>
                                                      </div>
                                                    </div>
                                                    <div>
                                                      {/* <div className="form-group row mt-3 mb-4">
                                                    <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                      Team Member
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-2">
                                                      <div className="w-100 d-flex flex-row flex-wrap mb-3">
                                                        <div className="col-12 col-sm-12 col-md-8">
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter the email address"
                                                          />
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-md-4">
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter nick name"
                                                          />
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-right brdrbtm_dashed pt-2 pb-2">
                                                          <a>
                                                            <i className="fas fa-trash-alt mt-2 mr-3 f_sz16 crsr_pntr fmaroon" />
                                                          </a>
                                                          <a>
                                                            <i className="fas fa-plus-circle mt-2 f_sz17 crsr_pntr fmaroon" />
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div> */}

                                                      <div className="card-body py-0">
                                                        <div className="form-group row mt-2 mb-2">
                                                          <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                            <span className="f_sz15">
                                                              Greetings Message For Chat Widget
                                                            </span>
                                                          </label>
                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <textarea
                                                              className="form-control textarea_hgt100 txtarea_resizenone"
                                                              maxLength={300}
                                                              onChange={(e) => {
                                                                this.setState({ chat_grtmsg: e.target.value });
                                                              }}
                                                              onClick={() => this.hide_emoji()}
                                                              placeholder="Enter the Message"
                                                              value={this.state.chat_grtmsg}
                                                            />
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_greeting_show emoji_show_all"
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_greeting');
                                                                }}>
                                                                <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" />
                                                              </div>
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_greeting_close emoji_close_all"
                                                                style={{ display: 'none' }}
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_greeting');
                                                                }}>
                                                                <i
                                                                  className={
                                                                    'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                                  }
                                                                />
                                                              </div>
                                                              {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                              <span
                                                                className="flex-row flex-wrap emoji_position emoji_disable"
                                                                style={{
                                                                  display: 'none',
                                                                  position: 'inherit',
                                                                  width: 'inherit',
                                                                  zIndex: '10',
                                                                }}
                                                                id="chat_widgit_greeting"></span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="card-body py-0">
                                                        <div className="form-group row mt-2 mb-2">
                                                          <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                            <span className="f_sz15">
                                                              Reply Message For Chat Widget
                                                            </span>
                                                          </label>
                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <textarea
                                                              className="form-control textarea_hgt100 txtarea_resizenone"
                                                              maxLength={300}
                                                              onChange={(e) => {
                                                                this.setState({ chat_replymsg: e.target.value });
                                                              }}
                                                              onClick={() => this.hide_emoji()}
                                                              placeholder="Enter the Message"
                                                              value={this.state.chat_replymsg}
                                                            />
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_reply_show emoji_show_all"
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_reply');
                                                                }}>
                                                                <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" />
                                                              </div>
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_reply_close emoji_close_all"
                                                                style={{ display: 'none' }}
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_reply');
                                                                }}>
                                                                <i
                                                                  className={
                                                                    'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                                  }
                                                                />
                                                              </div>
                                                              {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                              <span
                                                                className="flex-row flex-wrap emoji_position emoji_disable"
                                                                style={{
                                                                  display: 'none',
                                                                  position: 'inherit',
                                                                  width: 'inherit',
                                                                  zIndex: '10',
                                                                }}
                                                                id="chat_widgit_reply"></span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="card-body py-0">
                                                        <div className="form-group row mt-2 mb-2">
                                                          <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                            <span className="f_sz15">
                                                              New Contact Message For Chat Widget
                                                            </span>
                                                          </label>

                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <textarea
                                                              className="form-control textarea_hgt100 txtarea_resizenone"
                                                              maxLength={300}
                                                              onChange={(e) => {
                                                                this.setState({ chat_newcontactmsg: e.target.value });
                                                              }}
                                                              onClick={() => this.hide_emoji()}
                                                              placeholder="Enter the Message"
                                                              value={this.state.chat_newcontactmsg}
                                                            />
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_new_con_show emoji_show_all"
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_new_con');
                                                                }}>
                                                                <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" />
                                                              </div>
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_new_con_close emoji_close_all"
                                                                style={{ display: 'none' }}
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_new_con');
                                                                }}>
                                                                <i
                                                                  className={
                                                                    'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                                  }
                                                                />
                                                              </div>
                                                              {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                              <span
                                                                className="flex-row flex-wrap emoji_position emoji_disable"
                                                                style={{
                                                                  display: 'none',
                                                                  position: 'inherit',
                                                                  width: 'inherit',
                                                                  zIndex: '10',
                                                                }}
                                                                id="chat_widgit_new_con"></span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="card-body py-0">
                                                        <div className="form-group row mt-2 mb-2">
                                                          <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                            <span className="f_sz15">
                                                              Existing Contact Message For Chat Widget
                                                            </span>
                                                          </label>

                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <textarea
                                                              className="form-control textarea_hgt100 txtarea_resizenone"
                                                              maxLength={300}
                                                              onChange={(e) => {
                                                                this.setState({ chat_existcontactmsg: e.target.value });
                                                              }}
                                                              onClick={() => this.hide_emoji()}
                                                              placeholder="Enter the Message"
                                                              value={this.state.chat_existcontactmsg}
                                                            />
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_exist_con_show emoji_show_all"
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_exist_con');
                                                                }}>
                                                                <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" />
                                                              </div>
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 chat_widgit_exist_con_close emoji_close_all"
                                                                style={{ display: 'none' }}
                                                                onClick={() => {
                                                                  this.render_emoji('chat_widgit_exist_con');
                                                                }}>
                                                                <i
                                                                  className={
                                                                    'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                                  }
                                                                />
                                                              </div>
                                                              {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                              <span
                                                                className="flex-row flex-wrap emoji_position emoji_disable"
                                                                style={{
                                                                  display: 'none',
                                                                  position: 'inherit',
                                                                  width: 'inherit',
                                                                  zIndex: '10',
                                                                }}
                                                                id="chat_widgit_exist_con"></span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="card-body py-0" onClick={() => this.hide_emoji()}>
                                                        <div className="form-group row mt-2 mb-2">
                                                          <label className="col-12 col-sm-12 col-md-12 col-lg-12 col-form-label">
                                                            <span className="f_sz15">Team</span>
                                                          </label>
                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <div className="table-responsive">
                                                              <table
                                                                className="table table-hover tbl_valignmdle tbl_teammember border-bottom"
                                                                id="profteammember"
                                                                cellPadding={0}
                                                                cellSpacing={0}
                                                                style={{ width: '100%' }}>
                                                                <thead>
                                                                  <tr>
                                                                    <th className="text-center">
                                                                      <div className="icheck-darkgrey d-inline-block">
                                                                        <input
                                                                          type="checkbox"
                                                                          id="allteam_chat"
                                                                          onClick={() => this.chkAllTem_chat()}
                                                                        />
                                                                        <label htmlFor="allteam_chat">&nbsp;</label>
                                                                      </div>
                                                                    </th>
                                                                    <th>Photo</th>
                                                                    <th>Email Address</th>
                                                                  </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {this.state.TeamMbrLst.map((teamList, index) => {
                                                                    var frst_ltr =
                                                                      teamList.user_info[0].email_address.charAt(0);
                                                                    var frstLtrCaps = frst_ltr.toUpperCase();
                                                                    var randomClr = randDarkColor();

                                                                    return (
                                                                      <tr>
                                                                        <td align="center">
                                                                          <div className="icheck-darkgrey d-inline-block">
                                                                            <input
                                                                              type="checkbox"
                                                                              id={
                                                                                'chatTmIds_' + teamList.user_info[0]._id
                                                                              }
                                                                              className={
                                                                                'chatTmIds_' + teamList.user_info[0]._id
                                                                              }
                                                                            />
                                                                            <label
                                                                              htmlFor={
                                                                                'chatTmIds_' + teamList.user_info[0]._id
                                                                              }>
                                                                              &nbsp;
                                                                            </label>
                                                                          </div>
                                                                        </td>
                                                                        {teamList.user_info[0].profile_image != '' ? (
                                                                          <td>
                                                                            <span className="usercircleimg_md">
                                                                              <img
                                                                                src={
                                                                                  teamList.user_info[0].profile_image
                                                                                }
                                                                                border="0"
                                                                              />
                                                                            </span>
                                                                          </td>
                                                                        ) : (
                                                                          <td>
                                                                            <span
                                                                              className="usercircle_md bg_teammember1"
                                                                              style={{ backgroundColor: randomClr }}>
                                                                              {frstLtrCaps}
                                                                            </span>
                                                                          </td>
                                                                        )}
                                                                        <td>{teamList.user_info[0].email_address}</td>
                                                                      </tr>
                                                                    );
                                                                  })}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="form-group mt-3 mb-4"
                                                      onClick={() => this.hide_emoji()}>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <div className="pschat_entertagname_drpdwn_div">
                                                          <span className="allselectdropdwn chatWidget_tags">
                                                            <select
                                                              className="selectpicker w-100 border-bottom f_sz16"
                                                              // id="chatWidget_tags"
                                                              onChange={(e) => {
                                                                this.tagonChange_chat(e);
                                                              }}
                                                              multiple
                                                              data-live-search="true">
                                                              {/* <option selected="selected">--Choose Tag--</option> */}
                                                              {this.state.tagList.map((tag, index) => {
                                                                return (
                                                                  <option key={index} value={tag._id}>
                                                                    {tag.tag_name}
                                                                  </option>
                                                                );
                                                              })}
                                                            </select>
                                                          </span>
                                                          <div className="col-12 px-0 text-right pt-2">
                                                            <span
                                                              className="fmaroon f_sz13 pschat_addtagname crsr_pntr"
                                                              onClick={() => this.pschat_addtagname()}>
                                                              <i className="fas fa-plus f_sz13 mr-2" />
                                                              Add New Tag
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div
                                                          className="pschat_entertagname_txtbx_div"
                                                          style={{ display: 'none' }}>
                                                          <div className="input-group">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder="Enter the new tag name"
                                                              value={this.state.chat_newtag}
                                                              onChange={(e) => {
                                                                this.setState({ chat_newtag: e.target.value });
                                                              }}
                                                            />
                                                            <div className="input-group-append">
                                                              <span className="input-group-text nobrdr_bg">
                                                                <span
                                                                  className="pschat_closeaddtagname crsr_pntr"
                                                                  onClick={() => this.pschat_closeaddtagname()}>
                                                                  <i className="fas fa-times f_sz13" />
                                                                </span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3"
                                                    onClick={() => this.hide_emoji()}>
                                                    <a
                                                      className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                      onClick={() => {
                                                        this.save_chat_details();
                                                      }}>
                                                      Save
                                                    </a>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade  "
                                      id="custom-tabs-psslack"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psslack-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <small class="text-red d-inline-block mt-1 ml-2">
                                            <b>
                                              Note: You will be notified via slack when there is an inbound text
                                              message.
                                            </b>
                                          </small>
                                          <div className="all_contentcntr_700">
                                            <div className="form-horizontal formbiglbl">
                                              {this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                'Trial' ||
                                                this.state.business_info_array?.business?.plan_id?.plan_name ===
                                                'Free' ? (
                                                <div className="card-body">
                                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                                    <div className="f_sz16 w-100 d-inline-block pb-2">
                                                      To utilize{' '}
                                                      <span className="fmaroon font-weight-semibold">Slack</span>,
                                                      please upgrade.
                                                    </div>
                                                    {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                    {/* <TrialPaymentButton
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      name="Upgrade"
                                                    /> */}
                                                    <a
                                                      class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                      onClick={() =>
                                                        this.upgradeWorkspace(
                                                          '/create-profile?bid=' +
                                                          this.state.business_info_array?.business?._id,
                                                        )
                                                      }>
                                                      Upgrade
                                                    </a>
                                                  </div>
                                                </div>
                                              ) : (
                                                <>
                                                  <div className="card-body">
                                                    <div className={this.state.slackGrtcls}>
                                                      {this.state.slackGrtMsg}
                                                    </div>
                                                    <div className="form-group row mt-5 mb-4">
                                                      <h5 className="col-12 col-sm-12 text-center fmaroon">
                                                        Connect with Slack
                                                      </h5>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <div className="text-center mt-3">
                                                          {!this.state.business_info_array?.business?.slack?.text ? (
                                                            <a
                                                              href={
                                                                Slack_auth + 'state=text|' + this.state.business_id
                                                              }>
                                                              <span className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm">
                                                                <i className="fab fa-slack f_sz22 postop_2 mr-3" />
                                                                Connect
                                                              </span>
                                                            </a>
                                                          ) : (
                                                            <span
                                                              className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm"
                                                              onClick={(e) => {
                                                                this.disconnectslack();
                                                              }}>
                                                              <i className="fab fa-slack f_sz22 postop_2 mr-3" />
                                                              Disconnect
                                                            </span>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id="custom-tabs-pswebhooks"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-pswebhooks-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div
                                            className="webhookadd_div"
                                            style={{
                                              display: this.state.webhookdetails?.length === 0 ? 'block' : 'none',
                                            }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body">
                                                  <div className="form-group row mt-5 mb-4">
                                                    <h5 className="col-12 col-sm-12 text-center fmaroon">
                                                      Webhook URL
                                                    </h5>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <div className="text-center mt-3">
                                                        <a>
                                                          <span
                                                            className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm addwebhook_clk"
                                                            onClick={this.addwebhook_clk}>
                                                            Add
                                                          </span>
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="webhooklist_div"
                                            style={{
                                              display: this.state.webhookdetails?.length === 0 ? 'none' : 'block',
                                            }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="card-header d-flex flex-row flex-wrap">
                                                <div className="col-6 col-sm-6 col-md-6 pl-0">
                                                  <h5 className="fmaroon pt-2">Webhook URL's</h5>
                                                </div>
                                                <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                                  <a
                                                    style={{
                                                      display:
                                                        this.state.webhookdetails_count <= 9 ? 'inline-block' : 'none',
                                                    }}
                                                    className="btn btn-black crsr_pntr btn-sm mt-1 addwebhook_clk">
                                                    <i className="fas fa-plus mr-2" />
                                                    Add New
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body pb-0">
                                                  <div className="form-group row">
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                                                      {this.state?.webhookdetails?.length !== 0
                                                        ? this.state?.webhookdetails?.map((webhook, index) => {
                                                          var nums = parseInt(index) + 1;
                                                          return (
                                                            <div className="web_hooks_lists">
                                                              <div className="w-100 d-flex flex-row flex-wrap mb-3">
                                                                <div className="col-12 col-sm-12 col-md-9 col-lg-10 pl-0">
                                                                  <div className="d-table webhookdedtls">
                                                                    <div className="d-table-row">
                                                                      <div className="d-table-cell align-middle">
                                                                        {nums++}.
                                                                      </div>
                                                                      <div className="d-table-cell">
                                                                        <span className="d-inline-block mr-2 f_sz14 txt_wrap w-100">
                                                                          {webhook.url}
                                                                        </span>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-md-3 col-lg-2">
                                                                  <div className="text-right text-md-center mt-2 mt-md-0 mr-3">
                                                                    {/* <span className="d-inline-block fmaroon f_sz16 webhookshistory_tgl1 crsr_pntr mr-3">
                                                                <i
                                                                  className="fas fa-history"
                                                                  onClick={this.webhookshistory_tgl1}
                                                                />
                                                                      </span> */}
                                                                    <span
                                                                      className="d-inline-block fmaroon crsr_pntr mr-3"
                                                                      onClick={this.editwebhooks.bind(
                                                                        this,
                                                                        webhook._id,
                                                                        webhook.url,
                                                                      )}
                                                                      data-id={webhook._id}
                                                                      data-url={webhook.url}>
                                                                      <i className="fas fa-pen f_sz16" />
                                                                    </span>
                                                                    <span
                                                                      className="d-inline-block fmaroon crsr_pntr"
                                                                      data-toggle="modal"
                                                                      data-target="#modal_deletewebhoos"
                                                                      onClick={this.deletewebhooks.bind(
                                                                        this,
                                                                        webhook._id,
                                                                        webhook.url,
                                                                      )}
                                                                      data-backdrop="static"
                                                                      data-id={webhook._id}>
                                                                      <i className="far fa-trash-alt f_sz16" />
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div
                                                                className="webhookshistory_tgldiv1"
                                                                style={{ display: 'none' }}>
                                                                <div className="all_contentflex_div">
                                                                  <div className="card w-100 mt-2 mb-5">
                                                                    <div className="card-header">
                                                                      <h5 className="fmaroon f_sz15">History</h5>
                                                                    </div>
                                                                    <div className="card-body p-0">
                                                                      <div className="table-responsive">
                                                                        <table
                                                                          className="table table-hover tbl_valignmdle tbl_webhookshistory border-bottom"
                                                                          id="webhookshistory_tbl1"
                                                                          cellPadding={0}
                                                                          cellSpacing={0}
                                                                          style={{ width: '100%' }}>
                                                                          <thead>
                                                                            <tr>
                                                                              <th>Date Time</th>
                                                                              <th>IPAddress</th>
                                                                            </tr>
                                                                          </thead>
                                                                          <tbody>
                                                                            <tr>
                                                                              <td>05/25/2020 7.53pm</td>
                                                                              <td>152.145.1.1</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/14/2020 5.00am</td>
                                                                              <td>152.142.1.1</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 3.00pm</td>
                                                                              <td>147.155.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 8.00am</td>
                                                                              <td>111.155.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 7.00pm</td>
                                                                              <td>147.145.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 6.45pm</td>
                                                                              <td>122.475.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 8.23am</td>
                                                                              <td>123.155.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 7.45pm</td>
                                                                              <td>784.145.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 8.00am</td>
                                                                              <td>485.123.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 4.00am</td>
                                                                              <td>125.155.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 6.00am</td>
                                                                              <td>142.155.1.0</td>
                                                                            </tr>
                                                                            <tr>
                                                                              <td>04/10/2020 9.00am</td>
                                                                              <td>147.142.1.0</td>
                                                                            </tr>
                                                                          </tbody>
                                                                        </table>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          );
                                                        })
                                                        : ''}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="addwebhook_div" style={{ display: 'none' }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                                <h5>
                                                  <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                                    Add Webhook URL(s)
                                                  </span>
                                                  <span className="addwebhook_close mr-2 mt-1">
                                                    <i className="fas fa-times" onClick={this.addwebhook_close} />
                                                  </span>
                                                </h5>
                                              </div>
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body webhooks_append_div">
                                                  <div className="form-group row mt-3 mb-4 web_hooks_lists">
                                                    <div className="col-10 col-sm-10 col-md-10 col-lg-10">
                                                      <input
                                                        type="text"
                                                        className="form-control webhook_urls"
                                                        placeholder="Enter Webhook URL"
                                                      />
                                                      <small className="text-gray d-inline-block mt-1">
                                                        Eg: https://www.redtie.co/v4/app/webhook
                                                      </small>
                                                    </div>
                                                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 pr-0">
                                                      {/* <a>
                                                        <i
                                                          className="fas fa-trash-alt mt-2 mr-3 f_sz16 crsr_pntr fmaroon webhook_trash"
                                                          data-id="0"
                                                        />
                                                      </a> */}
                                                      <a>
                                                        <i
                                                          className="fas fa-plus-circle mt-2 f_sz16 crsr_pntr fmaroon webhook_add"
                                                          data-id="0"
                                                        />
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3">
                                                <a className="btn btn-black crsr_pntr m-2 btnpdng_sm webhook_save">
                                                  Save
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="edit_webhooks_div" style={{ display: 'none' }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                                <h5>
                                                  <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                                    Edit Webhook URL
                                                  </span>
                                                  <span className="addwebhook_close mr-2 mt-1">
                                                    <i className="fas fa-times" onClick={this.addwebhook_close} />
                                                  </span>
                                                </h5>
                                              </div>
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body">
                                                  <div className="form-group row mt-3 mb-4">
                                                    <div className="col-10 col-sm-10 col-md-10 col-lg-10">
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Webhook URL"
                                                        id="webhooks_updated_url"
                                                      />
                                                      <input type="hidden" id="webhook_id" />
                                                      <small className="text-gray d-inline-block mt-1">
                                                        Eg: https://www.redtie.co/v4/app/webhook
                                                      </small>
                                                    </div>
                                                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 pr-0"></div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3">
                                                <a className="btn btn-black crsr_pntr m-2 btnpdng_sm webhook_update">
                                                  Update
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id="custom-tabs-psapi"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psapi-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="apicreate_div">
                                            <div className="card w-100 shadow-none">
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body">
                                                  <div className="form-group row mt-5 mb-4">
                                                    <h5 className="col-12 col-sm-12 text-center fmaroon">API Keys</h5>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <div className="text-center mt-3">
                                                        <a>
                                                          <span
                                                            className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm apicreate_clk"
                                                            onClick={this.apicreate_clk}>
                                                            Create
                                                          </span>
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="apilist_div" style={{ display: 'none' }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="card-header d-flex flex-row flex-wrap">
                                                <div className="col-6 col-sm-6 col-md-6 pl-0">
                                                  <h5 className="fmaroon pt-2">
                                                    <span className="mr-3">API Keys</span>{' '}
                                                    <a href="#">
                                                      <span className="f_sz14 forange d-block d-md-inline-block mt-2 mt-md-0">
                                                        API Reference
                                                        <i className="fas fa-long-arrow-alt-right ml-1" />
                                                      </span>
                                                    </a>
                                                  </h5>
                                                </div>
                                                <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                                  <a className="btn btn-black crsr_pntr btn-sm mt-1">Create New</a>
                                                </div>
                                              </div>
                                              <div className="card-body p-0">
                                                <div className="table-responsive">
                                                  <table
                                                    className="table table-hover tbl_valignmdle tbl_api border-bottom"
                                                    id="apikey_tbl"
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    style={{ width: '100%' }}>
                                                    <thead>
                                                      <tr>
                                                        <th className="text-center">S.No</th>
                                                        <th>ID and Secret Key</th>
                                                        <th className="text-center">Action</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr>
                                                        <td align="center">1</td>
                                                        <td>
                                                          <div>
                                                            <span className="font-weight-semibold mr-2">ID:</span>
                                                            zUBuFTh9QIK8sTr9mLDieFxSXR3hdPBzvqZJZctm9PYXyH87xveKaFls1wbK
                                                          </div>
                                                          <div>
                                                            <span className="font-weight-semibold mr-2">
                                                              Secret Key:
                                                            </span>{' '}
                                                            gwdjWgoO5hfQ{' '}
                                                          </div>
                                                        </td>
                                                        <td align="center">
                                                          <div className="tbl_actionbtns">
                                                            <div className="d-inline-block switchbtn_wdth postop_5up">
                                                              <div className="custom-control custom-switch pl-0">
                                                                <input
                                                                  type="checkbox"
                                                                  className="custom-control-input"
                                                                  id="apikey1"
                                                                />
                                                                <label
                                                                  className="custom-control-label"
                                                                  htmlFor="apikey1"
                                                                />
                                                              </div>
                                                            </div>
                                                            <div className="d-inline-block mt-2 mt-md-0">
                                                              <a href="#">
                                                                <i className="far fa-trash-alt postop_2up" />
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td align="center">2</td>
                                                        <td>
                                                          <div>
                                                            <span className="font-weight-semibold mr-2">ID:</span>
                                                            juLOpTh9QIK8sTr9mLDieFxSXR3hdPBzvqZJZctm9PYXyH87xveKaKILOPgh
                                                          </div>
                                                          <div>
                                                            <span className="font-weight-semibold mr-2">
                                                              Secret Key:
                                                            </span>{' '}
                                                            WgoOgwdj5hfQ{' '}
                                                          </div>
                                                        </td>
                                                        <td align="center">
                                                          <div className="tbl_actionbtns">
                                                            <div className="d-inline-block switchbtn_wdth postop_5up">
                                                              <div className="custom-control custom-switch pl-0">
                                                                <input
                                                                  type="checkbox"
                                                                  className="custom-control-input"
                                                                  id="apikey2"
                                                                  defaultChecked="checked"
                                                                />
                                                                <label
                                                                  className="custom-control-label"
                                                                  htmlFor="apikey2"
                                                                />
                                                              </div>
                                                            </div>
                                                            <div className="d-inline-block mt-2 mt-md-0">
                                                              <a href="#">
                                                                <i className="far fa-trash-alt postop_2up" />
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id="custom-tabs-psphrases"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psphrases-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="phrasecreate_div">
                                            <div className="card w-100 shadow-none">
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body">
                                                  <div className="form-group row mt-5 mb-4">
                                                    <h5 className="col-12 col-sm-12 text-center fmaroon">Phrases</h5>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <div className="text-center mt-3">
                                                        <a onClick={this.phrasecreate_clk}>
                                                          <span
                                                            className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm phrasecreate_clk"
                                                            onClick={this.phrasecreate_clk}>
                                                            Create Phrase
                                                          </span>
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="phraselist_div" style={{ display: 'none' }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="card-header d-flex flex-row flex-wrap">
                                                <div className="col-6 col-sm-6 col-md-6 pl-0">
                                                  <h5 className="fmaroon pt-2">Phrases</h5>
                                                </div>
                                                <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                                  <a
                                                    className="btn btn-black crsr_pntr btn-sm mt-1 phrasecreate_clk"
                                                    onClick={this.phrasecreate_clk}>
                                                    Add New
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="card-body p-0">
                                                <div className="table-responsive">
                                                  <table
                                                    className="table table-hover tbl_valignmdle tbl_intphrases border-bottom"
                                                    id="intphrases_tbl"
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    style={{ width: '100%' }}>
                                                    <thead>
                                                      <tr>
                                                        <th>Phrase</th>
                                                        <th>Auto Response Message</th>
                                                        <th>Tags</th>
                                                        <th className="text-center">Action</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr>
                                                        <td>DIWALI</td>
                                                        <td>
                                                          Thanks for joining our Diwali list. We will send Diwali
                                                          specials from merchants. You can send 'STOP DIWALI' any time
                                                          to unsubscribe.
                                                        </td>
                                                        <td>
                                                          <span className="badge badge-info f_sz12 mr-1">
                                                            Diwali 2020
                                                          </span>
                                                          <span className="badge badge-info f_sz12 mr-1">
                                                            Crackers 2020
                                                          </span>
                                                          <span className="badge badge-info f_sz12 mr-1">
                                                            Funny Diwlali 2020
                                                          </span>
                                                        </td>
                                                        <td align="center">
                                                          <div className="tbl_actionbtns">
                                                            <a className="phrasecreate_clk">
                                                              <i
                                                                className="fas fa-pen"
                                                                title="Edit"
                                                                onClick={this.phrasecreate_clk}
                                                              />
                                                            </a>
                                                            <a href="#">
                                                              <i className="far fa-trash-alt" title="Delete" />
                                                            </a>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>STUDAI</td>
                                                        <td>
                                                          Thanks for joining our Students list. We will send updates on
                                                          AI. You can send 'STOP STUDAI' any time to unsubscribe.
                                                        </td>
                                                        <td>
                                                          <span className="badge badge-info f_sz12 mr-1">
                                                            Students IIL 2020
                                                          </span>
                                                          <span className="badge badge-info f_sz12 mr-1">
                                                            StudAI 2020
                                                          </span>
                                                        </td>
                                                        <td align="center">
                                                          <div className="tbl_actionbtns">
                                                            <a className="phrasecreate_clk">
                                                              <i className="fas fa-pen" title="Edit" />
                                                            </a>
                                                            <a href="#">
                                                              <i className="far fa-trash-alt" title="Delete" />
                                                            </a>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>Hackathon</td>
                                                        <td>
                                                          Thanks for joining Hackathon. We will send updates on the
                                                          events. You can send 'STOP Hackathon' any time to unsubscribe.
                                                        </td>
                                                        <td>
                                                          <span className="badge badge-info f_sz12 mr-1">
                                                            Hackathon 2020
                                                          </span>
                                                        </td>
                                                        <td align="center">
                                                          <div className="tbl_actionbtns">
                                                            <a className="phrasecreate_clk">
                                                              <i
                                                                className="fas fa-pen"
                                                                title="Edit"
                                                                onClick={this.phrasecreate_clk}
                                                              />
                                                            </a>
                                                            <a href="#">
                                                              <i className="far fa-trash-alt" title="Delete" />
                                                            </a>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="addphrase_div" style={{ display: 'none' }}>
                                            <div className="card w-100 shadow-none">
                                              <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                                <h5>
                                                  <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                                    Add Phrase
                                                  </span>
                                                  <span className="addintphrase_close mr-2 mt-1">
                                                    <i className="fas fa-times" onClick={this.addintphrase_close} />
                                                  </span>
                                                </h5>
                                              </div>
                                              <div className="all_contentcntr_700">
                                                <div className="form-horizontal formbiglbl">
                                                  <div className="card-body">
                                                    {/*Element to be Looped*/}
                                                    <div>
                                                      <div className="form-group mt-3 mb-4">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter the New Phrase"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="form-group mt-3 mb-2">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <textarea
                                                            className="form-control textarea_hgt100 txtarea_resizenone"
                                                            placeholder="Enter Auto Response Message"
                                                            defaultValue={''}
                                                            maxLength={300}
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="form-group mt-3 mb-4">
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                                                          <div className="psphrase_entertagname_drpdwn_div">
                                                            <span className="allselectdropdwn">
                                                              <select
                                                                className="selectpicker w-100 border-bottom f_sz16"
                                                                multiple
                                                                data-live-search="true">
                                                                <option selected="selected">--Choose Tag(s)--</option>
                                                                <option>Conference IIL 2020</option>
                                                                <option>Friends and Relatives</option>
                                                                <option>Innovation Strategy</option>
                                                                <option>Design and Development</option>
                                                              </select>
                                                            </span>
                                                            <div className="col-12 px-0 text-right pt-2">
                                                              <span className="fmaroon f_sz13 psphrase_addtagname crsr_pntr">
                                                                <i
                                                                  className="fas fa-plus f_sz13 mr-2"
                                                                  onClick={this.psphrase_addtagname}
                                                                />
                                                                Add New Tag
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="psphrase_entertagname_txtbx_div"
                                                            style={{ display: 'none' }}>
                                                            <div className="input-group">
                                                              <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter the new tag name"
                                                              />
                                                              <div className="input-group-append">
                                                                <span className="input-group-text nobrdr_bg">
                                                                  <span className="psphrase_closeaddtagname crsr_pntr">
                                                                    <i
                                                                      className="fas fa-times f_sz13"
                                                                      onClick={this.psphrase_closeaddtagname}
                                                                    />
                                                                  </span>
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-right brdrbtm_dashed pb-2">
                                                        <a>
                                                          <i className="fas fa-trash-alt mt-2 mr-3 f_sz16 crsr_pntr fmaroon" />
                                                        </a>
                                                        <a>
                                                          <i className="fas fa-plus-circle mt-2 f_sz17 crsr_pntr fmaroon" />
                                                        </a>
                                                      </div>
                                                    </div>
                                                    {/*Element to be Looped*/}
                                                  </div>
                                                </div>
                                                <div className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3">
                                                  <a className="btn btn-black crsr_pntr m-2 btnpdng_sm">Save</a>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade  "
                                      id="custom-tabs-psqrcodes"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psqrcodes-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          {this.state.business_info_array?.business?.plan_id?.plan_name === 'Trial' ||
                                            this.state.business_info_array?.business?.plan_id?.plan_name === 'Free' ? (
                                            <div className="card-body">
                                              <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                                <div className="f_sz16 w-100 d-inline-block pb-2">
                                                  To utilize{' '}
                                                  <span className="fmaroon font-weight-semibold">Qr Codes</span>, please
                                                  upgrade.
                                                </div>
                                                {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                {/* <TrialPaymentButton
                                                  class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                  name="Upgrade"
                                                /> */}
                                                <a
                                                  class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                  onClick={() => this.upgradeWorkspace('/create-profile?bid=' + this.state.business_info_array?.business?._id)}
                                                >Upgrade</a>
                                              </div>
                                            </div>
                                          ) : (
                                            <>
                                              <small className="text-red d-inline-block mt-1 ml-2">
                                                <b>
                                                  Note: Create QR code campaigns and send text messages to the users who
                                                  scan your QR code.
                                                </b>
                                              </small>
                                              <div className="qrcodecreate_div">
                                                <div className="card w-100 shadow-none">
                                                  <div className="form-horizontal formbiglbl">
                                                    <div className="card-body">
                                                      <div className="form-group row mt-5 mb-4">
                                                        <h5 className="col-12 col-sm-12 text-center fmaroon">
                                                          QR Codes
                                                        </h5>
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <div className="text-center mt-3">
                                                            <span
                                                              className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm qrcodecreate_clk"
                                                              onClick={this.qrcodecreate_clk}>
                                                              Create
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="qrcodelist_div" style={{ display: 'none' }}>
                                                <div className="card w-100 shadow-none">
                                                  <div className="card-header d-flex flex-row flex-wrap">
                                                    <div className="col-6 col-sm-6 col-md-6 pl-0">
                                                      <h5 className="fmaroon pt-2">QR Codes</h5>
                                                    </div>
                                                    <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                                      <a
                                                        className="btn btn-black crsr_pntr btn-sm mt-1 qrcodecreate_clk"
                                                        onClick={this.qrcodecreate_clk}>
                                                        Add New
                                                      </a>
                                                    </div>
                                                  </div>
                                                  <div className="card-body p-0">
                                                    <div className={this.state.QRGrtcls}>{this.state.QRGrtMsg}</div>
                                                    {this.state.qr_code_list.map((qr_code_individual, index) => {
                                                      return (
                                                        <>
                                                          <div>
                                                            <div className="w-100 d-flex flex-row flex-wrap mb-3">
                                                              <div className="col-12 col-sm-12 col-md-9 col-lg-10 pl-0">
                                                                <div className="d-table qrcodedtls">
                                                                  <div className="d-table-row">
                                                                    <div className="d-table-cell align-middle">
                                                                      {index + 1}.
                                                                    </div>
                                                                    <div className="d-table-cell">
                                                                      <div className="d-inline-block f_sz14 w-100">
                                                                        <span className="d-inline-block w-100 font-weight-semibold pb-2">
                                                                          {qr_code_individual.qr_title}
                                                                        </span>
                                                                        <span className="d-inline-block w-100 pb-2">
                                                                          <i className="far fa-comment-alt mr-3 postop_2 forange f_sz15" />
                                                                          {qr_code_individual.auto_response}
                                                                        </span>
                                                                        <span className="d-inline-block w-100">
                                                                          <i className="fas fa-tag mr-3 img-size-16"></i>
                                                                          {qr_code_individual?.tags?.map(
                                                                            (tags, index) => {
                                                                              return (
                                                                                <span className="badge badge-info f_sz12 mr-1">
                                                                                  {tags?.tag_name}
                                                                                </span>
                                                                              );
                                                                            },
                                                                          )}
                                                                          {/* <span className="badge badge-info f_sz12 mr-1">
                                                                        Conference IIL 2020
                                                                      </span>
                                                                      <span className="badge badge-info f_sz12 mr-1">
                                                                        IIL 2020
                                                                      </span> */}
                                                                        </span>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-3 col-lg-2">
                                                                <div className="f_sz16 mt-2 mt-md-5 text-right text-md-center mr-3">
                                                                  <span className="d-inline-block fmaroon crsr_pntr">
                                                                    <a
                                                                      data-toggle="modal"
                                                                      data-target="#modal_qrcodedownload"
                                                                      data-backdrop="static"
                                                                      className="crsr_pntrmt-1 mr-2"
                                                                      onClick={() => {
                                                                        this.view_presignedurl(
                                                                          qr_code_individual.qr_code_image,
                                                                        );
                                                                      }}>
                                                                      <i className="far fa-eye" />
                                                                    </a>
                                                                  </span>
                                                                  <span
                                                                    onClick={() => {
                                                                      this.qrcodeonMessageEdit(qr_code_individual);
                                                                    }}
                                                                    className="d-inline-block fmaroon crsr_pntr mr-3">
                                                                    <i className="fas fa-pencil-alt" />
                                                                  </span>

                                                                  <span className="d-inline-block fmaroon qrcodehistory_tgl1 crsr_pntr mr-3">
                                                                    <i
                                                                      className="fas fa-history"
                                                                      onClick={() => {
                                                                        this.qrcodehistory_tgl1(qr_code_individual);
                                                                      }}
                                                                    />
                                                                  </span>
                                                                  <span className="d-inline-block fmaroon crsr_pntr">
                                                                    <i
                                                                      className="far fa-trash-alt"
                                                                      onClick={() => {
                                                                        this.qrcode_delete(qr_code_individual);
                                                                      }}
                                                                    />
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div
                                                              id={'qr_his_' + qr_code_individual._id}
                                                              className="qrcodehistory_tgldiv1"
                                                              style={{ display: 'none' }}>
                                                              <div className="all_contentflex_div">
                                                                <div className="card w-100 mt-2">
                                                                  <div className="card-header">
                                                                    <h5 className="fmaroon f_sz15">History</h5>
                                                                  </div>
                                                                  <div className="card-body p-0">
                                                                    {this.state?.qr_code_history ? (
                                                                      <div className="table-responsive">
                                                                        <table
                                                                          className="table table-hover tbl_valignmdle tbl_qrcodehistory border-bottom"
                                                                          id="qrcodehistory_tbl1"
                                                                          cellPadding={0}
                                                                          cellSpacing={0}
                                                                          style={{ width: '100%' }}>
                                                                          <thead>
                                                                            <tr>
                                                                              <th>Date Time</th>
                                                                              <th>Location</th>
                                                                              <th>Contact</th>
                                                                            </tr>
                                                                          </thead>
                                                                          <tbody>
                                                                            {this.state?.qr_code_history.map(
                                                                              (history, index) => {
                                                                                return (
                                                                                  <tr>
                                                                                    <td>
                                                                                      <span className="time">
                                                                                        {moment(
                                                                                          history?.created_date,
                                                                                        ).format('MMMM DD,YYYY')}
                                                                                        <span className="ml-2">
                                                                                          {moment(
                                                                                            history?.created_date,
                                                                                          ).format('hh:mma')}
                                                                                        </span>
                                                                                      </span>
                                                                                    </td>
                                                                                    <td>{history?.location}</td>
                                                                                    <td>
                                                                                      {history?.contacts?.phone_number[0]
                                                                                        .toString()
                                                                                        .substring(1, 11)
                                                                                        .replace(/[^0-9]/g, '')
                                                                                        .replace(
                                                                                          /(\d{3})(\d{3})(\d{4})/,
                                                                                          '($1) $2-$3',
                                                                                        )
                                                                                        .trim()}
                                                                                    </td>
                                                                                  </tr>
                                                                                  // <span className="badge badge-info f_sz12 mr-1">
                                                                                  //   {tags?.tag_name}
                                                                                  // </span>
                                                                                );
                                                                              },
                                                                            )}
                                                                          </tbody>
                                                                        </table>
                                                                      </div>
                                                                    ) : (
                                                                      <h5 className="fmaroon f_sz15 text-center">
                                                                        ---No Records Found Yet---
                                                                      </h5>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <hr />
                                                        </>
                                                      );
                                                    })}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="addqrcode_div" style={{ display: 'none' }}>
                                                <div className="card w-100 shadow-none">
                                                  <div
                                                    className="card-header d-flex flex-row flex-wrap pb-0 pt-3"
                                                    onClick={() => {
                                                      this.hide_emoji();
                                                    }}>
                                                    <h5>
                                                      <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                                        Create QR Code
                                                      </span>
                                                      <span
                                                        className="addqrcode_close mr-2 mt-1"
                                                        onClick={this.addqrcode_close}>
                                                        <i className="fas fa-times" onClcik={this.addqrcode_close} />
                                                      </span>
                                                    </h5>
                                                  </div>
                                                  <div className="form-horizontal formbiglbl">
                                                    <div className="card-body px-0">
                                                      {/*Element to be Looped*/}
                                                      <div className={this.state.QRGrtcls}>{this.state.QRGrtMsg}</div>
                                                      <div>
                                                        <div
                                                          className="form-group mt-3 mb-4"
                                                          onClick={() => {
                                                            this.hide_emoji();
                                                          }}>
                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder="Enter the Title"
                                                              value={this.state.qr_title}
                                                              onChange={(e) => {
                                                                this.setState({ qr_title: e.target.value });
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                        <div
                                                          className="form-group mt-3 mb-4"
                                                          onClick={() => {
                                                            this.hide_emoji();
                                                          }}>
                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder="Enter the Description"
                                                              value={this.state.qr_description}
                                                              onChange={(e) => {
                                                                this.setState({ qr_description: e.target.value });
                                                              }}
                                                            />
                                                          </div>
                                                        </div>

                                                        <div className="form-group mt-3 mb-4">
                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                            <textarea
                                                              className="form-control textarea_hgt100 txtarea_resizenone"
                                                              placeholder="Enter Auto Response Message"
                                                              value={this.state.qr_message}
                                                              maxLength={300}
                                                              onChange={(e) => {
                                                                this.setState({ qr_message: e.target.value });
                                                              }}
                                                              onClick={() => {
                                                                this.hide_emoji();
                                                              }}
                                                            />
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 QR_code_response_show emoji_show_all"
                                                                onClick={() => {
                                                                  this.render_emoji('QR_code_response');
                                                                }}>
                                                                <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" />
                                                              </div>
                                                              <div
                                                                className="col-4 col-sm-4 col-md-4 pl-0 QR_code_response_close emoji_close_all"
                                                                style={{ display: 'none' }}
                                                                onClick={() => {
                                                                  this.render_emoji('QR_code_response');
                                                                }}>
                                                                <i
                                                                  className={
                                                                    'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                                  }
                                                                />
                                                              </div>
                                                              {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
                                                                  <div className="f_sz12 fred mt-1 text-left text-md-right">
                                          {this.state.chars_left_wfmsg} characters remaining
                                        </div>
                                                </div> */}
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                              <span
                                                                className="flex-row flex-wrap emoji_position emoji_disable"
                                                                style={{
                                                                  display: 'none',
                                                                  position: 'inherit',
                                                                  width: 'inherit',
                                                                  zIndex: '10',
                                                                }}
                                                                id="QR_code_response"></span>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="sendmessage_btnsdiv"
                                                            onClick={() => {
                                                              this.hide_emoji();
                                                            }}>
                                                            <div className="dropdown attachment_drpdwn d-inline-block">
                                                              <span
                                                                data-toggle="dropdown"
                                                                className="sendmessage_btnsspan">
                                                                <span className="btn btn-lg btn-black crsr_pntr">
                                                                  <i className="fas fa-paperclip" />
                                                                </span>
                                                              </span>
                                                              <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                                                <div className="dropdown-item">
                                                                  <div className="overallattachment_div">
                                                                    {/*<div class="overallattach_item qrcodesendmsgattach_clk">
                                                                    <div class="overallattach_icon bg_rewards bx_shadow_sm">
                                                                    <i class="far fa-star"></i>
                                                                    </div>
                                                                    <div class="fgrey">Rewards</div>
                                                                  </div>*/}
                                                                    <div
                                                                      className="overallattach_item qrcodesendmsgattach_clk"
                                                                      onClick={
                                                                        this.state.savingprogress === '...'
                                                                          ? null
                                                                          : this.saveNotes2_cmb
                                                                      }>
                                                                      <div className="overallattach_icon bg_notes bx_shadow_sm">
                                                                        <i className="far fa-sticky-note" />
                                                                      </div>
                                                                      <div className="fgrey">Notes</div>
                                                                    </div>
                                                                    <div
                                                                      className="overallattach_item qrcodesendmsgattach_clk"
                                                                    // onClick={this.fileGetDetails_cmb}
                                                                    >
                                                                      {/* <div className="overallattach_icon bg_documents bx_shadow_sm">
                                                                    <i className="far fa-file-alt" />
                                                                  </div> */}
                                                                      <label for="file-input">
                                                                        <div
                                                                          className="overallattach_icon bg_documents bx_shadow_sm"
                                                                          id="fdupld">
                                                                          <i className="far fa-file-alt" />
                                                                          <input
                                                                            id="file-input"
                                                                            type="file"
                                                                            name="DcfilNm"
                                                                            onChange={this.fileGetDetails_cmb}
                                                                          // multiple
                                                                          />
                                                                        </div>
                                                                      </label>
                                                                      <div className="fgrey">Documents</div>
                                                                    </div>
                                                                    <div className="overallattach_item qrcodesendmsgattach_clk">
                                                                      <label htmlFor="file-input3">
                                                                        <div
                                                                          className="overallattach_icon bg_gallery bx_shadow_sm"
                                                                          id="fdupld_2">
                                                                          <i
                                                                            className="far fa-image"
                                                                            data-place="bottom"
                                                                            data-tip="Images"
                                                                          />
                                                                          <input
                                                                            id="file-input3"
                                                                            type="file"
                                                                            name="DcfilNm"
                                                                            accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                                                            onChange={(event) =>
                                                                              this.fileGetDetails_cmb_images(event)
                                                                            }
                                                                          // multiple
                                                                          />
                                                                        </div>
                                                                        {/* <ReactTooltip /> */}
                                                                      </label>
                                                                      <div className="fgrey">Images</div>
                                                                    </div>
                                                                    <div
                                                                      className="overallattach_item qrcodesendmsgattach_clk"
                                                                      onClick={this.sendmsgattach_clkAudio2_cmb}>
                                                                      <div className="overallattach_icon bg_audio bx_shadow_sm">
                                                                        <i className="fas fa-microphone-alt" />
                                                                      </div>
                                                                      <div className="fgrey">Audio</div>
                                                                    </div>
                                                                    <div
                                                                      className="overallattach_item qrcodesendmsgattach_clk"
                                                                      onClick={this.sendmsgattach_clkVideo2_cmb}>
                                                                      <div className="overallattach_icon bg_video bx_shadow_sm">
                                                                        <i className="fas fa-film" />
                                                                      </div>
                                                                      <div className="fgrey">Video</div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb"
                                                          style={{ display: 'none' }}
                                                          onClick={() => {
                                                            this.hide_emoji();
                                                          }}>
                                                          <div className="row position-relative">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="attachment_timelinediv">
                                                                {/* The time line */}
                                                                <div className="timeline">
                                                                  {/* timeline item */}
                                                                  <div
                                                                    style={{ display: 'none' }}
                                                                    className="sendmsgattach_clkAudio2_cmb">
                                                                    <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="attachmentbody_div d-table">
                                                                          <div className="d-table-row">
                                                                            <div className="d-table-cell align-middle">
                                                                              <span className="ml-2">
                                                                                <span className="crsr_pntr">
                                                                                  <i
                                                                                    className="fas fa-record-vinyl fa-2x fbred"
                                                                                    onClick={this.audio_start_cmb}
                                                                                  />
                                                                                  <span
                                                                                    className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                    onClick={this.audio_start_cmb}>
                                                                                    Start Recording
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={this.audioLclDelte_cmb}>
                                                                          Delete
                                                                        </a>
                                                                        <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div>

                                                                  {/* timeline item */}
                                                                  <div
                                                                    style={{ display: 'none' }}
                                                                    className="audioRecordLoading_cmb">
                                                                    <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="attachmentbody_div d-table">
                                                                          <div className="d-table-row">
                                                                            <div className="d-table-cell align-middle">
                                                                              <span>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i
                                                                                      className="far fa-stop-circle f_sz30 fbred"
                                                                                      onClick={this.audio_stop_cmb}></i>
                                                                                    <span
                                                                                      className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                      onClick={this.audio_stop_cmb}>
                                                                                      Stop Recording
                                                                                    </span>
                                                                                  </span>
                                                                                  <span className="f_sz16">
                                                                                    <span>
                                                                                      <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                                        <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                          Delete
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {/* END timeline item */}
                                                                  {/* timeline item */}
                                                                  <div
                                                                    style={{ display: 'none' }}
                                                                    className="sendmsgattach_clkNotes2_cmb">
                                                                    <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <textarea
                                                                          className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                                                          placeholder="Enter the notes"
                                                                          value={this.state.notesValue2_cmb}
                                                                          onChange={this.notesLetter2_cmb}
                                                                          id="notestypearea"
                                                                        />
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        <a
                                                                          className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={this.saveNotes2_cmb}>
                                                                          Save
                                                                        </a>
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={this.notesLclDelte_cmb}>
                                                                          Delete
                                                                        </a>
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {/* END timeline item */}
                                                                  {/* timeline item */}
                                                                  <div
                                                                    style={{ display: 'none' }}
                                                                    className="sendmsgattach_clkVideo2_cmb">
                                                                    <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="attachmentbody_div d-table">
                                                                          <div className="d-table-row">
                                                                            <div className="d-table-cell align-middle">
                                                                              <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                                                <VideoRecorder
                                                                                  replayVideoAutoplayAndLoopOff={true}
                                                                                  // showReplayControls={true}
                                                                                  // mimeType="video/mp4"
                                                                                  // constraints={{audio: true}}
                                                                                  timeLimit={120000}
                                                                                  onRecordingComplete={(
                                                                                    videoBlob,
                                                                                    thumbnailBlob,
                                                                                    videoUrl,
                                                                                  ) => {
                                                                                    $(
                                                                                      '.sendmsgattach_clkVideo2_cmb',
                                                                                    ).hide();
                                                                                    $(
                                                                                      '.sendmsg_attachmentdiv2_cmb',
                                                                                    ).hide();

                                                                                    $('.attachLoading_cmb').show();
                                                                                    $('.attchLstShow_cmb').show();
                                                                                    this.setState({
                                                                                      lodingicon_cmb:
                                                                                        'fas fa-film bg_video',
                                                                                    });

                                                                                    // Do something with the video...
                                                                                    console.log(
                                                                                      'videoBloburl',
                                                                                      window.URL.createObjectURL(
                                                                                        videoBlob,
                                                                                      ),
                                                                                    );
                                                                                    console.log('videoBlob', videoBlob);
                                                                                    console.log(
                                                                                      'thumbnailBlob',
                                                                                      thumbnailBlob,
                                                                                    );
                                                                                    console.log('videoUrl', videoUrl);
                                                                                    var reader = new FileReader();
                                                                                    reader.readAsDataURL(videoBlob);
                                                                                    reader.onloadend = function () {
                                                                                      var base64data = reader.result;
                                                                                      // console.log(base64data);
                                                                                    };
                                                                                    var filename =
                                                                                      new Date().toISOString();
                                                                                    const data = new FormData();
                                                                                    var mp4file = new File(
                                                                                      [videoBlob],
                                                                                      filename + '.mp4',
                                                                                      {
                                                                                        type: 'video/mp4',
                                                                                        lastModified: new Date(),
                                                                                      },
                                                                                    );

                                                                                    data.append(
                                                                                      'apikey',
                                                                                      'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                                                    );
                                                                                    data.append(
                                                                                      'secret',
                                                                                      'R1eqD2twI3E4',
                                                                                    );
                                                                                    data.append(
                                                                                      'user_id',
                                                                                      this.state.user_id,
                                                                                    );
                                                                                    data.append(
                                                                                      'business_id',
                                                                                      this.state.business_id,
                                                                                    );
                                                                                    data.append(
                                                                                      'file',
                                                                                      videoBlob,
                                                                                      filename,
                                                                                    );
                                                                                    data.append('reference', 'text');
                                                                                    // data.append('type', 'video');

                                                                                    axios
                                                                                      .post(
                                                                                        API_CALL_ENDPOINT +
                                                                                        '/file/upload',
                                                                                        data,
                                                                                      )
                                                                                      .then((res) => {
                                                                                        // console.log(res);
                                                                                        // console.log(res.data.message);
                                                                                        // console.log(res.data?.result?.files);

                                                                                        if (
                                                                                          res.data.status == 'success'
                                                                                        ) {
                                                                                          var file_url = '';
                                                                                          var file_path = '';
                                                                                          var file_url2 = '';
                                                                                          var second_file_path = '';
                                                                                          var file_url3 = '';
                                                                                          var file_url4 = '';
                                                                                          var file_id = '';
                                                                                          for (var i in res.data.result
                                                                                            .files) {
                                                                                            console.log(
                                                                                              res.data.result.files[i]
                                                                                                .file_url,
                                                                                            );
                                                                                            file_url +=
                                                                                              res.data.result.files[i]
                                                                                                .file_url;
                                                                                            file_path +=
                                                                                              res.data.result.files[i]
                                                                                                .file_path;
                                                                                            file_url2 +=
                                                                                              res.data.result.files[i]
                                                                                                .second_file_url;
                                                                                            second_file_path +=
                                                                                              res.data.result.files[i]
                                                                                                .second_file_path;
                                                                                            file_url3 +=
                                                                                              res.data.result.files[i]
                                                                                                .third_file_url;
                                                                                            file_url4 +=
                                                                                              res.data.result.files[i]
                                                                                                .fourth_file_url;
                                                                                            file_id +=
                                                                                              res.data.result.files[i]
                                                                                                ._id;
                                                                                            var joined_videoId =
                                                                                              this.state.attchmnt_videoId_cmb.concat(
                                                                                                res.data.result.files[i]
                                                                                                  ._id,
                                                                                              );
                                                                                            this.setState({
                                                                                              attchmnt_videoId_cmb:
                                                                                                joined_videoId,
                                                                                            });
                                                                                          }
                                                                                          const atchId_recrd =
                                                                                            res.data.result.files[0]
                                                                                              ._id;
                                                                                          console.log(atchId_recrd);

                                                                                          setTimeout(() => {
                                                                                            console.log(
                                                                                              this.state
                                                                                                .atcharryDet_cmb,
                                                                                            );
                                                                                          }, 150);

                                                                                          $(
                                                                                            '.attachLoading_cmb',
                                                                                          ).hide();
                                                                                          $(
                                                                                            '#attachLoading_cmb_video',
                                                                                          ).hide();

                                                                                          const video_details = {
                                                                                            apikey: API_KEY,
                                                                                            secret: API_SECRET,
                                                                                            user_id: this.state.user_id,
                                                                                            business_id:
                                                                                              this.state.business_id,
                                                                                            attachment: atchId_recrd,
                                                                                            attachment_type: 'video',
                                                                                            unique_id:
                                                                                              this.state
                                                                                                .message_edit === false
                                                                                                ? Rnunique_id_cmb
                                                                                                : this.state
                                                                                                  .Rnunique_id_cmb
                                                                                                  .append
                                                                                                  ? this.state
                                                                                                    .Rnunique_id_cmb
                                                                                                  : Rnunique_id_cmb,
                                                                                            order:
                                                                                              '' +
                                                                                              this.state
                                                                                                .attachOrderIncrs_cmb +
                                                                                              '',
                                                                                          };

                                                                                          axios
                                                                                            .post(
                                                                                              API_CALL_ENDPOINT +
                                                                                              '/text/attachment/create',
                                                                                              video_details,
                                                                                            )
                                                                                            .then((res) => {
                                                                                              console.log(res);
                                                                                              console.log(
                                                                                                res.data.message,
                                                                                              );

                                                                                              if (
                                                                                                res.data.status ==
                                                                                                'success'
                                                                                              ) {
                                                                                                this.setState({
                                                                                                  messageAttachd_cmb: true,
                                                                                                });
                                                                                                this.setState({
                                                                                                  atcharryDet_cmb: [
                                                                                                    {
                                                                                                      file_path:
                                                                                                        file_path,
                                                                                                      second_file_path:
                                                                                                        second_file_path,
                                                                                                      video_id: file_id,
                                                                                                      video_url:
                                                                                                        file_url,
                                                                                                      video_url2:
                                                                                                        file_url2,
                                                                                                      video_url3:
                                                                                                        file_url3,
                                                                                                      video_url4:
                                                                                                        file_url4,
                                                                                                      attach_id:
                                                                                                        res.data.result
                                                                                                          ._id,
                                                                                                    },
                                                                                                    ...this.state
                                                                                                      .atcharryDet_cmb,
                                                                                                  ],
                                                                                                });
                                                                                                var OrderIncr =
                                                                                                  this.state
                                                                                                    .attachOrderIncrs_cmb +
                                                                                                  parseInt(1);
                                                                                                this.setState({
                                                                                                  attachOrderIncrs_cmb:
                                                                                                    OrderIncr,
                                                                                                });
                                                                                              }
                                                                                              if (res.data.error) {
                                                                                              }
                                                                                            });

                                                                                          console.log(file_url);
                                                                                        }
                                                                                      });
                                                                                  }}
                                                                                  setVideo={(blob) => {
                                                                                    let blobUrl =
                                                                                      URL.createObjectURL(blob);
                                                                                    console.log(blobUrl);
                                                                                    // this.setState({ captureVideoUrl: blobUrl })
                                                                                  }}
                                                                                />
                                                                                {/* </div> */}
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={this.videoLclDelte_cmb}>
                                                                          Delete
                                                                        </a>
                                                                        <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {/* END timeline item */}
                                                                  {/* timeline item */}
                                                                  <div style={{ display: 'none' }}>
                                                                    <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="attachmentbody_div d-table">
                                                                          <div className="d-table-row">
                                                                            <div className="d-table-cell w-70 align-top">
                                                                              <span className="attachrecord_icon bg_video crsr_pntr">
                                                                                <i className="fas fa-film" />
                                                                              </span>
                                                                            </div>
                                                                            <div className="d-table-cell align-middle">
                                                                              <div className="f_sz16">
                                                                                <span>
                                                                                  <i className="fas fa-spinner fa-spin f_sz24" />
                                                                                </span>
                                                                                <span
                                                                                  className="ml-2"
                                                                                  style={{
                                                                                    display: 'none',
                                                                                  }}>
                                                                                  0.10
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                          Save
                                                                        </a>
                                                                        <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                          Delete
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {/* END timeline item */}

                                                                  {/* timeline item */}
                                                                  <div style={{ display: 'none' }}>
                                                                    <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="form-group row">
                                                                          <label className="col-form-label pull-left pl-2 f_sz16">
                                                                            No. of Rewards
                                                                          </label>
                                                                          <div className="pull-left ml-3">
                                                                            <input
                                                                              type="text"
                                                                              className="form-control text-center txtbx_sm"
                                                                              defaultValue={10}
                                                                              disabled
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                        <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">
                                                                          Delete
                                                                        </a>
                                                                        <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {/* END timeline item */}
                                                                  {/* timeline item */}
                                                                  <div style={{ display: 'none' }}>
                                                                    <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="form-group row">
                                                                          <label className="col-form-label pull-left pl-2 f_sz16">
                                                                            No. of Rewards
                                                                          </label>
                                                                          <div className="pull-left ml-3">
                                                                            <input
                                                                              type="text"
                                                                              className="form-control text-center txtbx_sm"
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                          Save
                                                                        </a>
                                                                        <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                          Delete
                                                                        </a>
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {/* END timeline item */}
                                                                  <div id="attachLoading_cmb_video">
                                                                    <i
                                                                      className="fas fa-circle bg-gray"
                                                                      style={{ fontSize: 'x-small' }}
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className="attchLstShow_cmb"
                                                          style={{ display: 'none' }}
                                                          onClick={() => {
                                                            this.hide_emoji();
                                                          }}>
                                                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                                                            <div className="attachment_timelinediv">
                                                              {/* The time line */}

                                                              {/* The time line */}
                                                              <div
                                                                // onDragOver={this.dragOver_cmb}
                                                                className="timeline"
                                                                id="timelineprepend">
                                                                <div
                                                                  id="attachLoading_cmb"
                                                                  className="attachLoading_cmb"
                                                                  style={{ display: 'none' }}>
                                                                  <i
                                                                    className={
                                                                      this.state.lodingicon_cmb +
                                                                      ' attachtype_timelineicon'
                                                                    }
                                                                  />
                                                                  <div className="timeline-item">
                                                                    <div className="timeline-body">
                                                                      <div className="attachmentbody_div d-table">
                                                                        <span>
                                                                          <span className="d-inline-block">
                                                                            <span>
                                                                              <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                                            </span>
                                                                            <span className="postop_5up">
                                                                              This might take few mins, please hold on
                                                                              while we process your attachment
                                                                            </span>
                                                                          </span>
                                                                        </span>
                                                                      </div>
                                                                    </div>
                                                                    <div className="timeline-footer"></div>
                                                                  </div>
                                                                </div>
                                                                {this.state.atcharryDet_cmb.map((attachment, index) => {
                                                                  return attachment.notes_content1 ? (
                                                                    <>
                                                                      <div
                                                                        className={'editor_cmb_' + attachment.attach_id}
                                                                        style={{ display: 'none' }}>
                                                                        <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                        <div className="timeline-item ">
                                                                          {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                          <div
                                                                            className={
                                                                              'timeline-body attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }
                                                                            // onClick={() => {
                                                                            //   this.oneditnotecmb(attachment);
                                                                            // }}
                                                                            style={{ wordWrap: 'break-word' }}>
                                                                            <div className="attachmentbody_div">
                                                                              {/* <ReactQuill
                  // theme="bubble"

                  modules={{
                    toolbar: [
                      [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                      ],
                      [
                        {header: '1'},
                        {header: '2'},
                        {font: []},
                      ],
                      [
                        {list: 'ordered'},
                        {list: 'bullet'},
                        {indent: '-1'},
                        {indent: '+1'},
                      ],
                      ['link', 'video'],
                      ['clean'],
                    ],

                    clipboard: {
                      // toggle to add extra line breaks when pasting HTML:
                      matchVisual: false,
                    },
                  }}
                  formats={[
                    'header',
                    'font',
                    'size',
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'list',
                    'bullet',
                    'indent',
                    'link',
                    'video',
                  ]}
                  value={this.state.notesValue2_cmb}
                  onChange={this.notesLetter2_cmb}
                  maxLength="600"
                /> */}
                                                                              <CKEditor
                                                                                editor={ClassicEditor}
                                                                                data={this.state.notesValue2_cmb}
                                                                                id="mytext"
                                                                                config={editorConfiguration}
                                                                                onReady={(editor) => {
                                                                                  // You can store the "editor" and use when it is needed.
                                                                                  // console.log( 'Editor is ready to use!', editor );
                                                                                }}
                                                                                onChange={(event, editor) => {
                                                                                  const data = editor.getData();
                                                                                  // console.log( { event, editor, data } );
                                                                                  // if (data.length <= 1200) {
                                                                                  this.setState({
                                                                                    notesValue2_cmb: data,
                                                                                    chars_left_notes_cmb:
                                                                                      this.state.max_chars_notes_cmb -
                                                                                      data.length,
                                                                                  });
                                                                                  // }
                                                                                }}
                                                                                onBlur={(event, editor) => {
                                                                                  // console.log( 'Blur.', editor );
                                                                                }}
                                                                                onFocus={(event, editor) => {
                                                                                  // console.log( 'Focus.', editor );
                                                                                }}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          {/* {this.state.cmb_notesedit === true ? (
              <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                {this.state.savingprogress}
              </div>
            ) : null} */}

                                                                          {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                                                        
                                                                        Maximum 1200 characters
                                                                      </div> */}
                                                                          <div
                                                                            className={
                                                                              'timeline-footer attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }>
                                                                            {/* {this.state.cmb_notesedit === true ? (
                <a
                  className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                  onClick={() => {
                    this.updateNotes2_cmb();
                  }}>
                  Update
                </a>
              ) : null} */}
                                                                            <a
                                                                              className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                              onClick={() => {
                                                                                this.updateNotes2_cmb();
                                                                                this.expanded_attach(
                                                                                  attachment.attach_id,
                                                                                );
                                                                              }}>
                                                                              {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                                              Save
                                                                            </a>
                                                                            <a
                                                                              className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                              onClick={() =>
                                                                                this.notesAtchDelte_cmb_edit(
                                                                                  attachment.attach_id,
                                                                                )
                                                                              }>
                                                                              Delete
                                                                            </a>
                                                                            <a
                                                                              className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                              onClick={() => {
                                                                                this.expanded_attach(
                                                                                  attachment.attach_id,
                                                                                );
                                                                              }}>
                                                                              <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                            </a>
                                                                            {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                          </div>
                                                                          {/* </span> */}
                                                                          {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                        </div>
                                                                        <div className="timeline-item ">
                                                                          <div
                                                                            className={
                                                                              'timeline-body attachment_colapsed attachment_colapsed_' +
                                                                              attachment.attach_id
                                                                            }
                                                                            style={{ display: 'none' }}>
                                                                            <div className="attachmentbody_div">
                                                                              Notes Attached
                                                                              <a
                                                                                className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                                onClick={() => {
                                                                                  this.colapsed_attach(
                                                                                    attachment.attach_id,
                                                                                  );
                                                                                  this.oneditnotecmb(attachment);
                                                                                }}>
                                                                                <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                              </a>
                                                                            </div>
                                                                          </div>
                                                                          {/* </span> */}
                                                                        </div>
                                                                      </div>

                                                                      <div
                                                                        data-id={index}
                                                                        key={index}
                                                                        // draggable="true"
                                                                        // onDragEnd={this.dragEnd_cmb}
                                                                        // onDragStart={this.dragStart_cmb}
                                                                        className={
                                                                          'notecontent_cmb_show notecontent_cmb_' +
                                                                          attachment.attach_id
                                                                        }>
                                                                        <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                                        <div className="timeline-item ">
                                                                          {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                          <div
                                                                            className={
                                                                              'timeline-body attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }
                                                                            onClick={() => {
                                                                              this.oneditnotecmb(attachment);
                                                                            }}
                                                                            style={{ wordWrap: 'break-word' }}>
                                                                            <div className="attachmentbody_div">
                                                                              <Linkify
                                                                                componentDecorator={(
                                                                                  decoratedHref,
                                                                                  decoratedText,
                                                                                  key,
                                                                                ) => (
                                                                                  <a
                                                                                    target="blank"
                                                                                    href={decoratedHref}
                                                                                    key={key}>
                                                                                    {decoratedText}
                                                                                  </a>
                                                                                )}>
                                                                                <div
                                                                                  dangerouslySetInnerHTML={{
                                                                                    __html: attachment.notes_content,
                                                                                  }}
                                                                                />
                                                                                {/* {attachment.notes_content} */}
                                                                              </Linkify>
                                                                            </div>
                                                                          </div>

                                                                          <div
                                                                            className={
                                                                              'timeline-footer attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }>
                                                                            <a
                                                                              className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                              id={attachment.attach_id}
                                                                              onClick={this.notesAtchDelte_cmb}>
                                                                              Delete
                                                                            </a>
                                                                            <a
                                                                              className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                              onClick={() => {
                                                                                this.expanded_attach(
                                                                                  attachment.attach_id,
                                                                                );
                                                                              }}>
                                                                              <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                            </a>
                                                                            {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
            <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
          </a> */}
                                                                          </div>
                                                                          {/* </span> */}
                                                                          {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                        </div>
                                                                        <div className="timeline-item ">
                                                                          <div
                                                                            className={
                                                                              'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                              attachment.attach_id
                                                                            }
                                                                            style={{ display: 'none' }}>
                                                                            <div className="attachmentbody_div">
                                                                              Notes Attached
                                                                              <a
                                                                                className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                                onClick={() => {
                                                                                  this.colapsed_attach(
                                                                                    attachment.attach_id,
                                                                                  );
                                                                                  this.oneditnotecmb(attachment);
                                                                                }}>
                                                                                <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                              </a>
                                                                              {/* </span> */}
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </>
                                                                  ) : attachment.documents ? (
                                                                    attachment.documents.length > 0 ? (
                                                                      <div
                                                                        data-id={index}
                                                                        key={index}
                                                                      // draggable="true"
                                                                      // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                      // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                      >
                                                                        <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                                                        <div className="timeline-item ">
                                                                          {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                          <div
                                                                            className={
                                                                              'timeline-body attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }>
                                                                            <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                              <span className="font-weight-bold">
                                                                                Documents:
                                                                              </span>
                                                                              <br />

                                                                              <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                                {attachment.documents.map(
                                                                                  (documentList, index) => {
                                                                                    var fileType =
                                                                                      documentList.file_name.split('.');
                                                                                    return (
                                                                                      <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                        <a
                                                                                          onClick={() =>
                                                                                            this.document_read(
                                                                                              documentList,
                                                                                            )
                                                                                          }>
                                                                                          {documentList?.thumbnail_file_url ? (
                                                                                            <div className="attachdoc_thumb">
                                                                                              <img
                                                                                                src={
                                                                                                  documentList?.thumbnail_file_url
                                                                                                }
                                                                                                border={0}
                                                                                              />
                                                                                            </div>
                                                                                          ) : (
                                                                                            <div className="attachdoc_type text-center">
                                                                                              <i className="far fa-file-alt flightgrey1"></i>
                                                                                            </div>
                                                                                          )}

                                                                                          <div className="attachdoc_filenmesze py-1 px-2">
                                                                                            <table
                                                                                              width="100%"
                                                                                              cellPadding={0}
                                                                                              cellSpacing={0}>
                                                                                              <tbody>
                                                                                                <tr>
                                                                                                  <td>
                                                                                                    {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                    {fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'pdf' ? (
                                                                                                      <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'docx' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'doc' ? (
                                                                                                      <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'jpg' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'jpeg' ? (
                                                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'png' ? (
                                                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'csv' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'xls' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'xlsx' ? (
                                                                                                      <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'pptx' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'ppt' ? (
                                                                                                      <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                    ) : (
                                                                                                      <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                    )}

                                                                                                    <span className="f_sz13 mr-2">
                                                                                                      {/* {documentList.file_name} */}
                                                                                                      {documentList
                                                                                                        ?.file_name
                                                                                                        ?.length > 5
                                                                                                        ? documentList?.file_name.substring(
                                                                                                          0,
                                                                                                          5,
                                                                                                        ) +
                                                                                                        '...' +
                                                                                                        this.getExtensionFromUrl(
                                                                                                          documentList?.file_name,
                                                                                                        )
                                                                                                        : documentList?.file_name}
                                                                                                    </span>
                                                                                                  </td>
                                                                                                  <td align="right">
                                                                                                    <span className="f_sz12 flightgrey">
                                                                                                      {this.bytesToKb(
                                                                                                        documentList?.file_size,
                                                                                                      )}{' '}
                                                                                                      kB
                                                                                                    </span>
                                                                                                  </td>
                                                                                                </tr>
                                                                                              </tbody>
                                                                                            </table>
                                                                                          </div>
                                                                                        </a>
                                                                                      </div>
                                                                                    );
                                                                                  },
                                                                                )}
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div
                                                                            className={
                                                                              'timeline-footer attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }>
                                                                            <a
                                                                              className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                              id={attachment.attach_id}
                                                                              onClick={(e) =>
                                                                                this.documntAtchDelte_cmb(
                                                                                  e,
                                                                                  attachment.documents,
                                                                                )
                                                                              }>
                                                                              Delete
                                                                            </a>
                                                                            <a
                                                                              className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                              onClick={() => {
                                                                                this.expanded_attach(
                                                                                  attachment.attach_id,
                                                                                );
                                                                              }}>
                                                                              <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                            </a>

                                                                            {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
              </a> */}
                                                                          </div>
                                                                          {/* </span> */}
                                                                          {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                                        </div>
                                                                        <div className="timeline-item ">
                                                                          <div
                                                                            className={
                                                                              'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                              attachment.attach_id
                                                                            }
                                                                            style={{ display: 'none' }}>
                                                                            <div className="attachmentbody_div">
                                                                              Document Attached
                                                                              <a
                                                                                className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                                onClick={() => {
                                                                                  this.colapsed_attach(
                                                                                    attachment.attach_id,
                                                                                  );
                                                                                }}>
                                                                                <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                              </a>
                                                                            </div>
                                                                          </div>
                                                                          {/* </span> */}
                                                                        </div>
                                                                      </div>
                                                                    ) : undefined
                                                                  ) : attachment.images ? (
                                                                    attachment.images.length > 0 ? (
                                                                      <div
                                                                        data-id={index}
                                                                        key={index}
                                                                      // draggable="true"
                                                                      // onDragEnd={this.dragEnd_cmb}
                                                                      // onDragStart={this.dragStart_cmb}
                                                                      >
                                                                        <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                                                        <div className="timeline-item ">
                                                                          {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                          <div
                                                                            className={
                                                                              'timeline-body attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }>
                                                                            <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                              {/* <span className="font-weight-bold">Images:</span> */}
                                                                              <br />

                                                                              <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                                {attachment.images.map(
                                                                                  (documentList, index) => {
                                                                                    var fileType =
                                                                                      documentList.file_name.split('.');
                                                                                    return (
                                                                                      <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                                        <a
                                                                                          onClick={() =>
                                                                                            this.document_read(
                                                                                              documentList,
                                                                                            )
                                                                                          }>
                                                                                          {documentList?.thumbnail_file_url ? (
                                                                                            <div className="attachdoc_thumb">
                                                                                              <img
                                                                                                src={
                                                                                                  documentList?.thumbnail_file_url
                                                                                                }
                                                                                                border={0}
                                                                                              />
                                                                                            </div>
                                                                                          ) : (
                                                                                            <div className="attachdoc_type text-center">
                                                                                              <i className="far fa-file-alt flightgrey1"></i>
                                                                                            </div>
                                                                                          )}

                                                                                          <div className="attachdoc_filenmesze py-1 px-2">
                                                                                            <table
                                                                                              width="100%"
                                                                                              cellPadding={0}
                                                                                              cellSpacing={0}>
                                                                                              <tbody>
                                                                                                <tr>
                                                                                                  <td>
                                                                                                    {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                                    {fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'pdf' ? (
                                                                                                      <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'docx' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'doc' ? (
                                                                                                      <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'jpg' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'jpeg' ? (
                                                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'png' ? (
                                                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'csv' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'xls' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'xlsx' ? (
                                                                                                      <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                                    ) : fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                    ] === 'pptx' ||
                                                                                                      fileType[
                                                                                                      fileType.length -
                                                                                                      1
                                                                                                      ] === 'ppt' ? (
                                                                                                      <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                                    ) : (
                                                                                                      <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                                    )}

                                                                                                    <span className="f_sz13 mr-2">
                                                                                                      {/* {documentList.file_name} */}
                                                                                                      {documentList
                                                                                                        ?.file_name
                                                                                                        ?.length > 5
                                                                                                        ? documentList?.file_name.substring(
                                                                                                          0,
                                                                                                          5,
                                                                                                        ) +
                                                                                                        '...' +
                                                                                                        this.getExtensionFromUrl(
                                                                                                          documentList?.file_name,
                                                                                                        )
                                                                                                        : documentList?.file_name}
                                                                                                    </span>
                                                                                                  </td>
                                                                                                  <td align="right">
                                                                                                    <span className="f_sz12 flightgrey">
                                                                                                      {this.bytesToKb(
                                                                                                        documentList?.file_size,
                                                                                                      )}{' '}
                                                                                                      kB
                                                                                                    </span>
                                                                                                  </td>
                                                                                                </tr>
                                                                                              </tbody>
                                                                                            </table>
                                                                                          </div>
                                                                                        </a>
                                                                                        {/* <div className="attachdoc_delete">
                            <a
                              href="javascript:void(0)"
                              className="crsr_pntr">
                              <i
                                className="far fa-trash-alt f_sz15"
                                onClick={this.DocLclDlete_cmb}
                                id={documentList.file_id}
                                data-id={attachment.attach_id}
                              />
                            </a>
                          </div> */}
                                                                                      </div>
                                                                                    );
                                                                                  },
                                                                                )}
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <div
                                                                            className={
                                                                              'timeline-footer attachment_expanded attachment_expanded_' +
                                                                              attachment.attach_id
                                                                            }>
                                                                            <a
                                                                              className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                              id={attachment.attach_id}
                                                                              onClick={(e) =>
                                                                                this.documntAtchDelte_cmb(
                                                                                  e,
                                                                                  attachment.images,
                                                                                )
                                                                              }>
                                                                              Delete
                                                                            </a>
                                                                            <a
                                                                              className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                              onClick={() => {
                                                                                this.expanded_attach(
                                                                                  attachment.attach_id,
                                                                                );
                                                                              }}>
                                                                              <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                            </a>
                                                                            {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
              </a> */}
                                                                          </div>
                                                                          {/* </span> */}
                                                                          {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                        </div>
                                                                        <div className="timeline-item ">
                                                                          <div
                                                                            className={
                                                                              'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                              attachment.attach_id
                                                                            }
                                                                            style={{ display: 'none' }}>
                                                                            <div className="attachmentbody_div">
                                                                              Image Attached
                                                                              <a
                                                                                className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                                onClick={() => {
                                                                                  this.colapsed_attach(
                                                                                    attachment.attach_id,
                                                                                  );
                                                                                }}>
                                                                                <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                              </a>
                                                                            </div>
                                                                          </div>
                                                                          {/* </span> */}
                                                                        </div>
                                                                      </div>
                                                                    ) : undefined
                                                                  ) : attachment.audio_url ? (
                                                                    <div
                                                                      data-id={index}
                                                                      key={index}
                                                                    // draggable="true"
                                                                    // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                    // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                    >
                                                                      <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                      <div className="timeline-item ">
                                                                        {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                                        <div
                                                                          className={
                                                                            'timeline-body attachment_expanded attachment_expanded_' +
                                                                            attachment.audio_id
                                                                          }>
                                                                          <div className="attachmentbody_div d-table">
                                                                            <div className="d-table-row">
                                                                              <div className="d-table-cell align-middle">
                                                                                <span>
                                                                                  <span className="d-inline-block">
                                                                                    <span className="crsr_pntr">
                                                                                      <i
                                                                                        className={
                                                                                          'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                          attachment.audio_id
                                                                                        }
                                                                                        onClick={() => {
                                                                                          this.audioPly(attachment);
                                                                                        }}
                                                                                        id={attachment.audio_id}
                                                                                      />
                                                                                      <i
                                                                                        className={
                                                                                          'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                          attachment.audio_id
                                                                                        }
                                                                                        onClick={this.audioPaue}
                                                                                        id={attachment.audio_id}
                                                                                        style={{
                                                                                          display: 'none',
                                                                                        }}></i>
                                                                                      <span
                                                                                        className="ml-2 d-inline-block postop_5up"
                                                                                      // style={{
                                                                                      //   display: 'none',
                                                                                      // }}
                                                                                      ></span>
                                                                                      <audio
                                                                                        className={
                                                                                          'audioplayer123 audio_temp_' +
                                                                                          attachment.audio_id
                                                                                        }
                                                                                        style={{
                                                                                          width: '258px',
                                                                                          display: 'none',
                                                                                        }}
                                                                                        src={
                                                                                          this.state.play_audio_url
                                                                                            ? this.state.play_audio_url
                                                                                            : undefined
                                                                                        }
                                                                                        controls="controls"
                                                                                        controlsList="nodownload"
                                                                                        //hidden
                                                                                        id={
                                                                                          'audio_temp_' +
                                                                                          attachment.audio_id
                                                                                        }
                                                                                      />
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                        <div
                                                                          className={
                                                                            'timeline-footer attachment_expanded attachment_expanded_' +
                                                                            attachment.audio_id
                                                                          }>
                                                                          <a
                                                                            className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                            id={attachment.attach_id}
                                                                            onClick={this.audioAtchDelte_cmb}>
                                                                            Delete
                                                                          </a>
                                                                          <a
                                                                            className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                            onClick={() => {
                                                                              this.expanded_attach(attachment.audio_id);
                                                                            }}>
                                                                            <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                          {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
              <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
            </a> */}
                                                                        </div>
                                                                        {/* </span> */}
                                                                        {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
          style={{display: "none"}}
          onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                                                      </div>
                                                                      <div className="timeline-item ">
                                                                        <div
                                                                          className={
                                                                            'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                            attachment.audio_id
                                                                          }
                                                                          style={{ display: 'none' }}>
                                                                          <div className="attachmentbody_div">
                                                                            Audio Attached
                                                                            <a
                                                                              className={
                                                                                'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                              }
                                                                              onClick={() => {
                                                                                this.colapsed_attach(
                                                                                  attachment.audio_id,
                                                                                );
                                                                              }}>
                                                                              <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                            </a>
                                                                            {/* </span> */}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  ) : attachment.video_url ? (
                                                                    <div
                                                                      data-id={index}
                                                                      key={index}
                                                                    // draggable="true"
                                                                    // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                    // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                    >
                                                                      <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                                                      <div className="timeline-item">
                                                                        {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                        <div
                                                                          className={
                                                                            'timeline-body attachment_expanded attachment_expanded_' +
                                                                            attachment.attach_id
                                                                          }>
                                                                          <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                            <span className="font-weight-bold">
                                                                              Video:
                                                                            </span>
                                                                            <br />
                                                                            <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                              <a
                                                                                onClick={() =>
                                                                                  this.Video_play_url(attachment)
                                                                                }>
                                                                                {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
    <div className="attachdoc_type text-center">
      <i className="fas fa-video" />
    </div>
    <div className="attachdoc_name">
      Click here to
      play video
    </div>
  </div> */}
                                                                                <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                                                  <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                                                    {/* <img src={} border={0} /> */}
                                                                                    <i className="fas fa-video fa-3x" />
                                                                                  </div>
                                                                                  <div className="attachvideo_gif">
                                                                                    {/* <img src={} border={0} /> */}
                                                                                    Click here to play video
                                                                                  </div>
                                                                                </div>
                                                                                {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                                              </a>
                                                                            </div>
                                                                          </div>
                                                                          {/* <div className="attachmentbody_div d-table">
<div className="d-table-row">
<div className="d-table-cell align-middle">
  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
    <div className="videoWrapper">
      <video
        onPlay={() =>
          this.Video_play_url(
            attachment
          )
        }
        width="300"
        controls
        playsinline
      >
        
        <source
          src={
            this.state
              .video_play_link
          }
          type="video/mp4"
        />                                                                
      </video>
    </div>
  </div>
</div>
</div>
</div> */}
                                                                        </div>
                                                                        <div
                                                                          className={
                                                                            'timeline-footer attachment_expanded attachment_expanded_' +
                                                                            attachment.attach_id
                                                                          }>
                                                                          <a
                                                                            className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                            id={attachment.attach_id}
                                                                            onClick={this.videAtchDelte_cmb}>
                                                                            Delete
                                                                          </a>
                                                                          <a
                                                                            className={
                                                                              'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                            }
                                                                            onClick={() => {
                                                                              this.expanded_attach(
                                                                                attachment.attach_id,
                                                                              );
                                                                            }}>
                                                                            <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                          {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
              <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
            </a> */}
                                                                        </div>
                                                                        {/* </span> */}
                                                                        {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
          style={{display: "none"}}
          onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                                      </div>
                                                                      <div className="timeline-item ">
                                                                        <div
                                                                          className={
                                                                            'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                            attachment.attach_id
                                                                          }
                                                                          style={{ display: 'none' }}>
                                                                          <div className="attachmentbody_div">
                                                                            Video Attached
                                                                            <a
                                                                              className={
                                                                                'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                              }
                                                                              onClick={() => {
                                                                                this.colapsed_attach(
                                                                                  attachment.attach_id,
                                                                                );
                                                                              }}>
                                                                              <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                            </a>
                                                                            {/* </span> */}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  ) : null;
                                                                })}

                                                                <div>
                                                                  <i
                                                                    className="fas fa-circle bg-gray"
                                                                    style={{ fontSize: 'x-small' }}
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className="form-group mt-3 mb-4"
                                                          onClick={() => {
                                                            this.hide_emoji();
                                                          }}>
                                                          <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                                                            <div className="psqrcode_entertagname_drpdwn_div">
                                                              <span
                                                                // onClick={() => this.tags_list_click()}
                                                                className="allselectdropdwn qrcode_taglist">
                                                                <select
                                                                  className="selectpicker w-100 border-bottom f_sz16"
                                                                  onChange={(e) => {
                                                                    this.tagonChange_send(e);
                                                                  }}
                                                                  multiple
                                                                  data-live-search="true">
                                                                  {/* <option selected="selected">--Choose Tag--</option> */}
                                                                  {this.state.tagList.map((tag, index) => {
                                                                    return (
                                                                      <option key={index} value={tag._id}>
                                                                        {tag.tag_name}
                                                                      </option>
                                                                    );
                                                                  })}
                                                                </select>
                                                              </span>
                                                              <div className="col-12 px-0 text-right pt-2">
                                                                <span
                                                                  className="fmaroon f_sz13 psqrcode_addtagname crsr_pntr"
                                                                  onClick={() => this.psqrcode_addtagname()}>
                                                                  <i className="fas fa-plus f_sz13 mr-2" />
                                                                  Add New Tag
                                                                </span>
                                                              </div>
                                                            </div>
                                                            <div
                                                              className="psqrcode_entertagname_txtbx_div"
                                                              style={{ display: 'none' }}>
                                                              <div className="input-group">
                                                                <input
                                                                  type="text"
                                                                  className="form-control"
                                                                  placeholder="Enter the new tag name"
                                                                  value={this.state.qr_newtag}
                                                                  onChange={(e) => {
                                                                    this.setState({ qr_newtag: e.target.value });
                                                                  }}
                                                                />
                                                                <div className="input-group-append">
                                                                  <span className="input-group-text nobrdr_bg">
                                                                    <span
                                                                      className="psqrcode_closeaddtagname crsr_pntr"
                                                                      onClick={() => this.psqrcode_closeaddtagname()}>
                                                                      <i className="fas fa-times f_sz13" />
                                                                    </span>
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div
                                                          className="col-12 col-sm-12 col-md-12 col-lg-12 pt-3 pb-3 py-sm-2  generate_qr_btn"
                                                          onClick={() => {
                                                            this.hide_emoji();
                                                          }}>
                                                          <a
                                                            onClick={() => {
                                                              this.generate_qr();
                                                            }}
                                                            className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                                            Generate QR Code
                                                          </a>
                                                        </div>
                                                        <span
                                                          className="qr_codedisplay col-12 col-sm-12 col-md-12 col-lg-12 pt-3 pb-3 py-sm-2  brdrbtm_dashed"
                                                          style={{ display: 'none', left: '22px' }}
                                                          onClick={() => {
                                                            this.hide_emoji();
                                                          }}>
                                                          <div className="qrcode_img">
                                                            <QRCode
                                                              id="123456"
                                                              value={
                                                                APP_ENDPOINT +
                                                                '/qrcode_form?user=' +
                                                                this.state.user_id +
                                                                '&profile=' +
                                                                this.state.business_id +
                                                                '&qr_code=' +
                                                                Rnunique_id_cmb
                                                              }
                                                              size={200}
                                                              level={'L'}
                                                              includeMargin={false}
                                                            />
                                                          </div>
                                                          <div className="qrcode_btn pt-3">
                                                            <a
                                                              className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                              onClick={() => this.downloadQR()}>
                                                              Download QR Code
                                                            </a>
                                                          </div>
                                                        </span>
                                                        {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-right brdrbtm_dashed pb-2">
                                                      <a>
                                                        <i className="fas fa-trash-alt mt-2 mr-3 f_sz16 crsr_pntr fmaroon" />
                                                      </a>
                                                      <a>
                                                        <i className="fas fa-plus-circle mt-2 f_sz17 crsr_pntr fmaroon" />
                                                      </a>
                                                    </div> */}
                                                      </div>
                                                      {/*Element to be Looped*/}
                                                    </div>
                                                    <div
                                                      className="card-footer bg-transparent  pt-3 pb-5 py-sm-3"
                                                      onClick={() => {
                                                        this.hide_emoji();
                                                      }}>
                                                      <a
                                                        className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                                        onClick={() => {
                                                          this.state.message_edit === true
                                                            ? this.update_qrcode_details()
                                                            : this.save_qrcode_details();
                                                        }}>
                                                        Save
                                                      </a>
                                                      <a class="btn btn-black crsr_pntr m-2 btnpdng_sm">Cancel</a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id="custom-tabs-psgmail"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-psgmail-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="all_contentcntr_700">
                                            <div className="form-horizontal formbiglbl">
                                              <div className="card-body">
                                                <div className="gmail_notconnected_div">
                                                  <div className="form-group row mt-5 mb-4">
                                                    <h5 className="col-12 col-sm-12 text-center fmaroon">
                                                      Connect with Gmail
                                                    </h5>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <div className="text-center mt-3">
                                                        <a>
                                                          <span
                                                            className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm gmailconnect_clk"
                                                            onClick={this.gmailconnect_clk}>
                                                            <i
                                                              className="fab fa-google f_sz22 postop_2 mr-3"
                                                              onClick={this.gmailconnect_clk}
                                                            />
                                                            Connect
                                                          </span>
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="gmail_connected_div" style={{ display: 'none' }}>
                                                  <div className="form-group row mt-2 mb-4">
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <div className="text-center mt-3">
                                                        <div>
                                                          <span className="btn btn-green1 btn-lg crsr_pntr m-2 btnpdng_sm">
                                                            <i className="fab fa-google f_sz22 postop_2 mr-3" />
                                                            Connected
                                                          </span>
                                                        </div>
                                                        <div className="mb-2 fmaroon f_sz15">
                                                          alexanderpierce@gmail.com
                                                        </div>
                                                        <div className="mb-4">
                                                          <span className="font-weight-semibold">Verified:</span> March
                                                          18, 2020<span className="ml-2">9.15am</span>
                                                        </div>
                                                        <div>
                                                          <a>
                                                            <span className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                                              Reauthorize Connection
                                                            </span>
                                                          </a>
                                                        </div>
                                                        <div>
                                                          <a>
                                                            <span className="crsr_pntr flightgrey">Disconnect</span>
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade  "
                                      id="custom-tabs-meeting"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-meeting-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          {this.state.business_info_array?.business?.plan_id?.plan_name === 'Trial' ||
                                            this.state.business_info_array?.business?.plan_id?.plan_name === 'Free' ? (
                                            <div className="card-body">
                                              <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                                <div className="f_sz16 w-100 d-inline-block pb-2">
                                                  To utilize{' '}
                                                  <span className="fmaroon font-weight-semibold">Meeting</span>, please
                                                  upgrade.
                                                </div>
                                                {/* <a data-toggle="modal" data-target="#modal_upgrade" data-backdrop="static" className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                {/* <a onClick={() => this.show_trial_payment()} className="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm">Upgrade</a> */}
                                                {/* <TrialPaymentButton
                                                  class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                  name="Upgrade"
                                                /> */}
                                                <a
                                                  class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                                  onClick={() => this.upgradeWorkspace('/create-profile?bid=' + this.state.business_info_array?.business?._id)}
                                                >Upgrade</a>
                                              </div>
                                            </div>
                                          ) : (
                                            <>
                                              <small className="text-red d-inline-block mt-1 ml-2">
                                                <b>
                                                  Note: Create a Google meet Event and invite the participants via
                                                  Redtie text message.
                                                </b>
                                              </small>
                                              <div className="all_contentcntr_700">
                                                <div className="form-horizontal formbiglbl">
                                                  <div className="card-body">
                                                    <div
                                                      className="gmailmeet_notconnected_div"
                                                      style={{
                                                        display: !this.state.business_info_array?.business
                                                          ?.google_calendar?.auth
                                                          ? 'block'
                                                          : 'none',
                                                      }}>
                                                      <div className="form-group row mt-5 mb-4">
                                                        <h5 className="col-12 col-sm-12 text-center fmaroon">
                                                          Connect with Google
                                                        </h5>
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <div className="text-center mt-3">
                                                            <a onClick={this.handleclick}>
                                                              <span className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm gmailmeetconnect_clk">
                                                                <i className="fab fa-google f_sz22 postop_2 mr-3" />
                                                                Connect
                                                              </span>
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="gmailmeet_connected_div"
                                                      style={{
                                                        display: this.state.business_info_array?.business
                                                          ?.google_calendar?.auth
                                                          ? 'block'
                                                          : 'none',
                                                      }}>
                                                      <div className="form-group row mt-2 mb-4">
                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                          <div className="text-center mt-3">
                                                            <div>
                                                              <span className="btn btn-green1 btn-lg crsr_pntr m-2 btnpdng_sm">
                                                                <i className="fab fa-google f_sz22 postop_2 mr-3" />
                                                                Connected
                                                              </span>
                                                            </div>
                                                            <div className="mb-2 fmaroon f_sz15">
                                                              {
                                                                this.state.business_info_array?.business
                                                                  ?.google_calendar?.user_info?.email
                                                              }
                                                            </div>
                                                            <div className="mb-4">
                                                              <span className="font-weight-semibold">Verified:</span>{' '}
                                                              {moment(
                                                                this.state.business_info_array?.business
                                                                  ?.google_calendar?.created_date,
                                                              ).format('MMMM DD,YYYY hh:mma')}
                                                              {/* <span className="ml-2">
                                                                                      {moment(
                                                                                        this.state.business_info_array?.business?.google_calendar?.created_date,
                                                                                      ).format('hh:mma')}
                                                                                    </span> */}
                                                            </div>
                                                            <div>
                                                              <a>
                                                                <span
                                                                  onClick={this.handleclick}
                                                                  className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                                                  Reauthorize Connection
                                                                </span>
                                                              </a>
                                                            </div>
                                                            <div>
                                                              <a>
                                                                <span
                                                                  onClick={this.disconnectcalender}
                                                                  className="crsr_pntr flightgrey">
                                                                  Disconnect
                                                                </span>
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id="custom-tabs-zapier"
                                      role="tabpanel"
                                      aria-labelledby="custom-tabs-pstags-tab">
                                      <div className="all_contentflex_div">
                                        <div className="card w-100 bx_shadow_sm">
                                          <div className="tagcreate_div">
                                            <div className="card w-100 shadow-none">
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body">
                                                  <div className="form-group row mt-5 mb-4">
                                                    <h5 className="col-12 col-sm-12 text-center fmaroon">Zapier</h5>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                      <div className="text-center mt-3">
                                                        <a
                                                          href="https://zapier.com/apps/redtie/integrations"
                                                          target="_blank">
                                                          <span className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm tagcreate_clk">
                                                            Get Started
                                                          </span>
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* <div class="tab-pane fade" id="custom-tabs-psrewards" role="tabpanel" aria-labelledby="custom-tabs-psrewards-tab">
                  
                 Needs to be done after the inputs are ready.
                 
                   
                </div>*/}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="tab-pane fade nav_links_prof_tabs"
                              id="custom-tabs-packs"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-packs-tab">
                              {/*Packs*/}
                              <div className="all_contentflex_div">
                                <div className="card w-100 shadow-none">
                                  <div className="card-body p-0">
                                    <div className="choosepackdtls_div">
                                      <div className="booster_packages all_contentflex_div pt-4  pb-3 justify-content-center">
                                        {this.state.booster_pack_list.map((pack, index) => {
                                          return (
                                            pack?.pack_type === 'message' ?
                                              <>
                                                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                                  <div className="card bx_shadow_sm brdrtop_yellow">
                                                    <div className="card-header pack_cardheader border-bottom-0">
                                                      <h3 className="card-title fmaroon w-100 text-center">
                                                        {pack.pack_name}
                                                      </h3>
                                                    </div>
                                                    {/* /.card-header */}
                                                    <div className="card-body fgrey pt-0 pb-4 text-center">
                                                      <div className="all_contentcntr_300">
                                                        <table
                                                          className="text-center f_sz15"
                                                          width="100%"
                                                          cellSpacing={0}
                                                          cellPadding={5}>
                                                          <tbody>
                                                            <tr>
                                                              <td className="text-left">
                                                                {pack?.pack_type?.charAt(0).toUpperCase() +
                                                                  pack?.pack_type?.slice(1)}
                                                              </td>
                                                              <td className="text-right font-weight-bold">
                                                                {pack.data_count}
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td className="text-left">Price</td>
                                                              <td className="text-right font-weight-bold">{pack.price}</td>
                                                            </tr>
                                                            <tr>
                                                              <td className="text-left">Quantity</td>
                                                              <td className="text-right">
                                                                <div className="quantity_wdth">
                                                                  <span
                                                                    className="f_sz22 crsr_pntr"
                                                                    onClick={() =>
                                                                      this.state.packcart_list.some(
                                                                        (el) => el.master_pack_id === pack._id,
                                                                      )
                                                                        ? this.onupdatecart_add_cart(pack, pack._id)
                                                                        : this.onupdatecart_add(pack, pack._id)
                                                                    }>
                                                                    <i className="far fa-plus-square" />
                                                                  </span>
                                                                  <span className="mx-3 postop_3up">
                                                                    {this.getQuantity(pack, pack._id)}
                                                                  </span>
                                                                  <span
                                                                    className="f_sz22 crsr_pntr"
                                                                    onClick={() =>
                                                                      this.state.packcart_list.some(
                                                                        (el) => el.master_pack_id === pack._id,
                                                                      )
                                                                        ? this.onupdatecart_delete_cart(pack, pack._id)
                                                                        : this.onupdatecart_delete(pack, pack._id)
                                                                    }>
                                                                    <i className="far fa-minus-square" />
                                                                  </span>
                                                                </div>
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td className="text-left">
                                                                Total{' '}
                                                                {pack?.pack_type?.charAt(0).toUpperCase() +
                                                                  pack?.pack_type?.slice(1)}
                                                              </td>
                                                              <td className="text-right font-weight-bold fgreen4 f_sz20">
                                                                {parseInt(pack.data_count) *
                                                                  this.getQuantity(pack, pack._id)}
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                    {/* /.card-body */}
                                                    <div className="card-footer text-center bg-transparent border-top">
                                                      <div className="f_sz15 pb-2">Total</div>
                                                      <h1 className="font-weight-bold mb-1">
                                                        <sup className="f_sz22 mr-1">$</sup>

                                                        {parseInt(pack.dollar) * this.getQuantity(pack, pack._id)}
                                                      </h1>
                                                      {/* <div class="f_sz13 pb-2">per month</div> */}
                                                      <a
                                                        style={{
                                                          display: this.state.packcart_list.some(
                                                            (el) => el.master_pack_id === pack._id,
                                                          )
                                                            ? 'none'
                                                            : 'block',
                                                        }}
                                                        onClick={() => {
                                                          this.add_to_cart(pack, pack._id);
                                                        }}
                                                        className="btn btn-black crsr_pntr btn-sm1 mx-1 mt-2 mb-1 btnpdng_sm">
                                                        {this.state.packcart_list.some(
                                                          (el) => el.master_pack_id === pack._id,
                                                        )
                                                          ? 'Update cart'
                                                          : 'Add to Cart'}
                                                      </a>
                                                    </div>
                                                    {/* /.card-footer */}
                                                  </div>
                                                  {/* /.card */}
                                                </div>
                                              </> : ""
                                          );
                                        })}

                                        {/* /.col */}
                                        <div className="w-100 d-inline-block text-center mt-3">
                                          <a
                                            onClick={() => {
                                              if (this.state.packcart_list?.length !== 0) {
                                                this.proceed_checkout();
                                              }
                                              // this.state.packcart_list?.length !== 0 ? this.proceed_checkout() : null;
                                            }}
                                            className={
                                              this.state.packcart_list?.length !== 0
                                                ? 'btn btn-black crsr_pntr btn-sm1 mx-1 mt-2 mb-1 btnpdng_sm'
                                                : 'btn btn-black crsr_pntr btn-sm1 mx-1 mt-2 mb-1 btnpdng_sm isdisabled'
                                            }>
                                            Proceed to Checkout
                                          </a>
                                        </div>

                                        <div
                                          onClick={() => this.view_pack_history()}
                                          className="w-100 d-inline-block my-3 text-center fmaroon packshistory_tgl crsr_pntr">
                                          View History
                                        </div>
                                        <div className="packshistory_tgldiv w-100" style={{ display: 'none' }}>
                                          <div className="all_contentflex_div">
                                            <div className="card w-100 mt-2 mb-5">
                                              <div className="card-header">
                                                <h5 className="fmaroon f_sz15">History</h5>
                                              </div>
                                              <div className="card-body p-0">
                                                <div className="table-responsive">
                                                  <table
                                                    className="table table-hover tbl_valignmdle  border-bottom"
                                                    id="packshistory_tbl"
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    style={{ width: '100%' }}>
                                                    <thead>
                                                      <tr>
                                                        <th>Pack</th>
                                                        <th>Purchased on</th>
                                                        <th className="text-right">
                                                          <div className="count_wdth">Count</div>
                                                        </th>
                                                        <th className="text-right">
                                                          <div className="count_wdth">Total</div>
                                                        </th>
                                                        <th className="text-right">
                                                          <div className="count_wdth">Invoice</div>
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.pack_history_list?.map((list, index) => {
                                                        return this.state.pack_history_list ? (
                                                          <tr>
                                                            <td>{list.master_pack_id.pack_name}</td>
                                                            <td>{moment(list.updated_date).format('MM/DD/YYYY')}</td>
                                                            <td className="text-right">
                                                              <div className="count_wdth">{list.order_data_count}</div>
                                                            </td>
                                                            <td className="text-right">
                                                              <div className="count_wdth">${list.order_doller}</div>
                                                            </td>
                                                            <td className="text-right">
                                                              <div className="tbl_actionbtns">
                                                                <a
                                                                  onClick={() => {
                                                                    this.InvoiceViewClk(list.invoice);
                                                                  }}>
                                                                  <i className="far fa-eye" title="View PDF" />
                                                                </a>
                                                                {/*When View is clicked, Invoice PDF should open*/}
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        ) : (
                                                          <tr>
                                                            <td>No History Found</td>
                                                          </tr>
                                                        );
                                                      })}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="creditcarddtls_div" style={{ display: 'none' }}>
                                      <div className="all_contentflex_div">
                                        <div className="all_content_div mt-3">
                                          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-12">
                                            <div class="card w-100 mb-0 bx_shadow_sm">
                                              <div class="card-header">
                                                <div class="card-title fmaroon f_sz16 font-weight-semibold">
                                                  Chosen Packs
                                                </div>
                                              </div>
                                              <div className="card-header px-1">
                                                <div className="card-title text-center w-100">
                                                  <div className="shoppingcart_headlist scrollbar_style">
                                                    {this.state.packcart_list.map((list, index) => {
                                                      return (
                                                        <>
                                                          <div className="media">
                                                            <div className="d-flex flex-row flex-wrap text-center">
                                                              <div className="w-100 d-inline-block">
                                                                <span
                                                                  className="usercircle_sm1"
                                                                  style={{ backgroundColor: '#c6c819' }}>
                                                                  {list?.pack_type?.charAt(0).toUpperCase()}
                                                                </span>
                                                              </div>
                                                              <div className="w-100 d-inline-block">
                                                                <a onClick={() => this.delete_cart_pack(list)}>
                                                                  <i className="fas fa-trash-alt mt-2 f_sz13 crsr_pntr fmaroon" />
                                                                </a>
                                                              </div>
                                                            </div>
                                                            <div className="media-body">
                                                              <table width="100%" cellPadding={0} cellSpacing={0}>
                                                                <tbody>
                                                                  <tr>
                                                                    <td
                                                                      valign="top"
                                                                      className="text-center"
                                                                      width={100}>
                                                                      <div className="f_sz13 font-weight-bold">
                                                                        {list?.pack_type?.charAt(0).toUpperCase() +
                                                                          list?.pack_type?.slice(1)}
                                                                      </div>
                                                                      <span className="mt-2 d-inline-block">
                                                                        {list.pack_data_count}
                                                                      </span>
                                                                    </td>
                                                                    <td valign="top" className="text-center" width={80}>
                                                                      <div className="f_sz13 font-weight-bold">
                                                                        Price
                                                                      </div>
                                                                      <span className="mt-2 d-inline-block">
                                                                        ${list.pack_dollar}
                                                                      </span>
                                                                    </td>
                                                                    <td valign="top" className="text-center" width={80}>
                                                                      <div className="f_sz13 font-weight-bold">Qty</div>
                                                                      <div>
                                                                        <span
                                                                          onClick={() =>
                                                                            this.onupdatecart_add_cart(
                                                                              list,
                                                                              list.master_pack_id,
                                                                            )
                                                                          }
                                                                          className="f_sz22 crsr_pntr">
                                                                          <i className="far fa-plus-square" />
                                                                        </span>
                                                                        <span className="mx-2 postop_3up">
                                                                          {this.getQuantity_cart(
                                                                            list,
                                                                            list.master_pack_id,
                                                                          )}
                                                                        </span>
                                                                        <span
                                                                          className="f_sz22 crsr_pntr"
                                                                          onClick={() =>
                                                                            this.onupdatecart_delete_cart(
                                                                              list,
                                                                              list.master_pack_id,
                                                                            )
                                                                          }>
                                                                          <i className="far fa-minus-square" />
                                                                        </span>
                                                                      </div>
                                                                    </td>
                                                                  </tr>
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                          <div className="dropdown-divider" />
                                                        </>
                                                      );
                                                    })}

                                                    <div className="media">
                                                      <div className="media-body">
                                                        <table width="100%" cellPadding={0} cellSpacing={0}>
                                                          <tbody>
                                                            {/* <tr>
                                                              <td valign="top" className="text-center">
                                                                <div className="f_sz13 font-weight-bold">
                                                                  Total Contacts
                                                                </div>
                                                                <span className="mt-2 mb-2 d-inline-block fgreen4 font-weight-bold f_sz16">
                                                                  200
                                                                </span>
                                                              </td>
                                                              <td>&nbsp;</td>
                                                              <td valign="top" className="text-center">
                                                                <div className="f_sz13 font-weight-bold">
                                                                  Total Messages
                                                                </div>
                                                                <span className="mt-2 mb-2 d-inline-block fgreen4 font-weight-bold f_sz16">
                                                                  4000
                                                                </span>
                                                              </td>
                                                            </tr> */}
                                                            <tr>
                                                              {/* <td valign="top" className="text-center">
                                                                <div className="f_sz13 font-weight-bold">
                                                                  Total Messages
                                                                </div>
                                                                <span className="mt-2 d-inline-block fgreen4 font-weight-bold f_sz16">
                                                                  {this.state.order_data_count}
                                                                </span>
                                                              </td>  <td valign="top" className="text-center">
                                                                <div className="f_sz13 font-weight-bold">Contacts</div>
                                                                <span className="mt-2 d-inline-block fgreen4 font-weight-bold f_sz16">
                                                                  $6
                                                                </span>
                                                              </td>  <td valign="top" className="text-center">
                                                                <div className="f_sz13 font-weight-bold">
                                                                  Message cost
                                                                </div>
                                                                <span className="mt-2 d-inline-block fgreen4 font-weight-bold f_sz16">
                                                                  ${this.state.order_doller}
                                                                </span>
                                                              </td> */}
                                                              <td valign="top" className="text-center">
                                                                <div className="f_sz13 font-weight-bold">
                                                                  Order Total
                                                                </div>
                                                                <span className="mt-2 d-inline-block fgreen4 font-weight-bold f_sz16">
                                                                  ${this.state.order_doller}
                                                                </span>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="mt-3 all_link text-right">
                                                    <a className="planback_clk crsr_pntr">
                                                      <span className="f_sz15 fmaroon">
                                                        <i className="fas fa-plus-circle mr-2" />
                                                        Add More
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div className="card-footer brdrradius_btm text-center bg-transparent mb-2">
                                                    <button
                                                      onClick={(e) => this.onPayexistCard(e)}
                                                      disabled={this.state.isLoading}
                                                      className="btn btn-lg btnpdng_md btn-black">
                                                      {this.state.isLoading ? 'Processing...' : 'Pay Now'}
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          {/* /.card-header */}
                                          {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-5">
                                            <div className="card w-100 mb-0 bx_shadow_sm">
                                              <div className="card-header">
                                                <div className="card-title fmaroon f_sz16 font-weight-semibold">
                                                  Payment
                                                </div>
                                              </div>
                                              <div className="form-horizontal formbiglbl">
                                                <div className="card-body">
                                                  <div className={this.state.cartcls}>{this.state.cartmsg}</div>
                                                  <div id="choosecrd">
                                                    <div className="form-group row mb-4">
                                                     
                                                      <h4 className="cardchosen_ortxt">
                                                        <span>Choose Card</span>
                                                      </h4>
                                                      <div className="col-12 col-sm-12 col-md-12">
                                                        <div className="select_style">
                                                          <select
                                                            className="form-control"
                                                            onChange={(e) => this.onChangecard_id(e)}>
                                                            <option>Select</option>
                                                            {this.state.cardList.map((cards) => {
                                                              var month = new Date().getMonth() + 1;
                                                              var year = new Date().getFullYear();
                                                              var New_date = new Date();
                                                              
                                                              return New_date.getTime() >
                                                                new Date(
                                                                  cards.exp_year,
                                                                  cards.exp_month - 1,
                                                                ).getTime() ? undefined : (
                                                                <option key={cards.id} value={cards.id}>
                                                                  xxxx-xxxx-xxxx-
                                                                  {cards.card_number} - {cards.brand}
                                                                </option>
                                                              );
                                                            })}
                                                          </select>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <h4 className="cardchosen_ortxt">
                                                      <span>New Card Details</span>
                                                    </h4>
                                                  </div>

                                                  <div
                                                    className="f_sz12 fred mt-1 text-left text-md-left pr-2"
                                                    style={{display: this.state.existcard_id ? 'block' : 'none'}}>
                                                    *Note - Please Unselect Card To Enable New Card Details
                                                  </div>
                                                  <div className="form-group row mb-4">
                                                    <label className="col-12 col-sm-12 col-md-12 col-form-label">
                                                      Name On Card
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-12">
                                                      <input
                                                        disabled={this.state.existcard_id ? true : false}
                                                        style={{
                                                          backgroundColor: this.state.existcard_id
                                                            ? '#a9a9a9a9'
                                                            : undefined,
                                                        }}
                                                        value={this.state.card_name}
                                                        onChange={(e) => this.onChangecardname(e)}
                                                        type="text"
                                                        className="form-control"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mb-4">
                                                    <label className="col-12 col-sm-12 col-md-12 col-form-label">
                                                      Card Number:
                                                    </label>
                                                    <div className="col-12 col-sm-12 col-md-12">
                                                      <input
                                                        disabled={this.state.existcard_id ? true : false}
                                                        style={{
                                                          backgroundColor: this.state.existcard_id
                                                            ? '#a9a9a9a9'
                                                            : undefined,
                                                        }}
                                                        id="card-no"
                                                        type="text"
                                                        value={this.state.card_number}
                                                        onChange={(e) => this.onChangecardnumber(e)}
                                                        className="form-control"
                                                        placeholder="XXXX-XXXX-XXXX-XX"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="form-group row mb-4">
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-4">
                                                      <label className="col-form-label">Expiration Date:</label>
                                                      <div>
                                                        <input
                                                          disabled={this.state.existcard_id ? true : false}
                                                          style={{
                                                            backgroundColor: this.state.existcard_id
                                                              ? '#a9a9a9a9'
                                                              : undefined,
                                                          }}
                                                          type="text"
                                                          value={this.state.exp_date}
                                                          maxLength="7"
                                                          onChange={(e) => this.onChangeexpdate(e)}
                                                          className="form-control"
                                                          placeholder="MM/YYYY"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                                                      <label className="col-form-label">CVV:</label>
                                                      <div>
                                                        <input
                                                          disabled={this.state.existcard_id ? true : false}
                                                          style={{
                                                            backgroundColor: this.state.existcard_id
                                                              ? '#a9a9a9a9'
                                                              : undefined,
                                                          }}
                                                          type="text"
                                                          value={this.state.cvc}
                                                          onChange={(e) => this.onChangecvc(e)}
                                                          maxLength="3"
                                                          className="form-control"
                                                          placeholder="XXX"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                               <div className="card-footer brdrradius_btm text-center bg-transparent mb-2">
                                                  <button
                                                    onClick={(e) =>
                                                      this.state.existcard_id
                                                        ? this.onPayexistCard(e)
                                                        : this.paymentonSubmit(e)
                                                    }
                                                    disabled={this.state.isLoading}
                                                    className="btn btn-lg btnpdng_md btn-black">
                                                    {this.state.isLoading ? 'Processing...' : 'Pay Now'}
                                                  </button>
                                                </div>
                                               </div>
                                            </div>
                                          </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              // style={{'display':this.state?.business_info_array?.busines_evaluation_details?.status == 'approved'?'block':'none'}}
                              className="tab-pane fade nav_links_prof_tabs"
                              id="custom-tabs-workspace_id"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-workspace_id-tab">
                              <div className="all_contentflex_div">
                                <div className="card w-100 bx_shadow_sm">
                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                    <div className="f_sz16 w-100 d-inline-block pb-2">
                                      Workspace Id :{' '}
                                      <span className="fmaroon font-weight-semibold">
                                        {!this.state.business_info_array?.busines_evaluation_details ||
                                          this.state.business_info_array?.busines_evaluation_details?.status !=
                                          'approved' ||
                                          this.state.business_info_array?.busines_evaluation_details?.otp_status !=
                                          'verified'
                                          ? '-'
                                          : this.state.business_id}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade "
                              id="custom-tabs-templates"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-templates-tab">
                              <div className="all_contentflex_div">
                                <div className="card w-100 bx_shadow_sm">
                                  {this.state.business_info_array?.business?.plan_id?.plan_name === 'Trial' ||
                                    this.state.business_info_array?.business?.plan_id?.plan_name === 'Free' ? (
                                    <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-3 pb-2 mt-5 mb-5">
                                      <div className="f_sz16 w-100 d-inline-block pb-2">
                                        To utilize <span className="fmaroon font-weight-semibold">Templates</span>,
                                        please upgrade.
                                      </div>

                                      <a
                                        class="btn btn-black crsr_pntr btn-sm1 m-2 btnpdng_sm"
                                        onClick={() =>
                                          this.upgradeWorkspace(
                                            '/create-profile?bid=' + this.state.business_info_array?.business?._id,
                                          )
                                        }>
                                        Upgrade
                                      </a>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="templatecreate_div">
                                        <div className="card w-100 shadow-none">
                                          <div className="form-horizontal formbiglbl">
                                            <div className="card-body">
                                              <div className="form-group row mt-5 mb-5">
                                                <h5 className="col-12 col-sm-12 text-center fmaroon">Templates</h5>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                  <div className="text-center mt-3">
                                                    <a>
                                                      <span
                                                        onClick={() => this.templatecreate_clk()}
                                                        className="btn btn-black btn-lg crsr_pntr m-2 btnpdng_sm templatecreate_clk">
                                                        Create Template
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="templatelist_div" style={{ display: 'none' }}>
                                        <div className="card w-100 shadow-none">
                                          <div className="card-header d-flex flex-row flex-wrap">
                                            <div className="col-6 col-sm-6 col-md-6 pl-0">
                                              <h5 className="fmaroon pt-2">Templates</h5>
                                            </div>
                                            <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                              <a
                                                onClick={() => this.templatecreate_clk()}
                                                className="btn btn-black crsr_pntr btn-sm mt-1 templatecreate_clk">
                                                Add New
                                              </a>
                                            </div>
                                          </div>
                                          <div className="card-body p-0">
                                            <div className="table-responsive">
                                              <table
                                                className="table table-hover tbl_valignmdle tbl_intphrases border-bottom"
                                                id="templates_tbl"
                                                cellPadding={0}
                                                cellSpacing={0}
                                                style={{ width: '100%' }}>
                                                <thead>
                                                  <tr>
                                                    <th>Template Name</th>
                                                    <th>Text Message</th>
                                                    <th className="text-center">Action</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {this.state.template_list_data?.map((template, index) => {
                                                    return (
                                                      <tr>
                                                        <td>{template?.template_name}</td>
                                                        <td>{template?.text_message}</td>
                                                        <td align="center">
                                                          <div className="tbl_actionbtns">
                                                            <a
                                                              className="phrasecreate_clk crsr_pntr"
                                                              onClick={() => this.on_temp_MessageEdit(template)}>
                                                              <i className="fas fa-pen" title="Edit" />
                                                            </a>
                                                            <a
                                                              href="#"
                                                              onClick={() => this.onTemplateDelete(template?._id)}>
                                                              <i className="far fa-trash-alt" title="Delete" />
                                                            </a>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    );
                                                  })}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="addtemplate_div" style={{ display: 'none' }}>
                                        <div className="card w-100 shadow-none">
                                          <div
                                            className="card-header d-flex flex-row flex-wrap pb-0 pt-3"
                                            onClick={() => this.hide_emoji()}>
                                            <h5>
                                              <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                                Add Template
                                              </span>
                                              <span
                                                className="addinttemplate_close mr-2 mt-1"
                                                onClick={() => this.templates_listclick()}>
                                                <i className="fas fa-times" />
                                              </span>
                                            </h5>
                                          </div>
                                          <div className="form-horizontal formbiglbl">
                                            <div className="card-body px-0">
                                              {/*Element to be Looped*/}
                                              <div className={this.state.QRGrtcls}>{this.state.QRGrtMsg}</div>
                                              <div>
                                                <div className="form-group mt-3 mb-4" onClick={() => this.hide_emoji()}>
                                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      onChange={(e) => {
                                                        this.setState({ templ_name: e.target.value });
                                                      }}
                                                      value={this.state.templ_name}
                                                      maxLength="50"
                                                      placeholder="Enter the Template Name"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="form-group mt-3 mb-4">
                                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                    <textarea
                                                      className="form-control textarea_hgt125 txtarea_resizenone"
                                                      placeholder="Enter Text Message"
                                                      maxLength="300"
                                                      onClick={() => this.hide_emoji()}
                                                      onChange={(e) => {
                                                        this.setState({
                                                          templ_msg: e.target.value,
                                                          chars_left_templ_msg:
                                                            this.state.max_chars_templ_msg - e.target.value.length,
                                                        });
                                                      }}
                                                      value={this.state.templ_msg}
                                                    />
                                                  </div>
                                                  <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                                    <div
                                                      className="col-4 col-sm-4 col-md-4 pl-0 template_message_text_show emoji_show_all"
                                                      onClick={() => {
                                                        this.render_emoji('template_message_text');
                                                      }}>
                                                      <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" />
                                                    </div>
                                                    <div
                                                      className="col-4 col-sm-4 col-md-4 pl-0 template_message_text_close emoji_close_all"
                                                      style={{ display: 'none' }}
                                                      onClick={() => {
                                                        this.render_emoji('template_message_text');
                                                      }}>
                                                      <i
                                                        className={
                                                          'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'
                                                        }
                                                      />
                                                    </div>
                                                    <div className="col-8 col-sm-8 col-md-8 pr-0">
                                                      <div className="f_sz12 fred mt-1 text-left text-md-right">
                                                        {this.state.chars_left_templ_msg} characters remaining
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                                    <span
                                                      className="flex-row flex-wrap emoji_position emoji_disable"
                                                      style={{
                                                        display: 'none',
                                                        position: 'inherit',
                                                        width: 'inherit',
                                                        zIndex: '10',
                                                      }}
                                                      id="template_message_text"></span>
                                                  </div>
                                                </div>
                                                <div className="form-group mb-4" onClick={() => this.hide_emoji()}>
                                                  <div className="sendmessage_btnsdiv text-right">
                                                    {/*<span class="sendmessage_btnsspan"><a target="_blank" class="btn btn-lg btn-black crsr_pntr btnpdng_sm sendmsgattach_clk"><i class="fas fa-paperclip"></i></a></span>*/}
                                                    <div className="dropdown attachment_drpdwn d-inline-block">
                                                      <span data-toggle="dropdown" className="sendmessage_btnsspan">
                                                        <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                          <i className="fas fa-paperclip" />
                                                        </span>
                                                      </span>
                                                      <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                                        <div className="dropdown-item">
                                                          <div className="overallattachment_div">
                                                            <div
                                                              className="overallattach_item sendmsgtempattach_clk"
                                                              onClick={
                                                                this.state.savingprogress === '...'
                                                                  ? null
                                                                  : this.saveNotes2_cmb
                                                              }>
                                                              <div className="overallattach_icon bg_notes bx_shadow_sm">
                                                                <i className="far fa-sticky-note" />
                                                              </div>
                                                              <div className="fgrey">Notes</div>
                                                            </div>
                                                            <div className="overallattach_item sendmsgtempattach_clk">
                                                              <label for="file-input">
                                                                <div
                                                                  className="overallattach_icon bg_documents bx_shadow_sm"
                                                                  id="fdupld">
                                                                  <i className="far fa-file-alt" />
                                                                  <input
                                                                    id="file-input"
                                                                    type="file"
                                                                    name="DcfilNm"
                                                                    onChange={this.fileGetDetails_cmb}
                                                                  // multiple
                                                                  />
                                                                </div>
                                                              </label>
                                                              <div className="fgrey">Documents</div>
                                                            </div>
                                                            <div className="overallattach_item">
                                                              <label htmlFor="file-input3">
                                                                <div
                                                                  className="overallattach_icon bg_gallery bx_shadow_sm"
                                                                  id="fdupld_2">
                                                                  <i
                                                                    className="far fa-image"
                                                                    data-place="bottom"
                                                                    data-tip="Images"
                                                                  />
                                                                  <input
                                                                    id="file-input3"
                                                                    type="file"
                                                                    name="DcfilNm"
                                                                    accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                                                    onChange={(event) =>
                                                                      this.fileGetDetails_cmb_images(event)
                                                                    }
                                                                  // multiple
                                                                  />
                                                                </div>
                                                                {/* <ReactTooltip /> */}
                                                              </label>
                                                              <div className="fgrey">Gallery</div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="d-inline-block sendmsgtempattach_clk"
                                                      onClick={this.sendmsgattach_clkAudio2_cmb}>
                                                      <span className="sendmessage_btnsspan">
                                                        <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                          <i className="fas fa-microphone-alt" />
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div
                                                      className="d-inline-block sendmsgtempattach_clk"
                                                      onClick={this.sendmsgattach_clkVideo2_cmb}>
                                                      <span className="sendmessage_btnsspan">
                                                        <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                                          <i className="fas fa-video" />
                                                        </span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb"
                                                style={{ display: 'none' }}
                                                onClick={() => this.hide_emoji()}>
                                                <div className="row position-relative">
                                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                    <div className="attachment_timelinediv">
                                                      {/* The time line */}
                                                      <div className="timeline">
                                                        {/* timeline item */}
                                                        <div
                                                          style={{ display: 'none' }}
                                                          className="sendmsgattach_clkAudio2_cmb">
                                                          <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                          <div className="timeline-item">
                                                            <div className="timeline-body">
                                                              <div className="attachmentbody_div d-table">
                                                                <div className="d-table-row">
                                                                  <div className="d-table-cell align-middle">
                                                                    <span className="ml-2">
                                                                      <span className="crsr_pntr">
                                                                        <i
                                                                          className="fas fa-record-vinyl fa-2x fbred"
                                                                          onClick={this.audio_start_cmb}
                                                                        />
                                                                        <span
                                                                          className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                          onClick={this.audio_start_cmb}>
                                                                          Start Recording
                                                                        </span>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="timeline-footer">
                                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                              <a
                                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                onClick={this.audioLclDelte_cmb}>
                                                                Delete
                                                              </a>
                                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        {/* timeline item */}
                                                        <div
                                                          style={{ display: 'none' }}
                                                          className="audioRecordLoading_cmb">
                                                          <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                          <div className="timeline-item">
                                                            <div className="timeline-body">
                                                              <div className="attachmentbody_div d-table">
                                                                <div className="d-table-row">
                                                                  <div className="d-table-cell align-middle">
                                                                    <span>
                                                                      <span className="d-inline-block">
                                                                        <span className="crsr_pntr">
                                                                          <i
                                                                            className="far fa-stop-circle f_sz30 fbred"
                                                                            onClick={this.audio_stop_cmb}></i>
                                                                          <span
                                                                            className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                            onClick={this.audio_stop_cmb}>
                                                                            Stop Recording
                                                                          </span>
                                                                        </span>
                                                                        <span className="f_sz16">
                                                                          <span>
                                                                            <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                          </span>
                                                                        </span>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="timeline-footer">
                                                              {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                Delete
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {/* END timeline item */}
                                                        {/* timeline item */}
                                                        <div
                                                          style={{ display: 'none' }}
                                                          className="sendmsgattach_clkNotes2_cmb">
                                                          <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                                          <div className="timeline-item">
                                                            <div className="timeline-body">
                                                              <textarea
                                                                className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                                                placeholder="Enter the notes"
                                                                value={this.state.notesValue2_cmb}
                                                                onChange={this.notesLetter2_cmb}
                                                                id="notestypearea"
                                                              />
                                                            </div>
                                                            <div className="timeline-footer">
                                                              <a
                                                                className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                onClick={this.saveNotes2_cmb}>
                                                                Save
                                                              </a>
                                                              <a
                                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                onClick={this.notesLclDelte_cmb}>
                                                                Delete
                                                              </a>
                                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {/* END timeline item */}
                                                        {/* timeline item */}
                                                        <div
                                                          style={{ display: 'none' }}
                                                          className="sendmsgattach_clkVideo2_cmb">
                                                          <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                          <div className="timeline-item">
                                                            <div className="timeline-body">
                                                              <div className="attachmentbody_div d-table">
                                                                <div className="d-table-row">
                                                                  <div className="d-table-cell align-middle">
                                                                    <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                                      <VideoRecorder
                                                                        replayVideoAutoplayAndLoopOff={true}
                                                                        // showReplayControls={true}
                                                                        // mimeType="video/mp4"
                                                                        // constraints={{audio: true}}
                                                                        timeLimit={120000}
                                                                        onRecordingComplete={(
                                                                          videoBlob,
                                                                          thumbnailBlob,
                                                                          videoUrl,
                                                                        ) => {
                                                                          $('.sendmsgattach_clkVideo2_cmb').hide();
                                                                          $('.sendmsg_attachmentdiv2_cmb').hide();

                                                                          $('.attachLoading_cmb').show();
                                                                          $('.attchLstShow_cmb').show();
                                                                          this.setState({
                                                                            lodingicon_cmb: 'fas fa-film bg_video',
                                                                          });

                                                                          // Do something with the video...
                                                                          console.log(
                                                                            'videoBloburl',
                                                                            window.URL.createObjectURL(videoBlob),
                                                                          );
                                                                          console.log('videoBlob', videoBlob);
                                                                          console.log('thumbnailBlob', thumbnailBlob);
                                                                          console.log('videoUrl', videoUrl);
                                                                          var reader = new FileReader();
                                                                          reader.readAsDataURL(videoBlob);
                                                                          reader.onloadend = function () {
                                                                            var base64data = reader.result;
                                                                            // console.log(base64data);
                                                                          };
                                                                          var filename = new Date().toISOString();
                                                                          const data = new FormData();
                                                                          var mp4file = new File(
                                                                            [videoBlob],
                                                                            filename + '.mp4',
                                                                            {
                                                                              type: 'video/mp4',
                                                                              lastModified: new Date(),
                                                                            },
                                                                          );

                                                                          data.append(
                                                                            'apikey',
                                                                            'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                                          );
                                                                          data.append('secret', 'R1eqD2twI3E4');
                                                                          data.append('user_id', this.state.user_id);
                                                                          data.append(
                                                                            'business_id',
                                                                            this.state.business_id,
                                                                          );
                                                                          data.append('file', videoBlob, filename);
                                                                          data.append('reference', 'text');
                                                                          // data.append('type', 'video');

                                                                          axios
                                                                            .post(
                                                                              API_CALL_ENDPOINT + '/file/upload',
                                                                              data,
                                                                            )
                                                                            .then((res) => {
                                                                              // console.log(res);
                                                                              // console.log(res.data.message);
                                                                              // console.log(res.data?.result?.files);

                                                                              if (res.data.status == 'success') {
                                                                                var file_url = '';
                                                                                var file_path = '';
                                                                                var file_url2 = '';
                                                                                var second_file_path = '';
                                                                                var file_url3 = '';
                                                                                var file_url4 = '';
                                                                                var file_id = '';
                                                                                for (var i in res.data.result.files) {
                                                                                  console.log(
                                                                                    res.data.result.files[i].file_url,
                                                                                  );
                                                                                  file_url +=
                                                                                    res.data.result.files[i].file_url;
                                                                                  file_path +=
                                                                                    res.data.result.files[i].file_path;
                                                                                  file_url2 +=
                                                                                    res.data.result.files[i]
                                                                                      .second_file_url;
                                                                                  second_file_path +=
                                                                                    res.data.result.files[i]
                                                                                      .second_file_path;
                                                                                  file_url3 +=
                                                                                    res.data.result.files[i]
                                                                                      .third_file_url;
                                                                                  file_url4 +=
                                                                                    res.data.result.files[i]
                                                                                      .fourth_file_url;
                                                                                  file_id +=
                                                                                    res.data.result.files[i]._id;
                                                                                  var joined_videoId =
                                                                                    this.state.attchmnt_videoId_cmb.concat(
                                                                                      res.data.result.files[i]._id,
                                                                                    );
                                                                                  this.setState({
                                                                                    attchmnt_videoId_cmb:
                                                                                      joined_videoId,
                                                                                  });
                                                                                }
                                                                                const atchId_recrd =
                                                                                  res.data.result.files[0]._id;
                                                                                console.log(atchId_recrd);

                                                                                setTimeout(() => {
                                                                                  console.log(
                                                                                    this.state.atcharryDet_cmb,
                                                                                  );
                                                                                }, 150);

                                                                                $('.attachLoading_cmb').hide();
                                                                                $('#attachLoading_cmb_video').hide();

                                                                                const video_details = {
                                                                                  apikey: API_KEY,
                                                                                  secret: API_SECRET,
                                                                                  user_id: this.state.user_id,
                                                                                  business_id: this.state.business_id,
                                                                                  attachment: atchId_recrd,
                                                                                  attachment_type: 'video',
                                                                                  unique_id:
                                                                                    this.state.message_edit === false
                                                                                      ? Rnunique_id_cmb
                                                                                      : this.state.Rnunique_id_cmb
                                                                                        .append
                                                                                        ? this.state.Rnunique_id_cmb
                                                                                        : Rnunique_id_cmb,
                                                                                  order:
                                                                                    '' +
                                                                                    this.state.attachOrderIncrs_cmb +
                                                                                    '',
                                                                                };

                                                                                axios
                                                                                  .post(
                                                                                    API_CALL_ENDPOINT +
                                                                                    '/text/attachment/create',
                                                                                    video_details,
                                                                                  )
                                                                                  .then((res) => {
                                                                                    console.log(res);
                                                                                    console.log(res.data.message);

                                                                                    if (res.data.status == 'success') {
                                                                                      this.setState({
                                                                                        messageAttachd_cmb: true,
                                                                                      });
                                                                                      this.setState({
                                                                                        atcharryDet_cmb: [
                                                                                          {
                                                                                            file_path: file_path,
                                                                                            second_file_path:
                                                                                              second_file_path,
                                                                                            video_id: file_id,
                                                                                            video_url: file_url,
                                                                                            video_url2: file_url2,
                                                                                            video_url3: file_url3,
                                                                                            video_url4: file_url4,
                                                                                            attach_id:
                                                                                              res.data.result._id,
                                                                                          },
                                                                                          ...this.state.atcharryDet_cmb,
                                                                                        ],
                                                                                      });
                                                                                      var OrderIncr =
                                                                                        this.state
                                                                                          .attachOrderIncrs_cmb +
                                                                                        parseInt(1);
                                                                                      this.setState({
                                                                                        attachOrderIncrs_cmb: OrderIncr,
                                                                                      });
                                                                                    }
                                                                                    if (res.data.error) {
                                                                                    }
                                                                                  });

                                                                                console.log(file_url);
                                                                              }
                                                                            });
                                                                        }}
                                                                        setVideo={(blob) => {
                                                                          let blobUrl = URL.createObjectURL(blob);
                                                                          console.log(blobUrl);
                                                                          // this.setState({ captureVideoUrl: blobUrl })
                                                                        }}
                                                                      />
                                                                      {/* </div> */}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="timeline-footer">
                                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                              <a
                                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                onClick={this.videoLclDelte_cmb}>
                                                                Delete
                                                              </a>
                                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {/* END timeline item */}
                                                        {/* timeline item */}
                                                        <div style={{ display: 'none' }}>
                                                          <i className="fas fa-film bg_video attachtype_timelineicon" />
                                                          <div className="timeline-item">
                                                            <div className="timeline-body">
                                                              <div className="attachmentbody_div d-table">
                                                                <div className="d-table-row">
                                                                  <div className="d-table-cell w-70 align-top">
                                                                    <span className="attachrecord_icon bg_video crsr_pntr">
                                                                      <i className="fas fa-film" />
                                                                    </span>
                                                                  </div>
                                                                  <div className="d-table-cell align-middle">
                                                                    <div className="f_sz16">
                                                                      <span>
                                                                        <i className="fas fa-spinner fa-spin f_sz24" />
                                                                      </span>
                                                                      <span
                                                                        className="ml-2"
                                                                        style={{
                                                                          display: 'none',
                                                                        }}>
                                                                        0.10
                                                                      </span>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="timeline-footer">
                                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                Save
                                                              </a>
                                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                Delete
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {/* END timeline item */}

                                                        {/* timeline item */}
                                                        <div style={{ display: 'none' }}>
                                                          <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                          <div className="timeline-item">
                                                            <div className="timeline-body">
                                                              <div className="form-group row">
                                                                <label className="col-form-label pull-left pl-2 f_sz16">
                                                                  No. of Rewards
                                                                </label>
                                                                <div className="pull-left ml-3">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control text-center txtbx_sm"
                                                                    defaultValue={10}
                                                                    disabled
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="timeline-footer">
                                                              {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">
                                                                Delete
                                                              </a>
                                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                              </a>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {/* END timeline item */}
                                                        {/* timeline item */}
                                                        <div style={{ display: 'none' }}>
                                                          <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                                          <div className="timeline-item">
                                                            <div className="timeline-body">
                                                              <div className="form-group row">
                                                                <label className="col-form-label pull-left pl-2 f_sz16">
                                                                  No. of Rewards
                                                                </label>
                                                                <div className="pull-left ml-3">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control text-center txtbx_sm"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="timeline-footer">
                                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                Save
                                                              </a>
                                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                Delete
                                                              </a>
                                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {/* END timeline item */}
                                                        <div id="attachLoading_cmb_video">
                                                          <i
                                                            className="fas fa-circle bg-gray"
                                                            style={{ fontSize: 'x-small' }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                className="attchLstShow_cmb"
                                                style={{ display: 'none' }}
                                                onClick={() => this.hide_emoji()}>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                                                  <div className="attachment_timelinediv">
                                                    {/* The time line */}

                                                    {/* The time line */}
                                                    <div
                                                      // onDragOver={this.dragOver_cmb}
                                                      className="timeline"
                                                      id="timelineprepend">
                                                      <div
                                                        id="attachLoading_cmb"
                                                        className="attachLoading_cmb"
                                                        style={{ display: 'none' }}>
                                                        <i
                                                          className={
                                                            this.state.lodingicon_cmb + ' attachtype_timelineicon'
                                                          }
                                                        />
                                                        <div className="timeline-item">
                                                          <div className="timeline-body">
                                                            <div className="attachmentbody_div d-table">
                                                              <span>
                                                                <span className="d-inline-block">
                                                                  <span>
                                                                    <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                                  </span>
                                                                  <span className="postop_5up">
                                                                    This might take few mins, please hold on while we
                                                                    process your attachment
                                                                  </span>
                                                                </span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className="timeline-footer"></div>
                                                        </div>
                                                      </div>

                                                      {this.state.atcharryDet_cmb.map((attachment, index) => {
                                                        return attachment.notes_content1 ? (
                                                          <>
                                                            <div
                                                              className={'editor_cmb_' + attachment.attach_id}
                                                              style={{ display: 'none' }}>
                                                              <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                              <div className="timeline-item ">
                                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                <div
                                                                  className={
                                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }
                                                                  // onClick={() => {
                                                                  //   this.oneditnotecmb(attachment);
                                                                  // }}
                                                                  style={{ wordWrap: 'break-word' }}>
                                                                  <div className="attachmentbody_div">
                                                                    {/* <ReactQuill
                  // theme="bubble"

                  modules={{
                    toolbar: [
                      [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                      ],
                      [
                        {header: '1'},
                        {header: '2'},
                        {font: []},
                      ],
                      [
                        {list: 'ordered'},
                        {list: 'bullet'},
                        {indent: '-1'},
                        {indent: '+1'},
                      ],
                      ['link', 'video'],
                      ['clean'],
                    ],

                    clipboard: {
                      // toggle to add extra line breaks when pasting HTML:
                      matchVisual: false,
                    },
                  }}
                  formats={[
                    'header',
                    'font',
                    'size',
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'list',
                    'bullet',
                    'indent',
                    'link',
                    'video',
                  ]}
                  value={this.state.notesValue2_cmb}
                  onChange={this.notesLetter2_cmb}
                  maxLength="600"
                /> */}
                                                                    <CKEditor
                                                                      editor={ClassicEditor}
                                                                      data={this.state.notesValue2_cmb}
                                                                      id="mytext"
                                                                      config={editorConfiguration}
                                                                      onReady={(editor) => {
                                                                        // You can store the "editor" and use when it is needed.
                                                                        // console.log( 'Editor is ready to use!', editor );
                                                                      }}
                                                                      onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        // console.log( { event, editor, data } );
                                                                        // if (data.length <= 1200) {
                                                                        this.setState({
                                                                          notesValue2_cmb: data,
                                                                          chars_left_notes_cmb:
                                                                            this.state.max_chars_notes_cmb -
                                                                            data.length,
                                                                        });
                                                                        // }
                                                                      }}
                                                                      onBlur={(event, editor) => {
                                                                        // console.log( 'Blur.', editor );
                                                                      }}
                                                                      onFocus={(event, editor) => {
                                                                        // console.log( 'Focus.', editor );
                                                                      }}
                                                                    />
                                                                  </div>
                                                                </div>

                                                                {/* {this.state.cmb_notesedit === true ? (
              <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                {this.state.savingprogress}
              </div>
            ) : null} */}

                                                                {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                                              
                                                              Maximum 1200 characters
                                                            </div> */}
                                                                <div
                                                                  className={
                                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }>
                                                                  {/* {this.state.cmb_notesedit === true ? (
                <a
                  className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                  onClick={() => {
                    this.updateNotes2_cmb();
                  }}>
                  Update
                </a>
              ) : null} */}
                                                                  <a
                                                                    className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                    onClick={() => {
                                                                      this.updateNotes2_cmb();
                                                                      this.expanded_attach(attachment.attach_id);
                                                                    }}>
                                                                    {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                                    Save
                                                                  </a>
                                                                  <a
                                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                    onClick={() =>
                                                                      this.notesAtchDelte_cmb_edit(attachment.attach_id)
                                                                    }>
                                                                    Delete
                                                                  </a>
                                                                  <a
                                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                    onClick={() => {
                                                                      this.expanded_attach(attachment.attach_id);
                                                                    }}>
                                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                  </a>
                                                                  {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                                </div>
                                                                {/* </span> */}
                                                                {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                              </div>
                                                              <div className="timeline-item ">
                                                                <div
                                                                  className={
                                                                    'timeline-body attachment_colapsed attachment_colapsed_' +
                                                                    attachment.attach_id
                                                                  }
                                                                  style={{ display: 'none' }}>
                                                                  <div className="attachmentbody_div">
                                                                    Notes Attached
                                                                    <a
                                                                      className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                      onClick={() => {
                                                                        this.colapsed_attach(attachment.attach_id);
                                                                        this.oneditnotecmb(attachment);
                                                                      }}>
                                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                                {/* </span> */}
                                                              </div>
                                                            </div>

                                                            <div
                                                              data-id={index}
                                                              key={index}
                                                              // draggable="true"
                                                              // onDragEnd={this.dragEnd_cmb}
                                                              // onDragStart={this.dragStart_cmb}
                                                              className={
                                                                'notecontent_cmb_show notecontent_cmb_' +
                                                                attachment.attach_id
                                                              }>
                                                              <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                                              <div className="timeline-item ">
                                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                <div
                                                                  className={
                                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }
                                                                  onClick={() => {
                                                                    this.oneditnotecmb(attachment);
                                                                  }}
                                                                  style={{ wordWrap: 'break-word' }}>
                                                                  <div className="attachmentbody_div">
                                                                    <Linkify
                                                                      componentDecorator={(
                                                                        decoratedHref,
                                                                        decoratedText,
                                                                        key,
                                                                      ) => (
                                                                        <a
                                                                          target="blank"
                                                                          href={decoratedHref}
                                                                          key={key}>
                                                                          {decoratedText}
                                                                        </a>
                                                                      )}>
                                                                      <div
                                                                        dangerouslySetInnerHTML={{
                                                                          __html: attachment.notes_content,
                                                                        }}
                                                                      />
                                                                      {/* {attachment.notes_content} */}
                                                                    </Linkify>
                                                                  </div>
                                                                </div>

                                                                <div
                                                                  className={
                                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }>
                                                                  <a
                                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                    id={attachment.attach_id}
                                                                    onClick={this.notesAtchDelte_cmb}>
                                                                    Delete
                                                                  </a>
                                                                  <a
                                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                    onClick={() => {
                                                                      this.expanded_attach(attachment.attach_id);
                                                                    }}>
                                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                  </a>
                                                                  {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
            <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
          </a> */}
                                                                </div>
                                                                {/* </span> */}
                                                                {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                              </div>
                                                              <div className="timeline-item ">
                                                                <div
                                                                  className={
                                                                    'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                    attachment.attach_id
                                                                  }
                                                                  style={{ display: 'none' }}>
                                                                  <div className="attachmentbody_div">
                                                                    Notes Attached
                                                                    <a
                                                                      className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                      onClick={() => {
                                                                        this.colapsed_attach(attachment.attach_id);
                                                                        this.oneditnotecmb(attachment);
                                                                      }}>
                                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                    {/* </span> */}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </>
                                                        ) : attachment.documents ? (
                                                          attachment.documents.length > 0 ? (
                                                            <div
                                                              data-id={index}
                                                              key={index}
                                                            // draggable="true"
                                                            // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                            // onDragStart={(e) => this.dragStart_cmb(e)}
                                                            >
                                                              <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                                              <div className="timeline-item ">
                                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                <div
                                                                  className={
                                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }>
                                                                  <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                    <span className="font-weight-bold">Documents:</span>
                                                                    <br />

                                                                    <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                      {attachment.documents.map(
                                                                        (documentList, index) => {
                                                                          var fileType =
                                                                            documentList.file_name.split('.');
                                                                          return (
                                                                            <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                              <a
                                                                                onClick={() =>
                                                                                  this.document_read(documentList)
                                                                                }>
                                                                                {documentList?.thumbnail_file_url ? (
                                                                                  <div className="attachdoc_thumb">
                                                                                    <img
                                                                                      src={
                                                                                        documentList?.thumbnail_file_url
                                                                                      }
                                                                                      border={0}
                                                                                    />
                                                                                  </div>
                                                                                ) : (
                                                                                  <div className="attachdoc_type text-center">
                                                                                    <i className="far fa-file-alt flightgrey1"></i>
                                                                                  </div>
                                                                                )}

                                                                                <div className="attachdoc_filenmesze py-1 px-2">
                                                                                  <table
                                                                                    width="100%"
                                                                                    cellPadding={0}
                                                                                    cellSpacing={0}>
                                                                                    <tbody>
                                                                                      <tr>
                                                                                        <td>
                                                                                          {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                          {fileType[
                                                                                            fileType.length - 1
                                                                                          ] === 'pdf' ? (
                                                                                            <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                          ) : fileType[
                                                                                            fileType.length - 1
                                                                                          ] === 'docx' ||
                                                                                            fileType[
                                                                                            fileType.length - 1
                                                                                            ] === 'doc' ? (
                                                                                            <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                          ) : fileType[
                                                                                            fileType.length - 1
                                                                                          ] === 'jpg' ||
                                                                                            fileType[
                                                                                            fileType.length - 1
                                                                                            ] === 'jpeg' ? (
                                                                                            <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                          ) : fileType[
                                                                                            fileType.length - 1
                                                                                          ] === 'png' ? (
                                                                                            <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                          ) : fileType[
                                                                                            fileType.length - 1
                                                                                          ] === 'csv' ||
                                                                                            fileType[
                                                                                            fileType.length - 1
                                                                                            ] === 'xls' ||
                                                                                            fileType[
                                                                                            fileType.length - 1
                                                                                            ] === 'xlsx' ? (
                                                                                            <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                          ) : fileType[
                                                                                            fileType.length - 1
                                                                                          ] === 'pptx' ||
                                                                                            fileType[
                                                                                            fileType.length - 1
                                                                                            ] === 'ppt' ? (
                                                                                            <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                          ) : (
                                                                                            <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                          )}

                                                                                          <span className="f_sz13 mr-2">
                                                                                            {/* {documentList.file_name} */}
                                                                                            {documentList?.file_name
                                                                                              ?.length > 5
                                                                                              ? documentList?.file_name.substring(
                                                                                                0,
                                                                                                5,
                                                                                              ) +
                                                                                              '...' +
                                                                                              this.getExtensionFromUrl(
                                                                                                documentList?.file_name,
                                                                                              )
                                                                                              : documentList?.file_name}
                                                                                          </span>
                                                                                        </td>
                                                                                        <td align="right">
                                                                                          <span className="f_sz12 flightgrey">
                                                                                            {this.bytesToKb(
                                                                                              documentList?.file_size,
                                                                                            )}{' '}
                                                                                            kB
                                                                                          </span>
                                                                                        </td>
                                                                                      </tr>
                                                                                    </tbody>
                                                                                  </table>
                                                                                </div>
                                                                              </a>
                                                                            </div>
                                                                          );
                                                                        },
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  className={
                                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }>
                                                                  <a
                                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                    id={attachment.attach_id}
                                                                    onClick={(e) =>
                                                                      this.documntAtchDelte_cmb(e, attachment.documents)
                                                                    }>
                                                                    Delete
                                                                  </a>
                                                                  <a
                                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                    onClick={() => {
                                                                      this.expanded_attach(attachment.attach_id);
                                                                    }}>
                                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                  </a>

                                                                  {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
              </a> */}
                                                                </div>
                                                                {/* </span> */}
                                                                {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                                              </div>
                                                              <div className="timeline-item ">
                                                                <div
                                                                  className={
                                                                    'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                    attachment.attach_id
                                                                  }
                                                                  style={{ display: 'none' }}>
                                                                  <div className="attachmentbody_div">
                                                                    Document Attached
                                                                    <a
                                                                      className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                      onClick={() => {
                                                                        this.colapsed_attach(attachment.attach_id);
                                                                      }}>
                                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                                {/* </span> */}
                                                              </div>
                                                            </div>
                                                          ) : undefined
                                                        ) : attachment.images ? (
                                                          attachment.images.length > 0 ? (
                                                            <div
                                                              data-id={index}
                                                              key={index}
                                                            // draggable="true"
                                                            // onDragEnd={this.dragEnd_cmb}
                                                            // onDragStart={this.dragStart_cmb}
                                                            >
                                                              <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                                              <div className="timeline-item ">
                                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                                <div
                                                                  className={
                                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }>
                                                                  <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                    {/* <span className="font-weight-bold">Images:</span> */}
                                                                    <br />

                                                                    <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                      {attachment.images.map((documentList, index) => {
                                                                        var fileType =
                                                                          documentList.file_name.split('.');
                                                                        return (
                                                                          <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                                            <a
                                                                              onClick={() =>
                                                                                this.document_read(documentList)
                                                                              }>
                                                                              {documentList?.thumbnail_file_url ? (
                                                                                <div className="attachdoc_thumb">
                                                                                  <img
                                                                                    src={
                                                                                      documentList?.thumbnail_file_url
                                                                                    }
                                                                                    border={0}
                                                                                  />
                                                                                </div>
                                                                              ) : (
                                                                                <div className="attachdoc_type text-center">
                                                                                  <i className="far fa-file-alt flightgrey1"></i>
                                                                                </div>
                                                                              )}

                                                                              <div className="attachdoc_filenmesze py-1 px-2">
                                                                                <table
                                                                                  width="100%"
                                                                                  cellPadding={0}
                                                                                  cellSpacing={0}>
                                                                                  <tbody>
                                                                                    <tr>
                                                                                      <td>
                                                                                        {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                                        {fileType[
                                                                                          fileType.length - 1
                                                                                        ] === 'pdf' ? (
                                                                                          <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                                        ) : fileType[
                                                                                          fileType.length - 1
                                                                                        ] === 'docx' ||
                                                                                          fileType[
                                                                                          fileType.length - 1
                                                                                          ] === 'doc' ? (
                                                                                          <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                                        ) : fileType[
                                                                                          fileType.length - 1
                                                                                        ] === 'jpg' ||
                                                                                          fileType[
                                                                                          fileType.length - 1
                                                                                          ] === 'jpeg' ? (
                                                                                          <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                        ) : fileType[
                                                                                          fileType.length - 1
                                                                                        ] === 'png' ? (
                                                                                          <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                                        ) : fileType[
                                                                                          fileType.length - 1
                                                                                        ] === 'csv' ||
                                                                                          fileType[
                                                                                          fileType.length - 1
                                                                                          ] === 'xls' ||
                                                                                          fileType[
                                                                                          fileType.length - 1
                                                                                          ] === 'xlsx' ? (
                                                                                          <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                                        ) : fileType[
                                                                                          fileType.length - 1
                                                                                        ] === 'pptx' ||
                                                                                          fileType[
                                                                                          fileType.length - 1
                                                                                          ] === 'ppt' ? (
                                                                                          <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                                        ) : (
                                                                                          <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                                        )}

                                                                                        <span className="f_sz13 mr-2">
                                                                                          {/* {documentList.file_name} */}
                                                                                          {documentList?.file_name
                                                                                            ?.length > 5
                                                                                            ? documentList?.file_name.substring(
                                                                                              0,
                                                                                              5,
                                                                                            ) +
                                                                                            '...' +
                                                                                            this.getExtensionFromUrl(
                                                                                              documentList?.file_name,
                                                                                            )
                                                                                            : documentList?.file_name}
                                                                                        </span>
                                                                                      </td>
                                                                                      <td align="right">
                                                                                        <span className="f_sz12 flightgrey">
                                                                                          {this.bytesToKb(
                                                                                            documentList?.file_size,
                                                                                          )}{' '}
                                                                                          kB
                                                                                        </span>
                                                                                      </td>
                                                                                    </tr>
                                                                                  </tbody>
                                                                                </table>
                                                                              </div>
                                                                            </a>
                                                                            {/* <div className="attachdoc_delete">
                            <a
                              href="javascript:void(0)"
                              className="crsr_pntr">
                              <i
                                className="far fa-trash-alt f_sz15"
                                onClick={this.DocLclDlete_cmb}
                                id={documentList.file_id}
                                data-id={attachment.attach_id}
                              />
                            </a>
                          </div> */}
                                                                          </div>
                                                                        );
                                                                      })}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  className={
                                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                                    attachment.attach_id
                                                                  }>
                                                                  <a
                                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                    id={attachment.attach_id}
                                                                    onClick={(e) =>
                                                                      this.documntAtchDelte_cmb(e, attachment.images)
                                                                    }>
                                                                    Delete
                                                                  </a>
                                                                  <a
                                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                    onClick={() => {
                                                                      this.expanded_attach(attachment.attach_id);
                                                                    }}>
                                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                  </a>
                                                                  {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
              </a> */}
                                                                </div>
                                                                {/* </span> */}
                                                                {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                              </div>
                                                              <div className="timeline-item ">
                                                                <div
                                                                  className={
                                                                    'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                    attachment.attach_id
                                                                  }
                                                                  style={{ display: 'none' }}>
                                                                  <div className="attachmentbody_div">
                                                                    Image Attached
                                                                    <a
                                                                      className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                      onClick={() => {
                                                                        this.colapsed_attach(attachment.attach_id);
                                                                      }}>
                                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                                {/* </span> */}
                                                              </div>
                                                            </div>
                                                          ) : undefined
                                                        ) : attachment.audio_url ? (
                                                          <div
                                                            data-id={index}
                                                            key={index}
                                                          // draggable="true"
                                                          // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                          // onDragStart={(e) => this.dragStart_cmb(e)}
                                                          >
                                                            <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                            <div className="timeline-item ">
                                                              {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                              <div
                                                                className={
                                                                  'timeline-body attachment_expanded attachment_expanded_' +
                                                                  attachment.audio_id
                                                                }>
                                                                <div className="attachmentbody_div d-table">
                                                                  <div className="d-table-row">
                                                                    <div className="d-table-cell align-middle">
                                                                      <span>
                                                                        <span className="d-inline-block">
                                                                          <span className="crsr_pntr">
                                                                            <i
                                                                              className={
                                                                                'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                attachment.audio_id
                                                                              }
                                                                              onClick={() => {
                                                                                this.audioPly_temp(attachment);
                                                                              }}
                                                                              id={attachment.audio_id}
                                                                            />
                                                                            <i
                                                                              className={
                                                                                'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                attachment.audio_id
                                                                              }
                                                                              onClick={this.audioPaue}
                                                                              id={attachment.audio_id}
                                                                              style={{
                                                                                display: 'none',
                                                                              }}></i>
                                                                            <span
                                                                              className="ml-2 d-inline-block postop_5up"
                                                                            // style={{
                                                                            //   display: 'none',
                                                                            // }}
                                                                            ></span>
                                                                            <audio
                                                                              className={
                                                                                'audioplayer123 audio_temp_' +
                                                                                attachment.audio_id
                                                                              }
                                                                              style={{ width: '258px', display: 'none' }}
                                                                              src={
                                                                                this.state.play_audio_url
                                                                                  ? this.state.play_audio_url
                                                                                  : undefined
                                                                              }
                                                                              controls="controls"
                                                                              controlsList="nodownload"
                                                                              //hidden
                                                                              id={'audio_temp_' + attachment.audio_id}
                                                                            />
                                                                          </span>
                                                                        </span>
                                                                      </span>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div
                                                                className={
                                                                  'timeline-footer attachment_expanded attachment_expanded_' +
                                                                  attachment.audio_id
                                                                }>
                                                                <a
                                                                  className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                  id={attachment.attach_id}
                                                                  onClick={this.audioAtchDelte_cmb}>
                                                                  Delete
                                                                </a>
                                                                <a
                                                                  className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                  onClick={() => {
                                                                    this.expanded_attach(attachment.audio_id);
                                                                  }}>
                                                                  <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                </a>
                                                                {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
              <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
            </a> */}
                                                              </div>
                                                              {/* </span> */}
                                                              {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
          style={{display: "none"}}
          onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                                            </div>
                                                            <div className="timeline-item ">
                                                              <div
                                                                className={
                                                                  'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                  attachment.audio_id
                                                                }
                                                                style={{ display: 'none' }}>
                                                                <div className="attachmentbody_div">
                                                                  Audio Attached
                                                                  <a
                                                                    className={
                                                                      'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                    }
                                                                    onClick={() => {
                                                                      this.colapsed_attach(attachment.audio_id);
                                                                    }}>
                                                                    <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                  </a>
                                                                  {/* </span> */}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ) : attachment.video_url ? (
                                                          <div
                                                            data-id={index}
                                                            key={index}
                                                          // draggable="true"
                                                          // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                          // onDragStart={(e) => this.dragStart_cmb(e)}
                                                          >
                                                            <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                                            <div className="timeline-item">
                                                              {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                              <div
                                                                className={
                                                                  'timeline-body attachment_expanded attachment_expanded_' +
                                                                  attachment.attach_id
                                                                }>
                                                                <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                                  <span className="font-weight-bold">Video:</span>
                                                                  <br />
                                                                  <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                                    <a onClick={() => this.Video_play_url(attachment)}>
                                                                      {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
    <div className="attachdoc_type text-center">
      <i className="fas fa-video" />
    </div>
    <div className="attachdoc_name">
      Click here to
      play video
    </div>
  </div> */}
                                                                      <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                                        <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                                          {/* <img src={} border={0} /> */}
                                                                          <i className="fas fa-video fa-3x" />
                                                                        </div>
                                                                        <div className="attachvideo_gif">
                                                                          {/* <img src={} border={0} /> */}
                                                                          Click here to play video
                                                                        </div>
                                                                      </div>
                                                                      {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                                    </a>
                                                                  </div>
                                                                </div>
                                                                {/* <div className="attachmentbody_div d-table">
<div className="d-table-row">
<div className="d-table-cell align-middle">
  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
    <div className="videoWrapper">
      <video
        onPlay={() =>
          this.Video_play_url(
            attachment
          )
        }
        width="300"
        controls
        playsinline
      >
        
        <source
          src={
            this.state
              .video_play_link
          }
          type="video/mp4"
        />                                                                
      </video>
    </div>
  </div>
</div>
</div>
</div> */}
                                                              </div>
                                                              <div
                                                                className={
                                                                  'timeline-footer attachment_expanded attachment_expanded_' +
                                                                  attachment.attach_id
                                                                }>
                                                                <a
                                                                  className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                  id={attachment.attach_id}
                                                                  onClick={this.videAtchDelte_cmb}>
                                                                  Delete
                                                                </a>
                                                                <a
                                                                  className={
                                                                    'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                  }
                                                                  onClick={() => {
                                                                    this.expanded_attach(attachment.attach_id);
                                                                  }}>
                                                                  <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                </a>
                                                                {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
              <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
            </a> */}
                                                              </div>
                                                              {/* </span> */}
                                                              {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
          style={{display: "none"}}
          onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                                            </div>
                                                            <div className="timeline-item ">
                                                              <div
                                                                className={
                                                                  'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                  attachment.attach_id
                                                                }
                                                                style={{ display: 'none' }}>
                                                                <div className="attachmentbody_div">
                                                                  Video Attached
                                                                  <a
                                                                    className={
                                                                      'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                    }
                                                                    onClick={() => {
                                                                      this.colapsed_attach(attachment.attach_id);
                                                                    }}>
                                                                    <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                  </a>
                                                                  {/* </span> */}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ) : null;
                                                      })}

                                                      <div>
                                                        <i
                                                          className="fas fa-circle bg-gray"
                                                          style={{ fontSize: 'x-small' }}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="card-footer bg-transparent text-center pt-3 pb-5 py-sm-3"
                                              onClick={() => this.hide_emoji()}>
                                              <a
                                                onClick={() => {
                                                  this.template_save();
                                                }}
                                                className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                                {!this.state.templ_message_edit ? 'Add' : 'Update'}
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade nav_links_prof_tabs"
                              id="custom-tabs-nft"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-nft-tab">
                              <div className="all_contentflex_div">
                                <div className="card w-100 bx_shadow_sm">
                                  <div
                                    className="nftcreate_div"
                                    style={{
                                      display:
                                        this.state.nft_tokens?.length === 0 && this.state.nft_total_count === 0
                                          ? 'inline-block'
                                          : 'none',
                                    }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body">
                                          <div className="psnftstepwise_div">
                                            <div className="row justify-content-center">
                                              <div className="col-12 col-sm-10 col-md-10 col-lg-6 col-xl-5 text-center p-0 mt-3 mb-2">
                                                <div className="card px-0 pt-4 pb-0 mt-3 mb-3 shadow-none">
                                                  <h5 id="heading">NFT's</h5>
                                                  <form id="msform">
                                                    <ul id="progressbar">
                                                      <li className="active" id="nftcontract">
                                                        <strong>NFT Contract</strong>
                                                      </li>
                                                      <li id="nftmint">
                                                        <strong>Mint an NFT</strong>
                                                      </li>
                                                      <li id="nftconfirm">
                                                        <strong>Confirm</strong>
                                                      </li>
                                                    </ul>
                                                    <fieldset id="nft_step_1">
                                                      <div className="form-card">
                                                        <div className="row">
                                                          <div className="col-7">
                                                            <h2 className="fs-title">Set Up NFT Minting Contract</h2>
                                                          </div>
                                                          <div className="col-5">
                                                            <h2 className="steps">Step 1 - 3</h2>
                                                          </div>
                                                        </div>
                                                        <div className="mt-4">
                                                          <div
                                                            className="nftrequest"
                                                            style={{
                                                              display:
                                                                this.state.nft_details.status == '' ||
                                                                  this.state.nft_details.status == 'deleted'
                                                                  ? 'block'
                                                                  : 'none',
                                                            }}>
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder="Token Name"
                                                              id="nft_token_name"
                                                            />
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder="Token Symbol"
                                                              id="nft_token_symbol"
                                                            />
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              placeholder="Maximum Number of Tokens"
                                                              id="token_limits"
                                                              min="1"
                                                            />
                                                            <div className="nftrequest_div">
                                                              <div className="w-100 d-flex flex-row flex-wrap pb-4 keys0">
                                                                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control key_vals"
                                                                    data-id="0"
                                                                    placeholder="Key"
                                                                  />
                                                                </div>
                                                                <div className="col-5 col-sm-5 col-md-4 col-lg-4">
                                                                  <div className="icheck-darkgrey d-inline-block pt-1 pt-md-3">
                                                                    <input type="checkbox" id="keyrequired0" />
                                                                    <label htmlFor="keyrequired0">Required</label>
                                                                  </div>
                                                                </div>
                                                                <div className="col-7 col-sm-7 col-md-2 col-lg-2 pr-0 pt-1 pt-md-3">
                                                                  {/* <a>
                                                                    <i
                                                                      class="fas fa-trash-alt mt-2 mr-3 f_sz16 crsr_pntr fmaroon remove_keys"
                                                                      data-id="0"></i>
                                                                  </a> */}
                                                                  <a>
                                                                    <i className="fas fa-plus-circle mt-2 f_sz16 crsr_pntr fmaroon addmore_nft_keys" />
                                                                  </a>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div align="center" className="mt-3">
                                                              <a className="btn btn-black crsr_pntr btnpdng_sm nftrequest_btn">
                                                                Request NFT Contract
                                                              </a>
                                                              <h6
                                                                className="w-100 mb-3 btn_confirmation"
                                                                style={{ display: 'none' }}>
                                                                Are you sure, NFT contract will be created with the
                                                                above token name and token symbol? Once created, it
                                                                cannot be reverted.
                                                              </h6>
                                                              <a
                                                                className="btn btn-black crsr_pntr btnpdng_sm nftrequest_confirm_btn"
                                                                onClick={() => this.contractRequest()}
                                                                style={{ display: 'none' }}>
                                                                Confirm NFT Contract Request
                                                              </a>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="text-center nftprocess"
                                                            style={{
                                                              display:
                                                                this.state.nft_details.status == 'requested'
                                                                  ? 'block'
                                                                  : 'none',
                                                            }}>
                                                            <h5>
                                                              Your request for NFT creation will be reviewed and
                                                              approved within 24 hours.
                                                            </h5>
                                                            <div align="center" className="mt-5">
                                                              <span className="btn btn-black btnpdng_sm nftprocess_btn">
                                                                Requested
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="text-center nftapproved"
                                                            style={{
                                                              display:
                                                                this.state.nft_details.status == 'approved'
                                                                  ? 'block'
                                                                  : 'none',
                                                            }}>
                                                            <h5>NFT contract created. You are now ready to mint.</h5>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <input
                                                        type="button"
                                                        name="next"
                                                        className="next action-button mt-4 nftapproved_next"
                                                        defaultValue="Next"
                                                        style={{
                                                          display:
                                                            this.state.nft_details.status == 'approved'
                                                              ? 'inline-block'
                                                              : 'none',
                                                        }}
                                                        onClick={() => this.contractNextStep(2)}
                                                      />
                                                    </fieldset>
                                                    <fieldset id="nft_step_2">
                                                      <div className="form-card">
                                                        <div className="row">
                                                          <div className="col-7">
                                                            <h2 className="fs-title">Mint an NFT:</h2>
                                                          </div>
                                                          <div className="col-5">
                                                            <h2 className="steps">Step 2 - 3</h2>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div className="form-group mt-3 mb-4">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter the NFT Name"
                                                                id="nft_name"
                                                              />
                                                            </div>
                                                          </div>
                                                          <div className="form-group mt-3 mb-4">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <textarea
                                                                className="form-control textarea_hgt125 txtarea_resizenone"
                                                                placeholder="Enter Description"
                                                                defaultValue={''}
                                                                id="nft_decription"
                                                              />
                                                            </div>
                                                            <input type="hidden" id="nft_file_name" />
                                                            <input type="hidden" id="nft_file_url" />
                                                            <input type="hidden" id="nft_thumb_file_url" />
                                                          </div>
                                                          <div className="form-group row mt-3 mb-4 m-2 upload_div">
                                                            <div className="col-3 col-sm-2 col-md-2 col-lg-2">
                                                              <label className="col-form-label">Upload</label>
                                                            </div>
                                                            <div className="col-9 col-sm-10 col-md-10 col-lg-10">
                                                              <div className="d-inline-block postop_3up">
                                                                <div className="select_style">
                                                                  <select className="form-control chooseupload">
                                                                    <option value="">--Select--</option>
                                                                    <option value="chooseimage">Image</option>
                                                                    {/* <option value="chooseaudio">Audio</option> */}
                                                                    <option value="choosegif">GIF</option>
                                                                  </select>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="chooseimage chupld" style={{ display: 'none' }}>
                                                            <div className="form-group row mt-3 mb-4 m-2">
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label className="col-form-label">
                                                                  Upload the image
                                                                </label>
                                                                <div className="d-inline-block ml-4">
                                                                  <label className="btn-bs-file">
                                                                    <span className="btn btn-black btnpdng_sm crsr_pntr">
                                                                      Upload
                                                                    </span>
                                                                    <input
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,image/*"
                                                                      onChange={(event) =>
                                                                        this.fileGetDetails_cmb_imagesnft(event)
                                                                      }
                                                                      className="nft_img_uploads"
                                                                    />
                                                                  </label>
                                                                </div>
                                                              </div>
                                                              <div
                                                                className="col-12 col-sm-12 col-md-12 col-lg-12"
                                                                style={{ display: 'none' }}
                                                                id="uploaded_image">
                                                                <div className="nftimage_div mt-3">
                                                                  <img
                                                                    src="../dist/img/sample_painting1.jpg"
                                                                    id="uploaded_img_src"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="chooseaudio chupld" style={{ display: 'none' }}>
                                                            <div className="form-group row mt-3 mb-4 m-2">
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label className="col-form-label">
                                                                  Upload the audio
                                                                </label>
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <div className="all_contentflex_div icheck_lbl">
                                                                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 pl-0">
                                                                    <div className="icheck-darkgrey d-inline-block py-2">
                                                                      <input
                                                                        type="radio"
                                                                        name="nft_uploadaudio"
                                                                        id="nft_record"
                                                                        defaultValue={1}
                                                                        className="audio_select"
                                                                      />
                                                                      <label htmlFor="nft_record">Record</label>
                                                                    </div>
                                                                  </div>
                                                                  <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                                                    <div className="icheck-darkgrey d-inline-block py-2">
                                                                      <input
                                                                        type="radio"
                                                                        name="nft_uploadaudio"
                                                                        id="nft_upload"
                                                                        defaultValue={2}
                                                                        className="audio_select"
                                                                      />
                                                                      <label htmlFor="nft_upload">Upload</label>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <div
                                                                  className="nftvoicedesc"
                                                                  id="nftvoicemsg1"
                                                                  style={{ display: 'none' }}>
                                                                  {/* <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" /> */}
                                                                  <div className="sendmsgattach_clkAudio2_cmb_nft">
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="attachmentbody_div d-table">
                                                                          <div className="d-table-row">
                                                                            <div class="d-table-cell w-70 align-top">
                                                                              <span class="attachrecord_icon bg_audio crsr_pntr">
                                                                                <i class="fas fa-microphone-alt"></i>
                                                                              </span>
                                                                            </div>
                                                                            <div className="d-table-cell align-middle">
                                                                              <span className="ml-2">
                                                                                <span className="crsr_pntr">
                                                                                  <i
                                                                                    className="fas fa-record-vinyl fa-2x fbred"
                                                                                    onClick={this.audio_start_cmb_nft}
                                                                                  />
                                                                                  <span
                                                                                    className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                    onClick={this.audio_start_cmb_nft}>
                                                                                    Start Recording
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>

                                                                      <div className="timeline-footer">
                                                                        {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                        <a
                                                                          className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                          onClick={this.audioLclDelte_cmb_nft}>
                                                                          Delete
                                                                        </a>
                                                                        <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {this.state.atcharryDet_cmb.map(
                                                                    (attachment, index) => {
                                                                      return attachment.audio_url ? (
                                                                        <div
                                                                          data-id={index}
                                                                          key={index}
                                                                        // draggable="true"
                                                                        // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                        // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                        >
                                                                          <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                          <div className="timeline-item ">
                                                                            {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                                            <div
                                                                              className={
                                                                                'timeline-body attachment_expanded_nft attachment_expanded_' +
                                                                                attachment.audio_id
                                                                              }>
                                                                              <div className="attachmentbody_div d-table">
                                                                                <div className="d-table-row">
                                                                                  <div className="d-table-cell align-middle">
                                                                                    <span>
                                                                                      <span className="d-inline-block">
                                                                                        <span className="crsr_pntr">
                                                                                          <i
                                                                                            className={
                                                                                              'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                              attachment.audio_id
                                                                                            }
                                                                                            onClick={() => {
                                                                                              this.audioPly_temp(
                                                                                                attachment,
                                                                                              );
                                                                                            }}
                                                                                            id={attachment.audio_id}
                                                                                          />
                                                                                          <i
                                                                                            className={
                                                                                              'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                              attachment.audio_id
                                                                                            }
                                                                                            onClick={this.audioPaue}
                                                                                            id={attachment.audio_id}
                                                                                            style={{
                                                                                              display: 'none',
                                                                                            }}></i>
                                                                                          <span
                                                                                            className="ml-2 d-inline-block postop_5up"
                                                                                          // style={{
                                                                                          //   display: 'none',
                                                                                          // }}
                                                                                          ></span>
                                                                                          <audio
                                                                                            className={
                                                                                              'audioplayer123 audio_temp_' +
                                                                                              attachment.audio_id
                                                                                            }
                                                                                            style={{
                                                                                              width: '258px',
                                                                                              display: 'none',
                                                                                            }}
                                                                                            src={
                                                                                              this.state.play_audio_url
                                                                                                ? this.state
                                                                                                  .play_audio_url
                                                                                                : undefined
                                                                                            }
                                                                                            controls="controls"
                                                                                            controlsList="nodownload"
                                                                                            //hidden
                                                                                            id={
                                                                                              'audio_temp_' +
                                                                                              attachment.audio_id
                                                                                            }
                                                                                          />
                                                                                        </span>
                                                                                      </span>
                                                                                    </span>
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <div
                                                                              className={
                                                                                'timeline-footer attachment_expanded_nft attachment_expanded_' +
                                                                                attachment.audio_id
                                                                              }>
                                                                              <a
                                                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                                id={attachment.attach_id}
                                                                                onClick={this.audioAtchDelte_cmb}>
                                                                                Delete
                                                                              </a>
                                                                              <a
                                                                                className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                                onClick={() => {
                                                                                  this.expanded_attach(
                                                                                    attachment.audio_id,
                                                                                  );
                                                                                }}>
                                                                                <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                              </a>
                                                                            </div>
                                                                          </div>
                                                                          <div className="timeline-item ">
                                                                            <div
                                                                              className={
                                                                                'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                                attachment.audio_id
                                                                              }
                                                                              style={{ display: 'none' }}>
                                                                              <div className="attachmentbody_div">
                                                                                Audio Attached
                                                                                <a
                                                                                  className={
                                                                                    'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                                  }
                                                                                  onClick={() => {
                                                                                    this.colapsed_attach(
                                                                                      attachment.audio_id,
                                                                                    );
                                                                                  }}>
                                                                                  <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                                </a>
                                                                                {/* </span> */}
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      ) : (
                                                                        ''
                                                                      );
                                                                    },
                                                                  )}
                                                                  ;
                                                                  <div
                                                                    style={{ display: 'none' }}
                                                                    className="audioRecordLoading_cmb_nft">
                                                                    <div className="timeline-item">
                                                                      <div className="timeline-body">
                                                                        <div className="attachmentbody_div d-table">
                                                                          <div className="d-table-row">
                                                                            <div class="d-table-cell w-70 align-top">
                                                                              <span class="attachrecord_icon bg_audio crsr_pntr">
                                                                                <i class="fas fa-microphone-alt"></i>
                                                                              </span>
                                                                            </div>
                                                                            <div className="d-table-cell align-middle">
                                                                              <span>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i
                                                                                      className="far fa-stop-circle f_sz30 fbred"
                                                                                      onClick={
                                                                                        this.audio_stop_cmb_nft
                                                                                      }></i>
                                                                                    <span
                                                                                      className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                      onClick={this.audio_stop_cmb_nft}>
                                                                                      Stop Recording
                                                                                    </span>
                                                                                  </span>
                                                                                  <span className="f_sz16">
                                                                                    <span>
                                                                                      <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="timeline-footer">
                                                                        {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                                        <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                          Delete
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  {/* <div className="all_contentflex_div">
                                                                    <div className="card w-100 mt-2 mb-4 shadow-none">
                                                                      <div className="card-header">
                                                                        <h5 className="fmaroon f_sz15">Record Audio</h5>
                                                                      </div>
                                                                      <div className="card-body">
                                                                        <div className="d-table w-100">
                                                                          <div className="d-table-row">
                                                                            <div className="d-table-cell w-70 align-top">
                                                                              <span className="attachrecord_icon bg_audio crsr_pntr">
                                                                                <i className="fas fa-microphone-alt" />
                                                                              </span>
                                                                            </div>
                                                                            <div className="d-table-cell align-middle">
                                                                              <span style={{display: 'none'}}>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i className="fas fa-record-vinyl fa-2x" />
                                                                                    <span className="ml-2 d-inline-block postop_5up mr-2 fmaroon">
                                                                                      Start Recording
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                              <span style={{display: 'none'}}>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i className="far fa-stop-circle f_sz30" />
                                                                                    <span className="ml-2 d-inline-block postop_5up mr-2 fmaroon">
                                                                                      Stop Recording
                                                                                    </span>
                                                                                  </span>
                                                                                  <span className="f_sz16">
                                                                                    <span>
                                                                                      <i className="fas fa-spinner fa-spin f_sz24" />
                                                                                    </span>
                                                                                    <span className="ml-2 d-inline-block postop_3up">
                                                                                      0.08
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                              <span style={{display: 'block'}}>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i className="far fa-play-circle fa-2x" />
                                                                                    <span className="ml-2 d-inline-block postop_5up">
                                                                                      1:08
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="card-footer bg-transparent text-center ">
                                                                        <a className="btn btn-black crsr_pntr btnpdng_sm mr-2">
                                                                          Save
                                                                        </a>
                                                                        <a className="btn btn-secondary crsr_pntr btnpdng_sm">
                                                                          Delete
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div> */}
                                                                </div>
                                                                <div
                                                                  className="nftvoicedesc"
                                                                  id="nftvoicemsg2"
                                                                  style={{ display: 'none' }}>
                                                                  <div className="all_contentflex_div">
                                                                    <div className="card w-100 mt-2 mb-4 shadow-none">
                                                                      <div className="card-header">
                                                                        <h5 className="fmaroon f_sz15">Upload Audio</h5>
                                                                      </div>
                                                                      <div className="card-body">
                                                                        <div className="w-100 d-flex flex-flow flex-row flex-wrap justify-content-center mt-3">
                                                                          <label className="btn-bs-file">
                                                                            <span className="btn btn-black btnpdng_sm crsr_pntr">
                                                                              Upload Audio
                                                                            </span>
                                                                            <input type="file" />
                                                                          </label>
                                                                        </div>
                                                                        <div className="uploaded_audiodiv text-center mt-3">
                                                                          <div className="d-flex align-items-center justify-content-center">
                                                                            <i className="fas fa-play-circle fa-4x mr-2 fblue" />
                                                                            <span className="font-weight-semibold">
                                                                              sample_audio.mp3
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="choosegif chupld" style={{ display: 'none' }}>
                                                            <div className="form-group row mt-3 mb-4 m-2">
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label className="col-form-label">Upload GIF</label>
                                                                <div className="d-inline-block ml-4">
                                                                  <label className="btn-bs-file">
                                                                    <span className="btn btn-black btnpdng_sm crsr_pntr">
                                                                      Upload
                                                                    </span>
                                                                    <input
                                                                      type="file"
                                                                      name="DcfilNm"
                                                                      accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,image/*"
                                                                      onChange={(event) =>
                                                                        this.fileGetDetails_cmb_imagesnftgiff(event)
                                                                      }
                                                                      className="nft_img_uploads"
                                                                    />
                                                                  </label>
                                                                </div>
                                                              </div>
                                                              <div
                                                                className="col-12 col-sm-12 col-md-12 col-lg-12"
                                                                style={{ display: 'none' }}
                                                                id="uploaded_image_giff">
                                                                <div className="nftimage_div mt-3">
                                                                  <img
                                                                    src="../dist/img/sample_painting1.jpg"
                                                                    id="uploaded_img_src_giff"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div>
                                                            {this.state.business_info_array?.business?.nft?.token_key
                                                              ?.length != 0
                                                              ? this.state.business_info_array?.business?.nft?.token_key?.map(
                                                                (data, index) => (
                                                                  <div className="form-group row mt-3 mb-2 m-2">
                                                                    <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                                                                      <label className="col-form-label">
                                                                        {data.key}
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control cnftkeyvalues"
                                                                        data-key={data.key}
                                                                        data-required={data.required}
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                ),
                                                              )
                                                              : null}
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <input
                                                        type="button"
                                                        name="next"
                                                        className="next action-button mt-4 nft_next_btn"
                                                        defaultValue="Mint an NFT"
                                                        onClick={() => this.contractNextStep(3)}
                                                      />
                                                      <input
                                                        style={{ display: 'none' }}
                                                        type="button"
                                                        name="next"
                                                        className="next action-button mt-4 isdisabled nft_next_btn_disabled"
                                                        defaultValue="Mint an NFT"
                                                      />
                                                    </fieldset>
                                                    <fieldset id="nft_step_3">
                                                      <div className="form-card">
                                                        <div className="row">
                                                          <div className="col-7">
                                                            <h2 className="fs-title">Confirm:</h2>
                                                          </div>
                                                          <div className="col-5">
                                                            <h2 className="steps">Step 3 - 3</h2>
                                                          </div>
                                                        </div>{' '}
                                                        <br />
                                                        <div>
                                                          <div className="form-group row mt-3 mb-4">
                                                            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                              <label className="col-form-label">NFT Name</label>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                              <div className="pdngtop_10">{this.state.nft_name}</div>
                                                            </div>
                                                          </div>
                                                          <div className="form-group row mt-3 mb-4">
                                                            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                              <label className="col-form-label">Description</label>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                              <div className="pdngtop_10">
                                                                {this.state.nft_decription}
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="form-group row mt-3 mb-4 m-2"
                                                            style={{
                                                              display:
                                                                this.state.nft_file_type !== 'image/gif' ? '' : 'none',
                                                            }}>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <label className="col-form-label">Image</label>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="nftimage_div mt-3">
                                                                <img src={this.state.nft_file_url} />
                                                              </div>
                                                            </div>
                                                          </div>

                                                          {/* <div className="form-group row mt-3 mb-4 m-2">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <label className="col-form-label">Audio</label>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="uploaded_audiodiv text-center">
                                                                <div className="d-flex align-items-center">
                                                                  <i className="fas fa-play-circle fa-4x mr-2 fblue" />
                                                                  <span className="font-weight-semibold">
                                                                    sample_audio.mp3
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div> */}
                                                          <div
                                                            className="form-group row mt-3 mb-4 m-2"
                                                            style={{
                                                              display:
                                                                this.state.nft_file_type === 'image/gif' ? '' : 'none',
                                                            }}>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <label className="col-form-label">GIF</label>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="nftimage_div mt-3">
                                                                <img src={this.state.nft_file_url} />
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="mt-4">
                                                            {this.state.nft_keys?.length != 0
                                                              ? this.state.nft_keys?.map((data, index) => (
                                                                <div className="form-group row mt-3 mb-2 m-2">
                                                                  <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                                                                    <label className="col-form-label">
                                                                      {data.key}
                                                                    </label>
                                                                  </div>
                                                                  <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                                                                    <div className="mt-2">{data.value}</div>
                                                                  </div>
                                                                </div>
                                                              ))
                                                              : null}
                                                          </div>
                                                          <div className="form-group row mt-5 mb-4 m-2">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="icheck-darkgrey d-inline-block py-1">
                                                                <input type="checkbox" id="nftagree" />
                                                                <label htmlFor="nftagree">
                                                                  I agree to the{' '}
                                                                  <a
                                                                    target="_blank"
                                                                    href="https://www.getredtie.com/terms-conditions"
                                                                    className="fmaroon">
                                                                    terms of service
                                                                  </a>
                                                                </label>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <input
                                                        type="button"
                                                        name="previous"
                                                        className="previous action-button-previous"
                                                        defaultValue="Previous"
                                                        onClick={() => this.contractNextStep(2)}
                                                      />
                                                      <input
                                                        type="button"
                                                        name="next"
                                                        className="action-button mt-4 nftconfirm_receipt_clk"
                                                        defaultValue="Confirm"
                                                        onClick={() => this.contractNextStep(4)}
                                                      />
                                                      <input
                                                        style={{ display: 'none' }}
                                                        type="button"
                                                        name="next"
                                                        className="action-button mt-4 isdisabled nftconfirm_receipt_clk_diabled"
                                                        defaultValue="Confirm"
                                                      />
                                                    </fieldset>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="addnft_div"
                                    style={{
                                      display:
                                        this.state.nft_tokens?.length === 0 || !this.state.table_view
                                          ? 'none'
                                          : 'inline-block',
                                    }}>
                                    <div className="card w-100 bx_shadow_sm">
                                      <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                        <h5>
                                          <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">Add NFT</span>
                                          <span className="addnewnft_close mr-2 mt-1">
                                            <i className="fas fa-times" onClick={() => this.closeReceipt()} />
                                          </span>
                                        </h5>
                                      </div>
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body px-0 pb-3">
                                          <div>
                                            <div className="psnftstepwise_div addnewnftstepwise_div">
                                              <div className="row justify-content-center">
                                                <div className="col-12 col-sm-10 col-md-10 col-lg-6 col-xl-5 text-center p-0 mt-3 mb-2">
                                                  <div className="card px-0 pt-4 pb-0 mt-3 mb-3 shadow-none">
                                                    <form id="msform">
                                                      <ul id="progressbar">
                                                        <li className="active" id="nftmint">
                                                          <strong>Mint an NFT</strong>
                                                        </li>
                                                        <li id="nftconfirm" className="nftconfirm_minted">
                                                          <strong>Confirm</strong>
                                                        </li>
                                                      </ul>
                                                      <fieldset id="nftminted_step_1">
                                                        <div className="form-card">
                                                          <div className="row">
                                                            <div className="col-7">
                                                              <h2 className="fs-title">Mint an NFT:</h2>
                                                            </div>
                                                            <div className="col-5">
                                                              <h2 className="steps">Step 1 - 2</h2>
                                                            </div>
                                                          </div>
                                                          <div>
                                                            <div className="form-group mt-3 mb-4">
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <input
                                                                  type="text"
                                                                  className="form-control"
                                                                  placeholder="Enter the NFT Name"
                                                                  id="nft_name_minted"
                                                                />
                                                              </div>
                                                            </div>
                                                            <div className="form-group mt-3 mb-4">
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <textarea
                                                                  className="form-control textarea_hgt125 txtarea_resizenone"
                                                                  placeholder="Enter Description"
                                                                  defaultValue={''}
                                                                  id="nft_decription_minted"
                                                                />
                                                              </div>
                                                              <input type="hidden" id="nft_file_name_minted" />
                                                              <input type="hidden" id="nft_file_url_minted" />
                                                              <input type="hidden" id="nft_thumb_file_url_minted" />
                                                            </div>
                                                            <div className="form-group row mt-3 mb-4 m-2 upload_div">
                                                              <div className="col-3 col-sm-2 col-md-2 col-lg-2">
                                                                <label className="col-form-label">Upload</label>
                                                              </div>
                                                              <div className="col-9 col-sm-10 col-md-10 col-lg-10">
                                                                <div className="d-inline-block postop_3up">
                                                                  <div className="select_style">
                                                                    <select className="form-control chooseupload_nft_minted">
                                                                      <option value="">--Select--</option>
                                                                      <option value="chooseimage">Image</option>
                                                                      {/* <option value="chooseaudio">Audio</option> */}
                                                                      <option value="choosegif">GIF</option>
                                                                    </select>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div
                                                              className="chooseimage chupld"
                                                              style={{ display: 'none' }}>
                                                              <div className="form-group row mt-3 mb-4 m-2">
                                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                  <label className="col-form-label">
                                                                    Upload the image
                                                                  </label>
                                                                  <div className="d-inline-block ml-4">
                                                                    <label className="btn-bs-file">
                                                                      <span className="btn btn-black btnpdng_sm crsr_pntr">
                                                                        Upload
                                                                      </span>
                                                                      <input
                                                                        type="file"
                                                                        name="DcfilNm"
                                                                        accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,image/*"
                                                                        onChange={(event) =>
                                                                          this.fileGetDetails_cmb_imagesnft_mint(event)
                                                                        }
                                                                        className="nft_img_uploads"
                                                                      />
                                                                    </label>
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  className="col-12 col-sm-12 col-md-12 col-lg-12"
                                                                  style={{ display: 'none' }}
                                                                  id="uploaded_image_minted">
                                                                  <div className="nftimage_div mt-3">
                                                                    <img
                                                                      src="../dist/img/sample_painting1.jpg"
                                                                      id="uploaded_image_minted_src"
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div
                                                              className="chooseaudio chupld"
                                                              style={{ display: 'none' }}>
                                                              <div className="form-group row mt-3 mb-4 m-2">
                                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                  <label className="col-form-label">
                                                                    Upload the audio
                                                                  </label>
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                  <div className="all_contentflex_div icheck_lbl">
                                                                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 pl-0">
                                                                      <div className="icheck-darkgrey d-inline-block py-2">
                                                                        <input
                                                                          type="radio"
                                                                          name="nft_uploadaudio"
                                                                          id="nft_record"
                                                                          defaultValue={1}
                                                                          className="audio_select"
                                                                        />
                                                                        <label htmlFor="nft_record">Record</label>
                                                                      </div>
                                                                    </div>
                                                                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                                                      <div className="icheck-darkgrey d-inline-block py-2">
                                                                        <input
                                                                          type="radio"
                                                                          name="nft_uploadaudio"
                                                                          id="nft_upload"
                                                                          defaultValue={2}
                                                                          className="audio_select"
                                                                        />
                                                                        <label htmlFor="nft_upload">Upload</label>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                  <div
                                                                    className="nftvoicedesc"
                                                                    id="nftvoicemsg1"
                                                                    style={{ display: 'none' }}>
                                                                    {/* <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" /> */}
                                                                    <div className="sendmsgattach_clkAudio2_cmb_nft">
                                                                      <div className="timeline-item">
                                                                        <div className="timeline-body">
                                                                          <div className="attachmentbody_div d-table">
                                                                            <div className="d-table-row">
                                                                              <div class="d-table-cell w-70 align-top">
                                                                                <span class="attachrecord_icon bg_audio crsr_pntr">
                                                                                  <i class="fas fa-microphone-alt"></i>
                                                                                </span>
                                                                              </div>
                                                                              <div className="d-table-cell align-middle">
                                                                                <span className="ml-2">
                                                                                  <span className="crsr_pntr">
                                                                                    <i
                                                                                      className="fas fa-record-vinyl fa-2x fbred"
                                                                                      onClick={this.audio_start_cmb_nft}
                                                                                    />
                                                                                    <span
                                                                                      className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                      onClick={
                                                                                        this.audio_start_cmb_nft
                                                                                      }>
                                                                                      Start Recording
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>

                                                                        <div className="timeline-footer">
                                                                          {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                                                          <a
                                                                            className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                            onClick={this.audioLclDelte_cmb_nft}>
                                                                            Delete
                                                                          </a>
                                                                          <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                            <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    {this.state.atcharryDet_cmb.map(
                                                                      (attachment, index) => {
                                                                        return attachment.audio_url ? (
                                                                          <div
                                                                            data-id={index}
                                                                            key={index}
                                                                          // draggable="true"
                                                                          // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                                                          // onDragStart={(e) => this.dragStart_cmb(e)}
                                                                          >
                                                                            <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                                                            <div className="timeline-item ">
                                                                              {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                                                              <div
                                                                                className={
                                                                                  'timeline-body attachment_expanded_nft attachment_expanded_' +
                                                                                  attachment.audio_id
                                                                                }>
                                                                                <div className="attachmentbody_div d-table">
                                                                                  <div className="d-table-row">
                                                                                    <div className="d-table-cell align-middle">
                                                                                      <span>
                                                                                        <span className="d-inline-block">
                                                                                          <span className="crsr_pntr">
                                                                                            <i
                                                                                              className={
                                                                                                'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                                                attachment.audio_id
                                                                                              }
                                                                                              onClick={() => {
                                                                                                this.audioPly_temp(
                                                                                                  attachment,
                                                                                                );
                                                                                              }}
                                                                                              id={attachment.audio_id}
                                                                                            />
                                                                                            <i
                                                                                              className={
                                                                                                'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                                                attachment.audio_id
                                                                                              }
                                                                                              onClick={this.audioPaue}
                                                                                              id={attachment.audio_id}
                                                                                              style={{
                                                                                                display: 'none',
                                                                                              }}></i>
                                                                                            <span
                                                                                              className="ml-2 d-inline-block postop_5up"
                                                                                            // style={{
                                                                                            //   display: 'none',
                                                                                            // }}
                                                                                            ></span>
                                                                                            <audio
                                                                                              className={
                                                                                                'audioplayer123 audio_temp_' +
                                                                                                attachment.audio_id
                                                                                              }
                                                                                              style={{
                                                                                                width: '258px',
                                                                                                display: 'none',
                                                                                              }}
                                                                                              src={
                                                                                                this.state
                                                                                                  .play_audio_url
                                                                                                  ? this.state
                                                                                                    .play_audio_url
                                                                                                  : undefined
                                                                                              }
                                                                                              controls="controls"
                                                                                              controlsList="nodownload"
                                                                                              //hidden
                                                                                              id={
                                                                                                'audio_temp_' +
                                                                                                attachment.audio_id
                                                                                              }
                                                                                            />
                                                                                          </span>
                                                                                        </span>
                                                                                      </span>
                                                                                    </div>
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                              <div
                                                                                className={
                                                                                  'timeline-footer attachment_expanded_nft attachment_expanded_' +
                                                                                  attachment.audio_id
                                                                                }>
                                                                                <a
                                                                                  className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                                                  id={attachment.attach_id}
                                                                                  onClick={this.audioAtchDelte_cmb}>
                                                                                  Delete
                                                                                </a>
                                                                                <a
                                                                                  className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                                                  onClick={() => {
                                                                                    this.expanded_attach(
                                                                                      attachment.audio_id,
                                                                                    );
                                                                                  }}>
                                                                                  <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                                                </a>
                                                                              </div>
                                                                            </div>
                                                                            <div className="timeline-item ">
                                                                              <div
                                                                                className={
                                                                                  'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                                                  attachment.audio_id
                                                                                }
                                                                                style={{ display: 'none' }}>
                                                                                <div className="attachmentbody_div">
                                                                                  Audio Attached
                                                                                  <a
                                                                                    className={
                                                                                      'crsr_pntr btnpdng_sm attach_expdcollapse_btn'
                                                                                    }
                                                                                    onClick={() => {
                                                                                      this.colapsed_attach(
                                                                                        attachment.audio_id,
                                                                                      );
                                                                                    }}>
                                                                                    <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                                                  </a>
                                                                                  {/* </span> */}
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        ) : (
                                                                          ''
                                                                        );
                                                                      },
                                                                    )}
                                                                    ;
                                                                    <div
                                                                      style={{ display: 'none' }}
                                                                      className="audioRecordLoading_cmb_nft">
                                                                      <div className="timeline-item">
                                                                        <div className="timeline-body">
                                                                          <div className="attachmentbody_div d-table">
                                                                            <div className="d-table-row">
                                                                              <div class="d-table-cell w-70 align-top">
                                                                                <span class="attachrecord_icon bg_audio crsr_pntr">
                                                                                  <i class="fas fa-microphone-alt"></i>
                                                                                </span>
                                                                              </div>
                                                                              <div className="d-table-cell align-middle">
                                                                                <span>
                                                                                  <span className="d-inline-block">
                                                                                    <span className="crsr_pntr">
                                                                                      <i
                                                                                        className="far fa-stop-circle f_sz30 fbred"
                                                                                        onClick={
                                                                                          this.audio_stop_cmb_nft
                                                                                        }></i>
                                                                                      <span
                                                                                        className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                                                        onClick={
                                                                                          this.audio_stop_cmb_nft
                                                                                        }>
                                                                                        Stop Recording
                                                                                      </span>
                                                                                    </span>
                                                                                    <span className="f_sz16">
                                                                                      <span>
                                                                                        <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                                                      </span>
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                        <div className="timeline-footer">
                                                                          {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                                                          <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                                            Delete
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    {/* <div className="all_contentflex_div">
                                                                    <div className="card w-100 mt-2 mb-4 shadow-none">
                                                                      <div className="card-header">
                                                                        <h5 className="fmaroon f_sz15">Record Audio</h5>
                                                                      </div>
                                                                      <div className="card-body">
                                                                        <div className="d-table w-100">
                                                                          <div className="d-table-row">
                                                                            <div className="d-table-cell w-70 align-top">
                                                                              <span className="attachrecord_icon bg_audio crsr_pntr">
                                                                                <i className="fas fa-microphone-alt" />
                                                                              </span>
                                                                            </div>
                                                                            <div className="d-table-cell align-middle">
                                                                              <span style={{display: 'none'}}>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i className="fas fa-record-vinyl fa-2x" />
                                                                                    <span className="ml-2 d-inline-block postop_5up mr-2 fmaroon">
                                                                                      Start Recording
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                              <span style={{display: 'none'}}>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i className="far fa-stop-circle f_sz30" />
                                                                                    <span className="ml-2 d-inline-block postop_5up mr-2 fmaroon">
                                                                                      Stop Recording
                                                                                    </span>
                                                                                  </span>
                                                                                  <span className="f_sz16">
                                                                                    <span>
                                                                                      <i className="fas fa-spinner fa-spin f_sz24" />
                                                                                    </span>
                                                                                    <span className="ml-2 d-inline-block postop_3up">
                                                                                      0.08
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                              <span style={{display: 'block'}}>
                                                                                <span className="d-inline-block">
                                                                                  <span className="crsr_pntr">
                                                                                    <i className="far fa-play-circle fa-2x" />
                                                                                    <span className="ml-2 d-inline-block postop_5up">
                                                                                      1:08
                                                                                    </span>
                                                                                  </span>
                                                                                </span>
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                      <div className="card-footer bg-transparent text-center ">
                                                                        <a className="btn btn-black crsr_pntr btnpdng_sm mr-2">
                                                                          Save
                                                                        </a>
                                                                        <a className="btn btn-secondary crsr_pntr btnpdng_sm">
                                                                          Delete
                                                                        </a>
                                                                      </div>
                                                                    </div>
                                                                  </div> */}
                                                                  </div>
                                                                  <div
                                                                    className="nftvoicedesc"
                                                                    id="nftvoicemsg2"
                                                                    style={{ display: 'none' }}>
                                                                    <div className="all_contentflex_div">
                                                                      <div className="card w-100 mt-2 mb-4 shadow-none">
                                                                        <div className="card-header">
                                                                          <h5 className="fmaroon f_sz15">
                                                                            Upload Audio
                                                                          </h5>
                                                                        </div>
                                                                        <div className="card-body">
                                                                          <div className="w-100 d-flex flex-flow flex-row flex-wrap justify-content-center mt-3">
                                                                            <label className="btn-bs-file">
                                                                              <span className="btn btn-black btnpdng_sm crsr_pntr">
                                                                                Upload Audio
                                                                              </span>
                                                                              <input type="file" />
                                                                            </label>
                                                                          </div>
                                                                          <div className="uploaded_audiodiv text-center mt-3">
                                                                            <div className="d-flex align-items-center justify-content-center">
                                                                              <i className="fas fa-play-circle fa-4x mr-2 fblue" />
                                                                              <span className="font-weight-semibold">
                                                                                sample_audio.mp3
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="choosegif chupld" style={{ display: 'none' }}>
                                                              <div className="form-group row mt-3 mb-4 m-2">
                                                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                  <label className="col-form-label">Upload GIF</label>
                                                                  <div className="d-inline-block ml-4">
                                                                    <label className="btn-bs-file">
                                                                      <span className="btn btn-black btnpdng_sm crsr_pntr">
                                                                        Upload
                                                                      </span>
                                                                      <input
                                                                        type="file"
                                                                        name="DcfilNm"
                                                                        accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,image/*"
                                                                        onChange={(event) =>
                                                                          this.fileGetDetails_cmb_imagesnftgiff_mint(
                                                                            event,
                                                                          )
                                                                        }
                                                                        className="nft_img_uploads"
                                                                      />
                                                                    </label>
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  className="col-12 col-sm-12 col-md-12 col-lg-12"
                                                                  style={{ display: 'none' }}
                                                                  id="uploaded_image_giff_minted">
                                                                  <div className="nftimage_div mt-3">
                                                                    <img
                                                                      src="../dist/img/sample_painting1.jpg"
                                                                      id="uploaded_img_src_giff_minted"
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div>
                                                              {this.state.business_info_array?.business?.nft?.token_key
                                                                ?.length != 0
                                                                ? this.state.business_info_array?.business?.nft?.token_key?.map(
                                                                  (data, index) => (
                                                                    <div className="form-group row mt-3 mb-2 m-2">
                                                                      <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                                                                        <label className="col-form-label">
                                                                          {data.key}
                                                                        </label>
                                                                      </div>
                                                                      <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                                                                        <input
                                                                          type="text"
                                                                          className="form-control nftkeyvalues"
                                                                          data-key={data.key}
                                                                          data-required={data.required}
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  ),
                                                                )
                                                                : null}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <input
                                                          type="button"
                                                          name="next"
                                                          className="next action-button mt-4 nftapproved_next nft_next_btn"
                                                          defaultValue="Next"
                                                          style={{
                                                            display:
                                                              this.state.nft_details.status == 'approved'
                                                                ? 'inline-block'
                                                                : 'none',
                                                          }}
                                                          onClick={() => this.mintingNextStep(3)}
                                                        />
                                                        <input
                                                          style={{ display: 'none' }}
                                                          type="button"
                                                          name="next"
                                                          className="next action-button mt-4 nftapproved_next nft_next_btn_disabled isdisabled"
                                                          defaultValue="Next"
                                                        />
                                                      </fieldset>
                                                      <fieldset id="nftminted_step_2">
                                                        <div className="form-card">
                                                          <div className="row">
                                                            <div className="col-7">
                                                              <h2 className="fs-title">Confirm:</h2>
                                                            </div>
                                                            <div className="col-5">
                                                              <h2 className="steps">Step 2 - 2</h2>
                                                            </div>
                                                          </div>{' '}
                                                          <br />
                                                          <div>
                                                            <div className="form-group row mt-3 mb-4">
                                                              <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                <label className="col-form-label">NFT Name</label>
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                                <div className="pdngtop_10">{this.state.nft_name}</div>
                                                              </div>
                                                            </div>
                                                            <div className="form-group row mt-3 mb-4">
                                                              <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                <label className="col-form-label">Description</label>
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-8 col-lg-8">
                                                                <div className="pdngtop_10">
                                                                  {this.state.nft_decription}
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div
                                                              className="form-group row mt-3 mb-4 m-2"
                                                              style={{
                                                                display:
                                                                  this.state.nft_file_type !== 'image/gif'
                                                                    ? ''
                                                                    : 'none',
                                                              }}>
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label className="col-form-label">Image</label>
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <div className="nftimage_div mt-3">
                                                                  <img src={this.state.nft_file_url} />
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="mt-4">
                                                              {this.state.nft_keys?.length != 0
                                                                ? this.state.nft_keys?.map((data, index) => (
                                                                  <div className="form-group row mt-3 mb-2 m-2">
                                                                    <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                                                                      <label className="col-form-label">
                                                                        {data.key}
                                                                      </label>
                                                                    </div>
                                                                    <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                                                                      <div className="mt-2">{data.value}</div>
                                                                    </div>
                                                                  </div>
                                                                ))
                                                                : null}
                                                            </div>

                                                            {/* <div className="form-group row mt-3 mb-4 m-2">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <label className="col-form-label">Audio</label>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="uploaded_audiodiv text-center">
                                                                <div className="d-flex align-items-center">
                                                                  <i className="fas fa-play-circle fa-4x mr-2 fblue" />
                                                                  <span className="font-weight-semibold">
                                                                    sample_audio.mp3
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div> */}
                                                            <div
                                                              className="form-group row mt-3 mb-4 m-2"
                                                              style={{
                                                                display:
                                                                  this.state.nft_file_type === 'image/gif'
                                                                    ? ''
                                                                    : 'none',
                                                              }}>
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <label className="col-form-label">GIF</label>
                                                              </div>
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <div className="nftimage_div mt-3">
                                                                  <img src={this.state.nft_file_url} />
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div className="form-group row mt-5 mb-4 m-2">
                                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                                <div className="icheck-darkgrey d-inline-block py-1">
                                                                  <input type="checkbox" id="nftagree_minted" />
                                                                  <label htmlFor="nftagree_minted">
                                                                    I agree to the{' '}
                                                                    <a href="#" className="fmaroon">
                                                                      terms of service
                                                                    </a>
                                                                  </label>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <input
                                                          type="button"
                                                          name="previous"
                                                          className="previous action-button-previous"
                                                          defaultValue="Previous"
                                                          onClick={() => this.mintingNextStep(2)}
                                                        />
                                                        <input
                                                          type="button"
                                                          name="next"
                                                          className="action-button mt-4 nftconfirm_receipt_clk"
                                                          defaultValue="Confirm"
                                                          onClick={() => this.mintingNextStep(4)}
                                                        />
                                                        <input
                                                          style={{ display: 'none' }}
                                                          type="button"
                                                          name="next"
                                                          className="action-button mt-4 isdisabled nftconfirm_receipt_clk_diabled"
                                                          defaultValue="Confirm"
                                                        />
                                                      </fieldset>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="nftmintedlist_div"
                                    style={{
                                      display:
                                        this.state.nft_tokens?.length !== 0 || this.state.nft_total_count !== 0
                                          ? 'inline-block'
                                          : 'none',
                                    }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="card-header d-flex flex-row flex-wrap">
                                        <div className="col-6 col-sm-6 col-md-6 pl-0">
                                          <h5 className="fmaroon pt-2">NFT's</h5>
                                        </div>
                                        <div className="col-6 col-sm-6 col-md-6 pr-0 text-right">
                                          {this.state.business_info_array?.business?.nft?.token_count !=
                                            this.state.business_info_array?.business?.nft?.token_limit ? (
                                            <a
                                              className="btn btn-black crsr_pntr btn-sm mt-1 addnewnft_clk"
                                              onClick={() => this.mintingNextStep(2)}>
                                              Mint New
                                            </a>
                                          ) : null}
                                        </div>
                                      </div>
                                      <div className="card-body p-0 workflow_cardbdy">
                                        <div className="tabbable-responsive scrollbar_style1">
                                          <div className="tabbable">
                                            <ul
                                              className="nav nav-tabs border-bottom"
                                              id="custom-tabs-nftlist-tab1"
                                              role="tablist">
                                              <li className="nav-item nft_minted_li" data-name="Available">
                                                <a
                                                  className="nav-link active"
                                                  id="custom-tabs-nftavailable-tab"
                                                  data-toggle="pill"
                                                  href="#custom-tabs-nftavailable"
                                                  role="tab"
                                                  aria-controls="custom-tabs-nftavailable"
                                                  aria-selected="true">
                                                  <span className="d-inline-block">Available</span>
                                                </a>
                                              </li>
                                              <li className="nav-item nft_minted_li" data-name="Sent">
                                                <a
                                                  className="nav-link"
                                                  id="custom-tabs-nftinprocess-tab"
                                                  data-toggle="pill"
                                                  href="#custom-tabs-nftinprocess"
                                                  role="tab"
                                                  aria-controls="custom-tabs-nftinprocess"
                                                  aria-selected="false">
                                                  <span className="d-inline-block">Sent</span>
                                                </a>
                                              </li>
                                              <li className="nav-item nft_minted_li" data-name="Accepted">
                                                <a
                                                  className="nav-link"
                                                  id="custom-tabs-nftsent-tab"
                                                  data-toggle="pill"
                                                  href="#custom-tabs-nftsent"
                                                  role="tab"
                                                  aria-controls="custom-tabs-nftsent"
                                                  aria-selected="false">
                                                  <span className="d-inline-block">Accepted</span>
                                                </a>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        <div className="tab-content" id="custom-tabs-nftlist-tabContent1">
                                          <div
                                            className="tab-pane fade active show"
                                            id="custom-tabs-nftavailable"
                                            role="tabpanel"
                                            aria-labelledby="custom-tabs-nftavailable-tab">
                                            <div className="all_contentflex_div">
                                              <div className="card w-100 p-0 shadow-none mb-0">
                                                <div className="card-header py-0 border-bottom-0" id="minted_search">
                                                  <div className="all_contentcntr_300">
                                                    <div className="input-group bx_shadow_smlight brdr_radius_mrdiv mt-3 mb-3">
                                                      <div className="input-group-prepend">
                                                        <span className="input-group-text search_inptgrptxt search_ctsinptgrptxt">
                                                          <button className="btn btn-sm" type="submit">
                                                            <i className="fas fa-search" />
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <input
                                                        type="text"
                                                        className="form-control search_frmcntrl3 bgclr1 minted_nft_search nft_minted_search"
                                                        placeholder="Search NFT"
                                                        data-type="minted"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="card-body p-0">
                                                  <div className="nftgallery_boxes all_contentflex_div pt-1 pb-3 justify-content-center availble_nft_tokens">
                                                    {this.state?.nft_minted_tokens_lists.length !== 0 ? (
                                                      this.state?.nft_minted_tokens_lists?.map(
                                                        (nft_tokens_details, index) => {
                                                          if (nft_tokens_details?.status === 'minted') {
                                                            return (
                                                              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3" key={index}>
                                                                <div
                                                                  className={
                                                                    index % 2
                                                                      ? 'card bx_shadow_sm brdrtop_green1'
                                                                      : 'card bx_shadow_sm brdrtop_orange'
                                                                  }>
                                                                  <div className="card-header border-bottom-0 position-relative">
                                                                    <div className="card-title w-100 text-center position-relative">
                                                                      <div className="postop_abs15uprgt f_sz12 flightgrey">
                                                                        Token #: {nft_tokens_details?.token_id}
                                                                      </div>
                                                                      <h3 className="f_sz15 mb-2 pb-1">
                                                                        {nft_tokens_details?.nft_name}
                                                                      </h3>
                                                                      <div>
                                                                        <span className="flightgrey f_sz13">
                                                                          {moment(
                                                                            nft_tokens_details?.created_date,
                                                                          ).format('MMM DD, YYYY, h:mm a')}
                                                                        </span>{' '}
                                                                        {/* <span
                                                                          className="badge badge-active"
                                                                          style={{textTransform: 'capitalize'}}>
                                                                          {nft_tokens_details?.status}
                                                                        </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="card-body fgrey pt-0 pb-1 text-center">
                                                                    <div className="nftpreviewimage_div">
                                                                      {/* <img src={nft_tokens_details?.thumbnail_file_url.length !=0 ? nft_tokens_details?.thumbnail_file_url :nft_tokens_details?.file_url} /> */}
                                                                      <img
                                                                        src={nft_tokens_details?.thumbnail_file_url || nft_tokens_details?.file_url}
                                                                        alt="NFT Preview"
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div className="card-footer text-center bg-transparent">
                                                                    <div className="tbl_actionbtns text-center">
                                                                      <a
                                                                        onClick={() =>
                                                                          this.nftFunctionalities(
                                                                            nft_tokens_details,
                                                                            'view_receipt',
                                                                          )
                                                                        }>
                                                                        {/* //  className="nftavailable_receiptview_clk"
                                                                        // data-id={nft_tokens_details?._id}
                                                                        // data-type={nft_tokens_details?.status}> */}
                                                                        <i
                                                                          className="far fa-eye fmaroon crsr_pntr"
                                                                          data-toggle="tooltip"
                                                                          data-placement="bottom"
                                                                          title="View"
                                                                        // data-original-title="View"
                                                                        />
                                                                      </a>
                                                                      {this.state.business_info_array?.business?.nft
                                                                        ?.token_count !==
                                                                        this.state.business_info_array?.business?.nft
                                                                          ?.token_limitn && (
                                                                          <a
                                                                            onClick={() =>
                                                                              this.nftFunctionalities(
                                                                                nft_tokens_details,
                                                                                'copy',
                                                                              )
                                                                            }>
                                                                            {/* //  className="nftavailable_copy_clk"
                                                                          data-id={nft_tokens_details?.token_hash}
                                                                          data-nft_name={nft_tokens_details?.nft_name}
                                                                          data-nft_description={
                                                                            nft_tokens_details?.nft_description
                                                                          }
                                                                          data-file_url={nft_tokens_details?.file_url}
                                                                          data-file_name={nft_tokens_details?.file_name}
                                                                          data-upload_type={
                                                                            nft_tokens_details?.upload_type
                                                                          }> */}
                                                                            <i
                                                                              className="far fa-copy fmaroon crsr_pntr"
                                                                              data-toggle="tooltip"
                                                                              data-placement="bottom"
                                                                              title="Copy"
                                                                            />
                                                                          </a>
                                                                        )}
                                                                      <a
                                                                        onClick={() =>
                                                                          this.nftFunctionalities(
                                                                            nft_tokens_details,
                                                                            'delete',
                                                                          )
                                                                        }>
                                                                        {/* // className="revert_nft"
                                                                        data-type="delete"
                                                                        data-id={nft_tokens_details?._id}
                                                                        data-cid={nft_tokens_details?.sent_to}> */}
                                                                        <i
                                                                          className="far fa-trash-alt"
                                                                          data-toggle="tooltip"
                                                                          data-placement="bottom"
                                                                          title="Delete"
                                                                        />
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            );
                                                          }
                                                        },
                                                      )
                                                    ) : (
                                                      <>
                                                        <div
                                                          style={{
                                                            display: this.state.nft_load_more ? 'inline-block' : 'none',
                                                          }}
                                                          className="mt-3 w-100 text-center">
                                                          <i className="fas fa-spinner fa-pulse fa-2x fmaroon" />
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: !this.state.nft_load_more
                                                              ? 'inline-block'
                                                              : 'none',
                                                          }}
                                                          className="text-center pt-5 pb-3">
                                                          No NFTs to show
                                                        </div>
                                                      </>
                                                    )}
                                                    {this.state?.nft_minted_tokens_lists.length !== 0 &&
                                                      this.state.nft_available_load_more && (
                                                        <div className="mt-3 w-100 text-center nft_minted_tokens_lists_load_more">
                                                          <a
                                                            href="javascript:void(0)"
                                                            onClick={
                                                              !this.state.nft_load_more
                                                                ? () => this.LoadMoreNft('available')
                                                                : ''
                                                            }
                                                            className="btn btn-black btn-sm1 crsr_pntr f_sz16">
                                                            <span className="d-none d-md-inline-block">
                                                              {!this.state.nft_load_more
                                                                ? 'Load More'
                                                                : 'Processing...'}
                                                            </span>
                                                          </a>
                                                        </div>

                                                      )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="custom-tabs-nftinprocess"
                                            role="tabpanel"
                                            aria-labelledby="custom-tabs-nftinprocess-tab">
                                            <div className="all_contentflex_div">
                                              <div className="card w-100 p-0 shadow-none mb-0">
                                                <div className="card-header py-0 border-bottom-0" id="sent_search">
                                                  <div className="all_contentcntr_300">
                                                    <div className="input-group bx_shadow_smlight brdr_radius_mrdiv mt-3 mb-3">
                                                      <div className="input-group-prepend">
                                                        <span className="input-group-text search_inptgrptxt search_ctsinptgrptxt">
                                                          <button className="btn btn-sm" type="submit">
                                                            <i className="fas fa-search" />
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <input
                                                        type="text"
                                                        className="form-control search_frmcntrl3 bgclr1 minted_nft_search nft_sent_search"
                                                        placeholder="Search NFT"
                                                        data-type="sent"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="card-body p-0">
                                                  <div className="nftgallery_boxes all_contentflex_div pt-1 pb-3 justify-content-center sent_nft_tokens">
                                                    {this.state?.nft_sent_tokens_lists.length !== 0 ? (
                                                      this.state?.nft_sent_tokens_lists?.map(
                                                        (nft_tokens_details, index) => {
                                                          if (nft_tokens_details?.status === 'sent') {
                                                            return (
                                                              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                                <div
                                                                  className={
                                                                    index % 2
                                                                      ? 'card bx_shadow_sm brdrtop_green1'
                                                                      : 'card bx_shadow_sm brdrtop_orange'
                                                                  }>
                                                                  <div className="card-header border-bottom-0 position-relative">
                                                                    <div className="card-title w-100 text-center position-relative">
                                                                      <div className="postop_abs15uprgt f_sz12 flightgrey">
                                                                        Token #: {nft_tokens_details?.token_id}
                                                                      </div>
                                                                      <h3 className="f_sz15 mb-2 pb-1">
                                                                        {nft_tokens_details?.nft_name}
                                                                      </h3>
                                                                      <div>
                                                                        <span className="flightgrey f_sz13">
                                                                          {moment(
                                                                            nft_tokens_details?.updated_date,
                                                                          ).format('MMM DD, YYYY, h:mm a')}
                                                                        </span>{' '}
                                                                        {/* <span
                                                                          className="badge badge-active"
                                                                          style={{textTransform: 'capitalize'}}>
                                                                          {nft_tokens_details?.status}
                                                                        </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="card-body fgrey pt-0 pb-1 text-center">
                                                                    <div className="nftpreviewimage_div">
                                                                      <img src={nft_tokens_details?.file_url} />
                                                                    </div>
                                                                  </div>
                                                                  <div className="card-footer text-center bg-transparent">
                                                                    <div className="tbl_actionbtns text-center">
                                                                      <a
                                                                        onClick={() =>
                                                                          this.nftFunctionalities(
                                                                            nft_tokens_details,
                                                                            'view_receipt',
                                                                          )
                                                                        }
                                                                        // className="nftavailable_receiptview_clk"
                                                                        data-id={nft_tokens_details?._id}
                                                                        data-type={nft_tokens_details?.status}>
                                                                        <i
                                                                          className="far fa-eye fmaroon crsr_pntr"
                                                                          data-toggle="tooltip"
                                                                          data-placement="bottom"
                                                                          title
                                                                          data-original-title="View"
                                                                        />
                                                                      </a>
                                                                      <a
                                                                        onClick={() =>
                                                                          this.nftFunctionalities(
                                                                            nft_tokens_details,
                                                                            'revert',
                                                                          )
                                                                        }
                                                                        // className="revert_nft"
                                                                        data-type="revert"
                                                                        data-id={nft_tokens_details?._id}
                                                                        data-cid={nft_tokens_details?.sent_to}>
                                                                        <i
                                                                          className="fas fa-share fa-flip-horizontal fmaroon crsr_pntr"
                                                                          data-toggle="tooltip"
                                                                          data-placement="bottom"
                                                                          title
                                                                          data-original-title="Revert"
                                                                        />
                                                                      </a>
                                                                      <a
                                                                        onClick={() =>
                                                                          this.nftFunctionalities(
                                                                            nft_tokens_details,
                                                                            'delete',
                                                                          )
                                                                        }
                                                                        // className="revert_nft"
                                                                        data-type="delete"
                                                                        data-id={nft_tokens_details?._id}
                                                                        data-cid={nft_tokens_details?.sent_to}>
                                                                        <i
                                                                          className="far fa-trash-alt"
                                                                          data-toggle="tooltip"
                                                                          data-placement="bottom"
                                                                          title
                                                                          data-original-title="Delete"
                                                                        />
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            );
                                                          }
                                                        },
                                                      )
                                                    ) : (
                                                      <>
                                                        <div
                                                          style={{
                                                            display: this.state.nft_load_more ? 'inline-block' : 'none',
                                                          }}
                                                          className="mt-3 w-100 text-center">
                                                          <i className="fas fa-spinner fa-pulse fa-2x fmaroon" />
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: !this.state.nft_load_more
                                                              ? 'inline-block'
                                                              : 'none',
                                                          }}
                                                          className="text-center pt-5 pb-3">
                                                          No NFTs to show
                                                        </div>
                                                      </>
                                                    )}
                                                    {this.state?.nft_sent_tokens_lists.length !== 0 &&
                                                      this.state?.nft_sent_load_more ? (
                                                      <>
                                                        <div className="mt-3 w-100 text-center">
                                                          <a
                                                            href="javascript:void(0)"
                                                            onClick={
                                                              !this.state.nft_load_more
                                                                ? () => this.LoadMoreNft('sent')
                                                                : ''
                                                            }
                                                            className="btn btn-black btn-sm1 crsr_pntr f_sz16">
                                                            <span className="d-none d-md-inline-block">
                                                              {!this.state.nft_load_more
                                                                ? 'Load More'
                                                                : 'Processing...'}
                                                            </span>
                                                          </a>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      ' '
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="tab-pane fade"
                                            id="custom-tabs-nftsent"
                                            role="tabpanel"
                                            aria-labelledby="custom-tabs-nftsent-tab">
                                            <div className="all_contentflex_div">
                                              <div className="card w-100 p-0 shadow-none mb-0">
                                                <div className="card-header py-0 border-bottom-0" id="accept_search">
                                                  <div className="all_contentcntr_300">
                                                    <div className="input-group bx_shadow_smlight brdr_radius_mrdiv mt-3 mb-3">
                                                      <div className="input-group-prepend">
                                                        <span className="input-group-text search_inptgrptxt search_ctsinptgrptxt">
                                                          <button className="btn btn-sm" type="submit">
                                                            <i className="fas fa-search" />
                                                          </button>
                                                        </span>
                                                      </div>
                                                      <input
                                                        type="text"
                                                        className="form-control search_frmcntrl3 bgclr1 minted_nft_search nft_accept_search"
                                                        placeholder="Search NFT"
                                                        data-type="accepted"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="card-body p-0">
                                                  <div className="nftgallery_boxes all_contentflex_div pt-1 pb-3 justify-content-center accept_nft_tokens">
                                                    {this.state?.nft_accept_tokens_lists.length !== 0 ? (
                                                      this.state?.nft_accept_tokens_lists?.map(
                                                        (nft_tokens_details, index) => {
                                                          if (nft_tokens_details?.status === 'accepted') {
                                                            return (
                                                              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                                <div
                                                                  className={
                                                                    index % 2
                                                                      ? 'card bx_shadow_sm brdrtop_green1'
                                                                      : 'card bx_shadow_sm brdrtop_orange'
                                                                  }>
                                                                  <div className="card-header border-bottom-0 position-relative">
                                                                    <div className="card-title w-100 text-center position-relative">
                                                                      <div className="postop_abs15uprgt f_sz12 flightgrey">
                                                                        Token #: {nft_tokens_details?.token_id}
                                                                      </div>
                                                                      <h3
                                                                        className="f_sz15 mb-2 pb-1"
                                                                      // data-for={'toolTip2' + index}
                                                                      // data-place="bottom"
                                                                      // data-tip={
                                                                      //   'Description: ' +
                                                                      //   nft_tokens_details?.nft_description
                                                                      // }
                                                                      >
                                                                        {nft_tokens_details?.nft_name}
                                                                      </h3>
                                                                      {/* <ReactTooltip id={'toolTip2' + index} /> */}
                                                                      <div>
                                                                        <span className="flightgrey f_sz13">
                                                                          {moment(
                                                                            nft_tokens_details?.updated_date,
                                                                          ).format('MMM DD, YYYY, h:mm a')}
                                                                        </span>{' '}
                                                                        {/* <span
                                                                          className="badge badge-active"
                                                                          style={{textTransform: 'capitalize'}}>
                                                                          {nft_tokens_details?.status}
                                                                        </span> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="card-body fgrey pt-0 pb-1 text-center">
                                                                    <div className="nftpreviewimage_div">
                                                                      <img src={nft_tokens_details?.file_url} />
                                                                    </div>
                                                                  </div>
                                                                  <div className="card-footer text-center bg-transparent">
                                                                    <div className="tbl_actionbtns text-center">
                                                                      <a
                                                                        onClick={() =>
                                                                          this.nftFunctionalities(
                                                                            nft_tokens_details,
                                                                            'view_receipt',
                                                                          )
                                                                        }
                                                                        // className="nftavailable_receiptview_clk"
                                                                        data-id={nft_tokens_details?._id}
                                                                        data-type={nft_tokens_details?.status}>
                                                                        <i
                                                                          className="far fa-eye fmaroon crsr_pntr"
                                                                          data-toggle="tooltip"
                                                                          data-placement="bottom"
                                                                          title
                                                                          data-original-title="View"
                                                                        />
                                                                      </a>
                                                                      {this.state.business_info_array?.business?.nft
                                                                        ?.token_count !=
                                                                        this.state.business_info_array?.business?.nft
                                                                          ?.token_limit ? (
                                                                        <a
                                                                          onClick={() =>
                                                                            this.nftFunctionalities(
                                                                              nft_tokens_details,
                                                                              'copy',
                                                                            )
                                                                          }
                                                                          //  className="nftavailable_copy_clk"
                                                                          data-id={nft_tokens_details?.token_hash}
                                                                          data-nft_name={nft_tokens_details?.nft_name}
                                                                          data-nft_description={
                                                                            nft_tokens_details?.nft_description
                                                                          }
                                                                          data-file_url={nft_tokens_details?.file_url}
                                                                          data-file_name={nft_tokens_details?.file_name}
                                                                          data-upload_type={
                                                                            nft_tokens_details?.upload_type
                                                                          }>
                                                                          <i
                                                                            className="far fa-copy fmaroon crsr_pntr"
                                                                            data-toggle="tooltip"
                                                                            data-placement="bottom"
                                                                            title
                                                                            data-original-title="Copy"
                                                                          />
                                                                        </a>
                                                                      ) : null}
                                                                      <a
                                                                        onClick={() =>
                                                                          this.nftFunctionalities(
                                                                            nft_tokens_details,
                                                                            'delete',
                                                                          )
                                                                        }
                                                                        // className="revert_nft"
                                                                        data-type="delete"
                                                                        data-id={nft_tokens_details?._id}
                                                                        data-cid={nft_tokens_details?.sent_to}>
                                                                        <i
                                                                          className="far fa-trash-alt"
                                                                          data-toggle="tooltip"
                                                                          data-placement="bottom"
                                                                          title
                                                                          data-original-title="Delete"
                                                                        />
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            );
                                                          }
                                                        },
                                                      )
                                                    ) : (
                                                      <>
                                                        <div
                                                          style={{
                                                            display: this.state.nft_load_more ? 'inline-block' : 'none',
                                                          }}
                                                          className="mt-3 w-100 text-center">
                                                          <i className="fas fa-spinner fa-pulse fa-2x fmaroon" />
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: !this.state.nft_load_more
                                                              ? 'inline-block'
                                                              : 'none',
                                                          }}
                                                          className="text-center pt-5 pb-3">
                                                          No NFTs to show
                                                        </div>
                                                      </>
                                                    )}
                                                    {this.state?.nft_accept_tokens_lists.length !== 0 &&
                                                      this.state?.nft_accept_load_more ? (
                                                      <>
                                                        <div className="mt-3 w-100 text-center">
                                                          <a
                                                            href="javascript:void(0)"
                                                            onClick={
                                                              !this.state.nft_load_more
                                                                ? () => this.LoadMoreNft('accept')
                                                                : ''
                                                            }
                                                            className="btn btn-black btn-sm1 crsr_pntr f_sz16">
                                                            <span className="d-none d-md-inline-block">
                                                              {!this.state.nft_load_more
                                                                ? 'Load More'
                                                                : 'Processing...'}
                                                            </span>
                                                          </a>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      ' '
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="receiptnft_div" style={{ display: 'none' }}>
                                    <div className="card w-100 bx_shadow_sm">
                                      <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                        <h5>
                                          <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">
                                            Receipt{' '}
                                            {/* <a
                                              data-toggle="modal"
                                              data-target="#modal_nftreceipt_viewlog"
                                              data-backdrop="static"
                                              data-dismiss="modal">
                                              <i className="fas fa-history ml-3 fmaroon crsr_pntr" />
                                            </a> */}
                                          </span>
                                          <span
                                            className="receiptnft_close mr-2 mt-1"
                                            data-name={
                                              this.state.nft_token?.status === 'minted'
                                                ? 'available'
                                                : this.state.nft_token?.status
                                            }
                                            onClick={() =>
                                              this.closeReceipt(
                                                this.state.nft_token?.status === 'minted'
                                                  ? 'available'
                                                  : this.state.nft_token?.status,
                                              )
                                            }>
                                            <i className="fas fa-times" />
                                          </span>
                                        </h5>
                                      </div>
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body px-0 pb-3">
                                          <div>
                                            <div className="form-group mb-4 mx-1">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Owner:</label>
                                                <div
                                                  className="ml-3 d-inline-block"
                                                  style={{ textTransform: 'capitalize' }}>
                                                  {typeof this.state.nft_token?.user_id?.first_name !== 'undefined' &&
                                                    this.state.nft_token?.user_id?.first_name != null &&
                                                    this.state.nft_token?.user_id?.first_name?.length !== 0
                                                    ? this.state.nft_token?.user_id?.first_name +
                                                    ' ' +
                                                    this.state.nft_token?.user_id?.last_name
                                                    : this.state.nft_token?.user_id?.email_address}
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="form-group mb-4 mx-1">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">State:</label>
                                                <div
                                                  className="ml-3 d-inline-block fgreen4 font-weight-semibold"
                                                  style={{ textTransform: 'capitalize' }}>
                                                  {this.state.nft_token?.status}
                                                </div>
                                              </div>
                                            </div> */}
                                            {/* <div className="form-group mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">QR Code</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftqrcode_img">
                                                  <QRCode
                                                    //id="qrcode"
                                                    value={
                                                      APP_ENDPOINT +
                                                      '/Nft_Receipt?qrcode=true&trans_id=' +
                                                      this.state.nft_token?.token_hash +
                                                      '&user_id=' +
                                                      this.state.user_id +
                                                      '&business_id=' +
                                                      this.state.business_id
                                                    }
                                                    size={200}
                                                    level={'L'}
                                                    includeMargin={false}
                                                  />
                                                </div>
                                              </div>
                                            </div> */}
                                            {/* <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">IPFS</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <a
                                                  target="_blank"
                                                  href={'https://ipfs.io/ipfs/' + this.state.nft_token?.ipfs}
                                                  className="fmaroon">
                                                  {this.state.nft_token?.ipfs}
                                                </a>
                                              </div>
                                            </div> */}
                                            <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Description</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                {this.state.nft_token?.nft_description}
                                              </div>
                                            </div>
                                            <div
                                              className="form-group mt-3 mb-4"
                                              style={{
                                                display:
                                                  this.state.nft_token?.upload_type !== 'image/gif' ? '' : 'none',
                                              }}>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Image</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftimage_div">
                                                  <img src={this.state.nft_token?.file_url} />
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="form-group row mt-3 mb-4 m-2">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Audio</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="uploaded_audiodiv text-center">
                                                  <div className="d-flex align-items-center">
                                                    <i className="fas fa-play-circle fa-4x mr-2 fblue" />
                                                    <span className="font-weight-semibold">sample_audio.mp3</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                            <div
                                              className="form-group row mt-3 mb-4 m-2"
                                              style={{
                                                display:
                                                  this.state.nft_token?.upload_type === 'image/gif' ? '' : 'none',
                                              }}>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">GIF</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftimage_div mt-3">
                                                  <img src={this.state.nft_token?.file_url} />
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 receipt_div mt-4 p-0">
                                              <div className="w-100 d-table">
                                                <div className="d-tablerow">
                                                  <div className="d-tablecell">
                                                    <div className="receipt_photo" align="center">
                                                      <img src="../dist/img/sample_painting1.jpg" border={0} />
                                                    </div>
                                                  </div>
                                                  <div className="d-tablecell">
                                                    <div className="receipt_nftlogo" align="center">
                                                      <img src="../dist/img/nft_icon.png" border={0} />
                                                    </div>
                                                  </div>
                                                  <div className="d-tablecell">
                                                    <div className="receipt_ethereumlogo" align="center">
                                                      <img src="../dist/img/ethereum_logo.png" border={0} />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                            <div className="mt-4">
                                              {this.state.nft_token?.token_key?.length != 0
                                                ? this.state.nft_token?.token_key?.map((data, index) => (
                                                  <div className="form-group row mt-3 mb-2 m-2">
                                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                                      <label className="col-form-label">{data.key}</label>
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                      <div className="mt-2">{data.value}</div>
                                                    </div>
                                                  </div>
                                                ))
                                                : null}
                                            </div>

                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                              {/* <div className="mt-4 mb-1">
                                                Your art is available as NFT as of{' '}
                                                {moment(this.state.nft_token?.created_date).format(
                                                  'MMM DD,YYYY, h:mm a',
                                                )}
                                              </div> */}
                                              {/* <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Wallet Address:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/address/' +
                                                    this.state.nft_token?.original_wallet_address
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.original_wallet_address}
                                                </a>
                                              </div> */}
                                              {/* <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Transaction Hash:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/transaction/' +
                                                    this.state.nft_token?.token_hash +
                                                    '?project=redtie_live'
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.token_hash}
                                                </a>
                                              </div> */}
                                              {/* <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Token Transfer Hash:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/transaction/' +
                                                    this.state.nft_token?.token_transfer_hash +
                                                    '?project=redtie_live'
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.token_transfer_hash}
                                                </a>
                                              </div> */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sentreceiptnft_div" style={{ display: 'none' }}>
                                    <div className="card w-100 bx_shadow_sm">
                                      <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                        <h5>
                                          <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">Receipt </span>
                                          <span
                                            className="sentreceiptnft_close mr-2 mt-1"
                                            onClick={() =>
                                              this.closeReceipt(
                                                this.state.nft_token?.status === 'minted'
                                                  ? 'available'
                                                  : this.state.nft_token?.status,
                                              )
                                            }>
                                            <i className="fas fa-times" />
                                          </span>
                                        </h5>
                                      </div>
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body px-0 pb-3">
                                          <div>
                                            <div className="form-group mb-4 mx-1">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Owner:</label>
                                                <div
                                                  className="ml-3 d-inline-block"
                                                  style={{ textTransform: 'capitalize' }}>
                                                  {typeof this.state.nft_token?.user_id?.first_name !== 'undefined' &&
                                                    this.state.nft_token?.user_id?.first_name != null &&
                                                    this.state.nft_token?.user_id?.first_name?.length !== 0
                                                    ? this.state.nft_token?.user_id?.first_name +
                                                    ' ' +
                                                    this.state.nft_token?.user_id?.last_name
                                                    : this.state.nft_token?.user_id?.email_address}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="form-group mb-4 mx-1">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">State:</label>
                                                <div
                                                  className="ml-3 d-inline-block fgreen4 font-weight-semibold"
                                                  style={{ textTransform: 'capitalize' }}>
                                                  {this.state.nft_token?.status}
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="form-group mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">QR Code</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftqrcode_img">
                                                  <QRCode
                                                    //id="qrcode"
                                                    value={
                                                      APP_ENDPOINT +
                                                      '/Nft_Receipt?qrcode=true&trans_id=' +
                                                      this.state.nft_token?.token_hash +
                                                      '&user_id=' +
                                                      this.state.user_id +
                                                      '&business_id=' +
                                                      this.state.business_id
                                                    }
                                                    size={200}
                                                    level={'L'}
                                                    includeMargin={false}
                                                  />
                                                </div>
                                              </div>
                                            </div> */}
                                            {/* <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">IPFS</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <a
                                                  target="_blank"
                                                  href={'https://ipfs.io/ipfs/' + this.state.nft_token?.ipfs}
                                                  className="fmaroon">
                                                  {this.state.nft_token?.ipfs}
                                                </a>
                                              </div>
                                            </div> */}
                                            <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Description</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                {this.state.nft_token?.nft_description}
                                              </div>
                                            </div>
                                            <div
                                              className="form-group mt-3 mb-4"
                                              style={{
                                                display:
                                                  this.state.nft_token?.upload_type !== 'image/gif' ? '' : 'none',
                                              }}>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Image</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftimage_div">
                                                  <img src={this.state.nft_token?.file_url} />
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="form-group row mt-3 mb-4 m-2">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Audio</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="uploaded_audiodiv text-center">
                                                  <div className="d-flex align-items-center">
                                                    <i className="fas fa-play-circle fa-4x mr-2 fblue" />
                                                    <span className="font-weight-semibold">sample_audio.mp3</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                            <div
                                              className="form-group row mt-3 mb-4 m-2"
                                              style={{
                                                display:
                                                  this.state.nft_token?.upload_type === 'image/gif' ? '' : 'none',
                                              }}>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">GIF</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftimage_div mt-3">
                                                  <img src={this.state.nft_token?.file_url} />
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 receipt_div mt-4 p-0">
                                              <div className="w-100 d-table">
                                                <div className="d-tablerow">
                                                  <div className="d-tablecell">
                                                    <div className="receipt_photo" align="center">
                                                      <img src="../dist/img/sample_painting1.jpg" border={0} />
                                                    </div>
                                                  </div>
                                                  <div className="d-tablecell">
                                                    <div className="receipt_nftlogo" align="center">
                                                      <img src="../dist/img/nft_icon.png" border={0} />
                                                    </div>
                                                  </div>
                                                  <div className="d-tablecell">
                                                    <div className="receipt_ethereumlogo" align="center">
                                                      <img src="../dist/img/ethereum_logo.png" border={0} />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                            {/* <div className="mt-4">
                                              {this.state.nft_token?.token_key?.length != 0
                                                ? this.state.nft_token?.token_key?.map((data, index) => (
                                                  <div className="form-group row mt-3 mb-2 m-2">
                                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                                      <label className="col-form-label">{data.key}</label>
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                      <div className="mt-2">{data.value}</div>
                                                    </div>
                                                  </div>
                                                ))
                                                : null}
                                            </div> */}
                                            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                              <div className="mt-4 mb-1">
                                                Your art is available as NFT as of{' '}
                                                {moment(this.state.nft_token?.created_date).format(
                                                  'MMM DD,YYYY, h:mm a',
                                                )}
                                              </div>
                                              <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Wallet Address:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/address/' +
                                                    this.state.nft_token?.original_wallet_address
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.original_wallet_address}
                                                </a>
                                              </div>
                                              <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Transaction Hash:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/transaction/' +
                                                    this.state.nft_token?.token_hash +
                                                    '?project=redtie_live'
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.token_hash}
                                                </a>
                                              </div>
                                              <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Token Transfer Hash:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/transaction/' +
                                                    this.state.nft_token?.token_transfer_hash +
                                                    '?project=redtie_live'
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.token_transfer_hash}
                                                </a>
                                              </div>
                                            </div> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="inprocessreceiptnft_div" style={{ display: 'none' }}>
                                    <div className="card w-100 bx_shadow_sm">
                                      <div className="card-header d-flex flex-row flex-wrap pb-0 pt-3">
                                        <h5>
                                          <span className="fmaroon mr-3 d-block d-sm-inline-block mb-2">Receipt </span>
                                          <span
                                            className="inprocessreceiptnft_close mr-2 mt-1"
                                            onClick={() =>
                                              this.closeReceipt(
                                                this.state.nft_token?.status === 'minted'
                                                  ? 'available'
                                                  : this.state.nft_token?.status,
                                              )
                                            }>
                                            <i className="fas fa-times" />
                                          </span>
                                        </h5>
                                      </div>
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body px-0 pb-3">
                                          <div>
                                            <div className="form-group mb-4 mx-1">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Owner:</label>
                                                <div
                                                  className="ml-3 d-inline-block"
                                                  style={{ textTransform: 'capitalize' }}>
                                                  {typeof this.state.nft_token?.user_id?.first_name !== 'undefined' &&
                                                    this.state.nft_token?.user_id?.first_name != null &&
                                                    this.state.nft_token?.user_id?.first_name?.length !== 0
                                                    ? this.state.nft_token?.user_id?.first_name +
                                                    ' ' +
                                                    this.state.nft_token?.user_id?.last_name
                                                    : this.state.nft_token?.user_id?.email_address}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="form-group mb-4 mx-1">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">State:</label>
                                                <div
                                                  className="ml-3 d-inline-block fgreen4 font-weight-semibold"
                                                  style={{ textTransform: 'capitalize' }}>
                                                  {this.state.nft_token?.status}
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="form-group mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">QR Code</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftqrcode_img">
                                                  <QRCode
                                                    //id="qrcode"
                                                    value={
                                                      APP_ENDPOINT +
                                                      '/Nft_Receipt?qrcode=true&trans_id=' +
                                                      this.state.nft_token?.token_hash +
                                                      '&user_id=' +
                                                      this.state.user_id +
                                                      '&business_id=' +
                                                      this.state.business_id
                                                    }
                                                    size={200}
                                                    level={'L'}
                                                    includeMargin={false}
                                                  />
                                                </div>
                                              </div>
                                            </div> */}
                                            {/* <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">IPFS</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <a
                                                  target="_blank"
                                                  href={'https://ipfs.io/ipfs/' + this.state.nft_token?.ipfs}
                                                  className="fmaroon">
                                                  {this.state.nft_token?.ipfs}
                                                </a>
                                              </div>
                                            </div> */}
                                            <div className="form-group mt-3 mb-4">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Description</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                {this.state.nft_token?.nft_description}
                                              </div>
                                            </div>
                                            <div
                                              className="form-group mt-3 mb-4"
                                              style={{
                                                display:
                                                  this.state.nft_token?.upload_type !== 'image/gif' ? '' : 'none',
                                              }}>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Image</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftimage_div">
                                                  <img src={this.state.nft_token?.file_url} />
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="form-group row mt-3 mb-4 m-2">
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">Audio</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="uploaded_audiodiv text-center">
                                                  <div className="d-flex align-items-center">
                                                    <i className="fas fa-play-circle fa-4x mr-2 fblue" />
                                                    <span className="font-weight-semibold">sample_audio.mp3</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                            <div
                                              className="form-group row mt-3 mb-4 m-2"
                                              style={{
                                                display:
                                                  this.state.nft_token?.upload_type === 'image/gif' ? '' : 'none',
                                              }}>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <label className="col-form-label">GIF</label>
                                              </div>
                                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="nftimage_div mt-3">
                                                  <img src={this.state.nft_token?.file_url} />
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 receipt_div mt-4 p-0">
                                              <div className="w-100 d-table">
                                                <div className="d-tablerow">
                                                  <div className="d-tablecell">
                                                    <div className="receipt_photo" align="center">
                                                      <img src="../dist/img/sample_painting1.jpg" border={0} />
                                                    </div>
                                                  </div>
                                                  <div className="d-tablecell">
                                                    <div className="receipt_nftlogo" align="center">
                                                      <img src="../dist/img/nft_icon.png" border={0} />
                                                    </div>
                                                  </div>
                                                  <div className="d-tablecell">
                                                    <div className="receipt_ethereumlogo" align="center">
                                                      <img src="../dist/img/ethereum_logo.png" border={0} />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                            {/* <div className="mt-4">
                                              {this.state.nft_token?.token_key?.length != 0
                                                ? this.state.nft_token?.token_key?.map((data, index) => (
                                                  <div className="form-group row mt-3 mb-2 m-2">
                                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                                      <label className="col-form-label">{data.key}</label>
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                      <div className="mt-2">{data.value}</div>
                                                    </div>
                                                  </div>
                                                ))
                                                : null}
                                            </div> */}
                                            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                              <div className="mt-4 mb-1">
                                                Your art is available as NFT as of{' '}
                                                {moment(this.state.nft_token?.created_date).format(
                                                  'MMM DD,YYYY, h:mm a',
                                                )}
                                              </div>
                                              <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Wallet Address:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/address/' +
                                                    this.state.nft_token?.to_wallet_address
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.to_wallet_address}
                                                </a>
                                              </div>
                                              <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Transaction Hash:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/transaction/' +
                                                    this.state.nft_token?.token_hash +
                                                    '?project=redtie_live'
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.token_hash}
                                                </a>
                                              </div>
                                              <div className="mt-3 mb-1">
                                                <span className="font-weight-bold">Token Transfer Hash:</span>{' '}
                                                <a
                                                  target="_blank"
                                                  href={
                                                    'http://blezar.ephrontech.com/transaction/' +
                                                    this.state.nft_token?.token_transfer_hash +
                                                    '?project=redtie_live'
                                                  }
                                                  className="fmaroon">
                                                  {this.state.nft_token?.token_transfer_hash}
                                                </a>
                                              </div>
                                            </div> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="tab-pane fade nav_links_prof_tabs"
                              id="custom-tabs-ft"
                              role="tabpanel"
                              aria-labelledby="custom-tabs-ft-tab">
                              <div className="all_contentflex_div">
                                <div className="card w-100 bx_shadow_sm">
                                  <div
                                    className="ftcreate_div"
                                    style={{
                                      display:
                                        this.state.business_info_array?.business?.fungible_token?.token_available ===
                                          this.state.business_info_array?.business?.fungible_token?.token_limit
                                          ? 'inline-block'
                                          : 'none',
                                    }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="form-horizontal formbiglbl">
                                        <div className="card-body">
                                          <div className="psnftstepwise_div">
                                            <div className="row justify-content-center">
                                              <div className="col-12 col-sm-10 col-md-10 col-lg-6 col-xl-5 text-center p-0 mt-3 mb-2">
                                                <div className="card px-0 pt-4 pb-0 mt-3 mb-3 shadow-none">
                                                  <h5 id="heading" className="d-md-none">
                                                    Fungible Tokens
                                                  </h5>
                                                  <form id="msform">
                                                    <fieldset>
                                                      <div
                                                        className="form-card"
                                                        style={{
                                                          display:
                                                            this.state.business_info_array?.business?.fungible_token
                                                              .status == '' ||
                                                              this.state.business_info_array?.business?.fungible_token
                                                                .status == 'requested'
                                                              ? 'inline-block'
                                                              : 'none',
                                                        }}>
                                                        <div className="row">
                                                          <div className="col-12">
                                                            <h2 className="fs-title text-center">
                                                              Set Up Fungible Token Contract
                                                            </h2>
                                                          </div>
                                                        </div>
                                                        <div className="mt-4">
                                                          <div
                                                            className="ftrequest"
                                                            style={{
                                                              display:
                                                                this.state.business_info_array?.business?.fungible_token
                                                                  .status == ''
                                                                  ? 'inline-block'
                                                                  : 'none',
                                                            }}>
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder="Token Name"
                                                              id="ft_token_name"
                                                            />
                                                            <input
                                                              type="text"
                                                              className="form-control"
                                                              placeholder="Token Symbol"
                                                              id="ft_token_symbol"
                                                            />
                                                            <input
                                                              type="number"
                                                              className="form-control"
                                                              placeholder="Maximum Number of Tokens"
                                                              id="ft_token_number"
                                                              min="1"
                                                              max="999999999"
                                                            />
                                                            <div align="center" className="mt-3">
                                                              <a
                                                                href="javascript:void(0)"
                                                                onClick={this.requestFungibleToken}
                                                                className="btn btn-black crsr_pntr btnpdng_sm ftrequest_btn">
                                                                Request Fungible Token Contract
                                                              </a>
                                                              <h6
                                                                className="w-100 mb-5 ftrequest_confirm_message"
                                                                style={{ display: 'none' }}>
                                                                Are you sure, Fungible Token contract will be created
                                                                with the above token name, token symbol and maximum
                                                                number of tokens? Once created, it cannot be reverted.
                                                              </h6>
                                                              <a
                                                                href="javascript:void(0)"
                                                                onClick={this.requestFungibleTokenConfirm}
                                                                className="btn btn-black crsr_pntr btnpdng_sm ftrequest_confirm_btn"
                                                                style={{ display: 'none' }}>
                                                                Confirm Fungible Token Contract Request
                                                              </a>
                                                            </div>
                                                          </div>

                                                          <div
                                                            data-val={
                                                              this.state.business_info_array?.business?.fungible_token
                                                                .status
                                                            }
                                                            className="text-center ftprocess"
                                                            style={{
                                                              display:
                                                                this.state.business_info_array?.business?.fungible_token
                                                                  .status == 'requested' &&
                                                                  this.state.business_info_array?.business?.fungible_token
                                                                    .status !== null &&
                                                                  this.state.business_info_array?.business?.fungible_token
                                                                    .status !== undefined &&
                                                                  this.state.business_info_array?.business?.fungible_token
                                                                    .status !== ''
                                                                  ? 'inline-block'
                                                                  : 'none',
                                                            }}>
                                                            <h5>
                                                              Your request for Fungible Token creation will be reviewed
                                                              and approved within 24 hours.
                                                            </h5>
                                                            <div align="center" className="mt-5">
                                                              <span className="btn btn-black btnpdng_sm ftprocess_btn">
                                                                Requested
                                                              </span>
                                                            </div>
                                                          </div>
                                                          {/* <div
                                                            className="text-center ftapproved"
                                                            style={{
                                                              display:
                                                                this.state.business_info_array?.business?.fungible_token
                                                                  .status == 'approved' &&
                                                                this.state.business_info_array?.business?.fungible_token
                                                                  ?.token_available ===
                                                                  this.state.business_info_array?.business?.fungible_token
                                                                    ?.token_limit
                                                                  ? 'inline-block'
                                                                  : 'none',
                                                            }}>
                                                            <h5>
                                                              Fungible Token contract created. You are now ready to use.
                                                            </h5>
                                                          </div> */}
                                                        </div>
                                                      </div>
                                                      <div
                                                        className="form-card"
                                                        style={{
                                                          display:
                                                            this.state.business_info_array?.business?.fungible_token
                                                              .status == 'approved' &&
                                                              this.state.business_info_array?.business?.fungible_token
                                                                ?.token_available ===
                                                              this.state.business_info_array?.business?.fungible_token
                                                                ?.token_limit
                                                              ? 'inline-block'
                                                              : 'none',
                                                        }}>
                                                        <div className="row">
                                                          <div className="col-12">
                                                            <h2 className="fs-title text-center">
                                                              Set Up Fungible Token Contract
                                                            </h2>
                                                          </div>
                                                        </div>
                                                        <div className="mt-4">



                                                          <div
                                                            className="text-center ftapproved"
                                                            style={{
                                                              display:
                                                                this.state.business_info_array?.business?.fungible_token
                                                                  .status == 'approved' &&
                                                                  this.state.business_info_array?.business?.fungible_token
                                                                    ?.token_available ===
                                                                  this.state.business_info_array?.business
                                                                    ?.fungible_token?.token_limit
                                                                  ? 'inline-block'
                                                                  : 'none',
                                                            }}>
                                                            <h5>
                                                              Fungible Token contract created. You are now ready to use.
                                                            </h5>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <input
                                                        type="button"
                                                        name="next"
                                                        className="action-button mt-4 ftapproved_next ftdone_next_clk"
                                                        defaultValue="Done"
                                                        style={{
                                                          display:
                                                            this.state.business_info_array?.business?.fungible_token
                                                              .status == 'approved' &&
                                                              this.state.business_info_array?.business?.fungible_token
                                                                ?.token_available ===
                                                              this.state.business_info_array?.business?.fungible_token
                                                                ?.token_limit
                                                              ? 'inline-block'
                                                              : 'none',
                                                        }}
                                                      />
                                                    </fieldset>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="ftlist_div"
                                    style={{
                                      display:
                                        this.state.business_info_array?.business?.fungible_token?.token_available !==
                                          this.state.business_info_array?.business?.fungible_token?.token_limit
                                          ? 'inline-block'
                                          : 'none',
                                    }}>
                                    <div className="card w-100 shadow-none">
                                      <div className="card-header d-flex flex-row flex-wrap">
                                        <div className="col-12 col-sm-12 col-md-12 pl-0">
                                          <h5 className="fmaroon pt-2">
                                            {this.state.business_info_array?.business?.fungible_token?.token_name}
                                          </h5>
                                        </div>
                                      </div>
                                      <div className="card-body p-0">
                                        <div className="my-3 text-center f_sz16">
                                          <span className="fmaroon font-weight-bold"></span> You have used{' '}
                                          <span className="fgreen4 font-weight-bold">
                                            {this.state.business_info_array?.business?.fungible_token?.token_limit -
                                              this.state.business_info_array?.business?.fungible_token?.token_available}
                                          </span>{' '}
                                          from the total tokens{' '}
                                          <span className="fgreen4 font-weight-bold">
                                            {this.state.business_info_array?.business?.fungible_token?.token_limit}
                                          </span>
                                        </div>
                                        <div className="table-responsive">
                                          <table
                                            className="table table-hover tbl_valignmdle tbl_ftsent border-bottom"
                                            id="ftsent_tbl"
                                            cellPadding={0}
                                            cellSpacing={0}
                                            style={{ width: '100%' }}>
                                            <thead>
                                              <tr>
                                                <th>Receiver</th>
                                                <th>Sent</th>
                                                <th>Accepted</th>
                                                <th>No. of Tokens</th>
                                              </tr>
                                            </thead>
                                            <tbody>{/* {this.state.ft_table_details?.length } */}</tbody>
                                          </table>
                                          <div
                                            className="mt-3 w-100 text-center"
                                            style={{
                                              display: this.state.ft_load_more_button ? 'inline-block' : 'none',
                                            }}>
                                            <a
                                              href="javascript:void(0)"
                                              onClick={!this.state.ft_load_more ? () => this.ft_table_data('cmb') : ''}
                                              className="btn btn-black btn-sm1 crsr_pntr f_sz16">
                                              <span className="d-none d-md-inline-block">
                                                {!this.state.ft_load_more ? 'Load More' : 'Processing...'}
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="popup_new" style={{ display: 'none' }}>
                          <div className="popup_inner">
                            <div className="popup_header">
                              <h5 className="fmaroon w-100 text-center">Upload Your Photo</h5>
                            </div>

                            <div className="popup_body">
                              {this.state.src && (
                                <ReactCrop
                                  src={this.state.src}
                                  crop={this.state.crop}
                                  ruleOfThirds
                                  onImageLoaded={this.onImageLoaded}
                                  onComplete={this.onCropComplete}
                                  onChange={this.onCropChange}
                                />
                              )}
                            </div>

                            <div align="center" className="mt-3">
                              <button className="btn btn-black btnpdng_sm mr-2" onClick={this.save_imageCrop}>
                                Save
                              </button>

                              <button className="btn btn-secondary crsr_pntr btnpdng_sm" onClick={this.close_imageCrop}>
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.row */}
              </div>
              {/* /.container-fluid */}
              {this.state.Lightbox_open ? (
                <Modal
                  classNames={{
                    overlay: 'customOverlay',
                    modal: 'imageModal',
                  }}
                  open={true}
                  onClose={this.closeLightbox}
                  center>
                  <img src={this.state.document_url} />
                </Modal>
              ) : (
                <Modal
                  classNames={{
                    overlay: 'customOverlay',
                    modal: 'imageModal',
                  }}
                  open={false}
                  onClose={this.closeLightbox}
                  center>
                  <img src={this.state.document_url} />
                </Modal>
              )}
              {this.state.Lightbox_open_video ? (
                <Modal
                  classNames={{
                    overlay: 'customOverlay',
                    modal: 'videoModal',
                  }}
                  open={true}
                  onClose={this.closeLightbox_video}
                  center>
                  <video controls playsInline disablePictureInPicture autoPlay muted controlsList="download">
                    <source
                      src={
                        this.state.video_play_link // {video_play_link_demo}
                      }
                      type="video/mp4"
                    />
                  </video>
                </Modal>
              ) : (
                <Modal
                  classNames={{
                    overlay: 'customOverlay',
                    modal: 'videoModal',
                  }}
                  open={false}
                  onClose={this.closeLightbox_video}
                  center>
                  <video controls playsInline disablePictureInPicture autoPlay muted controlsList="download">
                    <source
                      src={
                        this.state.video_play_link // {video_play_link_demo}
                      }
                      type="video/mp4"
                    />
                  </video>
                </Modal>
              )}
            </div>
            <div className="corSticky_container" style={{ display: 'none' }}>
              <div className="corSticky" style={{ display: 'none' }}>
                <div className="corSticky-wrap">
                  <div className="row">
                    <div className="col-sm-12 file_upload_append">
                      <div
                        className="alert alert-warning alert-dismissible fade show file_upload_alert_class"
                        role="alert">
                        <span className="up-item-tex">File Uploading</span>
                        <button type="button" className="close">
                          {/* <span className="hide_show" aria-hidden="true">
                            -
                          </span>{' '}
                          &nbsp;<span className="close_file_upload">×</span> */}
                        </button>
                      </div>
                      <div id="attachement_progress_div" style={{ height: 65 }}>
                        <div className="added_class alert alert-light alert_hide completed_cls1" role="alert">
                          world.topo.bathy.200407.3x21600x10800.jp...
                          <div className="progress whole_progres1">
                            <div
                              className="progress-bar progress_bar_color_cls progres_cnt1"
                              role="progressbar"
                              style={{ width: '20%' }}
                              aria-valuenow={25}
                              aria-valuemin={0}
                              aria-valuemax={100}>
                              15%
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* /.content */}
          </div>
          {/* /.content-wrapper */}
          <div className="modal fade" id="modal_qrcodedownload">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title fmaroon">Download QR Code</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body pt-0">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 pt-3 pb-3 py-sm-2 text-center brdrbtm_dashed">
                    <div className="qrcode_img">
                      <img src={this.state.qr_download_link} alt="Redtie" className="brand-image" />
                      {/* <canvas height="250" width="250" id="123456" style="height: 200px; width: 200px;"></canvas> */}
                    </div>
                    {/* <div class="qrcode_btn pt-3">
                                  <a class="btn btn-black crsr_pntr m-2 btnpdng_sm">Download QR Code</a>
                                </div>    */}
                  </div>
                </div>
                <div className="modal-footer justify-content-center">
                  <a
                    href={this.state.qr_download_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    className="btn btn-black btn-lg btnpdng_sm crsr_pntr">
                    Download QR Code
                  </a>
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>

          {/* /Trial payment start */}
          {/* <TrialPayment /> */}
          {/* /Trial payment end */}
          <div>
            <div className="modal fade modal_custom_800" id="modal_attachments">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">R-Bot Response for Inbound Messages</h5>
                    <button
                      type="button"
                      className="close auto_txt_model_close"
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="card w-100 shadow-none mb-0">
                        <div className="card-header mt-0">
                          <div className="form-group w-100 mb-2 text-center">
                            <div className="sendmessage_btnsdiv">
                              <div className="dropdown attachment_drpdwn d-inline-block">
                                <span data-toggle="dropdown" className="sendmessage_btnsspan">
                                  <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                    <i className="fas fa-paperclip" />
                                  </span>
                                </span>
                                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                  <div className="dropdown-item">
                                    <div className="overallattachment_div">
                                      <div
                                        className="overallattach_item sendmsgtempattach_clk"
                                        onClick={this.state.savingprogress === '...' ? null : this.saveNotes2_cmb}>
                                        <div className="overallattach_icon bg_notes bx_shadow_sm">
                                          <i className="far fa-sticky-note" />
                                        </div>
                                        <div className="fgrey">Notes</div>
                                      </div>
                                      <div className="overallattach_item sendmsgtempattach_clk">
                                        <label for="file-input">
                                          <div className="overallattach_icon bg_documents bx_shadow_sm" id="fdupld">
                                            <i className="far fa-file-alt" />
                                            <input
                                              id="file-input"
                                              type="file"
                                              name="DcfilNm"
                                              onChange={this.fileGetDetails_cmb}
                                            // multiple
                                            />
                                          </div>
                                        </label>
                                        <div className="fgrey">Documents</div>
                                      </div>
                                      <div className="overallattach_item">
                                        <label htmlFor="file-input3">
                                          <div className="overallattach_icon bg_gallery bx_shadow_sm" id="fdupld_2">
                                            <i className="far fa-image" data-place="bottom" data-tip="Images" />
                                            <input
                                              id="file-input3"
                                              type="file"
                                              name="DcfilNm"
                                              accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                              onChange={(event) => this.fileGetDetails_cmb_images(event)}
                                            // multiple
                                            />
                                          </div>
                                          {/* <ReactTooltip /> */}
                                        </label>
                                        <div className="fgrey">Gallery</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="d-inline-block sendmsgtempattach_clk"
                                onClick={this.sendmsgattach_clkAudio2_cmb}>
                                <span className="sendmessage_btnsspan">
                                  <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                    <i className="fas fa-microphone-alt" />
                                  </span>
                                </span>
                              </div>
                              <div
                                className="d-inline-block sendmsgtempattach_clk"
                                onClick={this.sendmsgattach_clkVideo2_cmb}>
                                <span className="sendmessage_btnsspan">
                                  <span className="btn btn-lg btn-black crsr_pntr btnpdng_sm">
                                    <i className="fas fa-video" />
                                  </span>
                                </span>
                              </div>
                              <div className="d-inline-block">
                                <a
                                  onClick={() => this.AutoTxtSaveclick()}
                                  className="btn btn-black crsr_pntr m-1 btnpdng_sm">
                                  Save
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body px-0 pb-0">
                          <div
                            className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb scrollbar_style"
                            style={{ display: 'none' }}
                            onClick={() => this.hide_emoji()}>
                            <div className="row position-relative">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="attachment_timelinediv">
                                  {/* The time line */}
                                  <div className="timeline">
                                    {/* timeline item */}
                                    <div style={{ display: 'none' }} className="sendmsgattach_clkAudio2_cmb">
                                      <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                      <div className="timeline-item">
                                        <div className="timeline-body">
                                          <div className="attachmentbody_div d-table">
                                            <div className="d-table-row">
                                              <div className="d-table-cell align-middle">
                                                <span className="ml-2">
                                                  <span className="crsr_pntr">
                                                    <i
                                                      className="fas fa-record-vinyl fa-2x fbred"
                                                      onClick={this.audio_start_cmb}
                                                    />
                                                    <span
                                                      className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                      onClick={this.audio_start_cmb}>
                                                      Start Recording
                                                    </span>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="timeline-footer">
                                          {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                          <a
                                            className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                            onClick={this.audioLclDelte_cmb}>
                                            Delete
                                          </a>
                                          <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                            <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                          </a>
                                        </div>
                                      </div>
                                    </div>

                                    {/* timeline item */}
                                    <div style={{ display: 'none' }} className="audioRecordLoading_cmb">
                                      <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                      <div className="timeline-item">
                                        <div className="timeline-body">
                                          <div className="attachmentbody_div d-table">
                                            <div className="d-table-row">
                                              <div className="d-table-cell align-middle">
                                                <span>
                                                  <span className="d-inline-block">
                                                    <span className="crsr_pntr">
                                                      <i
                                                        className="far fa-stop-circle f_sz30 fbred"
                                                        onClick={this.audio_stop_cmb}></i>
                                                      <span
                                                        className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                        onClick={this.audio_stop_cmb}>
                                                        Stop Recording
                                                      </span>
                                                    </span>
                                                    <span className="f_sz16">
                                                      <span>
                                                        <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                      </span>
                                                    </span>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="timeline-footer">
                                          {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                          <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">Delete</a>
                                        </div>
                                      </div>
                                    </div>
                                    {/* END timeline item */}
                                    {/* timeline item */}
                                    <div style={{ display: 'none' }} className="sendmsgattach_clkNotes2_cmb">
                                      <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                      <div className="timeline-item">
                                        <div className="timeline-body">
                                          <textarea
                                            className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                            placeholder="Enter the notes"
                                            value={this.state.notesValue2_cmb}
                                            onChange={this.notesLetter2_cmb}
                                            id="notestypearea"
                                          />
                                        </div>
                                        <div className="timeline-footer">
                                          <a
                                            className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                            onClick={this.saveNotes2_cmb}>
                                            Save
                                          </a>
                                          <a
                                            className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                            onClick={this.notesLclDelte_cmb}>
                                            Delete
                                          </a>
                                          {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                        </div>
                                      </div>
                                    </div>
                                    {/* END timeline item */}
                                    {/* timeline item */}
                                    <div style={{ display: 'none' }} className="sendmsgattach_clkVideo2_cmb">
                                      <i className="fas fa-film bg_video attachtype_timelineicon" />
                                      <div className="timeline-item">
                                        <div className="timeline-body">
                                          <div className="attachmentbody_div d-table">
                                            <div className="d-table-row">
                                              <div className="d-table-cell align-middle">
                                                <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                  <VideoRecorder
                                                    replayVideoAutoplayAndLoopOff={true}
                                                    // showReplayControls={true}
                                                    // mimeType="video/mp4"
                                                    // constraints={{audio: true}}
                                                    timeLimit={120000}
                                                    onRecordingComplete={(videoBlob, thumbnailBlob, videoUrl) => {
                                                      $('.sendmsgattach_clkVideo2_cmb').hide();
                                                      $('.sendmsg_attachmentdiv2_cmb').hide();

                                                      $('.attachLoading_cmb').show();
                                                      $('.attchLstShow_cmb').show();
                                                      this.setState({
                                                        lodingicon_cmb: 'fas fa-film bg_video',
                                                      });

                                                      // Do something with the video...
                                                      console.log(
                                                        'videoBloburl',
                                                        window.URL.createObjectURL(videoBlob),
                                                      );
                                                      console.log('videoBlob', videoBlob);
                                                      console.log('thumbnailBlob', thumbnailBlob);
                                                      console.log('videoUrl', videoUrl);
                                                      var reader = new FileReader();
                                                      reader.readAsDataURL(videoBlob);
                                                      reader.onloadend = function () {
                                                        var base64data = reader.result;
                                                        // console.log(base64data);
                                                      };
                                                      var filename = new Date().toISOString();
                                                      const data = new FormData();
                                                      var mp4file = new File([videoBlob], filename + '.mp4', {
                                                        type: 'video/mp4',
                                                        lastModified: new Date(),
                                                      });

                                                      data.append(
                                                        'apikey',
                                                        'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                      );
                                                      data.append('secret', 'R1eqD2twI3E4');
                                                      data.append('user_id', this.state.user_id);
                                                      data.append('business_id', this.state.business_id);
                                                      data.append('file', videoBlob, filename);
                                                      data.append('reference', 'text');
                                                      // data.append('type', 'video');

                                                      axios
                                                        .post(API_CALL_ENDPOINT + '/file/upload', data)
                                                        .then((res) => {
                                                          // console.log(res);
                                                          // console.log(res.data.message);
                                                          // console.log(res.data?.result?.files);

                                                          if (res.data.status == 'success') {
                                                            var file_url = '';
                                                            var file_path = '';
                                                            var file_url2 = '';
                                                            var second_file_path = '';
                                                            var file_url3 = '';
                                                            var file_url4 = '';
                                                            var file_id = '';
                                                            for (var i in res.data.result.files) {
                                                              console.log(res.data.result.files[i].file_url);
                                                              file_url += res.data.result.files[i].file_url;
                                                              file_path += res.data.result.files[i].file_path;
                                                              file_url2 += res.data.result.files[i].second_file_url;
                                                              second_file_path +=
                                                                res.data.result.files[i].second_file_path;
                                                              file_url3 += res.data.result.files[i].third_file_url;
                                                              file_url4 += res.data.result.files[i].fourth_file_url;
                                                              file_id += res.data.result.files[i]._id;
                                                              var joined_videoId =
                                                                this.state.attchmnt_videoId_cmb.concat(
                                                                  res.data.result.files[i]._id,
                                                                );
                                                              this.setState({
                                                                attchmnt_videoId_cmb: joined_videoId,
                                                              });
                                                            }
                                                            const atchId_recrd = res.data.result.files[0]._id;
                                                            console.log(atchId_recrd);

                                                            setTimeout(() => {
                                                              console.log(this.state.atcharryDet_cmb);
                                                            }, 150);

                                                            $('.attachLoading_cmb').hide();
                                                            $('#attachLoading_cmb_video').hide();

                                                            const video_details = {
                                                              apikey: API_KEY,
                                                              secret: API_SECRET,
                                                              user_id: this.state.user_id,
                                                              business_id: this.state.business_id,
                                                              attachment: atchId_recrd,
                                                              attachment_type: 'video',
                                                              unique_id:
                                                                this.state.message_edit === false
                                                                  ? Rnunique_id_cmb
                                                                  : this.state.Rnunique_id_cmb.append
                                                                    ? this.state.Rnunique_id_cmb
                                                                    : Rnunique_id_cmb,
                                                              order: '' + this.state.attachOrderIncrs_cmb + '',
                                                            };

                                                            axios
                                                              .post(
                                                                API_CALL_ENDPOINT + '/text/attachment/create',
                                                                video_details,
                                                              )
                                                              .then((res) => {
                                                                console.log(res);
                                                                console.log(res.data.message);

                                                                if (res.data.status == 'success') {
                                                                  this.setState({
                                                                    messageAttachd_cmb: true,
                                                                  });
                                                                  this.setState({
                                                                    atcharryDet_cmb: [
                                                                      {
                                                                        file_path: file_path,
                                                                        second_file_path: second_file_path,
                                                                        video_id: file_id,
                                                                        video_url: file_url,
                                                                        video_url2: file_url2,
                                                                        video_url3: file_url3,
                                                                        video_url4: file_url4,
                                                                        attach_id: res.data.result._id,
                                                                      },
                                                                      ...this.state.atcharryDet_cmb,
                                                                    ],
                                                                  });
                                                                  var OrderIncr =
                                                                    this.state.attachOrderIncrs_cmb + parseInt(1);
                                                                  this.setState({
                                                                    attachOrderIncrs_cmb: OrderIncr,
                                                                  });
                                                                }
                                                                if (res.data.error) {
                                                                }
                                                              });

                                                            console.log(file_url);
                                                          }
                                                        });
                                                    }}
                                                    setVideo={(blob) => {
                                                      let blobUrl = URL.createObjectURL(blob);
                                                      console.log(blobUrl);
                                                      // this.setState({ captureVideoUrl: blobUrl })
                                                    }}
                                                  />
                                                  {/* </div> */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="timeline-footer">
                                          {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                          <a
                                            className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                            onClick={this.videoLclDelte_cmb}>
                                            Delete
                                          </a>
                                          <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                            <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    {/* END timeline item */}
                                    {/* timeline item */}
                                    <div style={{ display: 'none' }}>
                                      <i className="fas fa-film bg_video attachtype_timelineicon" />
                                      <div className="timeline-item">
                                        <div className="timeline-body">
                                          <div className="attachmentbody_div d-table">
                                            <div className="d-table-row">
                                              <div className="d-table-cell w-70 align-top">
                                                <span className="attachrecord_icon bg_video crsr_pntr">
                                                  <i className="fas fa-film" />
                                                </span>
                                              </div>
                                              <div className="d-table-cell align-middle">
                                                <div className="f_sz16">
                                                  <span>
                                                    <i className="fas fa-spinner fa-spin f_sz24" />
                                                  </span>
                                                  <span
                                                    className="ml-2"
                                                    style={{
                                                      display: 'none',
                                                    }}>
                                                    0.10
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="timeline-footer">
                                          <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">Save</a>
                                          <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">Delete</a>
                                        </div>
                                      </div>
                                    </div>
                                    {/* END timeline item */}

                                    {/* timeline item */}
                                    <div style={{ display: 'none' }}>
                                      <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                      <div className="timeline-item">
                                        <div className="timeline-body">
                                          <div className="form-group row">
                                            <label className="col-form-label pull-left pl-2 f_sz16">
                                              No. of Rewards
                                            </label>
                                            <div className="pull-left ml-3">
                                              <input
                                                type="text"
                                                className="form-control text-center txtbx_sm"
                                                defaultValue={10}
                                                disabled
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="timeline-footer">
                                          {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                          <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">Delete</a>
                                          <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                            <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    {/* END timeline item */}
                                    {/* timeline item */}
                                    <div style={{ display: 'none' }}>
                                      <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                      <div className="timeline-item">
                                        <div className="timeline-body">
                                          <div className="form-group row">
                                            <label className="col-form-label pull-left pl-2 f_sz16">
                                              No. of Rewards
                                            </label>
                                            <div className="pull-left ml-3">
                                              <input type="text" className="form-control text-center txtbx_sm" />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="timeline-footer">
                                          <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">Save</a>
                                          <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">Delete</a>
                                          {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                        </div>
                                      </div>
                                    </div>
                                    {/* END timeline item */}
                                    <div id="attachLoading_cmb_video">
                                      <i className="fas fa-circle bg-gray" style={{ fontSize: 'x-small' }} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="attchLstShow_cmb" style={{ display: 'none' }} onClick={() => this.hide_emoji()}>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                              <div className="attachment_timelinediv">
                                {/* The time line */}

                                {/* The time line */}
                                <div
                                  // onDragOver={this.dragOver_cmb}
                                  className="timeline"
                                  id="timelineprepend">
                                  <div id="attachLoading_cmb" className="attachLoading_cmb" style={{ display: 'none' }}>
                                    <i className={this.state.lodingicon_cmb + ' attachtype_timelineicon'} />
                                    <div className="timeline-item">
                                      <div className="timeline-body">
                                        <div className="attachmentbody_div d-table">
                                          <span>
                                            <span className="d-inline-block">
                                              <span>
                                                <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                              </span>
                                              <span className="postop_5up">
                                                This might take few mins, please hold on while we process your
                                                attachment
                                              </span>
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                      <div className="timeline-footer"></div>
                                    </div>
                                  </div>

                                  {this.state.atcharryDet_cmb.map((attachment, index) => {
                                    return attachment.notes_content1 ? (
                                      <>
                                        <div className={'editor_cmb_' + attachment.attach_id} style={{ display: 'none' }}>
                                          <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                          <div className="timeline-item ">
                                            {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                            <div
                                              className={
                                                'timeline-body attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }
                                              // onClick={() => {
                                              //   this.oneditnotecmb(attachment);
                                              // }}
                                              style={{ wordWrap: 'break-word' }}>
                                              <div className="attachmentbody_div">
                                                {/* <ReactQuill
                  // theme="bubble"

                  modules={{
                    toolbar: [
                      [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                      ],
                      [
                        {header: '1'},
                        {header: '2'},
                        {font: []},
                      ],
                      [
                        {list: 'ordered'},
                        {list: 'bullet'},
                        {indent: '-1'},
                        {indent: '+1'},
                      ],
                      ['link', 'video'],
                      ['clean'],
                    ],

                    clipboard: {
                      // toggle to add extra line breaks when pasting HTML:
                      matchVisual: false,
                    },
                  }}
                  formats={[
                    'header',
                    'font',
                    'size',
                    'bold',
                    'italic',
                    'underline',
                    'strike',
                    'list',
                    'bullet',
                    'indent',
                    'link',
                    'video',
                  ]}
                  value={this.state.notesValue2_cmb}
                  onChange={this.notesLetter2_cmb}
                  maxLength="600"
                /> */}
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={this.state.notesValue2_cmb}
                                                  id="mytext"
                                                  config={editorConfiguration}
                                                  onReady={(editor) => {
                                                    // You can store the "editor" and use when it is needed.
                                                    // console.log( 'Editor is ready to use!', editor );
                                                  }}
                                                  onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    // console.log( { event, editor, data } );
                                                    // if (data.length <= 1200) {
                                                    this.setState({
                                                      notesValue2_cmb: data,
                                                      chars_left_notes_cmb:
                                                        this.state.max_chars_notes_cmb - data.length,
                                                    });
                                                    // }
                                                  }}
                                                  onBlur={(event, editor) => {
                                                    // console.log( 'Blur.', editor );
                                                  }}
                                                  onFocus={(event, editor) => {
                                                    // console.log( 'Focus.', editor );
                                                  }}
                                                />
                                              </div>
                                            </div>

                                            {/* {this.state.cmb_notesedit === true ? (
              <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                {this.state.savingprogress}
              </div>
            ) : null} */}

                                            {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                              
                                              Maximum 1200 characters
                                            </div> */}
                                            <div
                                              className={
                                                'timeline-footer attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }>
                                              {/* {this.state.cmb_notesedit === true ? (
                <a
                  className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                  onClick={() => {
                    this.updateNotes2_cmb();
                  }}>
                  Update
                </a>
              ) : null} */}
                                              <a
                                                className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                onClick={() => {
                                                  this.updateNotes2_cmb();
                                                  this.expanded_attach(attachment.attach_id);
                                                }}>
                                                {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                Save
                                              </a>
                                              <a
                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                onClick={() => this.notesAtchDelte_cmb_edit(attachment.attach_id)}>
                                                Delete
                                              </a>
                                              <a
                                                className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                onClick={() => {
                                                  this.expanded_attach(attachment.attach_id);
                                                }}>
                                                <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                            </div>
                                            {/* </span> */}
                                            {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                          </div>
                                          <div className="timeline-item ">
                                            <div
                                              className={
                                                'timeline-body attachment_colapsed attachment_colapsed_' +
                                                attachment.attach_id
                                              }
                                              style={{ display: 'none' }}>
                                              <div className="attachmentbody_div">
                                                Notes Attached
                                                <a
                                                  className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                  onClick={() => {
                                                    this.colapsed_attach(attachment.attach_id);
                                                    this.oneditnotecmb(attachment);
                                                  }}>
                                                  <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                </a>
                                              </div>
                                            </div>
                                            {/* </span> */}
                                          </div>
                                        </div>

                                        <div
                                          data-id={index}
                                          key={index}
                                          // draggable="true"
                                          // onDragEnd={this.dragEnd_cmb}
                                          // onDragStart={this.dragStart_cmb}
                                          className={'notecontent_cmb_show notecontent_cmb_' + attachment.attach_id}>
                                          <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                          <div className="timeline-item ">
                                            {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                            <div
                                              className={
                                                'timeline-body attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }
                                              onClick={() => {
                                                this.oneditnotecmb(attachment);
                                              }}
                                              style={{ wordWrap: 'break-word' }}>
                                              <div className="attachmentbody_div">
                                                <Linkify
                                                  componentDecorator={(decoratedHref, decoratedText, key) => (
                                                    <a target="blank" href={decoratedHref} key={key}>
                                                      {decoratedText}
                                                    </a>
                                                  )}>
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: attachment.notes_content,
                                                    }}
                                                  />
                                                  {/* {attachment.notes_content} */}
                                                </Linkify>
                                              </div>
                                            </div>

                                            <div
                                              className={
                                                'timeline-footer attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }>
                                              <a
                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                id={attachment.attach_id}
                                                onClick={this.notesAtchDelte_cmb}>
                                                Delete
                                              </a>
                                              <a
                                                className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                onClick={() => {
                                                  this.expanded_attach(attachment.attach_id);
                                                }}>
                                                <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                              {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
            <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
          </a> */}
                                            </div>
                                            {/* </span> */}
                                            {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                          </div>
                                          <div className="timeline-item ">
                                            <div
                                              className={
                                                'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                attachment.attach_id
                                              }
                                              style={{ display: 'none' }}>
                                              <div className="attachmentbody_div">
                                                Notes Attached
                                                <a
                                                  className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                  onClick={() => {
                                                    this.colapsed_attach(attachment.attach_id);
                                                    this.oneditnotecmb(attachment);
                                                  }}>
                                                  <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                </a>
                                                {/* </span> */}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : attachment.documents ? (
                                      attachment.documents.length > 0 ? (
                                        <div
                                          data-id={index}
                                          key={index}
                                        // draggable="true"
                                        // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                        // onDragStart={(e) => this.dragStart_cmb(e)}
                                        >
                                          <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                          <div className="timeline-item ">
                                            {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                            <div
                                              className={
                                                'timeline-body attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }>
                                              <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                <span className="font-weight-bold">Documents:</span>
                                                <br />

                                                <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                  {attachment.documents.map((documentList, index) => {
                                                    var fileType = documentList.file_name.split('.');
                                                    return (
                                                      <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                        <a onClick={() => this.document_read_auto(documentList)}>
                                                          {documentList?.thumbnail_file_url ? (
                                                            <div className="attachdoc_thumb">
                                                              <img src={documentList?.thumbnail_file_url} border={0} />
                                                            </div>
                                                          ) : (
                                                            <div className="attachdoc_type text-center">
                                                              <i className="far fa-file-alt flightgrey1"></i>
                                                            </div>
                                                          )}

                                                          <div className="attachdoc_filenmesze py-1 px-2">
                                                            <table width="100%" cellPadding={0} cellSpacing={0}>
                                                              <tbody>
                                                                <tr>
                                                                  <td>
                                                                    {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                    {fileType[fileType.length - 1] === 'pdf' ? (
                                                                      <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'docx' ||
                                                                      fileType[fileType.length - 1] === 'doc' ? (
                                                                      <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'jpg' ||
                                                                      fileType[fileType.length - 1] === 'jpeg' ? (
                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'png' ? (
                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'csv' ||
                                                                      fileType[fileType.length - 1] === 'xls' ||
                                                                      fileType[fileType.length - 1] === 'xlsx' ? (
                                                                      <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'pptx' ||
                                                                      fileType[fileType.length - 1] === 'ppt' ? (
                                                                      <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                    ) : (
                                                                      <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                    )}

                                                                    <span className="f_sz13 mr-2">
                                                                      {/* {documentList.file_name} */}
                                                                      {documentList?.file_name?.length > 5
                                                                        ? documentList?.file_name.substring(0, 5) +
                                                                        '...' +
                                                                        this.getExtensionFromUrl(
                                                                          documentList?.file_name,
                                                                        )
                                                                        : documentList?.file_name}
                                                                    </span>
                                                                  </td>
                                                                  <td align="right">
                                                                    <span className="f_sz12 flightgrey">
                                                                      {this.bytesToKb(documentList?.file_size)} kB
                                                                    </span>
                                                                  </td>
                                                                </tr>
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </a>
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className={
                                                'timeline-footer attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }>
                                              <a
                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                id={attachment.attach_id}
                                                onClick={(e) => this.documntAtchDelte_cmb(e, attachment.documents)}>
                                                Delete
                                              </a>
                                              <a
                                                className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                onClick={() => {
                                                  this.expanded_attach(attachment.attach_id);
                                                }}>
                                                <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                              </a>

                                              {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
              </a> */}
                                            </div>
                                            {/* </span> */}
                                            {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                          </div>
                                          <div className="timeline-item ">
                                            <div
                                              className={
                                                'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                attachment.attach_id
                                              }
                                              style={{ display: 'none' }}>
                                              <div className="attachmentbody_div">
                                                Document Attached
                                                <a
                                                  className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                  onClick={() => {
                                                    this.colapsed_attach(attachment.attach_id);
                                                  }}>
                                                  <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                </a>
                                              </div>
                                            </div>
                                            {/* </span> */}
                                          </div>
                                        </div>
                                      ) : undefined
                                    ) : attachment.images ? (
                                      attachment.images.length > 0 ? (
                                        <div
                                          data-id={index}
                                          key={index}
                                        // draggable="true"
                                        // onDragEnd={this.dragEnd_cmb}
                                        // onDragStart={this.dragStart_cmb}
                                        >
                                          <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                          <div className="timeline-item ">
                                            {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                            <div
                                              className={
                                                'timeline-body attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }>
                                              <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                {/* <span className="font-weight-bold">Images:</span> */}
                                                <br />

                                                <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                  {attachment.images.map((documentList, index) => {
                                                    var fileType = documentList.file_name.split('.');
                                                    return (
                                                      <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                        <a onClick={() => this.document_read_auto(documentList)}>
                                                          {documentList?.thumbnail_file_url ? (
                                                            <div className="attachdoc_thumb">
                                                              <img src={documentList?.thumbnail_file_url} border={0} />
                                                            </div>
                                                          ) : (
                                                            <div className="attachdoc_type text-center">
                                                              <i className="far fa-file-alt flightgrey1"></i>
                                                            </div>
                                                          )}

                                                          <div className="attachdoc_filenmesze py-1 px-2">
                                                            <table width="100%" cellPadding={0} cellSpacing={0}>
                                                              <tbody>
                                                                <tr>
                                                                  <td>
                                                                    {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                    {fileType[fileType.length - 1] === 'pdf' ? (
                                                                      <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'docx' ||
                                                                      fileType[fileType.length - 1] === 'doc' ? (
                                                                      <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'jpg' ||
                                                                      fileType[fileType.length - 1] === 'jpeg' ? (
                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'png' ? (
                                                                      <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'csv' ||
                                                                      fileType[fileType.length - 1] === 'xls' ||
                                                                      fileType[fileType.length - 1] === 'xlsx' ? (
                                                                      <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                    ) : fileType[fileType.length - 1] === 'pptx' ||
                                                                      fileType[fileType.length - 1] === 'ppt' ? (
                                                                      <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                    ) : (
                                                                      <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                    )}

                                                                    <span className="f_sz13 mr-2">
                                                                      {/* {documentList.file_name} */}
                                                                      {documentList?.file_name?.length > 5
                                                                        ? documentList?.file_name.substring(0, 5) +
                                                                        '...' +
                                                                        this.getExtensionFromUrl(
                                                                          documentList?.file_name,
                                                                        )
                                                                        : documentList?.file_name}
                                                                    </span>
                                                                  </td>
                                                                  <td align="right">
                                                                    <span className="f_sz12 flightgrey">
                                                                      {this.bytesToKb(documentList?.file_size)} kB
                                                                    </span>
                                                                  </td>
                                                                </tr>
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </a>
                                                        {/* <div className="attachdoc_delete">
                            <a
                              href="javascript:void(0)"
                              className="crsr_pntr">
                              <i
                                className="far fa-trash-alt f_sz15"
                                onClick={this.DocLclDlete_cmb}
                                id={documentList.file_id}
                                data-id={attachment.attach_id}
                              />
                            </a>
                          </div> */}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className={
                                                'timeline-footer attachment_expanded attachment_expanded_' +
                                                attachment.attach_id
                                              }>
                                              <a
                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                id={attachment.attach_id}
                                                onClick={(e) => this.documntAtchDelte_cmb(e, attachment.images)}>
                                                Delete
                                              </a>
                                              <a
                                                className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                onClick={() => {
                                                  this.expanded_attach(attachment.attach_id);
                                                }}>
                                                <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                              {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
              </a> */}
                                            </div>
                                            {/* </span> */}
                                            {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
            style={{display: "none"}}
            onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                          </div>
                                          <div className="timeline-item ">
                                            <div
                                              className={
                                                'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                attachment.attach_id
                                              }
                                              style={{ display: 'none' }}>
                                              <div className="attachmentbody_div">
                                                Image Attached
                                                <a
                                                  className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                  onClick={() => {
                                                    this.colapsed_attach(attachment.attach_id);
                                                  }}>
                                                  <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                </a>
                                              </div>
                                            </div>
                                            {/* </span> */}
                                          </div>
                                        </div>
                                      ) : undefined
                                    ) : attachment.audio_url ? (
                                      <div
                                        data-id={index}
                                        key={index}
                                      // draggable="true"
                                      // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                      // onDragStart={(e) => this.dragStart_cmb(e)}
                                      >
                                        <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                        <div className="timeline-item ">
                                          {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                          <div
                                            className={
                                              'timeline-body attachment_expanded attachment_expanded_' +
                                              attachment.audio_id
                                            }>
                                            <div className="attachmentbody_div d-table">
                                              <div className="d-table-row">
                                                <div className="d-table-cell align-middle">
                                                  <span>
                                                    <span className="d-inline-block">
                                                      <span className="crsr_pntr">
                                                        <i
                                                          className={
                                                            'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                            attachment.audio_id
                                                          }
                                                          onClick={() => {
                                                            this.audioPly_temp(attachment);
                                                          }}
                                                          id={attachment.audio_id}
                                                        />
                                                        <i
                                                          className={
                                                            'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                            attachment.audio_id
                                                          }
                                                          onClick={this.audioPaue}
                                                          id={attachment.audio_id}
                                                          style={{
                                                            display: 'none',
                                                          }}></i>
                                                        <span
                                                          className="ml-2 d-inline-block postop_5up"
                                                        // style={{
                                                        //   display: 'none',
                                                        // }}
                                                        ></span>
                                                        <audio
                                                          className={
                                                            'audioplayer123 audio_temp_' +
                                                            attachment.audio_id
                                                          }
                                                          style={{ width: '258px', display: 'none' }}
                                                          src={
                                                            this.state.play_audio_url
                                                              ? this.state.play_audio_url
                                                              : undefined
                                                          }
                                                          controls="controls"
                                                          controlsList="nodownload"
                                                          //hidden
                                                          id={'audio_temp_' + attachment.audio_id}
                                                        />
                                                      </span>
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className={
                                              'timeline-footer attachment_expanded attachment_expanded_' +
                                              attachment.audio_id
                                            }>
                                            <a
                                              className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                              id={attachment.attach_id}
                                              onClick={this.audioAtchDelte_cmb}>
                                              Delete
                                            </a>
                                            <a
                                              className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                              onClick={() => {
                                                this.expanded_attach(attachment.audio_id);
                                              }}>
                                              <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                            </a>
                                            {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
              <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
            </a> */}
                                          </div>
                                          {/* </span> */}
                                          {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
          style={{display: "none"}}
          onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                        </div>
                                        <div className="timeline-item ">
                                          <div
                                            className={
                                              'timeline-body  attachment_colapsed attachment_colapsed_' +
                                              attachment.audio_id
                                            }
                                            style={{ display: 'none' }}>
                                            <div className="attachmentbody_div">
                                              Audio Attached
                                              <a
                                                className={'crsr_pntr btnpdng_sm attach_expdcollapse_btn'}
                                                onClick={() => {
                                                  this.colapsed_attach(attachment.audio_id);
                                                }}>
                                                <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                              {/* </span> */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : attachment.video_url ? (
                                      <div
                                        data-id={index}
                                        key={index}
                                      // draggable="true"
                                      // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                      // onDragStart={(e) => this.dragStart_cmb(e)}
                                      >
                                        <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                        <div className="timeline-item">
                                          {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                          <div
                                            className={
                                              'timeline-body attachment_expanded attachment_expanded_' +
                                              attachment.attach_id
                                            }>
                                            <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                              <span className="font-weight-bold">Video:</span>
                                              <br />
                                              <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                <a onClick={() => this.Video_play_url(attachment)}>
                                                  {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
    <div className="attachdoc_type text-center">
      <i className="fas fa-video" />
    </div>
    <div className="attachdoc_name">
      Click here to
      play video
    </div>
  </div> */}
                                                  <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                    <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                      {/* <img src={} border={0} /> */}
                                                      <i className="fas fa-video fa-3x" />
                                                    </div>
                                                    <div className="attachvideo_gif">
                                                      {/* <img src={} border={0} /> */}
                                                      Click here to play video
                                                    </div>
                                                  </div>
                                                  {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                </a>
                                              </div>
                                            </div>
                                            {/* <div className="attachmentbody_div d-table">
<div className="d-table-row">
<div className="d-table-cell align-middle">
  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
    <div className="videoWrapper">
      <video
        onPlay={() =>
          this.Video_play_url(
            attachment
          )
        }
        width="300"
        controls
        playsinline
      >
        
        <source
          src={
            this.state
              .video_play_link
          }
          type="video/mp4"
        />                                                                
      </video>
    </div>
  </div>
</div>
</div>
</div> */}
                                          </div>
                                          <div
                                            className={
                                              'timeline-footer attachment_expanded attachment_expanded_' +
                                              attachment.attach_id
                                            }>
                                            <a
                                              className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                              id={attachment.attach_id}
                                              onClick={this.videAtchDelte_cmb}>
                                              Delete
                                            </a>
                                            <a
                                              className={'crsr_pntr btnpdng_sm attach_expdcollapse_btn'}
                                              onClick={() => {
                                                this.expanded_attach(attachment.attach_id);
                                              }}>
                                              <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                            </a>
                                            {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
              <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
            </a> */}
                                          </div>
                                          {/* </span> */}
                                          {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
          style={{display: "none"}}
          onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                        </div>
                                        <div className="timeline-item ">
                                          <div
                                            className={
                                              'timeline-body  attachment_colapsed attachment_colapsed_' +
                                              attachment.attach_id
                                            }
                                            style={{ display: 'none' }}>
                                            <div className="attachmentbody_div">
                                              Video Attached
                                              <a
                                                className={'crsr_pntr btnpdng_sm attach_expdcollapse_btn'}
                                                onClick={() => {
                                                  this.colapsed_attach(attachment.attach_id);
                                                }}>
                                                <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                              {/* </span> */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null;
                                  })}

                                  <div>
                                    <i className="fas fa-circle bg-gray" style={{ fontSize: 'x-small' }} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            <div className="modal fade modal_custom_600" id="modal_entrypoint">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Select an entry point to your workflow</h5>
                    <button
                      type="button"
                      className="close entry_point_close_allcontact"
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypoints_list scrollbar_style wf_entrypoints_listhgt">
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr wfentrypt_contactstgl"
                          //  onClick={() => (!this.state.disable_contact ? this.onAdd_entry_point() : null)}
                          >
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-user-friends f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">For given contact(s)</div>
                          </div>
                        </div>
                        <div className="w-100 mt-2 ml-5 wfentrypt_contactstgl_div" style={{ display: 'none' }}>
                          <div className="wf_entrypoints_item">
                            <div
                              className="wf_entrypoints_tblrow crsr_pntr"
                              onClick={() =>
                                !this.state.disable_contact ? this.onAdd_entry_point_all_contacts() : null
                              }>
                              <div className="wf_entrypoints_tbltd text-center">
                                <span>
                                  <i className="fas fa-user-friends f_sz18" />
                                </span>
                              </div>
                              <div className="wf_entrypoints_tbltd">All contact(s)</div>
                            </div>
                          </div>

                          <div className="w-100 mb-2" />

                          <div className="wf_entrypoints_item">
                            <div
                              onClick={() => this.choose_Contacts()}
                              className="wf_entrypoints_tblrow crsr_pntr"
                              data-toggle="modal"
                              data-target="#modal_entrypt_contacts"
                              data-backdrop="static"
                              data-dismiss="modal">
                              <div className="wf_entrypoints_tbltd text-center">
                                <span>
                                  <i className="fas fa-user f_sz18" />
                                </span>
                              </div>
                              <div className="wf_entrypoints_tbltd">Choose contact(s)</div>
                            </div>
                          </div>

                          <div className="w-100 mb-2" />

                          {/*<div className="wf_entrypoints_item">
                            <div className="wf_entrypoints_tblrow crsr_pntr">
                              <div className="wf_entrypoints_tbltd text-center">
                                <span>
                                  <i className="fas fa-user-plus f_sz18" />
                                </span>
                              </div>
                              <div className="wf_entrypoints_tbltd">When a new contact is added</div>
                            </div>
                          </div>
                          <div className="w-100 mb-2" />
                          <div className="wf_entrypoints_item">
                            <div className="wf_entrypoints_tblrow crsr_pntr">
                              <div className="wf_entrypoints_tbltd text-center">
                                <span>
                                  <i className="fas fa-list-alt f_sz20" />
                                </span>
                              </div>
                              <div className="wf_entrypoints_tbltd">Custom Properties</div>
                            </div>
                          </div>
                          <div className="w-100 mb-2" />
                          <div className="wf_entrypoints_item">
                            <div className="wf_entrypoints_tblrow crsr_pntr">
                              <div className="wf_entrypoints_tbltd text-center">
                                <span>
                                  <i className="fas fa-filter f_sz18" />
                                </span>
                              </div>
                              <div className="wf_entrypoints_tbltd">Contact filter conditions</div>
                            </div>
                          </div> */}
                        </div>

                        <div className=" w-100 mb-2" />
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_entrypt_tags"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-tags f_sz16" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">For given tag(s)</div>
                          </div>
                        </div>
                        <div className=" w-100 mb-2" />
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_entrypt_inboundmsg"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="far fa-arrow-alt-circle-down f_sz22" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">
                              If there is inbound message with or without [THIS] content.
                            </div>
                          </div>
                          <div className=" w-100 mb-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_entrypt_inboundmsg">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">When there is inbound message</h5>
                    <button
                      type="button"
                      className="close entry_pointinbound_close"
                      onClick={() => this.entry_pointinbound_close()}
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Start this workflow when there is inbound message with or without [THIS] content.
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          data-place="bottom"
                          title="You can filter contacts based on the content in inbound messages"
                        // data-tip="You can filter contacts based on the content in inbound messages"
                        />
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row mb-0">
                                  <div className="col-12 col-sm-12 col-md-5 px-0 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-12 mb-3">
                                        <div className="select_style">
                                          <select
                                            onChange={(e) => this.setState({ inbound_cond: e.target.value })}
                                            id="entryinbound"
                                            className="form-control">
                                            <option value="">--Select--</option>
                                            <option value="equal_to">Equal to</option>
                                            <option value="start_with">Starts with</option>
                                            <option value="contains">Contains</option>
                                            <option value="no_specification">No specification</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-sm-12 col-md-7 px-0 mt-2">
                                    <input
                                      disabled={this.state.inbound_cond === 'no_specification' ? true : false}
                                      type="text"
                                      className="form-control"
                                      value={
                                        this.state.inbound_cond === 'no_specification' ? '' : this.state.inbound_content
                                      }
                                      onChange={(e) => this.setState({ inbound_content: e.target.value })}
                                      placeholder="Enter the value"
                                      maxLength="300"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                style={{ display: !this.state.edit_entrypnt_inbound ? 'inline-block' : 'none' }}
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_entrypoint"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                onClick={() => (!this.state.disable_inbound ? this.onAdd_entry_point_inbound() : null)}>
                                {!this.state.edit_entrypnt_inbound ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_entrypt_contacts">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Choose contact(s)</h5>
                    <button
                      type="button"
                      onClick={() => this.entry_point_close()}
                      className="close entry_point_close"
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Start this workflow for the chosen contact(s).
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div className="searchcontacts_modaldiv">
                                <form id="contact search" onSubmit={(e) => this.contactSearch(e, false)}>
                                  <div className="input-group bx_shadow_smlight brdr_radius_mrdiv mb-3">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text search_inptgrptxt search_ctsinptgrptxt">
                                        <button className="btn btn-sm" type="submit">
                                          <i className="fas fa-search" />
                                        </button>
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      value={this.state.search_content}
                                      onChange={(e) => {
                                        this.onChangeSeacrchcnt(e);
                                      }}
                                      className="form-control search_frmcntrl3 bgclr1"
                                      placeholder="Search Contact(s)"
                                    />
                                  </div>
                                </form>
                                <div className="w-100 f_sz16 mb-2 text-right">
                                  <span className="fmaroon font-weight-bold">{this.state?.contact_id?.length}</span>{' '}
                                  contacts selected
                                </div>
                                <div id="contacts_nil" className="all_contentcntr_450" style={{ display: 'none' }}>
                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-4 mt-5">
                                    <img src={alert_search} alt="Redtie" className="img-size-180" />
                                    <div className="f_sz16 d-inline-block w-100">
                                      No specific contact found for the search term
                                    </div>
                                  </div>
                                </div>
                                <div
                                  onScroll={(e) => this.onScrollToBottom_contact(e)}
                                  className="contacts_tbldiv  contacts_tbldiv_modal scrollbar_style">
                                  <table
                                    className="table table-hover"
                                    cellPadding={0}
                                    cellSpacing={0}
                                    style={{ width: '100%' }}>
                                    <tbody>
                                      {this.state?.contacts?.map((contact, index) => {
                                        // console.log(contact.phone_number.toString().substring(1).replace(/[^\dA-Z]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3").trim())
                                        return (
                                          <tr
                                            id={'rw_' + contact._id}
                                            className={contact.status === 'unsubscribe' ? 'notsubscribed' : null}>
                                            <td>
                                              <div>
                                                {contact.first_name == 'Guest' ? (
                                                  <div
                                                    id={contact._id}
                                                    onClick={() =>
                                                      contact.status !== 'unsubscribe' ? this.selct({ contact }) : null
                                                    }
                                                    className={'ctdtls_tddiv slcttd_' + contact._id}
                                                    data-txt={contact.first_name}>
                                                    <span
                                                      className={'usercircle_sm1 mr-2 notselected_' + contact._id}
                                                      style={{
                                                        // backgroundColor: this.state.bgColor[
                                                        //   Math.floor(Math.random() * this.state.bgColor.length)
                                                        // ],
                                                        backgroundColor: contact.color_code
                                                          ? contact.color_code
                                                          : '#097952',
                                                      }}>
                                                      <i className="far fa-user"></i>
                                                    </span>
                                                    <span
                                                      style={{
                                                        backgroundColor: '#20c997',
                                                        display: 'none',
                                                      }}
                                                      className={'usercircle_sm1 mr-1 selected_' + contact._id}>
                                                      <i className="fas fa-check" id={contact._id}></i>
                                                    </span>
                                                    <span className="font-weight-bold">
                                                      {contact.phone_number.toString().length == 12
                                                        ? contact.phone_number
                                                          .toString()
                                                          .substring(2)
                                                          .replace(/[^\dA-Z]/g, '')
                                                          .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                                          .trim()
                                                        : contact.phone_number
                                                          .toString()
                                                          .substring(1)
                                                          .replace(/[^\dA-Z]/g, '')
                                                          .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                                          .trim()}
                                                    </span>

                                                    <span
                                                      style={
                                                        contact.delete === '1'
                                                          ? { display: 'inline-block' }
                                                          : { display: 'none' }
                                                      }
                                                      className="ml-3"
                                                      data-toggle="tooltip"
                                                      data-place="bottom"
                                                      data-tip="Deleted Contact">
                                                      {/* <ReactTooltip /> */}
                                                      <i className="fas fa-user-times fbred"></i>
                                                    </span>
                                                    {contact.text_archive === 'false' ? undefined : (
                                                      <span
                                                        style={
                                                          this.state.view_archive === 'on'
                                                            ? {
                                                              display: 'inline-block',
                                                            }
                                                            : { display: 'none' }
                                                        }
                                                        className="ml-3"
                                                        data-toggle="tooltip"
                                                        data-place="bottom"
                                                        data-tip="Archived Messages">
                                                        {/* <ReactTooltip /> */}
                                                        <i className="fas fa-archive fbred"></i>
                                                      </span>
                                                    )}
                                                    <small className="badge badge-success ml-2">New</small>
                                                    <span
                                                      style={
                                                        contact.status === 'unsubscribe'
                                                          ? { display: 'inline-block' }
                                                          : { display: 'none' }
                                                      }
                                                      className="ml-3"
                                                      data-toggle="tooltip"
                                                      data-placement="bottom"
                                                      title="Unsubscribed"
                                                      data-original-title="Unsubscribed">
                                                      <i className="fas fa-hand-point-down f_sz20 flightgrey2 postop_5" />
                                                    </span>
                                                  </div>
                                                ) : (
                                                  <div
                                                    id={contact._id}
                                                    onClick={() =>
                                                      contact.status !== 'unsubscribe' ? this.selct({ contact }) : null
                                                    }
                                                    className={'ctdtls_tddiv slcttd_' + contact._id}
                                                    data-txt={contact.first_name}>
                                                    <span
                                                      id={contact._id}
                                                      className={
                                                        contact.read_status == 'no'
                                                          ? 'inbound_' + contact._id + ' font-weight-bold'
                                                          : 'inbound_' + contact._id
                                                      }
                                                      data-txt={contact.first_name}>
                                                      <span
                                                        className={'usercircle_sm1 mr-2 notselected_' + contact._id}
                                                        style={{
                                                          // backgroundColor: this.state.bgColor[
                                                          //   Math.floor(Math.random() * this.state.bgColor.length)
                                                          // ],
                                                          backgroundColor: contact.color_code
                                                            ? contact.color_code
                                                            : '#097952',
                                                        }}>
                                                        {contact.first_name.substring(1, 0).toUpperCase()}
                                                      </span>
                                                      <span
                                                        style={{
                                                          backgroundColor: '#20c997',
                                                          display: 'none',
                                                        }}
                                                        className={'usercircle_sm1 mr-1 selected_' + contact._id}>
                                                        <i className="fas fa-check" id={contact._id}></i>
                                                      </span>
                                                      {contact.first_name} {contact.last_name}
                                                    </span>
                                                    <span
                                                      style={
                                                        contact.status === 'unsubscribe'
                                                          ? { display: 'inline-block' }
                                                          : { display: 'none' }
                                                      }
                                                      className="ml-3"
                                                      data-toggle="tooltip"
                                                      data-placement="bottom"
                                                      title="Unsubscribed"
                                                      data-original-title="Unsubscribed">
                                                      <i className="fas fa-hand-point-down f_sz20 flightgrey2 postop_5" />
                                                    </span>

                                                    <span
                                                      style={
                                                        contact.delete === '1'
                                                          ? { display: 'inline-block' }
                                                          : { display: 'none' }
                                                      }
                                                      className="ml-3"
                                                      data-toggle="tooltip"
                                                      data-place="bottom"
                                                      data-tip="Deleted Contact">
                                                      {/* <ReactTooltip /> */}
                                                      <i className="fas fa-user-times fbred"></i>
                                                    </span>
                                                    {contact.text_archive === 'false' ? undefined : (
                                                      <span
                                                        style={
                                                          this.state.view_archive === 'on'
                                                            ? {
                                                              display: 'inline-block',
                                                            }
                                                            : { display: 'none' }
                                                        }
                                                        className="ml-3"
                                                        data-toggle="tooltip"
                                                        data-place="bottom"
                                                        data-tip="Archived Messages">
                                                        {/* <ReactTooltip /> */}
                                                        <i className="fas fa-archive fbred"></i>
                                                      </span>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                style={{ display: !this.state.edit_entrypnt_contacts ? 'inline-block' : 'none' }}
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_entrypoint"
                                data-backdrop="static"
                                data-dismiss="modal"
                                onClick={() => this.entry_point_close()}>
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm contact_update_create"
                                onClick={() => (!this.state.disable_contact ? this.onAdd_entry_point() : null)}
                              // data-dismiss="modal"
                              >
                                {!this.state.edit_entrypnt_contacts ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            <div className="modal fade modal_custom_600" id="modal_entrypt_customprop">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Custom Properties</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Start this workflow for the given contact(s) having custom properties.
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title
                          data-original-title="You can filter contacts based on the custom properties"
                        />
                        <div className="wfcontact_customprphgt scrollbar_style">
                          <div className="form-horizontal formbiglbl">
                            <div className="card p-0 mb-0 shadow-none">
                              <div className="card-body">
                                <div>
                                  {/*First Name*/}
                                  <div className="form-group row mb-0">
                                    <div className="col-12 col-sm-12 col-md-6 mt-2">
                                      <div className="select_style">
                                        <select className="form-control" id="custom_properties_select">
                                          <option value="">--Select--</option>
                                          {this.state?.business_info_array.business?.add_property?.map(
                                            (properties, index) => {
                                              // if (properties.label_name != 'Email') {
                                              //console.log('properties', properties);
                                              return <option value={properties._id}>{properties.label_name}</option>;
                                              //}
                                            },
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 px-0 mt-3">
                                      <div className="w-100 d-flex flex-row flex-wrap">
                                        <div className="col-12 col-sm-12 col-md-5 mb-3">
                                          <div className="select_style">
                                            <select className="form-control" id="condition_dropdown">
                                              <option value="">--Select--</option>
                                              <option value="equal_to">Equal to</option>
                                              <option value="start_with">Starts with</option>
                                              <option value="contains">Contains</option>
                                              <option value="no_specification">No specification</option>
                                            </select>
                                          </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-7">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter the value"
                                            id="condition_value"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="card-footer bg-transparent text-center p-0">
                                <span
                                  className="m-2 crsr_pntr"
                                  data-toggle="modal"
                                  data-target="#modal_wfifelse_cond"
                                  data-backdrop="static"
                                  data-dismiss="modal">
                                  <span className="f_sz15">
                                    <i className="fas fa-long-arrow-alt-left mr-2" />
                                    Back
                                  </span>
                                </span>
                                <span
                                  className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                  onClick={() =>
                                    !this.state.disable_step_inbound ? this.updateifElseCustomProperties() : null
                                  }>
                                  Ok
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            <div className="modal fade modal_custom_600" id="modal_entrypt_tags">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">For given tag(s)</h5>
                    <button
                      type="button"
                      className="close entry_pointtag_close"
                      onClick={() => this.entry_pointtag_close()}
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Start this workflow for the given tag(s).
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          // data-placement="bottom"
                          title="You can filter contacts based on the given tag(s)"
                          data-place="bottom"
                          data-tip="You can filter contacts based on the given tag(s)"
                        // data-original-title="You can filter contacts based on the given tag(s)"
                        />
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div className="searchtag_modaldiv">
                                <form id="contact_search" onSubmit={(e) => this.tagcomp_search(e)}>
                                  <div className="input-group bx_shadow_smlight brdr_radius_mrdiv mb-2">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text search_inptgrptxt">
                                        <button className="btn btn-sm" type="submit">
                                          <i className="fas fa-search" />
                                        </button>
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      onChange={(e) => {
                                        this.onchange_tagsearch_txt(e);
                                      }}
                                      value={this.state.compsrch_txt}
                                      className="form-control search_frmcntrl3 bgclr"
                                      placeholder="Search Tag(s)"
                                    />
                                  </div>
                                </form>
                                <div className="w-100 f_sz16 mb-2 text-right">
                                  <span className="fmaroon font-weight-bold">{this.state?.tags_contact_count}</span>{' '}
                                  contacts selected
                                </div>
                                <div id="tags_nil" className="all_contentcntr_450" style={{ display: 'none' }}>
                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-4 mt-5">
                                    <img src={alert_search} alt="Redtie" className="img-size-180" />
                                    <div className="f_sz16 d-inline-block w-100">
                                      No specific tag found for the search term
                                    </div>
                                  </div>
                                </div>
                                <div className="contacts_tbldiv  tags_tbldiv_modal scrollbar_style mt-3">
                                  <table
                                    className="table table-hover"
                                    cellPadding={0}
                                    cellSpacing={0}
                                    style={{ width: '100%' }}>
                                    <tbody>
                                      {this.state.tag_list?.map((tag, index) => {
                                        return (
                                          <tr id={'tg_' + tag?._id}>
                                            <td>
                                              <div>
                                                <div className="ctdtls_tddiv">
                                                  <span
                                                    onClick={() => {
                                                      this.tag_selct(tag?._id);
                                                    }}>
                                                    <span
                                                      className={'usercircle_sm1 mr-1  tgnotselected_' + tag?._id}
                                                      style={{ backgroundColor: '#cccccc' }}>
                                                      <i className="fas fa-tag f_sz14" />
                                                    </span>
                                                    <span
                                                      className={'usercircle_sm1 mr-1  tgselected_' + tag?._id}
                                                      style={{ backgroundColor: '#20c997', display: 'none' }}>
                                                      <i className="fas fa-check" />
                                                    </span>
                                                    <span className="font-weight-bold">{tag?.tag_name}</span>
                                                  </span>
                                                  <span
                                                    style={{ display: tag.contactsCount !== 0 ? 'inline-block' : 'none' }}
                                                    onClick={() => {
                                                      this.view_cttaggedlist(tag?._id);
                                                    }}
                                                    className="ml-2 fmaroon f_sz13 crsr_pntr">
                                                    View
                                                  </span>
                                                  <div
                                                    className={'cttaggedlist_items p-2 mt-2 cttag_' + tag?._id}
                                                    style={{ display: 'none' }}>
                                                    <ol className="alllist f_sz13 mb-0">
                                                      {this.state.tagcnt_list.map((tagdet, index) => {
                                                        return (
                                                          <li>
                                                            {tagdet.first_name} {tagdet.last_name}
                                                          </li>
                                                        );
                                                      })}
                                                    </ol>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                // style={{display: !this.state.edit_entrypnt_tags ? 'inline-block' : 'none'}}
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_entrypoint"
                                data-backdrop="static"
                                data-dismiss="modal"
                                onClick={() => this.entry_pointtag_close()}>
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                onClick={() => (!this.state.disable_tag ? this.onAdd_entry_point_tags() : null)}
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm tags_update_create">
                                {!this.state.edit_entrypnt_tags ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            <div className="modal fade modal_custom_600" id="modal_entrypt_tags_if">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">For given tag(s)</h5>
                    <button
                      type="button"
                      className="close entry_pointtag_close"
                      onClick={() => this.entry_pointtag_close()}
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Start this workflow for the given tag(s).
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          // data-placement="bottom"
                          title="You can filter contacts based on the given tag(s)"
                          data-place="bottom"
                          data-tip="You can filter contacts based on the given tag(s)"
                        // data-original-title="You can filter contacts based on the given tag(s)"
                        />
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div className="searchtag_modaldiv">
                                <form id="contact_search" onSubmit={(e) => this.tagcomp_search(e)}>
                                  <div className="input-group bx_shadow_smlight brdr_radius_mrdiv mb-2">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text search_inptgrptxt">
                                        <button className="btn btn-sm" type="submit">
                                          <i className="fas fa-search" />
                                        </button>
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      onChange={(e) => {
                                        this.onchange_tagsearch_txt(e);
                                      }}
                                      value={this.state.compsrch_txt}
                                      className="form-control search_frmcntrl3 bgclr"
                                      placeholder="Search Tag(s)"
                                    />
                                  </div>
                                </form>
                                <div className="w-100 f_sz16 mb-2 text-right">
                                  <span className="fmaroon font-weight-bold">{this.state?.tags_contact_count}</span>{' '}
                                  contacts selected
                                </div>
                                <div id="tags_nil" className="all_contentcntr_450" style={{ display: 'none' }}>
                                  <div className="all_alertmessages d-flex flex-row flex-wrap align-items-center justify-content-center text-center pt-4 mt-5">
                                    <img src={alert_search} alt="Redtie" className="img-size-180" />
                                    <div className="f_sz16 d-inline-block w-100">
                                      No specific tag found for the search term
                                    </div>
                                  </div>
                                </div>
                                <div className="contacts_tbldiv  tags_tbldiv_modal scrollbar_style mt-3">
                                  <table
                                    className="table table-hover"
                                    cellPadding={0}
                                    cellSpacing={0}
                                    style={{ width: '100%' }}>
                                    <tbody>
                                      {this.state.tag_list?.map((tag, index) => {
                                        return (
                                          <tr id={'tg_' + tag?._id}>
                                            <td>
                                              <div>
                                                <div className="ctdtls_tddiv">
                                                  <span
                                                    onClick={() => {
                                                      this.tag_selct(tag?._id);
                                                    }}>
                                                    <span
                                                      className={'usercircle_sm1 mr-1  tgnotselected_' + tag?._id}
                                                      style={{ backgroundColor: '#cccccc' }}>
                                                      <i className="fas fa-tag f_sz14" />
                                                    </span>
                                                    <span
                                                      className={'usercircle_sm1 mr-1  tgselected_' + tag?._id}
                                                      style={{ backgroundColor: '#20c997', display: 'none' }}>
                                                      <i className="fas fa-check" />
                                                    </span>
                                                    <span className="font-weight-bold">{tag?.tag_name}</span>
                                                  </span>
                                                  <span
                                                    style={{ display: tag.contactsCount !== 0 ? 'inline-block' : 'none' }}
                                                    onClick={() => {
                                                      this.view_cttaggedlist(tag?._id);
                                                    }}
                                                    className="ml-2 fmaroon f_sz13 crsr_pntr">
                                                    View
                                                  </span>
                                                  <div
                                                    className={'cttaggedlist_items p-2 mt-2 cttag_' + tag?._id}
                                                    style={{ display: 'none' }}>
                                                    <ol className="alllist f_sz13 mb-0">
                                                      {this.state.tagcnt_list.map((tagdet, index) => {
                                                        return (
                                                          <li>
                                                            {tagdet.first_name} {tagdet.last_name}
                                                          </li>
                                                        );
                                                      })}
                                                    </ol>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                // style={{display: !this.state.edit_entrypnt_tags ? 'inline-block' : 'none'}}
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_entrypoint"
                                data-backdrop="static"
                                data-dismiss="modal"
                                onClick={() => this.entry_pointtag_close()}>
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                onClick={() => (!this.state.disable_tag ? this.onAdd_if_entry_point_tags() : null)}
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm tags_update_create iftags">
                                {!this.state.edit_ifentrypnt_tags ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade" id="modal_wfstep">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Add a step to your workflow</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_steplist scrollbar_style wf_step_listhgt">
                        <h6 className="w-100 text-center">Actions:</h6>
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfsendsms"
                            data-backdrop="static"
                            data-dismiss="modal"
                            onClick={() => {
                              this.remove_attach();
                            }}>
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="far fa-comment-alt f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">Send a Message</div>
                          </div>
                          <div className="mb-2" />
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfupdcontact"
                            data-backdrop="static"
                            data-dismiss="modal"
                            onClick={() => {
                              this.update_contact_popup();
                            }}>
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-user f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">Update Contact</div>
                          </div>
                        </div>
                        <h6 className="w-100 text-center mt-3">Condition:</h6>
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfdelay"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-spinner f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">Add a delay</div>
                          </div>
                          <div className="mb-2" />
                          {/* <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfwaituntil_cond"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-spinner f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">Wait Until</div>
                          </div>
                          <div className="mb-2" /> */}

                          {/* <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfwaituntil_cond"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-spinner f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">Wait Until</div>
                          </div>
                          <div className="mb-2" /> */}

                          <div
                            style={{ display: !this.state.firstlevel_click ? '' : 'none' }}
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfifelse_cond"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-code f_sz16" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">If / Else Conditions</div>
                          </div>
                          <div className="mb-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade" id="modal_wfdelay">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Add a delay</h5>
                    <button
                      type="button"
                      onClick={() => this.workflow_stepdelay_close()}
                      className="close workflow_stepdelay_close"
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        The workflow will wait a specific period of time before continuing.
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row mb-0">
                                  <div className="col-3 col-sm-3 col-md-3 mt-2">
                                    <input
                                      type="text"
                                      maxLength="4"
                                      value={this.state.workflow_delay_count}
                                      onChange={(e) => {
                                        const re = /^[0-9\b]+$/;
                                        this.setState({
                                          workflow_delay_count:
                                            e.target.value === '' || re.test(e.target.value)
                                              ? e.target.value
                                              : this.state.workflow_delay_count,
                                        });
                                      }}
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="col-9 col-sm-9 col-md-5 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-12 mb-3">
                                        <div className="select_style">
                                          <select
                                            onChange={(e) => this.setState({ workflow_delay_time: e.target.value })}
                                            id="startstepdelay"
                                            className="form-control">
                                            <option value="">--Select--</option>
                                            <option value="minutes">minute(s)</option>
                                            <option value="hours">hour(s)</option>
                                            <option value="days">day(s)</option>
                                            <option value="weeks">week(s)</option>
                                            <option value="months">month(s)</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                style={{ display: !this.state.edit_startpnt_delay ? 'inline-block' : 'none' }}
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                onClick={() => (!this.state.disable_start_delay ? this.onAdd_step_delay() : null)}
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                {!this.state.edit_startpnt_delay ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_800" id="modal_wfsendsms">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header" onClick={() => this.hide_emoji()}>
                    <h5 className="modal-title fmaroon">Send a Message</h5>
                    <button
                      type="button"
                      onClick={() => this.workflow_sendmsg_close()}
                      className="close workflow_sendmsg_close"
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification workflow_sendsmshgt scrollbar_style">
                        A message will be sent to the contact.
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row">
                                  <div className="col-12 col-sm-12 col-md-12">
                                    <textarea
                                      onChange={(e) => this.onchange_send_wfmessage(e)}
                                      onClick={() => this.hide_emoji()}
                                      className="form-control textarea_hgt80 txtarea_resizenone"
                                      placeholder="Enter Text Message"
                                      value={this.state.workflow_msg}
                                      maxLength="300"
                                    />
                                    <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
                                      <div className="col-4 col-sm-4 col-md-4 pl-0 workflow_message_show emoji_show_all">
                                        <i
                                          onClick={() => {
                                            this.render_emoji('workflow_message');
                                          }}
                                          className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative"
                                        />
                                        <a className="crsr_pntr">
                                          <i
                                            className={
                                              this.state.atcharryDet_cmb.length !== 0
                                                ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                            }
                                          />
                                        </a>
                                      </div>
                                      <div
                                        className="col-4 col-sm-4 col-md-4 pl-0 workflow_message_close emoji_close_all"
                                        style={{ display: 'none' }}>
                                        <i
                                          onClick={() => {
                                            this.render_emoji('workflow_message');
                                          }}
                                          className={'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'}
                                        />
                                        <a className="crsr_pntr">
                                          <i
                                            className={
                                              this.state.atcharryDet_cmb.length !== 0
                                                ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                                                : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                                            }
                                          />
                                        </a>
                                      </div>
                                      <div className="col-8 col-sm-8 col-md-8 pr-0">
                                        <div className="f_sz12 fred mt-1 text-left text-md-right">
                                          {this.state.chars_left_wfmsg} characters remaining
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
                                      <span
                                        className="flex-row flex-wrap emoji_position emoji_disable"
                                        style={{
                                          display: 'none',
                                          position: 'inherit',
                                          width: 'inherit',
                                          zIndex: '10',
                                        }}
                                        id="workflow_message"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="form-group w-100 mt-4 mb-2 text-center" onClick={() => this.hide_emoji()}>
                              <div className="sendmessage_btnsdiv">
                                <div class="dropdown attachment_drpdwn d-inline-block">
                                  <span data-toggle="dropdown" class="sendmessage_btnsspan">
                                    <span class="btn btn-black crsr_pntr btnpdng_sm">
                                      <i class="fas fa-paperclip"></i>
                                    </span>
                                  </span>

                                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-left">
                                    <div class="dropdown-item">
                                      <div class="overallattachment_div">
                                        <div
                                          className="overallattach_item sendmsgattach_clk"
                                          onClick={this.state.savingprogress === '...' ? null : this.saveNotes2_cmb}>
                                          <div className="overallattach_icon bg_notes bx_shadow_sm">
                                            <i className="far fa-sticky-note" />
                                          </div>
                                          <div className="fgrey">Notes</div>
                                        </div>
                                        <div className="overallattach_item sendmsgattach_clk">
                                          <label for="file-input">
                                            <div className="overallattach_icon bg_documents bx_shadow_sm" id="fdupld">
                                              <i className="far fa-file-alt" />
                                              <input
                                                id="file-input"
                                                type="file"
                                                name="DcfilNm"
                                                onChange={this.fileGetDetails_cmb}
                                              // multiple
                                              />
                                            </div>
                                          </label>
                                          <div className="fgrey">Documents</div>
                                        </div>
                                        <div className="overallattach_item">
                                          <label htmlFor="file-input3">
                                            <div className="overallattach_icon bg_gallery bx_shadow_sm" id="fdupld_2">
                                              <i className="far fa-image" data-place="bottom" data-tip="Images" />
                                              <input
                                                id="file-input3"
                                                type="file"
                                                name="DcfilNm"
                                                accept="image/x-png,image/gif,image/jpeg,image/pipeg,image/tiff,image/svg+xml,video/mpeg,video/quicktime,video/x-msvideo,video/*,image/*,video/quicktime,video/mp4,.mov,.mkv"
                                                onChange={(event) => this.fileGetDetails_cmb_images(event)}
                                              // multiple
                                              />
                                            </div>
                                            {/* <ReactTooltip /> */}
                                          </label>
                                          <div className="fgrey">Gallery</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="d-inline-block sendmsgattach_clk"
                                  onClick={() => {
                                    this.sendmsgattach_clkAudio2_cmb();
                                  }}
                                // onClick={this.sendmsgattach_clkAudio2_cmb}
                                >
                                  <span className="sendmessage_btnsspan">
                                    <span className="btn btn-black crsr_pntr btnpdng_sm">
                                      <i className="fas fa-microphone-alt" />
                                    </span>
                                  </span>
                                </div>
                                <div
                                  className="d-inline-block sendmsgattach_clk"
                                  onClick={() => {
                                    this.sendmsgattach_clkVideo2_cmb();
                                  }}
                                // onClick={this.sendmsgattach_clkVideo2_cmb}
                                >
                                  <span className="sendmessage_btnsspan">
                                    <span className="btn btn-black crsr_pntr btnpdng_sm">
                                      <i className="fas fa-video" />
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="card-body px-0 pb-0   scrollbar_style">
                              <div
                                className="sendmsg_attachmentdiv_sm sendmsg_attachmentdiv2_cmb scrollbar_style"
                                style={{ display: 'none' }}
                                onClick={() => this.hide_emoji()}>
                                <div className="row position-relative">
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="attachment_timelinediv">
                                      {/* The time line */}
                                      <div className="timeline">
                                        {/* timeline item */}
                                        <div style={{ display: 'none' }} className="sendmsgattach_clkAudio2_cmb">
                                          <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                          <div className="timeline-item">
                                            <div className="timeline-body">
                                              <div className="attachmentbody_div d-table">
                                                <div className="d-table-row">
                                                  <div className="d-table-cell align-middle">
                                                    <span className="ml-2">
                                                      <span className="crsr_pntr">
                                                        <i
                                                          className="fas fa-record-vinyl fa-2x fbred"
                                                          onClick={this.audio_start_cmb}
                                                        />
                                                        <span
                                                          className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                          onClick={this.audio_start_cmb}>
                                                          Start Recording
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="timeline-footer">
                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                              <a
                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                onClick={this.audioLclDelte_cmb}>
                                                Delete
                                              </a>
                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                            </div>
                                          </div>
                                        </div>

                                        {/* timeline item */}
                                        <div style={{ display: 'none' }} className="audioRecordLoading_cmb">
                                          <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                          <div className="timeline-item">
                                            <div className="timeline-body">
                                              <div className="attachmentbody_div d-table">
                                                <div className="d-table-row">
                                                  <div className="d-table-cell align-middle">
                                                    <span>
                                                      <span className="d-inline-block">
                                                        <span className="crsr_pntr">
                                                          <i
                                                            className="far fa-stop-circle f_sz30 fbred"
                                                            onClick={this.audio_stop_cmb}></i>
                                                          <span
                                                            className="ml-2 d-inline-block postop_5up mr-2 fmaroon"
                                                            onClick={this.audio_stop_cmb}>
                                                            Stop Recording
                                                          </span>
                                                        </span>
                                                        <span className="f_sz16">
                                                          <span>
                                                            <i className="fas fa-spinner fa-spin f_sz24"></i>
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="timeline-footer">
                                              {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2" onClick={this.audio_stop}>Stop</a> */}
                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                Delete
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                        {/* END timeline item */}
                                        {/* timeline item */}
                                        <div style={{ display: 'none' }} className="sendmsgattach_clkNotes2_cmb">
                                          <i className="far fa-sticky-note bg_notes attachtype_timelineicon" />
                                          <div className="timeline-item">
                                            <div className="timeline-body">
                                              <textarea
                                                className="form-control notesbox textarea_hgt100 txtarea_resizenone"
                                                placeholder="Enter the notes"
                                                value={this.state.notesValue2_cmb}
                                                onChange={this.notesLetter2_cmb}
                                                id="notestypearea"
                                              />
                                            </div>
                                            <div className="timeline-footer">
                                              <a
                                                className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                onClick={this.saveNotes2_cmb}>
                                                Save
                                              </a>
                                              <a
                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                onClick={this.notesLclDelte_cmb}>
                                                Delete
                                              </a>
                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                            </div>
                                          </div>
                                        </div>
                                        {/* END timeline item */}
                                        {/* timeline item */}
                                        <div style={{ display: 'none' }} className="sendmsgattach_clkVideo2_cmb">
                                          <i className="fas fa-film bg_video attachtype_timelineicon" />
                                          <div className="timeline-item">
                                            <div className="timeline-body">
                                              <div className="attachmentbody_div d-table">
                                                <div className="d-table-row">
                                                  <div className="d-table-cell align-middle">
                                                    <div className="col-11 col-sm-12 col-md-12 col-lg-12 videohgt">
                                                      <VideoRecorder
                                                        replayVideoAutoplayAndLoopOff={true}
                                                        // showReplayControls={true}
                                                        // mimeType="video/mp4"
                                                        // constraints={{audio: true}}
                                                        timeLimit={120000}
                                                        onRecordingComplete={(videoBlob, thumbnailBlob, videoUrl) => {
                                                          $('.sendmsgattach_clkVideo2_cmb').hide();
                                                          $('.sendmsg_attachmentdiv2_cmb').hide();

                                                          $('.attachLoading_cmb').show();
                                                          $('.attchLstShow_cmb').show();
                                                          this.setState({
                                                            lodingicon_cmb: 'fas fa-film bg_video',
                                                          });

                                                          // Do something with the video...
                                                          console.log(
                                                            'videoBloburl',
                                                            window.URL.createObjectURL(videoBlob),
                                                          );
                                                          console.log('videoBlob', videoBlob);
                                                          console.log('thumbnailBlob', thumbnailBlob);
                                                          console.log('videoUrl', videoUrl);
                                                          var reader = new FileReader();
                                                          reader.readAsDataURL(videoBlob);
                                                          reader.onloadend = function () {
                                                            var base64data = reader.result;
                                                            // console.log(base64data);
                                                          };
                                                          var filename = new Date().toISOString();
                                                          const data = new FormData();
                                                          var mp4file = new File([videoBlob], filename + '.mp4', {
                                                            type: 'video/mp4',
                                                            lastModified: new Date(),
                                                          });

                                                          data.append(
                                                            'apikey',
                                                            'RVY0VnVLUDhQSHZST2hFM04xcnFnZDkzU2J2bGtZVVM1S2NNaXY2NHh4cmhhdEM5cjMyMTJaMXA',
                                                          );
                                                          data.append('secret', 'R1eqD2twI3E4');
                                                          data.append('user_id', this.state.user_id);
                                                          data.append('business_id', this.state.business_id);
                                                          data.append('file', videoBlob, filename);
                                                          data.append('reference', 'text');
                                                          // data.append('type', 'video');

                                                          axios
                                                            .post(API_CALL_ENDPOINT + '/file/upload', data)
                                                            .then((res) => {
                                                              // console.log(res);
                                                              // console.log(res.data.message);
                                                              // console.log(res.data?.result?.files);

                                                              if (res.data.status == 'success') {
                                                                var file_url = '';
                                                                var file_path = '';
                                                                var file_url2 = '';
                                                                var second_file_path = '';
                                                                var file_url3 = '';
                                                                var file_url4 = '';
                                                                var file_id = '';
                                                                for (var i in res.data.result.files) {
                                                                  console.log(res.data.result.files[i].file_url);
                                                                  file_url += res.data.result.files[i].file_url;
                                                                  file_path += res.data.result.files[i].file_path;
                                                                  file_url2 += res.data.result.files[i].second_file_url;
                                                                  second_file_path +=
                                                                    res.data.result.files[i].second_file_path;
                                                                  file_url3 += res.data.result.files[i].third_file_url;
                                                                  file_url4 += res.data.result.files[i].fourth_file_url;
                                                                  file_id += res.data.result.files[i]._id;
                                                                  var joined_videoId =
                                                                    this.state.attchmnt_videoId_cmb.concat(
                                                                      res.data.result.files[i]._id,
                                                                    );
                                                                  this.setState({
                                                                    attchmnt_videoId_cmb: joined_videoId,
                                                                  });
                                                                }
                                                                const atchId_recrd = res.data.result.files[0]._id;
                                                                console.log(atchId_recrd);

                                                                setTimeout(() => {
                                                                  console.log(this.state.atcharryDet_cmb);
                                                                }, 150);

                                                                $('.attachLoading_cmb').hide();
                                                                $('#attachLoading_cmb_video').hide();

                                                                const video_details = {
                                                                  apikey: API_KEY,
                                                                  secret: API_SECRET,
                                                                  user_id: this.state.user_id,
                                                                  business_id: this.state.business_id,
                                                                  attachment: atchId_recrd,
                                                                  attachment_type: 'video',
                                                                  unique_id:
                                                                    this.state.message_edit === false
                                                                      ? Rnunique_id_cmb
                                                                      : this.state.Rnunique_id_cmb.append
                                                                        ? this.state.Rnunique_id_cmb
                                                                        : Rnunique_id_cmb,
                                                                  order: '' + this.state.attachOrderIncrs_cmb + '',
                                                                };

                                                                axios
                                                                  .post(
                                                                    API_CALL_ENDPOINT + '/text/attachment/create',
                                                                    video_details,
                                                                  )
                                                                  .then((res) => {
                                                                    console.log(res);
                                                                    console.log(res.data.message);

                                                                    if (res.data.status == 'success') {
                                                                      this.setState({
                                                                        messageAttachd_cmb: true,
                                                                      });
                                                                      this.setState({
                                                                        atcharryDet_cmb: [
                                                                          {
                                                                            file_path: file_path,
                                                                            second_file_path: second_file_path,
                                                                            video_id: file_id,
                                                                            video_url: file_url,
                                                                            video_url2: file_url2,
                                                                            video_url3: file_url3,
                                                                            video_url4: file_url4,
                                                                            attach_id: res.data.result._id,
                                                                          },
                                                                          ...this.state.atcharryDet_cmb,
                                                                        ],
                                                                      });
                                                                      var OrderIncr =
                                                                        this.state.attachOrderIncrs_cmb + parseInt(1);
                                                                      this.setState({
                                                                        attachOrderIncrs_cmb: OrderIncr,
                                                                      });
                                                                      $('.attachment_colapsed').show();
                                                                      $('.attachment_colapsed_' + file_id).hide();
                                                                      $('.attachment_expanded').hide();
                                                                      $('.attachment_expanded_' + file_id).show();
                                                                    }
                                                                    if (res.data.error) {
                                                                      $('.attachment_colapsed').show();
                                                                      // $('.attachment_colapsed_'+file_id).hide();
                                                                      $('.attachment_expanded').hide();
                                                                      // $('.attachment_expanded_'+file_id).show();
                                                                    }
                                                                  })
                                                                  .catch((error) => {
                                                                    if (error.response) {
                                                                      if (error.response.data.error) {
                                                                        $('.attachment_colapsed').show();
                                                                        // $('.attachment_colapsed_'+file_id).hide();
                                                                        $('.attachment_expanded').hide();
                                                                        // $('.attachment_expanded_'+file_id).show();
                                                                      }
                                                                    }
                                                                  });

                                                                console.log(file_url);
                                                              }
                                                            });
                                                        }}
                                                        setVideo={(blob) => {
                                                          let blobUrl = URL.createObjectURL(blob);
                                                          console.log(blobUrl);
                                                          // this.setState({ captureVideoUrl: blobUrl })
                                                        }}
                                                      />
                                                      {/* </div> */}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="timeline-footer">
                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                              <a
                                                className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                onClick={this.videoLclDelte_cmb}>
                                                Delete
                                              </a>
                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                        {/* END timeline item */}
                                        {/* timeline item */}
                                        <div style={{ display: 'none' }}>
                                          <i className="fas fa-film bg_video attachtype_timelineicon" />
                                          <div className="timeline-item">
                                            <div className="timeline-body">
                                              <div className="attachmentbody_div d-table">
                                                <div className="d-table-row">
                                                  <div className="d-table-cell w-70 align-top">
                                                    <span className="attachrecord_icon bg_video crsr_pntr">
                                                      <i className="fas fa-film" />
                                                    </span>
                                                  </div>
                                                  <div className="d-table-cell align-middle">
                                                    <div className="f_sz16">
                                                      <span>
                                                        <i className="fas fa-spinner fa-spin f_sz24" />
                                                      </span>
                                                      <span
                                                        className="ml-2"
                                                        style={{
                                                          display: 'none',
                                                        }}>
                                                        0.10
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="timeline-footer">
                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">Save</a>
                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                Delete
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                        {/* END timeline item */}

                                        {/* timeline item */}
                                        <div style={{ display: 'none' }}>
                                          <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                          <div className="timeline-item">
                                            <div className="timeline-body">
                                              <div className="form-group row">
                                                <label className="col-form-label pull-left pl-2 f_sz16">
                                                  No. of Rewards
                                                </label>
                                                <div className="pull-left ml-3">
                                                  <input
                                                    type="text"
                                                    className="form-control text-center txtbx_sm"
                                                    defaultValue={10}
                                                    disabled
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="timeline-footer">
                                              {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">Save</a>*/}
                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm">Delete</a>
                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                        {/* END timeline item */}
                                        {/* timeline item */}
                                        <div style={{ display: 'none' }}>
                                          <i className="far fa-star bg_rewards attachtype_timelineicon" />
                                          <div className="timeline-item">
                                            <div className="timeline-body">
                                              <div className="form-group row">
                                                <label className="col-form-label pull-left pl-2 f_sz16">
                                                  No. of Rewards
                                                </label>
                                                <div className="pull-left ml-3">
                                                  <input type="text" className="form-control text-center txtbx_sm" />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="timeline-footer">
                                              <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">Save</a>
                                              <a className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2">
                                                Delete
                                              </a>
                                              {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                            </div>
                                          </div>
                                        </div>
                                        {/* END timeline item */}
                                        <div id="attachLoading_cmb_video">
                                          <i className="fas fa-circle bg-gray" style={{ fontSize: 'x-small' }} />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="attchLstShow_cmb"
                                style={{ display: 'none' }}
                                onClick={() => this.hide_emoji()}>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 px-0">
                                  <div className="attachment_timelinediv">
                                    {/* The time line */}

                                    {/* The time line */}
                                    <div
                                      // onDragOver={this.dragOver_cmb}
                                      className="timeline"
                                      id="timelineprepend">
                                      <div
                                        id="attachLoading_cmb"
                                        className="attachLoading_cmb"
                                        style={{ display: 'none' }}>
                                        <i className={this.state.lodingicon_cmb + ' attachtype_timelineicon'} />
                                        <div className="timeline-item">
                                          <div className="timeline-body">
                                            <div className="attachmentbody_div d-table">
                                              <span>
                                                <span className="d-inline-block">
                                                  <span>
                                                    <i className="fas fa-spinner fa-spin f_sz24 mr-2" />
                                                  </span>
                                                  <span className="postop_5up">
                                                    This might take few mins, please hold on while we process your
                                                    attachment
                                                  </span>
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                          <div className="timeline-footer"></div>
                                        </div>
                                      </div>

                                      {this.state.atcharryDet_cmb.map((attachment, index) => {
                                        return attachment.notes_content1 ? (
                                          <>
                                            <div
                                              className={'editor_cmb_' + attachment.attach_id}
                                              style={{ display: 'none' }}>
                                              <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                              <div className="timeline-item ">
                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                <div
                                                  className={
                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }
                                                  // onClick={() => {
                                                  //   this.oneditnotecmb(attachment);
                                                  // }}
                                                  style={{ wordWrap: 'break-word' }}>
                                                  <div className="attachmentbody_div">
                                                    {/* <ReactQuill
                                                                            // theme="bubble"

                                                                            modules={{
                                                                              toolbar: [
                                                                                [
                                                                                  'bold',
                                                                                  'italic',
                                                                                  'underline',
                                                                                  'strike',
                                                                                ],
                                                                                [
                                                                                  {header: '1'},
                                                                                  {header: '2'},
                                                                                  {font: []},
                                                                                ],
                                                                                [
                                                                                  {list: 'ordered'},
                                                                                  {list: 'bullet'},
                                                                                  {indent: '-1'},
                                                                                  {indent: '+1'},
                                                                                ],
                                                                                ['link', 'video'],
                                                                                ['clean'],
                                                                              ],

                                                                              clipboard: {
                                                                                // toggle to add extra line breaks when pasting HTML:
                                                                                matchVisual: false,
                                                                              },
                                                                            }}
                                                                            formats={[
                                                                              'header',
                                                                              'font',
                                                                              'size',
                                                                              'bold',
                                                                              'italic',
                                                                              'underline',
                                                                              'strike',
                                                                              'list',
                                                                              'bullet',
                                                                              'indent',
                                                                              'link',
                                                                              'video',
                                                                            ]}
                                                                            value={this.state.notesValue2_cmb}
                                                                            onChange={this.notesLetter2_cmb}
                                                                            maxLength="600"
                                                                          /> */}
                                                    <CKEditor
                                                      editor={ClassicEditor}
                                                      data={this.state.notesValue2_cmb}
                                                      id="mytext"
                                                      config={editorConfiguration}
                                                      onReady={(editor) => {
                                                        // You can store the "editor" and use when it is needed.
                                                        // console.log( 'Editor is ready to use!', editor );
                                                      }}
                                                      onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        // console.log( { event, editor, data } );
                                                        // if (data.length <= 1200) {
                                                        this.setState({
                                                          notesValue2_cmb: data,
                                                          chars_left_notes_cmb:
                                                            this.state.max_chars_notes_cmb - data.length,
                                                        });
                                                        // }
                                                      }}
                                                      onBlur={(event, editor) => {
                                                        // console.log( 'Blur.', editor );
                                                      }}
                                                      onFocus={(event, editor) => {
                                                        // console.log( 'Focus.', editor );
                                                      }}
                                                    />
                                                  </div>
                                                </div>

                                                {/* {this.state.cmb_notesedit === true ? (
                                                                        <div className={"font-weight-bold flightgrey3 ml-3 text-right text-md-left attachment_expanded attachment_expanded_"+attachment.attach_id}>
                                                                          {this.state.savingprogress}
                                                                        </div>
                                                                      ) : null} */}

                                                {/* <div className={"f_sz12 fred mt-1 text-left text-md-right attachment_expanded attachment_expanded_" + attachment.attach_id}>
                                                                        
                                                                        Maximum 1200 characters
                                                                      </div> */}
                                                <div
                                                  className={
                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }>
                                                  {/* {this.state.cmb_notesedit === true ? (
                                                                          <a
                                                                            className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                                            onClick={() => {
                                                                              this.updateNotes2_cmb();
                                                                            }}>
                                                                            Update
                                                                          </a>
                                                                        ) : null} */}
                                                  <a
                                                    className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2"
                                                    onClick={() => {
                                                      this.updateNotes2_cmb();
                                                      this.expanded_attach(attachment.attach_id);
                                                    }}>
                                                    {/* {this.state.savingprogress === "" ? "Save" : this.state.savingprogress} */}
                                                    Save
                                                  </a>
                                                  <a
                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                    onClick={() => this.notesAtchDelte_cmb_edit(attachment.attach_id)}>
                                                    Delete
                                                  </a>
                                                  <a
                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                    onClick={() => {
                                                      this.expanded_attach(attachment.attach_id);
                                                    }}>
                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                  </a>
                                                  {/*<a className="btn btn-sm btn-black crsr_pntr btnpdng_sm"><i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i></a>*/}
                                                </div>
                                                {/* </span> */}
                                                {/* <span  className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                              </div>
                                              <div className="timeline-item ">
                                                <div
                                                  className={
                                                    'timeline-body attachment_colapsed attachment_colapsed_' +
                                                    attachment.attach_id
                                                  }
                                                  style={{ display: 'none' }}>
                                                  <div className="attachmentbody_div">
                                                    Notes Attached
                                                    <a
                                                      className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                      onClick={() => {
                                                        this.colapsed_attach(attachment.attach_id);
                                                        this.oneditnotecmb(attachment);
                                                      }}>
                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                    </a>
                                                  </div>
                                                </div>
                                                {/* </span> */}
                                              </div>
                                            </div>

                                            <div
                                              data-id={index}
                                              key={index}
                                              // draggable="true"
                                              // onDragEnd={this.dragEnd_cmb}
                                              // onDragStart={this.dragStart_cmb}
                                              className={
                                                'notecontent_cmb_show notecontent_cmb_' + attachment.attach_id
                                              }>
                                              <i className="far fa-sticky-note bg_notes attachtype_timelineicon"></i>
                                              <div className="timeline-item ">
                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                <div
                                                  className={
                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }
                                                  onClick={() => {
                                                    this.oneditnotecmb(attachment);
                                                  }}
                                                  style={{ wordWrap: 'break-word' }}>
                                                  <div className="attachmentbody_div">
                                                    <Linkify
                                                      componentDecorator={(decoratedHref, decoratedText, key) => (
                                                        <a target="blank" href={decoratedHref} key={key}>
                                                          {decoratedText}
                                                        </a>
                                                      )}>
                                                      <div
                                                        dangerouslySetInnerHTML={{
                                                          __html: attachment.notes_content,
                                                        }}
                                                      />
                                                      {/* {attachment.notes_content} */}
                                                    </Linkify>
                                                  </div>
                                                </div>

                                                <div
                                                  className={
                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }>
                                                  <a
                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                    id={attachment.attach_id}
                                                    onClick={this.notesAtchDelte_cmb}>
                                                    Delete
                                                  </a>
                                                  <a
                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                    onClick={() => {
                                                      this.expanded_attach(attachment.attach_id);
                                                    }}>
                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                  </a>
                                                  {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                      <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                    </a> */}
                                                </div>
                                                {/* </span> */}
                                                {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                              </div>
                                              <div className="timeline-item ">
                                                <div
                                                  className={
                                                    'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                    attachment.attach_id
                                                  }
                                                  style={{ display: 'none' }}>
                                                  <div className="attachmentbody_div">
                                                    Notes Attached
                                                    <a
                                                      className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                      onClick={() => {
                                                        this.colapsed_attach(attachment.attach_id);
                                                        this.oneditnotecmb(attachment);
                                                      }}>
                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                    </a>
                                                    {/* </span> */}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        ) : attachment.documents ? (
                                          attachment.documents.length > 0 ? (
                                            <div
                                              data-id={index}
                                              key={index}
                                            // draggable="true"
                                            // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                            // onDragStart={(e) => this.dragStart_cmb(e)}
                                            >
                                              <i className="far fa-file-alt bg_documents attachtype_timelineicon" />
                                              <div className="timeline-item ">
                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                <div
                                                  className={
                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }>
                                                  <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                    <span className="font-weight-bold">Documents:</span>
                                                    <br />

                                                    <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                      {attachment.documents.map((documentList, index) => {
                                                        var fileType = documentList.file_name.split('.');
                                                        return (
                                                          <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                            <a onClick={() => this.document_read(documentList)}>
                                                              {documentList?.thumbnail_file_url ? (
                                                                <div className="attachdoc_thumb">
                                                                  <img
                                                                    src={documentList?.thumbnail_file_url}
                                                                    border={0}
                                                                  />
                                                                </div>
                                                              ) : (
                                                                <div className="attachdoc_type text-center">
                                                                  <i className="far fa-file-alt flightgrey1"></i>
                                                                </div>
                                                              )}

                                                              <div className="attachdoc_filenmesze py-1 px-2">
                                                                <table width="100%" cellPadding={0} cellSpacing={0}>
                                                                  <tbody>
                                                                    <tr>
                                                                      <td>
                                                                        {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                        {fileType[fileType.length - 1] === 'pdf' ? (
                                                                          <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'docx' ||
                                                                          fileType[fileType.length - 1] === 'doc' ? (
                                                                          <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'jpg' ||
                                                                          fileType[fileType.length - 1] === 'jpeg' ? (
                                                                          <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'png' ? (
                                                                          <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'csv' ||
                                                                          fileType[fileType.length - 1] === 'xls' ||
                                                                          fileType[fileType.length - 1] === 'xlsx' ? (
                                                                          <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'pptx' ||
                                                                          fileType[fileType.length - 1] === 'ppt' ? (
                                                                          <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                        ) : (
                                                                          <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                        )}

                                                                        <span className="f_sz13 mr-2">
                                                                          {/* {documentList.file_name} */}
                                                                          {documentList?.file_name?.length > 5
                                                                            ? documentList?.file_name.substring(0, 5) +
                                                                            '...' +
                                                                            this.getExtensionFromUrl(
                                                                              documentList?.file_name,
                                                                            )
                                                                            : documentList?.file_name}
                                                                        </span>
                                                                      </td>
                                                                      <td align="right">
                                                                        <span className="f_sz12 flightgrey">
                                                                          {this.bytesToKb(documentList?.file_size)} kB
                                                                        </span>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                            </a>
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className={
                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }>
                                                  <a
                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                    id={attachment.attach_id}
                                                    onClick={(e) => this.documntAtchDelte_cmb(e, attachment.documents)}>
                                                    Delete
                                                  </a>
                                                  <a
                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                    onClick={() => {
                                                      this.expanded_attach(attachment.attach_id);
                                                    }}>
                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                  </a>

                                                  {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                </div>
                                                {/* </span> */}
                                                {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id}  
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}>*/}
                                              </div>
                                              <div className="timeline-item ">
                                                <div
                                                  className={
                                                    'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                    attachment.attach_id
                                                  }
                                                  style={{ display: 'none' }}>
                                                  <div className="attachmentbody_div">
                                                    Document Attached
                                                    <a
                                                      className=" crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                      onClick={() => {
                                                        this.colapsed_attach(attachment.attach_id);
                                                      }}>
                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                    </a>
                                                  </div>
                                                </div>
                                                {/* </span> */}
                                              </div>
                                            </div>
                                          ) : undefined
                                        ) : attachment.images ? (
                                          attachment.images.length > 0 ? (
                                            <div
                                              data-id={index}
                                              key={index}
                                            // draggable="true"
                                            // onDragEnd={this.dragEnd_cmb}
                                            // onDragStart={this.dragStart_cmb}
                                            >
                                              <i className="far fa-image bg_gallery attachtype_timelineicon" />
                                              <div className="timeline-item ">
                                                {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                                <div
                                                  className={
                                                    'timeline-body attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }>
                                                  <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                    {/* <span className="font-weight-bold">Images:</span> */}
                                                    <br />

                                                    <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                      {attachment.images.map((documentList, index) => {
                                                        var fileType = documentList.file_name.split('.');
                                                        return (
                                                          <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                            <a onClick={() => this.document_read(documentList)}>
                                                              {documentList?.thumbnail_file_url ? (
                                                                <div className="attachdoc_thumb">
                                                                  <img
                                                                    src={documentList?.thumbnail_file_url}
                                                                    border={0}
                                                                  />
                                                                </div>
                                                              ) : (
                                                                <div className="attachdoc_type text-center">
                                                                  <i className="far fa-file-alt flightgrey1"></i>
                                                                </div>
                                                              )}

                                                              <div className="attachdoc_filenmesze py-1 px-2">
                                                                <table width="100%" cellPadding={0} cellSpacing={0}>
                                                                  <tbody>
                                                                    <tr>
                                                                      <td>
                                                                        {/* <i className="far fa-file-image attachtype_image f_sz18 mr-2" /> */}
                                                                        {fileType[fileType.length - 1] === 'pdf' ? (
                                                                          <i className="far fa-file-pdf attachtype_pdf f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'docx' ||
                                                                          fileType[fileType.length - 1] === 'doc' ? (
                                                                          <i className="far fa-file-word attachtype_word f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'jpg' ||
                                                                          fileType[fileType.length - 1] === 'jpeg' ? (
                                                                          <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'png' ? (
                                                                          <i className="far fa-file-image attachtype_image f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'csv' ||
                                                                          fileType[fileType.length - 1] === 'xls' ||
                                                                          fileType[fileType.length - 1] === 'xlsx' ? (
                                                                          <i className="far fa-file-excel attachtype_excel f_sz18 mr-2" />
                                                                        ) : fileType[fileType.length - 1] === 'pptx' ||
                                                                          fileType[fileType.length - 1] === 'ppt' ? (
                                                                          <i className="far fa-file-powerpoint attachtype_ppt f_sz18 mr-2" />
                                                                        ) : (
                                                                          <i className="far fa-file attachtype_otherext f_sz18 mr-2" />
                                                                        )}

                                                                        <span className="f_sz13 mr-2">
                                                                          {/* {documentList.file_name} */}
                                                                          {documentList?.file_name?.length > 5
                                                                            ? documentList?.file_name.substring(0, 5) +
                                                                            '...' +
                                                                            this.getExtensionFromUrl(
                                                                              documentList?.file_name,
                                                                            )
                                                                            : documentList?.file_name}
                                                                        </span>
                                                                      </td>
                                                                      <td align="right">
                                                                        <span className="f_sz12 flightgrey">
                                                                          {this.bytesToKb(documentList?.file_size)} kB
                                                                        </span>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                            </a>
                                                            {/* <div className="attachdoc_delete">
                                                                                      <a
                                                                                        href="javascript:void(0)"
                                                                                        className="crsr_pntr">
                                                                                        <i
                                                                                          className="far fa-trash-alt f_sz15"
                                                                                          onClick={this.DocLclDlete_cmb}
                                                                                          id={documentList.file_id}
                                                                                          data-id={attachment.attach_id}
                                                                                        />
                                                                                      </a>
                                                                                    </div> */}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div
                                                  className={
                                                    'timeline-footer attachment_expanded attachment_expanded_' +
                                                    attachment.attach_id
                                                  }>
                                                  <a
                                                    className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                    id={attachment.attach_id}
                                                    onClick={(e) => this.documntAtchDelte_cmb(e, attachment.images)}>
                                                    Delete
                                                  </a>
                                                  <a
                                                    className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                    onClick={() => {
                                                      this.expanded_attach(attachment.attach_id);
                                                    }}>
                                                    <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                  </a>
                                                  {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                          <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                        </a> */}
                                                </div>
                                                {/* </span> */}
                                                {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                      style={{display: "none"}}
                                                                      onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                              </div>
                                              <div className="timeline-item ">
                                                <div
                                                  className={
                                                    'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                    attachment.attach_id
                                                  }
                                                  style={{ display: 'none' }}>
                                                  <div className="attachmentbody_div">
                                                    Image Attached
                                                    <a
                                                      className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                      onClick={() => {
                                                        this.colapsed_attach(attachment.attach_id);
                                                      }}>
                                                      <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                    </a>
                                                  </div>
                                                </div>
                                                {/* </span> */}
                                              </div>
                                            </div>
                                          ) : undefined
                                        ) : attachment.audio_url ? (
                                          <div
                                            data-id={index}
                                            key={index}
                                          // draggable="true"
                                          // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                          // onDragStart={(e) => this.dragStart_cmb(e)}
                                          >
                                            <i className="fas fa-microphone-alt bg_audio attachtype_timelineicon" />
                                            <div className="timeline-item ">
                                              {/* <span className={"attachment_expanded attachment_expanded_"+attachment.audio_id}> */}
                                              <div
                                                className={
                                                  'timeline-body attachment_expanded attachment_expanded_' +
                                                  attachment.audio_id
                                                }>
                                                <div className="attachmentbody_div d-table">
                                                  <div className="d-table-row">
                                                    <div className="d-table-cell align-middle">
                                                      <span>
                                                        <span className="d-inline-block">
                                                          <span className="crsr_pntr">
                                                            <i
                                                              className={
                                                                'far fa-play-circle fa-2x fgreen1 adiPlyICn_toshow adiPlyICn_' +
                                                                attachment.audio_id
                                                              }
                                                              onClick={() => {
                                                                this.audioPly_work(attachment);
                                                              }}
                                                              id={attachment.audio_id}
                                                            />
                                                            <i
                                                              className={
                                                                'fas fa-pause f_sz24 adiPusIcn_tostop adiPusIcn_' +
                                                                attachment.audio_id
                                                              }
                                                              onClick={this.audioPaue}
                                                              id={attachment.audio_id}
                                                              style={{
                                                                display: 'none',
                                                              }}></i>
                                                            <span
                                                              className="ml-2 d-inline-block postop_5up"
                                                            // style={{
                                                            //   display: 'none',
                                                            // }}
                                                            ></span>
                                                            <audio
                                                              className="audioplayer123"
                                                              style={{ width: '258px', display: 'none' }}
                                                              src={
                                                                this.state.play_audio_url
                                                                  ? this.state.play_audio_url
                                                                  : undefined
                                                              }
                                                              controls="controls"
                                                              controlsList="nodownload"
                                                              //hidden
                                                              id={'audio_work_' + attachment.audio_id}
                                                            />
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className={
                                                  'timeline-footer attachment_expanded attachment_expanded_' +
                                                  attachment.audio_id
                                                }>
                                                <a
                                                  className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                  id={attachment.attach_id}
                                                  onClick={this.audioAtchDelte_cmb}>
                                                  Delete
                                                </a>
                                                <a
                                                  className="crsr_pntr btnpdng_sm attach_expdcollapse_btn"
                                                  onClick={() => {
                                                    this.expanded_attach(attachment.audio_id);
                                                  }}>
                                                  <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                </a>
                                                {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm mr-2">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2" />
                                                                      </a> */}
                                              </div>
                                              {/* </span> */}
                                              {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.audio_id}  
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.audio_id)}}>*/}
                                            </div>
                                            <div className="timeline-item ">
                                              <div
                                                className={
                                                  'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                  attachment.audio_id
                                                }
                                                style={{ display: 'none' }}>
                                                <div className="attachmentbody_div">
                                                  Audio Attached
                                                  <a
                                                    className={'crsr_pntr btnpdng_sm attach_expdcollapse_btn'}
                                                    onClick={() => {
                                                      this.colapsed_attach(attachment.audio_id);
                                                    }}>
                                                    <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                  </a>
                                                  {/* </span> */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : attachment.video_url ? (
                                          <div
                                            data-id={index}
                                            key={index}
                                          // draggable="true"
                                          // onDragEnd={(e) => this.dragEnd_cmb(e)}
                                          // onDragStart={(e) => this.dragStart_cmb(e)}
                                          >
                                            <i className="fas fa-film bg_video attachtype_timelineicon"></i>
                                            <div className="timeline-item">
                                              {/* <span className={"attachment_expanded attachment_expanded_"+attachment.attach_id}> */}
                                              <div
                                                className={
                                                  'timeline-body attachment_expanded attachment_expanded_' +
                                                  attachment.attach_id
                                                }>
                                                <div className="attachmentbody_div w-100 d-flex flex-row flex-wrap">
                                                  <span className="font-weight-bold">Video:</span>
                                                  <br />
                                                  <div className="attachdocuments_dsply w-100 d-flex flex-row flex-wrap mt-3">
                                                    <a onClick={() => this.Video_play_url(attachment)}>
                                                      {/* <div className="attachdoc_listitem position-relative mr-4 mb-5 mb-md-4">
                                                              <div className="attachdoc_type text-center">
                                                                <i className="fas fa-video" />
                                                              </div>
                                                              <div className="attachdoc_name">
                                                                Click here to
                                                                play video
                                                              </div>
                                                            </div> */}
                                                      <div className="attachdoc_listitemvideo position-relative mr-4 mb-5 mb-md-4">
                                                        <div className="attachvideo_thumb d-flex align-items-center justify-content-center">
                                                          {/* <img src={} border={0} /> */}
                                                          <i className="fas fa-video fa-3x" />
                                                        </div>
                                                        <div className="attachvideo_gif">
                                                          {/* <img src={} border={0} /> */}
                                                          Click here to play video
                                                        </div>
                                                      </div>
                                                      {/* <div className="attachdoc_delete"><a href="javascript:void(0)" className="crsr_pntr"><i className="far fa-trash-alt f_sz15" /></a></div> */}
                                                    </a>
                                                  </div>
                                                </div>
                                                {/* <div className="attachmentbody_div d-table">
                                                        <div className="d-table-row">
                                                          <div className="d-table-cell align-middle">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                              <div className="videoWrapper">
                                                                <video
                                                                  onPlay={() =>
                                                                    this.Video_play_url(
                                                                      attachment
                                                                    )
                                                                  }
                                                                  width="300"
                                                                  controls
                                                                  playsinline
                                                                >
                                                                  
                                                                  <source
                                                                    src={
                                                                      this.state
                                                                        .video_play_link
                                                                    }
                                                                    type="video/mp4"
                                                                  />                                                                
                                                                </video>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div> */}
                                              </div>
                                              <div
                                                className={
                                                  'timeline-footer attachment_expanded attachment_expanded_' +
                                                  attachment.attach_id
                                                }>
                                                <a
                                                  className="btn btn-sm btn-secondary crsr_pntr btnpdng_sm mr-2"
                                                  id={attachment.attach_id}
                                                  onClick={this.videAtchDelte_cmb}>
                                                  Delete
                                                </a>
                                                <a
                                                  className={'crsr_pntr btnpdng_sm attach_expdcollapse_btn'}
                                                  onClick={() => {
                                                    this.expanded_attach(attachment.attach_id);
                                                  }}>
                                                  <i className="fas fa-compress-arrows-alt f_sz17 ln_hgt2" />
                                                </a>
                                                {/* <a className="btn btn-sm btn-black crsr_pntr btnpdng_sm">
                                                                        <i className="fas fa-arrows-alt f_sz17 ln_hgt2"></i>
                                                                      </a> */}
                                              </div>
                                              {/* </span> */}
                                              {/* <span className={"attachment_colapsed attachment_colapsed_"+attachment.attach_id} 
                                                                    style={{display: "none"}}
                                                                    onClick={()=>{this.colapsed_attach(attachment.attach_id)}}> */}
                                            </div>
                                            <div className="timeline-item ">
                                              <div
                                                className={
                                                  'timeline-body  attachment_colapsed attachment_colapsed_' +
                                                  attachment.attach_id
                                                }
                                                style={{ display: 'none' }}>
                                                <div className="attachmentbody_div">
                                                  Video Attached
                                                  <a
                                                    className={'crsr_pntr btnpdng_sm attach_expdcollapse_btn'}
                                                    onClick={() => {
                                                      this.colapsed_attach(attachment.attach_id);
                                                    }}>
                                                    <i className="fas fa-expand-arrows-alt f_sz17 ln_hgt2" />
                                                  </a>
                                                  {/* </span> */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null;
                                      })}

                                      <div>
                                        <i className="fas fa-circle bg-gray" style={{ fontSize: 'x-small' }} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="card-footer bg-transparent text-center p-0"
                              onClick={() => this.hide_emoji()}>
                              <span
                                style={{ display: !this.state.edit_startpnt_msg ? 'inline-block' : 'none' }}
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                onClick={() => (!this.state.disable_send_msg ? this.onAdd_step_send_message() : null)}
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                {!this.state.edit_startpnt_msg ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            <div className="modal fade" id="modal_wfupdcontact">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Update Contact</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.workflow_update_contact_close()}>
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Contact will be updated based on the below
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row mb-0">
                                  <div className="col-12 col-sm-12 col-md-12 px-0 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-5 mb-3">
                                        <div className="mrgntop_10">Choose</div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-7">
                                        <div className="select_style">
                                          <select className="form-control updcontactsel">
                                            <option value="">--Select--</option>
                                            <option value="contacts">Update Property</option>
                                            <option value="assign_tags">Assign Tag</option>
                                            <option value="remove_tags">Remove Tag</option>
                                            <option value="notes">Update Notes</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="contacts updct" style={{ display: 'none' }}>
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0 mt-2">
                                    <h6 className="w-100">Update Property</h6>
                                  </div>
                                  <div className="form-group row mb-0">
                                    <div className="col-12 col-sm-12 col-md-12 px-0 mt-2">
                                      <div className="w-100 d-flex flex-row flex-wrap">
                                        <div className="col-12 col-sm-12 col-md-5 mb-3">
                                          <div className="select_style">
                                            <select className="form-control" id="custome_properties_updated_contact">
                                              <option value="">--Select--</option>
                                              {this.state?.business_info_array.business?.add_property?.map(
                                                (properties, index) => {
                                                  //  if (properties.label_name != 'Email') {
                                                  // console.log('properties', properties);
                                                  return (
                                                    <option value={properties._id}>{properties.label_name}</option>
                                                  );
                                                  // }
                                                },
                                              )}
                                            </select>
                                          </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-7">
                                          <div className="select_style">
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter the value"
                                              id="company_updated_value"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="assign_tags updct" style={{ display: 'none' }}>
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0 mt-3">
                                    <h6 className="w-100">Assign contact to the Tag</h6>
                                  </div>
                                  <div className="form-group row mb-0">
                                    <div className="col-12 col-sm-12 col-md-12 px-0 mt-2">
                                      <div className="w-100 d-flex flex-row flex-wrap wftags_chkbxlbl wftags_chkxhgt scrollbar_style">
                                        {this.state?.tag_list?.map((tag_lists, index) => {
                                          return (
                                            <div className="col-12 col-sm-12 col-md-12">
                                              <div className="icheck-darkgrey d-inline-block py-1">
                                                <input
                                                  type="checkbox"
                                                  id={index + 'assign'}
                                                  value={tag_lists._id}
                                                  className="assign_tags selected_tags"
                                                />
                                                <label htmlFor={index + 'assign'}>{tag_lists.tag_name}</label>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="remove_tags updct" style={{ display: 'none' }}>
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0 mt-3">
                                    <h6 className="w-100">Remove contact from the Tag</h6>
                                  </div>
                                  <div className="form-group row mb-0">
                                    <div className="col-12 col-sm-12 col-md-12 px-0 mt-2">
                                      <div className="w-100 d-flex flex-row flex-wrap wftags_chkbxlbl wftags_chkxhgt scrollbar_style">
                                        {this.state?.tag_list?.map((tag_lists, index) => {
                                          return (
                                            <div className="col-12 col-sm-12 col-md-12">
                                              <div className="icheck-darkgrey d-inline-block py-1">
                                                <input
                                                  type="checkbox"
                                                  id={index + 'remove'}
                                                  value={tag_lists._id}
                                                  className="assign_tags removed_tags"
                                                />
                                                <label htmlFor={index + 'remove'}>{tag_lists.tag_name}</label>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="notes updct" style={{ display: 'none' }}>
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0 mt-3">
                                    <h6 className="w-100">Update Notes</h6>
                                  </div>
                                  <div className="form-group row mb-0">
                                    <div className="col-12 col-sm-12 col-md-12 px-0 mt-2">
                                      <div className="w-100 d-flex flex-row flex-wrap">
                                        <div className="col-12 col-sm-12 col-md-12 mb-3">
                                          <textarea
                                            className="form-control textarea_hgt80 txtarea_resizenone"
                                            placeholder="Enter the Notes"
                                            id="update_contact_notes"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_wfstep"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                onClick={() => (!this.state.disable_tag ? this.onAdd_if_else_update_contcat() : null)}
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm">
                                {!this.state.edit_step_inbound ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_exitpoint">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Exit and restart conditions</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        <p>
                          Contacts exit a workflow when they reach the final step, or no longer match the conditions to
                          move forward.
                        </p>
                        <p>
                          Override this default at any step by inserting conditions to require contacts to exit and/or
                          restart the workflow.
                        </p>
                        <div className="w-100 d-flex flex-row flex-wrap">
                          <p className="w-100">
                            <span className="font-weight-bold">Exit the workflow</span>
                            <br />
                            If any of these condition are true:
                          </p>
                          <table
                            width="100%"
                            cellPadding={0}
                            cellSpacing={0}
                            className="table table-hover table-bordered">
                            <tbody>
                              <tr>
                                <td>When there is inbound message</td>
                                <td className="text-center">
                                  <a
                                    href
                                    className="fmaroon crsr_pntr"
                                    data-toggle="modal"
                                    data-target="#modal_exitpt_inboundmsg"
                                    data-backdrop="static"
                                    data-dismiss="modal">
                                    <i
                                      className="fas fa-pen"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title
                                      data-original-title="Edit"
                                    />
                                  </a>
                                  <a href className="ml-3 fmaroon">
                                    <i
                                      className="fas fa-trash-alt"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title
                                      data-original-title="Delete"
                                    />
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p className="w-100">
                            <a
                              data-toggle="modal"
                              data-target="#modal_exitpt_cond"
                              data-backdrop="static"
                              data-dismiss="modal"
                              className="fmaroon crsr_pntr f_sz13">
                              Add a condition
                            </a>
                          </p>
                        </div>
                        <div className="mt-2 w-100 d-flex flex-row flex-wrap">
                          <p className="w-100">
                            <span className="font-weight-bold">Restart the workflow</span>
                            <br />
                            If any of these condition are true:
                          </p>
                          <table
                            width="100%"
                            cellPadding={0}
                            cellSpacing={0}
                            className="table table-hover table-bordered">
                            <tbody>
                              <tr>
                                <td>When there is inbound message</td>
                                <td className="text-center">
                                  <a
                                    href
                                    className="fmaroon crsr_pntr"
                                    data-toggle="modal"
                                    data-target="#modal_exitpt_inboundmsg"
                                    data-backdrop="static"
                                    data-dismiss="modal">
                                    <i
                                      className="fas fa-pen"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title
                                      data-original-title="Edit"
                                    />
                                  </a>
                                  <a href className="ml-3 fmaroon">
                                    <i
                                      className="fas fa-trash-alt"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      title
                                      data-original-title="Delete"
                                    />
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p className="w-100">
                            <a
                              data-toggle="modal"
                              data-target="#modal_restartpt_cond"
                              data-backdrop="static"
                              data-dismiss="modal"
                              className="fmaroon crsr_pntr f_sz13">
                              Add a condition
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_exitpt_cond">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Add an exit condition</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypoints_list scrollbar_style wf_entrypoints_listhgt">
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_exitpt_inboundmsg"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="far fa-arrow-alt-circle-down f_sz22" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">When there is inbound message</div>
                          </div>
                          <div className="mb-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_exitpt_inboundmsg">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">When there is inbound message</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Stop this workflow when there is inbound message with or without [THIS] content.
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title
                          data-original-title="You can filter contacts based on the content in inbound messages"
                        />
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row mb-0">
                                  <div className="col-12 col-sm-12 col-md-5 px-0 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-12 mb-3">
                                        <div className="select_style">
                                          <select className="form-control">
                                            <option>--Select--</option>
                                            <option value="equalto">Equal to</option>
                                            <option value="startwith">Starts with</option>
                                            <option value="contains">Contains</option>
                                            <option value="contains">No specification</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-sm-12 col-md-7 px-0 mt-2">
                                    <input type="text" className="form-control" placeholder="Enter the value" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_exitpt_cond"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                data-toggle="modal"
                                data-target="#modal_exitpoint"
                                data-backdrop="static"
                                data-dismiss="modal">
                                Ok
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_restartpt_cond">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Add a restart condition</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypoints_list scrollbar_style wf_entrypoints_listhgt">
                        <div className="wf_entrypoints_item">
                          <div className="wf_entrypoints_tblrow crsr_pntr">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-user-friends f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">For given contact(s)</div>
                          </div>
                          <div className="mb-2" />
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_restartpt_tags"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-tags f_sz16" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">For given tag(s)</div>
                          </div>
                          <div className="mb-2" />
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_restartpt_inboundmsg"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="far fa-arrow-alt-circle-down f_sz22" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">
                              If there is inbound message with or without [THIS] content.
                            </div>
                          </div>
                          <div className="mb-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_restartpt_inboundmsg">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">When there is inbound message</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Start this workflow when there is inbound message with or without [THIS] content.
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          data-place="bottom"
                          title="You can filter contacts based on the content in inbound messages"
                        // data-tip="You can filter contacts based on the content in inbound messages"
                        />
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row mb-0">
                                  <div className="col-12 col-sm-12 col-md-5 px-0 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-12 mb-3">
                                        <div className="select_style">
                                          <select className="form-control">
                                            <option>--Select--</option>
                                            <option value="equalto">Equal to</option>
                                            <option value="startwith">Starts with</option>
                                            <option value="contains">Contains</option>
                                            <option value="contains">No specification</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-sm-12 col-md-7 px-0 mt-2">
                                    <input type="text" className="form-control" placeholder="Enter the value" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_restartpt_cond"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                data-toggle="modal"
                                data-target="#modal_exitpoint"
                                data-backdrop="static"
                                data-dismiss="modal">
                                Ok
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_restartpt_tags">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">For given tag(s)</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        Start this workflow for the given tag(s).
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          data-place="bottom"
                          title="You can filter contacts based on the given tag(s)"
                          data-tip="You can filter contacts based on the given tag(s)"
                        />
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div className="searchtag_modaldiv"></div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_restartpt_cond"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                                data-toggle="modal"
                                data-target="#modal_exitpoint"
                                data-backdrop="static"
                                data-dismiss="modal">
                                Ok
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_wfifelse_cond">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">If / Else conditions</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypoints_list scrollbar_style wf_entrypoints_listhgt">
                        <div className="wf_entrypoints_item">
                          <div className="wf_entrypoints_tblrow crsr_pntr wfentrypt_contactstgl">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-user-friends f_sz18" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">For given contact(s)</div>
                          </div>
                        </div>
                        <div className="w-100 mt-2 ml-5 wfentrypt_contactstgl_div" style={{}}>
                          <div className="wf_entrypoints_item">
                            <div
                              className="wf_entrypoints_tblrow crsr_pntr"
                              data-toggle="modal"
                              data-target="#modal_entrypt_customprop"
                              data-backdrop="static"
                              data-dismiss="modal">
                              <div className="wf_entrypoints_tbltd text-center">
                                <span>
                                  <i className="fas fa-list-alt f_sz20" />
                                </span>
                              </div>
                              <div className="wf_entrypoints_tbltd">Custom Properties</div>
                            </div>
                          </div>
                          <div className="w-100 mb-2" />
                        </div>
                        <div className="w-100 mb-2" />
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr inbtags"
                            data-toggle="modal"
                            data-target="#modal_entrypt_tags_if"
                            data-backdrop="static"
                            data-dismiss="modal"
                          // onClick={() => this.step_ifelse_inbound_close()}
                          >
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="fas fa-tags f_sz16" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">For given tag(s)</div>
                          </div>
                        </div>
                        <div className="w-100 mb-2" />

                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfifelse_inboundmsg"
                            data-backdrop="static"
                            data-dismiss="modal"
                            onClick={() => this.step_ifelse_inbound_close()}>
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="far fa-arrow-alt-circle-down f_sz22" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">
                              If there is inbound message with or without [THIS] content.
                            </div>
                          </div>
                          <div className="mb-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_wfifelse_inboundmsg">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">When there is inbound message</h5>
                    <button
                      type="button"
                      className="close step_ifelse_inbound_close"
                      onClick={() => this.step_ifelse_inbound_close()}
                      data-dismiss="modal"
                      aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        The workflow will check if a contact sends a message.
                        <i
                          className="fas fa-info-circle f_sz16 ml-2"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title
                          data-original-title="You can filter and start a workflow when your contact sends a message."
                        />
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row mb-0">
                                  <div className="col-12 col-sm-12 col-md-5 px-0 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-12 mb-3">
                                        <div className="select_style">
                                          <select
                                            onChange={(e) => this.setState({ inbound_cond_ifelse: e.target.value })}
                                            id="stepinbound"
                                            className="form-control">
                                            <option value="">--Select--</option>
                                            <option value="equal_to">Equal to</option>
                                            <option value="start_with">Starts with</option>
                                            <option value="contains">Contains</option>
                                            <option value="no_specification">No specification</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-sm-12 col-md-7 px-0 mt-2">
                                    <input
                                      id="inbvalue"
                                      disabled={this.state.inbound_cond_ifelse === 'no_specification' ? true : false}
                                      type="text"
                                      className="form-control"
                                      onChange={(e) => this.setState({ inbound_content_ifelse: e.target.value })}
                                      placeholder="Enter the value"
                                      maxLength="120"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_wfifelse_cond"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span
                                className="btn btn-black crsr_pntr m-2 btnpdng_sm if"
                                onClick={() => (!this.state.disable_step_inbound ? this.onAdd_step_ifelse() : null)}>
                                {!this.state.edit_step_inbound ? 'Ok' : 'Update'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_wfwaituntil_cond">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Wait until</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypoints_list scrollbar_style wf_entrypoints_listhgt">
                        <div className="wf_entrypoints_item">
                          <div
                            className="wf_entrypoints_tblrow crsr_pntr"
                            data-toggle="modal"
                            data-target="#modal_wfwaituntil_inboundmsg"
                            data-backdrop="static"
                            data-dismiss="modal">
                            <div className="wf_entrypoints_tbltd text-center">
                              <span>
                                <i className="far fa-arrow-alt-circle-down f_sz22" />
                              </span>
                            </div>
                            <div className="wf_entrypoints_tbltd">
                              If there is inbound message with or without [THIS] content.
                            </div>
                          </div>
                          <div className="mb-2" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_wfwaituntil_inboundmsg">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">When there is inbound message</h5>
                    <button type="button" className="close " data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        This workflow will wait until there is inbound message before continuing.
                        <div className="form-horizontal formbiglbl">
                          <div className="card p-0 mb-0 shadow-none">
                            <div className="card-body px-0">
                              <div>
                                <div className="form-group row mb-0">
                                  <div className="col-12 col-sm-12 col-md-5 px-0 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-12 mb-3">
                                        <div className="select_style">
                                          <select className="form-control">
                                            <option>--Select--</option>
                                            <option value="equalto">Equal to</option>
                                            <option value="startwith">Starts with</option>
                                            <option value="contains">Contains</option>
                                            <option value="contains">No specification</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-sm-12 col-md-7 px-0 mt-2">
                                    <input type="text" className="form-control" placeholder="Enter the value" />
                                  </div>
                                </div>
                                <div className="mt-3">
                                  Contacts who have not carried out this action will exit the step after:
                                </div>
                                <div className="form-group row mb-0">
                                  <div className="col-3 col-sm-3 col-md-3 mt-2">
                                    <input type="text" className="form-control" />
                                  </div>
                                  <div className="col-9 col-sm-9 col-md-5 mt-2">
                                    <div className="w-100 d-flex flex-row flex-wrap">
                                      <div className="col-12 col-sm-12 col-md-12 mb-3">
                                        <div className="select_style">
                                          <select className="form-control">
                                            <option>--Select--</option>
                                            <option value="minute">minute(s)</option>
                                            <option value="hour">hour(s)</option>
                                            <option value="day">day(s)</option>
                                            <option value="week">week(s)</option>
                                            <option value="month">month(s)</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer bg-transparent text-center p-0">
                              <span
                                className="m-2 crsr_pntr"
                                data-toggle="modal"
                                data-target="#modal_wfwaituntil_cond"
                                data-backdrop="static"
                                data-dismiss="modal">
                                <span className="f_sz15">
                                  <i className="fas fa-long-arrow-alt-left mr-2" />
                                  Back
                                </span>
                              </span>
                              <span className="btn btn-black crsr_pntr m-2 btnpdng_sm" data-dismiss="modal">
                                Ok
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            <div className="modal fade modal_custom_600" id="modal_wfdeactivate">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Deactivate Workflow</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        <p>
                          Your workflow will be deactivated. No new contacts will enter the workflow until you enable it
                          and all contacts currently in the workflow will be deleted from it.
                        </p>
                        <p>
                          <span className="font-weight-bold">Note:</span> It might take few minutes to deactivate your
                          workflow and until this process is finished you won't be able to activate it again.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <span
                      className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                      onClick={() => {
                        this.onupdate_workflow_status(this.state.workflow_status_data, 'deactive');
                      }}
                      data-dismiss="modal">
                      Ok
                    </span>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            <div className="modal fade" id="modal_deletewebhoos">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    {/* <h5 className="modal-title">Garrett Winters</h5> */}
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="card w-100 shadow-none">
                        <div className="card-body p-0">
                          <div className="text-center f_sz16 mt-3">Are you sure you want to delete this webhook?</div>
                        </div>
                        <div className="card-footer bg-transparent">
                          <div className="text-center mt-3">
                            <input type="hidden" id="webhook_id" />
                            <a href="#" className="btn btn-sm1 btn-black crsr_pntr btnpdng_sm mr-2 del_webhook">
                              Yes
                            </a>
                            <a href="#" className="btn btn-sm1 btn-black crsr_pntr btnpdng_sm close_del">
                              No
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>

            {/* /.modal */}
            <div className="modal fade modal_custom_600" id="modal_wfpause">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title fmaroon">Pause Workflow</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" className="postop_5">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="popupcontent_div">
                      <div className="wf_entrypt_specification">
                        <p>
                          Your workflow will be paused. No new contacts will enter the workflow until you enable it but
                          all contacts currently in the workflow can continue until the last step.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <span
                      className="btn btn-black crsr_pntr m-2 btnpdng_sm"
                      onClick={() => {
                        this.onupdate_workflow_status(this.state.workflow_status_data, 'inactive');
                      }}
                      data-dismiss="modal">
                      Ok
                    </span>
                  </div>
                </div>
                {/* /.modal-content */}
              </div>
              {/* /.modal-dialog */}
            </div>
            <BusinessVerification />
            {/* /.modal */}
            <div>
              <div className="modal fade modal_custom_600" id="modal_activecontacts">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title fmaroon">
                        {this.state.workflow_contacts_list_type === 'active'
                          ? 'Active Contacts'
                          : this.state.workflow_contacts_list_type === 'finished'
                            ? 'Finished Contacts'
                            : this.state.workflow_contacts_list_type === 'started'
                              ? 'Started Contacts'
                              : 'Suspended Contacts'}{' '}
                        ({this.state.workflow_contacts_list_arr?.length}) -{' '}
                        <span className="f_sz15 fgrey">{this.state.workflow_contacts_list_data?.workflow_name}</span>
                      </h5>
                      <button
                        onClick={() => {
                          this.workflow_contacts_list_close();
                        }}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close">
                        <span aria-hidden="true" className="postop_5">
                          ×
                        </span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="popupcontent_div">
                        <div className="wf_entrypt_specification">
                          <div className="form-horizontal formbiglbl">
                            <div className="card p-0 mb-0 shadow-none">
                              <div className="card-body p-0">
                                <div className="searchcontacts_modaldiv">
                                  <div className="wfhistorycontacts_tbldiv_modal scrollbar_style scrollbar_style1">
                                    <table
                                      className="table table-hover table-bordered"
                                      cellPadding={0}
                                      cellSpacing={0}
                                      style={{ width: '100%' }}
                                      id="wfactivects_tbl">
                                      <thead>
                                        <tr>
                                          <th>Time Stamp</th>
                                          <th>Contact Name</th>
                                          <th>Phone Number</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.workflow_contacts_list_arr?.map((contact, index) => {
                                          return (
                                            <tr>
                                              <td>
                                                {this.state.workflow_contacts_list_type === 'finished'
                                                  ? moment(contact?.updated_date).format('MMMM DD,YYYY hh:mma')
                                                  : moment(contact?.created_date).format('MMMM DD,YYYY hh:mma')}
                                              </td>
                                              <td>
                                                {contact.contact_info[0]?.first_name}{' '}
                                                {contact.contact_info[0]?.last_name}
                                              </td>
                                              <td>
                                                {contact.contact_info[0]?.phone_number
                                                  .toString()
                                                  .substring(1)
                                                  .replace(/[^\dA-Z]/g, '')
                                                  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                                  .trim()}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /.modal-content */}
                </div>
                {/* /.modal-dialog */}
              </div>

              <div>
                <div className="modal fade modal_custom_600" id="modal_historyifelse_yes_steps">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title fmaroon">
                          If / Else - <span className="fgreen5">YES</span>
                        </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true" className="postop_5">
                            ×
                          </span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="popupcontent_div">
                          <div className="wf_entrypt_specification">
                            <p>
                              <span className="font-weight-bold">Filter</span> - inbound message with "1". -{' '}
                              <span className="fgreen5 font-weight-bold">YES</span>
                            </p>
                            <div className="form-horizontal formbiglbl">
                              <div className="card p-0 mb-0 shadow-none">
                                <div className="card-body p-0">
                                  <div className="searchcontacts_modaldiv">
                                    <div className="wfhistorycontacts_tbldiv_modal scrollbar_style scrollbar_style1">
                                      <table
                                        className="table table-hover table-bordered"
                                        cellPadding={0}
                                        cellSpacing={0}
                                        style={{ width: '100%' }}
                                        id="wfhistoryifelsects_yes_tbl">
                                        <thead>
                                          <tr>
                                            <th>Date Time</th>
                                            <th>Contact Name</th>
                                            <th>Phone Number</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>6/16/2021 6.55pm</td>
                                            <td>Tiger Nixon</td>
                                            <td>(123) 456-8523 </td>
                                          </tr>
                                          <tr>
                                            <td>6/16/2021 8.55am</td>
                                            <td>Ashton Cox</td>
                                            <td>(123) 789-8523 </td>
                                          </tr>
                                          <tr>
                                            <td>6/15/2021 7.55am</td>
                                            <td>Cedric Kelly</td>
                                            <td>(852) 369-7425 </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.modal-content */}
                  </div>
                  {/* /.modal-dialog */}
                </div>
                {/* /.modal */}
                <div className="modal fade modal_custom_600" id="modal_historyifelse_no_steps">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title fmaroon">
                          If / Else - <span className="fred1">NO</span>
                        </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true" className="postop_5">
                            ×
                          </span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="popupcontent_div">
                          <div className="wf_entrypt_specification">
                            <p>
                              <span className="font-weight-bold">Filter</span> - inbound message with "1". -{' '}
                              <span className="fred1 font-weight-bold">NO</span>
                            </p>
                            <div className="form-horizontal formbiglbl">
                              <div className="card p-0 mb-0 shadow-none">
                                <div className="card-body p-0">
                                  <div className="searchcontacts_modaldiv">
                                    <div className="wfhistorycontacts_tbldiv_modal scrollbar_style scrollbar_style1">
                                      <table
                                        className="table table-hover table-bordered"
                                        cellPadding={0}
                                        cellSpacing={0}
                                        style={{ width: '100%' }}
                                        id="wfhistoryifelsects_no_tbl">
                                        <thead>
                                          <tr>
                                            <th>Date Time</th>
                                            <th>Contact Name</th>
                                            <th>Phone Number</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>6/15/2021 6.50am</td>
                                            <td>Donna Snider</td>
                                            <td>(856) 963-639 </td>
                                          </tr>
                                          <tr>
                                            <td>6/15/2021 5.50am</td>
                                            <td>Airi Satou</td>
                                            <td>(745) 852-9639 </td>
                                          </tr>
                                          <tr>
                                            <td>6/15/2021 5.45am</td>
                                            <td>Brielle Williamson</td>
                                            <td>(869) 452-7896 </td>
                                          </tr>
                                          <tr>
                                            <td>6/15/2021 5.00am</td>
                                            <td>Details Message</td>
                                            <td>(888) 639-7896 </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.modal-content */}
                  </div>
                  {/* /.modal-dialog */}
                </div>
                <div className="modal fade modal_custom_600" id="modal_historycontacts">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title fmaroon">
                          {this.state.workflow_entry_contact_data.select_entry_point === 'tags'
                            ? 'For given tag(s)'
                            : 'For given contact(s)'}
                        </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true" className="postop_5">
                            ×
                          </span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="popupcontent_div">
                          <div className="wf_entrypt_specification">
                            <div className="form-horizontal formbiglbl">
                              <div className="card p-0 mb-0 shadow-none">
                                <div className="card-body py-0">
                                  <div className="searchcontacts_modaldiv">
                                    <div className="wfhistorycontacts_tbldiv_modal scrollbar_style scrollbar_style1">
                                      <table
                                        className="table table-hover table-bordered"
                                        cellPadding={0}
                                        cellSpacing={0}
                                        style={{ width: '100%' }}
                                        id="wfhistorycts_tbl">
                                        <thead>
                                          <tr>
                                            <th>Contact Name</th>
                                            <th>Phone Number</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.workflow_entry_contact_array?.map((contact, index) => {
                                            return (
                                              <tr>
                                                <td>
                                                  {contact.first_name} {contact.last_name}
                                                </td>
                                                <td>
                                                  {contact.phone_number
                                                    .toString()
                                                    .substring(1)
                                                    .replace(/[^\dA-Z]/g, '')
                                                    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                                    .trim()}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.modal-content */}
                  </div>
                  {/* /.modal-dialog */}
                </div>
                {/* /.modal */}

                <div className="modal fade modal_custom_600" id="modal_historycontacts_steps">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title fmaroon">
                          {this.state.workflow_steps_contact_array_data.type === 'delay'
                            ? 'Wait'
                            : this.state.workflow_steps_contact_array_data.type === 'send_message'
                              ? 'Send Message'
                              : 'If / Else'}{' '}
                          - Contacts
                        </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true" className="postop_5">
                            ×
                          </span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="popupcontent_div">
                          <div className="wf_entrypt_specification">
                            <p>{this.state.workflow_steps_contact_array_data.message}</p>
                            <span
                              style={{
                                display:
                                  this.state.workflow_steps_contact_array_data.type === 'delay' ? 'block' : 'none',
                              }}>
                              For{' '}
                              <span className="font-weight-bold ">
                                {this.state.workflow_steps_contact_array_data.delay_count}{' '}
                                {this.state.workflow_steps_contact_array_data.delay_time === 'minutes'
                                  ? 'Minute(s)'
                                  : this.state.workflow_steps_contact_array_data.delay_time === 'hours'
                                    ? 'Hour(s)'
                                    : this.state.workflow_steps_contact_array_data.delay_time === 'days'
                                      ? 'Day(s)'
                                      : this.state.workflow_steps_contact_array_data.delay_time === 'weeks'
                                        ? 'Week(s)'
                                        : 'Month(s)'}
                              </span>
                            </span>
                            <span
                              style={{
                                display:
                                  this.state.workflow_steps_contact_array_data.type === 'if_else' ? 'block' : 'none',
                              }}>
                              Filter -{' '}
                              {this.state.workflow_steps_contact_array_data.inbound_type === 'equal_to'
                                ? 'Equal to'
                                : this.state.workflow_steps_contact_array_data.inbound_type === 'start_with'
                                  ? 'Starts with'
                                  : this.state.workflow_steps_contact_array_data.inbound_type === 'contains'
                                    ? 'Contains'
                                    : this.state.workflow_steps_contact_array_data.inbound_type === 'no_specification'
                                      ? 'No Specification'
                                      : ''}{' '}
                              <span className="font-weight-bold fmaroon">
                                {this.state.workflow_steps_contact_array_data.inbound_content}
                              </span>
                            </span>
                            <div className="form-horizontal formbiglbl">
                              <div className="card p-0 mb-0 shadow-none">
                                <div className="card-body p-0">
                                  <div className="searchcontacts_modaldiv">
                                    <div className="wfhistorycontacts_tbldiv_modal scrollbar_style scrollbar_style1">
                                      <table
                                        className="table table-hover table-bordered"
                                        cellPadding={0}
                                        cellSpacing={0}
                                        style={{ width: '100%' }}
                                        id="wfhistorysendmsgcts_tbl">
                                        <thead>
                                          <tr>
                                            <th>Date Time</th>
                                            <th>Contact Name</th>
                                            <th>Phone Number</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.workflow_steps_contact_array?.map((contact, index) => {
                                            return (
                                              <tr>
                                                <td>
                                                  {' '}
                                                  {moment(contact?.read_updated_date).format('MMMM DD,YYYY hh:mma')}
                                                </td>
                                                <td>
                                                  {contact.first_name} {contact.last_name}
                                                </td>
                                                <td>
                                                  {contact.phone_number
                                                    .toString()
                                                    .substring(1)
                                                    .replace(/[^\dA-Z]/g, '')
                                                    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                                                    .trim()}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.modal-content */}
                  </div>
                  {/* /.modal-dialog */}
                </div>
              </div>
            </div>
          </div>
          {/* File Upload Div */}

          {/* Main Footer */}
          {/* <footer className="main-footer">
     
      <strong>Copyright © 2020 <a href className="fmaroon">Redtie</a>.</strong> All rights reserved.
    </footer> */}
        </div>
        {/* <ReactTooltip /> */}
      </div>
    );
  }
}

function TagTxtbxFormGroup(props) {
  var rowNumber = props.rw + 1;
  var ttl_length = props.ttllngth;

  return (
    <div className="form-group row mt-3 mb-4">
      <div className="col-10 col-sm-10 col-md-10 col-lg-10">
        <input
          type="text"
          className="form-control"
          placeholder="Enter the New Tag"
          value={props.value}
          onChange={props.TaginputChange}
        />
      </div>
      <div className="col-2 col-sm-2 col-md-2 col-lg-2">
        {rowNumber > 1 ? (
          <a className="crsr_pntr">
            <i className="fas fa-trash-alt mt-3 mr-3 f_sz16 crsr_pntr fmaroon" onClick={props.TagDelonClick} />
          </a>
        ) : null}
        {rowNumber == ttl_length ? (
          <a className="crsr_pntr">
            <i className="fas fa-plus-circle mt-3 f_sz18 crsr_pntr fmaroon" onClick={props.TagPlsclick} />
          </a>
        ) : null}
      </div>
    </div>
  );
}

function TagTxtbxAddButton(props) {
  return (
    <a className="btn btn-black crsr_pntr m-2 btnpdng_sm" onClick={props.TagSaveclick} id="tag_saveBtb">
      Save
    </a>
  );
}

function AutoTxtRespnsFrmGrp(props) {
  var numbr = props.arealabel + 1;
  var LastVlu = props.ttl_lgth;
  if (LastVlu == numbr) {
    var labl = ordinal_suffix_of(numbr) + ' onwards';
  } else {
    var labl = ordinal_suffix_of(numbr);
  }

  //if(numbr == "1"){ var labl = numbr+"st"; }
  //(numbr > 1 && numbr < 4 ){ var labl = numbr+"nd Onwards"; }
  //if(numbr > 3 && numbr < 13){ var labl = numbr+"th Onwards"; }
  //if(numbr > 12 && numbr < 19){ var labl = numbr+"th Onwards"; }
  return (
    <>
      <div className="form-group row mt-2 mb-2">
        {/* <label className="col-12 col-sm-12 col-md-6 col-lg-4 col-form-label pdngtop_10"><span className="f_sz15">{labl}</span></label> */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
          <textarea
            className="form-control textarea_hgt100 txtarea_resizenone"
            placeholder="Enter the Message"
            value={props.value}
            onChange={props.AutoTxtOnChngFrm}
            onClick={props.onClickclose}
            maxLength="300"
            id="get_data_for_inbound"
          />
        </div>
        <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap">
          <div className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_inbound_show emoji_show_all">
            <i className="far fa-smile flightgrey3 f_sz18 mt-1 crsr_pntr position-relative" onClick={props.onClick} />
            <a className="crsr_pntr auto_txt_res_open" onClick={props.attachment_load}>
              <i
                className={
                  props.unique_id_check
                    ? 'fas fa-paperclip f_sz17 ml-2 fgreen4'
                    : 'fas fa-paperclip f_sz17 ml-2 flightgrey3'
                }
              />
            </a>
          </div>
          <div
            className="col-4 col-sm-4 col-md-4 pl-0 Auto_txt_inbound_close emoji_close_all"
            style={{ display: 'none' }}>
            <i className={'fas fa-times flightgrey3 f_sz18 mt-1 crsr_pntr position-relative'} onClick={props.onClick} />
            {/* <a
              className="crsr_pntr auto_txt_res_open1"
              
              >
              <i className="fas fa-paperclip f_sz17 ml-2 flightgrey3" />
            </a> */}
          </div>

          {/* <div className="col-8 col-sm-8 col-md-8 pr-0">
    <div className="f_sz12 fred mt-1 text-right">120 characters remaining</div>
  </div> */}
        </div>
        <div className="col-12 col-sm-12 col-md-12 d-flex flex-row flex-wrap position-relative">
          <span
            className="flex-row flex-wrap emoji_position emoji_disable"
            style={{ display: 'none', position: 'inherit', width: 'inherit', zIndex: '10' }}
            id="Auto_txt_inbound"></span>
        </div>
      </div>
      {/* <div className="addicondiv1">
		<div className="w-100 d-inline-block text-right">
			<span className="fmaroon crsr_pntr autotxtresp_clk">
				<i className="far fa-trash-alt f_sz18 mr-3" onClick={props.AutoTxtDelFrm} hidden={numbr == 1 ? true:false}/>
				{LastVlu == numbr ?
					<i className="fas fa-plus-circle f_sz18" onClick={props.AutoTxtPlsFrm} /> : null
				}
			</span>
        </div>
    </div> */}
    </>
  );
}

function AutoRspnsSaveButton(props) {
  return (
    <a className="btn btn-black crsr_pntr m-2 btnpdng_sm" onClick={props.AutoSvePrps}>
      Save
    </a>
  );
}

function ordinal_suffix_of(i) {
  var j = i % 10,
    k = i % 100;
  if (j == 1 && k != 11) {
    return i + 'st';
  }
  if (j == 2 && k != 12) {
    return i + 'nd';
  }
  if (j == 3 && k != 13) {
    return i + 'rd';
  }
  return i + 'th';
}
function FormGroup(props) {
  return (
    <div className="w-100 d-flex flex-row mb-3">
      <div className="col-10 col-sm-10 col-md-10">
        <input
          value={props.value}
          onChange={props.inputChange}
          className="form-control"
          placeholder="Enter the email address"
          pattern="^[a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,15})$"
          oninvalid="this.setCustomValidity('Please enter a valid email address (example@example.com)')"
        />
      </div>
      <div className="col-2 col-sm-2 col-md-2">
        <a>
          <i style={props.buttonDisabled} onClick={props.buttonClick} tabIndex="-1" className={props.buttonIcon} />
        </a>
      </div>
    </div>
  );
}
export default Profile_settings;
